import { useMutation, useQuery, useSuspenseQuery, useInfiniteQuery, useSuspenseInfiniteQuery, UseMutationOptions, UseQueryOptions, UseSuspenseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseSuspenseInfiniteQueryOptions } from '@tanstack/react-query';
import { fetchData } from '@/lib/fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: number; output: number; }
  Long: { input: any; output: any; }
  TimeSpan: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AccountDeletionEligibilityDto = {
  __typename?: 'AccountDeletionEligibilityDto';
  accountExists: Scalars['Boolean']['output'];
  alreadyDeleted: Scalars['Boolean']['output'];
  hasActiveSubscription: Scalars['Boolean']['output'];
  requiredConfirmation: Scalars['String']['output'];
  subscriptionMessage?: Maybe<Scalars['String']['output']>;
};

export type AccountDeletionResultDto = {
  __typename?: 'AccountDeletionResultDto';
  alreadyDeleted: Scalars['Boolean']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  externalCleanupPending: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdminAccountingPaymentLogDto = {
  __typename?: 'AdminAccountingPaymentLogDto';
  amount: Scalars['Decimal']['output'];
  brandId: Scalars['Int']['output'];
  brandName: Scalars['String']['output'];
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardFunding?: Maybe<Scalars['String']['output']>;
  cardLast4?: Maybe<Scalars['String']['output']>;
  currencyCode: Scalars['String']['output'];
  customerId?: Maybe<Scalars['Int']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  matchedOrder: Scalars['Boolean']['output'];
  method: Scalars['String']['output'];
  methodDescription: Scalars['String']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  providerMetadataJson?: Maybe<Scalars['String']['output']>;
  providerReferenceId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusDetail?: Maybe<Scalars['String']['output']>;
  transactionId: Scalars['String']['output'];
  walletType?: Maybe<Scalars['String']['output']>;
};

export type AdminAddOrderItemResultDto = {
  __typename?: 'AdminAddOrderItemResultDto';
  addedQuantity: Scalars['Int']['output'];
  currentQuantity?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  orderId: Scalars['Int']['output'];
  orderItemIds: Array<Scalars['Int']['output']>;
  previousStatusId?: Maybe<Scalars['Int']['output']>;
  statusId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  targetQuantity?: Maybe<Scalars['Int']['output']>;
};

export type AdminAdjustCustomerPointsResultDto = {
  __typename?: 'AdminAdjustCustomerPointsResultDto';
  balance: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  pointEntryId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdminApplyProductImageVariantInput = {
  expectedThumbnailPath?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
  uploadKey: Scalars['String']['input'];
  variant: AdminProductImageVariant;
};

export type AdminApplyProductThumbnailInput = {
  expectedThumbnailPath?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
  uploadKey: Scalars['String']['input'];
};

export enum AdminAssetUploadPurpose {
  BlogFeaturedImage = 'BLOG_FEATURED_IMAGE',
  BlogInlineImage = 'BLOG_INLINE_IMAGE',
  CreatorPhoto = 'CREATOR_PHOTO',
  HomepageCarouselImage = 'HOMEPAGE_CAROUSEL_IMAGE',
  ProductCarouselImage = 'PRODUCT_CAROUSEL_IMAGE',
  ProductGalleryImage = 'PRODUCT_GALLERY_IMAGE',
  ProductSidebarImage = 'PRODUCT_SIDEBAR_IMAGE',
  ProductSquareImage = 'PRODUCT_SQUARE_IMAGE',
  ProductThumbnail = 'PRODUCT_THUMBNAIL',
  ProductVideoThumbnail = 'PRODUCT_VIDEO_THUMBNAIL'
}

export type AdminAssetUploadRequestInput = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  purpose: AdminAssetUploadPurpose;
};

export type AdminAssetUploadResultDto = {
  __typename?: 'AdminAssetUploadResultDto';
  fileName: Scalars['String']['output'];
  key: Scalars['String']['output'];
  publicUrl: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AdminAssetUploadTargetDto = {
  __typename?: 'AdminAssetUploadTargetDto';
  fileName: Scalars['String']['output'];
  key: Scalars['String']['output'];
  publicUrl: Scalars['String']['output'];
  purpose: AdminAssetUploadPurpose;
  uploadUrl: Scalars['String']['output'];
};

export type AdminAttachProductImageInput = {
  expectedEditToken: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  uploadKey: Scalars['String']['input'];
};

export type AdminAttachProductTrailerInput = {
  bunnyId: Scalars['String']['input'];
  expectedEditToken: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  videoSource: Scalars['String']['input'];
};

export type AdminBatchShipmentGroupDto = {
  __typename?: 'AdminBatchShipmentGroupDto';
  items: Array<AdminBatchShipmentItemDto>;
  orderCount: Scalars['Int']['output'];
  orders: Array<AdminBatchShipmentOrderDto>;
  signature: Scalars['String']['output'];
};

export type AdminBatchShipmentItemDto = {
  __typename?: 'AdminBatchShipmentItemDto';
  batchEligibleQuantity: Scalars['Int']['output'];
  nonBatchEligibleQuantity: Scalars['Int']['output'];
  optionDescription?: Maybe<Scalars['String']['output']>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productOptionId?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
};

export type AdminBatchShipmentOrderDto = {
  __typename?: 'AdminBatchShipmentOrderDto';
  brandName: Scalars['String']['output'];
  customerComments?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  destinationCountry: Scalars['String']['output'];
  distributorOrderIds: Array<Scalars['String']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  isFullyPicked: Scalars['Boolean']['output'];
  orderDate: Scalars['DateTime']['output'];
  orderId: Scalars['Int']['output'];
  orderItemIds: Array<Scalars['Int']['output']>;
  otherOpenOrderCount: Scalars['Int']['output'];
  shippingMethodId?: Maybe<Scalars['Int']['output']>;
  shippingMethodName?: Maybe<Scalars['String']['output']>;
  warnings: Array<Scalars['String']['output']>;
};

export type AdminBatchShipmentOrderValidationDto = {
  __typename?: 'AdminBatchShipmentOrderValidationDto';
  eligible: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export type AdminBatchShipmentRecoveryInput = {
  orderId: Scalars['Int']['input'];
  orderItemIds: Array<Scalars['Int']['input']>;
};

export type AdminBatchShipmentRecoveryResultDto = {
  __typename?: 'AdminBatchShipmentRecoveryResultDto';
  message: Scalars['String']['output'];
  orderId: Scalars['Int']['output'];
  packageId?: Maybe<Scalars['Int']['output']>;
  state: Scalars['String']['output'];
};

export type AdminBlogBrandDto = {
  __typename?: 'AdminBlogBrandDto';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AdminBlogCategoryDto = {
  __typename?: 'AdminBlogCategoryDto';
  editToken: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  introText?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  postCount: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  urlPrefix?: Maybe<Scalars['String']['output']>;
  urlStub: Scalars['String']['output'];
};

export type AdminBlogCategoryInput = {
  expectedEditToken?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  introText?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
  urlPrefix?: InputMaybe<Scalars['String']['input']>;
  urlStub: Scalars['String']['input'];
};

export type AdminBlogCategoryMutationResultDto = {
  __typename?: 'AdminBlogCategoryMutationResultDto';
  category?: Maybe<AdminBlogCategoryDto>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type AdminBlogCommentDto = {
  __typename?: 'AdminBlogCommentDto';
  blogPostId: Scalars['Int']['output'];
  blogPostTitle: Scalars['String']['output'];
  blogPostUrl: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  createdAtUtc: Scalars['DateTime']['output'];
  customerId: Scalars['Int']['output'];
  customerName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  status: BlogCommentStatus;
};

export type AdminBlogCommentMutationResultDto = {
  __typename?: 'AdminBlogCommentMutationResultDto';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AdminBlogCommentPageDto = {
  __typename?: 'AdminBlogCommentPageDto';
  items: Array<AdminBlogCommentDto>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type AdminBlogListInput = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BlogPublicationStatus>;
  type?: InputMaybe<BlogPostType>;
};

export type AdminBlogLookupsDto = {
  __typename?: 'AdminBlogLookupsDto';
  brands: Array<AdminBlogBrandDto>;
  categories: Array<AdminBlogCategoryDto>;
  customerTags: Array<Scalars['String']['output']>;
};

export type AdminBlogMediaInput = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AdminBlogMediaItemDto = {
  __typename?: 'AdminBlogMediaItemDto';
  featured: Scalars['Boolean']['output'];
  fileName: Scalars['String']['output'];
  key: Scalars['String']['output'];
  markdown: Scalars['String']['output'];
  publicUrl: Scalars['String']['output'];
};

export type AdminBlogMediaPageDto = {
  __typename?: 'AdminBlogMediaPageDto';
  items: Array<AdminBlogMediaItemDto>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type AdminBlogPostDto = {
  __typename?: 'AdminBlogPostDto';
  authorName: Scalars['String']['output'];
  brandId?: Maybe<Scalars['Int']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  customerTag?: Maybe<Scalars['String']['output']>;
  editToken: Scalars['String']['output'];
  featuredImageUrl: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  intro?: Maybe<Scalars['String']['output']>;
  markdown: Scalars['String']['output'];
  podcastUrl?: Maybe<Scalars['String']['output']>;
  previewHtml: Scalars['String']['output'];
  productId?: Maybe<Scalars['Int']['output']>;
  publicUrl: Scalars['String']['output'];
  publishAtUtc: Scalars['DateTime']['output'];
  status: BlogPublicationStatus;
  title: Scalars['String']['output'];
  type: BlogPostType;
  urlStub: Scalars['String']['output'];
};

export type AdminBlogPostMutationResultDto = {
  __typename?: 'AdminBlogPostMutationResultDto';
  message: Scalars['String']['output'];
  post?: Maybe<AdminBlogPostDto>;
  success: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type AdminBlogPostPageDto = {
  __typename?: 'AdminBlogPostPageDto';
  items: Array<AdminBlogPostSummaryDto>;
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type AdminBlogPostSummaryDto = {
  __typename?: 'AdminBlogPostSummaryDto';
  authorName: Scalars['String']['output'];
  brandId?: Maybe<Scalars['Int']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  featuredImageUrl: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  publicUrl: Scalars['String']['output'];
  publishAtUtc: Scalars['DateTime']['output'];
  status: BlogPublicationStatus;
  title: Scalars['String']['output'];
  type: BlogPostType;
  urlStub: Scalars['String']['output'];
};

export type AdminBlogPreviewDto = {
  __typename?: 'AdminBlogPreviewDto';
  expiresAtUtc: Scalars['DateTime']['output'];
  previewUrl: Scalars['String']['output'];
};

export type AdminBlogPreviewInput = {
  authorName: Scalars['String']['input'];
  brandId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  markdown: Scalars['String']['input'];
  podcastUrl?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  publishAtUtc?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  type: BlogPostType;
  urlStub: Scalars['String']['input'];
};

export type AdminBlogRenderedPreviewDto = {
  __typename?: 'AdminBlogRenderedPreviewDto';
  html: Scalars['String']['output'];
};

export type AdminBlogSaveInput = {
  authorName: Scalars['String']['input'];
  brandId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  customerTag?: InputMaybe<Scalars['String']['input']>;
  expectedEditToken?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  markdown: Scalars['String']['input'];
  podcastUrl?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  publishAtUtc?: InputMaybe<Scalars['DateTime']['input']>;
  status: BlogPublicationStatus;
  title: Scalars['String']['input'];
  type: BlogPostType;
  urlStub: Scalars['String']['input'];
};

export type AdminComponentProductDto = {
  __typename?: 'AdminComponentProductDto';
  blackpoolStock: Scalars['Int']['output'];
  componentParentProductId?: Maybe<Scalars['Int']['output']>;
  dateAdded: Scalars['DateTime']['output'];
  featured: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  live: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sacramentoStock: Scalars['Int']['output'];
  stockNotes?: Maybe<Scalars['String']['output']>;
  urlStub: Scalars['String']['output'];
};

export type AdminConfirmProductContractUploadInput = {
  key: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
};

export type AdminConfirmProductDownloadSubtitleUploadInput = {
  downloadFileId: Scalars['Int']['input'];
  expectedEditToken: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  uploadKey: Scalars['String']['input'];
};

export type AdminConventionAddonPurchaseDto = {
  __typename?: 'AdminConventionAddonPurchaseDto';
  amountPaid: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  optionDescription: Scalars['String']['output'];
  optionId?: Maybe<Scalars['Int']['output']>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type AdminConventionCurrencyDto = {
  __typename?: 'AdminConventionCurrencyDto';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  symbol: Scalars['String']['output'];
};

export type AdminConventionCurrencyTotalDto = {
  __typename?: 'AdminConventionCurrencyTotalDto';
  code: Scalars['String']['output'];
  currencyId: Scalars['Int']['output'];
  symbol: Scalars['String']['output'];
  total: Scalars['Decimal']['output'];
};

export type AdminConventionDetailDto = {
  __typename?: 'AdminConventionDetailDto';
  currency?: Maybe<AdminConventionCurrencyDto>;
  id: Scalars['Int']['output'];
  isWorkshop: Scalars['Boolean']['output'];
  live: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  options: Array<AdminConventionOptionDto>;
  parentConventionId?: Maybe<Scalars['Int']['output']>;
  parentConventionName?: Maybe<Scalars['String']['output']>;
  registrations: Array<AdminConventionRegistrationListItemDto>;
  retreatMode: Scalars['Boolean']['output'];
  totals: AdminConventionTotalsDto;
  urlStub: Scalars['String']['output'];
  workshops: Array<AdminConventionWorkshopDto>;
};

export type AdminConventionListItemDto = {
  __typename?: 'AdminConventionListItemDto';
  conventionLocation?: Maybe<Scalars['String']['output']>;
  conventionStartDate?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<AdminConventionCurrencyDto>;
  dateAdded: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  live: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  options: Array<AdminConventionOptionDto>;
  registrationCount: Scalars['Int']['output'];
  totalRevenue: Scalars['Decimal']['output'];
  urlStub: Scalars['String']['output'];
};

export type AdminConventionMutationResultDto = {
  __typename?: 'AdminConventionMutationResultDto';
  id?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AdminConventionNextPaymentDto = {
  __typename?: 'AdminConventionNextPaymentDto';
  amount: Scalars['Decimal']['output'];
  canCharge: Scalars['Boolean']['output'];
  cardDescription: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  paymentNumber: Scalars['Int']['output'];
};

export type AdminConventionOptionBreakdownDto = {
  __typename?: 'AdminConventionOptionBreakdownDto';
  count: Scalars['Int']['output'];
  optionDescription: Scalars['String']['output'];
  optionId?: Maybe<Scalars['Int']['output']>;
  totalPaid: Scalars['Decimal']['output'];
};

export type AdminConventionOptionDto = {
  __typename?: 'AdminConventionOptionDto';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  live: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
};

export type AdminConventionRegistrationDetailDto = {
  __typename?: 'AdminConventionRegistrationDetailDto';
  addonPurchases: Array<AdminConventionAddonPurchaseDto>;
  amountPaid: Scalars['Decimal']['output'];
  availableWorkshops: Array<AdminConventionWorkshopDto>;
  conventionName: Scalars['String']['output'];
  conventionProductId: Scalars['Int']['output'];
  currency?: Maybe<AdminConventionCurrencyDto>;
  customerEmail: Scalars['String']['output'];
  customerId: Scalars['Int']['output'];
  customerName: Scalars['String']['output'];
  hasPaymentCard: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isPaidInFull: Scalars['Boolean']['output'];
  lastPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  meta: Array<AdminConventionRegistrationMetaDto>;
  nextPayment?: Maybe<AdminConventionNextPaymentDto>;
  optionDescription: Scalars['String']['output'];
  optionId?: Maybe<Scalars['Int']['output']>;
  orderId: Scalars['Int']['output'];
  paymentInstallments: Array<ConventionPaymentInstallmentDto>;
  paymentMethod: Scalars['String']['output'];
  registeredWorkshops: Array<AdminConventionWorkshopDto>;
  registrantName: Scalars['String']['output'];
  registrationOptions: Array<AdminConventionOptionDto>;
  remainingAmount?: Maybe<Scalars['Decimal']['output']>;
  retreatMode: Scalars['Boolean']['output'];
  signedUpDate?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminConventionRegistrationListItemDto = {
  __typename?: 'AdminConventionRegistrationListItemDto';
  addonPurchases: Array<AdminConventionAddonPurchaseDto>;
  amountPaid: Scalars['Decimal']['output'];
  currency?: Maybe<AdminConventionCurrencyDto>;
  customerEmail: Scalars['String']['output'];
  customerId: Scalars['Int']['output'];
  customerName: Scalars['String']['output'];
  hasPaymentCard: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isPaidInFull: Scalars['Boolean']['output'];
  lastPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  optionDescription: Scalars['String']['output'];
  optionId?: Maybe<Scalars['Int']['output']>;
  orderId: Scalars['Int']['output'];
  paymentMethod: Scalars['String']['output'];
  registrantName: Scalars['String']['output'];
  remainingAmount?: Maybe<Scalars['Decimal']['output']>;
  signedUpDate?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminConventionRegistrationMetaDto = {
  __typename?: 'AdminConventionRegistrationMetaDto';
  dateUpdated: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AdminConventionSalesEditionDto = {
  __typename?: 'AdminConventionSalesEditionDto';
  bookedRevenue: Scalars['Decimal']['output'];
  compCount: Scalars['Int']['output'];
  comparableBookedRevenue: Scalars['Decimal']['output'];
  comparableCompCount: Scalars['Int']['output'];
  comparableOptionBreakdown: Array<AdminConventionSalesOptionDto>;
  comparableRegistrations: Scalars['Int']['output'];
  comparableTicketSales: Scalars['Int']['output'];
  comparisonDaysBeforeEvent: Scalars['Int']['output'];
  conventionStartDate: Scalars['DateTime']['output'];
  isCurrent: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  points: Array<AdminConventionSalesPointDto>;
  productId: Scalars['Int']['output'];
  ticketSales: Scalars['Int']['output'];
  totalRegistrations: Scalars['Int']['output'];
};

export type AdminConventionSalesOptionDto = {
  __typename?: 'AdminConventionSalesOptionDto';
  bookedRevenue: Scalars['Decimal']['output'];
  compCount: Scalars['Int']['output'];
  optionDescription: Scalars['String']['output'];
  optionId?: Maybe<Scalars['Int']['output']>;
  registrations: Scalars['Int']['output'];
  ticketSales: Scalars['Int']['output'];
};

export type AdminConventionSalesPointDto = {
  __typename?: 'AdminConventionSalesPointDto';
  bookedRevenue: Scalars['Decimal']['output'];
  daysBeforeEvent: Scalars['Int']['output'];
  registrations: Scalars['Int']['output'];
  ticketSales: Scalars['Int']['output'];
};

export type AdminConventionSalesSeriesDto = {
  __typename?: 'AdminConventionSalesSeriesDto';
  currency?: Maybe<AdminConventionCurrencyDto>;
  daysBeforeCurrentConvention: Scalars['Int']['output'];
  editions: Array<AdminConventionSalesEditionDto>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AdminConventionSalesStatsDto = {
  __typename?: 'AdminConventionSalesStatsDto';
  asOfDate: Scalars['DateTime']['output'];
  generatedAtUtc: Scalars['DateTime']['output'];
  lookbackYears: Scalars['Int']['output'];
  series: Array<AdminConventionSalesSeriesDto>;
};

export type AdminConventionTotalsDto = {
  __typename?: 'AdminConventionTotalsDto';
  compCount: Scalars['Int']['output'];
  currencyTotals: Array<AdminConventionCurrencyTotalDto>;
  optionBreakdown: Array<AdminConventionOptionBreakdownDto>;
  registrationCount: Scalars['Int']['output'];
  totalRevenue: Scalars['Decimal']['output'];
};

export type AdminConventionWaitlistEntryDto = {
  __typename?: 'AdminConventionWaitlistEntryDto';
  customerEmail: Scalars['String']['output'];
  customerId: Scalars['Int']['output'];
  customerName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  optionDescription: Scalars['String']['output'];
  productId: Scalars['Int']['output'];
  productOptionId?: Maybe<Scalars['Int']['output']>;
  timeAdded: Scalars['DateTime']['output'];
};

export type AdminConventionWorkshopDto = {
  __typename?: 'AdminConventionWorkshopDto';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  urlStub: Scalars['String']['output'];
};

export type AdminCreateProductDownloadFileInput = {
  accessHours?: InputMaybe<Scalars['Int']['input']>;
  allowDownload: Scalars['Boolean']['input'];
  expectedEditToken: Scalars['String']['input'];
  lectureStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  optionIds: Array<Scalars['Int']['input']>;
  partId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
  showOnApp: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
  uploadKey?: InputMaybe<Scalars['String']['input']>;
  watermarkDownload: Scalars['Boolean']['input'];
};

export type AdminCreateProductFinanceEntryInput = {
  amount: Scalars['Decimal']['input'];
  brandId: Scalars['Int']['input'];
  category: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  direction: AdminProductFinanceEntryDirection;
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
};

export type AdminCreateProductInput = {
  brands?: InputMaybe<Array<AdminProductAssociationBrandInput>>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  creatorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  distributorId: Scalars['Int']['input'];
  manufacturerId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  productTypeId: Scalars['Int']['input'];
  urlStub?: InputMaybe<Scalars['String']['input']>;
};

export type AdminCreateProductMetaInput = {
  key: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['String']['input'];
};

export type AdminCreateScanFormResultDto = {
  __typename?: 'AdminCreateScanFormResultDto';
  hasWarnings: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  scanForm?: Maybe<AdminScanFormDto>;
  scanForms: Array<AdminScanFormDto>;
  skippedPackageCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type AdminCreateStoreOrderItemInput = {
  optionId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  unitPrice: Scalars['Decimal']['input'];
};

export type AdminCreateStoreOrderResultDto = {
  __typename?: 'AdminCreateStoreOrderResultDto';
  message: Scalars['String']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdminCreatedDownloadCodesDto = {
  __typename?: 'AdminCreatedDownloadCodesDto';
  codes: Array<Scalars['String']['output']>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productOptionDescription?: Maybe<Scalars['String']['output']>;
  productOptionId?: Maybe<Scalars['Int']['output']>;
};

export type AdminCreatorDetailDto = {
  __typename?: 'AdminCreatorDetailDto';
  emailAddress?: Maybe<Scalars['String']['output']>;
  hasCreatorAccess: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  intro?: Maybe<Scalars['String']['output']>;
  inviteLink?: Maybe<Scalars['String']['output']>;
  menuPosition?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['Int']['output']>;
  paymentMethodDescription?: Maybe<Scalars['String']['output']>;
  photoFilename?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  products: Array<AdminCreatorProductDto>;
  urlStub?: Maybe<Scalars['String']['output']>;
};

export type AdminCreatorListItemDto = {
  __typename?: 'AdminCreatorListItemDto';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  photoFilename?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  productCount: Scalars['Int']['output'];
  urlStub?: Maybe<Scalars['String']['output']>;
};

export type AdminCreatorPaymentPreviewDto = {
  __typename?: 'AdminCreatorPaymentPreviewDto';
  canGeneratePayment: Scalars['Boolean']['output'];
  creatorId: Scalars['Int']['output'];
  creatorName: Scalars['String']['output'];
  items: Array<AdminCreatorPaymentPreviewItemDto>;
  lastPaymentDatePaid?: Maybe<Scalars['DateTime']['output']>;
  lastPaymentDateProcessed?: Maybe<Scalars['DateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  paymentMethod: Scalars['Int']['output'];
  paymentMethodDescription: Scalars['String']['output'];
  totalAmount: Scalars['Decimal']['output'];
};

export type AdminCreatorPaymentPreviewItemDto = {
  __typename?: 'AdminCreatorPaymentPreviewItemDto';
  amount: Scalars['Decimal']['output'];
  info?: Maybe<Scalars['String']['output']>;
  payPerUnit?: Maybe<Scalars['Decimal']['output']>;
  percentageToCreator: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productOptionDescription?: Maybe<Scalars['String']['output']>;
  productOptionId?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  royaltyRate?: Maybe<Scalars['Decimal']['output']>;
  shipping: Scalars['Decimal']['output'];
  total: Scalars['Decimal']['output'];
};

export type AdminCreatorPendingPaymentDto = {
  __typename?: 'AdminCreatorPendingPaymentDto';
  amount: Scalars['Decimal']['output'];
  canSendPayPal: Scalars['Boolean']['output'];
  creatorEmailAddress?: Maybe<Scalars['String']['output']>;
  creatorId: Scalars['Int']['output'];
  creatorName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  items: Array<AdminCreatorPendingPaymentItemDto>;
  message?: Maybe<Scalars['String']['output']>;
  method: Scalars['Int']['output'];
  methodDescription: Scalars['String']['output'];
  paymentDetails?: Maybe<Scalars['String']['output']>;
};

export type AdminCreatorPendingPaymentItemDto = {
  __typename?: 'AdminCreatorPendingPaymentItemDto';
  brandId?: Maybe<Scalars['Int']['output']>;
  paymentDetails?: Maybe<Scalars['String']['output']>;
  postage: Scalars['Decimal']['output'];
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productOptionDescription?: Maybe<Scalars['String']['output']>;
  productOptionId?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Decimal']['output'];
};

export type AdminCreatorPendingPaymentsPageDto = {
  __typename?: 'AdminCreatorPendingPaymentsPageDto';
  items: Array<AdminCreatorPendingPaymentDto>;
  skip: Scalars['Int']['output'];
  take: Scalars['Int']['output'];
  totalAmount: Scalars['Decimal']['output'];
  totalCount: Scalars['Int']['output'];
};

export type AdminCreatorProductDto = {
  __typename?: 'AdminCreatorProductDto';
  id: Scalars['Int']['output'];
  live: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  percentageToCreator: Scalars['Int']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type AdminCreatorsPageDto = {
  __typename?: 'AdminCreatorsPageDto';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  items: Array<AdminCreatorListItemDto>;
  totalCount: Scalars['Int']['output'];
};

export type AdminCustomerBrandLinkMetaDto = {
  __typename?: 'AdminCustomerBrandLinkMetaDto';
  brandId: Scalars['Int']['output'];
  brandName: Scalars['String']['output'];
  customerBrandLinkId: Scalars['Int']['output'];
  dateUpdated: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AdminCustomerBrandStripeIdDto = {
  __typename?: 'AdminCustomerBrandStripeIdDto';
  brandId: Scalars['Int']['output'];
  brandName: Scalars['String']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
};

export type AdminCustomerDetailDto = {
  __typename?: 'AdminCustomerDetailDto';
  brandLinkMeta: Array<AdminCustomerBrandLinkMetaDto>;
  customerIoEmailSubscriptions: AdminCustomerIoEmailSubscriptionsDto;
  dateSignedUp: Scalars['DateTime']['output'];
  emailAddress: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  internalNotes?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  masterclassSubscription?: Maybe<AdminCustomerMasterclassSubscriptionDto>;
  points: AdminCustomerPointsSummaryDto;
  stripeCustomerIds: Array<AdminCustomerBrandStripeIdDto>;
  totalSpendGbp: Scalars['Decimal']['output'];
  totalSpendUsd: Scalars['Decimal']['output'];
};

export type AdminCustomerGiftVoucherCodeDto = {
  __typename?: 'AdminCustomerGiftVoucherCodeDto';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type AdminCustomerGiftVoucherDto = {
  __typename?: 'AdminCustomerGiftVoucherDto';
  amount: Scalars['Decimal']['output'];
  amountRemaining: Scalars['Decimal']['output'];
  currencyCode?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  dateAdded?: Maybe<Scalars['DateTime']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isExpired: Scalars['Boolean']['output'];
  isRevoked: Scalars['Boolean']['output'];
  maskedCode: Scalars['String']['output'];
  purchasedOrderId?: Maybe<Scalars['Int']['output']>;
  usage: Array<AdminCustomerGiftVoucherUsageDto>;
  usageScope: Scalars['String']['output'];
};

export type AdminCustomerGiftVoucherUsageDto = {
  __typename?: 'AdminCustomerGiftVoucherUsageDto';
  amountUsed: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  orderDate?: Maybe<Scalars['DateTime']['output']>;
  orderId: Scalars['Int']['output'];
};

export type AdminCustomerIoEmailSubscriptionsDto = {
  __typename?: 'AdminCustomerIoEmailSubscriptionsDto';
  dealOfTheDay: Scalars['Boolean']['output'];
  loaded: Scalars['Boolean']['output'];
  productEmails: Scalars['Boolean']['output'];
  weeklyNewsletter: Scalars['Boolean']['output'];
};

export type AdminCustomerMasterclassSubscriptionDto = {
  __typename?: 'AdminCustomerMasterclassSubscriptionDto';
  brandCode?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancellationRecordedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  hasCancellationRecord: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isInGoodStanding: Scalars['Boolean']['output'];
  isPaused: Scalars['Boolean']['output'];
  isTrial: Scalars['Boolean']['output'];
  lastBillingDate?: Maybe<Scalars['DateTime']['output']>;
  nextBillingDate?: Maybe<Scalars['DateTime']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  statusLabel: Scalars['String']['output'];
  stripeSubscription?: Maybe<AdminCustomerStripeSubscriptionDto>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionProviderCode?: Maybe<Scalars['String']['output']>;
  subscriptionProviderName?: Maybe<Scalars['String']['output']>;
  subscriptionTier?: Maybe<Scalars['Int']['output']>;
};

export type AdminCustomerMergeConflictDto = {
  __typename?: 'AdminCustomerMergeConflictDto';
  area: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type AdminCustomerMergeCustomerDto = {
  __typename?: 'AdminCustomerMergeCustomerDto';
  dateSignedUp?: Maybe<Scalars['DateTime']['output']>;
  deletedTime?: Maybe<Scalars['DateTime']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type AdminCustomerMergeExternalActionResultDto = {
  __typename?: 'AdminCustomerMergeExternalActionResultDto';
  escalationUrl?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  system: Scalars['String']['output'];
  warning: Scalars['Boolean']['output'];
};

export type AdminCustomerMergeMovedCountDto = {
  __typename?: 'AdminCustomerMergeMovedCountDto';
  columnName: Scalars['String']['output'];
  rowsMoved: Scalars['Long']['output'];
  tableName: Scalars['String']['output'];
};

export type AdminCustomerMergePreviewDto = {
  __typename?: 'AdminCustomerMergePreviewDto';
  canMerge: Scalars['Boolean']['output'];
  conflicts: Array<AdminCustomerMergeConflictDto>;
  counts: Array<AdminCustomerMergeTableCountDto>;
  message: Scalars['String']['output'];
  sourceCustomer?: Maybe<AdminCustomerMergeCustomerDto>;
  targetCustomer?: Maybe<AdminCustomerMergeCustomerDto>;
};

export type AdminCustomerMergeResultDto = {
  __typename?: 'AdminCustomerMergeResultDto';
  externalActions: Array<AdminCustomerMergeExternalActionResultDto>;
  mergeLogId: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  movedCounts: Array<AdminCustomerMergeMovedCountDto>;
  sourceCustomerId: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  targetCustomerId: Scalars['Int']['output'];
};

export type AdminCustomerMergeTableCountDto = {
  __typename?: 'AdminCustomerMergeTableCountDto';
  columnName: Scalars['String']['output'];
  label: Scalars['String']['output'];
  sourceCount: Scalars['Long']['output'];
  tableName: Scalars['String']['output'];
  targetCount: Scalars['Long']['output'];
  willMove: Scalars['Boolean']['output'];
};

/** A segment of a collection. */
export type AdminCustomerOrdersCollectionSegment = {
  __typename?: 'AdminCustomerOrdersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<AdminOrderDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdminCustomerPointsBrandBalanceDto = {
  __typename?: 'AdminCustomerPointsBrandBalanceDto';
  balance: Scalars['Int']['output'];
  brandCode?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['Int']['output'];
  brandName: Scalars['String']['output'];
  currencyCode?: Maybe<Scalars['String']['output']>;
  currencyId?: Maybe<Scalars['Int']['output']>;
  customerBrandLinkId: Scalars['Int']['output'];
  entryCount: Scalars['Int']['output'];
  pointsEarned: Scalars['Int']['output'];
  pointsSpent: Scalars['Int']['output'];
};

export type AdminCustomerPointsLogEntryDto = {
  __typename?: 'AdminCustomerPointsLogEntryDto';
  brandCode?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['Int']['output'];
  brandName: Scalars['String']['output'];
  customerBrandLinkId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  transactionDate?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminCustomerPointsSummaryDto = {
  __typename?: 'AdminCustomerPointsSummaryDto';
  balance: Scalars['Int']['output'];
  brandBalances: Array<AdminCustomerPointsBrandBalanceDto>;
  entryCount: Scalars['Int']['output'];
  hasNegativeBalance: Scalars['Boolean']['output'];
  pointsEarned: Scalars['Int']['output'];
  pointsSpent: Scalars['Int']['output'];
  recentEntries: Array<AdminCustomerPointsLogEntryDto>;
  recentEntryLimit: Scalars['Int']['output'];
};

export type AdminCustomerStripeSubscriptionDto = {
  __typename?: 'AdminCustomerStripeSubscriptionDto';
  billingCycleAnchor?: Maybe<Scalars['DateTime']['output']>;
  billingInterval?: Maybe<Scalars['String']['output']>;
  cancelAt?: Maybe<Scalars['DateTime']['output']>;
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  priceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trialEndDate?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminCustomerSubscriptionMutationResultDto = {
  __typename?: 'AdminCustomerSubscriptionMutationResultDto';
  createdSubscription: Scalars['Boolean']['output'];
  customerId: Scalars['Int']['output'];
  grantedStartedMonth: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  subscriptionStatusId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdminDelayedOrderEmailCandidateDto = {
  __typename?: 'AdminDelayedOrderEmailCandidateDto';
  brandCode?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['Int']['output'];
  brandName?: Maybe<Scalars['String']['output']>;
  customerEmail: Scalars['String']['output'];
  customerId: Scalars['Int']['output'];
  customerName: Scalars['String']['output'];
  lastContactDate?: Maybe<Scalars['DateTime']['output']>;
  orderDate: Scalars['DateTime']['output'];
  orderId: Scalars['Int']['output'];
  productNames: Array<Scalars['String']['output']>;
  statusDescription?: Maybe<Scalars['String']['output']>;
  statusId: Scalars['Int']['output'];
};

export type AdminDelayedOrderEmailSendResultDto = {
  __typename?: 'AdminDelayedOrderEmailSendResultDto';
  failedOrderIds: Array<Scalars['Int']['output']>;
  giftVoucherCount: Scalars['Int']['output'];
  giftVoucherOrderIds: Array<Scalars['Int']['output']>;
  loggedCount: Scalars['Int']['output'];
  loggedOrderIds: Array<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  sentCount: Scalars['Int']['output'];
  sentOrderIds: Array<Scalars['Int']['output']>;
  skippedCount: Scalars['Int']['output'];
  skippedOrderIds: Array<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdminDeleteProductFinanceEntryInput = {
  entryId: Scalars['Int']['input'];
  expectedEditToken: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
};

export type AdminDeleteProductFinanceEntryResultDto = {
  __typename?: 'AdminDeleteProductFinanceEntryResultDto';
  deletedEntryId: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
};

export type AdminDeleteProductMetaInput = {
  expectedEditToken: Scalars['String']['input'];
  metaId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
};

export enum AdminDistributorFulfillmentRegion {
  Uk = 'UK',
  Usa = 'USA'
}

export enum AdminDistributorItemRole {
  Murphys = 'MURPHYS',
  None = 'NONE',
  Other = 'OTHER',
  Warehouse = 'WAREHOUSE'
}

export type AdminDistributorOrderItemStateDto = {
  __typename?: 'AdminDistributorOrderItemStateDto';
  canCreateMurphysSalesOrderLine: Scalars['Boolean']['output'];
  canOrderFromMurphys: Scalars['Boolean']['output'];
  distributorId?: Maybe<Scalars['Int']['output']>;
  distributorOrderId?: Maybe<Scalars['String']['output']>;
  distributorRole: AdminDistributorItemRole;
  exceptionDescription?: Maybe<Scalars['String']['output']>;
  exceptionFixed?: Maybe<Scalars['DateTime']['output']>;
  exceptionType?: Maybe<Scalars['Int']['output']>;
  fulfillmentRegion?: Maybe<AdminDistributorFulfillmentRegion>;
  hasDistributorOrderToken: Scalars['Boolean']['output'];
  hasOpenException: Scalars['Boolean']['output'];
  hideFromCustomer: Scalars['Boolean']['output'];
  inventoryShelfId?: Maybe<Scalars['Int']['output']>;
  isActionable: Scalars['Boolean']['output'];
  isMobilePickingCandidate: Scalars['Boolean']['output'];
  isMurphysAssigned: Scalars['Boolean']['output'];
  isMurphysHandoffCandidate: Scalars['Boolean']['output'];
  isPackaged: Scalars['Boolean']['output'];
  isPendingDistributor: Scalars['Boolean']['output'];
  isPendingWarehouse: Scalars['Boolean']['output'];
  isPhysical: Scalars['Boolean']['output'];
  isRefunded: Scalars['Boolean']['output'];
  isSentByDistributor: Scalars['Boolean']['output'];
  isSentToDistributor: Scalars['Boolean']['output'];
  isTransferCandidate: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  murphysAccount?: Maybe<Scalars['String']['output']>;
  murphysActionBlockedReasons: Array<Scalars['String']['output']>;
  murphysBlockedReasons: Array<Scalars['String']['output']>;
  murphysDistributorId?: Maybe<Scalars['Int']['output']>;
  murphysItemId?: Maybe<Scalars['Int']['output']>;
  murphysItemIdSource: AdminMurphysItemIdSource;
  needsMurphysSalesOrder: Scalars['Boolean']['output'];
  orderId: Scalars['Int']['output'];
  orderItemId: Scalars['Int']['output'];
  orderStatusId: Scalars['Int']['output'];
  orderStatusName?: Maybe<Scalars['String']['output']>;
  packageId?: Maybe<Scalars['Int']['output']>;
  pickedDate?: Maybe<Scalars['DateTime']['output']>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productOptionDescription?: Maybe<Scalars['String']['output']>;
  productOptionId?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  recommendedFulfillmentAction: AdminRecommendedFulfillmentAction;
  refundedDate?: Maybe<Scalars['DateTime']['output']>;
  sentByDistributorDate?: Maybe<Scalars['DateTime']['output']>;
  sentToDistributorDate?: Maybe<Scalars['DateTime']['output']>;
  stockLocationId?: Maybe<Scalars['Int']['output']>;
  warehouseDistributorId?: Maybe<Scalars['Int']['output']>;
};

export type AdminDownloadCardLookupDto = {
  __typename?: 'AdminDownloadCardLookupDto';
  code: Scalars['String']['output'];
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerUrl: Scalars['String']['output'];
  isActivated: Scalars['Boolean']['output'];
  isUsed: Scalars['Boolean']['output'];
  isValid: Scalars['Boolean']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productOptionDescription?: Maybe<Scalars['String']['output']>;
  productOptionId?: Maybe<Scalars['Int']['output']>;
  productUrlStub?: Maybe<Scalars['String']['output']>;
};

export type AdminDownloadCodeProductDto = {
  __typename?: 'AdminDownloadCodeProductDto';
  availableCodeCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  initials: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options: Array<AdminDownloadCodeProductOptionDto>;
  usedCodeCount: Scalars['Int']['output'];
};

export type AdminDownloadCodeProductOptionDto = {
  __typename?: 'AdminDownloadCodeProductOptionDto';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type AdminDownloadGrantCandidateDto = {
  __typename?: 'AdminDownloadGrantCandidateDto';
  creatorDisplayName?: Maybe<Scalars['String']['output']>;
  downloadFileCount: Scalars['Int']['output'];
  options: Array<AdminDownloadGrantOptionDto>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  requiresOptionSelection: Scalars['Boolean']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  urlStub: Scalars['String']['output'];
};

export type AdminDownloadGrantOptionDto = {
  __typename?: 'AdminDownloadGrantOptionDto';
  description: Scalars['String']['output'];
  downloadFileCount: Scalars['Int']['output'];
  productOptionId: Scalars['Int']['output'];
};

export type AdminEasyPostShipmentDto = {
  __typename?: 'AdminEasyPostShipmentDto';
  carrier?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  deliveryDateGuaranteed: Scalars['Boolean']['output'];
  estimatedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  estimatedDeliveryDays?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Decimal']['output']>;
  length?: Maybe<Scalars['Decimal']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  originCountry?: Maybe<Scalars['String']['output']>;
  packageId?: Maybe<Scalars['Int']['output']>;
  shipmentId: Scalars['String']['output'];
  shippingMethod?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingStatus?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
  weightOz?: Maybe<Scalars['Decimal']['output']>;
  width?: Maybe<Scalars['Decimal']['output']>;
};

export type AdminEasyPostShipmentJsonDto = {
  __typename?: 'AdminEasyPostShipmentJsonDto';
  json: Scalars['String']['output'];
  shipmentId: Scalars['String']['output'];
};

export type AdminEscalationResult = {
  __typename?: 'AdminEscalationResult';
  externalId?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  skipped: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type AdminGiftVoucherLookupDto = {
  __typename?: 'AdminGiftVoucherLookupDto';
  amount?: Maybe<Scalars['Decimal']['output']>;
  amountRemaining?: Maybe<Scalars['Decimal']['output']>;
  code: Scalars['String']['output'];
  currencyCode?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  dateAdded?: Maybe<Scalars['DateTime']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isExpired: Scalars['Boolean']['output'];
  isRevoked: Scalars['Boolean']['output'];
  isValid: Scalars['Boolean']['output'];
  purchasedOrderId?: Maybe<Scalars['Int']['output']>;
  usage: Array<AdminCustomerGiftVoucherUsageDto>;
  usageScope?: Maybe<Scalars['String']['output']>;
};

export type AdminGrantCustomerDownloadResultDto = {
  __typename?: 'AdminGrantCustomerDownloadResultDto';
  alreadyHadAccess: Scalars['Boolean']['output'];
  customerId: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productOptionId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdminHomepageCarouselDto = {
  __typename?: 'AdminHomepageCarouselDto';
  items: Array<AdminHomepageCarouselItemDto>;
};

export type AdminHomepageCarouselItemDto = {
  __typename?: 'AdminHomepageCarouselItemDto';
  altText: Scalars['String']['output'];
  archivedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  archivedByAdminUserId?: Maybe<Scalars['Int']['output']>;
  brandId?: Maybe<Scalars['Int']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  createdAtUtc: Scalars['DateTime']['output'];
  createdByAdminUserId?: Maybe<Scalars['Int']['output']>;
  effectiveImageSrc?: Maybe<Scalars['String']['output']>;
  effectiveUrl?: Maybe<Scalars['String']['output']>;
  endAtUtc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  imageSrc?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  productId?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  published: Scalars['Boolean']['output'];
  startAtUtc?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  updatedAtUtc: Scalars['DateTime']['output'];
  updatedByAdminUserId?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AdminImportMurphysProductMediaInput = {
  expectedMediaEditToken: Scalars['String']['input'];
  expectedTrailersEditToken: Scalars['String']['input'];
  imageIds: Array<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
  trailerIds: Array<Scalars['String']['input']>;
};

export type AdminImportProductDownloadUploadInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  importUrl: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
};

export type AdminImportProductTrailerInput = {
  expectedEditToken: Scalars['String']['input'];
  importUrl: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  videoSource: Scalars['String']['input'];
};

export type AdminImportRemoteImageInput = {
  url: Scalars['String']['input'];
};

export type AdminInAppPurchaseCandidateProductDto = {
  __typename?: 'AdminInAppPurchaseCandidateProductDto';
  creatorDisplayName?: Maybe<Scalars['String']['output']>;
  dateAdded: Scalars['DateTime']['output'];
  downloadFileCount: Scalars['Int']['output'];
  hasDownload: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  inappPurchaseTier?: Maybe<Scalars['Int']['output']>;
  live: Scalars['Boolean']['output'];
  manufacturer?: Maybe<PlayingCardManufacturer>;
  name: Scalars['String']['output'];
  price: Scalars['Decimal']['output'];
  productType: ProductTypeDto;
  thumbnails?: Maybe<ProductThumbnailsDto>;
  urlStub: Scalars['String']['output'];
};

export type AdminInAppPurchaseCandidateProductDtoFilterInput = {
  and?: InputMaybe<Array<AdminInAppPurchaseCandidateProductDtoFilterInput>>;
  creatorDisplayName?: InputMaybe<StringOperationFilterInput>;
  dateAdded?: InputMaybe<DateTimeOperationFilterInput>;
  downloadFileCount?: InputMaybe<IntOperationFilterInput>;
  hasDownload?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  inappPurchaseTier?: InputMaybe<IntOperationFilterInput>;
  live?: InputMaybe<BooleanOperationFilterInput>;
  manufacturer?: InputMaybe<ManufacturerDtoFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AdminInAppPurchaseCandidateProductDtoFilterInput>>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  productType?: InputMaybe<ProductTypeDtoFilterInput>;
  thumbnails?: InputMaybe<ProductThumbnailsDtoFilterInput>;
  urlStub?: InputMaybe<StringOperationFilterInput>;
};

export type AdminInAppPurchaseCandidateProductDtoSortInput = {
  creatorDisplayName?: InputMaybe<SortEnumType>;
  dateAdded?: InputMaybe<SortEnumType>;
  downloadFileCount?: InputMaybe<SortEnumType>;
  hasDownload?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inappPurchaseTier?: InputMaybe<SortEnumType>;
  live?: InputMaybe<SortEnumType>;
  manufacturer?: InputMaybe<ManufacturerDtoSortInput>;
  name?: InputMaybe<SortEnumType>;
  price?: InputMaybe<SortEnumType>;
  productType?: InputMaybe<ProductTypeDtoSortInput>;
  thumbnails?: InputMaybe<ProductThumbnailsDtoSortInput>;
  urlStub?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type AdminInAppPurchaseCandidateProductsCollectionSegment = {
  __typename?: 'AdminInAppPurchaseCandidateProductsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<AdminInAppPurchaseCandidateProductDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum AdminInventoryAdjustmentDirection {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export type AdminLowStockProductDto = {
  __typename?: 'AdminLowStockProductDto';
  creatorDisplayName?: Maybe<Scalars['String']['output']>;
  dateAdded: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  lastPurchasedDate?: Maybe<Scalars['DateTime']['output']>;
  live: Scalars['Boolean']['output'];
  lowStockSnoozeUntil?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<PlayingCardManufacturer>;
  manufacturerId: Scalars['Int']['output'];
  murphysStock?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  optionDescription?: Maybe<Scalars['String']['output']>;
  productOptionId?: Maybe<Scalars['Int']['output']>;
  productType: ProductTypeDto;
  salesRank?: Maybe<Scalars['Int']['output']>;
  thumbnails?: Maybe<ProductThumbnailsDto>;
  urlStub: Scalars['String']['output'];
  warehouseStock: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type AdminLowStockProductsCollectionSegment = {
  __typename?: 'AdminLowStockProductsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<AdminLowStockProductDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdminManagedPageDto = {
  __typename?: 'AdminManagedPageDto';
  displayName: Scalars['String']['output'];
  pageKey: Scalars['String']['output'];
  publicPath: Scalars['String']['output'];
  publishedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  sections: Array<AdminManagedPageSectionDto>;
  updatedAtUtc: Scalars['DateTime']['output'];
};

export type AdminManagedPageSectionDto = {
  __typename?: 'AdminManagedPageSectionDto';
  displayName: Scalars['String']['output'];
  draftContentJson: Scalars['String']['output'];
  publishedContentJson?: Maybe<Scalars['String']['output']>;
  sectionKey: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedAtUtc: Scalars['DateTime']['output'];
};

export type AdminManifestCourierDto = {
  __typename?: 'AdminManifestCourierDto';
  eligiblePackageCount: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  newestPackageAt?: Maybe<Scalars['DateTime']['output']>;
  oldestPackageAt?: Maybe<Scalars['DateTime']['output']>;
  warehouse: Scalars['String']['output'];
};

export type AdminMasterclassLectureDateDto = {
  __typename?: 'AdminMasterclassLectureDateDto';
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
};

export type AdminMasterclassMetaMutationResultDto = {
  __typename?: 'AdminMasterclassMetaMutationResultDto';
  message: Scalars['String']['output'];
  meta?: Maybe<ProductMetaDto>;
  productId?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  subscriptionMetaKey?: Maybe<Scalars['String']['output']>;
  subscriptionMetaValue?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdminMasterclassRenewalRecoveryBatchDto = {
  __typename?: 'AdminMasterclassRenewalRecoveryBatchDto';
  alreadyRecovered: Scalars['Int']['output'];
  errors: Scalars['Int']['output'];
  executed: Scalars['Boolean']['output'];
  invalid: Scalars['Int']['output'];
  items: Array<AdminMasterclassRenewalRecoveryItemDto>;
  message: Scalars['String']['output'];
  month: Scalars['Int']['output'];
  needsReview: Scalars['Int']['output'];
  productId?: Maybe<Scalars['Int']['output']>;
  ready: Scalars['Int']['output'];
  recovered: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type AdminMasterclassRenewalRecoveryCandidateDto = {
  __typename?: 'AdminMasterclassRenewalRecoveryCandidateDto';
  customerId: Scalars['Int']['output'];
  eventProcessedUtc: Scalars['DateTime']['output'];
  stripeEventId: Scalars['String']['output'];
  stripeInvoiceId: Scalars['String']['output'];
  stripeSubscriptionId: Scalars['String']['output'];
  subscriptionProviderCode: Scalars['String']['output'];
  subscriptionStatusId: Scalars['Int']['output'];
};

export type AdminMasterclassRenewalRecoveryCandidatesDto = {
  __typename?: 'AdminMasterclassRenewalRecoveryCandidatesDto';
  distinctCustomers: Scalars['Int']['output'];
  items: Array<AdminMasterclassRenewalRecoveryCandidateDto>;
  message: Scalars['String']['output'];
  month: Scalars['Int']['output'];
  multipleRenewalCustomers: Scalars['Int']['output'];
  productId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type AdminMasterclassRenewalRecoveryInputDtoInput = {
  customerId: Scalars['Int']['input'];
  stripeEventId: Scalars['String']['input'];
  stripeInvoiceId: Scalars['String']['input'];
  stripeSubscriptionId: Scalars['String']['input'];
  subscriptionProviderCode: Scalars['String']['input'];
  subscriptionStatusId: Scalars['Int']['input'];
};

export type AdminMasterclassRenewalRecoveryItemDto = {
  __typename?: 'AdminMasterclassRenewalRecoveryItemDto';
  amountPaid?: Maybe<Scalars['Decimal']['output']>;
  canExecute: Scalars['Boolean']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  status: AdminMasterclassRenewalRecoveryStatus;
  stripeEventId: Scalars['String']['output'];
  stripeInvoiceId: Scalars['String']['output'];
  stripeSubscriptionId: Scalars['String']['output'];
  subscriptionProviderCode: Scalars['String']['output'];
  subscriptionStatusId: Scalars['Int']['output'];
};

export enum AdminMasterclassRenewalRecoveryStatus {
  AlreadyRecovered = 'ALREADY_RECOVERED',
  Error = 'ERROR',
  Invalid = 'INVALID',
  NeedsReview = 'NEEDS_REVIEW',
  Ready = 'READY',
  Recovered = 'RECOVERED'
}

export type AdminMurphysHandoffCandidatesDto = {
  __typename?: 'AdminMurphysHandoffCandidatesDto';
  eligibleItemCount: Scalars['Int']['output'];
  items: Array<AdminDistributorOrderItemStateDto>;
  orderId: Scalars['Int']['output'];
};

export enum AdminMurphysItemIdSource {
  None = 'NONE',
  Product = 'PRODUCT',
  ProductOption = 'PRODUCT_OPTION'
}

export type AdminMurphysOpenOrderMutationResultDto = {
  __typename?: 'AdminMurphysOpenOrderMutationResultDto';
  message: Scalars['String']['output'];
  salesOrderNumber?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdminMurphysOpenSalesOrderDto = {
  __typename?: 'AdminMurphysOpenSalesOrderDto';
  account: MurphysAccount;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  items: Array<AdminMurphysOpenSalesOrderItemDto>;
  lineCount: Scalars['Int']['output'];
  locationId: Scalars['Int']['output'];
  salesOrderNumber?: Maybe<Scalars['String']['output']>;
  totalQuantity: Scalars['Int']['output'];
};

export type AdminMurphysOpenSalesOrderItemDto = {
  __typename?: 'AdminMurphysOpenSalesOrderItemDto';
  murphysItemId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type AdminMurphysProductDownloadFileDto = {
  __typename?: 'AdminMurphysProductDownloadFileDto';
  partId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AdminMurphysProductDownloadsPreviewDto = {
  __typename?: 'AdminMurphysProductDownloadsPreviewDto';
  files: Array<AdminMurphysProductDownloadFileDto>;
  murphysProductId: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
};

export type AdminMurphysProductImageDto = {
  __typename?: 'AdminMurphysProductImageDto';
  alreadyImported: Scalars['Boolean']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  sourceUrl: Scalars['String']['output'];
};

export type AdminMurphysProductMediaImportResultDto = {
  __typename?: 'AdminMurphysProductMediaImportResultDto';
  errors: Array<Scalars['String']['output']>;
  importedImages: Scalars['Int']['output'];
  importedTrailers: Scalars['Int']['output'];
  product: AdminProductAuthoringDto;
  skippedImages: Scalars['Int']['output'];
  skippedTrailers: Scalars['Int']['output'];
};

export type AdminMurphysProductMediaPreviewDto = {
  __typename?: 'AdminMurphysProductMediaPreviewDto';
  images: Array<AdminMurphysProductImageDto>;
  murphysProductId: Scalars['Int']['output'];
  murphysTitle?: Maybe<Scalars['String']['output']>;
  productId: Scalars['Int']['output'];
  trailers: Array<AdminMurphysProductTrailerDto>;
};

export type AdminMurphysProductTrailerDto = {
  __typename?: 'AdminMurphysProductTrailerDto';
  alreadyImported: Scalars['Boolean']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AdminMurphysReturnSubmissionDto = {
  __typename?: 'AdminMurphysReturnSubmissionDto';
  account: Scalars['String']['output'];
  claimId: Scalars['Int']['output'];
  locationId: Scalars['Int']['output'];
  murphysSalesOrderId: Scalars['String']['output'];
  optionDescription?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['Int']['output'];
  orderItemId: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  returnId: Scalars['Int']['output'];
  returnItemId: Scalars['Int']['output'];
  submittedByAdminUserId?: Maybe<Scalars['Int']['output']>;
  submittedByAdminUserName?: Maybe<Scalars['String']['output']>;
  submittedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminMurphysReturnSubmissionReportDto = {
  __typename?: 'AdminMurphysReturnSubmissionReportDto';
  items: Array<AdminMurphysReturnSubmissionDto>;
  totalCount: Scalars['Int']['output'];
  ukCount: Scalars['Int']['output'];
  usaCount: Scalars['Int']['output'];
};

export type AdminMurphysSalesOrderDto = {
  __typename?: 'AdminMurphysSalesOrderDto';
  country: Scalars['String']['output'];
  displaySalesOrderId: Scalars['String']['output'];
  extraItems: Array<AdminMurphysSalesOrderExtraItemDto>;
  foundInMurphys: Scalars['Boolean']['output'];
  lookupError?: Maybe<Scalars['String']['output']>;
  missingItems: Array<AdminMurphysSalesOrderMissingItemDto>;
  orderStatus?: Maybe<Scalars['String']['output']>;
  orders: Array<AdminMurphysSalesOrderOrderDto>;
  requestedSalesOrderId: Scalars['String']['output'];
  salesOrderNumber: Scalars['String']['output'];
  shippedDate?: Maybe<Scalars['DateTime']['output']>;
  trackingNumbers: Array<AdminMurphysSalesOrderTrackingDto>;
};

export type AdminMurphysSalesOrderExtraItemDto = {
  __typename?: 'AdminMurphysSalesOrderExtraItemDto';
  murphysItemId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type AdminMurphysSalesOrderItemDto = {
  __typename?: 'AdminMurphysSalesOrderItemDto';
  canOrderFromMurphys: Scalars['Boolean']['output'];
  distributorId?: Maybe<Scalars['Int']['output']>;
  distributorOrderId?: Maybe<Scalars['String']['output']>;
  exceptionDescription?: Maybe<Scalars['String']['output']>;
  exceptionType?: Maybe<Scalars['Int']['output']>;
  hasOpenException: Scalars['Boolean']['output'];
  murphysItemId?: Maybe<Scalars['Int']['output']>;
  optionDescription?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['Int']['output'];
  orderItemId: Scalars['Int']['output'];
  picked: Scalars['Boolean']['output'];
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productOptionId?: Maybe<Scalars['Int']['output']>;
  productUrlStub?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  refunded: Scalars['Boolean']['output'];
  sentByDistributor: Scalars['Boolean']['output'];
  statuses: Array<AdminMurphysSalesOrderItemStatusDto>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type AdminMurphysSalesOrderItemStatusDto = {
  __typename?: 'AdminMurphysSalesOrderItemStatusDto';
  label: Scalars['String']['output'];
  tone: Scalars['String']['output'];
};

export type AdminMurphysSalesOrderLineResultDto = {
  __typename?: 'AdminMurphysSalesOrderLineResultDto';
  account?: Maybe<MurphysAccount>;
  blockedReasons: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  murphysItemId?: Maybe<Scalars['Int']['output']>;
  orderItemId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  salesOrderId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdminMurphysSalesOrderMissingItemDto = {
  __typename?: 'AdminMurphysSalesOrderMissingItemDto';
  missingQuantity: Scalars['Int']['output'];
  murphysItemId?: Maybe<Scalars['Int']['output']>;
  optionDescription?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['Int']['output'];
  orderItemId: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productOptionId?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
};

export type AdminMurphysSalesOrderOrderDto = {
  __typename?: 'AdminMurphysSalesOrderOrderDto';
  customerName: Scalars['String']['output'];
  items: Array<AdminMurphysSalesOrderItemDto>;
  orderDate: Scalars['DateTime']['output'];
  orderId: Scalars['Int']['output'];
  statusId: Scalars['Int']['output'];
  statusName?: Maybe<Scalars['String']['output']>;
};

export type AdminMurphysSalesOrderTrackingDto = {
  __typename?: 'AdminMurphysSalesOrderTrackingDto';
  trackingNumber: Scalars['String']['output'];
  trackingUrl: Scalars['String']['output'];
};

export type AdminMurphysUkShipmentDto = {
  __typename?: 'AdminMurphysUkShipmentDto';
  deliveredDate?: Maybe<Scalars['DateTime']['output']>;
  deliveryStatus: Scalars['String']['output'];
  expectedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  items: Array<AdminMurphysUkShipmentItemDto>;
  lastActivityDate?: Maybe<Scalars['DateTime']['output']>;
  salesOrderId: Scalars['String']['output'];
  trackingNumber: Scalars['String']['output'];
  trackingNumbers: Array<AdminMurphysUkShipmentTrackingDto>;
  trackingUrl: Scalars['String']['output'];
};

export type AdminMurphysUkShipmentItemDto = {
  __typename?: 'AdminMurphysUkShipmentItemDto';
  isStockTransfer: Scalars['Boolean']['output'];
  optionDescription?: Maybe<Scalars['String']['output']>;
  optionId?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type AdminMurphysUkShipmentTrackingDto = {
  __typename?: 'AdminMurphysUkShipmentTrackingDto';
  trackingNumber: Scalars['String']['output'];
  trackingUrl: Scalars['String']['output'];
};

export type AdminNegativeInventoryDto = {
  __typename?: 'AdminNegativeInventoryDto';
  availableLocations: Array<AdminWarehouseLocationDto>;
  issueCount: Scalars['Int']['output'];
  items: Array<AdminNegativeInventoryItemDto>;
  locationCode: Scalars['String']['output'];
  locationId: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  totalNegativeStock: Scalars['Int']['output'];
  totalReservedForUnpickedOrders: Scalars['Int']['output'];
};

export type AdminNegativeInventoryItemDto = {
  __typename?: 'AdminNegativeInventoryItemDto';
  activeCountRequestId?: Maybe<Scalars['Int']['output']>;
  activeCountRequestTime?: Maybe<Scalars['DateTime']['output']>;
  availableForSale: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  expectedPhysicalCount: Scalars['Int']['output'];
  hasActiveCountRequest: Scalars['Boolean']['output'];
  lastCounted?: Maybe<Scalars['DateTime']['output']>;
  lastCountedAdminUserId?: Maybe<Scalars['Int']['output']>;
  lastCountedAdminUserName?: Maybe<Scalars['String']['output']>;
  lastStockEventTime?: Maybe<Scalars['DateTime']['output']>;
  locationCode: Scalars['String']['output'];
  locationId: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  oldUnpicked: Scalars['Int']['output'];
  optionDescription?: Maybe<Scalars['String']['output']>;
  ordered: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productOptionId?: Maybe<Scalars['Int']['output']>;
  productTypeName?: Maybe<Scalars['String']['output']>;
  productUrlStub: Scalars['String']['output'];
  reservedForUnpickedOrders: Scalars['Int']['output'];
  shelfDeactivatedTime?: Maybe<Scalars['DateTime']['output']>;
  shelfId: Scalars['Int']['output'];
  shelfName: Scalars['String']['output'];
  shortfall: Scalars['Int']['output'];
  sold: Scalars['Int']['output'];
  stockOnShelf: Scalars['Int']['output'];
  storageOnly: Scalars['Boolean']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  unpicked: Scalars['Int']['output'];
};

export type AdminOrderAttachmentDto = {
  __typename?: 'AdminOrderAttachmentDto';
  archived: Scalars['Boolean']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  customerVisible: Scalars['Boolean']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  viewUrl?: Maybe<Scalars['String']['output']>;
};

export type AdminOrderCancellationItemPreviewDto = {
  __typename?: 'AdminOrderCancellationItemPreviewDto';
  description: Scalars['String']['output'];
  orderItemId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  requiresMurphysRemoval: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type AdminOrderCancellationPreviewDto = {
  __typename?: 'AdminOrderCancellationPreviewDto';
  actionType: Scalars['String']['output'];
  blockingReason?: Maybe<Scalars['String']['output']>;
  cancellationReasons: Array<AdminOrderCancellationReasonDto>;
  currentStatus: Scalars['String']['output'];
  currentStatusId: Scalars['Int']['output'];
  eligible: Scalars['Boolean']['output'];
  existingActionType?: Maybe<Scalars['String']['output']>;
  existingCancellationReasonId?: Maybe<Scalars['Int']['output']>;
  existingIssueRefund?: Maybe<Scalars['Boolean']['output']>;
  existingOperationStatus?: Maybe<Scalars['String']['output']>;
  existingRequestId?: Maybe<Scalars['UUID']['output']>;
  items: Array<AdminOrderCancellationItemPreviewDto>;
  orderId: Scalars['Int']['output'];
  refundPreview?: Maybe<AdminOrderRefundPreviewDto>;
  warnings: Array<Scalars['String']['output']>;
};

export type AdminOrderCancellationProcessInputDtoInput = {
  actionType: Scalars['String']['input'];
  cancellationReasonId?: InputMaybe<Scalars['Int']['input']>;
  customerMessage?: InputMaybe<Scalars['String']['input']>;
  issueRefund: Scalars['Boolean']['input'];
  manualProviderReference?: InputMaybe<Scalars['String']['input']>;
  manualProviderRefundConfirmed: Scalars['Boolean']['input'];
  orderId: Scalars['Int']['input'];
  providerAmountToStoreCredit: Scalars['Decimal']['input'];
  reason: Scalars['String']['input'];
  refundRequestId?: InputMaybe<Scalars['UUID']['input']>;
  requestId: Scalars['UUID']['input'];
  sendCustomerEmail: Scalars['Boolean']['input'];
};

export type AdminOrderCancellationQuoteInputDtoInput = {
  actionType: Scalars['String']['input'];
  issueRefund: Scalars['Boolean']['input'];
  manualProviderReference?: InputMaybe<Scalars['String']['input']>;
  manualProviderRefundConfirmed: Scalars['Boolean']['input'];
  orderId: Scalars['Int']['input'];
  providerAmountToStoreCredit: Scalars['Decimal']['input'];
};

export type AdminOrderCancellationReasonDto = {
  __typename?: 'AdminOrderCancellationReasonDto';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type AdminOrderCancellationResultDto = {
  __typename?: 'AdminOrderCancellationResultDto';
  actionType: Scalars['String']['output'];
  customerNotificationStatus: Scalars['String']['output'];
  fraudIpStatus: Scalars['String']['output'];
  message: Scalars['String']['output'];
  murphysStatus: Scalars['String']['output'];
  orderId: Scalars['Int']['output'];
  orderStatusId: Scalars['Int']['output'];
  refundRequestId?: Maybe<Scalars['UUID']['output']>;
  refundStatus: Scalars['String']['output'];
  requestId: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type AdminOrderDto = {
  __typename?: 'AdminOrderDto';
  canChangeShippingAddress: Scalars['Boolean']['output'];
  conventionPickupId?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<CurrencyDto>;
  customerComments?: Maybe<Scalars['String']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['Int']['output'];
  customerInternalNotes?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerVatNumber?: Maybe<Scalars['String']['output']>;
  dropShipFee?: Maybe<Scalars['Decimal']['output']>;
  giftWrap: Scalars['Boolean']['output'];
  hiddenItemSubtotal?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  importFee?: Maybe<Scalars['Decimal']['output']>;
  importFeeRefunded?: Maybe<Scalars['Decimal']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  isDropShip: Scalars['Boolean']['output'];
  isSubscriptionOrder: Scalars['Boolean']['output'];
  isWholesale: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  notices?: Maybe<Array<AdminOrderNoticeDto>>;
  orderCompletedDate?: Maybe<Scalars['DateTime']['output']>;
  orderDate: Scalars['DateTime']['output'];
  orderItems?: Maybe<Array<OrderItemDto>>;
  packages?: Maybe<Array<PackageDto>>;
  payment?: Maybe<AdminOrderPaymentDto>;
  pointsEarned: Scalars['Int']['output'];
  priority: Scalars['Boolean']['output'];
  processAction?: Maybe<AdminOrderProcessActionDto>;
  shippingAddress?: Maybe<CustomerAddressDto>;
  shippingMethod?: Maybe<Scalars['Int']['output']>;
  shippingMethodDescription?: Maybe<Scalars['String']['output']>;
  shippingPrice?: Maybe<Scalars['Decimal']['output']>;
  shippingTaxTotal?: Maybe<Scalars['Decimal']['output']>;
  status?: Maybe<OrderStatus>;
  statusDescription?: Maybe<Scalars['String']['output']>;
  statusId: Scalars['Int']['output'];
  taxBreakdownSource?: Maybe<Scalars['String']['output']>;
  timeline?: Maybe<Array<OrderTimelineItemDto>>;
  totalPrice: Scalars['Decimal']['output'];
  totalTax: Scalars['Decimal']['output'];
};

export type AdminOrderDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  itemCount?: InputMaybe<SortEnumType>;
  orderDate?: InputMaybe<SortEnumType>;
  totalPrice?: InputMaybe<SortEnumType>;
};

export type AdminOrderExceptionDto = {
  __typename?: 'AdminOrderExceptionDto';
  description?: Maybe<Scalars['String']['output']>;
  exceptionType: Scalars['Int']['output'];
  orderItemId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
};

export type AdminOrderHistoryCurrencyTotalDto = {
  __typename?: 'AdminOrderHistoryCurrencyTotalDto';
  code?: Maybe<Scalars['String']['output']>;
  currencyId?: Maybe<Scalars['Int']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
  total: Scalars['Decimal']['output'];
};

export type AdminOrderHistoryDto = {
  __typename?: 'AdminOrderHistoryDto';
  downloadTotals: Array<AdminOrderHistoryCurrencyTotalDto>;
  endDate: Scalars['DateTime']['output'];
  orders: Array<AdminOrderHistoryOrderDto>;
  periodTotals: Array<AdminOrderHistoryCurrencyTotalDto>;
  startDate: Scalars['DateTime']['output'];
};

export type AdminOrderHistoryOrderDto = {
  __typename?: 'AdminOrderHistoryOrderDto';
  currency?: Maybe<CurrencyDto>;
  customerId: Scalars['Int']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  orderDate: Scalars['DateTime']['output'];
  productNames: Array<Scalars['String']['output']>;
  totalPrice: Scalars['Decimal']['output'];
};

export type AdminOrderItemProductCandidateDto = {
  __typename?: 'AdminOrderItemProductCandidateDto';
  availableStock: Scalars['Int']['output'];
  creatorDisplayName?: Maybe<Scalars['String']['output']>;
  discontinued: Scalars['Boolean']['output'];
  exclusive: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  live: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  options: Array<AdminOrderItemProductOptionDto>;
  productType: Scalars['String']['output'];
  requiresOption: Scalars['Boolean']['output'];
  urlStub?: Maybe<Scalars['String']['output']>;
  usdPrice: Scalars['Decimal']['output'];
};

export type AdminOrderItemProductOptionDto = {
  __typename?: 'AdminOrderItemProductOptionDto';
  availableStock: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  eligible: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  live: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
  stock?: Maybe<Scalars['Int']['output']>;
};

export type AdminOrderListItemDto = {
  __typename?: 'AdminOrderListItemDto';
  brandCode?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['Int']['output'];
  brandName?: Maybe<Scalars['String']['output']>;
  conventionPickupId?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<CurrencyDto>;
  customerId: Scalars['Int']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  giftWrap: Scalars['Boolean']['output'];
  hasOpenException: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isDropShip: Scalars['Boolean']['output'];
  isWholesale: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  openExceptions: Array<AdminOrderExceptionDto>;
  orderDate: Scalars['DateTime']['output'];
  statusDescription?: Maybe<Scalars['String']['output']>;
  statusId: Scalars['Int']['output'];
  totalPrice: Scalars['Decimal']['output'];
  unsentDistributorNames: Array<Scalars['String']['output']>;
};

export type AdminOrderNoticeDto = {
  __typename?: 'AdminOrderNoticeDto';
  message: Scalars['String']['output'];
  relatedDate?: Maybe<Scalars['DateTime']['output']>;
  relatedOrderId?: Maybe<Scalars['Int']['output']>;
  relatedSummary?: Maybe<Scalars['String']['output']>;
  severity: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AdminOrderPaymentDto = {
  __typename?: 'AdminOrderPaymentDto';
  customerIpAddress?: Maybe<Scalars['String']['output']>;
  customerIpBlockOrders?: Maybe<Scalars['Boolean']['output']>;
  customerIpLastUsed?: Maybe<Scalars['DateTime']['output']>;
  customerIpRiskScore?: Maybe<Scalars['Decimal']['output']>;
  customerIpRiskStatus?: Maybe<Scalars['String']['output']>;
  customerIpSuccessfullyPaid?: Maybe<Scalars['Boolean']['output']>;
  customerIpSuspectedFraud?: Maybe<Scalars['DateTime']['output']>;
  expectedProcessorAmount?: Maybe<Scalars['Decimal']['output']>;
  giftVoucherUsed?: Maybe<Scalars['Decimal']['output']>;
  paidDate?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentMethodId?: Maybe<Scalars['Int']['output']>;
  paymentProcessingFee?: Maybe<Scalars['Decimal']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  processorChargedAmount?: Maybe<Scalars['Decimal']['output']>;
  processorCurrency?: Maybe<Scalars['String']['output']>;
  processorNetAmount?: Maybe<Scalars['Decimal']['output']>;
  processorRefundedAmount?: Maybe<Scalars['Decimal']['output']>;
  processorTransactionId?: Maybe<Scalars['String']['output']>;
  storeCreditUsed?: Maybe<Scalars['Decimal']['output']>;
};

export type AdminOrderProcessActionDto = {
  __typename?: 'AdminOrderProcessActionDto';
  blockedReason?: Maybe<Scalars['String']['output']>;
  canProcess: Scalars['Boolean']['output'];
  requiresOwner: Scalars['Boolean']['output'];
};

export type AdminOrderProcessingResultDto = {
  __typename?: 'AdminOrderProcessingResultDto';
  message: Scalars['String']['output'];
  nextOrderId?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<AdminOrderDto>;
  success: Scalars['Boolean']['output'];
};

/** A segment of a collection. */
export type AdminOrderQueueCollectionSegment = {
  __typename?: 'AdminOrderQueueCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<AdminOrderListItemDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdminOrderQueueCountDto = {
  __typename?: 'AdminOrderQueueCountDto';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type AdminOrderRefundItemInputDtoInput = {
  actionType: Scalars['String']['input'];
  amount: Scalars['Decimal']['input'];
  orderItemId: Scalars['Int']['input'];
  orderItemReturnItemId?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
};

export type AdminOrderRefundItemPreviewDto = {
  __typename?: 'AdminOrderRefundItemPreviewDto';
  description: Scalars['String']['output'];
  dispatched: Scalars['Boolean']['output'];
  lineTax: Scalars['Decimal']['output'];
  maximumRefundAmount: Scalars['Decimal']['output'];
  orderItemId: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  refunded: Scalars['Boolean']['output'];
  requiresMurphysRemoval: Scalars['Boolean']['output'];
  sentToDistributor: Scalars['Boolean']['output'];
  unitPrice: Scalars['Decimal']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type AdminOrderRefundPreviewDto = {
  __typename?: 'AdminOrderRefundPreviewDto';
  blockingReason?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  currencySymbol: Scalars['String']['output'];
  eligible: Scalars['Boolean']['output'];
  existingOperationStatus?: Maybe<Scalars['String']['output']>;
  existingRequestId?: Maybe<Scalars['UUID']['output']>;
  items: Array<AdminOrderRefundItemPreviewDto>;
  merchandiseAmount: Scalars['Decimal']['output'];
  merchandiseTaxAmount: Scalars['Decimal']['output'];
  operationType: Scalars['String']['output'];
  orderId: Scalars['Int']['output'];
  originalCreditAmount: Scalars['Decimal']['output'];
  originalCreditAvailable: Scalars['Decimal']['output'];
  paymentMethod: Scalars['String']['output'];
  pointsToDeduct: Scalars['Int']['output'];
  processorAvailableAmount?: Maybe<Scalars['Decimal']['output']>;
  processorName?: Maybe<Scalars['String']['output']>;
  providerAmount: Scalars['Decimal']['output'];
  providerConvertedToCreditAmount: Scalars['Decimal']['output'];
  refundHandling: Scalars['String']['output'];
  shippingAmount: Scalars['Decimal']['output'];
  shippingAvailable: Scalars['Decimal']['output'];
  shippingTaxAmount: Scalars['Decimal']['output'];
  shippingTaxAvailable: Scalars['Decimal']['output'];
  storeCreditAmount: Scalars['Decimal']['output'];
  totalAmount: Scalars['Decimal']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type AdminOrderRefundProcessInputDtoInput = {
  customerNote?: InputMaybe<Scalars['String']['input']>;
  deductPoints: Scalars['Boolean']['input'];
  items: Array<AdminOrderRefundItemInputDtoInput>;
  manualProviderReference?: InputMaybe<Scalars['String']['input']>;
  manualProviderRefundConfirmed: Scalars['Boolean']['input'];
  operationType: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
  providerAmountToStoreCredit: Scalars['Decimal']['input'];
  reason: Scalars['String']['input'];
  requestId: Scalars['UUID']['input'];
  sendCustomerEmail: Scalars['Boolean']['input'];
  shippingAmount: Scalars['Decimal']['input'];
};

export type AdminOrderRefundQuoteInputDtoInput = {
  items: Array<AdminOrderRefundItemInputDtoInput>;
  manualProviderReference?: InputMaybe<Scalars['String']['input']>;
  manualProviderRefundConfirmed: Scalars['Boolean']['input'];
  operationType: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
  providerAmountToStoreCredit: Scalars['Decimal']['input'];
  shippingAmount: Scalars['Decimal']['input'];
};

export type AdminOrderRefundResultDto = {
  __typename?: 'AdminOrderRefundResultDto';
  currency: Scalars['String']['output'];
  message: Scalars['String']['output'];
  orderId: Scalars['Int']['output'];
  pointsDeducted: Scalars['Int']['output'];
  processorRefundId?: Maybe<Scalars['String']['output']>;
  processorStatus?: Maybe<Scalars['String']['output']>;
  providerAmount: Scalars['Decimal']['output'];
  requestId: Scalars['UUID']['output'];
  status: Scalars['String']['output'];
  storeCreditAmount: Scalars['Decimal']['output'];
  success: Scalars['Boolean']['output'];
  totalAmount: Scalars['Decimal']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type AdminOrderSearchResultDto = {
  __typename?: 'AdminOrderSearchResultDto';
  customerId?: Maybe<Scalars['Int']['output']>;
  customers: Array<CustomerDto>;
  kind: Scalars['String']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
};

export type AdminOrderShippingMethodDto = {
  __typename?: 'AdminOrderShippingMethodDto';
  description: Scalars['String']['output'];
  enablesDispatchPriority: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

export type AdminOrderTaxAuditDto = {
  __typename?: 'AdminOrderTaxAuditDto';
  brandId: Scalars['Int']['output'];
  calculatedOrderTotal: Scalars['Decimal']['output'];
  currencyId?: Maybe<Scalars['Int']['output']>;
  importFee?: Maybe<Scalars['Decimal']['output']>;
  importFeeRefunded?: Maybe<Scalars['Decimal']['output']>;
  importFeeType?: Maybe<Scalars['Int']['output']>;
  importFeeTypeDescription: Scalars['String']['output'];
  itemSubtotal: Scalars['Decimal']['output'];
  itemTaxTotal: Scalars['Decimal']['output'];
  items: Array<AdminOrderTaxAuditItemDto>;
  orderDate: Scalars['DateTime']['output'];
  orderId: Scalars['Int']['output'];
  shipping: Scalars['Decimal']['output'];
  shippingTaxTotal?: Maybe<Scalars['Decimal']['output']>;
  taxBreakdownSource?: Maybe<Scalars['String']['output']>;
  taxCharged?: Maybe<Scalars['Decimal']['output']>;
  taxJarRate?: Maybe<TaxJarRateLookupDto>;
  totalTax: Scalars['Decimal']['output'];
  zonosQuote?: Maybe<AdminOrderTaxAuditZonosQuoteDto>;
};

export type AdminOrderTaxAuditItemDto = {
  __typename?: 'AdminOrderTaxAuditItemDto';
  lineSubtotal: Scalars['Decimal']['output'];
  lineTaxTotal?: Maybe<Scalars['Decimal']['output']>;
  optionDescription?: Maybe<Scalars['String']['output']>;
  optionId?: Maybe<Scalars['Int']['output']>;
  orderItemId: Scalars['Int']['output'];
  price: Scalars['Decimal']['output'];
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  refundedDate?: Maybe<Scalars['DateTime']['output']>;
  returnId?: Maybe<Scalars['Int']['output']>;
  taxRate?: Maybe<Scalars['Decimal']['output']>;
  unitTax?: Maybe<Scalars['Decimal']['output']>;
};

export type AdminOrderTaxAuditZonosQuoteDto = {
  __typename?: 'AdminOrderTaxAuditZonosQuoteDto';
  cartId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  requestHash?: Maybe<Scalars['String']['output']>;
  responseDateTime?: Maybe<Scalars['DateTime']['output']>;
  responseJson?: Maybe<Scalars['String']['output']>;
};

/** A segment of a collection. */
export type AdminOrdersByIpAddressCollectionSegment = {
  __typename?: 'AdminOrdersByIpAddressCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<AdminOrderListItemDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdminOverstockedProductDto = {
  __typename?: 'AdminOverstockedProductDto';
  averageMonthlySales: Scalars['Decimal']['output'];
  creatorDisplayName?: Maybe<Scalars['String']['output']>;
  dateAdded: Scalars['DateTime']['output'];
  excessStock: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  lastPurchasedDate?: Maybe<Scalars['DateTime']['output']>;
  live: Scalars['Boolean']['output'];
  manufacturer?: Maybe<PlayingCardManufacturer>;
  manufacturerId: Scalars['Int']['output'];
  monthsCover?: Maybe<Scalars['Decimal']['output']>;
  murphysStock?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  optionDescription?: Maybe<Scalars['String']['output']>;
  productOptionId?: Maybe<Scalars['Int']['output']>;
  productType: ProductTypeDto;
  salesRank?: Maybe<Scalars['Int']['output']>;
  soldInLookback: Scalars['Int']['output'];
  thumbnails?: Maybe<ProductThumbnailsDto>;
  urlStub: Scalars['String']['output'];
  warehouseStock: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type AdminOverstockedProductsCollectionSegment = {
  __typename?: 'AdminOverstockedProductsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<AdminOverstockedProductDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdminPackageResendHistoryDto = {
  __typename?: 'AdminPackageResendHistoryDto';
  orderDate: Scalars['DateTime']['output'];
  originalOrderId: Scalars['Int']['output'];
  replacementOrderId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type AdminPackageResendInputDtoInput = {
  items: Array<AdminPackageResendItemInputDtoInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['Int']['input'];
  packageId: Scalars['Int']['input'];
  reason: AdminPackageResendReason;
  requestId: Scalars['UUID']['input'];
};

export type AdminPackageResendItemDto = {
  __typename?: 'AdminPackageResendItemDto';
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  blockingReason?: Maybe<Scalars['String']['output']>;
  canResend: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  isPreorder: Scalars['Boolean']['output'];
  maximumResendQuantity: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  orderItemId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export type AdminPackageResendItemInputDtoInput = {
  orderItemId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type AdminPackageResendPreviewDto = {
  __typename?: 'AdminPackageResendPreviewDto';
  blockingReason?: Maybe<Scalars['String']['output']>;
  deliveredDate?: Maybe<Scalars['DateTime']['output']>;
  destination: Scalars['String']['output'];
  dispatchedDate?: Maybe<Scalars['DateTime']['output']>;
  eligible: Scalars['Boolean']['output'];
  items: Array<AdminPackageResendItemDto>;
  orderId: Scalars['Int']['output'];
  packageId: Scalars['Int']['output'];
  packageStatus?: Maybe<Scalars['String']['output']>;
  previousResends: Array<AdminPackageResendHistoryDto>;
  sourceOrderIds: Array<Scalars['Int']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export enum AdminPackageResendReason {
  Damaged = 'DAMAGED',
  Lost = 'LOST',
  MissingItems = 'MISSING_ITEMS',
  Other = 'OTHER',
  WrongItems = 'WRONG_ITEMS'
}

export type AdminPackageResendResultDto = {
  __typename?: 'AdminPackageResendResultDto';
  message: Scalars['String']['output'];
  packageId: Scalars['Int']['output'];
  replacementOrderIds: Array<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type AdminPackageStatsDto = {
  __typename?: 'AdminPackageStatsDto';
  averageDispatchMinutesPastWeek?: Maybe<Scalars['Float']['output']>;
  otherThisMonth: Scalars['Int']['output'];
  otherToday: Scalars['Int']['output'];
  totalThisMonth: Scalars['Int']['output'];
  totalToday: Scalars['Int']['output'];
  ukThisMonth: Scalars['Int']['output'];
  ukToday: Scalars['Int']['output'];
  usaThisMonth: Scalars['Int']['output'];
  usaToday: Scalars['Int']['output'];
};

export type AdminPartiallyPickedBoxDto = {
  __typename?: 'AdminPartiallyPickedBoxDto';
  activeItemCount: Scalars['Int']['output'];
  activeOrderCount: Scalars['Int']['output'];
  assignedOrderId?: Maybe<Scalars['Int']['output']>;
  boxId: Scalars['Int']['output'];
  canClearAssignment: Scalars['Boolean']['output'];
  health: AdminPartiallyPickedBoxHealth;
  id: Scalars['Int']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  locationId: Scalars['Int']['output'];
  size: Scalars['String']['output'];
};

export enum AdminPartiallyPickedBoxHealth {
  AssignmentOnly = 'ASSIGNMENT_ONLY',
  Available = 'AVAILABLE',
  InUse = 'IN_USE',
  ItemRelationOnly = 'ITEM_RELATION_ONLY',
  MultipleOrders = 'MULTIPLE_ORDERS',
  OrderMismatch = 'ORDER_MISMATCH'
}

export type AdminPartiallyPickedBoxMutationResultDto = {
  __typename?: 'AdminPartiallyPickedBoxMutationResultDto';
  box?: Maybe<AdminPartiallyPickedBoxDto>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AdminPayPalBalanceDto = {
  __typename?: 'AdminPayPalBalanceDto';
  account: Scalars['String']['output'];
  asOfTime?: Maybe<Scalars['DateTime']['output']>;
  availableBalance?: Maybe<Scalars['Decimal']['output']>;
  currency: Scalars['String']['output'];
  isAvailable: Scalars['Boolean']['output'];
  lastRefreshTime?: Maybe<Scalars['DateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  totalBalance?: Maybe<Scalars['Decimal']['output']>;
  withheldBalance?: Maybe<Scalars['Decimal']['output']>;
};

export type AdminPayPalPayoutResult = {
  __typename?: 'AdminPayPalPayoutResult';
  duplicateRequest: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  requestId: Scalars['UUID']['output'];
  senderBatchId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type AdminPickingExceptionReasonDto = {
  __typename?: 'AdminPickingExceptionReasonDto';
  label: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type AdminPickingFulfillmentGroupDto = {
  __typename?: 'AdminPickingFulfillmentGroupDto';
  distributorOrderId?: Maybe<Scalars['String']['output']>;
  isWarehouseQueue: Scalars['Boolean']['output'];
};

export type AdminPickingItemDto = {
  __typename?: 'AdminPickingItemDto';
  canOrderFromMurphys: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  distributorOrderId?: Maybe<Scalars['String']['output']>;
  exceptionDescription?: Maybe<Scalars['String']['output']>;
  exceptionType?: Maybe<Scalars['Int']['output']>;
  hasOpenException: Scalars['Boolean']['output'];
  isPreorder: Scalars['Boolean']['output'];
  optionDescription?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['Int']['output'];
  orderItemId: Scalars['Int']['output'];
  packageId?: Maybe<Scalars['Int']['output']>;
  picked: Scalars['Boolean']['output'];
  pickedBoxId?: Maybe<Scalars['String']['output']>;
  pickedDate?: Maybe<Scalars['DateTime']['output']>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productOptionId?: Maybe<Scalars['Int']['output']>;
  productTypeName?: Maybe<Scalars['String']['output']>;
  productUrlStub?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  shelfId?: Maybe<Scalars['Int']['output']>;
  shelfName?: Maybe<Scalars['String']['output']>;
  stockLocationName?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type AdminPickingMurphysShipmentStatusDto = {
  __typename?: 'AdminPickingMurphysShipmentStatusDto';
  salesOrderId: Scalars['String']['output'];
  shippedDate?: Maybe<Scalars['DateTime']['output']>;
  trackingNumbers: Array<AdminPickingShipmentTrackingDto>;
};

export type AdminPickingMutationResultDto = {
  __typename?: 'AdminPickingMutationResultDto';
  message: Scalars['String']['output'];
  order?: Maybe<AdminPickingOrderDto>;
  success: Scalars['Boolean']['output'];
};

export type AdminPickingOrderDto = {
  __typename?: 'AdminPickingOrderDto';
  customerComments?: Maybe<Scalars['String']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerInternalNotes?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  fulfillmentGroups: Array<AdminPickingFulfillmentGroupDto>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  isPriority: Scalars['Boolean']['output'];
  items: Array<AdminPickingItemDto>;
  lockedByAdminUserId?: Maybe<Scalars['Int']['output']>;
  lockedByAdminUserName?: Maybe<Scalars['String']['output']>;
  lockedByAnotherAdmin: Scalars['Boolean']['output'];
  lockedByCurrentAdmin: Scalars['Boolean']['output'];
  orderDate: Scalars['DateTime']['output'];
  orderId: Scalars['Int']['output'];
  otherOpenOrders: Array<AdminPickingOrderLinkDto>;
  pickedBoxId?: Maybe<Scalars['String']['output']>;
  shippingAddressSummary?: Maybe<Scalars['String']['output']>;
  shippingMethodId?: Maybe<Scalars['Int']['output']>;
  shippingMethodName?: Maybe<Scalars['String']['output']>;
  statusId: Scalars['Int']['output'];
  statusName?: Maybe<Scalars['String']['output']>;
};

export type AdminPickingOrderLinkDto = {
  __typename?: 'AdminPickingOrderLinkDto';
  orderDate: Scalars['DateTime']['output'];
  orderId: Scalars['Int']['output'];
  statusId: Scalars['Int']['output'];
  statusName?: Maybe<Scalars['String']['output']>;
};

export type AdminPickingOrderSummaryDto = {
  __typename?: 'AdminPickingOrderSummaryDto';
  badges: Array<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  hasMultipleItems: Scalars['Boolean']['output'];
  hasOpenException: Scalars['Boolean']['output'];
  isPickedPartial: Scalars['Boolean']['output'];
  isPreorder: Scalars['Boolean']['output'];
  isPriority: Scalars['Boolean']['output'];
  isUps: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  items: Array<AdminPickingOrderSummaryItemDto>;
  orderDate: Scalars['DateTime']['output'];
  orderId: Scalars['Int']['output'];
  statusId: Scalars['Int']['output'];
  statusName?: Maybe<Scalars['String']['output']>;
};

export type AdminPickingOrderSummaryItemDto = {
  __typename?: 'AdminPickingOrderSummaryItemDto';
  description?: Maybe<Scalars['String']['output']>;
  optionDescription?: Maybe<Scalars['String']['output']>;
  orderItemId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type AdminPickingPreviousPackageWeightDto = {
  __typename?: 'AdminPickingPreviousPackageWeightDto';
  candidateItemsHashes: Array<Scalars['String']['output']>;
  itemsHash: Scalars['String']['output'];
  matchedItemsHash: Scalars['String']['output'];
  maxWeightLbs: Scalars['Decimal']['output'];
  maxWeightOz: Scalars['Decimal']['output'];
  minWeightLbs: Scalars['Decimal']['output'];
  minWeightOz: Scalars['Decimal']['output'];
  sampleCount: Scalars['Int']['output'];
  warningThresholdPercent: Scalars['Decimal']['output'];
  weightLbs: Scalars['Decimal']['output'];
  weightOz: Scalars['Decimal']['output'];
};

export type AdminPickingQueueDto = {
  __typename?: 'AdminPickingQueueDto';
  closedDate?: Maybe<Scalars['DateTime']['output']>;
  distributorOrderId?: Maybe<Scalars['String']['output']>;
  isWarehouseQueue: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
};

export type AdminPickingShelfOptionDto = {
  __typename?: 'AdminPickingShelfOptionDto';
  availableForSale: Scalars['Int']['output'];
  isCurrentShelf: Scalars['Boolean']['output'];
  isPrimaryShelf: Scalars['Boolean']['output'];
  shelfId: Scalars['Int']['output'];
  shelfName: Scalars['String']['output'];
  stockOnShelf: Scalars['Int']['output'];
};

export type AdminPickingShipmentTrackingDto = {
  __typename?: 'AdminPickingShipmentTrackingDto';
  trackingNumber: Scalars['String']['output'];
  trackingUrl: Scalars['String']['output'];
};

export type AdminPickingWarehouseDto = {
  __typename?: 'AdminPickingWarehouseDto';
  code: Scalars['String']['output'];
  locationId: Scalars['Int']['output'];
  murphysDistributorId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  requiresPickedItemsForBatchShipping: Scalars['Boolean']['output'];
  warehouseDistributorId: Scalars['Int']['output'];
};

export type AdminPreorderProductSummaryDto = {
  __typename?: 'AdminPreorderProductSummaryDto';
  preorderRelease?: Maybe<Scalars['DateTime']['output']>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type AdminPrepareProductDownloadSubtitleUploadInput = {
  contentType: Scalars['String']['input'];
  downloadFileId: Scalars['Int']['input'];
  fileName: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
};

export type AdminPrepareProductDownloadUploadInput = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
};

export type AdminProductAssociationBrandInput = {
  brandId: Scalars['Int']['input'];
  descriptionMarkdown?: InputMaybe<Scalars['String']['input']>;
};

export type AdminProductAuthoringBrandDto = {
  __typename?: 'AdminProductAuthoringBrandDto';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionLastEdit?: Maybe<Scalars['DateTime']['output']>;
  descriptionMarkdown?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  intro?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type AdminProductAuthoringBrandLookupDto = {
  __typename?: 'AdminProductAuthoringBrandLookupDto';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminProductAuthoringCategoryLookupDto = {
  __typename?: 'AdminProductAuthoringCategoryLookupDto';
  brandId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  live: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
};

export type AdminProductAuthoringCurrencyLookupDto = {
  __typename?: 'AdminProductAuthoringCurrencyLookupDto';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  symbol: Scalars['String']['output'];
};

export type AdminProductAuthoringDistributorDto = {
  __typename?: 'AdminProductAuthoringDistributorDto';
  id: Scalars['Int']['output'];
  internal?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminProductAuthoringDownloadChapterDto = {
  __typename?: 'AdminProductAuthoringDownloadChapterDto';
  endSeconds: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  startSeconds: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type AdminProductAuthoringDownloadFileDto = {
  __typename?: 'AdminProductAuthoringDownloadFileDto';
  accessHours?: Maybe<Scalars['Int']['output']>;
  allowDownload: Scalars['Boolean']['output'];
  bunnyId?: Maybe<Scalars['String']['output']>;
  bunnyStatus?: Maybe<Scalars['Int']['output']>;
  chapters: Array<AdminProductAuthoringDownloadChapterDto>;
  filePath: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  indexedDate?: Maybe<Scalars['DateTime']['output']>;
  isPlayable: Scalars['Boolean']['output'];
  lectureStartTime?: Maybe<Scalars['DateTime']['output']>;
  lectureUploaded?: Maybe<Scalars['Boolean']['output']>;
  optionIds: Array<Scalars['Int']['output']>;
  partId?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  runningTime?: Maybe<Scalars['Int']['output']>;
  showOnApp?: Maybe<Scalars['Boolean']['output']>;
  subtitleUploaded: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
  watermarkDownload?: Maybe<Scalars['Boolean']['output']>;
};

export type AdminProductAuthoringDto = {
  __typename?: 'AdminProductAuthoringDto';
  associationsEditToken: Scalars['String']['output'];
  basePrices: Array<AdminProductAuthoringPriceDto>;
  brands: Array<AdminProductAuthoringBrandDto>;
  caseQuantity?: Maybe<Scalars['Int']['output']>;
  categories: Array<AdminProductAuthoringLookupDto>;
  checkedByAdminId?: Maybe<Scalars['Int']['output']>;
  componentParentProductId?: Maybe<Scalars['Int']['output']>;
  creators: Array<AdminProductAuthoringLookupDto>;
  dateAdded: Scalars['DateTime']['output'];
  digitalContentEditToken: Scalars['String']['output'];
  discontinued?: Maybe<Scalars['Boolean']['output']>;
  discountAllowed?: Maybe<Scalars['Boolean']['output']>;
  distributor?: Maybe<AdminProductAuthoringDistributorDto>;
  distributorProductId?: Maybe<Scalars['String']['output']>;
  downloadFiles: Array<AdminProductAuthoringDownloadFileDto>;
  featured: Scalars['Boolean']['output'];
  freeInternationalShipping?: Maybe<Scalars['Boolean']['output']>;
  fulfilmentEditToken: Scalars['String']['output'];
  hazardous?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['Decimal']['output']>;
  htmlDescription?: Maybe<Scalars['String']['output']>;
  htsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identityEditToken: Scalars['String']['output'];
  intro?: Maybe<Scalars['String']['output']>;
  isParent?: Maybe<Scalars['Boolean']['output']>;
  isPreorder?: Maybe<Scalars['Boolean']['output']>;
  legacyDiscountedPrice?: Maybe<Scalars['Decimal']['output']>;
  legacyPrice: Scalars['Decimal']['output'];
  length?: Maybe<Scalars['Decimal']['output']>;
  live: Scalars['Boolean']['output'];
  manufacturer?: Maybe<AdminProductAuthoringLookupDto>;
  mediaEditToken: Scalars['String']['output'];
  metadata: AdminProductAuthoringMetadataDto;
  metadataEditToken: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numberInStock: Scalars['Int']['output'];
  options: Array<AdminProductAuthoringOptionDto>;
  optionsEditToken: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  postSaveWarnings: Array<Scalars['String']['output']>;
  preorderRelease?: Maybe<Scalars['DateTime']['output']>;
  pricingEditToken: Scalars['String']['output'];
  pricingTaxType: Scalars['Int']['output'];
  pricingTaxTypeOverride?: Maybe<Scalars['Int']['output']>;
  productImages: Array<AdminProductAuthoringImageDto>;
  productTrailers: Array<AdminProductAuthoringTrailerDto>;
  productType: AdminProductAuthoringProductTypeLookupDto;
  publicationEditToken: Scalars['String']['output'];
  storefrontUrl?: Maybe<Scalars['String']['output']>;
  textDescription?: Maybe<Scalars['String']['output']>;
  thumbnailPath?: Maybe<Scalars['String']['output']>;
  thumbnails?: Maybe<ProductThumbnailsDto>;
  trailersEditToken: Scalars['String']['output'];
  unassignedOptionSalesQuantity: Scalars['Int']['output'];
  urlStub?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Decimal']['output']>;
  wholesale?: Maybe<Scalars['Boolean']['output']>;
  width?: Maybe<Scalars['Decimal']['output']>;
};

export type AdminProductAuthoringImageDto = {
  __typename?: 'AdminProductAuthoringImageDto';
  dateAdded: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isPrimary: Scalars['Boolean']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  publicUrl: Scalars['String']['output'];
  src: Scalars['String']['output'];
};

export type AdminProductAuthoringLookupDto = {
  __typename?: 'AdminProductAuthoringLookupDto';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminProductAuthoringLookupSearchDto = {
  __typename?: 'AdminProductAuthoringLookupSearchDto';
  creators: Array<AdminProductAuthoringLookupDto>;
  manufacturers: Array<AdminProductAuthoringLookupDto>;
};

export type AdminProductAuthoringLookupsDto = {
  __typename?: 'AdminProductAuthoringLookupsDto';
  brands: Array<AdminProductAuthoringBrandLookupDto>;
  categories: Array<AdminProductAuthoringCategoryLookupDto>;
  currencies: Array<AdminProductAuthoringCurrencyLookupDto>;
  distributors: Array<AdminProductAuthoringDistributorDto>;
  productTypes: Array<AdminProductAuthoringProductTypeLookupDto>;
};

export type AdminProductAuthoringMetadataDto = {
  __typename?: 'AdminProductAuthoringMetadataDto';
  instructionLink?: Maybe<Scalars['String']['output']>;
  instructionPassword?: Maybe<Scalars['String']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  searchKeywords?: Maybe<Scalars['String']['output']>;
};

export type AdminProductAuthoringOptionDto = {
  __typename?: 'AdminProductAuthoringOptionDto';
  description: Scalars['String']['output'];
  distributorId?: Maybe<Scalars['String']['output']>;
  hasDownload?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isDownload: Scalars['Boolean']['output'];
  live?: Maybe<Scalars['Boolean']['output']>;
  position: Scalars['Int']['output'];
  prices: Array<AdminProductAuthoringPriceDto>;
  pricingTaxType: Scalars['Int']['output'];
  pricingTaxTypeOverride?: Maybe<Scalars['Int']['output']>;
  productType?: Maybe<AdminProductAuthoringProductTypeLookupDto>;
  stock?: Maybe<Scalars['Int']['output']>;
  unlimitedStock: Scalars['Boolean']['output'];
};

export type AdminProductAuthoringPriceDto = {
  __typename?: 'AdminProductAuthoringPriceDto';
  currencyCode?: Maybe<Scalars['String']['output']>;
  currencyId: Scalars['Int']['output'];
  discountedPrice?: Maybe<Scalars['Decimal']['output']>;
  dynamicPrice?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  permanentDiscount?: Maybe<Scalars['Decimal']['output']>;
  price: Scalars['Decimal']['output'];
  taxType?: Maybe<Scalars['Int']['output']>;
};

export type AdminProductAuthoringProductTypeLookupDto = {
  __typename?: 'AdminProductAuthoringProductTypeLookupDto';
  defaultTaxType: Scalars['Int']['output'];
  htsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isDownload: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  needsShipping: Scalars['Boolean']['output'];
};

export type AdminProductAuthoringTrailerDto = {
  __typename?: 'AdminProductAuthoringTrailerDto';
  addedThumbnail?: Maybe<Scalars['Boolean']['output']>;
  backupFileName?: Maybe<Scalars['String']['output']>;
  bunnyId?: Maybe<Scalars['String']['output']>;
  bunnyStatus?: Maybe<Scalars['Int']['output']>;
  canRetryImport: Scalars['Boolean']['output'];
  hasImportUrl: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  importCompletedTime?: Maybe<Scalars['DateTime']['output']>;
  importUrl?: Maybe<Scalars['String']['output']>;
  isPlayable: Scalars['Boolean']['output'];
  originalVimeoId?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  uploadTime?: Maybe<Scalars['DateTime']['output']>;
  videoSource?: Maybe<Scalars['String']['output']>;
  videoType: Scalars['Int']['output'];
};

export type AdminProductContractDto = {
  __typename?: 'AdminProductContractDto';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  hasContract: Scalars['Boolean']['output'];
  percentageToCreator?: Maybe<Scalars['Int']['output']>;
  productId: Scalars['Int']['output'];
};

export type AdminProductContractUploadTargetDto = {
  __typename?: 'AdminProductContractUploadTargetDto';
  contentType: Scalars['String']['output'];
  key: Scalars['String']['output'];
  productId: Scalars['Int']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type AdminProductDownloadChapterInput = {
  endSeconds: Scalars['Int']['input'];
  startSeconds: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type AdminProductDownloadPreviewDto = {
  __typename?: 'AdminProductDownloadPreviewDto';
  downloadFileId: Scalars['Int']['output'];
  isBunnyStream: Scalars['Boolean']['output'];
  productId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum AdminProductDownloadStorageStatus {
  Available = 'AVAILABLE',
  Missing = 'MISSING',
  NotApplicable = 'NOT_APPLICABLE',
  Unknown = 'UNKNOWN'
}

export type AdminProductDownloadStorageStatusDto = {
  __typename?: 'AdminProductDownloadStorageStatusDto';
  downloadFileId: Scalars['Int']['output'];
  status: AdminProductDownloadStorageStatus;
};

export type AdminProductDownloadUploadTargetDto = {
  __typename?: 'AdminProductDownloadUploadTargetDto';
  contentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  key: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type AdminProductFinanceCreatorDto = {
  __typename?: 'AdminProductFinanceCreatorDto';
  id: Scalars['Int']['output'];
  isPaymentRecipient: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type AdminProductFinanceDto = {
  __typename?: 'AdminProductFinanceDto';
  brands: Array<AdminProductFinanceLookupDto>;
  creatorFinanceLogVisible: Scalars['Boolean']['output'];
  creatorHasAccountAccess: Scalars['Boolean']['output'];
  creators: Array<AdminProductFinanceCreatorDto>;
  entries: Array<AdminProductFinanceEntryDto>;
  options: Array<AdminProductFinanceLookupDto>;
  productId: Scalars['Int']['output'];
};

export enum AdminProductFinanceEntryDirection {
  Expense = 'EXPENSE',
  Sale = 'SALE'
}

export type AdminProductFinanceEntryDto = {
  __typename?: 'AdminProductFinanceEntryDto';
  amount: Scalars['Decimal']['output'];
  brandId?: Maybe<Scalars['Int']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  category: Scalars['Int']['output'];
  categoryDescription: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  editToken: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  internal: Scalars['Boolean']['output'];
  productOptionBelongsToProduct: Scalars['Boolean']['output'];
  productOptionDescription?: Maybe<Scalars['String']['output']>;
  productOptionId?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
};

export type AdminProductFinanceLookupDto = {
  __typename?: 'AdminProductFinanceLookupDto';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum AdminProductImageVariant {
  Carousel = 'CAROUSEL',
  Sidebar = 'SIDEBAR',
  Square = 'SQUARE',
  VideoThumbnail = 'VIDEO_THUMBNAIL'
}

export type AdminProductInventoryCountAdjustmentDto = {
  __typename?: 'AdminProductInventoryCountAdjustmentDto';
  adminUserId?: Maybe<Scalars['Int']['output']>;
  adminUserName?: Maybe<Scalars['String']['output']>;
  expectedCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  inventoryCountId: Scalars['Int']['output'];
  newCount: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  reviewedByAdminUserId?: Maybe<Scalars['Int']['output']>;
  reviewedByAdminUserName?: Maybe<Scalars['String']['output']>;
  timeHandled?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminProductInventoryCountRequestDto = {
  __typename?: 'AdminProductInventoryCountRequestDto';
  allShelves: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  requestedAdminUserId?: Maybe<Scalars['Int']['output']>;
  requestedAdminUserName?: Maybe<Scalars['String']['output']>;
  timeRequested?: Maybe<Scalars['DateTime']['output']>;
};

export type AdminProductInventoryDetailDto = {
  __typename?: 'AdminProductInventoryDetailDto';
  availableShelves: Array<AdminProductInventoryShelfOptionDto>;
  componentParentProductName?: Maybe<Scalars['String']['output']>;
  locations: Array<AdminProductInventoryLocationSummaryDto>;
  optionDescription?: Maybe<Scalars['String']['output']>;
  options: Array<AdminProductInventoryOptionDto>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productOptionId?: Maybe<Scalars['Int']['output']>;
  productTypeName?: Maybe<Scalars['String']['output']>;
  selectedLocationId: Scalars['Int']['output'];
  shelves: Array<AdminProductInventoryShelfDto>;
};

export type AdminProductInventoryHistoryRowDto = {
  __typename?: 'AdminProductInventoryHistoryRowDto';
  adminUserId?: Maybe<Scalars['Int']['output']>;
  adminUserName?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  countAdjustment?: Maybe<AdminProductInventoryCountAdjustmentDto>;
  countAdjustmentId?: Maybe<Scalars['Int']['output']>;
  countType?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isAfterLastStockReset: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  purchaseOrderId?: Maybe<Scalars['Int']['output']>;
  runningTotal: Scalars['Int']['output'];
  shelfId: Scalars['Int']['output'];
  time: Scalars['DateTime']['output'];
  transfer?: Maybe<AdminProductInventoryTransferDto>;
  transferItemId?: Maybe<Scalars['Int']['output']>;
};

export type AdminProductInventoryLocationSummaryDto = {
  __typename?: 'AdminProductInventoryLocationSummaryDto';
  availableForSale: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  locationId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  reservedForUnpickedOrders: Scalars['Int']['output'];
  shelfCount: Scalars['Int']['output'];
  stockOnShelves: Scalars['Int']['output'];
  storageOnlyStock: Scalars['Int']['output'];
};

export type AdminProductInventoryOptionDto = {
  __typename?: 'AdminProductInventoryOptionDto';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isDownload: Scalars['Boolean']['output'];
  live?: Maybe<Scalars['Boolean']['output']>;
  position: Scalars['Int']['output'];
  productTypeName?: Maybe<Scalars['String']['output']>;
};

export type AdminProductInventoryReservedOrderDto = {
  __typename?: 'AdminProductInventoryReservedOrderDto';
  id: Scalars['Int']['output'];
  inventoryTransferId?: Maybe<Scalars['Int']['output']>;
  orderDate: Scalars['DateTime']['output'];
  orderId: Scalars['Int']['output'];
  orderStatus: Scalars['Int']['output'];
  pickedBoxId?: Maybe<Scalars['String']['output']>;
  pickedDate?: Maybe<Scalars['DateTime']['output']>;
  quantity: Scalars['Int']['output'];
};

export type AdminProductInventoryShelfDto = {
  __typename?: 'AdminProductInventoryShelfDto';
  activeCountRequest?: Maybe<AdminProductInventoryCountRequestDto>;
  availableForSale: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  deactivatedTime?: Maybe<Scalars['DateTime']['output']>;
  expectedPhysicalCount: Scalars['Int']['output'];
  history: Array<AdminProductInventoryHistoryRowDto>;
  isPrimaryPickingShelf: Scalars['Boolean']['output'];
  lastCounted?: Maybe<Scalars['DateTime']['output']>;
  lastStockReset?: Maybe<Scalars['DateTime']['output']>;
  locationId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  oldUnpicked: Scalars['Int']['output'];
  ordered: Scalars['Int']['output'];
  pickingPriorityRank?: Maybe<Scalars['Int']['output']>;
  reservedOrders: Array<AdminProductInventoryReservedOrderDto>;
  shelfId: Scalars['Int']['output'];
  sold: Scalars['Int']['output'];
  stockAdded: Scalars['Int']['output'];
  stockOnShelf: Scalars['Int']['output'];
  stockRemoved: Scalars['Int']['output'];
  storageOnly: Scalars['Boolean']['output'];
  unpicked: Scalars['Int']['output'];
};

export type AdminProductInventoryShelfOptionDto = {
  __typename?: 'AdminProductInventoryShelfOptionDto';
  deactivatedTime?: Maybe<Scalars['DateTime']['output']>;
  locationId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  shelfId: Scalars['Int']['output'];
  storageOnly: Scalars['Boolean']['output'];
};

export type AdminProductInventoryTransferDto = {
  __typename?: 'AdminProductInventoryTransferDto';
  adminUserId?: Maybe<Scalars['Int']['output']>;
  adminUserName?: Maybe<Scalars['String']['output']>;
  fromLocationId: Scalars['Int']['output'];
  fromLocationName?: Maybe<Scalars['String']['output']>;
  fromShelfId?: Maybe<Scalars['Int']['output']>;
  fromShelfName?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  shelfId?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  timeDelivered?: Maybe<Scalars['DateTime']['output']>;
  timeSent?: Maybe<Scalars['DateTime']['output']>;
  toLocationId: Scalars['Int']['output'];
  toLocationName?: Maybe<Scalars['String']['output']>;
  toShelfId?: Maybe<Scalars['Int']['output']>;
  toShelfName?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  transferId?: Maybe<Scalars['Int']['output']>;
  transferItemId: Scalars['Int']['output'];
};

export type AdminProductMetadataKeySuggestionDto = {
  __typename?: 'AdminProductMetadataKeySuggestionDto';
  key: Scalars['String']['output'];
  usageCount: Scalars['Int']['output'];
};

export type AdminProductMetadataRowDto = {
  __typename?: 'AdminProductMetadataRowDto';
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  editToken: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isProtected: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  productOptionId?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type AdminProductMetadataWorkspaceDto = {
  __typename?: 'AdminProductMetadataWorkspaceDto';
  knownKeys: Array<AdminProductMetadataKeySuggestionDto>;
  productId: Scalars['Int']['output'];
  rows: Array<AdminProductMetadataRowDto>;
};

export type AdminProductPublishReadinessDto = {
  __typename?: 'AdminProductPublishReadinessDto';
  blockers: Array<AdminProductPublishReadinessIssueDto>;
  isLive: Scalars['Boolean']['output'];
  isReady: Scalars['Boolean']['output'];
  productId: Scalars['Int']['output'];
  warnings: Array<AdminProductPublishReadinessIssueDto>;
};

export type AdminProductPublishReadinessIssueDto = {
  __typename?: 'AdminProductPublishReadinessIssueDto';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  section: Scalars['String']['output'];
};

export type AdminProductReturnInsightDto = {
  __typename?: 'AdminProductReturnInsightDto';
  dispatchedUnits: Scalars['Int']['output'];
  dispositions: Array<AdminProductStatisticMetricDto>;
  last12MonthsUnitsReturned: Scalars['Int']['output'];
  noReturnRequiredUnits: Scalars['Int']['output'];
  reasons: Array<AdminProductStatisticMetricDto>;
  requiredReturnUnits: Scalars['Int']['output'];
  returnRatePercent?: Maybe<Scalars['Decimal']['output']>;
  returnRequestCount: Scalars['Int']['output'];
  totalUnitsReturned: Scalars['Int']['output'];
};

export type AdminProductStatisticMetricDto = {
  __typename?: 'AdminProductStatisticMetricDto';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type AdminProductStatisticMurphysOrderDto = {
  __typename?: 'AdminProductStatisticMurphysOrderDto';
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  isOpen: Scalars['Boolean']['output'];
  quantity: Scalars['Int']['output'];
  salesOrderNumber: Scalars['String']['output'];
};

export type AdminProductStatisticMurphysRegionDto = {
  __typename?: 'AdminProductStatisticMurphysRegionDto';
  error?: Maybe<Scalars['String']['output']>;
  isMurphysProduct: Scalars['Boolean']['output'];
  murphysProductId?: Maybe<Scalars['Int']['output']>;
  orders: Array<AdminProductStatisticMurphysOrderDto>;
  region: Scalars['String']['output'];
  totalQuantity: Scalars['Int']['output'];
};

export type AdminProductStatisticOrderDto = {
  __typename?: 'AdminProductStatisticOrderDto';
  brandName: Scalars['String']['output'];
  orderDate: Scalars['DateTime']['output'];
  orderId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  region: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type AdminProductStatisticsDto = {
  __typename?: 'AdminProductStatisticsDto';
  abandonedCarts: Array<AdminProductStatisticMetricDto>;
  firstSaleDate?: Maybe<Scalars['DateTime']['output']>;
  monthlyRunRate: Scalars['Int']['output'];
  murphysPurchases: Array<AdminProductStatisticMurphysRegionDto>;
  optionId?: Maybe<Scalars['Int']['output']>;
  productId: Scalars['Int']['output'];
  recentOrders: Array<AdminProductStatisticOrderDto>;
  restockAlertCount: Scalars['Int']['output'];
  returns: AdminProductReturnInsightDto;
  sold: Array<AdminProductStatisticMetricDto>;
  totalSold: Scalars['Int']['output'];
  unsentOrders: Array<AdminProductStatisticOrderDto>;
  waitingToSend: Array<AdminProductStatisticMetricDto>;
};

export type AdminProductStorefrontAndSearchRefreshDto = {
  __typename?: 'AdminProductStorefrontAndSearchRefreshDto';
  productId: Scalars['Int']['output'];
  refreshedAtUtc: Scalars['DateTime']['output'];
  success: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type AdminProductSupplierStockDto = {
  __typename?: 'AdminProductSupplierStockDto';
  applicable: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  productId: Scalars['Int']['output'];
  quantityAvailable?: Maybe<Scalars['Int']['output']>;
};

export type AdminProductTrailerProviderStatusDto = {
  __typename?: 'AdminProductTrailerProviderStatusDto';
  encodeProgress?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  trailerId: Scalars['Int']['output'];
};

export type AdminPublishProductInput = {
  dateAdded?: InputMaybe<Scalars['DateTime']['input']>;
  expectedEditToken: Scalars['String']['input'];
  featured: Scalars['Boolean']['input'];
  productId: Scalars['Int']['input'];
};

export type AdminPurchaseOrderDto = {
  __typename?: 'AdminPurchaseOrderDto';
  closedShortByAdminUserId?: Maybe<Scalars['Int']['output']>;
  closedShortByAdminUserName?: Maybe<Scalars['String']['output']>;
  closedShortNotes?: Maybe<Scalars['String']['output']>;
  dateExpected?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  locationId: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  makeProductLiveOnReceipt: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  placedByAdminUserId: Scalars['Int']['output'];
  placedByAdminUserName?: Maybe<Scalars['String']['output']>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productOptionDescription?: Maybe<Scalars['String']['output']>;
  productOptionId?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  receivedByAdminUserId?: Maybe<Scalars['Int']['output']>;
  receivedByAdminUserName?: Maybe<Scalars['String']['output']>;
  receivedQuantity: Scalars['Int']['output'];
  status: AdminPurchaseOrderStatus;
  timeAdded: Scalars['DateTime']['output'];
  timeArrived?: Maybe<Scalars['DateTime']['output']>;
  timeClosedShort?: Maybe<Scalars['DateTime']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export type AdminPurchaseOrderManufacturerDto = {
  __typename?: 'AdminPurchaseOrderManufacturerDto';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AdminPurchaseOrderOrderSheetDto = {
  __typename?: 'AdminPurchaseOrderOrderSheetDto';
  items: Array<AdminPurchaseOrderOrderSheetItemDto>;
  manufacturerId: Scalars['Int']['output'];
  manufacturerName: Scalars['String']['output'];
  orderInfo: Scalars['String']['output'];
};

export type AdminPurchaseOrderOrderSheetItemDto = {
  __typename?: 'AdminPurchaseOrderOrderSheetItemDto';
  currentStock: Scalars['Int']['output'];
  distributorStock?: Maybe<Scalars['Int']['output']>;
  distributorStockIsLive: Scalars['Boolean']['output'];
  lastOrdered?: Maybe<Scalars['DateTime']['output']>;
  ninetyDayRunRate?: Maybe<Scalars['Float']['output']>;
  openPurchaseOrderQuantity: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productOptionDescription?: Maybe<Scalars['String']['output']>;
  productOptionId?: Maybe<Scalars['Int']['output']>;
  salesDays31To60: Scalars['Int']['output'];
  salesDays61To90: Scalars['Int']['output'];
  salesLast30Days: Scalars['Int']['output'];
  urgency: AdminPurchaseOrderUrgency;
};

export type AdminPurchaseOrderPlacementItemInput = {
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
};

export type AdminPurchaseOrderPlacementResultDto = {
  __typename?: 'AdminPurchaseOrderPlacementResultDto';
  message: Scalars['String']['output'];
  purchaseOrderIds: Array<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdminPurchaseOrderReceiptDto = {
  __typename?: 'AdminPurchaseOrderReceiptDto';
  adminUserId?: Maybe<Scalars['Int']['output']>;
  adminUserName?: Maybe<Scalars['String']['output']>;
  canCorrect: Scalars['Boolean']['output'];
  effectiveQuantity: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  kind?: Maybe<AdminPurchaseOrderReceiptKind>;
  notes?: Maybe<Scalars['String']['output']>;
  purchaseOrderId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  reversesInventoryCountId?: Maybe<Scalars['Int']['output']>;
  shelfId: Scalars['Int']['output'];
  shelfName: Scalars['String']['output'];
  time: Scalars['DateTime']['output'];
  verifiedByAdminUserId?: Maybe<Scalars['Int']['output']>;
  verifiedByAdminUserName?: Maybe<Scalars['String']['output']>;
};

export enum AdminPurchaseOrderReceiptKind {
  Complete = 'COMPLETE',
  Correction = 'CORRECTION',
  ExpectedPartial = 'EXPECTED_PARTIAL',
  UnexpectedShort = 'UNEXPECTED_SHORT'
}

export type AdminPurchaseOrderReceiptReviewDto = {
  __typename?: 'AdminPurchaseOrderReceiptReviewDto';
  message: Scalars['String']['output'];
  outcome?: Maybe<AdminPurchaseOrderReceiptReviewOutcome>;
  success: Scalars['Boolean']['output'];
};

export enum AdminPurchaseOrderReceiptReviewOutcome {
  CompletesPurchaseOrder = 'COMPLETES_PURCHASE_ORDER',
  ExceedsOpenQuantity = 'EXCEEDS_OPEN_QUANTITY',
  LeavesPurchaseOrderOpen = 'LEAVES_PURCHASE_ORDER_OPEN'
}

export type AdminPurchaseOrderResultDto = {
  __typename?: 'AdminPurchaseOrderResultDto';
  message: Scalars['String']['output'];
  purchaseOrder?: Maybe<AdminPurchaseOrderDto>;
  receipt?: Maybe<AdminPurchaseOrderReceiptDto>;
  success: Scalars['Boolean']['output'];
};

export enum AdminPurchaseOrderStatus {
  ClosedShort = 'CLOSED_SHORT',
  Open = 'OPEN',
  PartiallyReceived = 'PARTIALLY_RECEIVED',
  Received = 'RECEIVED'
}

export enum AdminPurchaseOrderUrgency {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum AdminRecommendedFulfillmentAction {
  AlreadyOnMurphysOrder = 'ALREADY_ON_MURPHYS_ORDER',
  Blocked = 'BLOCKED',
  CreateMurphysSalesOrderLine = 'CREATE_MURPHYS_SALES_ORDER_LINE',
  PickFromWarehouse = 'PICK_FROM_WAREHOUSE'
}

export type AdminRefreshProductDownloadStreamingInput = {
  downloadFileId: Scalars['Int']['input'];
  expectedEditToken: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
};

export type AdminRefreshProductTrailerStatusInput = {
  expectedEditToken: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  trailerId: Scalars['Int']['input'];
};

export type AdminRemoteImageDto = {
  __typename?: 'AdminRemoteImageDto';
  base64Data: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type AdminRemoveProductDownloadFileInput = {
  downloadFileId: Scalars['Int']['input'];
  expectedEditToken: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
};

export type AdminRemoveProductImageInput = {
  expectedEditToken: Scalars['String']['input'];
  imageId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  replacementPrimaryImageId?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminRemoveProductTrailerInput = {
  expectedEditToken: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  trailerId: Scalars['Int']['input'];
};

export type AdminReorderProductDownloadFilesInput = {
  downloadFileIds: Array<Scalars['Int']['input']>;
  expectedEditToken: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
};

export type AdminReorderProductImagesInput = {
  expectedEditToken: Scalars['String']['input'];
  imageIds: Array<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};

export type AdminReorderProductOptionsInput = {
  expectedEditToken: Scalars['String']['input'];
  optionIds: Array<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};

export type AdminReorderProductTrailersInput = {
  expectedEditToken: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  trailerIds: Array<Scalars['Int']['input']>;
};

export type AdminReplaceProductDownloadChaptersInput = {
  chapters: Array<AdminProductDownloadChapterInput>;
  downloadFileId: Scalars['Int']['input'];
  expectedEditToken: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
};

export type AdminReplaceProductDownloadFileInput = {
  downloadFileId: Scalars['Int']['input'];
  expectedEditToken: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  storedFilePath?: InputMaybe<Scalars['String']['input']>;
  uploadKey?: InputMaybe<Scalars['String']['input']>;
};

export type AdminRetryProductTrailerImportInput = {
  expectedEditToken: Scalars['String']['input'];
  importUrl?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
  trailerId: Scalars['Int']['input'];
};

export type AdminReturnDetailDto = {
  __typename?: 'AdminReturnDetailDto';
  canCreateUsLabel: Scalars['Boolean']['output'];
  currencySymbol: Scalars['String']['output'];
  customerEmail: Scalars['String']['output'];
  customerId: Scalars['Int']['output'];
  customerName: Scalars['String']['output'];
  dateReceived?: Maybe<Scalars['DateTime']['output']>;
  dateRequested: Scalars['DateTime']['output'];
  internalNotes?: Maybe<Scalars['String']['output']>;
  items: Array<AdminReturnItemDto>;
  labelUrl?: Maybe<Scalars['String']['output']>;
  onHold: Scalars['Boolean']['output'];
  orderId: Scalars['Int']['output'];
  returnId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export type AdminReturnHoldInputDtoInput = {
  customerMessage?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  onHold: Scalars['Boolean']['input'];
  returnId: Scalars['Int']['input'];
  sendCustomerEmail: Scalars['Boolean']['input'];
};

export type AdminReturnItemDto = {
  __typename?: 'AdminReturnItemDto';
  action: Scalars['Int']['output'];
  actionName: Scalars['String']['output'];
  approved?: Maybe<Scalars['Boolean']['output']>;
  canCreateMurphysClaim: Scalars['Boolean']['output'];
  customerNotes?: Maybe<Scalars['String']['output']>;
  imageUrls: Array<Scalars['String']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  isRetiredPartialReplacement: Scalars['Boolean']['output'];
  murphysClaimId?: Maybe<Scalars['Int']['output']>;
  optionDescription?: Maybe<Scalars['String']['output']>;
  optionId?: Maybe<Scalars['Int']['output']>;
  orderItemId: Scalars['Int']['output'];
  originalShipmentCost?: Maybe<Scalars['Decimal']['output']>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  reasonId: Scalars['Int']['output'];
  receivedDate?: Maybe<Scalars['DateTime']['output']>;
  refundRequestId?: Maybe<Scalars['UUID']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  replacementOrderId?: Maybe<Scalars['Int']['output']>;
  resolvedDate?: Maybe<Scalars['DateTime']['output']>;
  returnInsights: AdminProductReturnInsightDto;
  returnItemId: Scalars['Int']['output'];
  returnProductRequired?: Maybe<Scalars['Boolean']['output']>;
  status: Scalars['String']['output'];
  storefrontUrl?: Maybe<Scalars['String']['output']>;
  tax: Scalars['Decimal']['output'];
  unitPrice: Scalars['Decimal']['output'];
  unitReplacementCost?: Maybe<Scalars['Decimal']['output']>;
  warehouseDisposition?: Maybe<Scalars['String']['output']>;
};

export type AdminReturnMutationResultDto = {
  __typename?: 'AdminReturnMutationResultDto';
  message: Scalars['String']['output'];
  return?: Maybe<AdminReturnDetailDto>;
  success: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type AdminReturnQueueDto = {
  __typename?: 'AdminReturnQueueDto';
  awaitingItemsCount: Scalars['Int']['output'];
  items: Array<AdminReturnQueueItemDto>;
  needsReviewCount: Scalars['Int']['output'];
  onHoldCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type AdminReturnQueueItemDto = {
  __typename?: 'AdminReturnQueueItemDto';
  awaitingItemCount: Scalars['Int']['output'];
  customerEmail: Scalars['String']['output'];
  customerId: Scalars['Int']['output'];
  customerName: Scalars['String']['output'];
  dateRequested: Scalars['DateTime']['output'];
  hasRetiredPartialReplacement: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  resolvedItemCount: Scalars['Int']['output'];
  returnId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type AdminReturnResolveItemInputDtoInput = {
  action: Scalars['Int']['input'];
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  manualProviderReference?: InputMaybe<Scalars['String']['input']>;
  manualProviderRefundConfirmed: Scalars['Boolean']['input'];
  returnId: Scalars['Int']['input'];
  returnItemId: Scalars['Int']['input'];
  sendCustomerEmail: Scalars['Boolean']['input'];
  warehouseDisposition: Scalars['String']['input'];
};

export type AdminReturnReviewInputDtoInput = {
  createReturnLabel: Scalars['Boolean']['input'];
  customerMessage?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  items: Array<AdminReturnReviewItemInputDtoInput>;
  returnId: Scalars['Int']['input'];
};

export type AdminReturnReviewItemInputDtoInput = {
  action: Scalars['Int']['input'];
  approved: Scalars['Boolean']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  returnItemId: Scalars['Int']['input'];
  returnProductRequired: Scalars['Boolean']['input'];
};

export type AdminSaleApplyResultDto = {
  __typename?: 'AdminSaleApplyResultDto';
  metadataRowsAdded: Scalars['Int']['output'];
  productCount: Scalars['Int']['output'];
  searchRefreshFailed: Scalars['Boolean']['output'];
  updatedPriceCount: Scalars['Int']['output'];
};

export type AdminSalePreviewDto = {
  __typename?: 'AdminSalePreviewDto';
  blockingReason?: Maybe<Scalars['String']['output']>;
  canApply: Scalars['Boolean']['output'];
  errorRows: Scalars['Int']['output'];
  gbpPriceTargetCount: Scalars['Int']['output'];
  ignoredRows: Scalars['Int']['output'];
  matchedRows: Scalars['Int']['output'];
  optionTargetCount: Scalars['Int']['output'];
  productTargetCount: Scalars['Int']['output'];
  rows: Array<AdminSalePreviewRowDto>;
  totalRows: Scalars['Int']['output'];
  unmatchedRows: Scalars['Int']['output'];
  usdPriceTargetCount: Scalars['Int']['output'];
};

export type AdminSalePreviewRowDto = {
  __typename?: 'AdminSalePreviewRowDto';
  distributorProductId: Scalars['String']['output'];
  gbpPriceTargetCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  productIds: Array<Scalars['Int']['output']>;
  productOptionIds: Array<Scalars['Int']['output']>;
  rowNumber: Scalars['Int']['output'];
  salePriceUsd?: Maybe<Scalars['Decimal']['output']>;
  status: Scalars['String']['output'];
  supplierSalePrice?: Maybe<Scalars['Decimal']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  usdPriceTargetCount: Scalars['Int']['output'];
  wholesalePrice?: Maybe<Scalars['Decimal']['output']>;
};

export type AdminSaleRestoreResultDto = {
  __typename?: 'AdminSaleRestoreResultDto';
  metadataRowsRemoved: Scalars['Int']['output'];
  missingPriceCount: Scalars['Int']['output'];
  productCount: Scalars['Int']['output'];
  restoredPriceCount: Scalars['Int']['output'];
  searchRefreshFailed: Scalars['Boolean']['output'];
  skippedChangedPriceCount: Scalars['Int']['output'];
};

export type AdminSaleRollbackDto = {
  __typename?: 'AdminSaleRollbackDto';
  csv: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  priceRowCount: Scalars['Int']['output'];
  productCount: Scalars['Int']['output'];
};

export type AdminSalesCountDto = {
  __typename?: 'AdminSalesCountDto';
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productOptionDescription?: Maybe<Scalars['String']['output']>;
  productOptionId?: Maybe<Scalars['Int']['output']>;
  sales: Scalars['Int']['output'];
  total: Scalars['Decimal']['output'];
};

export type AdminSalesReportDto = {
  __typename?: 'AdminSalesReportDto';
  generatedAtUtc: Scalars['DateTime']['output'];
  reportDate: Scalars['DateTime']['output'];
  sections: Array<AdminSalesReportSectionDto>;
  storeSales: Array<AdminSalesReportStoreSaleDto>;
};

export type AdminSalesReportSectionDto = {
  __typename?: 'AdminSalesReportSectionDto';
  index: Scalars['Int']['output'];
  rows: Array<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AdminSalesReportStoreSaleDto = {
  __typename?: 'AdminSalesReportStoreSaleDto';
  store: Scalars['String']['output'];
  total: Scalars['Decimal']['output'];
};

export type AdminSaveProductAssociationsInput = {
  brands: Array<AdminProductAssociationBrandInput>;
  categoryIds: Array<Scalars['Int']['input']>;
  creatorIds: Array<Scalars['Int']['input']>;
  expectedEditToken: Scalars['String']['input'];
};

export type AdminSaveProductDetailsInput = {
  associations?: InputMaybe<AdminSaveProductAssociationsInput>;
  fulfilment?: InputMaybe<AdminSaveProductFulfilmentInput>;
  identity?: InputMaybe<AdminSaveProductIdentityInput>;
  metadata?: InputMaybe<AdminSaveProductMetadataInput>;
  pricing?: InputMaybe<AdminSaveProductPricingInput>;
  productId: Scalars['Int']['input'];
};

export type AdminSaveProductFulfilmentInput = {
  caseQuantity?: InputMaybe<Scalars['Int']['input']>;
  distributorProductId?: InputMaybe<Scalars['String']['input']>;
  expectedEditToken: Scalars['String']['input'];
  hazardous: Scalars['Boolean']['input'];
  height?: InputMaybe<Scalars['Decimal']['input']>;
  isPreorder: Scalars['Boolean']['input'];
  length?: InputMaybe<Scalars['Decimal']['input']>;
  preorderRelease?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Decimal']['input']>;
  width?: InputMaybe<Scalars['Decimal']['input']>;
};

export type AdminSaveProductIdentityInput = {
  distributorId: Scalars['Int']['input'];
  expectedEditToken: Scalars['String']['input'];
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  productTypeId?: InputMaybe<Scalars['Int']['input']>;
  updateHierarchy?: InputMaybe<Scalars['Boolean']['input']>;
  urlStub: Scalars['String']['input'];
};

export type AdminSaveProductMetadataInput = {
  expectedEditToken: Scalars['String']['input'];
  instructionLink?: InputMaybe<Scalars['String']['input']>;
  instructionPassword?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
};

export type AdminSaveProductPricingInput = {
  expectedEditToken: Scalars['String']['input'];
  gbpDiscountedPrice?: InputMaybe<Scalars['Decimal']['input']>;
  gbpDynamicPrice: Scalars['Boolean']['input'];
  gbpPrice?: InputMaybe<Scalars['Decimal']['input']>;
  taxType?: InputMaybe<Scalars['Int']['input']>;
  usdDiscountedPrice?: InputMaybe<Scalars['Decimal']['input']>;
  usdPrice: Scalars['Decimal']['input'];
};

export type AdminScanFormDto = {
  __typename?: 'AdminScanFormDto';
  batchId?: Maybe<Scalars['String']['output']>;
  courier: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  formUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  packageCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  warehouse: Scalars['String']['output'];
};

export type AdminShelfAuditLineInput = {
  physicalCount: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminShelfAuditResultDto = {
  __typename?: 'AdminShelfAuditResultDto';
  discrepancies: Array<AdminStockCountDiscrepancyDto>;
  matchedCount: Scalars['Int']['output'];
  recountRequiredCount: Scalars['Int']['output'];
  shelfId: Scalars['Int']['output'];
  shelfName: Scalars['String']['output'];
  submittedCount: Scalars['Int']['output'];
  varianceCount: Scalars['Int']['output'];
};

export type AdminShipmentDispatchResultDto = {
  __typename?: 'AdminShipmentDispatchResultDto';
  message: Scalars['String']['output'];
  packageId?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AdminShipmentPackageInput = {
  height: Scalars['Decimal']['input'];
  length: Scalars['Decimal']['input'];
  template?: InputMaybe<Scalars['String']['input']>;
  templateLabel?: InputMaybe<Scalars['String']['input']>;
  weightLbs: Scalars['Decimal']['input'];
  width: Scalars['Decimal']['input'];
};

export type AdminShipmentPrintDocumentsResultDto = {
  __typename?: 'AdminShipmentPrintDocumentsResultDto';
  message: Scalars['String']['output'];
  packageId?: Maybe<Scalars['Int']['output']>;
  printJobs: Array<AdminShipmentPrintJobDto>;
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AdminShipmentPrintJobDto = {
  __typename?: 'AdminShipmentPrintJobDto';
  copies: Scalars['Int']['output'];
  data: Scalars['String']['output'];
  format: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type AdminShipmentPurchaseResultDto = {
  __typename?: 'AdminShipmentPurchaseResultDto';
  labelUrl?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  packageId?: Maybe<Scalars['Int']['output']>;
  printJobs: Array<AdminShipmentPrintJobDto>;
  shipmentId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type AdminShipmentQuoteResultDto = {
  __typename?: 'AdminShipmentQuoteResultDto';
  easyPostResponseJson?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  rates: Array<AdminShipmentRateDto>;
  selectedRateId?: Maybe<Scalars['String']['output']>;
  selectionRule: Scalars['String']['output'];
  shipmentId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdminShipmentRateDto = {
  __typename?: 'AdminShipmentRateDto';
  amount: Scalars['Decimal']['output'];
  carrier: Scalars['String']['output'];
  carrierAccountId?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  estDelivery: Scalars['String']['output'];
  id: Scalars['String']['output'];
  serviceLevel: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  shipmentId?: Maybe<Scalars['String']['output']>;
};

export enum AdminShoppingCartCompletionMode {
  FreeOrder = 'FREE_ORDER',
  ManualPayment = 'MANUAL_PAYMENT'
}

export type AdminStartProductDownloadStreamingInput = {
  downloadFileId: Scalars['Int']['input'];
  expectedEditToken: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
};

export type AdminStockCountAttemptDto = {
  __typename?: 'AdminStockCountAttemptDto';
  adminUserId?: Maybe<Scalars['Int']['output']>;
  adminUserName?: Maybe<Scalars['String']['output']>;
  attemptNumber: Scalars['Int']['output'];
  expectedCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  physicalCount: Scalars['Int']['output'];
  result: Scalars['String']['output'];
  submittedTime: Scalars['DateTime']['output'];
  taskId: Scalars['Int']['output'];
  varianceQuantity: Scalars['Int']['output'];
};

export type AdminStockCountDashboardDto = {
  __typename?: 'AdminStockCountDashboardDto';
  availableLocations: Array<AdminStockCountLocationDto>;
  completedTodayCount: Scalars['Int']['output'];
  currentTask?: Maybe<AdminStockCountWorkItemDto>;
  currentUserChecksTodayCount: Scalars['Int']['output'];
  locationCode: Scalars['String']['output'];
  locationId: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  manualTaskCount: Scalars['Int']['output'];
  openTaskCount: Scalars['Int']['output'];
  pendingApprovalCount: Scalars['Int']['output'];
  recountRequiredCount: Scalars['Int']['output'];
  unresolvedCount: Scalars['Int']['output'];
};

export type AdminStockCountDiscrepancyDto = {
  __typename?: 'AdminStockCountDiscrepancyDto';
  approvedByAdminUserId?: Maybe<Scalars['Int']['output']>;
  approvedByAdminUserName?: Maybe<Scalars['String']['output']>;
  approvedTime?: Maybe<Scalars['DateTime']['output']>;
  countAdjustmentId?: Maybe<Scalars['Int']['output']>;
  createdTime: Scalars['DateTime']['output'];
  expectedCount: Scalars['Int']['output'];
  firstAttempt?: Maybe<AdminStockCountAttemptDto>;
  firstCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  inventoryCountId?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  reasonCode?: Maybe<Scalars['String']['output']>;
  reasonLabel?: Maybe<Scalars['String']['output']>;
  requiresSecondCount: Scalars['Boolean']['output'];
  reviewNotes?: Maybe<Scalars['String']['output']>;
  secondAttempt?: Maybe<AdminStockCountAttemptDto>;
  secondCount?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  task?: Maybe<AdminStockCountWorkItemDto>;
  taskId: Scalars['Int']['output'];
  updatedTime: Scalars['DateTime']['output'];
  variancePercent?: Maybe<Scalars['Decimal']['output']>;
  varianceQuantity?: Maybe<Scalars['Int']['output']>;
};

export type AdminStockCountHistoryRowDto = {
  __typename?: 'AdminStockCountHistoryRowDto';
  adminUserId?: Maybe<Scalars['Int']['output']>;
  adminUserName?: Maybe<Scalars['String']['output']>;
  attemptId: Scalars['Int']['output'];
  discrepancyStatus?: Maybe<Scalars['String']['output']>;
  expectedCount: Scalars['Int']['output'];
  locationId: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  optionDescription?: Maybe<Scalars['String']['output']>;
  physicalCount: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productOptionId?: Maybe<Scalars['Int']['output']>;
  reasonCode?: Maybe<Scalars['String']['output']>;
  result: Scalars['String']['output'];
  shelfId: Scalars['Int']['output'];
  shelfName: Scalars['String']['output'];
  submittedTime: Scalars['DateTime']['output'];
  taskId: Scalars['Int']['output'];
  taskSource: Scalars['String']['output'];
  taskStatus: Scalars['String']['output'];
  varianceQuantity: Scalars['Int']['output'];
};

export type AdminStockCountLocationDto = {
  __typename?: 'AdminStockCountLocationDto';
  code: Scalars['String']['output'];
  locationId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AdminStockCountReasonCodeDto = {
  __typename?: 'AdminStockCountReasonCodeDto';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type AdminStockCountSubmitResultDto = {
  __typename?: 'AdminStockCountSubmitResultDto';
  discrepancy?: Maybe<AdminStockCountDiscrepancyDto>;
  matched: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  reasonRequired: Scalars['Boolean']['output'];
  recountRequired: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  task?: Maybe<AdminStockCountWorkItemDto>;
};

export type AdminStockCountWorkItemDto = {
  __typename?: 'AdminStockCountWorkItemDto';
  assignedTime?: Maybe<Scalars['DateTime']['output']>;
  assignedToAdminUserId?: Maybe<Scalars['Int']['output']>;
  assignedToAdminUserName?: Maybe<Scalars['String']['output']>;
  createdTime: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  instruction: Scalars['String']['output'];
  lastCountedTime?: Maybe<Scalars['DateTime']['output']>;
  legacyCountRequestId?: Maybe<Scalars['Int']['output']>;
  locationCode: Scalars['String']['output'];
  locationId: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  optionDescription?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productOptionId?: Maybe<Scalars['Int']['output']>;
  productUrlStub?: Maybe<Scalars['String']['output']>;
  shelfId: Scalars['Int']['output'];
  shelfName: Scalars['String']['output'];
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export enum AdminStoreOrderDestination {
  Disney = 'DISNEY',
  Murphys = 'MURPHYS',
  Pier39 = 'PIER39'
}

export type AdminSurveyAgentDto = {
  __typename?: 'AdminSurveyAgentDto';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AdminSurveyReportDto = {
  __typename?: 'AdminSurveyReportDto';
  agents: Array<AdminSurveyAgentDto>;
  averageCsat?: Maybe<Scalars['Float']['output']>;
  csatHasSufficientResponses: Scalars['Boolean']['output'];
  csatResponseCount: Scalars['Int']['output'];
  csatScore?: Maybe<Scalars['Int']['output']>;
  detractorCount: Scalars['Int']['output'];
  dissatisfiedCount: Scalars['Int']['output'];
  followUpRequestedCount: Scalars['Int']['output'];
  minimumResponderCsatResponses: Scalars['Int']['output'];
  neutralCount: Scalars['Int']['output'];
  notAboutResponderCount: Scalars['Int']['output'];
  nps?: Maybe<Scalars['Int']['output']>;
  passiveCount: Scalars['Int']['output'];
  pendingFollowUpCount: Scalars['Int']['output'];
  promoterCount: Scalars['Int']['output'];
  responseCount: Scalars['Int']['output'];
  responses: Array<AdminSurveyResponseDto>;
  satisfiedCount: Scalars['Int']['output'];
  scoredResponseCount: Scalars['Int']['output'];
  sentCount: Scalars['Int']['output'];
  veryDissatisfiedCount: Scalars['Int']['output'];
  verySatisfiedCount: Scalars['Int']['output'];
};

export type AdminSurveyResponseDto = {
  __typename?: 'AdminSurveyResponseDto';
  adminUserId: Scalars['Int']['output'];
  adminUserName: Scalars['String']['output'];
  comments: Scalars['String']['output'];
  completedAt: Scalars['DateTime']['output'];
  csatRating?: Maybe<Scalars['Int']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  customerName: Scalars['String']['output'];
  followUpCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  followUpCompletedBy: Scalars['String']['output'];
  followUpRequested: Scalars['Boolean']['output'];
  generalFeedback: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  notAboutResponder: Scalars['Boolean']['output'];
  notAboutResponderFlaggedAt?: Maybe<Scalars['DateTime']['output']>;
  notAboutResponderFlaggedBy: Scalars['String']['output'];
  notAboutResponderReason: Scalars['String']['output'];
  notAboutResponderSource: Scalars['String']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  responseAttribution: Scalars['String']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  surveyVersion: Scalars['Int']['output'];
  ticketId: Scalars['String']['output'];
  ticketUrl?: Maybe<Scalars['String']['output']>;
};

export type AdminTaxFailureRefundPreviewDto = {
  __typename?: 'AdminTaxFailureRefundPreviewDto';
  blockingReason?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  eligible: Scalars['Boolean']['output'];
  existingOperationStatus?: Maybe<Scalars['String']['output']>;
  minimumRefundAmount: Scalars['Decimal']['output'];
  orderId: Scalars['Int']['output'];
  prepaidImportAmount: Scalars['Decimal']['output'];
  prepaidTaxAmount: Scalars['Decimal']['output'];
  processorAvailableAmount?: Maybe<Scalars['Decimal']['output']>;
  processorChargedAmount?: Maybe<Scalars['Decimal']['output']>;
  processorRefundId?: Maybe<Scalars['String']['output']>;
  processorRefundedAmount?: Maybe<Scalars['Decimal']['output']>;
};

export type AdminTaxFailureRefundResultDto = {
  __typename?: 'AdminTaxFailureRefundResultDto';
  currency: Scalars['String']['output'];
  message: Scalars['String']['output'];
  orderId: Scalars['Int']['output'];
  processorRefundId?: Maybe<Scalars['String']['output']>;
  processorStatus?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  totalRefundAmount: Scalars['Decimal']['output'];
};

export type AdminTypesenseProductHitDto = {
  __typename?: 'AdminTypesenseProductHitDto';
  creators?: Maybe<Scalars['String']['output']>;
  discountGbp?: Maybe<Scalars['Decimal']['output']>;
  discountUsd?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  inStock?: Maybe<Scalars['String']['output']>;
  live?: Maybe<Scalars['Boolean']['output']>;
  objectId?: Maybe<Scalars['String']['output']>;
  priceGbp?: Maybe<Scalars['Decimal']['output']>;
  priceUsd?: Maybe<Scalars['Decimal']['output']>;
  productUrl?: Maybe<Scalars['String']['output']>;
  rawJson: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type AdminTypesenseProductSearchResultDto = {
  __typename?: 'AdminTypesenseProductSearchResultDto';
  found: Scalars['Int']['output'];
  hits: Array<AdminTypesenseProductHitDto>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  query: Scalars['String']['output'];
  usedCache: Scalars['Boolean']['output'];
};

/** A segment of a collection. */
export type AdminUkStockOpportunitiesCollectionSegment = {
  __typename?: 'AdminUkStockOpportunitiesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<AdminUkStockOpportunityDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdminUkStockOpportunityDto = {
  __typename?: 'AdminUkStockOpportunityDto';
  averageMonthlyUkSales: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  lastUkOrderDate: Scalars['DateTime']['output'];
  name?: Maybe<Scalars['String']['output']>;
  optionDescription?: Maybe<Scalars['String']['output']>;
  productOptionId?: Maybe<Scalars['Int']['output']>;
  recommendedQuantity: Scalars['Int']['output'];
  suggestedAction: Scalars['String']['output'];
  supplierStock?: Maybe<Scalars['Int']['output']>;
  targetUkStock: Scalars['Int']['output'];
  thumbnails?: Maybe<ProductThumbnailsDto>;
  ukOrderCount: Scalars['Int']['output'];
  ukStock: Scalars['Int']['output'];
  ukUnitsSold: Scalars['Int']['output'];
  urlStub: Scalars['String']['output'];
  usStock: Scalars['Int']['output'];
};

export type AdminUkTransferBoxInput = {
  height: Scalars['Decimal']['input'];
  items: Array<AdminUkTransferBoxItemInput>;
  length: Scalars['Decimal']['input'];
  weightLbs: Scalars['Decimal']['input'];
  width: Scalars['Decimal']['input'];
};

export type AdminUkTransferBoxItemInput = {
  key: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type AdminUkTransferHistoryDto = {
  __typename?: 'AdminUkTransferHistoryDto';
  cost: Scalars['Decimal']['output'];
  createdBy: Scalars['String']['output'];
  packages: Array<AdminUkTransferPackageDto>;
  timeSent: Scalars['DateTime']['output'];
  transferId: Scalars['Int']['output'];
};

export type AdminUkTransferItemDto = {
  __typename?: 'AdminUkTransferItemDto';
  htsCode: Scalars['String']['output'];
  key: Scalars['String']['output'];
  optionId?: Maybe<Scalars['Int']['output']>;
  optionName?: Maybe<Scalars['String']['output']>;
  orderItemIds: Array<Scalars['Int']['output']>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  shelf: Scalars['String']['output'];
  transferItemId?: Maybe<Scalars['Int']['output']>;
};

export type AdminUkTransferPackageDto = {
  __typename?: 'AdminUkTransferPackageDto';
  boxNumber: Scalars['Int']['output'];
  easyPostShipmentId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<AdminShipmentPrintJobDto>;
  labelUrl?: Maybe<Scalars['String']['output']>;
  trackingNumber: Scalars['String']['output'];
};

export type AdminUkTransferPurchaseDto = {
  __typename?: 'AdminUkTransferPurchaseDto';
  customsMessage: Scalars['String']['output'];
  customsSubmittedElectronically: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  packages: Array<AdminUkTransferPackageDto>;
  success: Scalars['Boolean']['output'];
  transferId?: Maybe<Scalars['Int']['output']>;
};

export type AdminUkTransferQuoteDto = {
  __typename?: 'AdminUkTransferQuoteDto';
  message: Scalars['String']['output'];
  orderId?: Maybe<Scalars['String']['output']>;
  rates: Array<AdminUkTransferRateDto>;
  success: Scalars['Boolean']['output'];
};

export type AdminUkTransferRateDto = {
  __typename?: 'AdminUkTransferRateDto';
  amount: Scalars['Decimal']['output'];
  carrier: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  service: Scalars['String']['output'];
};

export type AdminUnpublishProductInput = {
  dateAdded?: InputMaybe<Scalars['DateTime']['input']>;
  expectedEditToken: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
};

export type AdminUpcomingMasterclassDto = {
  __typename?: 'AdminUpcomingMasterclassDto';
  isReady: Scalars['Boolean']['output'];
  issues: Array<Scalars['String']['output']>;
  lectureDates?: Maybe<Scalars['String']['output']>;
  lectureDaysRaw?: Maybe<Scalars['String']['output']>;
  lectureSchedule: Array<AdminMasterclassLectureDateDto>;
  live?: Maybe<Scalars['Boolean']['output']>;
  month: Scalars['Int']['output'];
  monthName: Scalars['String']['output'];
  productId?: Maybe<Scalars['Int']['output']>;
  productMeta: Array<ProductMetaDto>;
  productName?: Maybe<Scalars['String']['output']>;
  productTypeId?: Maybe<Scalars['Int']['output']>;
  productUrlStub?: Maybe<Scalars['String']['output']>;
  streamyardUrlWeek1?: Maybe<Scalars['String']['output']>;
  streamyardUrlWeek2?: Maybe<Scalars['String']['output']>;
  streamyardUrlWeek3?: Maybe<Scalars['String']['output']>;
  subscriptionMetaDateUpdated?: Maybe<Scalars['DateTime']['output']>;
  subscriptionMetaKey: Scalars['String']['output'];
  subscriptionMetaValue?: Maybe<Scalars['String']['output']>;
  year: Scalars['Int']['output'];
};

export type AdminUpcomingMasterclassesDto = {
  __typename?: 'AdminUpcomingMasterclassesDto';
  items: Array<AdminUpcomingMasterclassDto>;
  months: Scalars['Int']['output'];
  startMonth: Scalars['DateTime']['output'];
  subscriptionProductId: Scalars['Int']['output'];
};

export type AdminUpdateProductAssociationsInput = {
  brands: Array<AdminProductAssociationBrandInput>;
  categoryIds: Array<Scalars['Int']['input']>;
  creatorIds: Array<Scalars['Int']['input']>;
  expectedEditToken: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
};

export type AdminUpdateProductDownloadFileInput = {
  accessHours?: InputMaybe<Scalars['Int']['input']>;
  allowDownload: Scalars['Boolean']['input'];
  downloadFileId: Scalars['Int']['input'];
  expectedEditToken: Scalars['String']['input'];
  lectureStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  optionIds: Array<Scalars['Int']['input']>;
  partId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
  showOnApp: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
  watermarkDownload: Scalars['Boolean']['input'];
};

export type AdminUpdateProductFinanceEntryInput = {
  amount: Scalars['Decimal']['input'];
  brandId: Scalars['Int']['input'];
  category: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  direction: AdminProductFinanceEntryDirection;
  entryId: Scalars['Int']['input'];
  expectedEditToken: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
};

export type AdminUpdateProductFulfilmentInput = {
  caseQuantity?: InputMaybe<Scalars['Int']['input']>;
  distributorProductId?: InputMaybe<Scalars['String']['input']>;
  expectedEditToken: Scalars['String']['input'];
  hazardous: Scalars['Boolean']['input'];
  height?: InputMaybe<Scalars['Decimal']['input']>;
  isPreorder: Scalars['Boolean']['input'];
  length?: InputMaybe<Scalars['Decimal']['input']>;
  preorderRelease?: InputMaybe<Scalars['DateTime']['input']>;
  productId: Scalars['Int']['input'];
  weight?: InputMaybe<Scalars['Decimal']['input']>;
  width?: InputMaybe<Scalars['Decimal']['input']>;
};

export type AdminUpdateProductIdentityInput = {
  distributorId: Scalars['Int']['input'];
  expectedEditToken: Scalars['String']['input'];
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
  productTypeId?: InputMaybe<Scalars['Int']['input']>;
  updateHierarchy?: InputMaybe<Scalars['Boolean']['input']>;
  urlStub: Scalars['String']['input'];
};

export type AdminUpdateProductMetaInput = {
  expectedEditToken: Scalars['String']['input'];
  key: Scalars['String']['input'];
  metaId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['String']['input'];
};

export type AdminUpdateProductMetadataInput = {
  expectedEditToken: Scalars['String']['input'];
  instructionLink?: InputMaybe<Scalars['String']['input']>;
  instructionPassword?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
  searchKeywords?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUpdateProductPricingInput = {
  expectedEditToken: Scalars['String']['input'];
  gbpDiscountedPrice?: InputMaybe<Scalars['Decimal']['input']>;
  gbpDynamicPrice: Scalars['Boolean']['input'];
  gbpPrice?: InputMaybe<Scalars['Decimal']['input']>;
  productId: Scalars['Int']['input'];
  taxType?: InputMaybe<Scalars['Int']['input']>;
  usdDiscountedPrice?: InputMaybe<Scalars['Decimal']['input']>;
  usdPrice: Scalars['Decimal']['input'];
};

export type AdminUpdateProductPublicationInput = {
  dateAdded?: InputMaybe<Scalars['DateTime']['input']>;
  expectedEditToken: Scalars['String']['input'];
  featured: Scalars['Boolean']['input'];
  live: Scalars['Boolean']['input'];
  productId: Scalars['Int']['input'];
};

export type AdminUploadOrderAttachmentInput = {
  base64Data: Scalars['String']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  customerVisible: Scalars['Boolean']['input'];
  fileName: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
};

export type AdminUpsertProductOptionInput = {
  associatePreviousSales: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  distributorId?: InputMaybe<Scalars['String']['input']>;
  expectedEditToken: Scalars['String']['input'];
  gbpDiscountedPrice?: InputMaybe<Scalars['Decimal']['input']>;
  gbpDynamicPrice: Scalars['Boolean']['input'];
  gbpPrice?: InputMaybe<Scalars['Decimal']['input']>;
  live: Scalars['Boolean']['input'];
  optionId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
  productTypeId: Scalars['Int']['input'];
  taxType?: InputMaybe<Scalars['Int']['input']>;
  unlimitedStock: Scalars['Boolean']['input'];
  usdDiscountedPrice?: InputMaybe<Scalars['Decimal']['input']>;
  usdPrice: Scalars['Decimal']['input'];
};

export type AdminUrlMappingResult = {
  __typename?: 'AdminUrlMappingResult';
  originalUrl: Scalars['String']['output'];
  shortUrl: Scalars['String']['output'];
  shortUrlCode: Scalars['String']['output'];
};

export type AdminVatReportRowDto = {
  __typename?: 'AdminVatReportRowDto';
  continent: Scalars['String']['output'];
  country: Scalars['String']['output'];
  digitalPrice: Scalars['Decimal']['output'];
  digitalVat: Scalars['Decimal']['output'];
  orderDate: Scalars['DateTime']['output'];
  orderId: Scalars['Int']['output'];
  physicalVat: Scalars['Decimal']['output'];
  productType: Scalars['String']['output'];
  taxExemptPrice: Scalars['Decimal']['output'];
  totalPrice: Scalars['Decimal']['output'];
  vatNumber: Scalars['String']['output'];
  yearMonth: Scalars['String']['output'];
};

export type AdminWarehouseLocationDto = {
  __typename?: 'AdminWarehouseLocationDto';
  code: Scalars['String']['output'];
  locationId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AdminWarehouseShelfContentDto = {
  __typename?: 'AdminWarehouseShelfContentDto';
  activeCountRequestId?: Maybe<Scalars['Int']['output']>;
  activeCountRequestTime?: Maybe<Scalars['DateTime']['output']>;
  availableForSale: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  countNeeded: Scalars['Boolean']['output'];
  expectedPhysicalCount: Scalars['Int']['output'];
  lastStockEventTime?: Maybe<Scalars['DateTime']['output']>;
  oldUnpicked: Scalars['Int']['output'];
  optionDescription?: Maybe<Scalars['String']['output']>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productOptionId?: Maybe<Scalars['Int']['output']>;
  productTypeName?: Maybe<Scalars['String']['output']>;
  productUrlStub: Scalars['String']['output'];
  reservedForUnpickedOrders: Scalars['Int']['output'];
  sold: Scalars['Int']['output'];
  stockOnShelf: Scalars['Int']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  unpicked: Scalars['Int']['output'];
};

export type AdminWarehouseShelfDto = {
  __typename?: 'AdminWarehouseShelfDto';
  canChangeStorageOnly: Scalars['Boolean']['output'];
  canDeactivate: Scalars['Boolean']['output'];
  canDelete: Scalars['Boolean']['output'];
  canReactivate: Scalars['Boolean']['output'];
  contents: Array<AdminWarehouseShelfContentDto>;
  deactivateBlockers: Array<Scalars['String']['output']>;
  deactivatedTime?: Maybe<Scalars['DateTime']['output']>;
  deleteBlockers: Array<Scalars['String']['output']>;
  hasActiveCountRequest: Scalars['Boolean']['output'];
  lastCounted?: Maybe<Scalars['DateTime']['output']>;
  lastCountedAdminUserId?: Maybe<Scalars['Int']['output']>;
  lastCountedAdminUserName?: Maybe<Scalars['String']['output']>;
  locationId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  productCount: Scalars['Int']['output'];
  shelfId: Scalars['Int']['output'];
  storageOnly: Scalars['Boolean']['output'];
  storageOnlyBlockers: Array<Scalars['String']['output']>;
  totalAvailableForSale: Scalars['Int']['output'];
  totalReservedForUnpickedOrders: Scalars['Int']['output'];
  totalStockOnShelf: Scalars['Int']['output'];
};

export type AdminWarehouseShelvesDto = {
  __typename?: 'AdminWarehouseShelvesDto';
  availableLocations: Array<AdminWarehouseLocationDto>;
  emptyShelfCount: Scalars['Int']['output'];
  locationCode: Scalars['String']['output'];
  locationId: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  productCount: Scalars['Int']['output'];
  shelfCount: Scalars['Int']['output'];
  shelfId?: Maybe<Scalars['Int']['output']>;
  shelves: Array<AdminWarehouseShelfDto>;
  totalAvailableForSale: Scalars['Int']['output'];
  totalStockOnShelves: Scalars['Int']['output'];
};

export type AgentStatsDto = {
  __typename?: 'AgentStatsDto';
  adminUserId: Scalars['Int']['output'];
  chatsThisMonth: Scalars['Int']['output'];
  chatsToday: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  ticketRepliesThisMonth: Scalars['Int']['output'];
  ticketRepliesToday: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type AllSubscriptionsForCustomerCollectionSegment = {
  __typename?: 'AllSubscriptionsForCustomerCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Subscription>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type AnswerDto = {
  __typename?: 'AnswerDto';
  answer?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['Int']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isCreator: Scalars['Boolean']['output'];
  responseTo?: Maybe<Scalars['Int']['output']>;
};

export type AppDeviceDto = {
  __typename?: 'AppDeviceDto';
  deactivatedDate?: Maybe<Scalars['DateTime']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastInstallDate?: Maybe<Scalars['DateTime']['output']>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
};

export type AppDeviceProductDto = {
  __typename?: 'AppDeviceProductDto';
  activeDeviceCount?: Maybe<Scalars['Int']['output']>;
  allowedDeviceCount?: Maybe<Scalars['Int']['output']>;
  devices: Array<AppDeviceDto>;
  installUrls?: Maybe<Array<Maybe<ProductMetaDto>>>;
  licenseCode?: Maybe<Scalars['String']['output']>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

/** A segment of a collection. */
export type AppProductsForCustomerCollectionSegment = {
  __typename?: 'AppProductsForCustomerCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<AppDeviceProductDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type AppVersionStatusDto = {
  __typename?: 'AppVersionStatusDto';
  blocked: Scalars['Boolean']['output'];
  build: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  minimumBuild?: Maybe<Scalars['Int']['output']>;
  minimumVersion?: Maybe<Scalars['String']['output']>;
  platform: Scalars['String']['output'];
  updateUrl?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

/** A segment of a collection. */
export type ArticlesCollectionSegment = {
  __typename?: 'ArticlesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BlogPostDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type AvailablePaymentMethodsDto = {
  __typename?: 'AvailablePaymentMethodsDto';
  payPalAccount?: Maybe<Scalars['String']['output']>;
  paymentPlan?: Maybe<ConventionPaymentPlanInfoDto>;
  showAdminFreeOrder: Scalars['Boolean']['output'];
  showAdminManualPayment: Scalars['Boolean']['output'];
  showApplePay: Scalars['Boolean']['output'];
  showCreditCard: Scalars['Boolean']['output'];
  showKlarna: Scalars['Boolean']['output'];
  showPayPal: Scalars['Boolean']['output'];
  showVenmo: Scalars['Boolean']['output'];
};

export type BannerMessageDto = {
  __typename?: 'BannerMessageDto';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  html?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type BannerMessageDtoFilterInput = {
  and?: InputMaybe<Array<BannerMessageDtoFilterInput>>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  html?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BannerMessageDtoFilterInput>>;
  position?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type BannerMessageDtoSortInput = {
  endDate?: InputMaybe<SortEnumType>;
  html?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  position?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
};

export type BlogCategoryDto = {
  __typename?: 'BlogCategoryDto';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  urlPrefix?: Maybe<Scalars['String']['output']>;
  urlStub?: Maybe<Scalars['String']['output']>;
};

export type BlogCategoryDtoFilterInput = {
  and?: InputMaybe<Array<BlogCategoryDtoFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BlogCategoryDtoFilterInput>>;
  urlStub?: InputMaybe<StringOperationFilterInput>;
};

export type BlogCategoryDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  urlPrefix?: InputMaybe<SortEnumType>;
  urlStub?: InputMaybe<SortEnumType>;
};

export type BlogCommentDto = {
  __typename?: 'BlogCommentDto';
  blogPostId: Scalars['Int']['output'];
  comment: Scalars['String']['output'];
  customerId: Scalars['Int']['output'];
  customerName: Scalars['String']['output'];
  gravatarUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  responseTo?: Maybe<Scalars['Int']['output']>;
  status: Scalars['Int']['output'];
  time: Scalars['DateTime']['output'];
};

export enum BlogCommentStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type BlogPostDto = {
  __typename?: 'BlogPostDto';
  authorName?: Maybe<Scalars['String']['output']>;
  blurb?: Maybe<Scalars['String']['output']>;
  category?: Maybe<BlogCategoryDto>;
  comments: Array<BlogCommentDto>;
  content?: Maybe<Scalars['String']['output']>;
  datePosted: Scalars['DateTime']['output'];
  faqType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  live: Scalars['Boolean']['output'];
  relatedPosts: Array<BlogPostDto>;
  thumbnailSrc: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  urlStub?: Maybe<Scalars['String']['output']>;
};

export type BlogPostDtoFilterInput = {
  and?: InputMaybe<Array<BlogPostDtoFilterInput>>;
  category?: InputMaybe<BlogCategoryDtoFilterInput>;
  faqType?: InputMaybe<StringOperationFilterInput>;
  live?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<BlogPostDtoFilterInput>>;
};

export type BlogPostDtoSortInput = {
  authorName?: InputMaybe<SortEnumType>;
  blurb?: InputMaybe<SortEnumType>;
  category?: InputMaybe<BlogCategoryDtoSortInput>;
  content?: InputMaybe<SortEnumType>;
  datePosted?: InputMaybe<SortEnumType>;
  faqType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  live?: InputMaybe<SortEnumType>;
  thumbnailSrc?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
  urlStub?: InputMaybe<SortEnumType>;
};

export enum BlogPostType {
  BookReview = 'BOOK_REVIEW',
  MasterclassMembers = 'MASTERCLASS_MEMBERS',
  Page = 'PAGE',
  Post = 'POST'
}

/** A segment of a collection. */
export type BlogPostsCollectionSegment = {
  __typename?: 'BlogPostsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BlogPostDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum BlogPublicationStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Scheduled = 'SCHEDULED'
}

export type BlogStorefrontPreviewDto = {
  __typename?: 'BlogStorefrontPreviewDto';
  authorName: Scalars['String']['output'];
  brandCode: Scalars['String']['output'];
  categoryName?: Maybe<Scalars['String']['output']>;
  categoryUrlStub?: Maybe<Scalars['String']['output']>;
  expiresAtUtc: Scalars['DateTime']['output'];
  featuredImageUrl: Scalars['String']['output'];
  html: Scalars['String']['output'];
  intro?: Maybe<Scalars['String']['output']>;
  podcastUrl?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  publicPath: Scalars['String']['output'];
  publishAtUtc: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  type: BlogPostType;
  urlStub: Scalars['String']['output'];
};

export type BookReviewDto = {
  __typename?: 'BookReviewDto';
  authorName?: Maybe<Scalars['String']['output']>;
  blurb?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  datePosted: Scalars['DateTime']['output'];
  faqType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  live: Scalars['Boolean']['output'];
  productSlug?: Maybe<Scalars['String']['output']>;
  thumbnailSrc?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
  urlStub?: Maybe<Scalars['String']['output']>;
};

export type BookReviewDtoFilterInput = {
  and?: InputMaybe<Array<BookReviewDtoFilterInput>>;
  authorName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BookReviewDtoFilterInput>>;
  title?: InputMaybe<StringOperationFilterInput>;
};

/** A segment of a collection. */
export type BookReviewsCollectionSegment = {
  __typename?: 'BookReviewsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BookReviewDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Brand = {
  __typename?: 'Brand';
  code: Scalars['String']['output'];
  countries: Array<Country>;
  currency: Currency;
  currencyId: Scalars['Int']['output'];
  freeShippingThreshold?: Maybe<Scalars['Decimal']['output']>;
  globalShippingThreshold?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  inventoryLocationId?: Maybe<Scalars['Int']['output']>;
  inventoryLocations: Array<InventoryLocation>;
  name: Scalars['String']['output'];
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  stripePublicKey?: Maybe<Scalars['String']['output']>;
  vat: Scalars['Boolean']['output'];
};

export type BrandDto = {
  __typename?: 'BrandDto';
  code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<CurrencyDto>;
  id: Scalars['Int']['output'];
  inventoryLocations?: Maybe<Array<InventoryLocation>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BrandDtoFilterInput = {
  and?: InputMaybe<Array<BrandDtoFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  currency?: InputMaybe<CurrencyDtoFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  inventoryLocations?: InputMaybe<ListFilterInputTypeOfInventoryLocationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BrandDtoFilterInput>>;
};

export type BrandDtoSortInput = {
  code?: InputMaybe<SortEnumType>;
  currency?: InputMaybe<CurrencyDtoSortInput>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type BrandFilterInput = {
  and?: InputMaybe<Array<BrandFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  countries?: InputMaybe<ListFilterInputTypeOfCountryFilterInput>;
  currency?: InputMaybe<CurrencyFilterInput>;
  currencyId?: InputMaybe<IntOperationFilterInput>;
  freeShippingThreshold?: InputMaybe<DecimalOperationFilterInput>;
  globalShippingThreshold?: InputMaybe<DecimalOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  inventoryLocationId?: InputMaybe<IntOperationFilterInput>;
  inventoryLocations?: InputMaybe<ListFilterInputTypeOfInventoryLocationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BrandFilterInput>>;
  stripeAccountId?: InputMaybe<StringOperationFilterInput>;
  stripePublicKey?: InputMaybe<StringOperationFilterInput>;
  vat?: InputMaybe<BooleanOperationFilterInput>;
};

export type CarouselBannerDto = {
  __typename?: 'CarouselBannerDto';
  altText?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageSrc?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CarrierDto = {
  __typename?: 'CarrierDto';
  contactPhone: Scalars['String']['output'];
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Category = {
  __typename?: 'Category';
  allowFilterBooks: Scalars['Boolean']['output'];
  allowFilterDiscounted: Scalars['Boolean']['output'];
  allowFilterDownloads: Scalars['Boolean']['output'];
  allowFilterDvds: Scalars['Boolean']['output'];
  allowFilterExclusive: Scalars['Boolean']['output'];
  allowFilterInStock: Scalars['Boolean']['output'];
  allowFilterTricks: Scalars['Boolean']['output'];
  brandId?: Maybe<Scalars['Int']['output']>;
  customPagePath?: Maybe<Scalars['String']['output']>;
  footerHtml?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  intro?: Maybe<Scalars['String']['output']>;
  live: Scalars['Boolean']['output'];
  metaDescription?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  numberPages?: Maybe<Scalars['Int']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  pageType?: Maybe<Scalars['Int']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  products: Array<Product>;
  showVideo?: Maybe<Scalars['Boolean']['output']>;
  urlStub: Scalars['String']['output'];
};

export type CategoryDto = {
  __typename?: 'CategoryDto';
  allowFilterBooks: Scalars['Boolean']['output'];
  allowFilterDiscounted: Scalars['Boolean']['output'];
  allowFilterDownloads: Scalars['Boolean']['output'];
  allowFilterDvds: Scalars['Boolean']['output'];
  allowFilterExclusive: Scalars['Boolean']['output'];
  allowFilterInStock: Scalars['Boolean']['output'];
  allowFilterTricks: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  intro?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  urlStub?: Maybe<Scalars['String']['output']>;
};

export type CategoryDtoSortInput = {
  allowFilterBooks?: InputMaybe<SortEnumType>;
  allowFilterDiscounted?: InputMaybe<SortEnumType>;
  allowFilterDownloads?: InputMaybe<SortEnumType>;
  allowFilterDvds?: InputMaybe<SortEnumType>;
  allowFilterExclusive?: InputMaybe<SortEnumType>;
  allowFilterInStock?: InputMaybe<SortEnumType>;
  allowFilterTricks?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  intro?: InputMaybe<SortEnumType>;
  metaDescription?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  urlStub?: InputMaybe<SortEnumType>;
};

export type CategoryFilterInput = {
  allowFilterBooks?: InputMaybe<BooleanOperationFilterInput>;
  allowFilterDiscounted?: InputMaybe<BooleanOperationFilterInput>;
  allowFilterDownloads?: InputMaybe<BooleanOperationFilterInput>;
  allowFilterDvds?: InputMaybe<BooleanOperationFilterInput>;
  allowFilterExclusive?: InputMaybe<BooleanOperationFilterInput>;
  allowFilterInStock?: InputMaybe<BooleanOperationFilterInput>;
  allowFilterTricks?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CategoryFilterInput>>;
  brandId?: InputMaybe<IntOperationFilterInput>;
  customPagePath?: InputMaybe<StringOperationFilterInput>;
  footerHtml?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  intro?: InputMaybe<StringOperationFilterInput>;
  live?: InputMaybe<BooleanOperationFilterInput>;
  metaDescription?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  numberPages?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CategoryFilterInput>>;
  pageTitle?: InputMaybe<StringOperationFilterInput>;
  pageType?: InputMaybe<IntOperationFilterInput>;
  parentId?: InputMaybe<IntOperationFilterInput>;
  position?: InputMaybe<IntOperationFilterInput>;
  products?: InputMaybe<ListFilterInputTypeOfProductFilterInput>;
  showVideo?: InputMaybe<BooleanOperationFilterInput>;
  urlStub?: InputMaybe<StringOperationFilterInput>;
};

export type CheckoutPaymentRecoveryStatusDto = {
  __typename?: 'CheckoutPaymentRecoveryStatusDto';
  canRetry: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  paymentIntentId: Scalars['String']['output'];
  paymentSucceeded: Scalars['Boolean']['output'];
  shoppingCartId?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type ComparableDateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ConfirmAdminAssetUploadInput = {
  key: Scalars['String']['input'];
  purpose: AdminAssetUploadPurpose;
};

export type Continent = {
  __typename?: 'Continent';
  defaultShippingPercent?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isoCode: Scalars['String']['output'];
  minimumShippingCost?: Maybe<Scalars['Decimal']['output']>;
  name: Scalars['String']['output'];
};

export type ContinentFilterInput = {
  and?: InputMaybe<Array<ContinentFilterInput>>;
  defaultShippingPercent?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isoCode?: InputMaybe<StringOperationFilterInput>;
  minimumShippingCost?: InputMaybe<DecimalOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ContinentFilterInput>>;
};

export type ConventionPaymentInfoDto = {
  __typename?: 'ConventionPaymentInfoDto';
  defaultCard?: Maybe<ConventionStripeCardDto>;
  hasPaymentCard: Scalars['Boolean']['output'];
  isCardExpired: Scalars['Boolean']['output'];
  remainingAmount: Scalars['Decimal']['output'];
  totalAmount: Scalars['Decimal']['output'];
  totalPaid: Scalars['Decimal']['output'];
};

export type ConventionPaymentInstallmentDto = {
  __typename?: 'ConventionPaymentInstallmentDto';
  amount: Scalars['Decimal']['output'];
  description: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  isExtraPayment: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  paidDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ConventionPaymentPlanInfoDto = {
  __typename?: 'ConventionPaymentPlanInfoDto';
  conventionProductId: Scalars['Int']['output'];
  dueDates: Array<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  installmentAmount: Scalars['Decimal']['output'];
  numberOfInstallments: Scalars['Int']['output'];
  totalAmount: Scalars['Decimal']['output'];
};

export type ConventionPaymentPlanInputDtoInput = {
  dueDates: Array<Scalars['String']['input']>;
};

export type ConventionRegistrantInputDtoInput = {
  meta?: InputMaybe<Array<KeyValueInputDtoInput>>;
  name: Scalars['String']['input'];
  upsellOptionId?: InputMaybe<Scalars['Int']['input']>;
  upsellProductId?: InputMaybe<Scalars['Int']['input']>;
  workshopProductIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ConventionRegistrationDto = {
  __typename?: 'ConventionRegistrationDto';
  conventionEndDate?: Maybe<Scalars['String']['output']>;
  conventionLocation?: Maybe<Scalars['String']['output']>;
  conventionName: Scalars['String']['output'];
  conventionStartDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  optionDescription?: Maybe<Scalars['String']['output']>;
  order?: Maybe<OrderDto>;
  orderId: Scalars['Int']['output'];
  paymentInfo?: Maybe<ConventionPaymentInfoDto>;
  paymentInstallments: Array<ConventionPaymentInstallmentDto>;
  priceCharged: Scalars['Decimal']['output'];
  productId: Scalars['Int']['output'];
  productType: Scalars['String']['output'];
  registrantName?: Maybe<Scalars['String']['output']>;
  thumbnailSrc?: Maybe<Scalars['String']['output']>;
  upgrade?: Maybe<ConventionUpgradeDto>;
  url?: Maybe<Scalars['String']['output']>;
};

/** A segment of a collection. */
export type ConventionRegistrationsCollectionSegment = {
  __typename?: 'ConventionRegistrationsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ConventionRegistrationDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ConventionStripeCardDto = {
  __typename?: 'ConventionStripeCardDto';
  brand: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  last4: Scalars['String']['output'];
};

export enum ConventionTimeFilterEnum {
  All = 'ALL',
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}

export type ConventionUpgradeDto = {
  __typename?: 'ConventionUpgradeDto';
  amount: Scalars['Decimal']['output'];
  currencyId: Scalars['Int']['output'];
  isAvailable: Scalars['Boolean']['output'];
  unavailableReason?: Maybe<Scalars['String']['output']>;
};

export type ConvertPointsToStoreCreditResultDto = {
  __typename?: 'ConvertPointsToStoreCreditResultDto';
  currencyId: Scalars['Int']['output'];
  pointsConverted: Scalars['Int']['output'];
  storeCreditAmount: Scalars['Decimal']['output'];
};

export type ConvertVoucherToStoreCreditResultDto = {
  __typename?: 'ConvertVoucherToStoreCreditResultDto';
  amount: Scalars['Decimal']['output'];
  currencyId: Scalars['Int']['output'];
};

export type Country = {
  __typename?: 'Country';
  addressFormat?: Maybe<Scalars['String']['output']>;
  brand: Brand;
  brandId: Scalars['Int']['output'];
  continent: Continent;
  continentId?: Maybe<Scalars['Int']['output']>;
  customerAddresses: Array<CustomerAddress>;
  customsFormUsa?: Maybe<Scalars['Boolean']['output']>;
  epackageTracking?: Maybe<Scalars['Boolean']['output']>;
  epacketZone?: Maybe<Scalars['Int']['output']>;
  freeShipping: Scalars['Boolean']['output'];
  hasPostcode: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isoCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paperlessInvoice?: Maybe<Scalars['Boolean']['output']>;
  states: Array<State>;
  ukMessage?: Maybe<Scalars['String']['output']>;
  usTerritory?: Maybe<Scalars['Boolean']['output']>;
  usaMessage?: Maybe<Scalars['String']['output']>;
  uspsAllowed?: Maybe<Scalars['Boolean']['output']>;
};

export type CountryDto = {
  __typename?: 'CountryDto';
  brandCode: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  freeShipping: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isoCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CountryDtoFilterInput = {
  and?: InputMaybe<Array<CountryDtoFilterInput>>;
  brand?: InputMaybe<BrandDtoFilterInput>;
  brandCode?: InputMaybe<StringOperationFilterInput>;
  currencyCode?: InputMaybe<StringOperationFilterInput>;
  freeShipping?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isoCode?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CountryDtoFilterInput>>;
};

export type CountryDtoSortInput = {
  brand?: InputMaybe<BrandDtoSortInput>;
  brandCode?: InputMaybe<SortEnumType>;
  currencyCode?: InputMaybe<SortEnumType>;
  freeShipping?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isoCode?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type CountryFilterInput = {
  addressFormat?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CountryFilterInput>>;
  brand?: InputMaybe<BrandFilterInput>;
  brandId?: InputMaybe<IntOperationFilterInput>;
  continent?: InputMaybe<ContinentFilterInput>;
  continentId?: InputMaybe<IntOperationFilterInput>;
  customerAddresses?: InputMaybe<ListFilterInputTypeOfCustomerAddressFilterInput>;
  customsFormUsa?: InputMaybe<BooleanOperationFilterInput>;
  epackageTracking?: InputMaybe<BooleanOperationFilterInput>;
  epacketZone?: InputMaybe<IntOperationFilterInput>;
  freeShipping?: InputMaybe<BooleanOperationFilterInput>;
  hasPostcode?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isoCode?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CountryFilterInput>>;
  paperlessInvoice?: InputMaybe<BooleanOperationFilterInput>;
  states?: InputMaybe<ListFilterInputTypeOfStateFilterInput>;
  ukMessage?: InputMaybe<StringOperationFilterInput>;
  usTerritory?: InputMaybe<BooleanOperationFilterInput>;
  usaMessage?: InputMaybe<StringOperationFilterInput>;
  uspsAllowed?: InputMaybe<BooleanOperationFilterInput>;
};

export type CreateCustomerAddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['Int']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  stateCounty?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
  townCity: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type CreateCustomerAddressResult = {
  __typename?: 'CreateCustomerAddressResult';
  addressId: Scalars['Int']['output'];
  isValidated?: Maybe<Scalars['Boolean']['output']>;
  validationErrorMessage?: Maybe<Scalars['String']['output']>;
};

export type CreateCustomerResultDto = {
  __typename?: 'CreateCustomerResultDto';
  customerId?: Maybe<Scalars['Int']['output']>;
  emailValidation: EmailValidationResultDto;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateInAppPurchaseOrderResultDto = {
  __typename?: 'CreateInAppPurchaseOrderResultDto';
  success: Scalars['Boolean']['output'];
};

export type Creator = {
  __typename?: 'Creator';
  emailAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  menuPosition?: Maybe<Scalars['Int']['output']>;
  miniBio?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  paymentMethod?: Maybe<Scalars['Int']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  products: Array<Product>;
  urlStub?: Maybe<Scalars['String']['output']>;
};

export type CreatorDto = {
  __typename?: 'CreatorDto';
  emailAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  intro?: Maybe<Scalars['String']['output']>;
  menuPosition?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['Int']['output']>;
  photoFilename?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  urlStub?: Maybe<Scalars['String']['output']>;
};

export type CreatorDtoFilterInput = {
  and?: InputMaybe<Array<CreatorDtoFilterInput>>;
  emailAddress?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  intro?: InputMaybe<StringOperationFilterInput>;
  menuPosition?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CreatorDtoFilterInput>>;
  paymentMethod?: InputMaybe<IntOperationFilterInput>;
  photoFilename?: InputMaybe<StringOperationFilterInput>;
  photoUrl?: InputMaybe<StringOperationFilterInput>;
  urlStub?: InputMaybe<StringOperationFilterInput>;
};

export type CreatorFilterInput = {
  and?: InputMaybe<Array<CreatorFilterInput>>;
  emailAddress?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  menuPosition?: InputMaybe<IntOperationFilterInput>;
  miniBio?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CreatorFilterInput>>;
  paymentMethod?: InputMaybe<IntOperationFilterInput>;
  photoUrl?: InputMaybe<StringOperationFilterInput>;
  products?: InputMaybe<ListFilterInputTypeOfProductFilterInput>;
  urlStub?: InputMaybe<StringOperationFilterInput>;
};

export type CreatorOwedStatementRowDto = {
  __typename?: 'CreatorOwedStatementRowDto';
  displayName: Scalars['String']['output'];
  isDownload: Scalars['Boolean']['output'];
  isGrossPayment: Scalars['Boolean']['output'];
  lastPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  newExpenses: Scalars['Decimal']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  optionDescription?: Maybe<Scalars['String']['output']>;
  optionId?: Maybe<Scalars['Int']['output']>;
  priorMonthBalance: Scalars['Decimal']['output'];
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productUrlStub?: Maybe<Scalars['String']['output']>;
  retailRoyalties: Scalars['Decimal']['output'];
  retailUnits: Scalars['Int']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  totalPayable: Scalars['Decimal']['output'];
  totalRoyalties: Scalars['Decimal']['output'];
  wholesaleRoyalties: Scalars['Decimal']['output'];
  wholesaleUnits: Scalars['Int']['output'];
};

export type CreatorPaymentDto = {
  __typename?: 'CreatorPaymentDto';
  amount?: Maybe<Scalars['Decimal']['output']>;
  creatorId: Scalars['Int']['output'];
  datePaid?: Maybe<Scalars['DateTime']['output']>;
  dateProcessed?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  method: Scalars['Int']['output'];
};

export type CreatorPaymentLogDto = {
  __typename?: 'CreatorPaymentLogDto';
  brandId?: Maybe<Scalars['Int']['output']>;
  creatorPaymentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDownload: Scalars['Boolean']['output'];
  paymentDatePaid?: Maybe<Scalars['DateTime']['output']>;
  paymentDetails?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['Int']['output']>;
  postage?: Maybe<Scalars['Decimal']['output']>;
  productId: Scalars['Int']['output'];
  productMeta: Array<ProductMetaDto>;
  productName?: Maybe<Scalars['String']['output']>;
  productOptionDescription?: Maybe<Scalars['String']['output']>;
  productOptionId?: Maybe<Scalars['Int']['output']>;
  productThumbnailUrl?: Maybe<Scalars['String']['output']>;
  productUrlStub?: Maybe<Scalars['String']['output']>;
  retailSalesCount?: Maybe<Scalars['Int']['output']>;
  salesCount?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Decimal']['output'];
  wholesaleSalesCount?: Maybe<Scalars['Int']['output']>;
};

export type CreatorPaymentMethodOptionDto = {
  __typename?: 'CreatorPaymentMethodOptionDto';
  description: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type CreatorProductDto = {
  __typename?: 'CreatorProductDto';
  id: Scalars['Int']['output'];
  meta: Array<ProductMetaDto>;
  name?: Maybe<Scalars['String']['output']>;
  payPerUnit?: Maybe<Scalars['Decimal']['output']>;
  percentageToCreator: Scalars['Int']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  urlStub: Scalars['String']['output'];
};

export type CreatorProfileQuestionAnswerInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type Currency = {
  __typename?: 'Currency';
  addPercent?: Maybe<Scalars['Int']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  symbol: Scalars['String']['output'];
};

export type CurrencyDto = {
  __typename?: 'CurrencyDto';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  symbol?: Maybe<Scalars['String']['output']>;
};

export type CurrencyDtoFilterInput = {
  and?: InputMaybe<Array<CurrencyDtoFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CurrencyDtoFilterInput>>;
  symbol?: InputMaybe<StringOperationFilterInput>;
};

export type CurrencyDtoSortInput = {
  code?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  symbol?: InputMaybe<SortEnumType>;
};

export type CurrencyFilterInput = {
  addPercent?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<CurrencyFilterInput>>;
  countryId?: InputMaybe<IntOperationFilterInput>;
  currencyCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CurrencyFilterInput>>;
  symbol?: InputMaybe<StringOperationFilterInput>;
};

export type CurrentMasterclassDto = {
  __typename?: 'CurrentMasterclassDto';
  hasReleasedFiles: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  lectureDates?: Maybe<Scalars['String']['output']>;
  monthName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  thumbnails?: Maybe<ProductThumbnailsDto>;
  url?: Maybe<Scalars['String']['output']>;
  videoSrc?: Maybe<Scalars['String']['output']>;
};

export type Customer = {
  __typename?: 'Customer';
  affiliateId?: Maybe<Scalars['Int']['output']>;
  allowNonDrmDownloads?: Maybe<Scalars['Boolean']['output']>;
  appSecret?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['Int']['output']>;
  customerAddresses: Array<CustomerAddress>;
  customerBrandLinks: Array<CustomerBrandLink>;
  dateSignedUp: Scalars['DateTime']['output'];
  defaultAddressId?: Maybe<Scalars['Int']['output']>;
  defaultShippingAddress?: Maybe<CustomerAddress>;
  deletedEmailAddress?: Maybe<Scalars['String']['output']>;
  deletedTime?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dropShip?: Maybe<Scalars['Boolean']['output']>;
  dropboxKey?: Maybe<Scalars['String']['output']>;
  dropboxSecret?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  emailAddressChanged?: Maybe<Scalars['DateTime']['output']>;
  emailVerifiedDate?: Maybe<Scalars['Date']['output']>;
  eoriNumber?: Maybe<Scalars['String']['output']>;
  firstOrderDate?: Maybe<Scalars['DateTime']['output']>;
  firstname: Scalars['String']['output'];
  howSignedUp?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  internalNotes?: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  murphysUserCreated?: Maybe<Scalars['Boolean']['output']>;
  newsletterSubscribe?: Maybe<Scalars['Boolean']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  passwordPlain?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferredCountryId?: Maybe<Scalars['Int']['output']>;
  reviews?: Maybe<Array<CustomerReview>>;
  sesBlock?: Maybe<Scalars['DateTime']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  shoppingCarts: Array<ShoppingCart>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  subscriptionStatus?: Maybe<Array<SubscriptionStatus>>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vip?: Maybe<Scalars['Boolean']['output']>;
  wholesale?: Maybe<Scalars['Boolean']['output']>;
  wholesaleDaysToPay?: Maybe<Scalars['Int']['output']>;
  wholesaleDownloadUrl?: Maybe<Scalars['String']['output']>;
  wholesalePercent?: Maybe<Scalars['Int']['output']>;
  wishlistItems: Array<WishlistItem>;
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  addressValidated?: Maybe<Scalars['Boolean']['output']>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['Int']['output']>;
  customer: Customer;
  customerId: Scalars['Int']['output'];
  dateAdded: Scalars['DateTime']['output'];
  dateLastUsed: Scalars['DateTime']['output'];
  deletedTime?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  shippoAddressId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<State>;
  stateCounty?: Maybe<Scalars['String']['output']>;
  stateId?: Maybe<Scalars['Int']['output']>;
  townCity: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type CustomerAddressDto = {
  __typename?: 'CustomerAddressDto';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLine3?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryDto>;
  dateLastUsed?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<StateDto>;
  stateCounty?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type CustomerAddressDtoSortInput = {
  addressLine1?: InputMaybe<SortEnumType>;
  addressLine2?: InputMaybe<SortEnumType>;
  addressLine3?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  country?: InputMaybe<CountryDtoSortInput>;
  dateLastUsed?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
  state?: InputMaybe<StateDtoSortInput>;
  stateCounty?: InputMaybe<SortEnumType>;
  zip?: InputMaybe<SortEnumType>;
};

export type CustomerAddressFilterInput = {
  address1?: InputMaybe<StringOperationFilterInput>;
  address2?: InputMaybe<StringOperationFilterInput>;
  address3?: InputMaybe<StringOperationFilterInput>;
  addressValidated?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CustomerAddressFilterInput>>;
  country?: InputMaybe<CountryFilterInput>;
  countryId?: InputMaybe<IntOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  dateAdded?: InputMaybe<DateTimeOperationFilterInput>;
  dateLastUsed?: InputMaybe<DateTimeOperationFilterInput>;
  deletedTime?: InputMaybe<DateTimeOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerAddressFilterInput>>;
  shippoAddressId?: InputMaybe<StringOperationFilterInput>;
  state?: InputMaybe<StateFilterInput>;
  stateCounty?: InputMaybe<StringOperationFilterInput>;
  stateId?: InputMaybe<IntOperationFilterInput>;
  townCity?: InputMaybe<StringOperationFilterInput>;
  zipCode?: InputMaybe<StringOperationFilterInput>;
};

export type CustomerBrandLink = {
  __typename?: 'CustomerBrandLink';
  brand: Brand;
  brandId: Scalars['Int']['output'];
  cachedTotalSpend?: Maybe<Scalars['Decimal']['output']>;
  currencyId?: Maybe<Scalars['Int']['output']>;
  customerBrandLinkMeta: Array<CustomerBrandLinkMetum>;
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  newsletterState?: Maybe<Scalars['Int']['output']>;
  paymentProviderCustomerId?: Maybe<Scalars['String']['output']>;
  resubscribeSentTime?: Maybe<Scalars['DateTime']['output']>;
  unsubscribedEmailId?: Maybe<Scalars['Int']['output']>;
  unsubscribedTime?: Maybe<Scalars['DateTime']['output']>;
  vat?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerBrandLinkFilterInput = {
  and?: InputMaybe<Array<CustomerBrandLinkFilterInput>>;
  brand?: InputMaybe<BrandFilterInput>;
  brandId?: InputMaybe<IntOperationFilterInput>;
  cachedTotalSpend?: InputMaybe<DecimalOperationFilterInput>;
  currencyId?: InputMaybe<IntOperationFilterInput>;
  customerBrandLinkMeta?: InputMaybe<ListFilterInputTypeOfCustomerBrandLinkMetumFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lastLogin?: InputMaybe<DateTimeOperationFilterInput>;
  newsletterState?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CustomerBrandLinkFilterInput>>;
  paymentProviderCustomerId?: InputMaybe<StringOperationFilterInput>;
  resubscribeSentTime?: InputMaybe<DateTimeOperationFilterInput>;
  unsubscribedEmailId?: InputMaybe<IntOperationFilterInput>;
  unsubscribedTime?: InputMaybe<DateTimeOperationFilterInput>;
  vat?: InputMaybe<BooleanOperationFilterInput>;
};

export type CustomerBrandLinkMetum = {
  __typename?: 'CustomerBrandLinkMetum';
  customerBrandLinkId: Scalars['Int']['output'];
  dateUpdated: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomerBrandLinkMetumFilterInput = {
  and?: InputMaybe<Array<CustomerBrandLinkMetumFilterInput>>;
  customerBrandLinkId?: InputMaybe<IntOperationFilterInput>;
  dateUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerBrandLinkMetumFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type CustomerDto = {
  __typename?: 'CustomerDto';
  birthday?: Maybe<Scalars['Date']['output']>;
  creatorId?: Maybe<Scalars['Int']['output']>;
  emailAddress: Scalars['String']['output'];
  eoriNumber?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isReviewer: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type CustomerFilterInput = {
  affiliateId?: InputMaybe<IntOperationFilterInput>;
  allowNonDrmDownloads?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CustomerFilterInput>>;
  appSecret?: InputMaybe<StringOperationFilterInput>;
  birthday?: InputMaybe<DateOperationFilterInput>;
  creatorId?: InputMaybe<IntOperationFilterInput>;
  customerAddresses?: InputMaybe<ListFilterInputTypeOfCustomerAddressFilterInput>;
  customerBrandLinks?: InputMaybe<ListFilterInputTypeOfCustomerBrandLinkFilterInput>;
  dateSignedUp?: InputMaybe<DateTimeOperationFilterInput>;
  defaultAddressId?: InputMaybe<IntOperationFilterInput>;
  defaultShippingAddress?: InputMaybe<CustomerAddressFilterInput>;
  deletedEmailAddress?: InputMaybe<StringOperationFilterInput>;
  deletedTime?: InputMaybe<DateTimeOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  dropShip?: InputMaybe<BooleanOperationFilterInput>;
  dropboxKey?: InputMaybe<StringOperationFilterInput>;
  dropboxSecret?: InputMaybe<StringOperationFilterInput>;
  emailAddress?: InputMaybe<StringOperationFilterInput>;
  emailAddressChanged?: InputMaybe<DateTimeOperationFilterInput>;
  emailVerifiedDate?: InputMaybe<DateOperationFilterInput>;
  eoriNumber?: InputMaybe<StringOperationFilterInput>;
  firstOrderDate?: InputMaybe<DateTimeOperationFilterInput>;
  firstname?: InputMaybe<StringOperationFilterInput>;
  howSignedUp?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  internalNotes?: InputMaybe<StringOperationFilterInput>;
  lastname?: InputMaybe<StringOperationFilterInput>;
  murphysUserCreated?: InputMaybe<BooleanOperationFilterInput>;
  newsletterSubscribe?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<CustomerFilterInput>>;
  parentId?: InputMaybe<IntOperationFilterInput>;
  password?: InputMaybe<StringOperationFilterInput>;
  passwordPlain?: InputMaybe<StringOperationFilterInput>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  preferredCountryId?: InputMaybe<IntOperationFilterInput>;
  reviews?: InputMaybe<ListFilterInputTypeOfCustomerReviewFilterInput>;
  sesBlock?: InputMaybe<DateTimeOperationFilterInput>;
  sex?: InputMaybe<StringOperationFilterInput>;
  shoppingCarts?: InputMaybe<ListFilterInputTypeOfShoppingCartFilterInput>;
  stripeCustomerId?: InputMaybe<StringOperationFilterInput>;
  subscriptionStatus?: InputMaybe<ListFilterInputTypeOfSubscriptionStatusFilterInput>;
  vatNumber?: InputMaybe<StringOperationFilterInput>;
  vip?: InputMaybe<BooleanOperationFilterInput>;
  wholesale?: InputMaybe<BooleanOperationFilterInput>;
  wholesaleDaysToPay?: InputMaybe<IntOperationFilterInput>;
  wholesaleDownloadUrl?: InputMaybe<StringOperationFilterInput>;
  wholesalePercent?: InputMaybe<IntOperationFilterInput>;
  wishlistItems?: InputMaybe<ListFilterInputTypeOfWishlistItemFilterInput>;
};

export enum CustomerIoWorkspace {
  MagicStores = 'MAGIC_STORES',
  VanishingInc = 'VANISHING_INC'
}

export type CustomerPaymentMethodDto = {
  __typename?: 'CustomerPaymentMethodDto';
  expiryMonth?: Maybe<Scalars['Int']['output']>;
  expiryYear?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  last4?: Maybe<Scalars['String']['output']>;
  paymentCompany?: Maybe<Scalars['String']['output']>;
};

/** A segment of a collection. */
export type CustomerProductInstructionsCollectionSegment = {
  __typename?: 'CustomerProductInstructionsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ProductInstructionDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type CustomerReview = {
  __typename?: 'CustomerReview';
  brandId: Scalars['Int']['output'];
  customer: Customer;
  customerContactedDate?: Maybe<Scalars['DateTime']['output']>;
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  product: Product;
  productId: Scalars['Int']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  review: Scalars['String']['output'];
  reviewDate: Scalars['DateTime']['output'];
  status?: Maybe<Scalars['Int']['output']>;
  ticketid?: Maybe<Scalars['String']['output']>;
};

export type CustomerReviewDto = {
  __typename?: 'CustomerReviewDto';
  customerId: Scalars['Int']['output'];
  gravatarUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isMasterclassSubscriber?: Maybe<Scalars['Boolean']['output']>;
  productId: Scalars['Int']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  productURL?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review?: Maybe<Scalars['String']['output']>;
  reviewDate: Scalars['DateTime']['output'];
  reviewerName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type CustomerReviewFilterInput = {
  and?: InputMaybe<Array<CustomerReviewFilterInput>>;
  brandId?: InputMaybe<IntOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerContactedDate?: InputMaybe<DateTimeOperationFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CustomerReviewFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  rating?: InputMaybe<IntOperationFilterInput>;
  review?: InputMaybe<StringOperationFilterInput>;
  reviewDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<IntOperationFilterInput>;
  ticketid?: InputMaybe<StringOperationFilterInput>;
};

export type CustomerReviewSort = {
  productName?: InputMaybe<SortEnumType>;
  rating?: InputMaybe<SortEnumType>;
  reviewDate?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type CustomerReviewsCollectionSegment = {
  __typename?: 'CustomerReviewsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CustomerReviewDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type CustomerSegmentDto = {
  __typename?: 'CustomerSegmentDto';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CustomerSegmentsResponseDto = {
  __typename?: 'CustomerSegmentsResponseDto';
  segments?: Maybe<Array<Maybe<CustomerSegmentDto>>>;
};

export type CustomerSubscriptionDtoFilterInput = {
  and?: InputMaybe<Array<CustomerSubscriptionDtoFilterInput>>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isCanceled?: InputMaybe<BooleanOperationFilterInput>;
  isInGoodStanding?: InputMaybe<BooleanOperationFilterInput>;
  isPauseScheduled?: InputMaybe<BooleanOperationFilterInput>;
  isPaused?: InputMaybe<BooleanOperationFilterInput>;
  isTrial?: InputMaybe<BooleanOperationFilterInput>;
  nextBillingDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CustomerSubscriptionDtoFilterInput>>;
  pauseInfo?: InputMaybe<CustomerSubscriptionPauseInfoDtoFilterInput>;
  subscriptionId?: InputMaybe<StringOperationFilterInput>;
  subscriptionProviderCode?: InputMaybe<StringOperationFilterInput>;
  subscriptionTier?: InputMaybe<SubscriptionTierEnumOperationFilterInput>;
  trial?: InputMaybe<MasterclassTrialDtoFilterInput>;
};

export type CustomerSubscriptionDtoSortInput = {
  endDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isCanceled?: InputMaybe<SortEnumType>;
  isInGoodStanding?: InputMaybe<SortEnumType>;
  isPauseScheduled?: InputMaybe<SortEnumType>;
  isPaused?: InputMaybe<SortEnumType>;
  isTrial?: InputMaybe<SortEnumType>;
  nextBillingDate?: InputMaybe<SortEnumType>;
  pauseInfo?: InputMaybe<CustomerSubscriptionPauseInfoDtoSortInput>;
  subscriptionId?: InputMaybe<SortEnumType>;
  subscriptionProviderCode?: InputMaybe<SortEnumType>;
  subscriptionTier?: InputMaybe<SortEnumType>;
  trial?: InputMaybe<MasterclassTrialDtoSortInput>;
};

export type CustomerSubscriptionPauseInfoDtoFilterInput = {
  and?: InputMaybe<Array<CustomerSubscriptionPauseInfoDtoFilterInput>>;
  cardBrand?: InputMaybe<StringOperationFilterInput>;
  cardLast4?: InputMaybe<StringOperationFilterInput>;
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  isPauseActive?: InputMaybe<BooleanOperationFilterInput>;
  isPauseScheduled?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<CustomerSubscriptionPauseInfoDtoFilterInput>>;
  pauseStartDate?: InputMaybe<DateTimeOperationFilterInput>;
  resumeChargeAmount?: InputMaybe<DecimalOperationFilterInput>;
  resumeCurrency?: InputMaybe<StringOperationFilterInput>;
  resumeDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type CustomerSubscriptionPauseInfoDtoSortInput = {
  cardBrand?: InputMaybe<SortEnumType>;
  cardLast4?: InputMaybe<SortEnumType>;
  errorMessage?: InputMaybe<SortEnumType>;
  isPauseActive?: InputMaybe<SortEnumType>;
  isPauseScheduled?: InputMaybe<SortEnumType>;
  pauseStartDate?: InputMaybe<SortEnumType>;
  resumeChargeAmount?: InputMaybe<SortEnumType>;
  resumeCurrency?: InputMaybe<SortEnumType>;
  resumeDate?: InputMaybe<SortEnumType>;
};

export type DashboardDto = {
  __typename?: 'DashboardDto';
  agents: Array<AgentStatsDto>;
  chatsThisMonth: Scalars['Int']['output'];
  chatsToday: Scalars['Int']['output'];
  personalChatsThisMonth?: Maybe<Scalars['Int']['output']>;
  personalChatsToday?: Maybe<Scalars['Int']['output']>;
  personalTicketRepliesThisMonth?: Maybe<Scalars['Int']['output']>;
  personalTicketRepliesToday?: Maybe<Scalars['Int']['output']>;
  ticketRepliesThisMonth: Scalars['Int']['output'];
  ticketRepliesToday: Scalars['Int']['output'];
};

export type DateOperationFilterInput = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  neq?: InputMaybe<Scalars['Date']['input']>;
  ngt?: InputMaybe<Scalars['Date']['input']>;
  ngte?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  nlt?: InputMaybe<Scalars['Date']['input']>;
  nlte?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

/** A segment of a collection. */
export type DigitalLibraryCollectionSegment = {
  __typename?: 'DigitalLibraryCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<DigitalLibraryItemDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type DigitalLibraryFilter = {
  and?: InputMaybe<Array<DigitalLibraryFilter>>;
  /** Filter by download file type */
  files?: InputMaybe<ListFilterInputTypeOfDownloadFileDtoFilterInput>;
  /** Include archived downloads */
  isArchived?: InputMaybe<BooleanOperationFilterInput>;
  /** Filter by masterclass */
  isMasterclass?: InputMaybe<BooleanOperationFilterInput>;
  /** Latest playback (UTC) across entitled files for this customer; null if never played. Comparable filter (eq, gt, gte, lt, lte, etc.). */
  lastPlayedAt?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  /** Filter by product name */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DigitalLibraryFilter>>;
  /** Filter by product ID */
  productId?: InputMaybe<IntOperationFilterInput>;
};

export type DigitalLibraryItemDto = {
  __typename?: 'DigitalLibraryItemDto';
  creatorNames?: Maybe<Scalars['String']['output']>;
  creators: Array<CreatorDto>;
  dateAdded?: Maybe<Scalars['DateTime']['output']>;
  directDownloadUrl?: Maybe<Scalars['String']['output']>;
  downloadIntro?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<DownloadFileDto>>;
  firstCreatorName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  isMasterclass: Scalars['Boolean']['output'];
  lastPlayedAt?: Maybe<Scalars['DateTime']['output']>;
  masterclassDownloadQa: MasterclassDownloadQaDto;
  name?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  thumbnailSrc?: Maybe<Scalars['String']['output']>;
};

export type DigitalLibraryItemDtoSortInput = {
  creatorNames?: InputMaybe<SortEnumType>;
  dateAdded?: InputMaybe<SortEnumType>;
  downloadIntro?: InputMaybe<SortEnumType>;
  firstCreatorName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isArchived?: InputMaybe<SortEnumType>;
  isMasterclass?: InputMaybe<SortEnumType>;
  lastPlayedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  productId?: InputMaybe<SortEnumType>;
  productType?: InputMaybe<SortEnumType>;
  thumbnailSrc?: InputMaybe<SortEnumType>;
};

export type Distributor = {
  __typename?: 'Distributor';
  attachPdf: Scalars['Boolean']['output'];
  attachVcard: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  internal?: Maybe<Scalars['Boolean']['output']>;
  lastPackList?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderEmail?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  products: Array<Product>;
  username?: Maybe<Scalars['String']['output']>;
};

export type DistributorDto = {
  __typename?: 'DistributorDto';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type DistributorFilterInput = {
  and?: InputMaybe<Array<DistributorFilterInput>>;
  attachPdf?: InputMaybe<BooleanOperationFilterInput>;
  attachVcard?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  internal?: InputMaybe<BooleanOperationFilterInput>;
  lastPackList?: InputMaybe<DateTimeOperationFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DistributorFilterInput>>;
  orderEmail?: InputMaybe<StringOperationFilterInput>;
  password?: InputMaybe<StringOperationFilterInput>;
  products?: InputMaybe<ListFilterInputTypeOfProductFilterInput>;
  username?: InputMaybe<StringOperationFilterInput>;
};

export type DownloadChapter = {
  __typename?: 'DownloadChapter';
  downloadFile: DownloadFile;
  downloadFileId: Scalars['Int']['output'];
  endPoint: Scalars['TimeSpan']['output'];
  id: Scalars['Int']['output'];
  startPoint: Scalars['TimeSpan']['output'];
  title: Scalars['String']['output'];
};

export type DownloadChapterFilterInput = {
  and?: InputMaybe<Array<DownloadChapterFilterInput>>;
  downloadFile?: InputMaybe<DownloadFileFilterInput>;
  downloadFileId?: InputMaybe<IntOperationFilterInput>;
  endPoint?: InputMaybe<TimeSpanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<DownloadChapterFilterInput>>;
  startPoint?: InputMaybe<TimeSpanOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
};

export type DownloadFile = {
  __typename?: 'DownloadFile';
  accessHours?: Maybe<Scalars['Int']['output']>;
  allowDownload: Scalars['Boolean']['output'];
  bunnyId?: Maybe<Scalars['String']['output']>;
  downloadChapters?: Maybe<Array<DownloadChapter>>;
  downloadFileLastAccess?: Maybe<Array<DownloadFileLastAccess>>;
  downloadFileOptionLinks?: Maybe<Array<DownloadFileOptionLink>>;
  downloadFileType?: Maybe<DownloadFileType>;
  downloadVersionPath?: Maybe<Scalars['String']['output']>;
  filePath: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  indexedDate?: Maybe<Scalars['DateTime']['output']>;
  intro?: Maybe<Scalars['String']['output']>;
  lectureStartTime?: Maybe<Scalars['DateTime']['output']>;
  lectureUploaded?: Maybe<Scalars['Boolean']['output']>;
  partId?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  product: Product;
  productId: Scalars['Int']['output'];
  runningTime?: Maybe<Scalars['Int']['output']>;
  showOnApp?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
  videoLength?: Maybe<Scalars['Int']['output']>;
  watermarkDownload?: Maybe<Scalars['Boolean']['output']>;
};

export type DownloadFileChapterDto = {
  __typename?: 'DownloadFileChapterDto';
  endTime: Scalars['Int']['output'];
  startTime: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type DownloadFileDto = {
  __typename?: 'DownloadFileDto';
  bunnyId?: Maybe<Scalars['String']['output']>;
  chapters: Array<DownloadFileChapterDto>;
  downloadLink?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  lastAccessPoint?: Maybe<Scalars['Int']['output']>;
  lectureStartTime?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  playbackSources?: Maybe<VideoPlaybackSourcesDto>;
  streamingLink?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  vtt?: Maybe<Scalars['String']['output']>;
};

export type VideoPlaybackSourcesDto = {
  __typename?: 'VideoPlaybackSourcesDto';
  originalStreamingLink?: Maybe<Scalars['String']['output']>;
  streamingLink: Scalars['String']['output'];
};

export type DownloadFileDtoFilterInput = {
  and?: InputMaybe<Array<DownloadFileDtoFilterInput>>;
  bunnyId?: InputMaybe<StringOperationFilterInput>;
  downloadLink?: InputMaybe<StringOperationFilterInput>;
  duration?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lastAccessPoint?: InputMaybe<IntOperationFilterInput>;
  lectureStartTime?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DownloadFileDtoFilterInput>>;
  title?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type DownloadFileFilterInput = {
  accessHours?: InputMaybe<IntOperationFilterInput>;
  allowDownload?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<DownloadFileFilterInput>>;
  bunnyId?: InputMaybe<StringOperationFilterInput>;
  downloadChapters?: InputMaybe<ListFilterInputTypeOfDownloadChapterFilterInput>;
  downloadFileLastAccess?: InputMaybe<ListFilterInputTypeOfDownloadFileLastAccessFilterInput>;
  downloadFileOptionLinks?: InputMaybe<ListFilterInputTypeOfDownloadFileOptionLinkFilterInput>;
  downloadFileType?: InputMaybe<DownloadFileTypeFilterInput>;
  downloadVersionPath?: InputMaybe<StringOperationFilterInput>;
  filePath?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  indexedDate?: InputMaybe<DateTimeOperationFilterInput>;
  intro?: InputMaybe<StringOperationFilterInput>;
  lectureStartTime?: InputMaybe<DateTimeOperationFilterInput>;
  lectureUploaded?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DownloadFileFilterInput>>;
  partId?: InputMaybe<IntOperationFilterInput>;
  position?: InputMaybe<IntOperationFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  runningTime?: InputMaybe<IntOperationFilterInput>;
  showOnApp?: InputMaybe<BooleanOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  typeId?: InputMaybe<IntOperationFilterInput>;
  videoLength?: InputMaybe<IntOperationFilterInput>;
  watermarkDownload?: InputMaybe<BooleanOperationFilterInput>;
};

export type DownloadFileLastAccess = {
  __typename?: 'DownloadFileLastAccess';
  customer: Customer;
  customerId: Scalars['Int']['output'];
  downloadFile: DownloadFile;
  downloadFileId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastAccessPoint: Scalars['Int']['output'];
  lastAccessTime: Scalars['DateTime']['output'];
};

export type DownloadFileLastAccessFilterInput = {
  and?: InputMaybe<Array<DownloadFileLastAccessFilterInput>>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  downloadFile?: InputMaybe<DownloadFileFilterInput>;
  downloadFileId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lastAccessPoint?: InputMaybe<IntOperationFilterInput>;
  lastAccessTime?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<DownloadFileLastAccessFilterInput>>;
};

export type DownloadFileOptionLink = {
  __typename?: 'DownloadFileOptionLink';
  downloadFile?: Maybe<DownloadFile>;
  downloadFileId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  productOptionId?: Maybe<Scalars['Int']['output']>;
};

export type DownloadFileOptionLinkFilterInput = {
  and?: InputMaybe<Array<DownloadFileOptionLinkFilterInput>>;
  downloadFile?: InputMaybe<DownloadFileFilterInput>;
  downloadFileId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<DownloadFileOptionLinkFilterInput>>;
  productOptionId?: InputMaybe<IntOperationFilterInput>;
};

export type DownloadFileType = {
  __typename?: 'DownloadFileType';
  description?: Maybe<Scalars['String']['output']>;
  downloadFiles?: Maybe<Array<DownloadFile>>;
  id: Scalars['Int']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type DownloadFileTypeFilterInput = {
  and?: InputMaybe<Array<DownloadFileTypeFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  downloadFiles?: InputMaybe<ListFilterInputTypeOfDownloadFileFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DownloadFileTypeFilterInput>>;
};

export type EbookBundleOptionDto = {
  __typename?: 'EbookBundleOptionDto';
  currency?: Maybe<CurrencyDto>;
  downloadOptionId: Scalars['Int']['output'];
  physicalOptionId: Scalars['Int']['output'];
  price: Scalars['Decimal']['output'];
};

export type EbookBundleOptionDtoSortInput = {
  currency?: InputMaybe<CurrencyDtoSortInput>;
  downloadOptionId?: InputMaybe<SortEnumType>;
  physicalOptionId?: InputMaybe<SortEnumType>;
  price?: InputMaybe<SortEnumType>;
};

export type EcommChildProductCommercialDto = {
  __typename?: 'EcommChildProductCommercialDto';
  displayPrice?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  isPreorder?: Maybe<Scalars['Boolean']['output']>;
  options: Array<ProductOptionDto>;
};

export type EcommChildProductContentDto = {
  __typename?: 'EcommChildProductContentDto';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  urlStub?: Maybe<Scalars['String']['output']>;
};

export type EcommProductAccessDto = {
  __typename?: 'EcommProductAccessDto';
  hasMetaPassword: Scalars['Boolean']['output'];
  isLive: Scalars['Boolean']['output'];
  productId: Scalars['Int']['output'];
  requiresPassword: Scalars['Boolean']['output'];
  supportsProductIdFallback: Scalars['Boolean']['output'];
};

export type EcommProductContentDto = {
  __typename?: 'EcommProductContentDto';
  blurb?: Maybe<Scalars['String']['output']>;
  creators: Array<CreatorDto>;
  description?: Maybe<Scalars['String']['output']>;
  hasDownloads: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  meta: Array<ProductMetaDto>;
  name?: Maybe<Scalars['String']['output']>;
  productImages: Array<ProductImageDto>;
  productType?: Maybe<ProductTypeDto>;
  thumbnails?: Maybe<ProductThumbnailsDto>;
  url?: Maybe<Scalars['String']['output']>;
  vanishingIncExclusive: Scalars['Boolean']['output'];
};

export type EcommProductDto = {
  __typename?: 'EcommProductDto';
  biggestDiscountPercentage?: Maybe<Scalars['Decimal']['output']>;
  blurb?: Maybe<Scalars['String']['output']>;
  categories: Array<CategoryDto>;
  childProductCommercials: Array<EcommChildProductCommercialDto>;
  childProductContents: Array<EcommChildProductContentDto>;
  creators: Array<CreatorDto>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  dateAdded: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discontinued?: Maybe<Scalars['Boolean']['output']>;
  discountedDisplayPrice?: Maybe<Scalars['Decimal']['output']>;
  displayPrice?: Maybe<Scalars['Decimal']['output']>;
  downloadFiles: Array<DownloadFileDto>;
  ebookBundleOption?: Maybe<EbookBundleOptionDto>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  hasDownloads: Scalars['Boolean']['output'];
  hidePrice: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  inStock: Scalars['Boolean']['output'];
  isParent: Scalars['Boolean']['output'];
  isPreorder?: Maybe<Scalars['Boolean']['output']>;
  lectureDates?: Maybe<Scalars['String']['output']>;
  manufacturerId?: Maybe<Scalars['Int']['output']>;
  meta: Array<ProductMetaDto>;
  murphysProductId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  needsShipping: Scalars['Boolean']['output'];
  options: Array<ProductOptionDto>;
  parentId?: Maybe<Scalars['Int']['output']>;
  positionInList?: Maybe<Scalars['Int']['output']>;
  preorderRelease?: Maybe<Scalars['DateTime']['output']>;
  productImages: Array<ProductImageDto>;
  productTrailers: Array<ProductTrailerDto>;
  productType?: Maybe<ProductTypeDto>;
  questions?: Maybe<QuestionsCollectionSegment>;
  rating?: Maybe<Scalars['Float']['output']>;
  restockDateDisplay?: Maybe<Scalars['String']['output']>;
  reviews: Array<CustomerReviewDto>;
  stockMessage?: Maybe<Scalars['String']['output']>;
  thumbnails?: Maybe<ProductThumbnailsDto>;
  url?: Maybe<Scalars['String']['output']>;
  vanishingIncExclusive: Scalars['Boolean']['output'];
};


export type EcommProductDtoQuestionsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type EcommProductDtoFilterInput = {
  and?: InputMaybe<Array<EcommProductDtoFilterInput>>;
  dateAdded?: InputMaybe<DateTimeOperationFilterInput>;
  featured?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  manufacturerId?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  options?: InputMaybe<ListFilterInputTypeOfProductOptionDtoFilterInput>;
  or?: InputMaybe<Array<EcommProductDtoFilterInput>>;
  parentId?: InputMaybe<IntOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
  vanishingIncExclusive?: InputMaybe<BooleanOperationFilterInput>;
};

/** A segment of a collection. */
export type EcommProductsCollectionSegment = {
  __typename?: 'EcommProductsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EcommProductDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EmailUpdateResult = {
  __typename?: 'EmailUpdateResult';
  correctedEmail?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  suggestion?: Maybe<Scalars['String']['output']>;
  validationWarnings: Array<Scalars['String']['output']>;
};

export enum EmailValidationErrorEnum {
  ApiValidationFailed = 'API_VALIDATION_FAILED',
  CommonTypo = 'COMMON_TYPO',
  Empty = 'EMPTY',
  InvalidDomain = 'INVALID_DOMAIN',
  InvalidFormat = 'INVALID_FORMAT',
  NetworkError = 'NETWORK_ERROR',
  None = 'NONE',
  TooLong = 'TOO_LONG'
}

export type EmailValidationResultDto = {
  __typename?: 'EmailValidationResultDto';
  correctedEmail?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType: EmailValidationErrorEnum;
  isValid: Scalars['Boolean']['output'];
  originalEmail: Scalars['String']['output'];
  suggestion?: Maybe<Scalars['String']['output']>;
};

export type ExplanationDownloadFileDto = {
  __typename?: 'ExplanationDownloadFileDto';
  bunnyId?: Maybe<Scalars['String']['output']>;
  filePath?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  vtt?: Maybe<Scalars['String']['output']>;
};

export type ExplanationDto = {
  __typename?: 'ExplanationDto';
  androidInstallLink?: Maybe<Scalars['String']['output']>;
  hasPassword: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  iosInstallLink?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  promptText?: Maybe<Scalars['String']['output']>;
  requiresLogin: Scalars['Boolean']['output'];
  requiresUniqueCode: Scalars['Boolean']['output'];
  thumbnailSrc?: Maybe<Scalars['String']['output']>;
};

export type ExplanationPageDto = {
  __typename?: 'ExplanationPageDto';
  downloadFiles: Array<ExplanationDownloadFileDto>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  meta: Array<ProductMetaDto>;
  name?: Maybe<Scalars['String']['output']>;
  productId: Scalars['Int']['output'];
  urlSlug?: Maybe<Scalars['String']['output']>;
};

export type FinanceLogDto = {
  __typename?: 'FinanceLogDto';
  amountOwed: Scalars['Decimal']['output'];
  amountPaid: Scalars['Decimal']['output'];
  footerText?: Maybe<Scalars['String']['output']>;
  isGrossPayment: Scalars['Boolean']['output'];
  items?: Maybe<Array<Maybe<FinanceLogItemDto>>>;
  optionDescription?: Maybe<Scalars['String']['output']>;
  optionId?: Maybe<Scalars['Int']['output']>;
  percentageToCreator: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  profit: Scalars['Decimal']['output'];
};

export type FinanceLogItemDto = {
  __typename?: 'FinanceLogItemDto';
  amount: Scalars['Decimal']['output'];
  category?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  isInternal: Scalars['Boolean']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type FlattenedProductDto = {
  __typename?: 'FlattenedProductDto';
  displayName: Scalars['String']['output'];
  optionDescription?: Maybe<Scalars['String']['output']>;
  optionId?: Maybe<Scalars['Int']['output']>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productUrlStub?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

export type GalleryDto = {
  __typename?: 'GalleryDto';
  id: Scalars['Int']['output'];
  intro?: Maybe<Scalars['String']['output']>;
  leadPhotoUrl?: Maybe<Scalars['String']['output']>;
  photographer?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  urlstub?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type GalleryDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  intro?: InputMaybe<SortEnumType>;
  leadPhotoUrl?: InputMaybe<SortEnumType>;
  photographer?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
  urlstub?: InputMaybe<SortEnumType>;
  year?: InputMaybe<SortEnumType>;
};

export type GalleryPhotoDto = {
  __typename?: 'GalleryPhotoDto';
  description?: Maybe<Scalars['String']['output']>;
  filePath: Scalars['String']['output'];
  galleryId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type GalleryPhotoDtoSortInput = {
  description?: InputMaybe<SortEnumType>;
  filePath?: InputMaybe<SortEnumType>;
  galleryId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  imageUrl?: InputMaybe<SortEnumType>;
  sortOrder?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
};

export type GeneralReturnType = {
  __typename?: 'GeneralReturnType';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GenerateCreatorPaymentsResultDto = {
  __typename?: 'GenerateCreatorPaymentsResultDto';
  logsCreated: Scalars['Int']['output'];
  orderItemLinksReconciledPayments: Scalars['Int']['output'];
  payments: Array<GeneratedCreatorPaymentDto>;
  paymentsCreated: Scalars['Int']['output'];
  totalAmount: Scalars['Decimal']['output'];
};

export type GeneratedCreatorPaymentDto = {
  __typename?: 'GeneratedCreatorPaymentDto';
  amount: Scalars['Decimal']['output'];
  creatorId: Scalars['Int']['output'];
  creatorName: Scalars['String']['output'];
  creatorPaymentId: Scalars['Int']['output'];
  method: Scalars['Int']['output'];
  methodDescription: Scalars['String']['output'];
  orderItemLinksReconciled: Scalars['Boolean']['output'];
};

export type GiftCertificateOptionDto = {
  __typename?: 'GiftCertificateOptionDto';
  currencySymbol: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Decimal']['output'];
};

export type GrantFreeDownloadResultDto = {
  __typename?: 'GrantFreeDownloadResultDto';
  alreadyHadAccess: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type HomepageCarouselItemInput = {
  altText: Scalars['String']['input'];
  brandId?: InputMaybe<Scalars['Int']['input']>;
  endAtUtc?: InputMaybe<Scalars['DateTime']['input']>;
  expectedUpdatedAtUtc?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imageSrc?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  productId?: InputMaybe<Scalars['Int']['input']>;
  published: Scalars['Boolean']['input'];
  startAtUtc?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type HomepageCarouselItemMutationResultDto = {
  __typename?: 'HomepageCarouselItemMutationResultDto';
  cacheRefreshMessage?: Maybe<Scalars['String']['output']>;
  cacheRefreshSucceeded: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  updatedAtUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type ImportDutiesQuoteDto = {
  __typename?: 'ImportDutiesQuoteDto';
  description?: Maybe<Scalars['String']['output']>;
  duties: Scalars['Decimal']['output'];
  fees: Scalars['Decimal']['output'];
  formula?: Maybe<Scalars['String']['output']>;
  isPrepayAvailable: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  itemTaxes: Array<ImportDutiesQuoteItemTaxDto>;
  optionalPrepayTotal: Scalars['Decimal']['output'];
  requiredDuties: Scalars['Decimal']['output'];
  requiredFees: Scalars['Decimal']['output'];
  requiredTaxes: Scalars['Decimal']['output'];
  requiredTotal: Scalars['Decimal']['output'];
  shipFromCountryIsoCode?: Maybe<Scalars['String']['output']>;
  shipToCountryName?: Maybe<Scalars['String']['output']>;
  taxes: Scalars['Decimal']['output'];
  total: Scalars['Decimal']['output'];
  type: Scalars['Int']['output'];
};

export type ImportDutiesQuoteItemTaxDto = {
  __typename?: 'ImportDutiesQuoteItemTaxDto';
  amount: Scalars['Decimal']['output'];
  itemId: Scalars['Int']['output'];
  taxRate?: Maybe<Scalars['Decimal']['output']>;
};

export type InTransitPackageDto = {
  __typename?: 'InTransitPackageDto';
  orderDate: Scalars['DateTime']['output'];
  orderId: Scalars['Int']['output'];
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type InventoryLocation = {
  __typename?: 'InventoryLocation';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  brands: Array<Brand>;
  city?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country: Country;
  countryId: Scalars['Int']['output'];
  county?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentLocationId?: Maybe<Scalars['Int']['output']>;
  state: State;
  stateId?: Maybe<Scalars['Int']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type InventoryLocationFilterInput = {
  address1?: InputMaybe<StringOperationFilterInput>;
  address2?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<InventoryLocationFilterInput>>;
  brands?: InputMaybe<ListFilterInputTypeOfBrandFilterInput>;
  city?: InputMaybe<StringOperationFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  contactEmail?: InputMaybe<StringOperationFilterInput>;
  contactPhone?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<CountryFilterInput>;
  countryId?: InputMaybe<IntOperationFilterInput>;
  county?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<InventoryLocationFilterInput>>;
  parentLocationId?: InputMaybe<IntOperationFilterInput>;
  state?: InputMaybe<StateFilterInput>;
  stateId?: InputMaybe<IntOperationFilterInput>;
  zipCode?: InputMaybe<StringOperationFilterInput>;
};

export type InventoryStat = {
  __typename?: 'InventoryStat';
  count?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  locationId: Scalars['Int']['output'];
  oldUnpicked?: Maybe<Scalars['Int']['output']>;
  optionId?: Maybe<Scalars['Int']['output']>;
  ordered?: Maybe<Scalars['Int']['output']>;
  productId: Scalars['Int']['output'];
  resetTime?: Maybe<Scalars['DateTime']['output']>;
  shelfId: Scalars['Int']['output'];
  shoppingCartItems: Array<ShoppingCartItem>;
  sold?: Maybe<Scalars['Int']['output']>;
  storageOnly: Scalars['Boolean']['output'];
  unpicked?: Maybe<Scalars['Int']['output']>;
};

export type InventoryStatFilterInput = {
  and?: InputMaybe<Array<InventoryStatFilterInput>>;
  count?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  locationId?: InputMaybe<IntOperationFilterInput>;
  oldUnpicked?: InputMaybe<IntOperationFilterInput>;
  optionId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<InventoryStatFilterInput>>;
  ordered?: InputMaybe<IntOperationFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  resetTime?: InputMaybe<DateTimeOperationFilterInput>;
  shelfId?: InputMaybe<IntOperationFilterInput>;
  shoppingCartItems?: InputMaybe<ListFilterInputTypeOfShoppingCartItemFilterInput>;
  sold?: InputMaybe<IntOperationFilterInput>;
  storageOnly?: InputMaybe<BooleanOperationFilterInput>;
  unpicked?: InputMaybe<IntOperationFilterInput>;
};

export type KeyValueInputDtoInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type KeyValuePairOfInt32AndInt32 = {
  __typename?: 'KeyValuePairOfInt32AndInt32';
  key: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type LatestExclusiveProductCardsCollectionSegment = {
  __typename?: 'LatestExclusiveProductCardsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ProductListCardDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ListFilterInputTypeOfBrandFilterInput = {
  all?: InputMaybe<BrandFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BrandFilterInput>;
  some?: InputMaybe<BrandFilterInput>;
};

export type ListFilterInputTypeOfCategoryFilterInput = {
  all?: InputMaybe<CategoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CategoryFilterInput>;
  some?: InputMaybe<CategoryFilterInput>;
};

export type ListFilterInputTypeOfCountryFilterInput = {
  all?: InputMaybe<CountryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CountryFilterInput>;
  some?: InputMaybe<CountryFilterInput>;
};

export type ListFilterInputTypeOfCreatorDtoFilterInput = {
  all?: InputMaybe<CreatorDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CreatorDtoFilterInput>;
  some?: InputMaybe<CreatorDtoFilterInput>;
};

export type ListFilterInputTypeOfCreatorFilterInput = {
  all?: InputMaybe<CreatorFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CreatorFilterInput>;
  some?: InputMaybe<CreatorFilterInput>;
};

export type ListFilterInputTypeOfCustomerAddressFilterInput = {
  all?: InputMaybe<CustomerAddressFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerAddressFilterInput>;
  some?: InputMaybe<CustomerAddressFilterInput>;
};

export type ListFilterInputTypeOfCustomerBrandLinkFilterInput = {
  all?: InputMaybe<CustomerBrandLinkFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerBrandLinkFilterInput>;
  some?: InputMaybe<CustomerBrandLinkFilterInput>;
};

export type ListFilterInputTypeOfCustomerBrandLinkMetumFilterInput = {
  all?: InputMaybe<CustomerBrandLinkMetumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerBrandLinkMetumFilterInput>;
  some?: InputMaybe<CustomerBrandLinkMetumFilterInput>;
};

export type ListFilterInputTypeOfCustomerReviewFilterInput = {
  all?: InputMaybe<CustomerReviewFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerReviewFilterInput>;
  some?: InputMaybe<CustomerReviewFilterInput>;
};

export type ListFilterInputTypeOfDownloadChapterFilterInput = {
  all?: InputMaybe<DownloadChapterFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DownloadChapterFilterInput>;
  some?: InputMaybe<DownloadChapterFilterInput>;
};

export type ListFilterInputTypeOfDownloadFileDtoFilterInput = {
  all?: InputMaybe<DownloadFileDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DownloadFileDtoFilterInput>;
  some?: InputMaybe<DownloadFileDtoFilterInput>;
};

export type ListFilterInputTypeOfDownloadFileFilterInput = {
  all?: InputMaybe<DownloadFileFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DownloadFileFilterInput>;
  some?: InputMaybe<DownloadFileFilterInput>;
};

export type ListFilterInputTypeOfDownloadFileLastAccessFilterInput = {
  all?: InputMaybe<DownloadFileLastAccessFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DownloadFileLastAccessFilterInput>;
  some?: InputMaybe<DownloadFileLastAccessFilterInput>;
};

export type ListFilterInputTypeOfDownloadFileOptionLinkFilterInput = {
  all?: InputMaybe<DownloadFileOptionLinkFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DownloadFileOptionLinkFilterInput>;
  some?: InputMaybe<DownloadFileOptionLinkFilterInput>;
};

export type ListFilterInputTypeOfInventoryLocationFilterInput = {
  all?: InputMaybe<InventoryLocationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InventoryLocationFilterInput>;
  some?: InputMaybe<InventoryLocationFilterInput>;
};

export type ListFilterInputTypeOfInventoryStatFilterInput = {
  all?: InputMaybe<InventoryStatFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InventoryStatFilterInput>;
  some?: InputMaybe<InventoryStatFilterInput>;
};

export type ListFilterInputTypeOfOrderItemFilterInput = {
  all?: InputMaybe<OrderItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderItemFilterInput>;
  some?: InputMaybe<OrderItemFilterInput>;
};

export type ListFilterInputTypeOfOrderItemReturnItemFilterInput = {
  all?: InputMaybe<OrderItemReturnItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OrderItemReturnItemFilterInput>;
  some?: InputMaybe<OrderItemReturnItemFilterInput>;
};

export type ListFilterInputTypeOfPackageTrackingFilterInput = {
  all?: InputMaybe<PackageTrackingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PackageTrackingFilterInput>;
  some?: InputMaybe<PackageTrackingFilterInput>;
};

export type ListFilterInputTypeOfProductBrandLinkFilterInput = {
  all?: InputMaybe<ProductBrandLinkFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductBrandLinkFilterInput>;
  some?: InputMaybe<ProductBrandLinkFilterInput>;
};

export type ListFilterInputTypeOfProductFilterInput = {
  all?: InputMaybe<ProductFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductFilterInput>;
  some?: InputMaybe<ProductFilterInput>;
};

export type ListFilterInputTypeOfProductImageFilterInput = {
  all?: InputMaybe<ProductImageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductImageFilterInput>;
  some?: InputMaybe<ProductImageFilterInput>;
};

export type ListFilterInputTypeOfProductListItemFilterInput = {
  all?: InputMaybe<ProductListItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductListItemFilterInput>;
  some?: InputMaybe<ProductListItemFilterInput>;
};

export type ListFilterInputTypeOfProductMetaFilterInput = {
  all?: InputMaybe<ProductMetaFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductMetaFilterInput>;
  some?: InputMaybe<ProductMetaFilterInput>;
};

export type ListFilterInputTypeOfProductOptionDtoFilterInput = {
  all?: InputMaybe<ProductOptionDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductOptionDtoFilterInput>;
  some?: InputMaybe<ProductOptionDtoFilterInput>;
};

export type ListFilterInputTypeOfProductOptionFilterInput = {
  all?: InputMaybe<ProductOptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductOptionFilterInput>;
  some?: InputMaybe<ProductOptionFilterInput>;
};

export type ListFilterInputTypeOfProductPriceFilterInput = {
  all?: InputMaybe<ProductPriceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductPriceFilterInput>;
  some?: InputMaybe<ProductPriceFilterInput>;
};

export type ListFilterInputTypeOfProductQuestionFilterInput = {
  all?: InputMaybe<ProductQuestionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductQuestionFilterInput>;
  some?: InputMaybe<ProductQuestionFilterInput>;
};

export type ListFilterInputTypeOfProductTrailerFilterInput = {
  all?: InputMaybe<ProductTrailerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProductTrailerFilterInput>;
  some?: InputMaybe<ProductTrailerFilterInput>;
};

export type ListFilterInputTypeOfShoppingCartFilterInput = {
  all?: InputMaybe<ShoppingCartFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ShoppingCartFilterInput>;
  some?: InputMaybe<ShoppingCartFilterInput>;
};

export type ListFilterInputTypeOfShoppingCartItemFilterInput = {
  all?: InputMaybe<ShoppingCartItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ShoppingCartItemFilterInput>;
  some?: InputMaybe<ShoppingCartItemFilterInput>;
};

export type ListFilterInputTypeOfStateFilterInput = {
  all?: InputMaybe<StateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StateFilterInput>;
  some?: InputMaybe<StateFilterInput>;
};

export type ListFilterInputTypeOfSubscriptionStatusFilterInput = {
  all?: InputMaybe<SubscriptionStatusFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SubscriptionStatusFilterInput>;
  some?: InputMaybe<SubscriptionStatusFilterInput>;
};

export type ListFilterInputTypeOfWishlistItemFilterInput = {
  all?: InputMaybe<WishlistItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<WishlistItemFilterInput>;
  some?: InputMaybe<WishlistItemFilterInput>;
};

export type MagicStoreSignupResultDto = {
  __typename?: 'MagicStoreSignupResultDto';
  emailValidation: EmailValidationResultDto;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ManagedPageDto = {
  __typename?: 'ManagedPageDto';
  displayName: Scalars['String']['output'];
  pageKey: Scalars['String']['output'];
  publicPath: Scalars['String']['output'];
  publishedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  sections: Array<ManagedPageSectionDto>;
};

export type ManagedPageMutationResultDto = {
  __typename?: 'ManagedPageMutationResultDto';
  cacheRefreshMessage?: Maybe<Scalars['String']['output']>;
  cacheRefreshSucceeded?: Maybe<Scalars['Boolean']['output']>;
  message: Scalars['String']['output'];
  publicPath?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  updatedAtUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type ManagedPageSectionDto = {
  __typename?: 'ManagedPageSectionDto';
  contentJson: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  sectionKey: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type ManagedPageSectionInputDtoInput = {
  contentJson: Scalars['String']['input'];
  sectionKey: Scalars['String']['input'];
};

export type Manufacturer = {
  __typename?: 'Manufacturer';
  id: Scalars['Int']['output'];
  manufacturesPlayingCards?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  orderInfo?: Maybe<Scalars['String']['output']>;
  urlStub?: Maybe<Scalars['String']['output']>;
};

export type ManufacturerDtoFilterInput = {
  and?: InputMaybe<Array<ManufacturerDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ManufacturerDtoFilterInput>>;
  urlStub?: InputMaybe<StringOperationFilterInput>;
};

export type ManufacturerDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  urlStub?: InputMaybe<SortEnumType>;
};

export type ManufacturerFilterInput = {
  and?: InputMaybe<Array<ManufacturerFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  manufacturesPlayingCards?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ManufacturerFilterInput>>;
  orderInfo?: InputMaybe<StringOperationFilterInput>;
  urlStub?: InputMaybe<StringOperationFilterInput>;
};

export type MasterclassDownloadQaDto = {
  __typename?: 'MasterclassDownloadQaDto';
  creatorDisplayName?: Maybe<Scalars['String']['output']>;
  productSlug?: Maybe<Scalars['String']['output']>;
  questions: Array<QuestionDto>;
  showQaSection: Scalars['Boolean']['output'];
};

export type MasterclassDto = {
  __typename?: 'MasterclassDto';
  dateAdded: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  rating: Scalars['Float']['output'];
  thumbnailSrc?: Maybe<Scalars['String']['output']>;
  urlStub?: Maybe<Scalars['String']['output']>;
};

export type MasterclassDtoSortInput = {
  dateAdded?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  rating?: InputMaybe<SortEnumType>;
  thumbnailSrc?: InputMaybe<SortEnumType>;
  urlStub?: InputMaybe<SortEnumType>;
};

export type MasterclassLiveBannerDto = {
  __typename?: 'MasterclassLiveBannerDto';
  lectureName?: Maybe<Scalars['String']['output']>;
  showBanner: Scalars['Boolean']['output'];
  streamUrl?: Maybe<Scalars['String']['output']>;
  thumbnails?: Maybe<ProductThumbnailsDto>;
};

export type MasterclassLiveStatusDto = {
  __typename?: 'MasterclassLiveStatusDto';
  url?: Maybe<Scalars['String']['output']>;
};

export type MasterclassStatusDto = {
  __typename?: 'MasterclassStatusDto';
  canStreamMasterclassCatalog: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isCanceled: Scalars['Boolean']['output'];
  isDelinquent: Scalars['Boolean']['output'];
  isFreeSubscription: Scalars['Boolean']['output'];
  isPauseScheduled: Scalars['Boolean']['output'];
  isPaused: Scalars['Boolean']['output'];
  nextBillingDate?: Maybe<Scalars['DateTime']['output']>;
  proratedAmount?: Maybe<Scalars['Decimal']['output']>;
  resumeChargeAmount?: Maybe<Scalars['Decimal']['output']>;
  resumeChargeCurrency?: Maybe<Scalars['String']['output']>;
  resumeChargeLast4?: Maybe<Scalars['String']['output']>;
  trial?: Maybe<MasterclassTrialDto>;
};

/** A segment of a collection. */
export type MasterclassStreamingLibraryCollectionSegment = {
  __typename?: 'MasterclassStreamingLibraryCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<MasterclassDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type MasterclassTrialDto = {
  __typename?: 'MasterclassTrialDto';
  isTrial: Scalars['Boolean']['output'];
  trialEndDate?: Maybe<Scalars['DateTime']['output']>;
  trialStartDate?: Maybe<Scalars['DateTime']['output']>;
};

export type MasterclassTrialDtoFilterInput = {
  and?: InputMaybe<Array<MasterclassTrialDtoFilterInput>>;
  isTrial?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<MasterclassTrialDtoFilterInput>>;
  trialEndDate?: InputMaybe<DateTimeOperationFilterInput>;
  trialStartDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type MasterclassTrialDtoSortInput = {
  isTrial?: InputMaybe<SortEnumType>;
  trialEndDate?: InputMaybe<SortEnumType>;
  trialStartDate?: InputMaybe<SortEnumType>;
};

export type MergeAnonymousShoppingCartResultDto = {
  __typename?: 'MergeAnonymousShoppingCartResultDto';
  isIdempotentReplay: Scalars['Boolean']['output'];
  mergedItemCount: Scalars['Int']['output'];
  shoppingCartToken?: Maybe<Scalars['String']['output']>;
  skippedItemCount: Scalars['Int']['output'];
  skippedReasonCodes: Array<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum MurphysAccount {
  Uk = 'UK',
  Usa = 'USA'
}

export type Mutation = {
  __typename?: 'Mutation';
  addConventionRegistrationBundleToShoppingCart: Scalars['Boolean']['output'];
  addConventionUpgradeToShoppingCart: Scalars['Boolean']['output'];
  addConventionWaitingList: Scalars['Boolean']['output'];
  addCustomerToSegment: Scalars['Boolean']['output'];
  addEbookBundleToShoppingCart: Scalars['Boolean']['output'];
  addGiftCertificateToShoppingCart: Scalars['Boolean']['output'];
  addItemToShoppingCart: Scalars['Boolean']['output'];
  addItemToWishList: Scalars['Int']['output'];
  addRestockAlert: Scalars['Boolean']['output'];
  adminAddConventionRegistrant: AdminConventionMutationResultDto;
  adminAddConventionWaitlistEntry: AdminConventionMutationResultDto;
  adminAddConventionWorkshop: AdminConventionMutationResultDto;
  adminAddCustomerSubscription: AdminCustomerSubscriptionMutationResultDto;
  adminAddDownloadCodes: AdminCreatedDownloadCodesDto;
  adminAddMurphysOpenOrderItem: AdminMurphysOpenOrderMutationResultDto;
  adminAddMurphysSalesOrderLine: AdminMurphysSalesOrderLineResultDto;
  adminAddOrderInternalNote: AdminOrderProcessingResultDto;
  adminAddOrderItem: AdminAddOrderItemResultDto;
  adminAddOrderItemToTargetQuantity: AdminAddOrderItemResultDto;
  adminAddProductInventoryStock: AdminProductInventoryDetailDto;
  adminAdjustCustomerPoints: AdminAdjustCustomerPointsResultDto;
  adminAdjustProductInventoryStock: AdminProductInventoryDetailDto;
  adminApplyOrderCancellation: AdminOrderCancellationResultDto;
  adminApplyProductImageVariant: AdminProductAuthoringDto;
  adminApplyProductThumbnail: AdminProductAuthoringDto;
  adminApplySaleCsv: AdminSaleApplyResultDto;
  adminApplyTaxJarCorrections: TaxJarCorrectionResultDto;
  adminApproveStockCountDiscrepancy: AdminStockCountDiscrepancyDto;
  adminApproveStockCountDiscrepancyWithCount: AdminStockCountDiscrepancyDto;
  adminArchiveHomepageCarouselItem: HomepageCarouselItemMutationResultDto;
  adminArchiveOrderAttachment: AdminOrderAttachmentDto;
  adminAssetUploadUrl: AdminAssetUploadTargetDto;
  adminAssignOrderLicenseCodes?: Maybe<AdminOrderDto>;
  adminAttachProductImage: AdminProductAuthoringDto;
  adminAttachProductTrailer: AdminProductAuthoringDto;
  adminBlogAssetUploadUrl: AdminAssetUploadTargetDto;
  adminBuildSaleRollbackCsv: AdminSaleRollbackDto;
  adminChangeOrderShippingMethod: AdminOrderProcessingResultDto;
  adminChangeOrderStatus: AdminOrderProcessingResultDto;
  adminChargeConventionNextPayment: AdminConventionMutationResultDto;
  adminCheckPendingOrderTaxReconciliations: OrderTaxReconciliationCheckResultDto;
  adminClaimPickingOrder: AdminPickingMutationResultDto;
  adminClearPartiallyPickedBoxAssignment: AdminPartiallyPickedBoxMutationResultDto;
  adminClearTypesenseSearchCache: Scalars['Boolean']['output'];
  adminClosePurchaseOrderShort: AdminPurchaseOrderResultDto;
  adminConfirmProductContractUpload: AdminProductContractDto;
  adminConfirmProductDownloadSubtitleUpload: AdminProductAuthoringDto;
  adminConfirmShipmentDispatch: AdminShipmentDispatchResultDto;
  adminCorrectPurchaseOrderReceipt: AdminPurchaseOrderResultDto;
  adminCreateAsanaEscalationTest: AdminEscalationResult;
  adminCreateBlogPreview: AdminBlogPreviewDto;
  adminCreateConventionGallery: AdminConventionMutationResultDto;
  adminCreateDownloadCodes: AdminCreatedDownloadCodesDto;
  adminCreateInventoryShelf: AdminWarehouseShelvesDto;
  adminCreatePackageResend: AdminPackageResendResultDto;
  adminCreatePartiallyPickedBox: AdminPartiallyPickedBoxMutationResultDto;
  adminCreateProduct: AdminProductAuthoringDto;
  adminCreateProductComponent: AdminComponentProductDto;
  adminCreateProductCreator: AdminProductAuthoringLookupDto;
  adminCreateProductDownloadFile: AdminProductAuthoringDto;
  adminCreateProductFinanceEntry: AdminProductFinanceEntryDto;
  adminCreateProductManufacturer: AdminProductAuthoringLookupDto;
  adminCreateProductMeta: AdminProductAuthoringDto;
  adminCreateScanForm: AdminCreateScanFormResultDto;
  adminCreateShortUrl: AdminUrlMappingResult;
  adminCreateStoreOrder: AdminCreateStoreOrderResultDto;
  adminDeactivateInventoryShelf: AdminWarehouseShelvesDto;
  adminDeleteProductFinanceEntry: AdminDeleteProductFinanceEntryResultDto;
  adminDeleteProductMeta: AdminProductAuthoringDto;
  adminDeletePurchaseOrder: AdminPurchaseOrderResultDto;
  adminDeleteUnusedInventoryShelf: AdminWarehouseShelvesDto;
  adminEnableProductCreatorFinanceLog: AdminProductFinanceDto;
  adminExplainStockCountDiscrepancy: AdminStockCountDiscrepancyDto;
  adminGrantCustomerDownload: AdminGrantCustomerDownloadResultDto;
  adminImportMurphysProductMedia: AdminMurphysProductMediaImportResultDto;
  adminImportProductDownloadUpload: AdminProductDownloadUploadTargetDto;
  adminImportProductTrailer: AdminProductAuthoringDto;
  adminImportRemoteImage: AdminRemoteImageDto;
  adminInsertMasterclassMeta: AdminMasterclassMetaMutationResultDto;
  adminLinkStripeSubscriptionToCustomer: AdminCustomerSubscriptionMutationResultDto;
  adminMergeCustomers: AdminCustomerMergeResultDto;
  adminModerateBlogComment: AdminBlogCommentMutationResultDto;
  adminMoveOrderToBackorder: AdminPickingMutationResultDto;
  adminMoveProductInventoryShelfStock: AdminProductInventoryDetailDto;
  adminPackagePrintDocuments: AdminShipmentPrintDocumentsResultDto;
  adminPackagePrintInvoice: AdminShipmentPrintDocumentsResultDto;
  adminPatchTypesenseProductLive?: Maybe<AdminTypesenseProductHitDto>;
  adminPatchTypesenseProductPrices?: Maybe<AdminTypesenseProductHitDto>;
  adminPlacePurchaseOrders: AdminPurchaseOrderPlacementResultDto;
  adminPrepareProductContractUpload: AdminProductContractUploadTargetDto;
  adminPrepareProductDownloadSubtitleUpload: AdminProductDownloadUploadTargetDto;
  adminPrepareProductDownloadUpload: AdminProductDownloadUploadTargetDto;
  adminPreviewSaleCsv: AdminSalePreviewDto;
  adminPreviewTaxJarCorrections: TaxJarCorrectionResultDto;
  adminProcessOrder: AdminOrderProcessingResultDto;
  adminProcessOrderRefund: AdminOrderRefundResultDto;
  adminProcessTaxFailureRefund: AdminTaxFailureRefundResultDto;
  adminPublishManagedPage: ManagedPageMutationResultDto;
  adminPublishProduct: AdminProductAuthoringDto;
  adminPurchaseShipmentLabel: AdminShipmentPurchaseResultDto;
  adminPurchaseUkTransfer: AdminUkTransferPurchaseDto;
  adminQuoteShipment: AdminShipmentQuoteResultDto;
  adminQuoteUkTransfer: AdminUkTransferQuoteDto;
  adminReactivateInventoryShelf: AdminWarehouseShelvesDto;
  adminRecalculateTypesenseProductPrices: Scalars['Boolean']['output'];
  adminReceivePurchaseOrder: AdminPurchaseOrderResultDto;
  adminRecoverMasterclassRenewals: AdminMasterclassRenewalRecoveryBatchDto;
  adminRefreshProductDownloadStreaming: AdminProductAuthoringDto;
  adminRefreshProductStorefrontAndSearch: AdminProductStorefrontAndSearchRefreshDto;
  adminRefreshProductTrailerStatus: AdminProductAuthoringDto;
  adminReleasePickingOrder: AdminPickingMutationResultDto;
  adminRemoveMurphysOpenOrderItem: AdminMurphysOpenOrderMutationResultDto;
  adminRemoveProductDownloadFile: AdminProductAuthoringDto;
  adminRemoveProductImage: AdminProductAuthoringDto;
  adminRemoveProductTrailer: AdminProductAuthoringDto;
  adminRenameInventoryShelf: AdminWarehouseShelvesDto;
  adminRenderBlogPreview: AdminBlogRenderedPreviewDto;
  adminReorderHomepageCarouselItems: HomepageCarouselItemMutationResultDto;
  adminReorderProductDownloadFiles: AdminProductAuthoringDto;
  adminReorderProductImages: AdminProductAuthoringDto;
  adminReorderProductOptions: AdminProductAuthoringDto;
  adminReorderProductTrailers: AdminProductAuthoringDto;
  adminReplaceProductDownloadChapters: AdminProductAuthoringDto;
  adminReplaceProductDownloadFile: AdminProductAuthoringDto;
  adminReportStockCountProblem: AdminStockCountDiscrepancyDto;
  adminRequestPickingStockCount: AdminPickingMutationResultDto;
  adminRequestProductInventoryCount: AdminProductInventoryDetailDto;
  adminRequestStockCount: AdminStockCountWorkItemDto;
  adminResendConventionConfirmation: AdminConventionMutationResultDto;
  adminResendOrderConfirmation: AdminOrderProcessingResultDto;
  adminResetProductInventoryCount: AdminProductInventoryDetailDto;
  adminResolveReturnItem: AdminReturnMutationResultDto;
  adminResolveStockCountDiscrepancyNoChange: AdminStockCountDiscrepancyDto;
  adminRestoreHomepageCarouselItem: HomepageCarouselItemMutationResultDto;
  adminRestoreSalePrices: AdminSaleRestoreResultDto;
  adminRetryProductTrailerImport: AdminProductAuthoringDto;
  adminReturnStockCountDiscrepancyToQueue: AdminStockCountDiscrepancyDto;
  adminReviewReturn: AdminReturnMutationResultDto;
  adminSaveBlogCategory: AdminBlogCategoryMutationResultDto;
  adminSaveBlogPost: AdminBlogPostMutationResultDto;
  adminSaveConventionRegistrationMeta: AdminConventionMutationResultDto;
  adminSaveManagedPageDraft: ManagedPageMutationResultDto;
  adminSavePickingException: AdminPickingMutationResultDto;
  adminSaveProductDetails: AdminProductAuthoringDto;
  adminSavePurchaseOrder: AdminPurchaseOrderResultDto;
  adminSendDelayedOrderEmails: AdminDelayedOrderEmailSendResultDto;
  adminSendStockCountDiscrepancyForRecount: AdminStockCountDiscrepancyDto;
  adminSetConventionGalleryLeadPhoto: AdminConventionMutationResultDto;
  adminSetInventoryShelfStorageOnly: AdminWarehouseShelvesDto;
  adminSetOrderAttachmentCustomerVisibility: AdminOrderAttachmentDto;
  adminSetOrderDispatchPriority: AdminOrderProcessingResultDto;
  adminSetPickingItemPicked: AdminPickingMutationResultDto;
  adminSetProductInventoryPrimaryShelf: AdminProductInventoryDetailDto;
  adminSetReturnHold: AdminReturnMutationResultDto;
  adminSetSupportSurveyFollowUpCompleted: Scalars['Boolean']['output'];
  adminSetSupportSurveyNotAboutResponder: Scalars['Boolean']['output'];
  adminSkipStockCountTask: AdminStockCountSubmitResultDto;
  adminSplitPickingItem: AdminPickingMutationResultDto;
  adminStartNextStockCountTask?: Maybe<AdminStockCountWorkItemDto>;
  adminStartProductDownloadStreaming: AdminProductAuthoringDto;
  adminSubmitProductInAppPurchase: ProductInAppPurchaseSubmissionResultDto;
  adminSubmitShelfAudit: AdminShelfAuditResultDto;
  adminSubmitStockCount: AdminStockCountSubmitResultDto;
  adminSubmitStockCountRecount: AdminStockCountDiscrepancyDto;
  adminSwitchConventionRegistration: AdminConventionMutationResultDto;
  adminSyncConventionGalleryPhotos: AdminConventionMutationResultDto;
  adminTransferProductInventoryStock: AdminProductInventoryDetailDto;
  adminUnpublishProduct: AdminProductAuthoringDto;
  adminUpdateComponentProduct: AdminComponentProductDto;
  adminUpdateConventionRegistration: AdminConventionMutationResultDto;
  adminUpdateOrderShippingAddress: AdminOrderProcessingResultDto;
  adminUpdatePickingShelf: AdminPickingMutationResultDto;
  adminUpdateProductAssociations: AdminProductAuthoringDto;
  adminUpdateProductDownloadFile: AdminProductAuthoringDto;
  adminUpdateProductFinanceEntry: AdminProductFinanceEntryDto;
  adminUpdateProductFulfilment: AdminProductAuthoringDto;
  adminUpdateProductIdentity: AdminProductAuthoringDto;
  adminUpdateProductMeta: AdminProductAuthoringDto;
  adminUpdateProductMetadata: AdminProductAuthoringDto;
  adminUpdateProductPricing: AdminProductAuthoringDto;
  adminUpdateProductPublication: AdminProductAuthoringDto;
  adminUploadOrderAttachment: AdminOrderAttachmentDto;
  adminUpsertHomepageCarouselItem: HomepageCarouselItemMutationResultDto;
  adminUpsertProductOption: AdminProductAuthoringDto;
  assignCartToCustomer: Scalars['Boolean']['output'];
  cancelSubscription: Scalars['Boolean']['output'];
  captureShoppingCartPayPalOrderAndCompleteCart: Scalars['Int']['output'];
  completeManualPayment: Scalars['Boolean']['output'];
  completeShoppingCartAsAdminWithoutOnlinePayment: Scalars['Int']['output'];
  completeShoppingCartWithStripePayment: Scalars['Int']['output'];
  completeShoppingCartWithoutPayment: Scalars['Int']['output'];
  confirmAdminAssetUpload: AdminAssetUploadResultDto;
  confirmAdminBlogAssetUpload: AdminAssetUploadResultDto;
  confirmReturnImageUpload: Scalars['Boolean']['output'];
  convertPointsToStoreCredit: ConvertPointsToStoreCreditResultDto;
  convertVoucherToStoreCredit: ConvertVoucherToStoreCreditResultDto;
  createAnonymousShoppingCart: Scalars['String']['output'];
  createBlogComment: Scalars['Boolean']['output'];
  createCustomer: CreateCustomerResultDto;
  createCustomerAddress: CreateCustomerAddressResult;
  createCustomerBrandLink: Scalars['Boolean']['output'];
  createCustomerReview: Scalars['Boolean']['output'];
  createCustomerShoppingCart: Scalars['String']['output'];
  createInAppPurchaseOrder: CreateInAppPurchaseOrderResultDto;
  createInstructionLink: Scalars['Boolean']['output'];
  createManualPaymentIntent: ShoppingCartPaymentIntentDto;
  createPaymentMethodSetupToken: Scalars['String']['output'];
  createProductQuestion: QuestionDto;
  createReturn: Scalars['Boolean']['output'];
  createShoppingCartPayPalOrder: PaypalOrderDto;
  createShoppingCartPaymentIntent: ShoppingCartPaymentIntentDto;
  deactivateAppDevice: GeneralReturnType;
  deleteCustomerAddress: GeneralReturnType;
  deleteCustomerPaymentMethod: Scalars['Boolean']['output'];
  deleteCustomerReview: Scalars['Boolean']['output'];
  deleteInstructionLink: Scalars['Boolean']['output'];
  deleteMyAccount: AccountDeletionResultDto;
  generateCreatorPayments: GenerateCreatorPaymentsResultDto;
  grantExplanationAccess: GrantFreeDownloadResultDto;
  grantFreeDownload: GrantFreeDownloadResultDto;
  linkCreatorAccount: Scalars['Boolean']['output'];
  mergeAnonymousShoppingCart: MergeAnonymousShoppingCartResultDto;
  pauseSubscription: Scalars['Boolean']['output'];
  presignedUrlForReturnImage: Scalars['String']['output'];
  processCreatorPayments: ProcessCreatorPaymentsResultDto;
  reactivateSubscription: Scalars['Boolean']['output'];
  reconcileCustomerShoppingCart: MergeAnonymousShoppingCartResultDto;
  recordProductLiveChatMessage: ProductLiveChatMessageDto;
  recoverCapturedPayPalCheckout: PayPalCheckoutRecoveryStatusDto;
  recoverPaidCheckout: CheckoutPaymentRecoveryStatusDto;
  redeemDownloadCard: RedeemDownloadCardResultDto;
  refreshCustomerSubscription: RefreshSubscriptionResultDto;
  refreshShoppingCartPrices: Scalars['Boolean']['output'];
  registerMagicStoreSignup: MagicStoreSignupResultDto;
  removeCustomerFromSegment: Scalars['Boolean']['output'];
  removeItemFromCart: GeneralReturnType;
  removeItemFromWishList: Scalars['Boolean']['output'];
  requestPasswordReset: Scalars['Boolean']['output'];
  resetPassword: Scalars['Boolean']['output'];
  /** @deprecated Use retryPaymentWithResult. */
  retryPayment: Scalars['Boolean']['output'];
  retryPaymentWithResult: SubscriptionPaymentRetryResultDto;
  sendAdminPayPalPayment: AdminPayPalPayoutResult;
  sendWishlistEmail: Scalars['Boolean']['output'];
  setDefaultCustomerAddress: Scalars['Boolean']['output'];
  setDefaultCustomerPaymentMethod: Scalars['Boolean']['output'];
  setShoppingCartShippingFromAddress: Scalars['Boolean']['output'];
  submitConsultingForm: Scalars['Boolean']['output'];
  submitContactForm: Scalars['Boolean']['output'];
  submitCreatorProfileUpdate: Scalars['Boolean']['output'];
  submitJobApplication: Scalars['Boolean']['output'];
  submitReviewerApplication: Scalars['Boolean']['output'];
  submitReviewerProductRequest: Scalars['Boolean']['output'];
  submitSupportSurvey: SubmitResult;
  submitTrick: Scalars['Boolean']['output'];
  unpauseSubscription: Scalars['Boolean']['output'];
  unsubscribeFromAllNewsletters: Scalars['Boolean']['output'];
  updateAdminCreator?: Maybe<AdminCreatorDetailDto>;
  updateCreatorPayPalAddress: Scalars['Boolean']['output'];
  updateCustomerBirthday: Scalars['Boolean']['output'];
  updateCustomerEmail: EmailUpdateResult;
  updateCustomerEori: Scalars['Boolean']['output'];
  updateCustomerInternalNotes: Scalars['Boolean']['output'];
  updateCustomerName: Scalars['Boolean']['output'];
  updateCustomerReview: Scalars['Boolean']['output'];
  updateCustomerVat: Scalars['Boolean']['output'];
  updateDownloadFileArchiveStatus: Scalars['Boolean']['output'];
  updateDownloadFileLastAccessPoint: Scalars['Boolean']['output'];
  updateGuestCheckoutCustomerProfile: EmailUpdateResult;
  updateGuestCheckoutEmail: EmailUpdateResult;
  updateInstructionLink: Scalars['Boolean']['output'];
  updateInvoiceExtraInfo: Scalars['Boolean']['output'];
  updateOrderShippingAddress: UpdateOrderShippingAddressResult;
  updatePassword: Scalars['Boolean']['output'];
  updatePrivateWishlistSetting: Scalars['Boolean']['output'];
  updateProduct: Scalars['Boolean']['output'];
  updateProductLowStockSnooze: Scalars['Boolean']['output'];
  updateShoppingCartItemPrice: Scalars['Boolean']['output'];
  updateShoppingCartItemQty: Scalars['Boolean']['output'];
  updateShoppingCartLocation: Scalars['Boolean']['output'];
  updateShoppingCartPromoCode: PromoCodeResultType;
  updateShoppingCartShippingAddress: Scalars['Boolean']['output'];
  updateShoppingCartShippingOption: Scalars['Boolean']['output'];
  updateShoppingCartUseStoreCredit?: Maybe<ShoppingCartDto>;
  uploadAdminAsset: AdminAssetUploadResultDto;
  upvoteProductQuestion: QuestionDto;
  validateCustomerAddress: ValidateAddressResult;
  validateExplanationUniqueCode: ValidateExplanationUniqueCodeResultDto;
};


export type MutationAddConventionRegistrationBundleToShoppingCartArgs = {
  bypassSoldOut?: Scalars['Boolean']['input'];
  conventionProductId: Scalars['Int']['input'];
  paymentPlan?: InputMaybe<ConventionPaymentPlanInputDtoInput>;
  registrants: Array<ConventionRegistrantInputDtoInput>;
  registrationOptionId?: InputMaybe<Scalars['Int']['input']>;
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationAddConventionUpgradeToShoppingCartArgs = {
  registrationOrderItemId: Scalars['Int']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationAddConventionWaitingListArgs = {
  conventionProductId: Scalars['Int']['input'];
  registrationOptionId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddCustomerToSegmentArgs = {
  segmentId: Scalars['Int']['input'];
  workspace?: InputMaybe<CustomerIoWorkspace>;
};


export type MutationAddEbookBundleToShoppingCartArgs = {
  downloadOptionId: Scalars['Int']['input'];
  physicalOptionId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  quantity?: Scalars['Int']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationAddGiftCertificateToShoppingCartArgs = {
  giftCertificateProductOptionId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationAddItemToShoppingCartArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
  quantity?: Scalars['Int']['input'];
  shoppingCartToken: Scalars['String']['input'];
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};


export type MutationAddItemToWishListArgs = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};


export type MutationAddRestockAlertArgs = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  optionId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};


export type MutationAdminAddConventionRegistrantArgs = {
  amountPaid: Scalars['Decimal']['input'];
  conventionProductId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  registrationOptionId?: InputMaybe<Scalars['Int']['input']>;
  sendConfirmation: Scalars['Boolean']['input'];
};


export type MutationAdminAddConventionWaitlistEntryArgs = {
  conventionProductId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  registrationOptionId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAdminAddConventionWorkshopArgs = {
  amountPaid: Scalars['Decimal']['input'];
  orderItemId: Scalars['Int']['input'];
  workshopProductId: Scalars['Int']['input'];
};


export type MutationAdminAddCustomerSubscriptionArgs = {
  customerId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  grantStartedMonth: Scalars['Boolean']['input'];
  startDate: Scalars['DateTime']['input'];
  subscriptionProviderCode: Scalars['String']['input'];
};


export type MutationAdminAddDownloadCodesArgs = {
  codes: Array<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAdminAddMurphysOpenOrderItemArgs = {
  account: MurphysAccount;
  murphysItemId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  salesOrderNumber: Scalars['String']['input'];
};


export type MutationAdminAddMurphysSalesOrderLineArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  orderItemId: Scalars['Int']['input'];
};


export type MutationAdminAddOrderInternalNoteArgs = {
  checkNote: Scalars['Boolean']['input'];
  note: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
};


export type MutationAdminAddOrderItemArgs = {
  expectedStatusId: Scalars['Int']['input'];
  optionId?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};


export type MutationAdminAddOrderItemToTargetQuantityArgs = {
  expectedStatusId: Scalars['Int']['input'];
  optionId?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  targetQuantity: Scalars['Int']['input'];
};


export type MutationAdminAddProductInventoryStockArgs = {
  notes?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
  shelfId: Scalars['Int']['input'];
};


export type MutationAdminAdjustCustomerPointsArgs = {
  customerBrandLinkId: Scalars['Int']['input'];
  customerId: Scalars['Int']['input'];
  note: Scalars['String']['input'];
  points: Scalars['Int']['input'];
};


export type MutationAdminAdjustProductInventoryStockArgs = {
  direction: AdminInventoryAdjustmentDirection;
  notes?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
  shelfId: Scalars['Int']['input'];
};


export type MutationAdminApplyOrderCancellationArgs = {
  input: AdminOrderCancellationProcessInputDtoInput;
};


export type MutationAdminApplyProductImageVariantArgs = {
  input: AdminApplyProductImageVariantInput;
};


export type MutationAdminApplyProductThumbnailArgs = {
  input: AdminApplyProductThumbnailInput;
};


export type MutationAdminApplySaleCsvArgs = {
  csv: Scalars['String']['input'];
  rollbackCsv: Scalars['String']['input'];
};


export type MutationAdminApplyTaxJarCorrectionsArgs = {
  confirmApply: Scalars['Boolean']['input'];
  csv: Scalars['String']['input'];
  maxRows: Scalars['Int']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
  usePreviewedActions: Scalars['Boolean']['input'];
};


export type MutationAdminApproveStockCountDiscrepancyArgs = {
  discrepancyId: Scalars['Int']['input'];
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminApproveStockCountDiscrepancyWithCountArgs = {
  discrepancyId: Scalars['Int']['input'];
  physicalCount: Scalars['Int']['input'];
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminArchiveHomepageCarouselItemArgs = {
  expectedUpdatedAtUtc: Scalars['DateTime']['input'];
  id: Scalars['Int']['input'];
};


export type MutationAdminArchiveOrderAttachmentArgs = {
  attachmentId: Scalars['Int']['input'];
  orderId: Scalars['Int']['input'];
};


export type MutationAdminAssetUploadUrlArgs = {
  input: AdminAssetUploadRequestInput;
};


export type MutationAdminAssignOrderLicenseCodesArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationAdminAttachProductImageArgs = {
  input: AdminAttachProductImageInput;
};


export type MutationAdminAttachProductTrailerArgs = {
  input: AdminAttachProductTrailerInput;
};


export type MutationAdminBlogAssetUploadUrlArgs = {
  input: AdminAssetUploadRequestInput;
};


export type MutationAdminBuildSaleRollbackCsvArgs = {
  csv: Scalars['String']['input'];
  saleName: Scalars['String']['input'];
};


export type MutationAdminChangeOrderShippingMethodArgs = {
  orderId: Scalars['Int']['input'];
  shippingMethodId: Scalars['Int']['input'];
};


export type MutationAdminChangeOrderStatusArgs = {
  orderId: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  statusId: Scalars['Int']['input'];
};


export type MutationAdminChargeConventionNextPaymentArgs = {
  orderItemId: Scalars['Int']['input'];
};


export type MutationAdminCheckPendingOrderTaxReconciliationsArgs = {
  maxRows: Scalars['Int']['input'];
  minimumDifference: Scalars['Decimal']['input'];
};


export type MutationAdminClaimPickingOrderArgs = {
  distributorOrderId?: InputMaybe<Scalars['String']['input']>;
  includeAllFulfillmentGroups?: InputMaybe<Scalars['Boolean']['input']>;
  includeCustomerOpenOrders: Scalars['Boolean']['input'];
  locationId: Scalars['Int']['input'];
  orderId: Scalars['Int']['input'];
};


export type MutationAdminClearPartiallyPickedBoxAssignmentArgs = {
  expectedLastUpdated: Scalars['DateTime']['input'];
  expectedOrderId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminClosePurchaseOrderShortArgs = {
  id: Scalars['Int']['input'];
  notes: Scalars['String']['input'];
};


export type MutationAdminConfirmProductContractUploadArgs = {
  input: AdminConfirmProductContractUploadInput;
};


export type MutationAdminConfirmProductDownloadSubtitleUploadArgs = {
  input: AdminConfirmProductDownloadSubtitleUploadInput;
};


export type MutationAdminConfirmShipmentDispatchArgs = {
  packageId: Scalars['Int']['input'];
};


export type MutationAdminCorrectPurchaseOrderReceiptArgs = {
  correctedQuantity: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  receiptId: Scalars['Int']['input'];
  requestId: Scalars['String']['input'];
};


export type MutationAdminCreateBlogPreviewArgs = {
  input: AdminBlogPreviewInput;
};


export type MutationAdminCreateConventionGalleryArgs = {
  intro?: InputMaybe<Scalars['String']['input']>;
  photographer?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  urlStub: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};


export type MutationAdminCreateDownloadCodesArgs = {
  count: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAdminCreateInventoryShelfArgs = {
  locationId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  storageOnly: Scalars['Boolean']['input'];
};


export type MutationAdminCreatePackageResendArgs = {
  input: AdminPackageResendInputDtoInput;
};


export type MutationAdminCreatePartiallyPickedBoxArgs = {
  boxId: Scalars['Int']['input'];
  locationId: Scalars['Int']['input'];
  size: Scalars['String']['input'];
};


export type MutationAdminCreateProductArgs = {
  input: AdminCreateProductInput;
};


export type MutationAdminCreateProductComponentArgs = {
  name: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  stockNotes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminCreateProductCreatorArgs = {
  name: Scalars['String']['input'];
};


export type MutationAdminCreateProductDownloadFileArgs = {
  input: AdminCreateProductDownloadFileInput;
};


export type MutationAdminCreateProductFinanceEntryArgs = {
  input: AdminCreateProductFinanceEntryInput;
};


export type MutationAdminCreateProductManufacturerArgs = {
  name: Scalars['String']['input'];
};


export type MutationAdminCreateProductMetaArgs = {
  input: AdminCreateProductMetaInput;
};


export type MutationAdminCreateScanFormArgs = {
  courier: Scalars['String']['input'];
};


export type MutationAdminCreateShortUrlArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  originalUrl: Scalars['String']['input'];
  shortUrlCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminCreateStoreOrderArgs = {
  destination: AdminStoreOrderDestination;
  items: Array<AdminCreateStoreOrderItemInput>;
  pending: Scalars['Boolean']['input'];
  purchaseOrderNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminDeactivateInventoryShelfArgs = {
  shelfId: Scalars['Int']['input'];
};


export type MutationAdminDeleteProductFinanceEntryArgs = {
  input: AdminDeleteProductFinanceEntryInput;
};


export type MutationAdminDeleteProductMetaArgs = {
  input: AdminDeleteProductMetaInput;
};


export type MutationAdminDeletePurchaseOrderArgs = {
  id: Scalars['Int']['input'];
};


export type MutationAdminDeleteUnusedInventoryShelfArgs = {
  shelfId: Scalars['Int']['input'];
};


export type MutationAdminEnableProductCreatorFinanceLogArgs = {
  productId: Scalars['Int']['input'];
};


export type MutationAdminExplainStockCountDiscrepancyArgs = {
  discrepancyId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reasonCode: Scalars['String']['input'];
};


export type MutationAdminGrantCustomerDownloadArgs = {
  brandId: Scalars['Int']['input'];
  customerId: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAdminImportMurphysProductMediaArgs = {
  input: AdminImportMurphysProductMediaInput;
};


export type MutationAdminImportProductDownloadUploadArgs = {
  input: AdminImportProductDownloadUploadInput;
};


export type MutationAdminImportProductTrailerArgs = {
  input: AdminImportProductTrailerInput;
};


export type MutationAdminImportRemoteImageArgs = {
  input: AdminImportRemoteImageInput;
};


export type MutationAdminInsertMasterclassMetaArgs = {
  month: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type MutationAdminLinkStripeSubscriptionToCustomerArgs = {
  customerId: Scalars['Int']['input'];
  grantStartedMonth: Scalars['Boolean']['input'];
  stripeSubscriptionId: Scalars['String']['input'];
  subscriptionProviderCode: Scalars['String']['input'];
};


export type MutationAdminMergeCustomersArgs = {
  confirmation: Scalars['String']['input'];
  sourceCustomerId: Scalars['Int']['input'];
  targetCustomerId: Scalars['Int']['input'];
};


export type MutationAdminModerateBlogCommentArgs = {
  commentId: Scalars['Int']['input'];
  status: BlogCommentStatus;
};


export type MutationAdminMoveOrderToBackorderArgs = {
  locationId: Scalars['Int']['input'];
  orderId: Scalars['Int']['input'];
};


export type MutationAdminMoveProductInventoryShelfStockArgs = {
  fromShelfId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
  toShelfId: Scalars['Int']['input'];
};


export type MutationAdminPackagePrintDocumentsArgs = {
  packageId: Scalars['Int']['input'];
};


export type MutationAdminPackagePrintInvoiceArgs = {
  packageId: Scalars['Int']['input'];
};


export type MutationAdminPatchTypesenseProductLiveArgs = {
  clearSearchCache: Scalars['Boolean']['input'];
  live: Scalars['Boolean']['input'];
  productId: Scalars['Int']['input'];
};


export type MutationAdminPatchTypesenseProductPricesArgs = {
  clearSearchCache: Scalars['Boolean']['input'];
  discountGbp?: InputMaybe<Scalars['Decimal']['input']>;
  discountUsd?: InputMaybe<Scalars['Decimal']['input']>;
  priceGbp?: InputMaybe<Scalars['Decimal']['input']>;
  priceUsd?: InputMaybe<Scalars['Decimal']['input']>;
  productId: Scalars['Int']['input'];
};


export type MutationAdminPlacePurchaseOrdersArgs = {
  items: Array<AdminPurchaseOrderPlacementItemInput>;
  manufacturerId: Scalars['Int']['input'];
  orderInfo?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminPrepareProductContractUploadArgs = {
  productId: Scalars['Int']['input'];
};


export type MutationAdminPrepareProductDownloadSubtitleUploadArgs = {
  input: AdminPrepareProductDownloadSubtitleUploadInput;
};


export type MutationAdminPrepareProductDownloadUploadArgs = {
  input: AdminPrepareProductDownloadUploadInput;
};


export type MutationAdminPreviewSaleCsvArgs = {
  csv: Scalars['String']['input'];
};


export type MutationAdminPreviewTaxJarCorrectionsArgs = {
  csv: Scalars['String']['input'];
  maxRows: Scalars['Int']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminProcessOrderArgs = {
  orderId: Scalars['Int']['input'];
  queueBrandId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAdminProcessOrderRefundArgs = {
  input: AdminOrderRefundProcessInputDtoInput;
};


export type MutationAdminProcessTaxFailureRefundArgs = {
  additionalRefundAmount: Scalars['Decimal']['input'];
  orderId: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};


export type MutationAdminPublishManagedPageArgs = {
  expectedUpdatedAtUtc: Scalars['DateTime']['input'];
  pageKey: Scalars['String']['input'];
  sections: Array<ManagedPageSectionInputDtoInput>;
};


export type MutationAdminPublishProductArgs = {
  input: AdminPublishProductInput;
};


export type MutationAdminPurchaseShipmentLabelArgs = {
  batchSignature?: InputMaybe<Scalars['String']['input']>;
  distributorOrderId?: InputMaybe<Scalars['String']['input']>;
  freeProductIncluded: Scalars['Boolean']['input'];
  includeAllFulfillmentGroups?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['Int']['input'];
  orderId: Scalars['Int']['input'];
  orderItemIds: Array<Scalars['Int']['input']>;
  package: AdminShipmentPackageInput;
  rateId: Scalars['String']['input'];
  sendAsGift: Scalars['Boolean']['input'];
};


export type MutationAdminPurchaseUkTransferArgs = {
  boxes: Array<AdminUkTransferBoxInput>;
  orderId: Scalars['String']['input'];
  serviceLevel: Scalars['String']['input'];
};


export type MutationAdminQuoteShipmentArgs = {
  distributorOrderId?: InputMaybe<Scalars['String']['input']>;
  includeAllFulfillmentGroups?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['Int']['input'];
  orderId: Scalars['Int']['input'];
  orderItemIds: Array<Scalars['Int']['input']>;
  package: AdminShipmentPackageInput;
  sendAsGift: Scalars['Boolean']['input'];
};


export type MutationAdminQuoteUkTransferArgs = {
  boxes: Array<AdminUkTransferBoxInput>;
};


export type MutationAdminReactivateInventoryShelfArgs = {
  shelfId: Scalars['Int']['input'];
};


export type MutationAdminRecalculateTypesenseProductPricesArgs = {
  clearSearchCache: Scalars['Boolean']['input'];
  productId: Scalars['Int']['input'];
};


export type MutationAdminReceivePurchaseOrderArgs = {
  id: Scalars['Int']['input'];
  kind: AdminPurchaseOrderReceiptKind;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  recountQuantity?: InputMaybe<Scalars['Int']['input']>;
  requestId: Scalars['String']['input'];
  shelfId: Scalars['Int']['input'];
};


export type MutationAdminRecoverMasterclassRenewalsArgs = {
  confirmation: Scalars['String']['input'];
  items: Array<AdminMasterclassRenewalRecoveryInputDtoInput>;
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type MutationAdminRefreshProductDownloadStreamingArgs = {
  input: AdminRefreshProductDownloadStreamingInput;
};


export type MutationAdminRefreshProductStorefrontAndSearchArgs = {
  productId: Scalars['Int']['input'];
};


export type MutationAdminRefreshProductTrailerStatusArgs = {
  input: AdminRefreshProductTrailerStatusInput;
};


export type MutationAdminReleasePickingOrderArgs = {
  distributorOrderId?: InputMaybe<Scalars['String']['input']>;
  includeAllFulfillmentGroups?: InputMaybe<Scalars['Boolean']['input']>;
  includeCustomerOpenOrders: Scalars['Boolean']['input'];
  locationId: Scalars['Int']['input'];
  orderId: Scalars['Int']['input'];
};


export type MutationAdminRemoveMurphysOpenOrderItemArgs = {
  account: MurphysAccount;
  murphysItemId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  salesOrderNumber: Scalars['String']['input'];
};


export type MutationAdminRemoveProductDownloadFileArgs = {
  input: AdminRemoveProductDownloadFileInput;
};


export type MutationAdminRemoveProductImageArgs = {
  input: AdminRemoveProductImageInput;
};


export type MutationAdminRemoveProductTrailerArgs = {
  input: AdminRemoveProductTrailerInput;
};


export type MutationAdminRenameInventoryShelfArgs = {
  name: Scalars['String']['input'];
  shelfId: Scalars['Int']['input'];
};


export type MutationAdminRenderBlogPreviewArgs = {
  markdown: Scalars['String']['input'];
};


export type MutationAdminReorderHomepageCarouselItemsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationAdminReorderProductDownloadFilesArgs = {
  input: AdminReorderProductDownloadFilesInput;
};


export type MutationAdminReorderProductImagesArgs = {
  input: AdminReorderProductImagesInput;
};


export type MutationAdminReorderProductOptionsArgs = {
  input: AdminReorderProductOptionsInput;
};


export type MutationAdminReorderProductTrailersArgs = {
  input: AdminReorderProductTrailersInput;
};


export type MutationAdminReplaceProductDownloadChaptersArgs = {
  input: AdminReplaceProductDownloadChaptersInput;
};


export type MutationAdminReplaceProductDownloadFileArgs = {
  input: AdminReplaceProductDownloadFileInput;
};


export type MutationAdminReportStockCountProblemArgs = {
  notes?: InputMaybe<Scalars['String']['input']>;
  reasonCode: Scalars['String']['input'];
  taskId: Scalars['Int']['input'];
};


export type MutationAdminRequestPickingStockCountArgs = {
  distributorOrderId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  orderItemId: Scalars['Int']['input'];
};


export type MutationAdminRequestProductInventoryCountArgs = {
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
  shelfId: Scalars['Int']['input'];
};


export type MutationAdminRequestStockCountArgs = {
  locationId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
  shelfId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAdminResendConventionConfirmationArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationAdminResendOrderConfirmationArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationAdminResetProductInventoryCountArgs = {
  physicalCount: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
  shelfId: Scalars['Int']['input'];
};


export type MutationAdminResolveReturnItemArgs = {
  input: AdminReturnResolveItemInputDtoInput;
};


export type MutationAdminResolveStockCountDiscrepancyNoChangeArgs = {
  discrepancyId: Scalars['Int']['input'];
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminRestoreHomepageCarouselItemArgs = {
  expectedUpdatedAtUtc: Scalars['DateTime']['input'];
  id: Scalars['Int']['input'];
};


export type MutationAdminRestoreSalePricesArgs = {
  rollbackCsv: Scalars['String']['input'];
};


export type MutationAdminRetryProductTrailerImportArgs = {
  input: AdminRetryProductTrailerImportInput;
};


export type MutationAdminReturnStockCountDiscrepancyToQueueArgs = {
  discrepancyId: Scalars['Int']['input'];
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminReviewReturnArgs = {
  input: AdminReturnReviewInputDtoInput;
};


export type MutationAdminSaveBlogCategoryArgs = {
  input: AdminBlogCategoryInput;
};


export type MutationAdminSaveBlogPostArgs = {
  input: AdminBlogSaveInput;
};


export type MutationAdminSaveConventionRegistrationMetaArgs = {
  key: Scalars['String']['input'];
  orderItemId: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};


export type MutationAdminSaveManagedPageDraftArgs = {
  expectedUpdatedAtUtc: Scalars['DateTime']['input'];
  pageKey: Scalars['String']['input'];
  sections: Array<ManagedPageSectionInputDtoInput>;
};


export type MutationAdminSavePickingExceptionArgs = {
  boxLocation?: InputMaybe<Scalars['String']['input']>;
  distributorOrderId?: InputMaybe<Scalars['String']['input']>;
  exceptionType?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  orderFromMurphys: Scalars['Boolean']['input'];
  orderItemId: Scalars['Int']['input'];
};


export type MutationAdminSaveProductDetailsArgs = {
  input: AdminSaveProductDetailsInput;
};


export type MutationAdminSavePurchaseOrderArgs = {
  dateExpected?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
  makeProductLiveOnReceipt: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminSendDelayedOrderEmailsArgs = {
  customerUpdate?: InputMaybe<Scalars['String']['input']>;
  emailMessage?: InputMaybe<Scalars['String']['input']>;
  giftVoucherAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderIds: Array<Scalars['Int']['input']>;
};


export type MutationAdminSendStockCountDiscrepancyForRecountArgs = {
  discrepancyId: Scalars['Int']['input'];
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminSetConventionGalleryLeadPhotoArgs = {
  galleryId: Scalars['Int']['input'];
  imageFileName: Scalars['String']['input'];
};


export type MutationAdminSetInventoryShelfStorageOnlyArgs = {
  shelfId: Scalars['Int']['input'];
  storageOnly: Scalars['Boolean']['input'];
};


export type MutationAdminSetOrderAttachmentCustomerVisibilityArgs = {
  attachmentId: Scalars['Int']['input'];
  customerVisible: Scalars['Boolean']['input'];
  orderId: Scalars['Int']['input'];
};


export type MutationAdminSetOrderDispatchPriorityArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationAdminSetPickingItemPickedArgs = {
  boxId?: InputMaybe<Scalars['String']['input']>;
  distributorOrderId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  orderItemId: Scalars['Int']['input'];
  picked: Scalars['Boolean']['input'];
};


export type MutationAdminSetProductInventoryPrimaryShelfArgs = {
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
  shelfId: Scalars['Int']['input'];
};


export type MutationAdminSetReturnHoldArgs = {
  input: AdminReturnHoldInputDtoInput;
};


export type MutationAdminSetSupportSurveyFollowUpCompletedArgs = {
  completed: Scalars['Boolean']['input'];
  supportLogId: Scalars['Int']['input'];
};


export type MutationAdminSetSupportSurveyNotAboutResponderArgs = {
  notAboutResponder: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  supportLogId: Scalars['Int']['input'];
};


export type MutationAdminSkipStockCountTaskArgs = {
  notes?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['Int']['input'];
};


export type MutationAdminSplitPickingItemArgs = {
  distributorOrderId?: InputMaybe<Scalars['String']['input']>;
  includeAllFulfillmentGroups?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['Int']['input'];
  orderItemId: Scalars['Int']['input'];
  quantityToShipNow: Scalars['Int']['input'];
};


export type MutationAdminStartNextStockCountTaskArgs = {
  locationId: Scalars['Int']['input'];
};


export type MutationAdminStartProductDownloadStreamingArgs = {
  input: AdminStartProductDownloadStreamingInput;
};


export type MutationAdminSubmitProductInAppPurchaseArgs = {
  allowNoDownloads?: Scalars['Boolean']['input'];
  allowNonViProduct?: Scalars['Boolean']['input'];
  allowNotLive?: Scalars['Boolean']['input'];
  productId: Scalars['Int']['input'];
  repairMetadata?: Scalars['Boolean']['input'];
  skipAvailability?: Scalars['Boolean']['input'];
  skipPrice?: Scalars['Boolean']['input'];
  skipScreenshot?: Scalars['Boolean']['input'];
  submitForReview?: Scalars['Boolean']['input'];
};


export type MutationAdminSubmitShelfAuditArgs = {
  counts: Array<AdminShelfAuditLineInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  shelfId: Scalars['Int']['input'];
};


export type MutationAdminSubmitStockCountArgs = {
  notes?: InputMaybe<Scalars['String']['input']>;
  physicalCount: Scalars['Int']['input'];
  taskId: Scalars['Int']['input'];
};


export type MutationAdminSubmitStockCountRecountArgs = {
  discrepancyId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  physicalCount: Scalars['Int']['input'];
};


export type MutationAdminSwitchConventionRegistrationArgs = {
  mapRegistrationOption?: Scalars['Boolean']['input'];
  newConventionProductId: Scalars['Int']['input'];
  orderItemId: Scalars['Int']['input'];
  registrationOptionId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAdminSyncConventionGalleryPhotosArgs = {
  galleryId: Scalars['Int']['input'];
};


export type MutationAdminTransferProductInventoryStockArgs = {
  addToDestinationStock: Scalars['Boolean']['input'];
  fromLocationId: Scalars['Int']['input'];
  fromShelfId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
  toLocationId: Scalars['Int']['input'];
  toShelfId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAdminUnpublishProductArgs = {
  input: AdminUnpublishProductInput;
};


export type MutationAdminUpdateComponentProductArgs = {
  componentProductId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  stockNotes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminUpdateConventionRegistrationArgs = {
  name: Scalars['String']['input'];
  orderItemId: Scalars['Int']['input'];
  registrationOptionId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAdminUpdateOrderShippingAddressArgs = {
  expectedShippingAddressId: Scalars['Int']['input'];
  input: UpdateOrderShippingAddressInput;
  orderId: Scalars['Int']['input'];
};


export type MutationAdminUpdatePickingShelfArgs = {
  distributorOrderId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  orderItemId: Scalars['Int']['input'];
  shelfId: Scalars['Int']['input'];
};


export type MutationAdminUpdateProductAssociationsArgs = {
  input: AdminUpdateProductAssociationsInput;
};


export type MutationAdminUpdateProductDownloadFileArgs = {
  input: AdminUpdateProductDownloadFileInput;
};


export type MutationAdminUpdateProductFinanceEntryArgs = {
  input: AdminUpdateProductFinanceEntryInput;
};


export type MutationAdminUpdateProductFulfilmentArgs = {
  input: AdminUpdateProductFulfilmentInput;
};


export type MutationAdminUpdateProductIdentityArgs = {
  input: AdminUpdateProductIdentityInput;
};


export type MutationAdminUpdateProductMetaArgs = {
  input: AdminUpdateProductMetaInput;
};


export type MutationAdminUpdateProductMetadataArgs = {
  input: AdminUpdateProductMetadataInput;
};


export type MutationAdminUpdateProductPricingArgs = {
  input: AdminUpdateProductPricingInput;
};


export type MutationAdminUpdateProductPublicationArgs = {
  input: AdminUpdateProductPublicationInput;
};


export type MutationAdminUploadOrderAttachmentArgs = {
  input: AdminUploadOrderAttachmentInput;
};


export type MutationAdminUpsertHomepageCarouselItemArgs = {
  input: HomepageCarouselItemInput;
};


export type MutationAdminUpsertProductOptionArgs = {
  input: AdminUpsertProductOptionInput;
};


export type MutationAssignCartToCustomerArgs = {
  customerId: Scalars['Int']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationCancelSubscriptionArgs = {
  howTheyMightStay?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  subscriptionId: Scalars['Int']['input'];
};


export type MutationCaptureShoppingCartPayPalOrderAndCompleteCartArgs = {
  addToNewsletter?: Scalars['Boolean']['input'];
  paypalOrderId: Scalars['String']['input'];
  prepayImportDuties?: Scalars['Boolean']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationCompleteManualPaymentArgs = {
  amount: Scalars['Decimal']['input'];
  currency: Scalars['String']['input'];
  paymentIntentId: Scalars['String']['input'];
};


export type MutationCompleteShoppingCartAsAdminWithoutOnlinePaymentArgs = {
  addToNewsletter?: Scalars['Boolean']['input'];
  mode: AdminShoppingCartCompletionMode;
  prepayImportDuties?: Scalars['Boolean']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationCompleteShoppingCartWithStripePaymentArgs = {
  addToNewsletter?: Scalars['Boolean']['input'];
  paymentIntentId: Scalars['String']['input'];
  prepayImportDuties?: Scalars['Boolean']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationCompleteShoppingCartWithoutPaymentArgs = {
  addToNewsletter?: Scalars['Boolean']['input'];
  prepayImportDuties?: Scalars['Boolean']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationConfirmAdminAssetUploadArgs = {
  input: ConfirmAdminAssetUploadInput;
};


export type MutationConfirmAdminBlogAssetUploadArgs = {
  input: ConfirmAdminAssetUploadInput;
};


export type MutationConfirmReturnImageUploadArgs = {
  fileName: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
  orderItemId: Scalars['Int']['input'];
};


export type MutationConvertPointsToStoreCreditArgs = {
  brandId: Scalars['Int']['input'];
  currencyId: Scalars['Int']['input'];
};


export type MutationConvertVoucherToStoreCreditArgs = {
  brandId: Scalars['Int']['input'];
  voucherCode: Scalars['String']['input'];
};


export type MutationCreateAnonymousShoppingCartArgs = {
  countryIsoCode: Scalars['String']['input'];
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  isConventionCart?: Scalars['Boolean']['input'];
};


export type MutationCreateBlogCommentArgs = {
  blogPostId: Scalars['Int']['input'];
  comment: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
  responseTo?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateCustomerArgs = {
  addToNewsletter?: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  howSignedUp?: Scalars['Int']['input'];
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  skipEmailValidation?: Scalars['Boolean']['input'];
};


export type MutationCreateCustomerAddressArgs = {
  customerId: Scalars['Int']['input'];
  input: CreateCustomerAddressInput;
  shoppingCartToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCustomerBrandLinkArgs = {
  brandId?: Scalars['Int']['input'];
};


export type MutationCreateCustomerReviewArgs = {
  productId: Scalars['Int']['input'];
  rating: Scalars['Int']['input'];
  review?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCustomerShoppingCartArgs = {
  countryIsoCode: Scalars['String']['input'];
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  customerId: Scalars['Int']['input'];
  forceNew?: Scalars['Boolean']['input'];
  isConventionCart?: Scalars['Boolean']['input'];
};


export type MutationCreateInAppPurchaseOrderArgs = {
  customerId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  transactionId: Scalars['String']['input'];
};


export type MutationCreateInstructionLinkArgs = {
  instructionLink: Scalars['String']['input'];
  instructionPassword?: InputMaybe<Scalars['String']['input']>;
  productName: Scalars['String']['input'];
};


export type MutationCreateManualPaymentIntentArgs = {
  amount: Scalars['Decimal']['input'];
  cardholderName: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreatePaymentMethodSetupTokenArgs = {
  brandId: Scalars['Int']['input'];
};


export type MutationCreateProductQuestionArgs = {
  postPurchase?: Scalars['Boolean']['input'];
  productId: Scalars['Int']['input'];
  question: Scalars['String']['input'];
  responseTo?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateReturnArgs = {
  items: Array<ReturnRequestItemDtoInput>;
  orderId: Scalars['Int']['input'];
};


export type MutationCreateShoppingCartPayPalOrderArgs = {
  lockShippingAddress?: Scalars['Boolean']['input'];
  prepayImportDuties?: Scalars['Boolean']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationCreateShoppingCartPaymentIntentArgs = {
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodType?: InputMaybe<Scalars['String']['input']>;
  prepayImportDuties?: Scalars['Boolean']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationDeactivateAppDeviceArgs = {
  deviceId: Scalars['Int']['input'];
};


export type MutationDeleteCustomerAddressArgs = {
  customerAddressId: Scalars['Int']['input'];
};


export type MutationDeleteCustomerPaymentMethodArgs = {
  brandId: Scalars['Int']['input'];
  paymentMethodId: Scalars['String']['input'];
};


export type MutationDeleteCustomerReviewArgs = {
  reviewId: Scalars['Int']['input'];
};


export type MutationDeleteInstructionLinkArgs = {
  instructionLinkId: Scalars['Int']['input'];
};


export type MutationDeleteMyAccountArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationGenerateCreatorPaymentsArgs = {
  creatorIds: Array<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationGrantExplanationAccessArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  brandId: Scalars['Int']['input'];
  customerId: Scalars['Int']['input'];
  productSlug: Scalars['String']['input'];
};


export type MutationGrantFreeDownloadArgs = {
  brandId: Scalars['Int']['input'];
  customerId: Scalars['Int']['input'];
  productSlug: Scalars['String']['input'];
};


export type MutationLinkCreatorAccountArgs = {
  creatorId: Scalars['Int']['input'];
  hash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMergeAnonymousShoppingCartArgs = {
  anonymousCartToken: Scalars['String']['input'];
  countryIsoCode: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
};


export type MutationPauseSubscriptionArgs = {
  subscriptionId: Scalars['Int']['input'];
};


export type MutationPresignedUrlForReturnImageArgs = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
  orderItemId: Scalars['Int']['input'];
};


export type MutationProcessCreatorPaymentsArgs = {
  allowUnverifiedBalance?: Scalars['Boolean']['input'];
};


export type MutationReactivateSubscriptionArgs = {
  subscriptionId: Scalars['Int']['input'];
};


export type MutationReconcileCustomerShoppingCartArgs = {
  anonymousCartToken?: InputMaybe<Scalars['String']['input']>;
  countryIsoCode: Scalars['String']['input'];
};


export type MutationRecordProductLiveChatMessageArgs = {
  message: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
};


export type MutationRecoverCapturedPayPalCheckoutArgs = {
  captureId?: InputMaybe<Scalars['String']['input']>;
  currencyCode: Scalars['String']['input'];
  paypalOrderId: Scalars['String']['input'];
};


export type MutationRecoverPaidCheckoutArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type MutationRedeemDownloadCardArgs = {
  brandId: Scalars['Int']['input'];
  code: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
  expectedProductId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRefreshCustomerSubscriptionArgs = {
  customerId: Scalars['Int']['input'];
};


export type MutationRefreshShoppingCartPricesArgs = {
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationRegisterMagicStoreSignupArgs = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  skipEmailValidation?: Scalars['Boolean']['input'];
  store?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveCustomerFromSegmentArgs = {
  segmentId: Scalars['Int']['input'];
  workspace?: InputMaybe<CustomerIoWorkspace>;
};


export type MutationRemoveItemFromCartArgs = {
  cartItemId: Scalars['Int']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationRemoveItemFromWishListArgs = {
  productId: Scalars['Int']['input'];
};


export type MutationRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  confirmNewPassword: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
  hash: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationRetryPaymentArgs = {
  subscriptionId: Scalars['Int']['input'];
};


export type MutationRetryPaymentWithResultArgs = {
  subscriptionId: Scalars['Int']['input'];
};


export type MutationSendAdminPayPalPaymentArgs = {
  allowUnverifiedBalance?: Scalars['Boolean']['input'];
  amount: Scalars['Decimal']['input'];
  currency: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  receiver: Scalars['String']['input'];
  requestId: Scalars['UUID']['input'];
};


export type MutationSendWishlistEmailArgs = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  recipientEmail: Scalars['String']['input'];
};


export type MutationSetDefaultCustomerAddressArgs = {
  customerAddressId: Scalars['Int']['input'];
};


export type MutationSetDefaultCustomerPaymentMethodArgs = {
  brandId: Scalars['Int']['input'];
  paymentMethodId: Scalars['String']['input'];
};


export type MutationSetShoppingCartShippingFromAddressArgs = {
  address: ShippingAddressInput;
  currencySymbol: Scalars['String']['input'];
  estDelivery: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
  shippingMethodId: Scalars['Int']['input'];
  shippingOptionDescription: Scalars['String']['input'];
  shippingOptionId: Scalars['String']['input'];
  shippingRateHash: Scalars['String']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationSubmitConsultingFormArgs = {
  companyName: Scalars['String']['input'];
  details: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationSubmitContactFormArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationSubmitCreatorProfileUpdateArgs = {
  input: SubmitCreatorProfileUpdateInput;
};


export type MutationSubmitJobApplicationArgs = {
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  cvBase64?: InputMaybe<Scalars['String']['input']>;
  cvFileName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  jobSlug: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
  location: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationSubmitReviewerApplicationArgs = {
  input: SubmitReviewerApplicationInput;
};


export type MutationSubmitReviewerProductRequestArgs = {
  input: ReviewerProductRequestInput;
};


export type MutationSubmitSupportSurveyArgs = {
  comments: Scalars['String']['input'];
  customerServiceRating?: InputMaybe<Scalars['Int']['input']>;
  externalId: Scalars['String']['input'];
  followUpRequested?: Scalars['Boolean']['input'];
  generalFeedback?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  responseAttribution?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubmitTrickArgs = {
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  trickName: Scalars['String']['input'];
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnpauseSubscriptionArgs = {
  subscriptionId: Scalars['Int']['input'];
};


export type MutationUnsubscribeFromAllNewslettersArgs = {
  workspace?: InputMaybe<CustomerIoWorkspace>;
};


export type MutationUpdateAdminCreatorArgs = {
  input: UpdateAdminCreatorInput;
};


export type MutationUpdateCreatorPayPalAddressArgs = {
  input: UpdateCreatorPayPalAddressInput;
};


export type MutationUpdateCustomerBirthdayArgs = {
  birthday: Scalars['DateTime']['input'];
};


export type MutationUpdateCustomerEmailArgs = {
  input: UpdateCustomerEmailInput;
};


export type MutationUpdateCustomerEoriArgs = {
  input: UpdateCustomerEoriInput;
};


export type MutationUpdateCustomerInternalNotesArgs = {
  customerId: Scalars['Int']['input'];
  internalNotes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCustomerNameArgs = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};


export type MutationUpdateCustomerReviewArgs = {
  rating: Scalars['Int']['input'];
  review?: InputMaybe<Scalars['String']['input']>;
  reviewId: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateCustomerVatArgs = {
  input: UpdateCustomerVatInput;
};


export type MutationUpdateDownloadFileArchiveStatusArgs = {
  isArchived: Scalars['Boolean']['input'];
  productId: Scalars['Int']['input'];
};


export type MutationUpdateDownloadFileLastAccessPointArgs = {
  downloadFileId: Scalars['Int']['input'];
  lastAccessPoint: Scalars['Int']['input'];
};


export type MutationUpdateGuestCheckoutCustomerProfileArgs = {
  customerId: Scalars['Int']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationUpdateGuestCheckoutEmailArgs = {
  customerId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationUpdateInstructionLinkArgs = {
  instructionLink: Scalars['String']['input'];
  instructionLinkId: Scalars['Int']['input'];
  instructionPassword?: InputMaybe<Scalars['String']['input']>;
  productName: Scalars['String']['input'];
};


export type MutationUpdateInvoiceExtraInfoArgs = {
  brandId: Scalars['Int']['input'];
  extraInfo?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOrderShippingAddressArgs = {
  input: UpdateOrderShippingAddressInput;
  orderId: Scalars['Int']['input'];
};


export type MutationUpdatePasswordArgs = {
  confirmNewPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationUpdatePrivateWishlistSettingArgs = {
  isPrivate: Scalars['Boolean']['input'];
};


export type MutationUpdateProductArgs = {
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  live?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
};


export type MutationUpdateProductLowStockSnoozeArgs = {
  lowStockSnoozeUntil: Scalars['DateTime']['input'];
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateShoppingCartItemPriceArgs = {
  newPrice: Scalars['Decimal']['input'];
  shoppingCartItemId: Scalars['Int']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationUpdateShoppingCartItemQtyArgs = {
  newQty: Scalars['Int']['input'];
  shoppingCartItemId: Scalars['Int']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationUpdateShoppingCartLocationArgs = {
  countryIsoCode: Scalars['String']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationUpdateShoppingCartPromoCodeArgs = {
  promoCode: Scalars['String']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationUpdateShoppingCartShippingAddressArgs = {
  shippingAddressId: Scalars['Int']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationUpdateShoppingCartShippingOptionArgs = {
  brandCode: Scalars['String']['input'];
  currencySymbol: Scalars['String']['input'];
  description: Scalars['String']['input'];
  destinationCountryOverride?: InputMaybe<Scalars['String']['input']>;
  destinationZipOverride?: InputMaybe<Scalars['String']['input']>;
  estDelivery: Scalars['String']['input'];
  id: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
  shippingMethodId: Scalars['Int']['input'];
  shippingRateHash: Scalars['String']['input'];
  shoppingCartToken: Scalars['String']['input'];
};


export type MutationUpdateShoppingCartUseStoreCreditArgs = {
  shoppingCartToken: Scalars['String']['input'];
  useStoreCredit: Scalars['Boolean']['input'];
};


export type MutationUploadAdminAssetArgs = {
  input: UploadAdminAssetInput;
};


export type MutationUpvoteProductQuestionArgs = {
  questionId: Scalars['Int']['input'];
};


export type MutationValidateCustomerAddressArgs = {
  input: ValidateAddressInput;
};


export type MutationValidateExplanationUniqueCodeArgs = {
  code: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type NewsletterSubscribeCheckoutDto = {
  __typename?: 'NewsletterSubscribeCheckoutDto';
  defaultMainNewsletterPreChecked: Scalars['Boolean']['output'];
  showMainCheckoutUpsell: Scalars['Boolean']['output'];
};

export type Order = {
  __typename?: 'Order';
  affiliateId?: Maybe<Scalars['Int']['output']>;
  billingAddress?: Maybe<CustomerAddress>;
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  brand: Brand;
  brandId: Scalars['Int']['output'];
  cancelReason?: Maybe<Scalars['Int']['output']>;
  conventionPickupId?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Currency>;
  currencyId?: Maybe<Scalars['Int']['output']>;
  customer: Customer;
  customerComments?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['Int']['output'];
  customerIpId?: Maybe<Scalars['Int']['output']>;
  dispatchByTime?: Maybe<Scalars['DateTime']['output']>;
  dropShipCustomerId?: Maybe<Scalars['Int']['output']>;
  dropShipFee?: Maybe<Scalars['Decimal']['output']>;
  giftWrap?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  importFee?: Maybe<Scalars['Decimal']['output']>;
  importFeeRefunded?: Maybe<Scalars['Decimal']['output']>;
  importFeeType?: Maybe<Scalars['Int']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  lockedByAdminUserId?: Maybe<Scalars['Int']['output']>;
  orderCompletedDate?: Maybe<Scalars['DateTime']['output']>;
  orderDate: Scalars['DateTime']['output'];
  orderItems: Array<OrderItem>;
  orderMethod: Scalars['Int']['output'];
  orderStatus?: Maybe<OrderStatus>;
  paidDate?: Maybe<Scalars['DateTime']['output']>;
  paymentMethodId?: Maybe<Scalars['Int']['output']>;
  paymentProcessingFeeToUs?: Maybe<Scalars['Decimal']['output']>;
  printedPackagingSlip?: Maybe<Scalars['DateTime']['output']>;
  priority?: Maybe<Scalars['Boolean']['output']>;
  processorTransactionId?: Maybe<Scalars['String']['output']>;
  profit?: Maybe<Scalars['Decimal']['output']>;
  shippingAddress?: Maybe<CustomerAddress>;
  shippingAddressId?: Maybe<Scalars['Int']['output']>;
  shippingCost?: Maybe<Scalars['Decimal']['output']>;
  shippingCostToUs?: Maybe<Scalars['Decimal']['output']>;
  shippingMethod?: Maybe<Scalars['Int']['output']>;
  shippingTaxTotal?: Maybe<Scalars['Decimal']['output']>;
  statusId: Scalars['Int']['output'];
  taxBreakdownSource?: Maybe<Scalars['String']['output']>;
  taxCharged?: Maybe<Scalars['Decimal']['output']>;
  voucherCode?: Maybe<Scalars['String']['output']>;
  wholesale?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderDto = {
  __typename?: 'OrderDto';
  canChangeShippingAddress: Scalars['Boolean']['output'];
  currency?: Maybe<CurrencyDto>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerVatNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  itemCount: Scalars['Int']['output'];
  orderDate: Scalars['DateTime']['output'];
  orderItems?: Maybe<Array<OrderItemDto>>;
  packages?: Maybe<Array<PackageDto>>;
  pointsEarned: Scalars['Int']['output'];
  shippingAddress?: Maybe<CustomerAddressDto>;
  shippingMethod?: Maybe<Scalars['Int']['output']>;
  shippingPrice?: Maybe<Scalars['Decimal']['output']>;
  shippingTaxTotal?: Maybe<Scalars['Decimal']['output']>;
  status?: Maybe<OrderStatus>;
  statusDescription?: Maybe<Scalars['String']['output']>;
  taxBreakdownSource?: Maybe<Scalars['String']['output']>;
  timeline?: Maybe<Array<OrderTimelineItemDto>>;
  totalPrice: Scalars['Decimal']['output'];
  totalTax: Scalars['Decimal']['output'];
};

export type OrderDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  itemCount?: InputMaybe<SortEnumType>;
  orderDate?: InputMaybe<SortEnumType>;
  totalPrice?: InputMaybe<SortEnumType>;
};

export type OrderFilterInput = {
  affiliateId?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<OrderFilterInput>>;
  billingAddress?: InputMaybe<CustomerAddressFilterInput>;
  billingAddressId?: InputMaybe<IntOperationFilterInput>;
  brand?: InputMaybe<BrandFilterInput>;
  brandId?: InputMaybe<IntOperationFilterInput>;
  cancelReason?: InputMaybe<IntOperationFilterInput>;
  conventionPickupId?: InputMaybe<IntOperationFilterInput>;
  currency?: InputMaybe<CurrencyFilterInput>;
  currencyId?: InputMaybe<IntOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerComments?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  customerIpId?: InputMaybe<IntOperationFilterInput>;
  dispatchByTime?: InputMaybe<DateTimeOperationFilterInput>;
  dropShipCustomerId?: InputMaybe<IntOperationFilterInput>;
  dropShipFee?: InputMaybe<DecimalOperationFilterInput>;
  giftWrap?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  importFee?: InputMaybe<DecimalOperationFilterInput>;
  importFeeRefunded?: InputMaybe<DecimalOperationFilterInput>;
  importFeeType?: InputMaybe<IntOperationFilterInput>;
  internalNotes?: InputMaybe<StringOperationFilterInput>;
  lockedByAdminUserId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<OrderFilterInput>>;
  orderCompletedDate?: InputMaybe<DateTimeOperationFilterInput>;
  orderDate?: InputMaybe<DateTimeOperationFilterInput>;
  orderItems?: InputMaybe<ListFilterInputTypeOfOrderItemFilterInput>;
  orderMethod?: InputMaybe<IntOperationFilterInput>;
  orderStatus?: InputMaybe<OrderStatusFilterInput>;
  paidDate?: InputMaybe<DateTimeOperationFilterInput>;
  paymentMethodId?: InputMaybe<IntOperationFilterInput>;
  paymentProcessingFeeToUs?: InputMaybe<DecimalOperationFilterInput>;
  printedPackagingSlip?: InputMaybe<DateTimeOperationFilterInput>;
  priority?: InputMaybe<BooleanOperationFilterInput>;
  processorTransactionId?: InputMaybe<StringOperationFilterInput>;
  profit?: InputMaybe<DecimalOperationFilterInput>;
  shippingAddress?: InputMaybe<CustomerAddressFilterInput>;
  shippingAddressId?: InputMaybe<IntOperationFilterInput>;
  shippingCost?: InputMaybe<DecimalOperationFilterInput>;
  shippingCostToUs?: InputMaybe<DecimalOperationFilterInput>;
  shippingMethod?: InputMaybe<IntOperationFilterInput>;
  shippingTaxTotal?: InputMaybe<DecimalOperationFilterInput>;
  statusId?: InputMaybe<IntOperationFilterInput>;
  taxBreakdownSource?: InputMaybe<StringOperationFilterInput>;
  taxCharged?: InputMaybe<DecimalOperationFilterInput>;
  voucherCode?: InputMaybe<StringOperationFilterInput>;
  wholesale?: InputMaybe<BooleanOperationFilterInput>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  associatedOrderItemId?: Maybe<Scalars['Int']['output']>;
  bundleId?: Maybe<Scalars['Int']['output']>;
  costToUs?: Maybe<Scalars['Decimal']['output']>;
  creatorPaymentLogId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distributorId?: Maybe<Scalars['Int']['output']>;
  distributorOrderId?: Maybe<Scalars['String']['output']>;
  downloadArchived?: Maybe<Scalars['Boolean']['output']>;
  exceptionDesc?: Maybe<Scalars['String']['output']>;
  exceptionFixed?: Maybe<Scalars['DateTime']['output']>;
  exceptionType?: Maybe<Scalars['Int']['output']>;
  exchangeRate?: Maybe<Scalars['Decimal']['output']>;
  hideFromCustomer?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  inventoryShelfId?: Maybe<Scalars['Int']['output']>;
  inventoryTransferId?: Maybe<Scalars['Int']['output']>;
  itemReturnId?: Maybe<Scalars['Int']['output']>;
  licenseCode?: Maybe<Scalars['String']['output']>;
  lineTaxTotal?: Maybe<Scalars['Decimal']['output']>;
  listPrice?: Maybe<Scalars['Decimal']['output']>;
  optionId?: Maybe<Scalars['Int']['output']>;
  order: Order;
  orderId: Scalars['Int']['output'];
  orderItemReturnItems: Array<OrderItemReturnItem>;
  package?: Maybe<Package>;
  packageId?: Maybe<Scalars['Int']['output']>;
  paidDistributor?: Maybe<Scalars['Boolean']['output']>;
  passedFraudCheck?: Maybe<Scalars['Boolean']['output']>;
  pickedBoxAdminId?: Maybe<Scalars['Int']['output']>;
  pickedBoxId?: Maybe<Scalars['String']['output']>;
  pickedBoxOpenAdminId?: Maybe<Scalars['Int']['output']>;
  pickedBoxOpenDate?: Maybe<Scalars['DateTime']['output']>;
  pickedDate?: Maybe<Scalars['DateTime']['output']>;
  price: Scalars['Decimal']['output'];
  product: Product;
  productId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  refundedDate?: Maybe<Scalars['DateTime']['output']>;
  releaseDate?: Maybe<Scalars['DateTime']['output']>;
  returnId?: Maybe<Scalars['Int']['output']>;
  returnInternalNotes?: Maybe<Scalars['String']['output']>;
  returnNotes?: Maybe<Scalars['String']['output']>;
  returnReason?: Maybe<Scalars['Int']['output']>;
  sentByDistributorDate?: Maybe<Scalars['DateTime']['output']>;
  sentToDistributorDate?: Maybe<Scalars['DateTime']['output']>;
  sentToShipperDate?: Maybe<Scalars['DateTime']['output']>;
  stockLocationId?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Decimal']['output']>;
  taxRate?: Maybe<Scalars['Decimal']['output']>;
  toShipperTracking?: Maybe<Scalars['String']['output']>;
  usdPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type OrderItemDto = {
  __typename?: 'OrderItemDto';
  canOrderFromMurphys: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dispatchedDate?: Maybe<Scalars['DateTime']['output']>;
  distributorName?: Maybe<Scalars['String']['output']>;
  exceptionDescription?: Maybe<Scalars['String']['output']>;
  exceptionFixed?: Maybe<Scalars['DateTime']['output']>;
  exceptionType?: Maybe<Scalars['Int']['output']>;
  hasDownloads: Scalars['Boolean']['output'];
  hasInstructions: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  instructionLink?: Maybe<Scalars['String']['output']>;
  licenseCode?: Maybe<Scalars['String']['output']>;
  lineTaxTotal?: Maybe<Scalars['Decimal']['output']>;
  needsShipping: Scalars['Boolean']['output'];
  optionDescription?: Maybe<Scalars['String']['output']>;
  optionId?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<OrderDto>;
  orderId: Scalars['Int']['output'];
  package?: Maybe<PackageDto>;
  priceCharged: Scalars['Decimal']['output'];
  productId: Scalars['Int']['output'];
  productMeta: Array<ProductMetaDto>;
  productName: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  returnId?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Decimal']['output']>;
  taxRate?: Maybe<Scalars['Decimal']['output']>;
  thumbnailSrc?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type OrderItemFilterInput = {
  and?: InputMaybe<Array<OrderItemFilterInput>>;
  associatedOrderItemId?: InputMaybe<IntOperationFilterInput>;
  bundleId?: InputMaybe<IntOperationFilterInput>;
  costToUs?: InputMaybe<DecimalOperationFilterInput>;
  creatorPaymentLogId?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  distributorId?: InputMaybe<IntOperationFilterInput>;
  distributorOrderId?: InputMaybe<StringOperationFilterInput>;
  downloadArchived?: InputMaybe<BooleanOperationFilterInput>;
  exceptionDesc?: InputMaybe<StringOperationFilterInput>;
  exceptionFixed?: InputMaybe<DateTimeOperationFilterInput>;
  exceptionType?: InputMaybe<IntOperationFilterInput>;
  exchangeRate?: InputMaybe<DecimalOperationFilterInput>;
  hideFromCustomer?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  inventoryShelfId?: InputMaybe<IntOperationFilterInput>;
  inventoryTransferId?: InputMaybe<IntOperationFilterInput>;
  itemReturnId?: InputMaybe<IntOperationFilterInput>;
  licenseCode?: InputMaybe<StringOperationFilterInput>;
  lineTaxTotal?: InputMaybe<DecimalOperationFilterInput>;
  listPrice?: InputMaybe<DecimalOperationFilterInput>;
  optionId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<OrderItemFilterInput>>;
  order?: InputMaybe<OrderFilterInput>;
  orderId?: InputMaybe<IntOperationFilterInput>;
  orderItemReturnItems?: InputMaybe<ListFilterInputTypeOfOrderItemReturnItemFilterInput>;
  package?: InputMaybe<PackageFilterInput>;
  packageId?: InputMaybe<IntOperationFilterInput>;
  paidDistributor?: InputMaybe<BooleanOperationFilterInput>;
  passedFraudCheck?: InputMaybe<BooleanOperationFilterInput>;
  pickedBoxAdminId?: InputMaybe<IntOperationFilterInput>;
  pickedBoxId?: InputMaybe<StringOperationFilterInput>;
  pickedBoxOpenAdminId?: InputMaybe<IntOperationFilterInput>;
  pickedBoxOpenDate?: InputMaybe<DateTimeOperationFilterInput>;
  pickedDate?: InputMaybe<DateTimeOperationFilterInput>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  refundedDate?: InputMaybe<DateTimeOperationFilterInput>;
  releaseDate?: InputMaybe<DateTimeOperationFilterInput>;
  returnId?: InputMaybe<IntOperationFilterInput>;
  returnInternalNotes?: InputMaybe<StringOperationFilterInput>;
  returnNotes?: InputMaybe<StringOperationFilterInput>;
  returnReason?: InputMaybe<IntOperationFilterInput>;
  sentByDistributorDate?: InputMaybe<DateTimeOperationFilterInput>;
  sentToDistributorDate?: InputMaybe<DateTimeOperationFilterInput>;
  sentToShipperDate?: InputMaybe<DateTimeOperationFilterInput>;
  stockLocationId?: InputMaybe<IntOperationFilterInput>;
  tax?: InputMaybe<DecimalOperationFilterInput>;
  taxRate?: InputMaybe<DecimalOperationFilterInput>;
  toShipperTracking?: InputMaybe<StringOperationFilterInput>;
  usdPrice?: InputMaybe<DecimalOperationFilterInput>;
};

export type OrderItemReturn = {
  __typename?: 'OrderItemReturn';
  approvedByAdminUserId?: Maybe<Scalars['Int']['output']>;
  customerId: Scalars['Int']['output'];
  dateReceived?: Maybe<Scalars['DateTime']['output']>;
  dateRequested: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  internalNotes?: Maybe<Scalars['String']['output']>;
  labelUrl?: Maybe<Scalars['String']['output']>;
  onHold?: Maybe<Scalars['Boolean']['output']>;
  orderItemReturnItems: Array<OrderItemReturnItem>;
  receivedByAdminUserId?: Maybe<Scalars['Int']['output']>;
  shippingRefundAmount?: Maybe<Scalars['Decimal']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export type OrderItemReturnEligibilityDto = {
  __typename?: 'OrderItemReturnEligibilityDto';
  availableReturnActions: Array<ReturnActionDto>;
  availableReturnReasons: Array<ReturnReasonDto>;
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  returnEligibilityMessage?: Maybe<Scalars['String']['output']>;
};

export type OrderItemReturnFilterInput = {
  and?: InputMaybe<Array<OrderItemReturnFilterInput>>;
  approvedByAdminUserId?: InputMaybe<IntOperationFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  dateReceived?: InputMaybe<DateTimeOperationFilterInput>;
  dateRequested?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  internalNotes?: InputMaybe<StringOperationFilterInput>;
  labelUrl?: InputMaybe<StringOperationFilterInput>;
  onHold?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OrderItemReturnFilterInput>>;
  orderItemReturnItems?: InputMaybe<ListFilterInputTypeOfOrderItemReturnItemFilterInput>;
  receivedByAdminUserId?: InputMaybe<IntOperationFilterInput>;
  shippingRefundAmount?: InputMaybe<DecimalOperationFilterInput>;
  trackingNumber?: InputMaybe<StringOperationFilterInput>;
};

export type OrderItemReturnItem = {
  __typename?: 'OrderItemReturnItem';
  creditNoteId?: Maybe<Scalars['Int']['output']>;
  customerNotes?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image1Filename?: Maybe<Scalars['String']['output']>;
  image2Filename?: Maybe<Scalars['String']['output']>;
  image3Filename?: Maybe<Scalars['String']['output']>;
  internalNotes?: Maybe<Scalars['String']['output']>;
  mmsclaimId?: Maybe<Scalars['Int']['output']>;
  orderItem: OrderItem;
  orderItemId: Scalars['Int']['output'];
  orderItemReturn?: Maybe<OrderItemReturn>;
  orderItemReturnId: Scalars['Int']['output'];
  quantityReturned: Scalars['Int']['output'];
  reason: Scalars['Int']['output'];
  receivedDate?: Maybe<Scalars['DateTime']['output']>;
  refundId?: Maybe<Scalars['Int']['output']>;
  replacementOrder?: Maybe<Order>;
  replacementOrderId?: Maybe<Scalars['Int']['output']>;
  resolvedByAdminUserId?: Maybe<Scalars['Int']['output']>;
  resolvedDate?: Maybe<Scalars['DateTime']['output']>;
  returnAction: Scalars['Int']['output'];
  returnApproved?: Maybe<Scalars['Boolean']['output']>;
  returnProductRequired?: Maybe<Scalars['Boolean']['output']>;
  returnRejectedReason?: Maybe<Scalars['String']['output']>;
  warehouseDisposition?: Maybe<Scalars['Int']['output']>;
};

export type OrderItemReturnItemFilterInput = {
  and?: InputMaybe<Array<OrderItemReturnItemFilterInput>>;
  creditNoteId?: InputMaybe<IntOperationFilterInput>;
  customerNotes?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  image1Filename?: InputMaybe<StringOperationFilterInput>;
  image2Filename?: InputMaybe<StringOperationFilterInput>;
  image3Filename?: InputMaybe<StringOperationFilterInput>;
  internalNotes?: InputMaybe<StringOperationFilterInput>;
  mmsclaimId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<OrderItemReturnItemFilterInput>>;
  orderItem?: InputMaybe<OrderItemFilterInput>;
  orderItemId?: InputMaybe<IntOperationFilterInput>;
  orderItemReturn?: InputMaybe<OrderItemReturnFilterInput>;
  orderItemReturnId?: InputMaybe<IntOperationFilterInput>;
  quantityReturned?: InputMaybe<IntOperationFilterInput>;
  reason?: InputMaybe<IntOperationFilterInput>;
  receivedDate?: InputMaybe<DateTimeOperationFilterInput>;
  refundId?: InputMaybe<IntOperationFilterInput>;
  replacementOrder?: InputMaybe<OrderFilterInput>;
  replacementOrderId?: InputMaybe<IntOperationFilterInput>;
  resolvedByAdminUserId?: InputMaybe<IntOperationFilterInput>;
  resolvedDate?: InputMaybe<DateTimeOperationFilterInput>;
  returnAction?: InputMaybe<IntOperationFilterInput>;
  returnApproved?: InputMaybe<BooleanOperationFilterInput>;
  returnProductRequired?: InputMaybe<BooleanOperationFilterInput>;
  returnRejectedReason?: InputMaybe<StringOperationFilterInput>;
  warehouseDisposition?: InputMaybe<IntOperationFilterInput>;
};

export type OrderStatus = {
  __typename?: 'OrderStatus';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type OrderStatusFilterInput = {
  and?: InputMaybe<Array<OrderStatusFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrderStatusFilterInput>>;
};

export type OrderTaxReconciliationCheckResultDto = {
  __typename?: 'OrderTaxReconciliationCheckResultDto';
  checkedCount: Scalars['Int']['output'];
  rows: Array<OrderTaxReconciliationDto>;
};

export type OrderTaxReconciliationDto = {
  __typename?: 'OrderTaxReconciliationDto';
  appliedAtUtc?: Maybe<Scalars['DateTime']['output']>;
  appliedByAdminUserId?: Maybe<Scalars['Int']['output']>;
  backfillStatus: Scalars['String']['output'];
  brandId?: Maybe<Scalars['Int']['output']>;
  checkedAtUtc: Scalars['DateTime']['output'];
  checkedByAdminUserId?: Maybe<Scalars['Int']['output']>;
  currencyId?: Maybe<Scalars['Int']['output']>;
  dbInvoiceAmount: Scalars['Decimal']['output'];
  difference: Scalars['Decimal']['output'];
  effectiveTaxRate?: Maybe<Scalars['Decimal']['output']>;
  giftVoucherUsed: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  importFee: Scalars['Decimal']['output'];
  itemSubtotal: Scalars['Decimal']['output'];
  itemTax: Scalars['Decimal']['output'];
  items: Array<OrderTaxReconciliationItemDto>;
  orderId: Scalars['Int']['output'];
  orderPaidDate?: Maybe<Scalars['DateTime']['output']>;
  orderTaxCharged: Scalars['Decimal']['output'];
  processorTransactionId?: Maybe<Scalars['String']['output']>;
  recommendation: Scalars['String']['output'];
  reviewNote?: Maybe<Scalars['String']['output']>;
  shipping: Scalars['Decimal']['output'];
  storeCreditUsed: Scalars['Decimal']['output'];
  stripeAmount?: Maybe<Scalars['Decimal']['output']>;
  stripeAmountMinor?: Maybe<Scalars['Long']['output']>;
  stripeCurrency?: Maybe<Scalars['String']['output']>;
  stripeLatestChargeId?: Maybe<Scalars['String']['output']>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  stripeProviderKey?: Maybe<Scalars['String']['output']>;
  stripeStatus?: Maybe<Scalars['String']['output']>;
};

export type OrderTaxReconciliationItemDto = {
  __typename?: 'OrderTaxReconciliationItemDto';
  createdAtUtc: Scalars['DateTime']['output'];
  currentTax?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  isIncludedInBackfill: Scalars['Boolean']['output'];
  lineSubtotal: Scalars['Decimal']['output'];
  optionId?: Maybe<Scalars['Int']['output']>;
  orderId: Scalars['Int']['output'];
  orderItemId: Scalars['Int']['output'];
  price: Scalars['Decimal']['output'];
  productId: Scalars['Int']['output'];
  proposedTax?: Maybe<Scalars['Decimal']['output']>;
  proposedTaxRate?: Maybe<Scalars['Decimal']['output']>;
  quantity: Scalars['Int']['output'];
  reconciliationId: Scalars['Int']['output'];
  refundedDate?: Maybe<Scalars['DateTime']['output']>;
  returnId?: Maybe<Scalars['Int']['output']>;
  reviewNote?: Maybe<Scalars['String']['output']>;
};

export type OrderTimelineItemDto = {
  __typename?: 'OrderTimelineItemDto';
  adminUserName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  linkText?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  note: Scalars['String']['output'];
  noteType: Scalars['String']['output'];
  time: Scalars['DateTime']['output'];
};

/** A segment of a collection. */
export type OrdersCollectionSegment = {
  __typename?: 'OrdersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<OrderDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Package = {
  __typename?: 'Package';
  adminUserId?: Maybe<Scalars['Int']['output']>;
  batchId?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Decimal']['output']>;
  deliveredDate?: Maybe<Scalars['DateTime']['output']>;
  dispatchedDate: Scalars['DateTime']['output'];
  distributorId: Scalars['Int']['output'];
  errorDescription?: Maybe<Scalars['String']['output']>;
  errorReason?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  itemsHash?: Maybe<Scalars['String']['output']>;
  labelPrinted?: Maybe<Scalars['DateTime']['output']>;
  lastCheck?: Maybe<Scalars['DateTime']['output']>;
  manifestId?: Maybe<Scalars['String']['output']>;
  orderItems: Array<OrderItem>;
  serviceLevel?: Maybe<Scalars['String']['output']>;
  shippingMethod?: Maybe<ShippingMethod>;
  shippingMethodId?: Maybe<Scalars['Int']['output']>;
  shippingProvider?: Maybe<Scalars['Int']['output']>;
  shippoId?: Maybe<Scalars['String']['output']>;
  shippoStatus?: Maybe<Scalars['String']['output']>;
  sizeTemplate?: Maybe<Scalars['String']['output']>;
  trackingCode?: Maybe<Scalars['String']['output']>;
  trackingRecords: Array<PackageTracking>;
  weight?: Maybe<Scalars['Decimal']['output']>;
};

export type PackageDto = {
  __typename?: 'PackageDto';
  carrier?: Maybe<CarrierDto>;
  cost?: Maybe<Scalars['Decimal']['output']>;
  deliveredDate?: Maybe<Scalars['DateTime']['output']>;
  dispatchedDate?: Maybe<Scalars['DateTime']['output']>;
  errorDescription?: Maybe<Scalars['String']['output']>;
  estDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  externalTrackingUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isEasyPostShipment: Scalars['Boolean']['output'];
  labelPrinted?: Maybe<Scalars['DateTime']['output']>;
  lastCheck?: Maybe<Scalars['DateTime']['output']>;
  orderItems: Array<OrderItemDto>;
  service?: Maybe<Scalars['String']['output']>;
  shippingMethod?: Maybe<Scalars['String']['output']>;
  signedBy?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['String']['output']>;
  statusDetail?: Maybe<Scalars['String']['output']>;
  statusLabel?: Maybe<Scalars['String']['output']>;
  trackingHistory?: Maybe<Array<TrackingRecordDto>>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingState: Scalars['String']['output'];
  trackingUrl?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Decimal']['output']>;
};

export type PackageFilterInput = {
  adminUserId?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<PackageFilterInput>>;
  batchId?: InputMaybe<StringOperationFilterInput>;
  cost?: InputMaybe<DecimalOperationFilterInput>;
  deliveredDate?: InputMaybe<DateTimeOperationFilterInput>;
  dispatchedDate?: InputMaybe<DateTimeOperationFilterInput>;
  distributorId?: InputMaybe<IntOperationFilterInput>;
  errorDescription?: InputMaybe<StringOperationFilterInput>;
  errorReason?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  itemsHash?: InputMaybe<StringOperationFilterInput>;
  labelPrinted?: InputMaybe<DateTimeOperationFilterInput>;
  lastCheck?: InputMaybe<DateTimeOperationFilterInput>;
  manifestId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PackageFilterInput>>;
  orderItems?: InputMaybe<ListFilterInputTypeOfOrderItemFilterInput>;
  serviceLevel?: InputMaybe<StringOperationFilterInput>;
  shippingMethod?: InputMaybe<ShippingMethodFilterInput>;
  shippingMethodId?: InputMaybe<IntOperationFilterInput>;
  shippingProvider?: InputMaybe<IntOperationFilterInput>;
  shippoId?: InputMaybe<StringOperationFilterInput>;
  shippoStatus?: InputMaybe<StringOperationFilterInput>;
  sizeTemplate?: InputMaybe<StringOperationFilterInput>;
  trackingCode?: InputMaybe<StringOperationFilterInput>;
  trackingRecords?: InputMaybe<ListFilterInputTypeOfPackageTrackingFilterInput>;
  weight?: InputMaybe<DecimalOperationFilterInput>;
};

export type PackageTracking = {
  __typename?: 'PackageTracking';
  city?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  packageId: Scalars['Int']['output'];
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timeUpdated: Scalars['DateTime']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type PackageTrackingFilterInput = {
  and?: InputMaybe<Array<PackageTrackingFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  countryId?: InputMaybe<IntOperationFilterInput>;
  details?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PackageTrackingFilterInput>>;
  packageId?: InputMaybe<IntOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  timeUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  zip?: InputMaybe<StringOperationFilterInput>;
};

/** A segment of a collection. */
export type PagesByCategoryCollectionSegment = {
  __typename?: 'PagesByCategoryCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BlogPostDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type PayPalCheckoutRecoveryStatusDto = {
  __typename?: 'PayPalCheckoutRecoveryStatusDto';
  canRetry: Scalars['Boolean']['output'];
  captureId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  paymentSucceeded: Scalars['Boolean']['output'];
  paypalOrderId: Scalars['String']['output'];
  shoppingCartId?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
};

export type PaypalOrderDto = {
  __typename?: 'PaypalOrderDto';
  paypalOrderId: Scalars['String']['output'];
};

export type PlayingCardManufacturer = {
  __typename?: 'PlayingCardManufacturer';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  urlStub: Scalars['String']['output'];
};

/** A segment of a collection. */
export type PlayingCardsCollectionSegment = {
  __typename?: 'PlayingCardsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EcommProductDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProcessCreatorPaymentsResultDto = {
  __typename?: 'ProcessCreatorPaymentsResultDto';
  message?: Maybe<Scalars['String']['output']>;
  method: Scalars['Int']['output'];
  methodDescription: Scalars['String']['output'];
  paymentsMarkedPaid: Scalars['Int']['output'];
  paymentsProcessed: Scalars['Int']['output'];
  paypalItemsQueued: Scalars['Int']['output'];
  paypalPayoutSent: Scalars['Boolean']['output'];
  statementsSent: Scalars['Int']['output'];
  totalAmount: Scalars['Decimal']['output'];
};

export type Product = {
  __typename?: 'Product';
  alwaysPay?: Maybe<Scalars['Boolean']['output']>;
  caseQuantity?: Maybe<Scalars['Int']['output']>;
  categories: Array<Category>;
  checkedByAdminId?: Maybe<Scalars['Int']['output']>;
  childProducts: Array<Product>;
  componentParentProductId?: Maybe<Scalars['Int']['output']>;
  creators: Array<Creator>;
  creatorsHTML?: Maybe<Scalars['String']['output']>;
  creatorsText?: Maybe<Scalars['String']['output']>;
  dateAdded: Scalars['DateTime']['output'];
  difficulty?: Maybe<Scalars['Int']['output']>;
  discontinued?: Maybe<Scalars['Boolean']['output']>;
  discountAllowed?: Maybe<Scalars['Boolean']['output']>;
  discountedPrice?: Maybe<Scalars['Decimal']['output']>;
  distributor: Distributor;
  distributorId: Scalars['Int']['output'];
  distributorProductId?: Maybe<Scalars['String']['output']>;
  distributorVideo?: Maybe<Scalars['String']['output']>;
  downloadFiles: Array<DownloadFile>;
  downloadPath: Scalars['String']['output'];
  exclusive: Scalars['Boolean']['output'];
  explanationDownloadId?: Maybe<Scalars['Int']['output']>;
  explanationPassword?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  freeInternationalShipping?: Maybe<Scalars['Boolean']['output']>;
  hazardous?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['Decimal']['output']>;
  htmlDescription: Scalars['String']['output'];
  htsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  inappPurchaseTier?: Maybe<Scalars['Int']['output']>;
  intro?: Maybe<Scalars['String']['output']>;
  isParent?: Maybe<Scalars['Boolean']['output']>;
  isPreorder?: Maybe<Scalars['Boolean']['output']>;
  lectureSeasonPassId?: Maybe<Scalars['Int']['output']>;
  lectureTime?: Maybe<Scalars['DateTime']['output']>;
  length?: Maybe<Scalars['Decimal']['output']>;
  live: Scalars['Boolean']['output'];
  manufacturer?: Maybe<Manufacturer>;
  manufacturerId: Scalars['Int']['output'];
  membersPrice?: Maybe<Scalars['Decimal']['output']>;
  name: Scalars['String']['output'];
  numberInStock: Scalars['Int']['output'];
  orderItems: Array<OrderItem>;
  pageThumbnails?: Maybe<Scalars['Int']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  parentProduct?: Maybe<Product>;
  payCreatorId?: Maybe<Scalars['Int']['output']>;
  payPerUnit?: Maybe<Scalars['Decimal']['output']>;
  payPercent?: Maybe<Scalars['Int']['output']>;
  percentageToCreator?: Maybe<Scalars['Int']['output']>;
  preorderRelease?: Maybe<Scalars['DateTime']['output']>;
  price: Scalars['Decimal']['output'];
  productBrandLinks: Array<ProductBrandLink>;
  productImages: Array<ProductImage>;
  productListItems: Array<ProductListItem>;
  productMeta: Array<ProductMeta>;
  productOptions: Array<ProductOption>;
  productPrices: Array<ProductPrice>;
  productTrailers: Array<ProductTrailer>;
  productType: ProductType;
  productTypeId: Scalars['Int']['output'];
  questions: Array<ProductQuestion>;
  reviewerId?: Maybe<Scalars['Int']['output']>;
  reviews: Array<CustomerReview>;
  salesRank?: Maybe<Scalars['Int']['output']>;
  shoppingCartItems: Array<ShoppingCartItem>;
  showCreatorLog?: Maybe<Scalars['Boolean']['output']>;
  stockCachedTime?: Maybe<Scalars['DateTime']['output']>;
  stockLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  stockNotes?: Maybe<Scalars['String']['output']>;
  textDescription?: Maybe<Scalars['String']['output']>;
  thumbnailPath: Scalars['String']['output'];
  urlStub: Scalars['String']['output'];
  video2Type?: Maybe<Scalars['Int']['output']>;
  videoReviewDuration?: Maybe<Scalars['Int']['output']>;
  videoReviewPath?: Maybe<Scalars['String']['output']>;
  vimeoId?: Maybe<Scalars['String']['output']>;
  vimeoId2?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Decimal']['output']>;
  wholesale?: Maybe<Scalars['Boolean']['output']>;
  width?: Maybe<Scalars['Decimal']['output']>;
  wishlistItems: Array<WishlistItem>;
};

export type ProductAmountOwedDto = {
  __typename?: 'ProductAmountOwedDto';
  amount: Scalars['Decimal']['output'];
  isDownload: Scalars['Boolean']['output'];
  isGrossPayment: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  optionDescription?: Maybe<Scalars['String']['output']>;
  optionId?: Maybe<Scalars['Int']['output']>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productUrlStub?: Maybe<Scalars['String']['output']>;
  retailAmount: Scalars['Decimal']['output'];
  retailSalesCount: Scalars['Int']['output'];
  salesCount: Scalars['Int']['output'];
  shipping: Scalars['Decimal']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  total: Scalars['Decimal']['output'];
  wholesaleAmount: Scalars['Decimal']['output'];
  wholesaleSalesCount: Scalars['Int']['output'];
};

export type ProductBrandLink = {
  __typename?: 'ProductBrandLink';
  brand: Brand;
  brandId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionLastEdit?: Maybe<Scalars['DateTime']['output']>;
  descriptionMarkdown?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  intro?: Maybe<Scalars['String']['output']>;
  product: Product;
  productId: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  urlSlug?: Maybe<Scalars['String']['output']>;
};

export type ProductBrandLinkDto = {
  __typename?: 'ProductBrandLinkDto';
  brandId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionMarkdown?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  textBlurb?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ProductBrandLinkFilterInput = {
  and?: InputMaybe<Array<ProductBrandLinkFilterInput>>;
  brand?: InputMaybe<BrandFilterInput>;
  brandId?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  descriptionLastEdit?: InputMaybe<DateTimeOperationFilterInput>;
  descriptionMarkdown?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  intro?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductBrandLinkFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
  urlSlug?: InputMaybe<StringOperationFilterInput>;
};

export type ProductByCategoryFilter = {
  and?: InputMaybe<Array<ProductByCategoryFilter>>;
  excludeFree?: InputMaybe<BooleanOperationFilterInput>;
  live?: InputMaybe<BooleanOperationFilterInput>;
  manufacturerId?: InputMaybe<IntOperationFilterInput>;
  onSale?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ProductByCategoryFilter>>;
  vanishingIncExclusive?: InputMaybe<BooleanOperationFilterInput>;
};

export type ProductByCategorySort = {
  biggestDiscountPercentage?: InputMaybe<SortEnumType>;
  currencySymbol?: InputMaybe<SortEnumType>;
  dateAdded?: InputMaybe<SortEnumType>;
  discontinued?: InputMaybe<SortEnumType>;
  discountedDisplayPrice?: InputMaybe<SortEnumType>;
  displayPrice?: InputMaybe<SortEnumType>;
  ebookBundleOption?: InputMaybe<EbookBundleOptionDtoSortInput>;
  hasDownloads?: InputMaybe<SortEnumType>;
  hidePrice?: InputMaybe<SortEnumType>;
  inStock?: InputMaybe<SortEnumType>;
  isParent?: InputMaybe<SortEnumType>;
  isPreorder?: InputMaybe<SortEnumType>;
  live?: InputMaybe<SortEnumType>;
  manufacturerId?: InputMaybe<SortEnumType>;
  murphysProductId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  needsShipping?: InputMaybe<SortEnumType>;
  positionInList?: InputMaybe<SortEnumType>;
  preorderRelease?: InputMaybe<SortEnumType>;
  productTypeId?: InputMaybe<SortEnumType>;
  rating?: InputMaybe<SortEnumType>;
  restockDateDisplay?: InputMaybe<SortEnumType>;
  salesRank?: InputMaybe<SortEnumType>;
  stockLocationIdsKey?: InputMaybe<SortEnumType>;
  stockMessage?: InputMaybe<SortEnumType>;
  stockResolved?: InputMaybe<SortEnumType>;
};

export type ProductDto = {
  __typename?: 'ProductDto';
  creatorDisplayName?: Maybe<Scalars['String']['output']>;
  dateAdded: Scalars['DateTime']['output'];
  distributorProductId?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  height?: Maybe<Scalars['Decimal']['output']>;
  htsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  length?: Maybe<Scalars['Decimal']['output']>;
  live: Scalars['Boolean']['output'];
  manufacturer?: Maybe<PlayingCardManufacturer>;
  name?: Maybe<Scalars['String']['output']>;
  options: Array<ProductOptionDto>;
  parentId?: Maybe<Scalars['Int']['output']>;
  productType: ProductTypeDto;
  thumbnails?: Maybe<ProductThumbnailsDto>;
  urlStub: Scalars['String']['output'];
  weight?: Maybe<Scalars['Decimal']['output']>;
  width?: Maybe<Scalars['Decimal']['output']>;
};

export type ProductDtoFilterInput = {
  and?: InputMaybe<Array<ProductDtoFilterInput>>;
  creatorDisplayName?: InputMaybe<StringOperationFilterInput>;
  dateAdded?: InputMaybe<DateTimeOperationFilterInput>;
  distributorProductId?: InputMaybe<StringOperationFilterInput>;
  featured?: InputMaybe<BooleanOperationFilterInput>;
  height?: InputMaybe<DecimalOperationFilterInput>;
  htsCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  length?: InputMaybe<DecimalOperationFilterInput>;
  live?: InputMaybe<BooleanOperationFilterInput>;
  manufacturer?: InputMaybe<ManufacturerDtoFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  options?: InputMaybe<ListFilterInputTypeOfProductOptionDtoFilterInput>;
  or?: InputMaybe<Array<ProductDtoFilterInput>>;
  parentId?: InputMaybe<IntOperationFilterInput>;
  productType?: InputMaybe<ProductTypeDtoFilterInput>;
  thumbnails?: InputMaybe<ProductThumbnailsDtoFilterInput>;
  urlStub?: InputMaybe<StringOperationFilterInput>;
  weight?: InputMaybe<DecimalOperationFilterInput>;
  width?: InputMaybe<DecimalOperationFilterInput>;
};

export type ProductDtoSortInput = {
  creatorDisplayName?: InputMaybe<SortEnumType>;
  dateAdded?: InputMaybe<SortEnumType>;
  distributorProductId?: InputMaybe<SortEnumType>;
  featured?: InputMaybe<SortEnumType>;
  height?: InputMaybe<SortEnumType>;
  htsCode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  length?: InputMaybe<SortEnumType>;
  live?: InputMaybe<SortEnumType>;
  manufacturer?: InputMaybe<ManufacturerDtoSortInput>;
  name?: InputMaybe<SortEnumType>;
  parentId?: InputMaybe<SortEnumType>;
  productType?: InputMaybe<ProductTypeDtoSortInput>;
  thumbnails?: InputMaybe<ProductThumbnailsDtoSortInput>;
  urlStub?: InputMaybe<SortEnumType>;
  weight?: InputMaybe<SortEnumType>;
  width?: InputMaybe<SortEnumType>;
};

export type ProductFilterInput = {
  alwaysPay?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ProductFilterInput>>;
  caseQuantity?: InputMaybe<IntOperationFilterInput>;
  categories?: InputMaybe<ListFilterInputTypeOfCategoryFilterInput>;
  checkedByAdminId?: InputMaybe<IntOperationFilterInput>;
  childProducts?: InputMaybe<ListFilterInputTypeOfProductFilterInput>;
  componentParentProductId?: InputMaybe<IntOperationFilterInput>;
  creators?: InputMaybe<ListFilterInputTypeOfCreatorFilterInput>;
  creatorsHTML?: InputMaybe<StringOperationFilterInput>;
  creatorsText?: InputMaybe<StringOperationFilterInput>;
  dateAdded?: InputMaybe<DateTimeOperationFilterInput>;
  difficulty?: InputMaybe<IntOperationFilterInput>;
  discontinued?: InputMaybe<BooleanOperationFilterInput>;
  discountAllowed?: InputMaybe<BooleanOperationFilterInput>;
  discountedPrice?: InputMaybe<DecimalOperationFilterInput>;
  distributor?: InputMaybe<DistributorFilterInput>;
  distributorId?: InputMaybe<IntOperationFilterInput>;
  distributorProductId?: InputMaybe<StringOperationFilterInput>;
  distributorVideo?: InputMaybe<StringOperationFilterInput>;
  downloadFiles?: InputMaybe<ListFilterInputTypeOfDownloadFileFilterInput>;
  downloadPath?: InputMaybe<StringOperationFilterInput>;
  exclusive?: InputMaybe<BooleanOperationFilterInput>;
  explanationDownloadId?: InputMaybe<IntOperationFilterInput>;
  explanationPassword?: InputMaybe<StringOperationFilterInput>;
  featured?: InputMaybe<BooleanOperationFilterInput>;
  freeInternationalShipping?: InputMaybe<BooleanOperationFilterInput>;
  hazardous?: InputMaybe<BooleanOperationFilterInput>;
  height?: InputMaybe<DecimalOperationFilterInput>;
  htmlDescription?: InputMaybe<StringOperationFilterInput>;
  htsCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  inappPurchaseTier?: InputMaybe<IntOperationFilterInput>;
  intro?: InputMaybe<StringOperationFilterInput>;
  isParent?: InputMaybe<BooleanOperationFilterInput>;
  isPreorder?: InputMaybe<BooleanOperationFilterInput>;
  lectureSeasonPassId?: InputMaybe<IntOperationFilterInput>;
  lectureTime?: InputMaybe<DateTimeOperationFilterInput>;
  length?: InputMaybe<DecimalOperationFilterInput>;
  live?: InputMaybe<BooleanOperationFilterInput>;
  manufacturer?: InputMaybe<ManufacturerFilterInput>;
  manufacturerId?: InputMaybe<IntOperationFilterInput>;
  membersPrice?: InputMaybe<DecimalOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  numberInStock?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductFilterInput>>;
  orderItems?: InputMaybe<ListFilterInputTypeOfOrderItemFilterInput>;
  pageThumbnails?: InputMaybe<IntOperationFilterInput>;
  parentId?: InputMaybe<IntOperationFilterInput>;
  parentProduct?: InputMaybe<ProductFilterInput>;
  payCreatorId?: InputMaybe<IntOperationFilterInput>;
  payPerUnit?: InputMaybe<DecimalOperationFilterInput>;
  payPercent?: InputMaybe<IntOperationFilterInput>;
  percentageToCreator?: InputMaybe<IntOperationFilterInput>;
  preorderRelease?: InputMaybe<DateTimeOperationFilterInput>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  productBrandLinks?: InputMaybe<ListFilterInputTypeOfProductBrandLinkFilterInput>;
  productImages?: InputMaybe<ListFilterInputTypeOfProductImageFilterInput>;
  productListItems?: InputMaybe<ListFilterInputTypeOfProductListItemFilterInput>;
  productMeta?: InputMaybe<ListFilterInputTypeOfProductMetaFilterInput>;
  productOptions?: InputMaybe<ListFilterInputTypeOfProductOptionFilterInput>;
  productPrices?: InputMaybe<ListFilterInputTypeOfProductPriceFilterInput>;
  productTrailers?: InputMaybe<ListFilterInputTypeOfProductTrailerFilterInput>;
  productType?: InputMaybe<ProductTypeFilterInput>;
  productTypeId?: InputMaybe<IntOperationFilterInput>;
  questions?: InputMaybe<ListFilterInputTypeOfProductQuestionFilterInput>;
  reviewerId?: InputMaybe<IntOperationFilterInput>;
  reviews?: InputMaybe<ListFilterInputTypeOfCustomerReviewFilterInput>;
  salesRank?: InputMaybe<IntOperationFilterInput>;
  shoppingCartItems?: InputMaybe<ListFilterInputTypeOfShoppingCartItemFilterInput>;
  showCreatorLog?: InputMaybe<BooleanOperationFilterInput>;
  stockCachedTime?: InputMaybe<DateTimeOperationFilterInput>;
  stockLastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  stockNotes?: InputMaybe<StringOperationFilterInput>;
  textDescription?: InputMaybe<StringOperationFilterInput>;
  thumbnailPath?: InputMaybe<StringOperationFilterInput>;
  urlStub?: InputMaybe<StringOperationFilterInput>;
  video2Type?: InputMaybe<IntOperationFilterInput>;
  videoReviewDuration?: InputMaybe<IntOperationFilterInput>;
  videoReviewPath?: InputMaybe<StringOperationFilterInput>;
  vimeoId?: InputMaybe<StringOperationFilterInput>;
  vimeoId2?: InputMaybe<StringOperationFilterInput>;
  weight?: InputMaybe<DecimalOperationFilterInput>;
  wholesale?: InputMaybe<BooleanOperationFilterInput>;
  width?: InputMaybe<DecimalOperationFilterInput>;
  wishlistItems?: InputMaybe<ListFilterInputTypeOfWishlistItemFilterInput>;
};

export type ProductForDiscoverieDto = {
  __typename?: 'ProductForDiscoverieDto';
  hasPurchased: Scalars['Boolean']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  price: Scalars['Decimal']['output'];
  productUrl: Scalars['String']['output'];
};

export type ProductImage = {
  __typename?: 'ProductImage';
  dateAdded: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isPrimary: Scalars['Boolean']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  product: Product;
  productId: Scalars['Int']['output'];
  src: Scalars['String']['output'];
};

export type ProductImageDto = {
  __typename?: 'ProductImageDto';
  id: Scalars['Int']['output'];
  isPrimary: Scalars['Boolean']['output'];
  src?: Maybe<Scalars['String']['output']>;
};

export type ProductImageFilterInput = {
  and?: InputMaybe<Array<ProductImageFilterInput>>;
  dateAdded?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isPrimary?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ProductImageFilterInput>>;
  position?: InputMaybe<IntOperationFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  src?: InputMaybe<StringOperationFilterInput>;
};

export type ProductInAppPurchaseAppleReadbackDto = {
  __typename?: 'ProductInAppPurchaseAppleReadbackDto';
  appleInAppPurchaseId?: Maybe<Scalars['String']['output']>;
  hasAvailability: Scalars['Boolean']['output'];
  hasLocalization: Scalars['Boolean']['output'];
  hasPriceSchedule: Scalars['Boolean']['output'];
  hasReviewScreenshot: Scalars['Boolean']['output'];
  localizationStates: Array<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type ProductInAppPurchaseSubmissionPlan = {
  __typename?: 'ProductInAppPurchaseSubmissionPlan';
  appleProductId: Scalars['String']['output'];
  baseTerritory: Scalars['String']['output'];
  inAppPurchaseType: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  localizationDescription: Scalars['String']['output'];
  localizationName: Scalars['String']['output'];
  productHasDownload: Scalars['Boolean']['output'];
  productId: Scalars['Int']['output'];
  productIsLive: Scalars['Boolean']['output'];
  productIsVanishingInc: Scalars['Boolean']['output'];
  productName: Scalars['String']['output'];
  referenceName: Scalars['String']['output'];
  reviewNote: Scalars['String']['output'];
  reviewScreenshotPath?: Maybe<Scalars['String']['output']>;
  usdPrice: Scalars['Decimal']['output'];
};

export type ProductInAppPurchaseSubmissionResultDto = {
  __typename?: 'ProductInAppPurchaseSubmissionResultDto';
  alreadyExists: Scalars['Boolean']['output'];
  appleInAppPurchaseId?: Maybe<Scalars['String']['output']>;
  appleReadback?: Maybe<ProductInAppPurchaseAppleReadbackDto>;
  appleReadbackVerified: Scalars['Boolean']['output'];
  appleState?: Maybe<Scalars['String']['output']>;
  created: Scalars['Boolean']['output'];
  errors: Array<Scalars['String']['output']>;
  inAppPurchaseTierUpdated: Scalars['Boolean']['output'];
  messages: Array<Scalars['String']['output']>;
  metadataUpdated: Scalars['Boolean']['output'];
  plan?: Maybe<ProductInAppPurchaseSubmissionPlan>;
  productId: Scalars['Int']['output'];
  submittedForReview: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type ProductInstructionDto = {
  __typename?: 'ProductInstructionDto';
  id?: Maybe<Scalars['Int']['output']>;
  instructionLink?: Maybe<Scalars['String']['output']>;
  isManuallyAdded: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  purchasedDate?: Maybe<Scalars['DateTime']['output']>;
  thumbnailSrc?: Maybe<Scalars['String']['output']>;
};

export type ProductInstructionDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  instructionLink?: InputMaybe<SortEnumType>;
  isManuallyAdded?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  password?: InputMaybe<SortEnumType>;
  productId?: InputMaybe<SortEnumType>;
  purchasedDate?: InputMaybe<SortEnumType>;
  thumbnailSrc?: InputMaybe<SortEnumType>;
};

export type ProductList = {
  __typename?: 'ProductList';
  customPagePath?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  introduction?: Maybe<Scalars['String']['output']>;
  live: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  productListItems: Array<ProductListItem>;
  showVideo?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  urlStub: Scalars['String']['output'];
};

export type ProductListCardDto = {
  __typename?: 'ProductListCardDto';
  creatorDisplayName?: Maybe<Scalars['String']['output']>;
  dateAdded: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  imageSrc?: Maybe<Scalars['String']['output']>;
  lectureMonth?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  positionInList?: Maybe<Scalars['Int']['output']>;
  thumbnailSrc?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ProductListCardSort = {
  dateAdded?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  positionInList?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type ProductListCardsByProductListSlugCollectionSegment = {
  __typename?: 'ProductListCardsByProductListSlugCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ProductListCardDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductListDto = {
  __typename?: 'ProductListDto';
  id: Scalars['Int']['output'];
  introduction?: Maybe<Scalars['String']['output']>;
  live: Scalars['Boolean']['output'];
  templateKey?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  urlStub: Scalars['String']['output'];
};

export type ProductListFilterInput = {
  and?: InputMaybe<Array<ProductListFilterInput>>;
  customPagePath?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  introduction?: InputMaybe<StringOperationFilterInput>;
  live?: InputMaybe<BooleanOperationFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductListFilterInput>>;
  productListItems?: InputMaybe<ListFilterInputTypeOfProductListItemFilterInput>;
  showVideo?: InputMaybe<BooleanOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  urlStub?: InputMaybe<StringOperationFilterInput>;
};

export type ProductListItem = {
  __typename?: 'ProductListItem';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  listPrice?: Maybe<Scalars['Decimal']['output']>;
  positionInList?: Maybe<Scalars['Int']['output']>;
  product: Product;
  productId: Scalars['Int']['output'];
  productIntro?: Maybe<Scalars['String']['output']>;
  productList: ProductList;
  productListId: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductListItemDto = {
  __typename?: 'ProductListItemDto';
  creatorDisplayName?: Maybe<Scalars['String']['output']>;
  dateAdded: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  rating: Scalars['Float']['output'];
  thumbnailSrc?: Maybe<Scalars['String']['output']>;
  urlStub?: Maybe<Scalars['String']['output']>;
};

export type ProductListItemDtoFilterInput = {
  and?: InputMaybe<Array<ProductListItemDtoFilterInput>>;
  creatorDisplayName?: InputMaybe<StringOperationFilterInput>;
  dateAdded?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductListItemDtoFilterInput>>;
  rating?: InputMaybe<FloatOperationFilterInput>;
  thumbnailSrc?: InputMaybe<StringOperationFilterInput>;
  urlStub?: InputMaybe<StringOperationFilterInput>;
};

export type ProductListItemDtoSortInput = {
  dateAdded?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  rating?: InputMaybe<SortEnumType>;
};

export type ProductListItemFilterInput = {
  and?: InputMaybe<Array<ProductListItemFilterInput>>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  listPrice?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<ProductListItemFilterInput>>;
  positionInList?: InputMaybe<IntOperationFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  productIntro?: InputMaybe<StringOperationFilterInput>;
  productList?: InputMaybe<ProductListFilterInput>;
  productListId?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ProductLiveChatMessageDto = {
  __typename?: 'ProductLiveChatMessageDto';
  customerId: Scalars['Int']['output'];
  customerName: Scalars['String']['output'];
  gravatarUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAdminStaff: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  productId: Scalars['Int']['output'];
  timePosted: Scalars['DateTime']['output'];
};

export type ProductMeta = {
  __typename?: 'ProductMeta';
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  product: Product;
  productId: Scalars['Int']['output'];
  productOptionId?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type ProductMetaDto = {
  __typename?: 'ProductMetaDto';
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProductMetaFilterInput = {
  and?: InputMaybe<Array<ProductMetaFilterInput>>;
  dateUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductMetaFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  productOptionId?: InputMaybe<IntOperationFilterInput>;
  source?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type ProductOption = {
  __typename?: 'ProductOption';
  description: Scalars['String']['output'];
  distributorId?: Maybe<Scalars['String']['output']>;
  hasDownload?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  live?: Maybe<Scalars['Boolean']['output']>;
  position: Scalars['Int']['output'];
  price?: Maybe<Scalars['Decimal']['output']>;
  productId: Scalars['Int']['output'];
  productType?: Maybe<ProductType>;
  productTypeId?: Maybe<Scalars['Int']['output']>;
  stock?: Maybe<Scalars['Int']['output']>;
  stockLastUpdated?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductOptionDto = {
  __typename?: 'ProductOptionDto';
  currency?: Maybe<CurrencyDto>;
  currencyId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  distributorId?: Maybe<Scalars['String']['output']>;
  hasDownloads: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  inStock: Scalars['Boolean']['output'];
  maxQuantity?: Maybe<Scalars['Int']['output']>;
  murphysProductId?: Maybe<Scalars['String']['output']>;
  needsShipping: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
  price: Scalars['Decimal']['output'];
  priceIncVat?: Maybe<Scalars['Decimal']['output']>;
  productId: Scalars['Int']['output'];
  productType?: Maybe<ProductTypeDto>;
  salePrice?: Maybe<Scalars['Decimal']['output']>;
  salePriceIncVat?: Maybe<Scalars['Decimal']['output']>;
  taxType?: Maybe<Scalars['Int']['output']>;
  viPoints: Scalars['Int']['output'];
};

export type ProductOptionDtoFilterInput = {
  and?: InputMaybe<Array<ProductOptionDtoFilterInput>>;
  currency?: InputMaybe<CurrencyDtoFilterInput>;
  currencyId?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  distributorId?: InputMaybe<StringOperationFilterInput>;
  hasDownloads?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  inStock?: InputMaybe<BooleanOperationFilterInput>;
  maxQuantity?: InputMaybe<IntOperationFilterInput>;
  murphysProductId?: InputMaybe<StringOperationFilterInput>;
  needsShipping?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ProductOptionDtoFilterInput>>;
  position?: InputMaybe<IntOperationFilterInput>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  priceIncVat?: InputMaybe<DecimalOperationFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  productType?: InputMaybe<ProductTypeDtoFilterInput>;
  salePrice?: InputMaybe<DecimalOperationFilterInput>;
  salePriceIncVat?: InputMaybe<DecimalOperationFilterInput>;
  stockLocationIdsKey?: InputMaybe<StringOperationFilterInput>;
  stockResolved?: InputMaybe<BooleanOperationFilterInput>;
  taxType?: InputMaybe<IntOperationFilterInput>;
  viPoints?: InputMaybe<IntOperationFilterInput>;
};

export type ProductOptionFilterInput = {
  and?: InputMaybe<Array<ProductOptionFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  distributorId?: InputMaybe<StringOperationFilterInput>;
  hasDownload?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  live?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ProductOptionFilterInput>>;
  position?: InputMaybe<IntOperationFilterInput>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  productType?: InputMaybe<ProductTypeFilterInput>;
  productTypeId?: InputMaybe<IntOperationFilterInput>;
  stock?: InputMaybe<IntOperationFilterInput>;
  stockLastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  clearancePrice?: Maybe<Scalars['Decimal']['output']>;
  clearanceStockFloor?: Maybe<Scalars['Int']['output']>;
  currency: Currency;
  currencyId: Scalars['Int']['output'];
  discountedPrice?: Maybe<Scalars['Decimal']['output']>;
  dynamicPrice?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  maxQuantity?: Maybe<Scalars['Int']['output']>;
  minQuantity?: Maybe<Scalars['Int']['output']>;
  permanentDiscount?: Maybe<Scalars['Decimal']['output']>;
  price: Scalars['Decimal']['output'];
  productId: Scalars['Int']['output'];
  productOption?: Maybe<ProductOption>;
  productOptionId?: Maybe<Scalars['Int']['output']>;
  taxType?: Maybe<Scalars['Int']['output']>;
};

export type ProductPriceFilterInput = {
  and?: InputMaybe<Array<ProductPriceFilterInput>>;
  clearancePrice?: InputMaybe<DecimalOperationFilterInput>;
  clearanceStockFloor?: InputMaybe<IntOperationFilterInput>;
  currency?: InputMaybe<CurrencyFilterInput>;
  currencyId?: InputMaybe<IntOperationFilterInput>;
  discountedPrice?: InputMaybe<DecimalOperationFilterInput>;
  dynamicPrice?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  maxQuantity?: InputMaybe<IntOperationFilterInput>;
  minQuantity?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductPriceFilterInput>>;
  permanentDiscount?: InputMaybe<DecimalOperationFilterInput>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  productOption?: InputMaybe<ProductOptionFilterInput>;
  productOptionId?: InputMaybe<IntOperationFilterInput>;
  taxType?: InputMaybe<IntOperationFilterInput>;
};

export type ProductQuestion = {
  __typename?: 'ProductQuestion';
  comment: Scalars['String']['output'];
  customer?: Maybe<Customer>;
  customerId: Scalars['Int']['output'];
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  postPurchase?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<Product>;
  productId: Scalars['Int']['output'];
  responseTo?: Maybe<Scalars['Int']['output']>;
  time: Scalars['DateTime']['output'];
  upvotes?: Maybe<Scalars['Int']['output']>;
};

export type ProductQuestionFilterInput = {
  and?: InputMaybe<Array<ProductQuestionFilterInput>>;
  comment?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  hidden?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProductQuestionFilterInput>>;
  postPurchase?: InputMaybe<BooleanOperationFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  responseTo?: InputMaybe<IntOperationFilterInput>;
  time?: InputMaybe<DateTimeOperationFilterInput>;
  upvotes?: InputMaybe<IntOperationFilterInput>;
};

/** A segment of a collection. */
export type ProductQuestionsCollectionSegment = {
  __typename?: 'ProductQuestionsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<QuestionDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
};

export type ProductThumbnailsDto = {
  __typename?: 'ProductThumbnailsDto';
  carousel?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['String']['output']>;
  sidebar?: Maybe<Scalars['String']['output']>;
  square?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Scalars['String']['output']>;
};

export type ProductThumbnailsDtoFilterInput = {
  and?: InputMaybe<Array<ProductThumbnailsDtoFilterInput>>;
  carousel?: InputMaybe<StringOperationFilterInput>;
  default?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductThumbnailsDtoFilterInput>>;
  sidebar?: InputMaybe<StringOperationFilterInput>;
  square?: InputMaybe<StringOperationFilterInput>;
  video?: InputMaybe<StringOperationFilterInput>;
};

export type ProductThumbnailsDtoSortInput = {
  carousel?: InputMaybe<SortEnumType>;
  default?: InputMaybe<SortEnumType>;
  sidebar?: InputMaybe<SortEnumType>;
  square?: InputMaybe<SortEnumType>;
  video?: InputMaybe<SortEnumType>;
};

export type ProductTrailer = {
  __typename?: 'ProductTrailer';
  addedThumbnail?: Maybe<Scalars['Boolean']['output']>;
  bunnyId?: Maybe<Scalars['String']['output']>;
  bunnyStatus?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  importCompletedTime?: Maybe<Scalars['DateTime']['output']>;
  importUrl?: Maybe<Scalars['String']['output']>;
  originalVimeoId?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  product: Product;
  productId: Scalars['Int']['output'];
  s3filename?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uploadTime?: Maybe<Scalars['DateTime']['output']>;
  videoSource?: Maybe<Scalars['String']['output']>;
  videoType: Scalars['Int']['output'];
};

export type ProductTrailerDto = {
  __typename?: 'ProductTrailerDto';
  bunnyId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type ProductTrailerFilterInput = {
  addedThumbnail?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ProductTrailerFilterInput>>;
  bunnyId?: InputMaybe<StringOperationFilterInput>;
  bunnyStatus?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  importCompletedTime?: InputMaybe<DateTimeOperationFilterInput>;
  importUrl?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductTrailerFilterInput>>;
  originalVimeoId?: InputMaybe<StringOperationFilterInput>;
  position?: InputMaybe<IntOperationFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  s3filename?: InputMaybe<StringOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  uploadTime?: InputMaybe<DateTimeOperationFilterInput>;
  videoSource?: InputMaybe<StringOperationFilterInput>;
  videoType?: InputMaybe<IntOperationFilterInput>;
};

export type ProductType = {
  __typename?: 'ProductType';
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  htsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isDownload: Scalars['Boolean']['output'];
  mediaMailEligible: Scalars['Boolean']['output'];
  needsShipping: Scalars['Boolean']['output'];
  ustaxCode?: Maybe<Scalars['String']['output']>;
};

export type ProductTypeDto = {
  __typename?: 'ProductTypeDto';
  id: Scalars['Int']['output'];
  isDownload: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  needsShipping: Scalars['Boolean']['output'];
};

export type ProductTypeDtoFilterInput = {
  and?: InputMaybe<Array<ProductTypeDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  isDownload?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  needsShipping?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ProductTypeDtoFilterInput>>;
};

export type ProductTypeDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  isDownload?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  needsShipping?: InputMaybe<SortEnumType>;
};

export type ProductTypeFilterInput = {
  and?: InputMaybe<Array<ProductTypeFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  displayName?: InputMaybe<StringOperationFilterInput>;
  htsCode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isDownload?: InputMaybe<BooleanOperationFilterInput>;
  mediaMailEligible?: InputMaybe<BooleanOperationFilterInput>;
  needsShipping?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ProductTypeFilterInput>>;
  ustaxCode?: InputMaybe<StringOperationFilterInput>;
};

/** A segment of a collection. */
export type ProductsByCategorySlugCollectionSegment = {
  __typename?: 'ProductsByCategorySlugCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EcommProductDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ProductsByCategorySlugCommercialCollectionSegment = {
  __typename?: 'ProductsByCategorySlugCommercialCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EcommProductDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ProductsByCreatorSlugCollectionSegment = {
  __typename?: 'ProductsByCreatorSlugCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EcommProductDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ProductsByProductListIdCollectionSegment = {
  __typename?: 'ProductsByProductListIdCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EcommProductDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ProductsByProductListSlugCollectionSegment = {
  __typename?: 'ProductsByProductListSlugCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EcommProductDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductsByProductListSort = {
  dateAdded?: InputMaybe<SortEnumType>;
  positionInList?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type ProductsCollectionSegment = {
  __typename?: 'ProductsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ProductDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductsSort = {
  biggestDiscountPercentage?: InputMaybe<SortEnumType>;
  dateAdded?: InputMaybe<SortEnumType>;
  displayPrice?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  rating?: InputMaybe<SortEnumType>;
  salesRank?: InputMaybe<SortEnumType>;
};

export type PromoCodeResultType = {
  __typename?: 'PromoCodeResultType';
  message: Scalars['String']['output'];
  status: PromoCodeStatusType;
  success: Scalars['Boolean']['output'];
  voucherCode?: Maybe<Scalars['String']['output']>;
};

export enum PromoCodeStatusType {
  AdminUserOnly = 'ADMIN_USER_ONLY',
  AlreadyUsed = 'ALREADY_USED',
  CreatorsOnly = 'CREATORS_ONLY',
  CustomerSegmentOnly = 'CUSTOMER_SEGMENT_ONLY',
  Expired = 'EXPIRED',
  FakeCode = 'FAKE_CODE',
  FirstOrderOnly = 'FIRST_ORDER_ONLY',
  MinimumSpendNotMet = 'MINIMUM_SPEND_NOT_MET',
  NeedsPhysicalItem = 'NEEDS_PHYSICAL_ITEM',
  NeedToLogin = 'NEED_TO_LOGIN',
  NotValid = 'NOT_VALID',
  NotValidDuringSale = 'NOT_VALID_DURING_SALE',
  SegmentVerificationUnavailable = 'SEGMENT_VERIFICATION_UNAVAILABLE',
  SubscribersOnly = 'SUBSCRIBERS_ONLY',
  Valid = 'VALID',
  WrongBrand = 'WRONG_BRAND'
}

export type PublicWishlistProductSort = {
  displayPrice?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  timeAdded?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type PublicWishlistProductsCollectionSegment = {
  __typename?: 'PublicWishlistProductsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WishlistProductDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type PurchasedProductAppDto = {
  __typename?: 'PurchasedProductAppDto';
  allowDownload: Scalars['Boolean']['output'];
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  creators: Array<CreatorDto>;
  hasDownloads: Scalars['Boolean']['output'];
  hasInstructions: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isMasterClass: Scalars['Boolean']['output'];
  lastPlayedAt?: Maybe<Scalars['DateTime']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  purchasedDate: Scalars['DateTime']['output'];
  thumbnailPath?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PurchasedProductAppDtoFilterInput = {
  allowDownload?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<PurchasedProductAppDtoFilterInput>>;
  bannerImageUrl?: InputMaybe<StringOperationFilterInput>;
  category?: InputMaybe<StringOperationFilterInput>;
  creators?: InputMaybe<ListFilterInputTypeOfCreatorDtoFilterInput>;
  hasDownloads?: InputMaybe<BooleanOperationFilterInput>;
  hasInstructions?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isMasterClass?: InputMaybe<BooleanOperationFilterInput>;
  lastPlayedAt?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PurchasedProductAppDtoFilterInput>>;
  productName?: InputMaybe<StringOperationFilterInput>;
  purchasedDate?: InputMaybe<DateTimeOperationFilterInput>;
  thumbnailPath?: InputMaybe<StringOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
};

export type PurchasedProductDto = {
  __typename?: 'PurchasedProductDto';
  creators: Array<CreatorDto>;
  hasDownloads: Scalars['Boolean']['output'];
  hasInstructions: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  purchasedDate: Scalars['DateTime']['output'];
  thumbnailPath?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PurchasedProductExportRowDto = {
  __typename?: 'PurchasedProductExportRowDto';
  creators: Array<CreatorDto>;
  orderId: Scalars['Int']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  productPageUrl?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  purchasedDate: Scalars['DateTime']['output'];
};

/** A segment of a collection. */
export type PurchasedProductExportRowsCollectionSegment = {
  __typename?: 'PurchasedProductExportRowsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PurchasedProductExportRowDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type PurchasedProductsAppCollectionSegmentCollectionSegment = {
  __typename?: 'PurchasedProductsAppCollectionSegmentCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PurchasedProductAppDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type PurchasedProductsAppSort = {
  allowDownload?: InputMaybe<SortEnumType>;
  bannerImageUrl?: InputMaybe<SortEnumType>;
  category?: InputMaybe<SortEnumType>;
  hasDownloads?: InputMaybe<SortEnumType>;
  hasInstructions?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isMasterClass?: InputMaybe<SortEnumType>;
  lastPlayedAt?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  purchaseDate?: InputMaybe<SortEnumType>;
  thumbnailPath?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
};

export type PurchasedProductsAppStatusDto = {
  __typename?: 'PurchasedProductsAppStatusDto';
  activeCount: Scalars['Int']['output'];
  latestPlayedAt?: Maybe<Scalars['DateTime']['output']>;
  latestPurchasedDate?: Maybe<Scalars['DateTime']['output']>;
  latestPurchasedProductId?: Maybe<Scalars['Int']['output']>;
  serverTime: Scalars['DateTime']['output'];
};

/** A segment of a collection. */
export type PurchasedProductsCollectionSegment = {
  __typename?: 'PurchasedProductsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PurchasedProductDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type PurchasedProductsSort = {
  hasDownloads?: InputMaybe<SortEnumType>;
  hasInstructions?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  purchaseDate?: InputMaybe<SortEnumType>;
  thumbnailPath?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
};

export type Query = {
  __typename?: 'Query';
  accountDeletionEligibility: AccountDeletionEligibilityDto;
  activeShoppingCart?: Maybe<ShoppingCartDto>;
  activeShoppingCartHeader?: Maybe<ShoppingCartHeaderDto>;
  adminAccountingPaymentLogs: Array<AdminAccountingPaymentLogDto>;
  adminBatchShipmentGroups: Array<AdminBatchShipmentGroupDto>;
  adminBatchShipmentOrderValidation: AdminBatchShipmentOrderValidationDto;
  adminBatchShipmentRecovery: Array<AdminBatchShipmentRecoveryResultDto>;
  adminBlogComments: AdminBlogCommentPageDto;
  adminBlogLookups: AdminBlogLookupsDto;
  adminBlogMedia: AdminBlogMediaPageDto;
  adminBlogPost?: Maybe<AdminBlogPostDto>;
  adminBlogPosts: AdminBlogPostPageDto;
  adminCompareTaxJarOrdersByDateRange: TaxJarOrderRangeResultDto;
  adminComponentProduct?: Maybe<AdminComponentProductDto>;
  adminConvention?: Maybe<AdminConventionDetailDto>;
  adminConventionBadgeCsv: Scalars['String']['output'];
  adminConventionOrder?: Maybe<AdminOrderDto>;
  adminConventionRegistration?: Maybe<AdminConventionRegistrationDetailDto>;
  adminConventionSalesStats: AdminConventionSalesStatsDto;
  adminConventionWaitlist: Array<AdminConventionWaitlistEntryDto>;
  adminConventions: Array<AdminConventionListItemDto>;
  adminCreator?: Maybe<AdminCreatorDetailDto>;
  adminCreatorPaymentPreview: Array<AdminCreatorPaymentPreviewDto>;
  adminCreatorPendingPayments: AdminCreatorPendingPaymentsPageDto;
  adminCreators: AdminCreatorsPageDto;
  adminCustomer?: Maybe<AdminCustomerDetailDto>;
  adminCustomerGiftVoucherCode?: Maybe<AdminCustomerGiftVoucherCodeDto>;
  adminCustomerGiftVouchers: Array<AdminCustomerGiftVoucherDto>;
  adminCustomerMergePreview: AdminCustomerMergePreviewDto;
  adminCustomerOrders?: Maybe<AdminCustomerOrdersCollectionSegment>;
  adminCustomerSearch: Array<CustomerDto>;
  adminDelayedOrderEmailCandidates: Array<AdminDelayedOrderEmailCandidateDto>;
  adminDownloadCardLookup: AdminDownloadCardLookupDto;
  adminDownloadCodeProduct?: Maybe<AdminDownloadCodeProductDto>;
  adminDownloadGrantCandidates: Array<AdminDownloadGrantCandidateDto>;
  adminEasyPostShipmentJson: AdminEasyPostShipmentJsonDto;
  adminGiftVoucherLookup: AdminGiftVoucherLookupDto;
  adminHomepageCarousel: AdminHomepageCarouselDto;
  adminInAppPurchaseCandidateProducts?: Maybe<AdminInAppPurchaseCandidateProductsCollectionSegment>;
  adminInventoryLocations: Array<AdminWarehouseLocationDto>;
  adminLowStockProducts?: Maybe<AdminLowStockProductsCollectionSegment>;
  adminManagedPage?: Maybe<AdminManagedPageDto>;
  adminManifestCouriers: Array<AdminManifestCourierDto>;
  adminMasterclassRenewalRecoveryCandidates: AdminMasterclassRenewalRecoveryCandidatesDto;
  adminMasterclassRenewalRecoveryPreview: AdminMasterclassRenewalRecoveryBatchDto;
  adminMurphysHandoffCandidates: AdminMurphysHandoffCandidatesDto;
  adminMurphysOpenSalesOrders: Array<AdminMurphysOpenSalesOrderDto>;
  adminMurphysProductDownloadsPreview: AdminMurphysProductDownloadsPreviewDto;
  adminMurphysProductMediaPreview: AdminMurphysProductMediaPreviewDto;
  adminMurphysReturnSubmissions: AdminMurphysReturnSubmissionReportDto;
  adminMurphysSalesOrder: AdminMurphysSalesOrderDto;
  adminMurphysUkShipments: Array<AdminMurphysUkShipmentDto>;
  adminNegativeInventory: AdminNegativeInventoryDto;
  adminOrder?: Maybe<AdminOrderDto>;
  adminOrderAttachments: Array<AdminOrderAttachmentDto>;
  adminOrderCancellationPreview: AdminOrderCancellationPreviewDto;
  adminOrderHistory: AdminOrderHistoryDto;
  adminOrderItemProductSearch: Array<AdminOrderItemProductCandidateDto>;
  adminOrderPaymentDiagnostics?: Maybe<AdminOrderPaymentDto>;
  adminOrderQueue?: Maybe<AdminOrderQueueCollectionSegment>;
  adminOrderQueueCounts: Array<AdminOrderQueueCountDto>;
  adminOrderRefundPreview: AdminOrderRefundPreviewDto;
  adminOrderSearch: AdminOrderSearchResultDto;
  adminOrderShippingMethods: Array<AdminOrderShippingMethodDto>;
  adminOrderStatuses: Array<OrderStatus>;
  adminOrderTaxAudit?: Maybe<AdminOrderTaxAuditDto>;
  adminOrderTaxReconciliations: Array<OrderTaxReconciliationDto>;
  adminOrdersByIpAddress?: Maybe<AdminOrdersByIpAddressCollectionSegment>;
  adminOverstockedProducts?: Maybe<AdminOverstockedProductsCollectionSegment>;
  adminPackageResendPreview: AdminPackageResendPreviewDto;
  adminPackageStats: AdminPackageStatsDto;
  adminPartiallyPickedBoxes: Array<AdminPartiallyPickedBoxDto>;
  adminPayPalBalance: AdminPayPalBalanceDto;
  adminPickingAvailableShelves: Array<AdminPickingShelfOptionDto>;
  adminPickingExceptionReasons: Array<AdminPickingExceptionReasonDto>;
  adminPickingMurphysShipmentStatus?: Maybe<AdminPickingMurphysShipmentStatusDto>;
  adminPickingNextOrderId?: Maybe<Scalars['Int']['output']>;
  adminPickingOrder?: Maybe<AdminPickingOrderDto>;
  adminPickingOrderIdByPickedBoxId?: Maybe<Scalars['Int']['output']>;
  adminPickingOrders: Array<AdminPickingOrderSummaryDto>;
  adminPickingPreviousPackageWeight?: Maybe<AdminPickingPreviousPackageWeightDto>;
  adminPickingQueues: Array<AdminPickingQueueDto>;
  adminPickingWarehouses: Array<AdminPickingWarehouseDto>;
  adminPreorderProductSummaries: Array<AdminPreorderProductSummaryDto>;
  adminProductAuthoring?: Maybe<AdminProductAuthoringDto>;
  adminProductAuthoringLookupSearch: AdminProductAuthoringLookupSearchDto;
  adminProductAuthoringLookups: AdminProductAuthoringLookupsDto;
  adminProductComponents: Array<AdminComponentProductDto>;
  adminProductContract?: Maybe<AdminProductContractDto>;
  adminProductDownloadPreview: AdminProductDownloadPreviewDto;
  adminProductDownloadStorageStatuses: Array<AdminProductDownloadStorageStatusDto>;
  adminProductFinance?: Maybe<AdminProductFinanceDto>;
  adminProductFinanceLog?: Maybe<FinanceLogDto>;
  adminProductInventory: AdminProductInventoryDetailDto;
  adminProductInventoryShelfHistory: Array<AdminProductInventoryHistoryRowDto>;
  adminProductMetadataWorkspace?: Maybe<AdminProductMetadataWorkspaceDto>;
  adminProductPublishReadiness?: Maybe<AdminProductPublishReadinessDto>;
  adminProductStatistics: AdminProductStatisticsDto;
  adminProductSupplierStock: AdminProductSupplierStockDto;
  adminProductTrailerProviderStatuses: Array<AdminProductTrailerProviderStatusDto>;
  adminPurchaseOrderOrderSheet?: Maybe<AdminPurchaseOrderOrderSheetDto>;
  adminPurchaseOrderOrderingManufacturers: Array<AdminPurchaseOrderManufacturerDto>;
  adminPurchaseOrderReceipts: Array<AdminPurchaseOrderReceiptDto>;
  adminPurchaseOrders: Array<AdminPurchaseOrderDto>;
  adminRecentEasyPostShipments: Array<AdminEasyPostShipmentDto>;
  adminRecentScanForms: Array<AdminScanFormDto>;
  adminReturn?: Maybe<AdminReturnDetailDto>;
  adminReturns: AdminReturnQueueDto;
  adminReviewPurchaseOrderReceipt: AdminPurchaseOrderReceiptReviewDto;
  adminSalesCounts: Array<AdminSalesCountDto>;
  adminSalesReport: AdminSalesReportDto;
  adminStockCountDashboard: AdminStockCountDashboardDto;
  adminStockCountDiscrepancies: Array<AdminStockCountDiscrepancyDto>;
  adminStockCountHistory: Array<AdminStockCountHistoryRowDto>;
  adminStockCountReasonCodes: Array<AdminStockCountReasonCodeDto>;
  adminSupportStats: DashboardDto;
  adminSupportSurveyReport: AdminSurveyReportDto;
  adminTaxFailureRefundPreview: AdminTaxFailureRefundPreviewDto;
  adminTypesenseProductDocument?: Maybe<AdminTypesenseProductHitDto>;
  adminTypesenseProductSearch: AdminTypesenseProductSearchResultDto;
  adminUkStockOpportunities?: Maybe<AdminUkStockOpportunitiesCollectionSegment>;
  adminUkTransferHistory: Array<AdminUkTransferHistoryDto>;
  adminUkTransferItems: Array<AdminUkTransferItemDto>;
  adminUkTransferLabel?: Maybe<AdminUkTransferPackageDto>;
  adminUpcomingMasterclasses: AdminUpcomingMasterclassesDto;
  adminVatReport: Array<AdminVatReportRowDto>;
  adminWarehouseShelves: AdminWarehouseShelvesDto;
  allSubscriptionsForCustomer?: Maybe<AllSubscriptionsForCustomerCollectionSegment>;
  appDevicesForProduct?: Maybe<AppDeviceProductDto>;
  appProductsForCustomer?: Maybe<AppProductsForCustomerCollectionSegment>;
  appVersionStatus: AppVersionStatusDto;
  articleByPath?: Maybe<BlogPostDto>;
  articleBySlug?: Maybe<BlogPostDto>;
  articles?: Maybe<ArticlesCollectionSegment>;
  availablePaymentMethodsForShoppingCart: AvailablePaymentMethodsDto;
  bannerMessages: Array<BannerMessageDto>;
  base64ImageFromUrl: Scalars['String']['output'];
  blogPostById?: Maybe<BlogPostDto>;
  blogPostBySlug?: Maybe<BlogPostDto>;
  blogPosts?: Maybe<BlogPostsCollectionSegment>;
  blogStorefrontPreview?: Maybe<BlogStorefrontPreviewDto>;
  bookReviewBySlug?: Maybe<BookReviewDto>;
  bookReviews?: Maybe<BookReviewsCollectionSegment>;
  categories: Array<CategoryDto>;
  categoryBySlug?: Maybe<CategoryDto>;
  /** Check if a customer account exists with the given email address */
  checkEmailExists: Scalars['Boolean']['output'];
  checkoutPaymentRecoveryStatus: CheckoutPaymentRecoveryStatusDto;
  conventionOrderItem?: Maybe<ConventionRegistrationDto>;
  conventionRegistrations?: Maybe<ConventionRegistrationsCollectionSegment>;
  countries: Array<CountryDto>;
  countriesWithoutFreeShipping: Array<CountryDto>;
  countryByIsoCode?: Maybe<CountryDto>;
  creatorById?: Maybe<CreatorDto>;
  creatorBySlug?: Maybe<CreatorDto>;
  creatorContractUrl?: Maybe<Scalars['String']['output']>;
  creatorOwedStatement: Array<CreatorOwedStatementRowDto>;
  creatorPaymentById?: Maybe<CreatorPaymentDto>;
  creatorPaymentMethodOptions: Array<CreatorPaymentMethodOptionDto>;
  creatorProductById?: Maybe<CreatorProductDto>;
  currencies: Array<CurrencyDto>;
  currentMasterclass?: Maybe<CurrentMasterclassDto>;
  customer?: Maybe<CustomerDto>;
  customerAddresses: Array<CustomerAddressDto>;
  customerProductInstructions?: Maybe<CustomerProductInstructionsCollectionSegment>;
  customerRequiresPasswordSet: Scalars['Boolean']['output'];
  customerReview?: Maybe<CustomerReviewDto>;
  customerReviews?: Maybe<CustomerReviewsCollectionSegment>;
  customerSegments?: Maybe<CustomerSegmentsResponseDto>;
  digitalLibrary?: Maybe<DigitalLibraryCollectionSegment>;
  digitalLibraryItem?: Maybe<DigitalLibraryItemDto>;
  ebookImageURL: Scalars['String']['output'];
  ecommBrandByCountry?: Maybe<BrandDto>;
  ecommProductAccessBySlug?: Maybe<EcommProductAccessDto>;
  ecommProductById?: Maybe<EcommProductDto>;
  ecommProductBySlug?: Maybe<EcommProductDto>;
  ecommProductCommercialBySlug?: Maybe<EcommProductDto>;
  ecommProductContentBySlug?: Maybe<EcommProductDto>;
  ecommProductContentsByIds: Array<EcommProductContentDto>;
  ecommProducts?: Maybe<EcommProductsCollectionSegment>;
  explanationBySlug?: Maybe<ExplanationDto>;
  explanationPage?: Maybe<ExplanationPageDto>;
  explanationSlugByPassword?: Maybe<Scalars['String']['output']>;
  faqBySlug?: Maybe<BlogPostDto>;
  faqs: Array<BlogPostDto>;
  financeLogForProduct?: Maybe<FinanceLogDto>;
  galleries: Array<GalleryDto>;
  galleryByUrlStub?: Maybe<GalleryDto>;
  galleryPhotos: Array<GalleryPhotoDto>;
  galleryPhotosCount: Scalars['Int']['output'];
  giftCertificateOptions: Array<GiftCertificateOptionDto>;
  hasPurchasedProduct: Scalars['Boolean']['output'];
  homepageCarouselBanners: Array<CarouselBannerDto>;
  importDutiesQuoteForShoppingCart?: Maybe<ImportDutiesQuoteDto>;
  inTransitPackagesForCustomer: Array<InTransitPackageDto>;
  invoiceExtraInfo?: Maybe<Scalars['String']['output']>;
  invoicePdf?: Maybe<Scalars['String']['output']>;
  isEligibleForTrial: Scalars['Boolean']['output'];
  itemsToReturnForOrder: ReturnEligibilityResponseDto;
  latestExclusiveProductCards?: Maybe<LatestExclusiveProductCardsCollectionSegment>;
  managedPage?: Maybe<ManagedPageDto>;
  masterclassByMonthAndYear?: Maybe<EcommProductDto>;
  masterclassBySlug?: Maybe<EcommProductDto>;
  masterclassDownloadQa: MasterclassDownloadQaDto;
  masterclassItem?: Maybe<DigitalLibraryItemDto>;
  masterclassLiveBanner: MasterclassLiveBannerDto;
  masterclassLiveStatus: MasterclassLiveStatusDto;
  masterclassStatusForCustomer?: Maybe<MasterclassStatusDto>;
  masterclassStreamingLibrary?: Maybe<MasterclassStreamingLibraryCollectionSegment>;
  /** Whether the main newsletter checkbox should default to checked for this country (EU/CA/AU → false). */
  newsletterMarketingDefaultPreChecked: Scalars['Boolean']['output'];
  newsletterSubscribe: NewsletterSubscribeCheckoutDto;
  order?: Maybe<OrderDto>;
  orderByPaymentIntentId?: Maybe<OrderDto>;
  orderItem?: Maybe<OrderItemDto>;
  orders?: Maybe<OrdersCollectionSegment>;
  pagesByCategory?: Maybe<PagesByCategoryCollectionSegment>;
  paymentLogsForCreatorPayment: Array<CreatorPaymentLogDto>;
  paymentLogsForProductAndCreator: Array<CreatorPaymentLogDto>;
  paymentMethodsForCustomer: Array<CustomerPaymentMethodDto>;
  paymentMethodsForShoppingCart: Array<CustomerPaymentMethodDto>;
  paymentsForCreator: Array<CreatorPaymentDto>;
  playingCardManufacturers: Array<PlayingCardManufacturer>;
  playingCards?: Maybe<PlayingCardsCollectionSegment>;
  productBySlug?: Maybe<ProductDto>;
  productCountsByCategories: Array<KeyValuePairOfInt32AndInt32>;
  productForDiscoverie?: Maybe<ProductForDiscoverieDto>;
  productList?: Maybe<ProductListDto>;
  productListCardsByProductListSlug?: Maybe<ProductListCardsByProductListSlugCollectionSegment>;
  productLiveChatMessages: Array<ProductLiveChatMessageDto>;
  productQuestion?: Maybe<QuestionDto>;
  productQuestions?: Maybe<ProductQuestionsCollectionSegment>;
  products?: Maybe<ProductsCollectionSegment>;
  productsByCategorySlug?: Maybe<ProductsByCategorySlugCollectionSegment>;
  productsByCategorySlugCommercial?: Maybe<ProductsByCategorySlugCommercialCollectionSegment>;
  productsByCreatorSlug?: Maybe<ProductsByCreatorSlugCollectionSegment>;
  productsByProductListId?: Maybe<ProductsByProductListIdCollectionSegment>;
  productsByProductListSlug?: Maybe<ProductsByProductListSlugCollectionSegment>;
  productsThatRequireCreatorPayment: Array<FlattenedProductDto>;
  productsWithAmountsOwed: Array<ProductAmountOwedDto>;
  publicWishlistOwnerName?: Maybe<Scalars['String']['output']>;
  publicWishlistProducts?: Maybe<PublicWishlistProductsCollectionSegment>;
  purchasedProductExportRows?: Maybe<PurchasedProductExportRowsCollectionSegment>;
  purchasedProductIds: Array<Scalars['Int']['output']>;
  purchasedProducts?: Maybe<PurchasedProductsCollectionSegment>;
  purchasedProductsApp?: Maybe<PurchasedProductsAppCollectionSegmentCollectionSegment>;
  purchasedProductsAppSince?: Maybe<PurchasedProductsAppCollectionSegmentCollectionSegment>;
  purchasedProductsAppStatus: PurchasedProductsAppStatusDto;
  purchasedProductsList: Array<PurchasedProductDto>;
  recentGalleries: Array<GalleryDto>;
  return?: Maybe<ReturnDto>;
  returnsForCustomer?: Maybe<ReturnsForCustomerCollectionSegment>;
  shippingOptionsForShoppingCart: Array<ShippingRateDto>;
  shippingOptionsForShoppingCartAddress: Array<ShippingRateDto>;
  sidebarAds?: Maybe<SidebarAdsCollectionSegment>;
  states: Array<StateDto>;
  storeCreditBalance: Scalars['Decimal']['output'];
  streams?: Maybe<StreamsCollectionSegment>;
  studioFileStreamingUrl?: Maybe<Scalars['String']['output']>;
  studioItem?: Maybe<DigitalLibraryItemDto>;
  studioVideos?: Maybe<StudioVideosCollectionSegment>;
  subscriptionById?: Maybe<Subscription>;
  subscriptionEligibility: SubscriptionEligibilityDto;
  supportSurveyByExternalId?: Maybe<SurveyDto>;
  topSellers: Array<TopSellerDto>;
  trackingInfo: PackageDto;
  upComingStudioVideos: Array<ProductListItemDto>;
  validateCartStock: StockValidationResultDto;
  validateResetLink: Scalars['Boolean']['output'];
  viPointsBalance: Scalars['Int']['output'];
  viPointsLog: ViPointsLogDto;
  wishlist: WishlistDto;
  wishlistProducts?: Maybe<WishlistProductsCollectionSegment>;
};


export type QueryActiveShoppingCartArgs = {
  anonymousCartToken?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  includeConventionCart?: Scalars['Boolean']['input'];
};


export type QueryActiveShoppingCartHeaderArgs = {
  anonymousCartToken?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  includeConventionCart?: Scalars['Boolean']['input'];
};


export type QueryAdminAccountingPaymentLogsArgs = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  brandId: Scalars['Int']['input'];
  cardLast4?: InputMaybe<Scalars['String']['input']>;
  method: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminBatchShipmentGroupsArgs = {
  locationId: Scalars['Int']['input'];
};


export type QueryAdminBatchShipmentOrderValidationArgs = {
  expectedOrderItemIds: Array<Scalars['Int']['input']>;
  expectedSignature: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
  orderId: Scalars['Int']['input'];
};


export type QueryAdminBatchShipmentRecoveryArgs = {
  orders: Array<AdminBatchShipmentRecoveryInput>;
};


export type QueryAdminBlogCommentsArgs = {
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  status?: BlogCommentStatus;
};


export type QueryAdminBlogMediaArgs = {
  input: AdminBlogMediaInput;
};


export type QueryAdminBlogPostArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdminBlogPostsArgs = {
  input: AdminBlogListInput;
};


export type QueryAdminCompareTaxJarOrdersByDateRangeArgs = {
  fromTransactionDate: Scalars['String']['input'];
  maxRows: Scalars['Int']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
  toTransactionDate: Scalars['String']['input'];
};


export type QueryAdminComponentProductArgs = {
  componentProductId: Scalars['Int']['input'];
};


export type QueryAdminConventionArgs = {
  conventionProductId: Scalars['Int']['input'];
};


export type QueryAdminConventionBadgeCsvArgs = {
  conventionProductId: Scalars['Int']['input'];
};


export type QueryAdminConventionOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryAdminConventionRegistrationArgs = {
  orderItemId: Scalars['Int']['input'];
};


export type QueryAdminConventionWaitlistArgs = {
  conventionProductId: Scalars['Int']['input'];
};


export type QueryAdminCreatorArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdminCreatorPaymentPreviewArgs = {
  productId?: InputMaybe<Scalars['Int']['input']>;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryAdminCreatorPendingPaymentsArgs = {
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type QueryAdminCreatorsArgs = {
  lastNameInitial?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryAdminCustomerArgs = {
  customerId: Scalars['Int']['input'];
};


export type QueryAdminCustomerGiftVoucherCodeArgs = {
  customerId: Scalars['Int']['input'];
  voucherId: Scalars['Int']['input'];
};


export type QueryAdminCustomerGiftVouchersArgs = {
  customerId: Scalars['Int']['input'];
};


export type QueryAdminCustomerMergePreviewArgs = {
  sourceCustomerReference: Scalars['String']['input'];
  targetCustomerId: Scalars['Int']['input'];
};


export type QueryAdminCustomerOrdersArgs = {
  customerId: Scalars['Int']['input'];
  order?: InputMaybe<Array<AdminOrderDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminCustomerSearchArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QueryAdminDelayedOrderEmailCandidatesArgs = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminDownloadCardLookupArgs = {
  code: Scalars['String']['input'];
};


export type QueryAdminDownloadCodeProductArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryAdminDownloadGrantCandidatesArgs = {
  searchTerm: Scalars['String']['input'];
  take: Scalars['Int']['input'];
};


export type QueryAdminEasyPostShipmentJsonArgs = {
  shipmentId: Scalars['String']['input'];
};


export type QueryAdminGiftVoucherLookupArgs = {
  code: Scalars['String']['input'];
};


export type QueryAdminHomepageCarouselArgs = {
  includeArchived: Scalars['Boolean']['input'];
};


export type QueryAdminInAppPurchaseCandidateProductsArgs = {
  downloadsOnly?: Scalars['Boolean']['input'];
  hasInAppPurchaseTier?: InputMaybe<Scalars['Boolean']['input']>;
  liveOnly?: Scalars['Boolean']['input'];
  order?: InputMaybe<Array<AdminInAppPurchaseCandidateProductDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AdminInAppPurchaseCandidateProductDtoFilterInput>;
};


export type QueryAdminLowStockProductsArgs = {
  lowStockThreshold?: Scalars['Int']['input'];
  productListId?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminManagedPageArgs = {
  pageKey: Scalars['String']['input'];
};


export type QueryAdminMasterclassRenewalRecoveryCandidatesArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryAdminMasterclassRenewalRecoveryPreviewArgs = {
  items: Array<AdminMasterclassRenewalRecoveryInputDtoInput>;
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryAdminMurphysHandoffCandidatesArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['Int']['input'];
};


export type QueryAdminMurphysProductDownloadsPreviewArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryAdminMurphysProductMediaPreviewArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryAdminMurphysReturnSubmissionsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type QueryAdminMurphysSalesOrderArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  salesOrderId: Scalars['String']['input'];
};


export type QueryAdminNegativeInventoryArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryAdminOrderAttachmentsArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryAdminOrderCancellationPreviewArgs = {
  input: AdminOrderCancellationQuoteInputDtoInput;
};


export type QueryAdminOrderHistoryArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryAdminOrderItemProductSearchArgs = {
  destination?: InputMaybe<AdminStoreOrderDestination>;
  query: Scalars['String']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryAdminOrderPaymentDiagnosticsArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryAdminOrderQueueArgs = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status: Scalars['String']['input'];
  summaryOnly?: Scalars['Boolean']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminOrderQueueCountsArgs = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminOrderRefundPreviewArgs = {
  input: AdminOrderRefundQuoteInputDtoInput;
};


export type QueryAdminOrderSearchArgs = {
  search: Scalars['String']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryAdminOrderShippingMethodsArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryAdminOrderTaxAuditArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryAdminOrderTaxReconciliationsArgs = {
  recommendation?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
};


export type QueryAdminOrdersByIpAddressArgs = {
  ipAddress: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminOverstockedProductsArgs = {
  lookbackDays?: Scalars['Int']['input'];
  manufacturerScope?: Scalars['String']['input'];
  minMonthsCover?: Scalars['Decimal']['input'];
  minStock?: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  warehouseLocationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminPackageResendPreviewArgs = {
  orderId: Scalars['Int']['input'];
  packageId: Scalars['Int']['input'];
};


export type QueryAdminPackageStatsArgs = {
  endUtc: Scalars['DateTime']['input'];
  monthStartUtc: Scalars['DateTime']['input'];
  todayStartUtc: Scalars['DateTime']['input'];
};


export type QueryAdminPartiallyPickedBoxesArgs = {
  locationId: Scalars['Int']['input'];
};


export type QueryAdminPayPalBalanceArgs = {
  currency: Scalars['String']['input'];
};


export type QueryAdminPickingAvailableShelvesArgs = {
  locationId: Scalars['Int']['input'];
  orderItemId: Scalars['Int']['input'];
};


export type QueryAdminPickingMurphysShipmentStatusArgs = {
  distributorOrderId: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
};


export type QueryAdminPickingNextOrderIdArgs = {
  currentOrderId: Scalars['Int']['input'];
  distributorOrderId?: InputMaybe<Scalars['String']['input']>;
  excludedOrderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  fallbackToAllOrders?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  includeAllFulfillmentGroups?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['Int']['input'];
  preorderOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAdminPickingOrderArgs = {
  distributorOrderId?: InputMaybe<Scalars['String']['input']>;
  includeAllFulfillmentGroups?: InputMaybe<Scalars['Boolean']['input']>;
  includeCustomerOpenOrders?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['Int']['input'];
  orderId: Scalars['Int']['input'];
};


export type QueryAdminPickingOrderIdByPickedBoxIdArgs = {
  distributorOrderId?: InputMaybe<Scalars['String']['input']>;
  includeAllFulfillmentGroups?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['Int']['input'];
  pickedBoxId: Scalars['String']['input'];
  preorderOnly: Scalars['Boolean']['input'];
};


export type QueryAdminPickingOrdersArgs = {
  distributorOrderId?: InputMaybe<Scalars['String']['input']>;
  includeAllFulfillmentGroups?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['Int']['input'];
  preorderOnly: Scalars['Boolean']['input'];
};


export type QueryAdminPickingPreviousPackageWeightArgs = {
  locationId: Scalars['Int']['input'];
  orderItemIds: Array<Scalars['Int']['input']>;
};


export type QueryAdminPickingQueuesArgs = {
  locationId: Scalars['Int']['input'];
};


export type QueryAdminPreorderProductSummariesArgs = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminProductAuthoringArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryAdminProductAuthoringLookupSearchArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  take?: Scalars['Int']['input'];
};


export type QueryAdminProductComponentsArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryAdminProductContractArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryAdminProductDownloadPreviewArgs = {
  downloadFileId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
};


export type QueryAdminProductDownloadStorageStatusesArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryAdminProductFinanceArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryAdminProductFinanceLogArgs = {
  creatorId: Scalars['Int']['input'];
  optionId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};


export type QueryAdminProductInventoryArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminProductInventoryShelfHistoryArgs = {
  detailed: Scalars['Boolean']['input'];
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
  shelfId: Scalars['Int']['input'];
};


export type QueryAdminProductMetadataWorkspaceArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryAdminProductPublishReadinessArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryAdminProductStatisticsArgs = {
  optionId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};


export type QueryAdminProductSupplierStockArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryAdminProductTrailerProviderStatusesArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryAdminPurchaseOrderOrderSheetArgs = {
  manufacturerId: Scalars['Int']['input'];
};


export type QueryAdminPurchaseOrderReceiptsArgs = {
  purchaseOrderId: Scalars['Int']['input'];
};


export type QueryAdminPurchaseOrdersArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  includeReceived: Scalars['Boolean']['input'];
  productId?: InputMaybe<Scalars['Int']['input']>;
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminRecentEasyPostShipmentsArgs = {
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminReturnArgs = {
  returnId: Scalars['Int']['input'];
};


export type QueryAdminReturnsArgs = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
};


export type QueryAdminReviewPurchaseOrderReceiptArgs = {
  id: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};


export type QueryAdminSalesCountsArgs = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryAdminSalesReportArgs = {
  date: Scalars['String']['input'];
};


export type QueryAdminStockCountDashboardArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminStockCountDiscrepanciesArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminStockCountHistoryArgs = {
  adminUserId?: InputMaybe<Scalars['Int']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  discrepancyStatus?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
  take: Scalars['Int']['input'];
};


export type QueryAdminSupportStatsArgs = {
  adminUserId?: InputMaybe<Scalars['Int']['input']>;
  endUtc: Scalars['DateTime']['input'];
  monthStartUtc: Scalars['DateTime']['input'];
  todayStartUtc: Scalars['DateTime']['input'];
};


export type QueryAdminSupportSurveyReportArgs = {
  adminUserId?: InputMaybe<Scalars['Int']['input']>;
  endUtc: Scalars['DateTime']['input'];
  startUtc: Scalars['DateTime']['input'];
};


export type QueryAdminTaxFailureRefundPreviewArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryAdminTypesenseProductDocumentArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryAdminTypesenseProductSearchArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  useCache: Scalars['Boolean']['input'];
};


export type QueryAdminUkStockOpportunitiesArgs = {
  lookbackDays?: Scalars['Int']['input'];
  minimumOrderCount?: Scalars['Int']['input'];
  minimumUnitsSold?: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  targetMonthsCover?: Scalars['Decimal']['input'];
};


export type QueryAdminUkTransferLabelArgs = {
  packageId: Scalars['Int']['input'];
};


export type QueryAdminUpcomingMasterclassesArgs = {
  months?: Scalars['Int']['input'];
};


export type QueryAdminVatReportArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryAdminWarehouseShelvesArgs = {
  emptyOnly: Scalars['Boolean']['input'];
  includeInactive: Scalars['Boolean']['input'];
  includeZeroStock: Scalars['Boolean']['input'];
  locationId: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  shelfId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllSubscriptionsForCustomerArgs = {
  order?: InputMaybe<Array<CustomerSubscriptionDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerSubscriptionDtoFilterInput>;
};


export type QueryAppDevicesForProductArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryAppProductsForCustomerArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAppVersionStatusArgs = {
  build: Scalars['Int']['input'];
  platform: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


export type QueryArticleByPathArgs = {
  articleSlug: Scalars['String']['input'];
  brandCode: Scalars['String']['input'];
  categorySlug: Scalars['String']['input'];
};


export type QueryArticleBySlugArgs = {
  brandCode: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryArticlesArgs = {
  brandCode: Scalars['String']['input'];
  order?: InputMaybe<Array<BlogPostDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogPostDtoFilterInput>;
};


export type QueryAvailablePaymentMethodsForShoppingCartArgs = {
  shoppingCartToken: Scalars['String']['input'];
};


export type QueryBannerMessagesArgs = {
  order?: InputMaybe<Array<BannerMessageDtoSortInput>>;
  where?: InputMaybe<BannerMessageDtoFilterInput>;
};


export type QueryBase64ImageFromUrlArgs = {
  imageUrl: Scalars['String']['input'];
};


export type QueryBlogPostByIdArgs = {
  id: Scalars['Int']['input'];
  where?: InputMaybe<BlogPostDtoFilterInput>;
};


export type QueryBlogPostBySlugArgs = {
  slug: Scalars['String']['input'];
  where?: InputMaybe<BlogPostDtoFilterInput>;
};


export type QueryBlogPostsArgs = {
  brandCode: Scalars['String']['input'];
  order?: InputMaybe<Array<BlogPostDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogPostDtoFilterInput>;
};


export type QueryBlogStorefrontPreviewArgs = {
  token: Scalars['String']['input'];
};


export type QueryBookReviewBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryBookReviewsArgs = {
  brandId: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BookReviewDtoFilterInput>;
};


export type QueryCategoriesArgs = {
  order?: InputMaybe<Array<CategoryDtoSortInput>>;
};


export type QueryCategoryBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCheckEmailExistsArgs = {
  email: Scalars['String']['input'];
};


export type QueryCheckoutPaymentRecoveryStatusArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type QueryConventionOrderItemArgs = {
  orderItemId: Scalars['Int']['input'];
};


export type QueryConventionRegistrationsArgs = {
  filter?: ConventionTimeFilterEnum;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCountriesArgs = {
  order?: InputMaybe<Array<CountryDtoSortInput>>;
};


export type QueryCountriesWithoutFreeShippingArgs = {
  brandCode: Scalars['String']['input'];
  order?: InputMaybe<Array<CountryDtoSortInput>>;
};


export type QueryCountryByIsoCodeArgs = {
  isoCode: Scalars['String']['input'];
};


export type QueryCreatorByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCreatorBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCreatorContractUrlArgs = {
  creatorId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
};


export type QueryCreatorOwedStatementArgs = {
  creatorId: Scalars['Int']['input'];
};


export type QueryCreatorPaymentByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCreatorProductByIdArgs = {
  creatorId: Scalars['Int']['input'];
  optionId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};


export type QueryCustomerAddressesArgs = {
  order?: InputMaybe<Array<CustomerAddressDtoSortInput>>;
};


export type QueryCustomerProductInstructionsArgs = {
  order?: InputMaybe<Array<ProductInstructionDtoSortInput>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerRequiresPasswordSetArgs = {
  customerId: Scalars['Int']['input'];
};


export type QueryCustomerReviewArgs = {
  reviewId: Scalars['Int']['input'];
};


export type QueryCustomerReviewsArgs = {
  order?: InputMaybe<Array<CustomerReviewSort>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerSegmentsArgs = {
  workspace?: InputMaybe<CustomerIoWorkspace>;
};


export type QueryDigitalLibraryArgs = {
  order?: InputMaybe<Array<DigitalLibraryItemDtoSortInput>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DigitalLibraryFilter>;
};


export type QueryDigitalLibraryItemArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryEbookImageUrlArgs = {
  imagePath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEcommBrandByCountryArgs = {
  country: Scalars['String']['input'];
};


export type QueryEcommProductAccessBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryEcommProductByIdArgs = {
  brandCode: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEcommProductBySlugArgs = {
  brandCode: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  requireInAppPurchaseTier?: Scalars['Boolean']['input'];
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryEcommProductCommercialBySlugArgs = {
  brandCode: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryEcommProductContentBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryEcommProductContentsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
  maxBlurbLength?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEcommProductsArgs = {
  brandCode: Scalars['String']['input'];
  maxBlurbLength?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductsSort>>;
  productTypeGroup?: InputMaybe<Scalars['String']['input']>;
  requireInAppPurchaseTier?: Scalars['Boolean']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EcommProductDtoFilterInput>;
};


export type QueryExplanationBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryExplanationPageArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryExplanationSlugByPasswordArgs = {
  password: Scalars['String']['input'];
};


export type QueryFaqBySlugArgs = {
  slug: Scalars['String']['input'];
  where?: InputMaybe<BlogPostDtoFilterInput>;
};


export type QueryFaqsArgs = {
  brandId: Scalars['Int']['input'];
  order?: InputMaybe<Array<BlogPostDtoSortInput>>;
  where?: InputMaybe<BlogPostDtoFilterInput>;
};


export type QueryFinanceLogForProductArgs = {
  creatorId: Scalars['Int']['input'];
  optionId?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};


export type QueryGalleriesArgs = {
  order?: InputMaybe<Array<GalleryDtoSortInput>>;
};


export type QueryGalleryByUrlStubArgs = {
  urlStub: Scalars['String']['input'];
};


export type QueryGalleryPhotosArgs = {
  galleryId: Scalars['Int']['input'];
  order?: InputMaybe<Array<GalleryPhotoDtoSortInput>>;
  page?: Scalars['Int']['input'];
};


export type QueryGalleryPhotosCountArgs = {
  galleryId: Scalars['Int']['input'];
};


export type QueryGiftCertificateOptionsArgs = {
  currencyId: Scalars['Int']['input'];
};


export type QueryHasPurchasedProductArgs = {
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHomepageCarouselBannersArgs = {
  brandCode: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryImportDutiesQuoteForShoppingCartArgs = {
  shoppingCartToken: Scalars['String']['input'];
};


export type QueryInvoiceExtraInfoArgs = {
  brandId: Scalars['Int']['input'];
};


export type QueryInvoicePdfArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryIsEligibleForTrialArgs = {
  customerId: Scalars['Int']['input'];
};


export type QueryItemsToReturnForOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryLatestExclusiveProductCardsArgs = {
  brandCode: Scalars['String']['input'];
  order?: InputMaybe<Array<ProductListCardSort>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryManagedPageArgs = {
  pageKey: Scalars['String']['input'];
};


export type QueryMasterclassByMonthAndYearArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryMasterclassBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryMasterclassDownloadQaArgs = {
  productId: Scalars['Int']['input'];
};


export type QueryMasterclassItemArgs = {
  urlStub: Scalars['String']['input'];
};


export type QueryMasterclassStreamingLibraryArgs = {
  order?: InputMaybe<Array<MasterclassDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EcommProductDtoFilterInput>;
};


export type QueryNewsletterMarketingDefaultPreCheckedArgs = {
  countryIsoCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNewsletterSubscribeArgs = {
  countryIsoCode?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['Int']['input'];
  workspace?: InputMaybe<CustomerIoWorkspace>;
};


export type QueryOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryOrderByPaymentIntentIdArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type QueryOrderItemArgs = {
  orderItemId: Scalars['Int']['input'];
};


export type QueryOrdersArgs = {
  order?: InputMaybe<Array<OrderDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPagesByCategoryArgs = {
  brandCode: Scalars['String']['input'];
  categorySlug: Scalars['String']['input'];
  order?: InputMaybe<Array<BlogPostDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BlogPostDtoFilterInput>;
};


export type QueryPaymentLogsForCreatorPaymentArgs = {
  creatorPaymentId: Scalars['Int']['input'];
};


export type QueryPaymentLogsForProductAndCreatorArgs = {
  creatorId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
};


export type QueryPaymentMethodsForCustomerArgs = {
  brandCode: Scalars['String']['input'];
};


export type QueryPaymentMethodsForShoppingCartArgs = {
  shoppingCartToken: Scalars['String']['input'];
};


export type QueryPaymentsForCreatorArgs = {
  creatorId: Scalars['Int']['input'];
};


export type QueryPlayingCardsArgs = {
  currencyId: Scalars['Int']['input'];
  order?: InputMaybe<Array<ProductsSort>>;
  shippingCountry: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EcommProductDtoFilterInput>;
};


export type QueryProductBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryProductCountsByCategoriesArgs = {
  categoryIds: Array<Scalars['Int']['input']>;
};


export type QueryProductForDiscoverieArgs = {
  brandCode: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryProductListArgs = {
  urlStub: Scalars['String']['input'];
};


export type QueryProductListCardsByProductListSlugArgs = {
  brandCode: Scalars['String']['input'];
  order?: InputMaybe<Array<ProductListCardSort>>;
  productListSlug: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductLiveChatMessagesArgs = {
  productId: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


export type QueryProductQuestionArgs = {
  productQuestionId: Scalars['Int']['input'];
};


export type QueryProductQuestionsArgs = {
  productId: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductsArgs = {
  order?: InputMaybe<Array<ProductDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductDtoFilterInput>;
};


export type QueryProductsByCategorySlugArgs = {
  brandCode: Scalars['String']['input'];
  categorySlug: Scalars['String']['input'];
  inStockOnly?: Scalars['Boolean']['input'];
  includeChildCategories: Scalars['Boolean']['input'];
  maxBlurbLength?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductByCategorySort>>;
  productTypeGroup?: InputMaybe<Scalars['String']['input']>;
  requireInAppPurchaseTier?: Scalars['Boolean']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductByCategoryFilter>;
};


export type QueryProductsByCategorySlugCommercialArgs = {
  brandCode: Scalars['String']['input'];
  categorySlug: Scalars['String']['input'];
  includeChildCategories: Scalars['Boolean']['input'];
  order?: InputMaybe<Array<ProductByCategorySort>>;
  productTypeGroup?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductByCategoryFilter>;
};


export type QueryProductsByCreatorSlugArgs = {
  brandCode: Scalars['String']['input'];
  creatorSlug: Scalars['String']['input'];
  maxBlurbLength?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductByCategorySort>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductByCategoryFilter>;
};


export type QueryProductsByProductListIdArgs = {
  brandCode: Scalars['String']['input'];
  includeProductTrailers?: Scalars['Boolean']['input'];
  order?: InputMaybe<Array<ProductsByProductListSort>>;
  productListId: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductsByProductListSlugArgs = {
  brandCode: Scalars['String']['input'];
  order?: InputMaybe<Array<ProductsByProductListSort>>;
  productListSlug: Scalars['String']['input'];
  requireInAppPurchaseTier?: Scalars['Boolean']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductsThatRequireCreatorPaymentArgs = {
  creatorId: Scalars['Int']['input'];
};


export type QueryProductsWithAmountsOwedArgs = {
  creatorId: Scalars['Int']['input'];
};


export type QueryPublicWishlistOwnerNameArgs = {
  wishlistSlug: Scalars['String']['input'];
};


export type QueryPublicWishlistProductsArgs = {
  brandCode: Scalars['String']['input'];
  order?: InputMaybe<Array<PublicWishlistProductSort>>;
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  wishlistSlug: Scalars['String']['input'];
};


export type QueryPurchasedProductExportRowsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPurchasedProductsArgs = {
  customerId: Scalars['Int']['input'];
  order?: InputMaybe<Array<PurchasedProductsSort>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPurchasedProductsAppArgs = {
  customerId: Scalars['Int']['input'];
  order?: InputMaybe<Array<PurchasedProductsAppSort>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PurchasedProductAppDtoFilterInput>;
};


export type QueryPurchasedProductsAppSinceArgs = {
  customerId: Scalars['Int']['input'];
  order?: InputMaybe<Array<PurchasedProductsAppSort>>;
  since: Scalars['DateTime']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PurchasedProductAppDtoFilterInput>;
};


export type QueryPurchasedProductsAppStatusArgs = {
  customerId: Scalars['Int']['input'];
};


export type QueryRecentGalleriesArgs = {
  take?: Scalars['Int']['input'];
};


export type QueryReturnArgs = {
  returnId: Scalars['Int']['input'];
};


export type QueryReturnsForCustomerArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryShippingOptionsForShoppingCartArgs = {
  shoppingCartToken: Scalars['String']['input'];
};


export type QueryShippingOptionsForShoppingCartAddressArgs = {
  address: ShippingAddressInput;
  shoppingCartToken: Scalars['String']['input'];
};


export type QuerySidebarAdsArgs = {
  brandCode: Scalars['String']['input'];
  order?: InputMaybe<Array<SidebarAdDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EcommProductDtoFilterInput>;
};


export type QueryStatesArgs = {
  countryId: Scalars['Int']['input'];
  order?: InputMaybe<Array<StateDtoSortInput>>;
  where?: InputMaybe<StateDtoFilterInput>;
};


export type QueryStoreCreditBalanceArgs = {
  brandId: Scalars['Int']['input'];
  currencyId: Scalars['Int']['input'];
};


export type QueryStreamsArgs = {
  activeOnly?: Scalars['Boolean']['input'];
  order?: InputMaybe<Array<StreamingProductDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StreamingProductDtoFilterInput>;
};


export type QueryStudioFileStreamingUrlArgs = {
  downloadFileId: Scalars['Int']['input'];
};


export type QueryStudioItemArgs = {
  urlStub: Scalars['String']['input'];
};


export type QueryStudioVideosArgs = {
  order?: InputMaybe<Array<ProductListItemDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductListItemDtoFilterInput>;
};


export type QuerySubscriptionByIdArgs = {
  subscriptionId: Scalars['Int']['input'];
};


export type QuerySupportSurveyByExternalIdArgs = {
  externalId: Scalars['String']['input'];
};


export type QueryTopSellersArgs = {
  brandCode: Scalars['String']['input'];
};


export type QueryTrackingInfoArgs = {
  trackingCode: Scalars['String']['input'];
};


export type QueryUpComingStudioVideosArgs = {
  where?: InputMaybe<ProductListItemDtoFilterInput>;
};


export type QueryValidateCartStockArgs = {
  shoppingCartToken: Scalars['String']['input'];
};


export type QueryValidateResetLinkArgs = {
  customerId: Scalars['Int']['input'];
  hash: Scalars['String']['input'];
};


export type QueryViPointsBalanceArgs = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryViPointsLogArgs = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWishlistProductsArgs = {
  brandCode: Scalars['String']['input'];
  order?: InputMaybe<Array<WishlistProductSort>>;
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionDto = {
  __typename?: 'QuestionDto';
  answers: Array<AnswerDto>;
  customerId: Scalars['Int']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  productId?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  responseTo?: Maybe<Scalars['Int']['output']>;
  upvotes?: Maybe<Scalars['Int']['output']>;
};

/** A segment of a collection. */
export type QuestionsCollectionSegment = {
  __typename?: 'QuestionsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<QuestionDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
};

export type RedeemDownloadCardResultDto = {
  __typename?: 'RedeemDownloadCardResultDto';
  message: Scalars['String']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  productId?: Maybe<Scalars['Int']['output']>;
  status: RedeemDownloadCardStatus;
};

export enum RedeemDownloadCardStatus {
  AlreadyRedeemed = 'ALREADY_REDEEMED',
  Error = 'ERROR',
  InvalidCode = 'INVALID_CODE',
  NotActivated = 'NOT_ACTIVATED',
  Success = 'SUCCESS',
  WrongProduct = 'WRONG_PRODUCT'
}

export type ReducedQuantityItemDto = {
  __typename?: 'ReducedQuantityItemDto';
  availableQuantity: Scalars['Int']['output'];
  cartItemId: Scalars['Int']['output'];
  optionId?: Maybe<Scalars['Int']['output']>;
  optionName?: Maybe<Scalars['String']['output']>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  requestedQuantity: Scalars['Int']['output'];
};

export type RefreshSubscriptionResultDto = {
  __typename?: 'RefreshSubscriptionResultDto';
  createdSubscription: Scalars['Boolean']['output'];
  customerId: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  subscriptionStatusIds: Array<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum ReturnAction {
  NoAction = 'NO_ACTION',
  Refund = 'REFUND',
  Replace = 'REPLACE'
}

export type ReturnActionDto = {
  __typename?: 'ReturnActionDto';
  action: ReturnAction;
  description: Scalars['String']['output'];
};

export type ReturnDto = {
  __typename?: 'ReturnDto';
  dateReceived?: Maybe<Scalars['DateTime']['output']>;
  dateRequested: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  items: Array<ReturnRequestItemDto>;
  order?: Maybe<OrderDto>;
  returnDetails: Scalars['String']['output'];
  returnInternalNotes?: Maybe<Scalars['String']['output']>;
  returnNotes?: Maybe<Scalars['String']['output']>;
  returnReason?: Maybe<Scalars['Int']['output']>;
  returnTracking: Scalars['String']['output'];
  shippingRefundAmount: Scalars['Decimal']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type ReturnEligibilityResponseDto = {
  __typename?: 'ReturnEligibilityResponseDto';
  explanation?: Maybe<Scalars['String']['output']>;
  items: Array<OrderItemReturnEligibilityDto>;
};

export type ReturnReasonDto = {
  __typename?: 'ReturnReasonDto';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type ReturnRequestItemDto = {
  __typename?: 'ReturnRequestItemDto';
  action: Scalars['String']['output'];
  files: Array<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  notes: Scalars['String']['output'];
  orderItemId: Scalars['Int']['output'];
  product?: Maybe<EcommProductDto>;
  productName: Scalars['String']['output'];
  productThumbnail?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  reasonId: Scalars['Int']['output'];
  requestedAction: Scalars['String']['output'];
  returnId?: Maybe<Scalars['Int']['output']>;
};

export type ReturnRequestItemDtoInput = {
  action: Scalars['String']['input'];
  files: Array<Scalars['String']['input']>;
  notes: Scalars['String']['input'];
  orderItemId: Scalars['Int']['input'];
  reasonId: Scalars['Int']['input'];
};

/** A segment of a collection. */
export type ReturnsForCustomerCollectionSegment = {
  __typename?: 'ReturnsForCustomerCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ReturnDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ReviewerProductRequestInput = {
  address: Scalars['String']['input'];
  brandCode: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  productIds: Array<Scalars['Int']['input']>;
};

export type ShippingAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryIsoCode: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  stateOrCounty?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type ShippingCarrier = {
  __typename?: 'ShippingCarrier';
  code: Scalars['String']['output'];
  contactPhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type ShippingCarrierFilterInput = {
  and?: InputMaybe<Array<ShippingCarrierFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  contactPhone?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  logoUrl?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ShippingCarrierFilterInput>>;
};

export type ShippingMethod = {
  __typename?: 'ShippingMethod';
  carrier?: Maybe<ShippingCarrier>;
  carrierId?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ShippingMethodFilterInput = {
  and?: InputMaybe<Array<ShippingMethodFilterInput>>;
  carrier?: InputMaybe<ShippingCarrierFilterInput>;
  carrierId?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ShippingMethodFilterInput>>;
};

export type ShippingRateDto = {
  __typename?: 'ShippingRateDto';
  currencySymbol: Scalars['String']['output'];
  description: Scalars['String']['output'];
  estDelivery: Scalars['String']['output'];
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isFallback: Scalars['Boolean']['output'];
  notice?: Maybe<Scalars['String']['output']>;
  price: Scalars['Decimal']['output'];
  shippingMethodId: Scalars['Int']['output'];
};

export type ShoppingCart = {
  __typename?: 'ShoppingCart';
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  brand?: Maybe<Brand>;
  brandId?: Maybe<Scalars['Int']['output']>;
  cartPurpose: Scalars['Int']['output'];
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Currency>;
  currencyId?: Maybe<Scalars['Int']['output']>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['Int']['output']>;
  giftVoucherCode?: Maybe<Scalars['String']['output']>;
  guestEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  openedDate: Scalars['DateTime']['output'];
  orderCompleteDate?: Maybe<Scalars['DateTime']['output']>;
  shippingAddress?: Maybe<CustomerAddress>;
  shippingAddressId?: Maybe<Scalars['Int']['output']>;
  shippingCost?: Maybe<Scalars['Decimal']['output']>;
  shippingMethod?: Maybe<Scalars['Int']['output']>;
  shoppingCartItems: Array<ShoppingCartItem>;
  token: Scalars['UUID']['output'];
  useStoreCredit?: Maybe<Scalars['Boolean']['output']>;
  voucherCode?: Maybe<Scalars['String']['output']>;
};

export type ShoppingCartDto = {
  __typename?: 'ShoppingCartDto';
  brand?: Maybe<BrandDto>;
  country?: Maybe<CountryDto>;
  currency?: Maybe<CurrencyDto>;
  giftVoucherCode?: Maybe<Scalars['String']['output']>;
  giftVoucherDeduction?: Maybe<Scalars['Decimal']['output']>;
  giftVoucherDownloadsOnly: Scalars['Boolean']['output'];
  items: Array<ShoppingCartItemDto>;
  promoCodeMessage?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<CustomerAddressDto>;
  shippingCost?: Maybe<Scalars['Decimal']['output']>;
  shippingMethod?: Maybe<Scalars['Int']['output']>;
  shippingTaxTotal?: Maybe<Scalars['Decimal']['output']>;
  storeCreditAvailable?: Maybe<Scalars['Decimal']['output']>;
  storeCreditToApply?: Maybe<Scalars['Decimal']['output']>;
  subTotal: Scalars['Decimal']['output'];
  subTotalIncVat?: Maybe<Scalars['Decimal']['output']>;
  taxBreakdownSource?: Maybe<Scalars['String']['output']>;
  taxCharged?: Maybe<Scalars['Decimal']['output']>;
  taxDescription?: Maybe<Scalars['String']['output']>;
  taxIncluded?: Maybe<Scalars['Decimal']['output']>;
  taxRate?: Maybe<Scalars['Decimal']['output']>;
  token: Scalars['String']['output'];
  useStoreCredit?: Maybe<Scalars['Boolean']['output']>;
  viPoints: Scalars['Int']['output'];
  voucherCode?: Maybe<Scalars['String']['output']>;
};

export type ShoppingCartFilterInput = {
  and?: InputMaybe<Array<ShoppingCartFilterInput>>;
  billingAddressId?: InputMaybe<IntOperationFilterInput>;
  brand?: InputMaybe<BrandFilterInput>;
  brandId?: InputMaybe<IntOperationFilterInput>;
  cartPurpose?: InputMaybe<IntOperationFilterInput>;
  country?: InputMaybe<CountryFilterInput>;
  countryId?: InputMaybe<IntOperationFilterInput>;
  currency?: InputMaybe<CurrencyFilterInput>;
  currencyId?: InputMaybe<IntOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  giftVoucherCode?: InputMaybe<StringOperationFilterInput>;
  guestEmail?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  openedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ShoppingCartFilterInput>>;
  orderCompleteDate?: InputMaybe<DateTimeOperationFilterInput>;
  shippingAddress?: InputMaybe<CustomerAddressFilterInput>;
  shippingAddressId?: InputMaybe<IntOperationFilterInput>;
  shippingCost?: InputMaybe<DecimalOperationFilterInput>;
  shippingMethod?: InputMaybe<IntOperationFilterInput>;
  shoppingCartItems?: InputMaybe<ListFilterInputTypeOfShoppingCartItemFilterInput>;
  token?: InputMaybe<UuidOperationFilterInput>;
  useStoreCredit?: InputMaybe<BooleanOperationFilterInput>;
  voucherCode?: InputMaybe<StringOperationFilterInput>;
};

export type ShoppingCartHeaderDto = {
  __typename?: 'ShoppingCartHeaderDto';
  totalQuantity: Scalars['Int']['output'];
};

export type ShoppingCartItem = {
  __typename?: 'ShoppingCartItem';
  addedTime: Scalars['DateTime']['output'];
  associatedOrderItem?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountDescription?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  inventoryStats: Array<InventoryStat>;
  metadata?: Maybe<Scalars['String']['output']>;
  optionId?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Decimal']['output'];
  product: Product;
  productId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  shoppingCart: ShoppingCart;
  shoppingCartId: Scalars['Int']['output'];
  tax?: Maybe<Scalars['Decimal']['output']>;
};

export type ShoppingCartItemDto = {
  __typename?: 'ShoppingCartItemDto';
  associatedOrderItemId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountDescription?: Maybe<Scalars['String']['output']>;
  discountTag?: Maybe<Scalars['String']['output']>;
  hazardous?: Maybe<Scalars['Boolean']['output']>;
  height?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['Int']['output'];
  isDiscounted: Scalars['Boolean']['output'];
  isDownload: Scalars['Boolean']['output'];
  isPreorder?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<Scalars['Decimal']['output']>;
  lineTaxTotal?: Maybe<Scalars['Decimal']['output']>;
  listPrice?: Maybe<Scalars['Decimal']['output']>;
  listPriceIncVat?: Maybe<Scalars['Decimal']['output']>;
  lowStock: Scalars['Boolean']['output'];
  manufacturerId?: Maybe<Scalars['Int']['output']>;
  masterclassAirsInNote?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  needsShipping: Scalars['Boolean']['output'];
  optionDescription?: Maybe<Scalars['String']['output']>;
  optionId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  priceIncVat?: Maybe<Scalars['Decimal']['output']>;
  productId: Scalars['Int']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  productTypeId?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  taxRate?: Maybe<Scalars['Decimal']['output']>;
  taxType?: Maybe<Scalars['Int']['output']>;
  thumbnailSrc?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Decimal']['output']>;
  width?: Maybe<Scalars['Decimal']['output']>;
};

export type ShoppingCartItemFilterInput = {
  addedTime?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<ShoppingCartItemFilterInput>>;
  associatedOrderItem?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  discountDescription?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  inventoryStats?: InputMaybe<ListFilterInputTypeOfInventoryStatFilterInput>;
  metadata?: InputMaybe<StringOperationFilterInput>;
  optionId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ShoppingCartItemFilterInput>>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  quantity?: InputMaybe<IntOperationFilterInput>;
  shoppingCart?: InputMaybe<ShoppingCartFilterInput>;
  shoppingCartId?: InputMaybe<IntOperationFilterInput>;
  tax?: InputMaybe<DecimalOperationFilterInput>;
};

export type ShoppingCartPaymentIntentDto = {
  __typename?: 'ShoppingCartPaymentIntentDto';
  clientSecret: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
  shoppingCartToken?: Maybe<Scalars['String']['output']>;
  stripePublicKey?: Maybe<Scalars['String']['output']>;
};

export type SidebarAdDto = {
  __typename?: 'SidebarAdDto';
  imageSrc?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SidebarAdDtoSortInput = {
  imageSrc?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type SidebarAdsCollectionSegment = {
  __typename?: 'SidebarAdsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<SidebarAdDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type State = {
  __typename?: 'State';
  abbreviation?: Maybe<Scalars['String']['output']>;
  country: Country;
  countryId: Scalars['Int']['output'];
  customerAddresses: Array<CustomerAddress>;
  id: Scalars['Int']['output'];
  isUsMilitaryBase: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type StateDto = {
  __typename?: 'StateDto';
  abbreviation?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryDto>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type StateDtoFilterInput = {
  abbreviation?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<StateDtoFilterInput>>;
  country?: InputMaybe<CountryDtoFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StateDtoFilterInput>>;
};

export type StateDtoSortInput = {
  abbreviation?: InputMaybe<SortEnumType>;
  country?: InputMaybe<CountryDtoSortInput>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type StateFilterInput = {
  abbreviation?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<StateFilterInput>>;
  country?: InputMaybe<CountryFilterInput>;
  countryId?: InputMaybe<IntOperationFilterInput>;
  customerAddresses?: InputMaybe<ListFilterInputTypeOfCustomerAddressFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isUsMilitaryBase?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StateFilterInput>>;
};

export type StockValidationResultDto = {
  __typename?: 'StockValidationResultDto';
  isValid: Scalars['Boolean']['output'];
  reducedQuantityItems: Array<ReducedQuantityItemDto>;
  unavailableItems: Array<UnavailableItemDto>;
};

export type StreamingProductDto = {
  __typename?: 'StreamingProductDto';
  creators: Array<CreatorDto>;
  dateAdded: Scalars['DateTime']['output'];
  endTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  optionId?: Maybe<Scalars['Int']['output']>;
  productId: Scalars['Int']['output'];
  rating: Scalars['Float']['output'];
  startTime?: Maybe<Scalars['DateTime']['output']>;
  thumbnailSrc?: Maybe<Scalars['String']['output']>;
  tierId?: Maybe<Scalars['Int']['output']>;
  urlStub?: Maybe<Scalars['String']['output']>;
};

export type StreamingProductDtoFilterInput = {
  and?: InputMaybe<Array<StreamingProductDtoFilterInput>>;
  creators?: InputMaybe<ListFilterInputTypeOfCreatorDtoFilterInput>;
  dateAdded?: InputMaybe<DateTimeOperationFilterInput>;
  endTime?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  optionId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<StreamingProductDtoFilterInput>>;
  productId?: InputMaybe<IntOperationFilterInput>;
  rating?: InputMaybe<FloatOperationFilterInput>;
  startTime?: InputMaybe<DateTimeOperationFilterInput>;
  thumbnailSrc?: InputMaybe<StringOperationFilterInput>;
  tierId?: InputMaybe<IntOperationFilterInput>;
  urlStub?: InputMaybe<StringOperationFilterInput>;
};

export type StreamingProductDtoSortInput = {
  dateAdded?: InputMaybe<SortEnumType>;
  endTime?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  optionId?: InputMaybe<SortEnumType>;
  productId?: InputMaybe<SortEnumType>;
  rating?: InputMaybe<SortEnumType>;
  startTime?: InputMaybe<SortEnumType>;
  thumbnailSrc?: InputMaybe<SortEnumType>;
  tierId?: InputMaybe<SortEnumType>;
  urlStub?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type StreamsCollectionSegment = {
  __typename?: 'StreamsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<StreamingProductDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** A segment of a collection. */
export type StudioVideosCollectionSegment = {
  __typename?: 'StudioVideosCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ProductListItemDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type SubmitCreatorProfileUpdateInput = {
  bio: Scalars['String']['input'];
  photoBase64: Scalars['String']['input'];
  photoFileName: Scalars['String']['input'];
  questionAnswers: Array<CreatorProfileQuestionAnswerInput>;
};

export type SubmitResult = {
  __typename?: 'SubmitResult';
  success: Scalars['Boolean']['output'];
  vimeoId?: Maybe<Scalars['String']['output']>;
};

export type SubmitReviewerApplicationInput = {
  aboutYou: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isInGoodStanding: Scalars['Boolean']['output'];
  isPaused: Scalars['Boolean']['output'];
  isTrial: Scalars['Boolean']['output'];
  nextBillingDate?: Maybe<Scalars['DateTime']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionProviderCode?: Maybe<Scalars['String']['output']>;
  subscriptionTier?: Maybe<Scalars['String']['output']>;
  trialEndDate?: Maybe<Scalars['DateTime']['output']>;
};

export type SubscriptionCancellation = {
  __typename?: 'SubscriptionCancellation';
  cancelledTime?: Maybe<Scalars['DateTime']['output']>;
  howTheyMightStay?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  subscriptionStatus?: Maybe<SubscriptionStatus>;
};

export type SubscriptionCancellationFilterInput = {
  and?: InputMaybe<Array<SubscriptionCancellationFilterInput>>;
  cancelledTime?: InputMaybe<DateTimeOperationFilterInput>;
  howTheyMightStay?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<SubscriptionCancellationFilterInput>>;
  reason?: InputMaybe<StringOperationFilterInput>;
  subscriptionId?: InputMaybe<IntOperationFilterInput>;
  subscriptionStatus?: InputMaybe<SubscriptionStatusFilterInput>;
};

export type SubscriptionEligibilityDto = {
  __typename?: 'SubscriptionEligibilityDto';
  hasDelinquentSubscription: Scalars['Boolean']['output'];
  hasHadSubscriptionBefore: Scalars['Boolean']['output'];
  hasPausedSubscription: Scalars['Boolean']['output'];
  isEligibleForTrial: Scalars['Boolean']['output'];
  isSubscriber: Scalars['Boolean']['output'];
};

export type SubscriptionPaymentRetryResultDto = {
  __typename?: 'SubscriptionPaymentRetryResultDto';
  status: SubscriptionPaymentRetryStatus;
};

export enum SubscriptionPaymentRetryStatus {
  Failed = 'FAILED',
  RequiresAction = 'REQUIRES_ACTION',
  Succeeded = 'SUCCEEDED',
  Unknown = 'UNKNOWN'
}

export type SubscriptionProviderAccount = {
  __typename?: 'SubscriptionProviderAccount';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subscriptionProviderId: Scalars['Int']['output'];
};

export type SubscriptionProviderAccountFilterInput = {
  and?: InputMaybe<Array<SubscriptionProviderAccountFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SubscriptionProviderAccountFilterInput>>;
  subscriptionProviderId?: InputMaybe<IntOperationFilterInput>;
};

export type SubscriptionStatus = {
  __typename?: 'SubscriptionStatus';
  customerId?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isInGoodStanding?: Maybe<Scalars['Boolean']['output']>;
  isPaused?: Maybe<Scalars['Boolean']['output']>;
  isTrial?: Maybe<Scalars['Boolean']['output']>;
  lastBillingDate?: Maybe<Scalars['DateTime']['output']>;
  lastStripePaymentEventCreatedUtc?: Maybe<Scalars['DateTime']['output']>;
  lastStripePaymentEventId?: Maybe<Scalars['String']['output']>;
  lastStripePaymentInvoiceId?: Maybe<Scalars['String']['output']>;
  lastStripePaymentState?: Maybe<Scalars['String']['output']>;
  nextBillingDate?: Maybe<Scalars['DateTime']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  subscriptionCancellation?: Maybe<SubscriptionCancellation>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionProviderAccount?: Maybe<SubscriptionProviderAccount>;
  subscriptionProviderAccountId?: Maybe<Scalars['Int']['output']>;
  subscriptionTier?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionStatusFilterInput = {
  and?: InputMaybe<Array<SubscriptionStatusFilterInput>>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isInGoodStanding?: InputMaybe<BooleanOperationFilterInput>;
  isPaused?: InputMaybe<BooleanOperationFilterInput>;
  isTrial?: InputMaybe<BooleanOperationFilterInput>;
  lastBillingDate?: InputMaybe<DateTimeOperationFilterInput>;
  lastStripePaymentEventCreatedUtc?: InputMaybe<DateTimeOperationFilterInput>;
  lastStripePaymentEventId?: InputMaybe<StringOperationFilterInput>;
  lastStripePaymentInvoiceId?: InputMaybe<StringOperationFilterInput>;
  lastStripePaymentState?: InputMaybe<StringOperationFilterInput>;
  nextBillingDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<SubscriptionStatusFilterInput>>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  subscriptionCancellation?: InputMaybe<SubscriptionCancellationFilterInput>;
  subscriptionId?: InputMaybe<StringOperationFilterInput>;
  subscriptionProviderAccount?: InputMaybe<SubscriptionProviderAccountFilterInput>;
  subscriptionProviderAccountId?: InputMaybe<IntOperationFilterInput>;
  subscriptionTier?: InputMaybe<IntOperationFilterInput>;
};

export enum SubscriptionTierEnum {
  Full = 'FULL',
  MasterclassOnly = 'MASTERCLASS_ONLY',
  None = 'NONE',
  ShowtimeOnly = 'SHOWTIME_ONLY'
}

export type SubscriptionTierEnumOperationFilterInput = {
  eq?: InputMaybe<SubscriptionTierEnum>;
  in?: InputMaybe<Array<SubscriptionTierEnum>>;
  neq?: InputMaybe<SubscriptionTierEnum>;
  nin?: InputMaybe<Array<SubscriptionTierEnum>>;
};

export type SurveyDto = {
  __typename?: 'SurveyDto';
  externalId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type TaxJarCorrectionResultDto = {
  __typename?: 'TaxJarCorrectionResultDto';
  abortReason?: Maybe<Scalars['String']['output']>;
  abortRowNumber?: Maybe<Scalars['Int']['output']>;
  aborted: Scalars['Boolean']['output'];
  createdRows: Scalars['Int']['output'];
  errorRows: Scalars['Int']['output'];
  rows: Array<TaxJarCorrectionRowDto>;
  skippedRows: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
  updatedRows: Scalars['Int']['output'];
  validRows: Scalars['Int']['output'];
};

export type TaxJarCorrectionRowDto = {
  __typename?: 'TaxJarCorrectionRowDto';
  action: Scalars['String']['output'];
  csvSalesTax?: Maybe<Scalars['Decimal']['output']>;
  dbCorrectedAmount?: Maybe<Scalars['Decimal']['output']>;
  dbCorrectedSalesTax?: Maybe<Scalars['Decimal']['output']>;
  dbLineSalesTaxTotal?: Maybe<Scalars['Decimal']['output']>;
  difference?: Maybe<Scalars['Decimal']['output']>;
  message: Scalars['String']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  rowNumber: Scalars['Int']['output'];
  taxJarAmount?: Maybe<Scalars['Decimal']['output']>;
  taxJarFound: Scalars['Boolean']['output'];
  taxJarLineSalesTaxTotal?: Maybe<Scalars['Decimal']['output']>;
  taxJarSalesTax?: Maybe<Scalars['Decimal']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
};

export type TaxJarOrderRangeResultDto = {
  __typename?: 'TaxJarOrderRangeResultDto';
  comparison: TaxJarCorrectionResultDto;
  fromTransactionDate: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  taxJarOrderCount: Scalars['Int']['output'];
  toTransactionDate: Scalars['String']['output'];
};

export type TaxJarRateLookupDto = {
  __typename?: 'TaxJarRateLookupDto';
  city?: Maybe<Scalars['String']['output']>;
  cityRate?: Maybe<Scalars['Decimal']['output']>;
  combinedDistrictRate?: Maybe<Scalars['Decimal']['output']>;
  combinedRate?: Maybe<Scalars['Decimal']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryRate?: Maybe<Scalars['Decimal']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  countyRate?: Maybe<Scalars['Decimal']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  freightTaxable?: Maybe<Scalars['Boolean']['output']>;
  lookupFailed: Scalars['Boolean']['output'];
  state?: Maybe<Scalars['String']['output']>;
  stateRate?: Maybe<Scalars['Decimal']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type TimeSpanOperationFilterInput = {
  eq?: InputMaybe<Scalars['TimeSpan']['input']>;
  gt?: InputMaybe<Scalars['TimeSpan']['input']>;
  gte?: InputMaybe<Scalars['TimeSpan']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']['input']>>>;
  lt?: InputMaybe<Scalars['TimeSpan']['input']>;
  lte?: InputMaybe<Scalars['TimeSpan']['input']>;
  neq?: InputMaybe<Scalars['TimeSpan']['input']>;
  ngt?: InputMaybe<Scalars['TimeSpan']['input']>;
  ngte?: InputMaybe<Scalars['TimeSpan']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']['input']>>>;
  nlt?: InputMaybe<Scalars['TimeSpan']['input']>;
  nlte?: InputMaybe<Scalars['TimeSpan']['input']>;
};

export type TopSellerDto = {
  __typename?: 'TopSellerDto';
  brandId?: Maybe<Scalars['Int']['output']>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberSold: Scalars['Int']['output'];
  onSale: Scalars['Boolean']['output'];
  timeCalculated: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type TrackingRecordDto = {
  __typename?: 'TrackingRecordDto';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryDto>;
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timeUpdated?: Maybe<Scalars['DateTime']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type UnavailableItemDto = {
  __typename?: 'UnavailableItemDto';
  availableQuantity: Scalars['Int']['output'];
  cartItemId: Scalars['Int']['output'];
  optionId?: Maybe<Scalars['Int']['output']>;
  optionName?: Maybe<Scalars['String']['output']>;
  productId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  requestedQuantity: Scalars['Int']['output'];
};

export type UpdateAdminCreatorInput = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  intro?: InputMaybe<Scalars['String']['input']>;
  menuPosition?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  paymentMethod?: InputMaybe<Scalars['Int']['input']>;
  photoFilename?: InputMaybe<Scalars['String']['input']>;
  urlStub?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCreatorPayPalAddressInput = {
  emailAddress: Scalars['String']['input'];
};

export type UpdateCustomerEmailInput = {
  email: Scalars['String']['input'];
  skipValidationWarnings: Scalars['Boolean']['input'];
};

export type UpdateCustomerEoriInput = {
  eoriNumber: Scalars['String']['input'];
};

export type UpdateCustomerVatInput = {
  vatNumber: Scalars['String']['input'];
};

export type UpdateOrderShippingAddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  stateCounty?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
  townCity: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type UpdateOrderShippingAddressResult = {
  __typename?: 'UpdateOrderShippingAddressResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  newAddressId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UploadAdminAssetInput = {
  base64Data: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  purpose: AdminAssetUploadPurpose;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export type ValidateAddressInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['Int']['input'];
  stateCounty?: InputMaybe<Scalars['String']['input']>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
  townCity: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type ValidateAddressResult = {
  __typename?: 'ValidateAddressResult';
  easyPostAddressId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
};

export type ValidateExplanationUniqueCodeResultDto = {
  __typename?: 'ValidateExplanationUniqueCodeResultDto';
  alreadyRedeemed?: Maybe<Scalars['Boolean']['output']>;
  isApp?: Maybe<Scalars['Boolean']['output']>;
  message: Scalars['String']['output'];
  productId?: Maybe<Scalars['Int']['output']>;
  requiresLogin?: Maybe<Scalars['Boolean']['output']>;
  status: ValidateExplanationUniqueCodeStatus;
};

export enum ValidateExplanationUniqueCodeStatus {
  Error = 'ERROR',
  ExplanationNotFound = 'EXPLANATION_NOT_FOUND',
  InvalidCode = 'INVALID_CODE',
  NotActivated = 'NOT_ACTIVATED',
  Valid = 'VALID',
  WrongProduct = 'WRONG_PRODUCT'
}

export type ViPointsLogDto = {
  __typename?: 'ViPointsLogDto';
  brandId: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  items?: Maybe<Array<ViPointsLogItemDto>>;
  pointsEarned: Scalars['Int']['output'];
  pointsSpent: Scalars['Int']['output'];
};

export type ViPointsLogItemDto = {
  __typename?: 'ViPointsLogItemDto';
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  reason: ViPointsLogReason;
  transactionDate?: Maybe<Scalars['DateTime']['output']>;
};

export type WishlistDto = {
  __typename?: 'WishlistDto';
  publicUrl: Scalars['String']['output'];
  showName: Scalars['Boolean']['output'];
};

export type WishlistItem = {
  __typename?: 'WishlistItem';
  brandId?: Maybe<Scalars['Int']['output']>;
  customer: Customer;
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  product: Product;
  productId: Scalars['Int']['output'];
  timeAdded: Scalars['DateTime']['output'];
  timeEmailed?: Maybe<Scalars['DateTime']['output']>;
  timePurchased?: Maybe<Scalars['DateTime']['output']>;
};

export type WishlistItemFilterInput = {
  and?: InputMaybe<Array<WishlistItemFilterInput>>;
  brandId?: InputMaybe<IntOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<WishlistItemFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<IntOperationFilterInput>;
  timeAdded?: InputMaybe<DateTimeOperationFilterInput>;
  timeEmailed?: InputMaybe<DateTimeOperationFilterInput>;
  timePurchased?: InputMaybe<DateTimeOperationFilterInput>;
};

export type WishlistProductDto = {
  __typename?: 'WishlistProductDto';
  blurb?: Maybe<Scalars['String']['output']>;
  creators?: Maybe<Array<CreatorDto>>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  displayPrice?: Maybe<Scalars['Decimal']['output']>;
  ebookBundleOption?: Maybe<EbookBundleOptionDto>;
  hasDownloads: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isPreorder?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options: Array<ProductOptionDto>;
  preorderRelease?: Maybe<Scalars['DateTime']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  salePrice?: Maybe<Scalars['Decimal']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  timeAdded: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  vanishingIncExclusive: Scalars['Boolean']['output'];
};

export type WishlistProductSort = {
  displayPrice?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  timeAdded?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type WishlistProductsCollectionSegment = {
  __typename?: 'WishlistProductsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<WishlistProductDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ViPointsLogReason {
  BirthdayGift = 'BIRTHDAY_GIFT',
  ConvertedToStoreCredit = 'CONVERTED_TO_STORE_CREDIT',
  EarnedFromOrder = 'EARNED_FROM_ORDER',
  ManuallyGiven = 'MANUALLY_GIVEN',
  PostedReview = 'POSTED_REVIEW',
  ProductBonus = 'PRODUCT_BONUS',
  Refund = 'REFUND',
  SpentPoints = 'SPENT_POINTS',
  SubscriptionBonus = 'SUBSCRIPTION_BONUS',
  SubscriptionRenewal = 'SUBSCRIPTION_RENEWAL'
}

export type AddCustomerToSegmentMutationVariables = Exact<{
  segmentId: Scalars['Int']['input'];
  workspace?: InputMaybe<CustomerIoWorkspace>;
}>;


export type AddCustomerToSegmentMutation = { __typename?: 'Mutation', addCustomerToSegment: boolean };

export type AddEbookBundleToShoppingCartMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  physicalOptionId: Scalars['Int']['input'];
  downloadOptionId: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddEbookBundleToShoppingCartMutation = { __typename?: 'Mutation', addEbookBundleToShoppingCart: boolean };

export type AddItemToShoppingCartMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
}>;


export type AddItemToShoppingCartMutation = { __typename?: 'Mutation', addItemToShoppingCart: boolean };

export type AddItemToWishlistMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type AddItemToWishlistMutation = { __typename?: 'Mutation', addItemToWishList: number };

export type AddRestockAlertMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  optionId?: InputMaybe<Scalars['Int']['input']>;
  brandId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddRestockAlertMutation = { __typename?: 'Mutation', addRestockAlert: boolean };

export type AssignCartToCustomerMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
}>;


export type AssignCartToCustomerMutation = { __typename?: 'Mutation', assignCartToCustomer: boolean };

export type CancelSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  howTheyMightStay: Scalars['String']['input'];
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription: boolean };

export type CaptureShoppingCartPayPalOrderAndCompleteCartMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  paypalOrderId: Scalars['String']['input'];
  addToNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  prepayImportDuties?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CaptureShoppingCartPayPalOrderAndCompleteCartMutation = { __typename?: 'Mutation', captureShoppingCartPayPalOrderAndCompleteCart: number };

export type CompleteManualPaymentMutationVariables = Exact<{
  paymentIntentId: Scalars['String']['input'];
  amount: Scalars['Decimal']['input'];
  currency: Scalars['String']['input'];
}>;


export type CompleteManualPaymentMutation = { __typename?: 'Mutation', completeManualPayment: boolean };

export type CompleteShoppingCartAsAdminWithoutOnlinePaymentMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  mode: AdminShoppingCartCompletionMode;
  addToNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  prepayImportDuties?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CompleteShoppingCartAsAdminWithoutOnlinePaymentMutation = { __typename?: 'Mutation', completeShoppingCartAsAdminWithoutOnlinePayment: number };

export type CompleteShoppingCartWithStripePaymentMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  paymentIntentId: Scalars['String']['input'];
  addToNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  prepayImportDuties?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CompleteShoppingCartWithStripePaymentMutation = { __typename?: 'Mutation', completeShoppingCartWithStripePayment: number };

export type CompleteShoppingCartWithoutPaymentMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  addToNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  prepayImportDuties?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CompleteShoppingCartWithoutPaymentMutation = { __typename?: 'Mutation', completeShoppingCartWithoutPayment: number };

export type ConfirmReturnImageUploadMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
  orderItemId: Scalars['Int']['input'];
  fileName: Scalars['String']['input'];
}>;


export type ConfirmReturnImageUploadMutation = { __typename?: 'Mutation', confirmReturnImageUpload: boolean };

export type ConvertPointsToStoreCreditMutationVariables = Exact<{
  brandId: Scalars['Int']['input'];
  currencyId: Scalars['Int']['input'];
}>;


export type ConvertPointsToStoreCreditMutation = { __typename?: 'Mutation', convertPointsToStoreCredit: { __typename?: 'ConvertPointsToStoreCreditResultDto', pointsConverted: number, storeCreditAmount: number, currencyId: number } };

export type ConvertVoucherToStoreCreditMutationVariables = Exact<{
  brandId: Scalars['Int']['input'];
  voucherCode: Scalars['String']['input'];
}>;


export type ConvertVoucherToStoreCreditMutation = { __typename?: 'Mutation', convertVoucherToStoreCredit: { __typename?: 'ConvertVoucherToStoreCreditResultDto', amount: number, currencyId: number } };

export type CreateAnonymousShoppingCartMutationVariables = Exact<{
  countryIsoCode: Scalars['String']['input'];
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  isConventionCart?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateAnonymousShoppingCartMutation = { __typename?: 'Mutation', createAnonymousShoppingCart: string };

export type CreateBlogCommentMutationVariables = Exact<{
  customerId: Scalars['Int']['input'];
  blogPostId: Scalars['Int']['input'];
  comment: Scalars['String']['input'];
  responseTo?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateBlogCommentMutation = { __typename?: 'Mutation', createBlogComment: boolean };

export type CreateCustomerMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  howSignedUp?: InputMaybe<Scalars['Int']['input']>;
  addToNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  skipEmailValidation?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer: { __typename?: 'CreateCustomerResultDto', success: boolean, customerId?: number | null, message: string, emailValidation: { __typename?: 'EmailValidationResultDto', isValid: boolean, errorType: EmailValidationErrorEnum, errorMessage?: string | null, suggestion?: string | null, correctedEmail?: string | null } } };

export type CreateCustomerAddressMutationVariables = Exact<{
  customerId: Scalars['Int']['input'];
  input: CreateCustomerAddressInput;
  shoppingCartToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCustomerAddressMutation = { __typename?: 'Mutation', createCustomerAddress: { __typename?: 'CreateCustomerAddressResult', addressId: number, isValidated?: boolean | null, validationErrorMessage?: string | null } };

export type CreateCustomerBrandLinkMutationVariables = Exact<{
  brandId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateCustomerBrandLinkMutation = { __typename?: 'Mutation', createCustomerBrandLink: boolean };

export type CreateCustomerReviewMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  rating: Scalars['Int']['input'];
  review?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCustomerReviewMutation = { __typename?: 'Mutation', createCustomerReview: boolean };

export type CreateCustomerShoppingCartMutationVariables = Exact<{
  customerId: Scalars['Int']['input'];
  countryIsoCode: Scalars['String']['input'];
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  forceNew?: InputMaybe<Scalars['Boolean']['input']>;
  isConventionCart?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateCustomerShoppingCartMutation = { __typename?: 'Mutation', createCustomerShoppingCart: string };

export type CreateInstructionLinkMutationVariables = Exact<{
  instructionLink: Scalars['String']['input'];
  productName: Scalars['String']['input'];
  instructionPassword?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateInstructionLinkMutation = { __typename?: 'Mutation', createInstructionLink: boolean };

export type CreateManualPaymentIntentMutationVariables = Exact<{
  amount: Scalars['Decimal']['input'];
  currency: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  cardholderName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateManualPaymentIntentMutation = { __typename?: 'Mutation', createManualPaymentIntent: { __typename?: 'ShoppingCartPaymentIntentDto', paymentIntentId: string, clientSecret: string, stripePublicKey?: string | null } };

export type CreatePaymentMethodSetupTokenMutationVariables = Exact<{
  brandId: Scalars['Int']['input'];
}>;


export type CreatePaymentMethodSetupTokenMutation = { __typename?: 'Mutation', createPaymentMethodSetupToken: string };

export type CreateProductQuestionMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  question: Scalars['String']['input'];
  responseTo?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateProductQuestionMutation = { __typename?: 'Mutation', createProductQuestion: { __typename?: 'QuestionDto', id: number, customerId: number, customerName?: string | null, question?: string | null, responseTo?: number | null, answers: Array<{ __typename?: 'AnswerDto', id: number, customerId: number, customerName?: string | null, answer?: string | null, isCreator: boolean, responseTo?: number | null }> } };

export type CreateReturnMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
  items: Array<ReturnRequestItemDtoInput> | ReturnRequestItemDtoInput;
}>;


export type CreateReturnMutation = { __typename?: 'Mutation', createReturn: boolean };

export type CreateShoppingCartPayPalOrderMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  prepayImportDuties?: InputMaybe<Scalars['Boolean']['input']>;
  lockShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateShoppingCartPayPalOrderMutation = { __typename?: 'Mutation', createShoppingCartPayPalOrder: { __typename?: 'PaypalOrderDto', paypalOrderId: string } };

export type CreateShoppingCartPaymentIntentMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  paymentMethodType?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  prepayImportDuties?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateShoppingCartPaymentIntentMutation = { __typename?: 'Mutation', createShoppingCartPaymentIntent: { __typename?: 'ShoppingCartPaymentIntentDto', paymentIntentId: string, clientSecret: string, stripePublicKey?: string | null } };

export type DeactivateAppDeviceMutationVariables = Exact<{
  deviceId: Scalars['Int']['input'];
}>;


export type DeactivateAppDeviceMutation = { __typename?: 'Mutation', deactivateAppDevice: { __typename?: 'GeneralReturnType', success: boolean, message?: string | null } };

export type DeleteCustomerAddressMutationVariables = Exact<{
  customerAddressId: Scalars['Int']['input'];
}>;


export type DeleteCustomerAddressMutation = { __typename?: 'Mutation', deleteCustomerAddress: { __typename?: 'GeneralReturnType', success: boolean } };

export type DeleteCustomerPaymentMethodMutationVariables = Exact<{
  brandId: Scalars['Int']['input'];
  paymentMethodId: Scalars['String']['input'];
}>;


export type DeleteCustomerPaymentMethodMutation = { __typename?: 'Mutation', deleteCustomerPaymentMethod: boolean };

export type DeleteCustomerReviewMutationVariables = Exact<{
  reviewId: Scalars['Int']['input'];
}>;


export type DeleteCustomerReviewMutation = { __typename?: 'Mutation', deleteCustomerReview: boolean };

export type DeleteInstructionLinkMutationVariables = Exact<{
  instructionLinkId: Scalars['Int']['input'];
}>;


export type DeleteInstructionLinkMutation = { __typename?: 'Mutation', deleteInstructionLink: boolean };

export type GrantFreeDownloadMutationVariables = Exact<{
  customerId: Scalars['Int']['input'];
  brandId: Scalars['Int']['input'];
  productSlug: Scalars['String']['input'];
}>;


export type GrantFreeDownloadMutation = { __typename?: 'Mutation', grantFreeDownload: { __typename?: 'GrantFreeDownloadResultDto', success: boolean, message: string, productId?: number | null, orderId?: number | null, alreadyHadAccess: boolean, productName?: string | null } };

export type MergeAnonymousShoppingCartMutationVariables = Exact<{
  anonymousCartToken: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
  countryIsoCode: Scalars['String']['input'];
}>;


export type MergeAnonymousShoppingCartMutation = { __typename?: 'Mutation', mergeAnonymousShoppingCart: { __typename?: 'MergeAnonymousShoppingCartResultDto', success: boolean, status: string, mergedItemCount: number, skippedItemCount: number, skippedReasonCodes: Array<string> } };

export type PauseSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['Int']['input'];
}>;


export type PauseSubscriptionMutation = { __typename?: 'Mutation', pauseSubscription: boolean };

export type PresignedUrlForReturnImageMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
  orderItemId: Scalars['Int']['input'];
  fileName: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
}>;


export type PresignedUrlForReturnImageMutation = { __typename?: 'Mutation', presignedUrlForReturnImage: string };

export type ReactivateSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['Int']['input'];
}>;


export type ReactivateSubscriptionMutation = { __typename?: 'Mutation', reactivateSubscription: boolean };

export type RecordProductLiveChatMessageMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  message: Scalars['String']['input'];
}>;


export type RecordProductLiveChatMessageMutation = { __typename?: 'Mutation', recordProductLiveChatMessage: { __typename?: 'ProductLiveChatMessageDto', id: number, message: string, timePosted: any, customerName: string, gravatarUrl?: string | null } };

export type RecoverPaidCheckoutMutationVariables = Exact<{
  paymentIntentId: Scalars['String']['input'];
}>;


export type RecoverPaidCheckoutMutation = { __typename?: 'Mutation', recoverPaidCheckout: { __typename?: 'CheckoutPaymentRecoveryStatusDto', paymentIntentId: string, status: string, message: string, paymentSucceeded: boolean, canRetry: boolean, orderId?: number | null, shoppingCartId?: number | null } };

export type RedeemDownloadCardMutationVariables = Exact<{
  customerId: Scalars['Int']['input'];
  brandId: Scalars['Int']['input'];
  code: Scalars['String']['input'];
  expectedProductId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RedeemDownloadCardMutation = { __typename?: 'Mutation', redeemDownloadCard: { __typename?: 'RedeemDownloadCardResultDto', status: RedeemDownloadCardStatus, message: string, productId?: number | null, orderId?: number | null } };

export type RefreshShoppingCartPricesMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
}>;


export type RefreshShoppingCartPricesMutation = { __typename?: 'Mutation', refreshShoppingCartPrices: boolean };

export type RegisterMagicStoreSignupMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  store?: InputMaybe<Scalars['String']['input']>;
  skipEmailValidation?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RegisterMagicStoreSignupMutation = { __typename?: 'Mutation', registerMagicStoreSignup: { __typename?: 'MagicStoreSignupResultDto', success: boolean, message: string, emailValidation: { __typename?: 'EmailValidationResultDto', isValid: boolean, errorType: EmailValidationErrorEnum, errorMessage?: string | null, suggestion?: string | null, correctedEmail?: string | null } } };

export type RemoveCartItemMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  cartItemId: Scalars['Int']['input'];
}>;


export type RemoveCartItemMutation = { __typename?: 'Mutation', removeItemFromCart: { __typename?: 'GeneralReturnType', success: boolean } };

export type RemoveCustomerFromSegmentMutationVariables = Exact<{
  segmentId: Scalars['Int']['input'];
  workspace?: InputMaybe<CustomerIoWorkspace>;
}>;


export type RemoveCustomerFromSegmentMutation = { __typename?: 'Mutation', removeCustomerFromSegment: boolean };

export type RemoveItemFromWishlistMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type RemoveItemFromWishlistMutation = { __typename?: 'Mutation', removeItemFromWishList: boolean };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset: boolean };

export type ResetPasswordMutationVariables = Exact<{
  hash: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
  newPassword: Scalars['String']['input'];
  confirmNewPassword: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type RetryPaymentMutationVariables = Exact<{
  subscriptionId: Scalars['Int']['input'];
}>;


export type RetryPaymentMutation = { __typename?: 'Mutation', retryPaymentWithResult: { __typename?: 'SubscriptionPaymentRetryResultDto', status: SubscriptionPaymentRetryStatus } };

export type SendWishlistEmailMutationVariables = Exact<{
  recipientEmail: Scalars['String']['input'];
  brandId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SendWishlistEmailMutation = { __typename?: 'Mutation', sendWishlistEmail: boolean };

export type SetDefaultCustomerPaymentMethodMutationVariables = Exact<{
  brandId: Scalars['Int']['input'];
  paymentMethodId: Scalars['String']['input'];
}>;


export type SetDefaultCustomerPaymentMethodMutation = { __typename?: 'Mutation', setDefaultCustomerPaymentMethod: boolean };

export type SetShoppingCartShippingFromAddressMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  address: ShippingAddressInput;
  shippingOptionId: Scalars['String']['input'];
  shippingOptionDescription: Scalars['String']['input'];
  shippingMethodId: Scalars['Int']['input'];
  estDelivery: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
  shippingRateHash: Scalars['String']['input'];
  currencySymbol: Scalars['String']['input'];
}>;


export type SetShoppingCartShippingFromAddressMutation = { __typename?: 'Mutation', setShoppingCartShippingFromAddress: boolean };

export type SubmitConsultingFormMutationVariables = Exact<{
  name: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  details: Scalars['String']['input'];
}>;


export type SubmitConsultingFormMutation = { __typename?: 'Mutation', submitConsultingForm: boolean };

export type SubmitContactFormMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  question: Scalars['String']['input'];
  orderNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubmitContactFormMutation = { __typename?: 'Mutation', submitContactForm: boolean };

export type SubmitJobApplicationMutationVariables = Exact<{
  turnstileToken: Scalars['String']['input'];
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  location: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
  jobSlug: Scalars['String']['input'];
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  cvBase64?: InputMaybe<Scalars['String']['input']>;
  cvFileName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubmitJobApplicationMutation = { __typename?: 'Mutation', submitJobApplication: boolean };

export type SubmitReviewerApplicationMutationVariables = Exact<{
  aboutYou: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type SubmitReviewerApplicationMutation = { __typename?: 'Mutation', submitReviewerApplication: boolean };

export type SubmitReviewerProductRequestMutationVariables = Exact<{
  input: ReviewerProductRequestInput;
}>;


export type SubmitReviewerProductRequestMutation = { __typename?: 'Mutation', submitReviewerProductRequest: boolean };

export type SubmitSupportSurveyMutationVariables = Exact<{
  externalId: Scalars['String']['input'];
  rating?: InputMaybe<Scalars['Int']['input']>;
  customerServiceRating: Scalars['Int']['input'];
  responseAttribution: Scalars['String']['input'];
  comments: Scalars['String']['input'];
  generalFeedback?: InputMaybe<Scalars['String']['input']>;
  followUpRequested: Scalars['Boolean']['input'];
}>;


export type SubmitSupportSurveyMutation = { __typename?: 'Mutation', submitSupportSurvey: { __typename?: 'SubmitResult', success: boolean, vimeoId?: string | null } };

export type SubmitTrickMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  trickName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubmitTrickMutation = { __typename?: 'Mutation', submitTrick: boolean };

export type UnPauseSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['Int']['input'];
}>;


export type UnPauseSubscriptionMutation = { __typename?: 'Mutation', unpauseSubscription: boolean };

export type UnsubscribeFromAllNewslettersMutationVariables = Exact<{
  workspace?: InputMaybe<CustomerIoWorkspace>;
}>;


export type UnsubscribeFromAllNewslettersMutation = { __typename?: 'Mutation', unsubscribeFromAllNewsletters: boolean };

export type UpdateCustomerBirthdayMutationVariables = Exact<{
  birthday: Scalars['DateTime']['input'];
}>;


export type UpdateCustomerBirthdayMutation = { __typename?: 'Mutation', updateCustomerBirthday: boolean };

export type UpdateCustomerEmailMutationVariables = Exact<{
  input: UpdateCustomerEmailInput;
}>;


export type UpdateCustomerEmailMutation = { __typename?: 'Mutation', updateCustomerEmail: { __typename?: 'EmailUpdateResult', success: boolean, errorMessage?: string | null, suggestion?: string | null, correctedEmail?: string | null, validationWarnings: Array<string> } };

export type UpdateCustomerEoriMutationVariables = Exact<{
  input: UpdateCustomerEoriInput;
}>;


export type UpdateCustomerEoriMutation = { __typename?: 'Mutation', updateCustomerEori: boolean };

export type UpdateCustomerReviewMutationVariables = Exact<{
  reviewId: Scalars['Int']['input'];
  rating: Scalars['Int']['input'];
  review?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateCustomerReviewMutation = { __typename?: 'Mutation', updateCustomerReview: boolean };

export type UpdateCustomerVatMutationVariables = Exact<{
  input: UpdateCustomerVatInput;
}>;


export type UpdateCustomerVatMutation = { __typename?: 'Mutation', updateCustomerVat: boolean };

export type UpdateDefaultCustomerAddressMutationVariables = Exact<{
  customerAddressId: Scalars['Int']['input'];
}>;


export type UpdateDefaultCustomerAddressMutation = { __typename?: 'Mutation', setDefaultCustomerAddress: boolean };

export type UpdateDownloadFileArchiveStatusMutationVariables = Exact<{
  productId: Scalars['Int']['input'];
  isArchived: Scalars['Boolean']['input'];
}>;


export type UpdateDownloadFileArchiveStatusMutation = { __typename?: 'Mutation', updateDownloadFileArchiveStatus: boolean };

export type UpdateDownloadFileLastAccessPointMutationVariables = Exact<{
  downloadFileId: Scalars['Int']['input'];
  lastAccessPoint: Scalars['Int']['input'];
}>;


export type UpdateDownloadFileLastAccessPointMutation = { __typename?: 'Mutation', updateDownloadFileLastAccessPoint: boolean };

export type UpdateGuestCheckoutCustomerProfileMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
}>;


export type UpdateGuestCheckoutCustomerProfileMutation = { __typename?: 'Mutation', updateGuestCheckoutCustomerProfile: { __typename?: 'EmailUpdateResult', success: boolean, errorMessage?: string | null } };

export type UpdateGuestCheckoutEmailMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
}>;


export type UpdateGuestCheckoutEmailMutation = { __typename?: 'Mutation', updateGuestCheckoutEmail: { __typename?: 'EmailUpdateResult', success: boolean, errorMessage?: string | null, suggestion?: string | null, correctedEmail?: string | null, validationWarnings: Array<string> } };

export type UpdateInstructionLinkMutationVariables = Exact<{
  instructionLinkId: Scalars['Int']['input'];
  instructionLink: Scalars['String']['input'];
  productName: Scalars['String']['input'];
  instructionPassword?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateInstructionLinkMutation = { __typename?: 'Mutation', updateInstructionLink: boolean };

export type UpdateInvoiceExtraInfoMutationVariables = Exact<{
  brandId: Scalars['Int']['input'];
  extraInfo?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateInvoiceExtraInfoMutation = { __typename?: 'Mutation', updateInvoiceExtraInfo: boolean };

export type UpdateOrderShippingAddressMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
  input: UpdateOrderShippingAddressInput;
}>;


export type UpdateOrderShippingAddressMutation = { __typename?: 'Mutation', updateOrderShippingAddress: { __typename?: 'UpdateOrderShippingAddressResult', success: boolean, errorMessage?: string | null, newAddressId?: number | null } };

export type UpdatePasswordMutationVariables = Exact<{
  newPassword: Scalars['String']['input'];
  confirmNewPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: boolean };

export type UpdatePrivateWishlistSettingMutationVariables = Exact<{
  isPrivate: Scalars['Boolean']['input'];
}>;


export type UpdatePrivateWishlistSettingMutation = { __typename?: 'Mutation', updatePrivateWishlistSetting: boolean };

export type UpdateShoppingCartItemPriceMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  shoppingCartItemId: Scalars['Int']['input'];
  newPrice: Scalars['Decimal']['input'];
}>;


export type UpdateShoppingCartItemPriceMutation = { __typename?: 'Mutation', updateShoppingCartItemPrice: boolean };

export type UpdateShoppingCartItemQtyMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  shoppingCartItemId: Scalars['Int']['input'];
  newQty: Scalars['Int']['input'];
}>;


export type UpdateShoppingCartItemQtyMutation = { __typename?: 'Mutation', updateShoppingCartItemQty: boolean };

export type UpdateShoppingCartLocationMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  countryIsoCode: Scalars['String']['input'];
}>;


export type UpdateShoppingCartLocationMutation = { __typename?: 'Mutation', updateShoppingCartLocation: boolean };

export type UpdateShoppingCartPromoCodeMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  promoCode: Scalars['String']['input'];
}>;


export type UpdateShoppingCartPromoCodeMutation = { __typename?: 'Mutation', updateShoppingCartPromoCode: { __typename?: 'PromoCodeResultType', success: boolean, status: PromoCodeStatusType, message: string, voucherCode?: string | null } };

export type UpdateShoppingCartShippingAddressMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  shippingAddressId: Scalars['Int']['input'];
}>;


export type UpdateShoppingCartShippingAddressMutation = { __typename?: 'Mutation', updateShoppingCartShippingAddress: boolean };

export type UpdateShoppingCartShippingOptionMutationVariables = Exact<{
  brandCode: Scalars['String']['input'];
  shoppingCartToken: Scalars['String']['input'];
  id: Scalars['String']['input'];
  description: Scalars['String']['input'];
  shippingMethodId: Scalars['Int']['input'];
  estDelivery: Scalars['String']['input'];
  price: Scalars['Decimal']['input'];
  shippingRateHash: Scalars['String']['input'];
  currencySymbol: Scalars['String']['input'];
  destinationCountryOverride?: InputMaybe<Scalars['String']['input']>;
  destinationZipOverride?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateShoppingCartShippingOptionMutation = { __typename?: 'Mutation', updateShoppingCartShippingOption: boolean };

export type UpdateShoppingCartUseStoreCreditMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  useStoreCredit: Scalars['Boolean']['input'];
}>;


export type UpdateShoppingCartUseStoreCreditMutation = { __typename?: 'Mutation', updateShoppingCartUseStoreCredit?: { __typename?: 'ShoppingCartDto', token: string, useStoreCredit?: boolean | null, storeCreditAvailable?: number | null, storeCreditToApply?: number | null, subTotal: number, shippingCost?: number | null, taxCharged?: number | null, taxIncluded?: number | null, taxDescription?: string | null, giftVoucherDeduction?: number | null, currency?: { __typename?: 'CurrencyDto', id: number, symbol?: string | null } | null } | null };

export type ValidateCustomerAddressMutationVariables = Exact<{
  input: ValidateAddressInput;
}>;


export type ValidateCustomerAddressMutation = { __typename?: 'Mutation', validateCustomerAddress: { __typename?: 'ValidateAddressResult', isValid: boolean, easyPostAddressId?: string | null, errorMessage?: string | null } };

export type ValidateExplanationUniqueCodeMutationVariables = Exact<{
  slug: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type ValidateExplanationUniqueCodeMutation = { __typename?: 'Mutation', validateExplanationUniqueCode: { __typename?: 'ValidateExplanationUniqueCodeResultDto', status: ValidateExplanationUniqueCodeStatus, message: string, productId?: number | null, isApp?: boolean | null, requiresLogin?: boolean | null, alreadyRedeemed?: boolean | null } };

export type AddConventionRegistrationBundleToShoppingCartMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  conventionProductId: Scalars['Int']['input'];
  registrationOptionId?: InputMaybe<Scalars['Int']['input']>;
  registrants: Array<ConventionRegistrantInputDtoInput> | ConventionRegistrantInputDtoInput;
  paymentPlan?: InputMaybe<ConventionPaymentPlanInputDtoInput>;
  bypassSoldOut?: Scalars['Boolean']['input'];
}>;


export type AddConventionRegistrationBundleToShoppingCartMutation = { __typename?: 'Mutation', addConventionRegistrationBundleToShoppingCart: boolean };

export type AddConventionUpgradeToShoppingCartMutationVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  registrationOrderItemId: Scalars['Int']['input'];
}>;


export type AddConventionUpgradeToShoppingCartMutation = { __typename?: 'Mutation', addConventionUpgradeToShoppingCart: boolean };

export type AddConventionWaitingListMutationVariables = Exact<{
  conventionProductId: Scalars['Int']['input'];
  registrationOptionId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddConventionWaitingListMutation = { __typename?: 'Mutation', addConventionWaitingList: boolean };

export type LinkCreatorAccountMutationVariables = Exact<{
  creatorId: Scalars['Int']['input'];
  hash?: InputMaybe<Scalars['String']['input']>;
}>;


export type LinkCreatorAccountMutation = { __typename?: 'Mutation', linkCreatorAccount: boolean };

export type SubmitCreatorProfileUpdateMutationVariables = Exact<{
  bio: Scalars['String']['input'];
  photoBase64: Scalars['String']['input'];
  photoFileName: Scalars['String']['input'];
  questionAnswers: Array<CreatorProfileQuestionAnswerInput> | CreatorProfileQuestionAnswerInput;
}>;


export type SubmitCreatorProfileUpdateMutation = { __typename?: 'Mutation', submitCreatorProfileUpdate: boolean };

export type UpdateCreatorPayPalAddressMutationVariables = Exact<{
  input: UpdateCreatorPayPalAddressInput;
}>;


export type UpdateCreatorPayPalAddressMutation = { __typename?: 'Mutation', updateCreatorPayPalAddress: boolean };

export type SupportSurveyByExternalIdQueryVariables = Exact<{
  externalId: Scalars['String']['input'];
}>;


export type SupportSurveyByExternalIdQuery = { __typename?: 'Query', supportSurveyByExternalId?: { __typename?: 'SurveyDto', id: number, externalId: string } | null };

export type ValidateResetLinkQueryVariables = Exact<{
  hash: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
}>;


export type ValidateResetLinkQuery = { __typename?: 'Query', validateResetLink: boolean };

export type HomepageCarouselQueryVariables = Exact<{
  brandCode: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
}>;


export type HomepageCarouselQuery = { __typename?: 'Query', homepageCarouselBanners: Array<{ __typename?: 'CarouselBannerDto', id: number, name?: string | null, altText?: string | null, imageSrc?: string | null, url?: string | null }> };

export type SidebarAdsQueryVariables = Exact<{
  brandCode: Scalars['String']['input'];
}>;


export type SidebarAdsQuery = { __typename?: 'Query', sidebarAds?: { __typename?: 'SidebarAdsCollectionSegment', items?: Array<{ __typename?: 'SidebarAdDto', imageSrc?: string | null, name?: string | null, url?: string | null }> | null } | null };

export type CustomerAppsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CustomerAppsQuery = { __typename?: 'Query', appProductsForCustomer?: { __typename?: 'AppProductsForCustomerCollectionSegment', items?: Array<{ __typename?: 'AppDeviceProductDto', activeDeviceCount?: number | null, productId: number, productName: string, allowedDeviceCount?: number | null, thumbnailUrl?: string | null, licenseCode?: string | null, installUrls?: Array<{ __typename?: 'ProductMetaDto', key: string, value: string } | null> | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type ProductAppDevicesQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type ProductAppDevicesQuery = { __typename?: 'Query', appDevicesForProduct?: { __typename?: 'AppDeviceProductDto', productId: number, productName: string, activeDeviceCount?: number | null, allowedDeviceCount?: number | null, thumbnailUrl?: string | null, devices: Array<{ __typename?: 'AppDeviceDto', id: number, productId: number, productName: string, lastInstallDate?: any | null, deactivatedDate?: any | null, deviceName?: string | null }>, installUrls?: Array<{ __typename?: 'ProductMetaDto', key: string, value: string } | null> | null } | null };

export type BrandStoreQueryVariables = Exact<{
  brandCode: Scalars['String']['input'];
}>;


export type BrandStoreQuery = { __typename?: 'Query', productsByCategorySlug?: { __typename?: 'ProductsByCategorySlugCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EcommProductDto', id: number, name?: string | null, url?: string | null, hasDownloads: boolean, displayPrice?: number | null, vanishingIncExclusive: boolean, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null, square?: string | null, video?: string | null } | null, options: Array<{ __typename?: 'ProductOptionDto', id?: number | null, description?: string | null, price: number, salePrice?: number | null, inStock: boolean, productType?: { __typename?: 'ProductTypeDto', id: number, name?: string | null } | null, currency?: { __typename?: 'CurrencyDto', symbol?: string | null } | null }> }> | null } | null };

export type CategoriesQueryVariables = Exact<{
  order?: InputMaybe<Array<CategoryDtoSortInput> | CategoryDtoSortInput>;
}>;


export type CategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'CategoryDto', id: number, name?: string | null, urlStub?: string | null, intro?: string | null, metaDescription?: string | null }> };

export type CategoryQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type CategoryQuery = { __typename?: 'Query', categoryBySlug?: { __typename?: 'CategoryDto', id: number, intro?: string | null, name?: string | null } | null };

export type CategoryProductsQueryVariables = Exact<{
  categorySlug: Scalars['String']['input'];
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  brandCode: Scalars['String']['input'];
  includeChildCategories: Scalars['Boolean']['input'];
  maxBlurbLength: Scalars['Int']['input'];
  order?: InputMaybe<Array<ProductByCategorySort> | ProductByCategorySort>;
  where?: InputMaybe<ProductByCategoryFilter>;
  productTypeGroup?: InputMaybe<Scalars['String']['input']>;
}>;


export type CategoryProductsQuery = { __typename?: 'Query', productsByCategorySlug?: { __typename?: 'ProductsByCategorySlugCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EcommProductDto', id: number, name?: string | null, url?: string | null, blurb?: string | null, hasDownloads: boolean, displayPrice?: number | null, vanishingIncExclusive: boolean, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null, square?: string | null, video?: string | null } | null, options: Array<{ __typename?: 'ProductOptionDto', id?: number | null, description?: string | null, price: number, salePrice?: number | null, priceIncVat?: number | null, salePriceIncVat?: number | null, taxType?: number | null, inStock: boolean, productType?: { __typename?: 'ProductTypeDto', id: number, name?: string | null } | null, currency?: { __typename?: 'CurrencyDto', symbol?: string | null, code?: string | null } | null }>, productType?: { __typename?: 'ProductTypeDto', name?: string | null, id: number } | null, creators: Array<{ __typename?: 'CreatorDto', id: number, name?: string | null, urlStub?: string | null }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CheckEmailExistsQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type CheckEmailExistsQuery = { __typename?: 'Query', checkEmailExists: boolean };

export type ArticleQueryVariables = Exact<{
  urlStub: Scalars['String']['input'];
  brandCode: Scalars['String']['input'];
}>;


export type ArticleQuery = { __typename?: 'Query', articleBySlug?: { __typename?: 'BlogPostDto', id: number, urlStub?: string | null, url: string, title?: string | null, content?: string | null, blurb?: string | null, authorName?: string | null, datePosted: any, category?: { __typename?: 'BlogCategoryDto', name?: string | null, urlStub?: string | null } | null } | null };

export type ArticleByPathQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  brandCode: Scalars['String']['input'];
}>;


export type ArticleByPathQuery = { __typename?: 'Query', articleBySlug?: { __typename?: 'BlogPostDto', id: number, urlStub?: string | null, title?: string | null, content?: string | null, authorName?: string | null, datePosted: any } | null };

export type ArticlesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  brandCode: Scalars['String']['input'];
}>;


export type ArticlesQuery = { __typename?: 'Query', articles?: { __typename?: 'ArticlesCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BlogPostDto', id: number, blurb?: string | null, thumbnailSrc: string, title?: string | null, urlStub?: string | null, authorName?: string | null, datePosted: any, url: string, category?: { __typename?: 'BlogCategoryDto', id: number, name?: string | null, urlStub?: string | null } | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type BannerMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type BannerMessagesQuery = { __typename?: 'Query', bannerMessages: Array<{ __typename?: 'BannerMessageDto', endDate?: any | null, html?: string | null, id: number, name?: string | null, position?: number | null, startDate?: any | null }> };

export type BlogPagePostsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  brandCode: Scalars['String']['input'];
}>;


export type BlogPagePostsQuery = { __typename?: 'Query', blogPosts?: { __typename?: 'BlogPostsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'BlogPostDto', id: number, blurb?: string | null, title?: string | null, urlStub?: string | null, url: string, authorName?: string | null, thumbnailSrc: string, datePosted: any, category?: { __typename?: 'BlogCategoryDto', name?: string | null } | null }> | null } | null };

export type BlogPostQueryVariables = Exact<{
  urlStub: Scalars['String']['input'];
}>;


export type BlogPostQuery = { __typename?: 'Query', blogPostBySlug?: { __typename?: 'BlogPostDto', id: number, title?: string | null, content?: string | null, authorName?: string | null, datePosted: any, blurb?: string | null, thumbnailSrc: string, url: string, faqType?: string | null, comments: Array<{ __typename?: 'BlogCommentDto', id: number, customerId: number, comment: string, time: any, responseTo?: number | null, customerName: string, gravatarUrl?: string | null }>, relatedPosts: Array<{ __typename?: 'BlogPostDto', id: number, title?: string | null, urlStub?: string | null, url: string, blurb?: string | null, authorName?: string | null, datePosted: any, thumbnailSrc: string, category?: { __typename?: 'BlogCategoryDto', name?: string | null } | null }> } | null };

export type BookReviewQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type BookReviewQuery = { __typename?: 'Query', bookReviewBySlug?: { __typename?: 'BookReviewDto', authorName?: string | null, blurb?: string | null, content?: string | null, datePosted: any, productSlug?: string | null, thumbnailSrc?: string | null, title?: string | null, type?: number | null, url: string, urlStub?: string | null } | null };

export type BookReviewsQueryVariables = Exact<{
  brandId: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  where?: InputMaybe<BookReviewDtoFilterInput>;
}>;


export type BookReviewsQuery = { __typename?: 'Query', bookReviews?: { __typename?: 'BookReviewsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BookReviewDto', authorName?: string | null, datePosted: any, id: number, live: boolean, title?: string | null, url: string }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CategoryBlogPostsQueryVariables = Exact<{
  categorySlug: Scalars['String']['input'];
  brandCode: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CategoryBlogPostsQuery = { __typename?: 'Query', pagesByCategory?: { __typename?: 'PagesByCategoryCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'BlogPostDto', id: number, blurb?: string | null, title?: string | null, urlStub?: string | null, url: string, authorName?: string | null, thumbnailSrc: string, datePosted: any, category?: { __typename?: 'BlogCategoryDto', name?: string | null, urlStub?: string | null } | null }> | null } | null };

export type FaqQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type FaqQuery = { __typename?: 'Query', faqBySlug?: { __typename?: 'BlogPostDto', title?: string | null, id: number, content?: string | null, authorName?: string | null, faqType?: string | null, category?: { __typename?: 'BlogCategoryDto', name?: string | null } | null } | null };

export type FaqsQueryVariables = Exact<{ [key: string]: never; }>;


export type FaqsQuery = { __typename?: 'Query', faqs: Array<{ __typename?: 'BlogPostDto', id: number, title?: string | null, faqType?: string | null, urlStub?: string | null }> };

export type FeaturedBlogPostsQueryVariables = Exact<{
  brandCode: Scalars['String']['input'];
}>;


export type FeaturedBlogPostsQuery = { __typename?: 'Query', blogPosts?: { __typename?: 'BlogPostsCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'BlogPostDto', id: number, blurb?: string | null, title?: string | null, urlStub?: string | null, authorName?: string | null, datePosted: any, category?: { __typename?: 'BlogCategoryDto', name?: string | null } | null }> | null } | null };

export type InsiderPodcastPostsQueryVariables = Exact<{
  brandCode: Scalars['String']['input'];
  categoryName: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InsiderPodcastPostsQuery = { __typename?: 'Query', blogPosts?: { __typename?: 'BlogPostsCollectionSegment', items?: Array<{ __typename?: 'BlogPostDto', id: number, title?: string | null, urlStub?: string | null, url: string, thumbnailSrc: string, datePosted: any }> | null } | null };

export type ConventionOrderItemQueryVariables = Exact<{
  orderItemId: Scalars['Int']['input'];
}>;


export type ConventionOrderItemQuery = { __typename?: 'Query', conventionOrderItem?: { __typename?: 'ConventionRegistrationDto', id: number, orderId: number, productId: number, conventionName: string, registrantName?: string | null, url?: string | null, priceCharged: number, thumbnailSrc?: string | null, optionDescription?: string | null, conventionStartDate?: string | null, conventionEndDate?: string | null, conventionLocation?: string | null, order?: { __typename?: 'OrderDto', id: number, orderDate: any, currency?: { __typename?: 'CurrencyDto', id: number, code?: string | null, symbol?: string | null } | null } | null, paymentInfo?: { __typename?: 'ConventionPaymentInfoDto', totalAmount: number, totalPaid: number, remainingAmount: number, hasPaymentCard: boolean, isCardExpired: boolean, defaultCard?: { __typename?: 'ConventionStripeCardDto', brand: string, last4: string, expMonth: number, expYear: number } | null } | null, paymentInstallments: Array<{ __typename?: 'ConventionPaymentInstallmentDto', description: string, dueDate?: any | null, paidDate?: any | null, amount: number, isPaid: boolean, isExtraPayment: boolean }>, upgrade?: { __typename?: 'ConventionUpgradeDto', isAvailable: boolean, amount: number, currencyId: number, unavailableReason?: string | null } | null } | null };

export type ConventionRegistrationProductQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  brandCode: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConventionRegistrationProductQuery = { __typename?: 'Query', ecommProductBySlug?: { __typename?: 'EcommProductDto', id: number, name?: string | null, displayPrice?: number | null, currencySymbol?: string | null, options: Array<{ __typename?: 'ProductOptionDto', id?: number | null, description?: string | null, price: number, salePrice?: number | null, priceIncVat?: number | null, salePriceIncVat?: number | null, maxQuantity?: number | null, currency?: { __typename?: 'CurrencyDto', symbol?: string | null, code?: string | null } | null }>, meta: Array<{ __typename?: 'ProductMetaDto', key: string, value: string }> } | null };

export type ConventionRegistrationsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ConventionTimeFilterEnum>;
}>;


export type ConventionRegistrationsQuery = { __typename?: 'Query', conventionRegistrations?: { __typename?: 'ConventionRegistrationsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ConventionRegistrationDto', id: number, conventionName: string, registrantName?: string | null, thumbnailSrc?: string | null, optionDescription?: string | null, conventionStartDate?: string | null, order?: { __typename?: 'OrderDto', statusDescription?: string | null } | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CreatorByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CreatorByIdQuery = { __typename?: 'Query', creatorById?: { __typename?: 'CreatorDto', id: number, name?: string | null, urlStub?: string | null, intro?: string | null, emailAddress?: string | null, paymentMethod?: number | null } | null };

export type CreatorContractUrlQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
  creatorId: Scalars['Int']['input'];
}>;


export type CreatorContractUrlQuery = { __typename?: 'Query', creatorContractUrl?: string | null };

export type CreatorInfoQueryVariables = Exact<{
  creatorId: Scalars['Int']['input'];
}>;


export type CreatorInfoQuery = { __typename?: 'Query', creatorById?: { __typename?: 'CreatorDto', id: number, name?: string | null, urlStub?: string | null, intro?: string | null, emailAddress?: string | null, paymentMethod?: number | null } | null };

export type CreatorOwedStatementQueryVariables = Exact<{
  creatorId: Scalars['Int']['input'];
}>;


export type CreatorOwedStatementQuery = { __typename?: 'Query', creatorOwedStatement: Array<{ __typename?: 'CreatorOwedStatementRowDto', productId: number, optionId?: number | null, productName: string, productUrlStub?: string | null, thumbnailUrl?: string | null, optionDescription?: string | null, displayName: string, isDownload: boolean, isGrossPayment: boolean, lastPaymentDate?: any | null, retailUnits: number, wholesaleUnits: number, retailRoyalties: number, wholesaleRoyalties: number, totalRoyalties: number, priorMonthBalance: number, newExpenses: number, totalPayable: number, notes?: string | null }> };

export type CreatorPaymentByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CreatorPaymentByIdQuery = { __typename?: 'Query', creatorPaymentById?: { __typename?: 'CreatorPaymentDto', id: number, creatorId: number, datePaid?: any | null, amount?: number | null, method: number, description?: string | null, dateProcessed?: any | null } | null };

export type CreatorPaymentsQueryVariables = Exact<{
  creatorId: Scalars['Int']['input'];
}>;


export type CreatorPaymentsQuery = { __typename?: 'Query', paymentsForCreator: Array<{ __typename?: 'CreatorPaymentDto', id: number, creatorId: number, datePaid?: any | null, amount?: number | null, method: number, description?: string | null, dateProcessed?: any | null }> };

export type CreatorProductByIdQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
  creatorId: Scalars['Int']['input'];
  optionId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreatorProductByIdQuery = { __typename?: 'Query', creatorProductById?: { __typename?: 'CreatorProductDto', id: number, name?: string | null, urlStub: string, thumbnailUrl?: string | null, percentageToCreator: number, payPerUnit?: number | null, meta: Array<{ __typename?: 'ProductMetaDto', id: number, key: string, value: string }> } | null };

export type CreatorProductsQueryVariables = Exact<{
  creatorId: Scalars['Int']['input'];
}>;


export type CreatorProductsQuery = { __typename?: 'Query', productsThatRequireCreatorPayment: Array<{ __typename?: 'FlattenedProductDto', productId: number, optionId?: number | null, displayName: string, productName: string, optionDescription?: string | null, productUrlStub?: string | null, thumbnailUrl?: string | null }> };

export type CreatorSystemMessageQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CreatorSystemMessageQuery = { __typename?: 'Query', blogPostById?: { __typename?: 'BlogPostDto', id: number, content?: string | null } | null };

export type FinanceLogForProductQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
  optionId?: InputMaybe<Scalars['Int']['input']>;
  creatorId: Scalars['Int']['input'];
}>;


export type FinanceLogForProductQuery = { __typename?: 'Query', financeLogForProduct?: { __typename?: 'FinanceLogDto', productId: number, productName: string, optionId?: number | null, optionDescription?: string | null, percentageToCreator: number, isGrossPayment: boolean, profit: number, amountPaid: number, amountOwed: number, footerText?: string | null, items?: Array<{ __typename?: 'FinanceLogItemDto', date: any, quantity?: number | null, category?: string | null, description: string, amount: number, isInternal: boolean } | null> | null } | null };

export type MagicianQueryVariables = Exact<{
  magicianSlug: Scalars['String']['input'];
}>;


export type MagicianQuery = { __typename?: 'Query', creatorBySlug?: { __typename?: 'CreatorDto', id: number, name?: string | null, urlStub?: string | null, intro?: string | null } | null };

export type MagicianProductsQueryVariables = Exact<{
  magicianSlug: Scalars['String']['input'];
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  brandCode: Scalars['String']['input'];
  maxBlurbLength: Scalars['Int']['input'];
  order?: InputMaybe<Array<ProductByCategorySort> | ProductByCategorySort>;
}>;


export type MagicianProductsQuery = { __typename?: 'Query', productsByCreatorSlug?: { __typename?: 'ProductsByCreatorSlugCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EcommProductDto', id: number, name?: string | null, url?: string | null, blurb?: string | null, hasDownloads: boolean, displayPrice?: number | null, vanishingIncExclusive: boolean, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null, video?: string | null } | null, options: Array<{ __typename?: 'ProductOptionDto', id?: number | null, description?: string | null, price: number, salePrice?: number | null, priceIncVat?: number | null, salePriceIncVat?: number | null, taxType?: number | null, inStock: boolean, productType?: { __typename?: 'ProductTypeDto', id: number, name?: string | null } | null, currency?: { __typename?: 'CurrencyDto', symbol?: string | null } | null }>, productType?: { __typename?: 'ProductTypeDto', name?: string | null, id: number } | null, creators: Array<{ __typename?: 'CreatorDto', id: number, name?: string | null, urlStub?: string | null }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type PaymentLogsForCreatorPaymentQueryVariables = Exact<{
  creatorPaymentId: Scalars['Int']['input'];
}>;


export type PaymentLogsForCreatorPaymentQuery = { __typename?: 'Query', paymentLogsForCreatorPayment: Array<{ __typename?: 'CreatorPaymentLogDto', id: number, creatorPaymentId: number, productId: number, total: number, brandId?: number | null, productOptionId?: number | null, productName?: string | null, productThumbnailUrl?: string | null, productUrlStub?: string | null, productOptionDescription?: string | null, isDownload: boolean, salesCount?: number | null, retailSalesCount?: number | null, wholesaleSalesCount?: number | null, productMeta: Array<{ __typename?: 'ProductMetaDto', id: number, key: string, value: string }> }> };

export type PaymentLogsForProductAndCreatorQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
  creatorId: Scalars['Int']['input'];
}>;


export type PaymentLogsForProductAndCreatorQuery = { __typename?: 'Query', paymentLogsForProductAndCreator: Array<{ __typename?: 'CreatorPaymentLogDto', id: number, creatorPaymentId: number, productId: number, total: number, brandId?: number | null, productOptionId?: number | null, productName?: string | null, productThumbnailUrl?: string | null, productUrlStub?: string | null, productOptionDescription?: string | null, paymentDatePaid?: any | null, paymentMethod?: number | null, productMeta: Array<{ __typename?: 'ProductMetaDto', id: number, key: string, value: string }> }> };

export type ProductsWithAmountsOwedQueryVariables = Exact<{
  creatorId: Scalars['Int']['input'];
}>;


export type ProductsWithAmountsOwedQuery = { __typename?: 'Query', productsWithAmountsOwed: Array<{ __typename?: 'ProductAmountOwedDto', productId: number, productName: string, productUrlStub?: string | null, thumbnailUrl?: string | null, optionId?: number | null, optionDescription?: string | null, isDownload: boolean, isGrossPayment: boolean, amount: number, retailAmount: number, wholesaleAmount: number, salesCount: number, retailSalesCount: number, wholesaleSalesCount: number, notes?: string | null }> };

export type CustomerAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerAddressesQuery = { __typename?: 'Query', customerAddresses: Array<{ __typename?: 'CustomerAddressDto', addressLine1?: string | null, city?: string | null, id: number, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, addressLine2?: string | null, zip?: string | null, isDefault: boolean, dateLastUsed?: any | null, country?: { __typename?: 'CountryDto', id: number, isoCode: string, name: string } | null, state?: { __typename?: 'StateDto', id: number, name?: string | null } | null }> };

export type CustomerBirthdayQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerBirthdayQuery = { __typename?: 'Query', customer?: { __typename?: 'CustomerDto', birthday?: any | null } | null };

export type CustomerCreatorIdQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerCreatorIdQuery = { __typename?: 'Query', customer?: { __typename?: 'CustomerDto', creatorId?: number | null, firstName: string, lastName: string, emailAddress: string, isReviewer: boolean } | null };

export type CustomerDigitalLibraryQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  order?: InputMaybe<Array<DigitalLibraryItemDtoSortInput> | DigitalLibraryItemDtoSortInput>;
  where?: InputMaybe<DigitalLibraryFilter>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomerDigitalLibraryQuery = { __typename?: 'Query', digitalLibrary?: { __typename?: 'DigitalLibraryCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'DigitalLibraryItemDto', id: number, name?: string | null, thumbnailSrc?: string | null, dateAdded?: any | null, productId?: number | null, productType?: string | null, isMasterclass: boolean, isArchived: boolean, firstCreatorName?: string | null, creatorNames?: string | null, creators: Array<{ __typename?: 'CreatorDto', id: number, name?: string | null }>, files?: Array<{ __typename?: 'DownloadFileDto', type: string }> | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CustomerEmailQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerEmailQuery = { __typename?: 'Query', customer?: { __typename?: 'CustomerDto', emailAddress: string } | null };

export type CustomerEoriNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerEoriNumberQuery = { __typename?: 'Query', customer?: { __typename?: 'CustomerDto', eoriNumber?: string | null } | null };

export type CustomerOrdersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrderDtoSortInput> | OrderDtoSortInput>;
}>;


export type CustomerOrdersQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'OrderDto', orderDate: any, id: number, itemCount: number, statusDescription?: string | null, totalPrice: number, currency?: { __typename?: 'CurrencyDto', code?: string | null, id: number, symbol?: string | null } | null, orderItems?: Array<{ __typename?: 'OrderItemDto', productName: string }> | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasPreviousPage: boolean, hasNextPage: boolean } } | null };

export type CustomerProductInstructionsQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  order?: InputMaybe<Array<ProductInstructionDtoSortInput> | ProductInstructionDtoSortInput>;
  search: Scalars['String']['input'];
}>;


export type CustomerProductInstructionsQuery = { __typename?: 'Query', customerProductInstructions?: { __typename?: 'CustomerProductInstructionsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ProductInstructionDto', id?: number | null, name?: string | null, productId?: number | null, isManuallyAdded: boolean, thumbnailSrc?: string | null, instructionLink?: string | null, password?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CustomerRequiresPasswordSetQueryVariables = Exact<{
  customerId: Scalars['Int']['input'];
}>;


export type CustomerRequiresPasswordSetQuery = { __typename?: 'Query', customerRequiresPasswordSet: boolean };

export type CustomerReviewQueryVariables = Exact<{
  reviewId: Scalars['Int']['input'];
}>;


export type CustomerReviewQuery = { __typename?: 'Query', customerReview?: { __typename?: 'CustomerReviewDto', id: number, productId: number, productName?: string | null, productURL?: string | null, rating?: number | null, review?: string | null, reviewDate: any, reviewerName?: string | null, thumbnail?: string | null, status?: number | null } | null };

export type CustomerReviewsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerReviewSort> | CustomerReviewSort>;
}>;


export type CustomerReviewsQuery = { __typename?: 'Query', customerReviews?: { __typename?: 'CustomerReviewsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'CustomerReviewDto', id: number, productId: number, productName?: string | null, productURL?: string | null, rating?: number | null, review?: string | null, reviewDate: any, reviewerName?: string | null, thumbnail?: string | null, status?: number | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CustomerSegmentsQueryVariables = Exact<{
  workspace?: InputMaybe<CustomerIoWorkspace>;
}>;


export type CustomerSegmentsQuery = { __typename?: 'Query', customerSegments?: { __typename?: 'CustomerSegmentsResponseDto', segments?: Array<{ __typename?: 'CustomerSegmentDto', id: number, name?: string | null, description?: string | null } | null> | null } | null };

export type CustomerVatNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerVatNumberQuery = { __typename?: 'Query', customer?: { __typename?: 'CustomerDto', vatNumber?: string | null } | null };

export type PurchasedProductExportRowsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PurchasedProductExportRowsQuery = { __typename?: 'Query', purchasedProductExportRows?: { __typename?: 'PurchasedProductExportRowsCollectionSegment', items?: Array<{ __typename?: 'PurchasedProductExportRowDto', orderId: number, productName?: string | null, productPageUrl?: string | null, purchasedDate: any, productType?: string | null, creators: Array<{ __typename?: 'CreatorDto', name?: string | null }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean } } | null };

export type ReviewerProductsCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type ReviewerProductsCustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'CustomerDto', isReviewer: boolean } | null };

export type StoreCreditBalanceQueryVariables = Exact<{
  brandId: Scalars['Int']['input'];
  currencyId: Scalars['Int']['input'];
}>;


export type StoreCreditBalanceQuery = { __typename?: 'Query', storeCreditBalance: number };

export type CustomerDigitalLibraryArchiveQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  order?: InputMaybe<Array<DigitalLibraryItemDtoSortInput> | DigitalLibraryItemDtoSortInput>;
  where?: InputMaybe<DigitalLibraryFilter>;
}>;


export type CustomerDigitalLibraryArchiveQuery = { __typename?: 'Query', digitalLibrary?: { __typename?: 'DigitalLibraryCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'DigitalLibraryItemDto', id: number, name?: string | null, thumbnailSrc?: string | null, productId?: number | null, isArchived: boolean, firstCreatorName?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type DigitalLibraryItemQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type DigitalLibraryItemQuery = { __typename?: 'Query', digitalLibraryItem?: { __typename?: 'DigitalLibraryItemDto', id: number, name?: string | null, downloadIntro?: string | null, thumbnailSrc?: string | null, productId?: number | null, creators: Array<{ __typename?: 'CreatorDto', name?: string | null }>, masterclassDownloadQa: { __typename?: 'MasterclassDownloadQaDto', showQaSection: boolean, creatorDisplayName?: string | null, productSlug?: string | null, questions: Array<{ __typename?: 'QuestionDto', id: number, customerId: number, customerName?: string | null, question?: string | null, upvotes?: number | null, answers: Array<{ __typename?: 'AnswerDto', id: number, customerId: number, customerName?: string | null, answer?: string | null, isCreator: boolean, responseTo?: number | null }> }> }, files?: Array<{ __typename?: 'DownloadFileDto', type: string, vtt?: string | null, title?: string | null, lastAccessPoint?: number | null, duration?: number | null, id: number, name?: string | null, lectureStartTime?: any | null, downloadLink?: string | null, playbackSources?: { __typename?: 'VideoPlaybackSourcesDto', streamingLink: string, originalStreamingLink?: string | null } | null, chapters: Array<{ __typename?: 'DownloadFileChapterDto', title: string }> }> | null } | null };

export type DirectDownloadUrlForProductQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
}>;


export type DirectDownloadUrlForProductQuery = { __typename?: 'Query', digitalLibraryItem?: { __typename?: 'DigitalLibraryItemDto', directDownloadUrl?: string | null, files?: Array<{ __typename?: 'DownloadFileDto', id: number, title?: string | null }> | null } | null };

export type EbookImageUrlQueryVariables = Exact<{
  imagePath: Scalars['String']['input'];
}>;


export type EbookImageUrlQuery = { __typename?: 'Query', ebookImageURL: string };

export type MasterclassQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type MasterclassQuery = { __typename?: 'Query', masterclassBySlug?: { __typename?: 'EcommProductDto', id: number, name?: string | null, creators: Array<{ __typename?: 'CreatorDto', name?: string | null }> } | null };

export type MasterclassItemQueryVariables = Exact<{
  urlStub: Scalars['String']['input'];
}>;


export type MasterclassItemQuery = { __typename?: 'Query', masterclassItem?: { __typename?: 'DigitalLibraryItemDto', id: number, name?: string | null, productId?: number | null, downloadIntro?: string | null, masterclassDownloadQa: { __typename?: 'MasterclassDownloadQaDto', showQaSection: boolean, creatorDisplayName?: string | null, productSlug?: string | null, questions: Array<{ __typename?: 'QuestionDto', id: number, customerId: number, customerName?: string | null, question?: string | null, upvotes?: number | null, answers: Array<{ __typename?: 'AnswerDto', id: number, customerId: number, customerName?: string | null, answer?: string | null, isCreator: boolean, responseTo?: number | null }> }> }, files?: Array<{ __typename?: 'DownloadFileDto', id: number, type: string, title?: string | null, downloadLink?: string | null, lastAccessPoint?: number | null, duration?: number | null, vtt?: string | null, playbackSources?: { __typename?: 'VideoPlaybackSourcesDto', streamingLink: string, originalStreamingLink?: string | null } | null }> | null } | null };

export type MasterclassLibraryQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  order?: InputMaybe<Array<MasterclassDtoSortInput> | MasterclassDtoSortInput>;
}>;


export type MasterclassLibraryQuery = { __typename?: 'Query', masterclassStreamingLibrary?: { __typename?: 'MasterclassStreamingLibraryCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'MasterclassDto', id: number, name?: string | null, thumbnailSrc?: string | null, urlStub?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type StudioItemQueryVariables = Exact<{
  urlStub: Scalars['String']['input'];
}>;


export type StudioItemQuery = { __typename?: 'Query', studioItem?: { __typename?: 'DigitalLibraryItemDto', id: number, name?: string | null, productId?: number | null, downloadIntro?: string | null, files?: Array<{ __typename?: 'DownloadFileDto', id: number, type: string, title?: string | null, downloadLink?: string | null, lastAccessPoint?: number | null, duration?: number | null, vtt?: string | null, playbackSources?: { __typename?: 'VideoPlaybackSourcesDto', streamingLink: string, originalStreamingLink?: string | null } | null }> | null } | null };

export type StudioVideosQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  order?: InputMaybe<Array<ProductListItemDtoSortInput> | ProductListItemDtoSortInput>;
}>;


export type StudioVideosQuery = { __typename?: 'Query', studioVideos?: { __typename?: 'StudioVideosCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ProductListItemDto', dateAdded: any, id: number, name?: string | null, rating: number, thumbnailSrc?: string | null, urlStub?: string | null, creatorDisplayName?: string | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type UpcomingStudioVideosQueryVariables = Exact<{ [key: string]: never; }>;


export type UpcomingStudioVideosQuery = { __typename?: 'Query', upComingStudioVideos: Array<{ __typename?: 'ProductListItemDto', name?: string | null, urlStub?: string | null, thumbnailSrc?: string | null, creatorDisplayName?: string | null }> };

export type ExplanationPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExplanationPageQuery = { __typename?: 'Query', explanationPage?: { __typename?: 'ExplanationPageDto', productId: number, name?: string | null, urlSlug?: string | null, downloadUrl?: string | null, meta: Array<{ __typename?: 'ProductMetaDto', id: number, key: string, value: string }>, downloadFiles: Array<{ __typename?: 'ExplanationDownloadFileDto', id: number, title?: string | null, fileType?: string | null, filePath?: string | null, position?: number | null, bunnyId?: string | null, vtt?: string | null }> } | null };

export type ExplanationSlugByPasswordQueryVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type ExplanationSlugByPasswordQuery = { __typename?: 'Query', explanationSlugByPassword?: string | null };

export type GetExplanationQueryVariables = Exact<{
  explanationSlug: Scalars['String']['input'];
}>;


export type GetExplanationQuery = { __typename?: 'Query', explanationBySlug?: { __typename?: 'ExplanationDto', id: number, name?: string | null, thumbnailSrc?: string | null, hasPassword: boolean, requiresUniqueCode: boolean, requiresLogin: boolean, promptText?: string | null, iosInstallLink?: string | null, androidInstallLink?: string | null } | null };

export type GalleriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GalleriesQuery = { __typename?: 'Query', galleries: Array<{ __typename?: 'GalleryDto', id: number, title?: string | null, intro?: string | null, photographer?: string | null, urlstub?: string | null, year?: number | null, leadPhotoUrl?: string | null }> };

export type GalleryByUrlStubQueryVariables = Exact<{
  urlStub: Scalars['String']['input'];
}>;


export type GalleryByUrlStubQuery = { __typename?: 'Query', galleryByUrlStub?: { __typename?: 'GalleryDto', id: number, title?: string | null, intro?: string | null, photographer?: string | null, urlstub?: string | null, year?: number | null, leadPhotoUrl?: string | null } | null };

export type GalleryPhotosQueryVariables = Exact<{
  galleryId: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type GalleryPhotosQuery = { __typename?: 'Query', galleryPhotosCount: number, galleryPhotos: Array<{ __typename?: 'GalleryPhotoDto', id: number, galleryId: number, filePath: string, title?: string | null, description?: string | null, imageUrl: string }> };

export type RecentGalleriesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecentGalleriesQuery = { __typename?: 'Query', recentGalleries: Array<{ __typename?: 'GalleryDto', id: number, title?: string | null, intro?: string | null, photographer?: string | null, urlstub?: string | null, year?: number | null, leadPhotoUrl?: string | null }> };

export type JobsQueryVariables = Exact<{ [key: string]: never; }>;


export type JobsQuery = { __typename?: 'Query', blogPosts?: { __typename?: 'BlogPostsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'BlogPostDto', thumbnailSrc: string, urlStub?: string | null, id: number, title?: string | null, category?: { __typename?: 'BlogCategoryDto', id: number, name?: string | null, urlStub?: string | null } | null }> | null } | null };

export type JobsByBrandQueryVariables = Exact<{
  brandCode: Scalars['String']['input'];
}>;


export type JobsByBrandQuery = { __typename?: 'Query', pagesByCategory?: { __typename?: 'PagesByCategoryCollectionSegment', items?: Array<{ __typename?: 'BlogPostDto', id: number, thumbnailSrc: string, urlStub?: string | null, title?: string | null, live: boolean }> | null } | null };

export type CountriesQueryVariables = Exact<{
  order?: InputMaybe<Array<CountryDtoSortInput> | CountryDtoSortInput>;
}>;


export type CountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'CountryDto', id: number, name: string, isoCode: string, brandCode: string, currencyCode: string }> };

export type CountryShippingStatusQueryVariables = Exact<{
  isoCode: Scalars['String']['input'];
}>;


export type CountryShippingStatusQuery = { __typename?: 'Query', countryByIsoCode?: { __typename?: 'CountryDto', id: number, isoCode: string, freeShipping: boolean } | null };

export type CurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrenciesQuery = { __typename?: 'Query', currencies: Array<{ __typename?: 'CurrencyDto', code?: string | null, id: number, symbol?: string | null }> };

export type EcommBrandByCountryQueryVariables = Exact<{
  country: Scalars['String']['input'];
}>;


export type EcommBrandByCountryQuery = { __typename?: 'Query', ecommBrandByCountry?: { __typename?: 'BrandDto', id: number, name?: string | null, currency?: { __typename?: 'CurrencyDto', id: number, code?: string | null, symbol?: string | null } | null } | null };

export type StatesQueryVariables = Exact<{
  countryId: Scalars['Int']['input'];
}>;


export type StatesQuery = { __typename?: 'Query', states: Array<{ __typename?: 'StateDto', abbreviation?: string | null, id: number, name?: string | null, country?: { __typename?: 'CountryDto', id: number, name: string } | null }> };

export type NewsletterMarketingDefaultPreCheckedQueryVariables = Exact<{
  countryIsoCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type NewsletterMarketingDefaultPreCheckedQuery = { __typename?: 'Query', newsletterMarketingDefaultPreChecked: boolean };

export type NewsletterSubscribeQueryVariables = Exact<{
  customerId: Scalars['Int']['input'];
  countryIsoCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type NewsletterSubscribeQuery = { __typename?: 'Query', newsletterSubscribe: { __typename?: 'NewsletterSubscribeCheckoutDto', showMainCheckoutUpsell: boolean, defaultMainNewsletterPreChecked: boolean } };

export type CheckoutPaymentRecoveryStatusQueryVariables = Exact<{
  paymentIntentId: Scalars['String']['input'];
}>;


export type CheckoutPaymentRecoveryStatusQuery = { __typename?: 'Query', checkoutPaymentRecoveryStatus: { __typename?: 'CheckoutPaymentRecoveryStatusDto', paymentIntentId: string, status: string, message: string, paymentSucceeded: boolean, canRetry: boolean, orderId?: number | null, shoppingCartId?: number | null } };

export type CustomerReturnsQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
}>;


export type CustomerReturnsQuery = { __typename?: 'Query', returnsForCustomer?: { __typename?: 'ReturnsForCustomerCollectionSegment', totalCount: number, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'ReturnDto', id: number, dateReceived?: any | null, dateRequested: any, status?: string | null, returnTracking: string, shippingRefundAmount: number, order?: { __typename?: 'OrderDto', id: number } | null, items: Array<{ __typename?: 'ReturnRequestItemDto', id?: number | null, orderItemId: number, reasonId: number, notes: string, action: string, product?: { __typename?: 'EcommProductDto', name?: string | null } | null }> }> | null } | null };

export type InTransitPackagesQueryVariables = Exact<{ [key: string]: never; }>;


export type InTransitPackagesQuery = { __typename?: 'Query', inTransitPackagesForCustomer: Array<{ __typename?: 'InTransitPackageDto', orderId: number, orderDate: any, trackingNumber?: string | null, trackingUrl?: string | null }> };

export type OrderQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type OrderQuery = { __typename?: 'Query', order?: { __typename?: 'OrderDto', id: number, orderDate: any, statusDescription?: string | null, totalPrice: number, totalTax: number, shippingPrice?: number | null, shippingMethod?: number | null, itemCount: number, canChangeShippingAddress: boolean, currency?: { __typename?: 'CurrencyDto', id: number, symbol?: string | null, code?: string | null } | null, packages?: Array<{ __typename?: 'PackageDto', id: number, deliveredDate?: any | null, dispatchedDate?: any | null, errorDescription?: string | null, service?: string | null, shippingMethod?: string | null, status?: string | null, trackingNumber?: string | null, carrier?: { __typename?: 'CarrierDto', name: string, contactPhone: string, logoUrl: string } | null, orderItems: Array<{ __typename?: 'OrderItemDto', id: number, productName: string }> }> | null, timeline?: Array<{ __typename?: 'OrderTimelineItemDto', id: number, time: any, note: string, noteType: string }> | null, orderItems?: Array<{ __typename?: 'OrderItemDto', id: number, productId: number, instructionLink?: string | null, priceCharged: number, quantity: number, returnId?: number | null, tax?: number | null, productName: string, productType: string, optionDescription?: string | null, hasInstructions: boolean, hasDownloads: boolean, dispatchedDate?: any | null, thumbnailSrc?: string | null, url?: string | null, needsShipping: boolean }> | null, shippingAddress?: { __typename?: 'CustomerAddressDto', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, id: number, firstName?: string | null, lastName?: string | null, zip?: string | null, country?: { __typename?: 'CountryDto', id: number, isoCode: string, name: string } | null, state?: { __typename?: 'StateDto', id: number, name?: string | null } | null } | null } | null };

export type OrderByPaymentIntentIdQueryVariables = Exact<{
  paymentIntentId: Scalars['String']['input'];
}>;


export type OrderByPaymentIntentIdQuery = { __typename?: 'Query', orderByPaymentIntentId?: { __typename?: 'OrderDto', id: number, orderDate: any, statusDescription?: string | null, totalPrice: number, currency?: { __typename?: 'CurrencyDto', id: number, symbol?: string | null, code?: string | null } | null } | null };

export type OrderItemQueryVariables = Exact<{
  orderItemId: Scalars['Int']['input'];
}>;


export type OrderItemQuery = { __typename?: 'Query', orderItem?: { __typename?: 'OrderItemDto', id: number, productId: number, instructionLink?: string | null, orderId: number, priceCharged: number, quantity: number, tax?: number | null, productName: string, productType: string, hasInstructions: boolean, hasDownloads: boolean, dispatchedDate?: any | null, thumbnailSrc?: string | null, url?: string | null, needsShipping: boolean, returnId?: number | null, description?: string | null, optionId?: number | null, optionDescription?: string | null, order?: { __typename?: 'OrderDto', id: number, orderDate: any, currency?: { __typename?: 'CurrencyDto', id: number, symbol?: string | null, code?: string | null } | null } | null, productMeta: Array<{ __typename?: 'ProductMetaDto', key: string, value: string }> } | null };

export type OrderItemsToReturnQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type OrderItemsToReturnQuery = { __typename?: 'Query', itemsToReturnForOrder: { __typename?: 'ReturnEligibilityResponseDto', explanation?: string | null, items: Array<{ __typename?: 'OrderItemReturnEligibilityDto', id: string, productId: number, productName: string, returnEligibilityMessage?: string | null, availableReturnActions: Array<{ __typename?: 'ReturnActionDto', action: ReturnAction, description: string }>, availableReturnReasons: Array<{ __typename?: 'ReturnReasonDto', id: number, description: string }> }> } };

export type ReturnQueryVariables = Exact<{
  returnId: Scalars['Int']['input'];
}>;


export type ReturnQuery = { __typename?: 'Query', return?: { __typename?: 'ReturnDto', id: number, dateReceived?: any | null, dateRequested: any, status?: string | null, returnTracking: string, shippingRefundAmount: number, returnNotes?: string | null, returnDetails: string, order?: { __typename?: 'OrderDto', id: number } | null, items: Array<{ __typename?: 'ReturnRequestItemDto', id?: number | null, orderItemId: number, reasonId: number, reason: string, notes: string, action: string, requestedAction: string, files: Array<string>, product?: { __typename?: 'EcommProductDto', name?: string | null, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null } | null } | null }> } | null };

export type CountriesWithoutFreeShippingQueryVariables = Exact<{
  brandCode: Scalars['String']['input'];
}>;


export type CountriesWithoutFreeShippingQuery = { __typename?: 'Query', countriesWithoutFreeShipping: Array<{ __typename?: 'CountryDto', name: string }> };

export type DecksQueryVariables = Exact<{
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  brandCode: Scalars['String']['input'];
  order?: InputMaybe<Array<ProductByCategorySort> | ProductByCategorySort>;
  where?: InputMaybe<ProductByCategoryFilter>;
  inStockOnly: Scalars['Boolean']['input'];
}>;


export type DecksQuery = { __typename?: 'Query', productsByCategorySlug?: { __typename?: 'ProductsByCategorySlugCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EcommProductDto', id: number, name?: string | null, url?: string | null, blurb?: string | null, displayPrice?: number | null, thumbnails?: { __typename?: 'ProductThumbnailsDto', square?: string | null } | null, options: Array<{ __typename?: 'ProductOptionDto', id?: number | null, description?: string | null, price: number, salePrice?: number | null, priceIncVat?: number | null, salePriceIncVat?: number | null, taxType?: number | null, inStock: boolean, currency?: { __typename?: 'CurrencyDto', symbol?: string | null, code?: string | null } | null, productType?: { __typename?: 'ProductTypeDto', name?: string | null } | null }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type PlayingCardManufacturersQueryVariables = Exact<{ [key: string]: never; }>;


export type PlayingCardManufacturersQuery = { __typename?: 'Query', playingCardManufacturers: Array<{ __typename?: 'PlayingCardManufacturer', id: number, name: string, urlStub: string }> };

export type AllExclusiveProductsQueryVariables = Exact<{
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  brandCode: Scalars['String']['input'];
  maxBlurbLength: Scalars['Int']['input'];
  order?: InputMaybe<Array<ProductsSort> | ProductsSort>;
}>;


export type AllExclusiveProductsQuery = { __typename?: 'Query', ecommProducts?: { __typename?: 'EcommProductsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EcommProductDto', id: number, name?: string | null, url?: string | null, blurb?: string | null, displayPrice?: number | null, vanishingIncExclusive: boolean, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null, square?: string | null, video?: string | null } | null, options: Array<{ __typename?: 'ProductOptionDto', id?: number | null, description?: string | null, price: number, salePrice?: number | null, priceIncVat?: number | null, salePriceIncVat?: number | null, taxType?: number | null, inStock: boolean, productType?: { __typename?: 'ProductTypeDto', id: number, name?: string | null } | null, currency?: { __typename?: 'CurrencyDto', symbol?: string | null } | null }>, productType?: { __typename?: 'ProductTypeDto', name?: string | null, id: number } | null, creators: Array<{ __typename?: 'CreatorDto', id: number, name?: string | null, urlStub?: string | null }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasPreviousPage: boolean, hasNextPage: boolean } } | null };

export type BeginnerProductsWithExplanationsQueryVariables = Exact<{
  categorySlug: Scalars['String']['input'];
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  brandCode: Scalars['String']['input'];
  includeChildCategories: Scalars['Boolean']['input'];
  maxBlurbLength: Scalars['Int']['input'];
  order?: InputMaybe<Array<ProductByCategorySort> | ProductByCategorySort>;
}>;


export type BeginnerProductsWithExplanationsQuery = { __typename?: 'Query', productsByCategorySlug?: { __typename?: 'ProductsByCategorySlugCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EcommProductDto', id: number, name?: string | null, url?: string | null, meta: Array<{ __typename?: 'ProductMetaDto', key: string, value: string }>, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null, video?: string | null } | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean } } | null };

export type CategoryProductCountsQueryVariables = Exact<{
  categoryIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type CategoryProductCountsQuery = { __typename?: 'Query', productCountsByCategories: Array<{ __typename?: 'KeyValuePairOfInt32AndInt32', key: number, value: number }> };

export type DiscoveryProductQueryVariables = Exact<{
  id: Scalars['String']['input'];
  brandCode: Scalars['String']['input'];
}>;


export type DiscoveryProductQuery = { __typename?: 'Query', productForDiscoverie?: { __typename?: 'ProductForDiscoverieDto', productUrl: string, price: number, hasPurchased: boolean, imageUrl?: string | null } | null };

export type ExclusiveDownloadsQueryVariables = Exact<{
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  brandCode: Scalars['String']['input'];
}>;


export type ExclusiveDownloadsQuery = { __typename?: 'Query', productsByCategorySlug?: { __typename?: 'ProductsByCategorySlugCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EcommProductDto', id: number, name?: string | null, url?: string | null, blurb?: string | null, vanishingIncExclusive: boolean, displayPrice?: number | null, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null, square?: string | null, video?: string | null } | null, options: Array<{ __typename?: 'ProductOptionDto', id?: number | null, description?: string | null, price: number, salePrice?: number | null, inStock: boolean, productType?: { __typename?: 'ProductTypeDto', id: number, name?: string | null } | null, currency?: { __typename?: 'CurrencyDto', symbol?: string | null } | null }>, productType?: { __typename?: 'ProductTypeDto', name?: string | null, id: number } | null, creators: Array<{ __typename?: 'CreatorDto', id: number, name?: string | null, urlStub?: string | null }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type FeaturedProductsQueryVariables = Exact<{
  brandCode: Scalars['String']['input'];
}>;


export type FeaturedProductsQuery = { __typename?: 'Query', ecommProducts?: { __typename?: 'EcommProductsCollectionSegment', items?: Array<{ __typename?: 'EcommProductDto', id: number, name?: string | null, url?: string | null, blurb?: string | null, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null } | null }> | null } | null };

export type GetProductLiveChatMessagesQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProductLiveChatMessagesQuery = { __typename?: 'Query', productLiveChatMessages: Array<{ __typename?: 'ProductLiveChatMessageDto', id: number, productId: number, customerId: number, message: string, timePosted: any, customerName: string, gravatarUrl?: string | null, isAdminStaff: boolean }> };

export type GetProductOptionsBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  brandCode: Scalars['String']['input'];
}>;


export type GetProductOptionsBySlugQuery = { __typename?: 'Query', ecommProductBySlug?: { __typename?: 'EcommProductDto', id: number, name?: string | null, options: Array<{ __typename?: 'ProductOptionDto', price: number, salePrice?: number | null, inStock: boolean, viPoints: number, description?: string | null, id?: number | null, currency?: { __typename?: 'CurrencyDto', symbol?: string | null } | null, productType?: { __typename?: 'ProductTypeDto', name?: string | null } | null }> } | null };

export type HasPurchasedProductQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
  productOptionId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type HasPurchasedProductQuery = { __typename?: 'Query', hasPurchasedProduct: boolean };

export type HomepageProductListQueryVariables = Exact<{
  productListId: Scalars['Int']['input'];
  brandCode: Scalars['String']['input'];
}>;


export type HomepageProductListQuery = { __typename?: 'Query', productsByProductListId?: { __typename?: 'ProductsByProductListIdCollectionSegment', items?: Array<{ __typename?: 'EcommProductDto', id: number, name?: string | null, url?: string | null, thumbnails?: { __typename?: 'ProductThumbnailsDto', video?: string | null } | null, productTrailers: Array<{ __typename?: 'ProductTrailerDto', bunnyId?: string | null }> }> | null } | null };

export type LatestExclusiveProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestExclusiveProductsQuery = { __typename?: 'Query', ecommProducts?: { __typename?: 'EcommProductsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EcommProductDto', id: number, name?: string | null, url?: string | null, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null } | null, creators: Array<{ __typename?: 'CreatorDto', name?: string | null }> }> | null } | null };

export type LatestFeaturedProductsQueryVariables = Exact<{
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  brandCode: Scalars['String']['input'];
  where?: InputMaybe<EcommProductDtoFilterInput>;
}>;


export type LatestFeaturedProductsQuery = { __typename?: 'Query', ecommProducts?: { __typename?: 'EcommProductsCollectionSegment', items?: Array<{ __typename?: 'EcommProductDto', id: number, name?: string | null, dateAdded: any, url?: string | null, blurb?: string | null, hasDownloads: boolean, displayPrice?: number | null, vanishingIncExclusive: boolean, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null, square?: string | null, video?: string | null } | null, options: Array<{ __typename?: 'ProductOptionDto', id?: number | null, description?: string | null, price: number, salePrice?: number | null, priceIncVat?: number | null, salePriceIncVat?: number | null, taxType?: number | null, inStock: boolean, productType?: { __typename?: 'ProductTypeDto', id: number, name?: string | null } | null, currency?: { __typename?: 'CurrencyDto', symbol?: string | null } | null }>, productType?: { __typename?: 'ProductTypeDto', name?: string | null, id: number } | null, creators: Array<{ __typename?: 'CreatorDto', id: number, name?: string | null, urlStub?: string | null }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasPreviousPage: boolean, hasNextPage: boolean } } | null };

export type LatestProductsQueryVariables = Exact<{
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  brandCode: Scalars['String']['input'];
  maxBlurbLength: Scalars['Int']['input'];
  where?: InputMaybe<EcommProductDtoFilterInput>;
  order?: InputMaybe<Array<ProductsSort> | ProductsSort>;
  productTypeGroup?: InputMaybe<Scalars['String']['input']>;
}>;


export type LatestProductsQuery = { __typename?: 'Query', ecommProducts?: { __typename?: 'EcommProductsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EcommProductDto', id: number, name?: string | null, url?: string | null, blurb?: string | null, hasDownloads: boolean, displayPrice?: number | null, vanishingIncExclusive: boolean, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null, square?: string | null, video?: string | null } | null, options: Array<{ __typename?: 'ProductOptionDto', id?: number | null, description?: string | null, price: number, salePrice?: number | null, priceIncVat?: number | null, salePriceIncVat?: number | null, taxType?: number | null, inStock: boolean, productType?: { __typename?: 'ProductTypeDto', id: number, name?: string | null } | null, currency?: { __typename?: 'CurrencyDto', symbol?: string | null } | null }>, productType?: { __typename?: 'ProductTypeDto', name?: string | null, id: number } | null, creators: Array<{ __typename?: 'CreatorDto', id: number, name?: string | null, urlStub?: string | null }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasPreviousPage: boolean, hasNextPage: boolean } } | null };

export type ListPageQueryVariables = Exact<{
  listSlug: Scalars['String']['input'];
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  brandCode: Scalars['String']['input'];
}>;


export type ListPageQuery = { __typename?: 'Query', productList?: { __typename?: 'ProductListDto', introduction?: string | null, templateKey?: string | null, title: string } | null, productsByProductListSlug?: { __typename?: 'ProductsByProductListSlugCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EcommProductDto', blurb?: string | null, displayPrice?: number | null, id: number, name?: string | null, url?: string | null, hasDownloads: boolean, vanishingIncExclusive: boolean, creators: Array<{ __typename?: 'CreatorDto', id: number, name?: string | null, urlStub?: string | null }>, options: Array<{ __typename?: 'ProductOptionDto', description?: string | null, id?: number | null, inStock: boolean, price: number, salePrice?: number | null, priceIncVat?: number | null, salePriceIncVat?: number | null, taxType?: number | null, productType?: { __typename?: 'ProductTypeDto', id: number, name?: string | null } | null, currency?: { __typename?: 'CurrencyDto', symbol?: string | null, code?: string | null } | null }>, productType?: { __typename?: 'ProductTypeDto', id: number, name?: string | null } | null, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null, square?: string | null } | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type MinimalProductQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  brandCode: Scalars['String']['input'];
}>;


export type MinimalProductQuery = { __typename?: 'Query', ecommProductBySlug?: { __typename?: 'EcommProductDto', id: number, name?: string | null, url?: string | null, blurb?: string | null, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null, square?: string | null, video?: string | null } | null } | null };

export type ProductQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  brandCode: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductQuery = { __typename?: 'Query', ecommProductBySlug?: { __typename?: 'EcommProductDto', id: number, name?: string | null, url?: string | null, displayPrice?: number | null, currencySymbol?: string | null, description?: string | null, murphysProductId?: string | null, vanishingIncExclusive: boolean, dateAdded: any, hasDownloads: boolean, isPreorder?: boolean | null, isParent: boolean, options: Array<{ __typename?: 'ProductOptionDto', price: number, salePrice?: number | null, priceIncVat?: number | null, salePriceIncVat?: number | null, taxType?: number | null, inStock: boolean, viPoints: number, maxQuantity?: number | null, description?: string | null, murphysProductId?: string | null, id?: number | null, needsShipping: boolean, currency?: { __typename?: 'CurrencyDto', symbol?: string | null, code?: string | null } | null, productType?: { __typename?: 'ProductTypeDto', name?: string | null } | null }>, productImages: Array<{ __typename?: 'ProductImageDto', id: number, src?: string | null }>, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null, video?: string | null } | null, productTrailers: Array<{ __typename?: 'ProductTrailerDto', bunnyId?: string | null }>, creators: Array<{ __typename?: 'CreatorDto', urlStub?: string | null, name?: string | null }>, productType?: { __typename?: 'ProductTypeDto', id: number, name?: string | null } | null, childProductContents: Array<{ __typename?: 'EcommChildProductContentDto', id: number, name?: string | null, urlStub?: string | null, url?: string | null, description?: string | null, thumbnailUrl?: string | null }>, childProductCommercials: Array<{ __typename?: 'EcommChildProductCommercialDto', id: number, displayPrice?: number | null, isPreorder?: boolean | null, options: Array<{ __typename?: 'ProductOptionDto', price: number, salePrice?: number | null, priceIncVat?: number | null, salePriceIncVat?: number | null, taxType?: number | null, inStock: boolean, viPoints: number, maxQuantity?: number | null, description?: string | null, id?: number | null, needsShipping: boolean, currency?: { __typename?: 'CurrencyDto', symbol?: string | null, code?: string | null } | null, productType?: { __typename?: 'ProductTypeDto', name?: string | null } | null }> }>, ebookBundleOption?: { __typename?: 'EbookBundleOptionDto', physicalOptionId: number, downloadOptionId: number, price: number, currency?: { __typename?: 'CurrencyDto', symbol?: string | null, code?: string | null } | null } | null, reviews: Array<{ __typename?: 'CustomerReviewDto', id: number, rating?: number | null, review?: string | null, reviewerName?: string | null, gravatarUrl?: string | null, isMasterclassSubscriber?: boolean | null }>, categories: Array<{ __typename?: 'CategoryDto', id: number, urlStub?: string | null, name?: string | null }>, meta: Array<{ __typename?: 'ProductMetaDto', id: number, key: string, value: string }> } | null };

export type ProductAccessQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ProductAccessQuery = { __typename?: 'Query', ecommProductAccessBySlug?: { __typename?: 'EcommProductAccessDto', productId: number, requiresPassword: boolean } | null };

export type ProductByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  brandCode: Scalars['String']['input'];
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductByIdQuery = { __typename?: 'Query', ecommProductById?: { __typename?: 'EcommProductDto', id: number, name?: string | null, url?: string | null, displayPrice?: number | null, currencySymbol?: string | null, inStock: boolean, hasDownloads: boolean, isPreorder?: boolean | null, preorderRelease?: any | null, ebookBundleOption?: { __typename?: 'EbookBundleOptionDto', physicalOptionId: number, downloadOptionId: number } | null, options: Array<{ __typename?: 'ProductOptionDto', id?: number | null, description?: string | null, position: number, price: number, salePrice?: number | null, priceIncVat?: number | null, salePriceIncVat?: number | null, taxType?: number | null, inStock: boolean, needsShipping: boolean, currency?: { __typename?: 'CurrencyDto', symbol?: string | null, code?: string | null } | null, productType?: { __typename?: 'ProductTypeDto', name?: string | null } | null }>, creators: Array<{ __typename?: 'CreatorDto', name?: string | null }> } | null };

export type ProductCommercialQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  brandCode: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductCommercialQuery = { __typename?: 'Query', ecommProductCommercialBySlug?: { __typename?: 'EcommProductDto', id: number, displayPrice?: number | null, murphysProductId?: string | null, isParent: boolean, ebookBundleOption?: { __typename?: 'EbookBundleOptionDto', physicalOptionId: number, downloadOptionId: number, price: number, currency?: { __typename?: 'CurrencyDto', symbol?: string | null, code?: string | null } | null } | null, options: Array<{ __typename?: 'ProductOptionDto', price: number, salePrice?: number | null, priceIncVat?: number | null, salePriceIncVat?: number | null, taxType?: number | null, inStock: boolean, viPoints: number, maxQuantity?: number | null, description?: string | null, murphysProductId?: string | null, id?: number | null, needsShipping: boolean, currency?: { __typename?: 'CurrencyDto', symbol?: string | null, code?: string | null } | null, productType?: { __typename?: 'ProductTypeDto', name?: string | null } | null }>, childProductCommercials: Array<{ __typename?: 'EcommChildProductCommercialDto', id: number, displayPrice?: number | null, isPreorder?: boolean | null, options: Array<{ __typename?: 'ProductOptionDto', price: number, salePrice?: number | null, priceIncVat?: number | null, salePriceIncVat?: number | null, taxType?: number | null, inStock: boolean, viPoints: number, maxQuantity?: number | null, description?: string | null, id?: number | null, needsShipping: boolean, currency?: { __typename?: 'CurrencyDto', symbol?: string | null, code?: string | null } | null, productType?: { __typename?: 'ProductTypeDto', name?: string | null } | null }> }> } | null };

export type ProductContentQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ProductContentQuery = { __typename?: 'Query', ecommProductContentBySlug?: { __typename?: 'EcommProductDto', id: number, name?: string | null, url?: string | null, description?: string | null, murphysProductId?: string | null, vanishingIncExclusive: boolean, dateAdded: any, manufacturerId?: number | null, hasDownloads: boolean, isPreorder?: boolean | null, preorderRelease?: any | null, discontinued?: boolean | null, rating?: number | null, isParent: boolean, productImages: Array<{ __typename?: 'ProductImageDto', id: number, src?: string | null }>, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null, video?: string | null } | null, productTrailers: Array<{ __typename?: 'ProductTrailerDto', bunnyId?: string | null }>, creators: Array<{ __typename?: 'CreatorDto', urlStub?: string | null, name?: string | null }>, productType?: { __typename?: 'ProductTypeDto', id: number, name?: string | null } | null, reviews: Array<{ __typename?: 'CustomerReviewDto', id: number, rating?: number | null, review?: string | null, reviewerName?: string | null, gravatarUrl?: string | null, isMasterclassSubscriber?: boolean | null, reviewDate: any }>, categories: Array<{ __typename?: 'CategoryDto', id: number, urlStub?: string | null, name?: string | null }>, meta: Array<{ __typename?: 'ProductMetaDto', id: number, key: string, value: string }>, childProductContents: Array<{ __typename?: 'EcommChildProductContentDto', id: number, name?: string | null, urlStub?: string | null, url?: string | null, description?: string | null, thumbnailUrl?: string | null }> } | null };

export type ProductListQueryVariables = Exact<{
  urlStub: Scalars['String']['input'];
}>;


export type ProductListQuery = { __typename?: 'Query', productList?: { __typename?: 'ProductListDto', id: number, introduction?: string | null, live: boolean, title: string, urlStub: string } | null };

export type ProductListProductsQueryVariables = Exact<{
  productListSlug: Scalars['String']['input'];
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  brandCode: Scalars['String']['input'];
  order?: InputMaybe<Array<ProductsByProductListSort> | ProductsByProductListSort>;
}>;


export type ProductListProductsQuery = { __typename?: 'Query', productsByProductListSlug?: { __typename?: 'ProductsByProductListSlugCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EcommProductDto', blurb?: string | null, dateAdded: any, description?: string | null, displayPrice?: number | null, id: number, name?: string | null, url?: string | null, hasDownloads: boolean, vanishingIncExclusive: boolean, creators: Array<{ __typename?: 'CreatorDto', id: number, name?: string | null, urlStub?: string | null }>, options: Array<{ __typename?: 'ProductOptionDto', description?: string | null, id?: number | null, inStock: boolean, price: number, salePrice?: number | null, priceIncVat?: number | null, salePriceIncVat?: number | null, taxType?: number | null, needsShipping: boolean, productType?: { __typename?: 'ProductTypeDto', id: number, name?: string | null } | null, currency?: { __typename?: 'CurrencyDto', symbol?: string | null, code?: string | null } | null }>, productImages: Array<{ __typename?: 'ProductImageDto', id: number, src?: string | null }>, productType?: { __typename?: 'ProductTypeDto', id: number, name?: string | null } | null, meta: Array<{ __typename?: 'ProductMetaDto', id: number, key: string, value: string }>, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null, square?: string | null, video?: string | null } | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type ProductQuestionQueryVariables = Exact<{
  productQuestionId: Scalars['Int']['input'];
}>;


export type ProductQuestionQuery = { __typename?: 'Query', productQuestion?: { __typename?: 'QuestionDto', id: number, customerId: number, customerName?: string | null, question?: string | null, productId?: number | null, productName?: string | null } | null };

export type ProductQuestionsQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProductQuestionsQuery = { __typename?: 'Query', productQuestions?: { __typename?: 'ProductQuestionsCollectionSegment', pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean }, items?: Array<{ __typename?: 'QuestionDto', id: number, customerId: number, customerName?: string | null, question?: string | null, answers: Array<{ __typename?: 'AnswerDto', id: number, customerId: number, customerName?: string | null, answer?: string | null, isCreator: boolean }> }> | null } | null };

export type ReviewerProductsQueryVariables = Exact<{
  brandCode: Scalars['String']['input'];
}>;


export type ReviewerProductsQuery = { __typename?: 'Query', ecommProducts?: { __typename?: 'EcommProductsCollectionSegment', items?: Array<{ __typename?: 'EcommProductDto', id: number, name?: string | null, url?: string | null, blurb?: string | null, meta: Array<{ __typename?: 'ProductMetaDto', key: string }>, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null } | null, productType?: { __typename?: 'ProductTypeDto', name?: string | null } | null, creators: Array<{ __typename?: 'CreatorDto', name?: string | null }> }> | null } | null };

export type TopSellersQueryVariables = Exact<{
  brandCode: Scalars['String']['input'];
}>;


export type TopSellersQuery = { __typename?: 'Query', topSellers: Array<{ __typename?: 'TopSellerDto', id: number, url?: string | null, imageUrl?: string | null, name?: string | null, onSale: boolean }> };

export type ActiveShoppingCartQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['Int']['input']>;
  anonymousCartToken?: InputMaybe<Scalars['String']['input']>;
  includeConventionCart?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ActiveShoppingCartQuery = { __typename?: 'Query', activeShoppingCart?: { __typename?: 'ShoppingCartDto', token: string, voucherCode?: string | null, giftVoucherCode?: string | null, giftVoucherDownloadsOnly: boolean, giftVoucherDeduction?: number | null, promoCodeMessage?: string | null, subTotal: number, subTotalIncVat?: number | null, viPoints: number, shippingMethod?: number | null, shippingCost?: number | null, taxCharged?: number | null, taxIncluded?: number | null, taxDescription?: string | null, useStoreCredit?: boolean | null, storeCreditAvailable?: number | null, storeCreditToApply?: number | null, items: Array<{ __typename?: 'ShoppingCartItemDto', id: number, price?: number | null, priceIncVat?: number | null, listPrice?: number | null, listPriceIncVat?: number | null, isDiscounted: boolean, discountTag?: string | null, taxType?: number | null, description?: string | null, discountDescription?: string | null, metadata?: string | null, productId: number, quantity: number, productName?: string | null, masterclassAirsInNote?: string | null, thumbnailSrc?: string | null, url?: string | null, optionDescription?: string | null, isPreorder?: boolean | null, needsShipping: boolean, isDownload: boolean, lowStock: boolean, hazardous?: boolean | null, associatedOrderItemId?: number | null }>, brand?: { __typename?: 'BrandDto', name?: string | null, id: number, code?: string | null } | null, currency?: { __typename?: 'CurrencyDto', id: number, symbol?: string | null, code?: string | null } | null, country?: { __typename?: 'CountryDto', name: string, isoCode: string, id: number, freeShipping: boolean } | null, shippingAddress?: { __typename?: 'CustomerAddressDto', id: number, firstName?: string | null, lastName?: string | null, city?: string | null, addressLine1?: string | null, addressLine2?: string | null, phoneNumber?: string | null, zip?: string | null, state?: { __typename?: 'StateDto', name?: string | null, abbreviation?: string | null, id: number } | null, country?: { __typename?: 'CountryDto', name: string, id: number, isoCode: string } | null } | null } | null };

export type ActiveShoppingCartHeaderQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['Int']['input']>;
  anonymousCartToken?: InputMaybe<Scalars['String']['input']>;
  includeConventionCart?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ActiveShoppingCartHeaderQuery = { __typename?: 'Query', activeShoppingCartHeader?: { __typename?: 'ShoppingCartHeaderDto', totalQuantity: number } | null };

export type AvailablePaymentMethodsForShoppingCartQueryVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
}>;


export type AvailablePaymentMethodsForShoppingCartQuery = { __typename?: 'Query', availablePaymentMethodsForShoppingCart: { __typename?: 'AvailablePaymentMethodsDto', showPayPal: boolean, showKlarna: boolean, showCreditCard: boolean, showApplePay: boolean, showAdminFreeOrder: boolean, showAdminManualPayment: boolean, payPalAccount?: string | null, paymentPlan?: { __typename?: 'ConventionPaymentPlanInfoDto', dueDates: Array<string>, totalAmount: number, installmentAmount: number, numberOfInstallments: number, enabled: boolean, conventionProductId: number } | null } };

export type CustomerPaymentMethodsQueryVariables = Exact<{
  brandCode: Scalars['String']['input'];
}>;


export type CustomerPaymentMethodsQuery = { __typename?: 'Query', paymentMethodsForCustomer: Array<{ __typename?: 'CustomerPaymentMethodDto', paymentCompany?: string | null, expiryMonth?: number | null, expiryYear?: number | null, id?: string | null, isDefault: boolean, last4?: string | null }> };

export type ImportDutiesQuoteForShoppingCartQueryVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
}>;


export type ImportDutiesQuoteForShoppingCartQuery = { __typename?: 'Query', importDutiesQuoteForShoppingCart?: { __typename?: 'ImportDutiesQuoteDto', type: number, isPrepayAvailable: boolean, isRequired: boolean, duties: number, taxes: number, fees: number, total: number, requiredDuties: number, requiredTaxes: number, requiredFees: number, requiredTotal: number, optionalPrepayTotal: number, description?: string | null, formula?: string | null, shipToCountryName?: string | null, shipFromCountryIsoCode?: string | null } | null };

export type PurchasedProductIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type PurchasedProductIdsQuery = { __typename?: 'Query', purchasedProductIds: Array<number> };

export type ShoppingCartPaymentMethodsQueryVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
}>;


export type ShoppingCartPaymentMethodsQuery = { __typename?: 'Query', paymentMethodsForShoppingCart: Array<{ __typename?: 'CustomerPaymentMethodDto', paymentCompany?: string | null, expiryMonth?: number | null, expiryYear?: number | null, id?: string | null, isDefault: boolean, last4?: string | null }> };

export type ShoppingCartShippingOptionsQueryVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
}>;


export type ShoppingCartShippingOptionsQuery = { __typename?: 'Query', shippingOptionsForShoppingCart: Array<{ __typename?: 'ShippingRateDto', id: string, estDelivery: string, description: string, price: number, currencySymbol: string, shippingMethodId: number, hash?: string | null, isFallback: boolean, notice?: string | null }> };

export type ShoppingCartShippingOptionsForAddressQueryVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
  address: ShippingAddressInput;
}>;


export type ShoppingCartShippingOptionsForAddressQuery = { __typename?: 'Query', shippingOptionsForShoppingCartAddress: Array<{ __typename?: 'ShippingRateDto', id: string, estDelivery: string, description: string, price: number, currencySymbol: string, shippingMethodId: number, hash?: string | null, isFallback: boolean, notice?: string | null }> };

export type ValidateCartStockQueryVariables = Exact<{
  shoppingCartToken: Scalars['String']['input'];
}>;


export type ValidateCartStockQuery = { __typename?: 'Query', validateCartStock: { __typename?: 'StockValidationResultDto', isValid: boolean, unavailableItems: Array<{ __typename?: 'UnavailableItemDto', productId: number, productName: string, optionId?: number | null, optionName?: string | null, requestedQuantity: number, availableQuantity: number, cartItemId: number }>, reducedQuantityItems: Array<{ __typename?: 'ReducedQuantityItemDto', productId: number, productName: string, optionId?: number | null, optionName?: string | null, requestedQuantity: number, availableQuantity: number, cartItemId: number }> } };

export type MasterClassStudioQueryVariables = Exact<{
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
}>;


export type MasterClassStudioQuery = { __typename?: 'Query', streams?: { __typename?: 'StreamsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'StreamingProductDto', id: number, name?: string | null, thumbnailSrc?: string | null, urlStub?: string | null, rating: number, creators: Array<{ __typename?: 'CreatorDto', name?: string | null, urlStub?: string | null }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CurrentMasterclassQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentMasterclassQuery = { __typename?: 'Query', currentMasterclass?: { __typename?: 'CurrentMasterclassDto', id: number, name?: string | null, url?: string | null, monthName?: string | null, videoSrc?: string | null, lectureDates?: string | null, hasReleasedFiles: boolean, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null, video?: string | null } | null } | null };

export type CustomerSubscriptionsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CustomerSubscriptionsQuery = { __typename?: 'Query', allSubscriptionsForCustomer?: { __typename?: 'AllSubscriptionsForCustomerCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Subscription', id: number, subscriptionId?: string | null, subscriptionTier?: string | null, isActive: boolean, isInGoodStanding: boolean, isPaused: boolean, nextBillingDate?: any | null, isTrial: boolean }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type IsEligibleForTrialQueryVariables = Exact<{
  customerId: Scalars['Int']['input'];
}>;


export type IsEligibleForTrialQuery = { __typename?: 'Query', isEligibleForTrial: boolean };

export type MasterclassLiveBannerQueryVariables = Exact<{ [key: string]: never; }>;


export type MasterclassLiveBannerQuery = { __typename?: 'Query', masterclassLiveBanner: { __typename?: 'MasterclassLiveBannerDto', showBanner: boolean, lectureName?: string | null, streamUrl?: string | null, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null } | null } };

export type MasterclassLiveStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type MasterclassLiveStatusQuery = { __typename?: 'Query', masterclassLiveStatus: { __typename?: 'MasterclassLiveStatusDto', url?: string | null } };

export type MasterclassStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type MasterclassStatusQuery = { __typename?: 'Query', masterclassStatusForCustomer?: { __typename?: 'MasterclassStatusDto', id: number, canStreamMasterclassCatalog: boolean, isDelinquent: boolean, isPaused: boolean, isCanceled: boolean, isFreeSubscription: boolean, isPauseScheduled: boolean, nextBillingDate?: any | null, proratedAmount?: number | null, resumeChargeAmount?: number | null, resumeChargeCurrency?: string | null, resumeChargeLast4?: string | null, trial?: { __typename?: 'MasterclassTrialDto', isTrial: boolean, trialEndDate?: any | null, trialStartDate?: any | null } | null } | null };

export type NextMonthMasterclassQueryVariables = Exact<{
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
}>;


export type NextMonthMasterclassQuery = { __typename?: 'Query', masterclassByMonthAndYear?: { __typename?: 'EcommProductDto', id: number, name?: string | null, url?: string | null, lectureDates?: string | null, thumbnails?: { __typename?: 'ProductThumbnailsDto', video?: string | null } | null, meta: Array<{ __typename?: 'ProductMetaDto', key: string, value: string }>, downloadFiles: Array<{ __typename?: 'DownloadFileDto', id: number, title?: string | null, type: string, lectureStartTime?: any | null }> } | null };

export type SubscriptionQueryVariables = Exact<{
  subscriptionId: Scalars['Int']['input'];
}>;


export type SubscriptionQuery = { __typename?: 'Query', subscriptionById?: { __typename?: 'Subscription', id: number, subscriptionId?: string | null, subscriptionTier?: string | null, isActive: boolean, isInGoodStanding: boolean, isPaused: boolean, nextBillingDate?: any | null, endDate?: any | null, isTrial: boolean } | null };

export type SubscriptionEligibilityQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionEligibilityQuery = { __typename?: 'Query', subscriptionEligibility: { __typename?: 'SubscriptionEligibilityDto', isSubscriber: boolean, hasHadSubscriptionBefore: boolean, isEligibleForTrial: boolean, hasPausedSubscription: boolean, hasDelinquentSubscription: boolean } };

export type InvoicePdfQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type InvoicePdfQuery = { __typename?: 'Query', invoicePdf?: string | null };

export type PackageTrackingQueryVariables = Exact<{
  trackingNumber: Scalars['String']['input'];
}>;


export type PackageTrackingQuery = { __typename?: 'Query', trackingInfo: { __typename?: 'PackageDto', cost?: number | null, trackingUrl?: string | null, externalTrackingUrl?: string | null, deliveredDate?: any | null, dispatchedDate?: any | null, errorDescription?: string | null, estDeliveryDate?: any | null, id: number, service?: string | null, shippingMethod?: string | null, signedBy?: string | null, status?: string | null, statusCode?: string | null, statusDetail?: string | null, statusLabel?: string | null, trackingNumber?: string | null, trackingState: string, weight?: number | null, carrier?: { __typename?: 'CarrierDto', name: string, contactPhone: string, logoUrl: string } | null, trackingHistory?: Array<{ __typename?: 'TrackingRecordDto', city?: string | null, details?: string | null, id: number, state?: string | null, status?: string | null, timeUpdated?: any | null, zip?: string | null, country?: { __typename?: 'CountryDto', isoCode: string, name: string } | null }> | null } };

export type GiftCertificateOptionsQueryVariables = Exact<{
  currencyId: Scalars['Int']['input'];
}>;


export type GiftCertificateOptionsQuery = { __typename?: 'Query', giftCertificateOptions: Array<{ __typename?: 'GiftCertificateOptionDto', id: number, name: string, price: number, currencySymbol: string }> };

export type InvoiceExtraInfoQueryVariables = Exact<{
  brandId: Scalars['Int']['input'];
}>;


export type InvoiceExtraInfoQuery = { __typename?: 'Query', invoiceExtraInfo?: string | null };

export type CustomerPurchasedProductsQueryVariables = Exact<{
  customerID: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  order?: InputMaybe<Array<PurchasedProductsSort> | PurchasedProductsSort>;
}>;


export type CustomerPurchasedProductsQuery = { __typename?: 'Query', purchasedProducts?: { __typename?: 'PurchasedProductsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PurchasedProductDto', hasDownloads: boolean, hasInstructions: boolean, id: number, productName?: string | null, purchasedDate: any, thumbnailPath?: string | null, url?: string | null, creators: Array<{ __typename?: 'CreatorDto', id: number, name?: string | null, urlStub?: string | null }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CustomerPurchasedProductsAppQueryVariables = Exact<{
  customerID: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  order?: InputMaybe<Array<PurchasedProductsAppSort> | PurchasedProductsAppSort>;
}>;


export type CustomerPurchasedProductsAppQuery = { __typename?: 'Query', purchasedProductsApp?: { __typename?: 'PurchasedProductsAppCollectionSegmentCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'PurchasedProductAppDto', allowDownload: boolean, bannerImageUrl?: string | null, category?: string | null, hasDownloads: boolean, hasInstructions: boolean, id: number, isMasterClass: boolean, productName?: string | null, purchasedDate: any, thumbnailPath?: string | null, url?: string | null, creators: Array<{ __typename?: 'CreatorDto', id: number, name?: string | null, urlStub?: string | null }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type CustomerPurchasedProductsListQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerPurchasedProductsListQuery = { __typename?: 'Query', purchasedProductsList: Array<{ __typename?: 'PurchasedProductDto', hasDownloads: boolean, hasInstructions: boolean, id: number, productName?: string | null, purchasedDate: any, thumbnailPath?: string | null, url?: string | null, creators: Array<{ __typename?: 'CreatorDto', id: number, name?: string | null, urlStub?: string | null }> }> };

export type ViPointsBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type ViPointsBalanceQuery = { __typename?: 'Query', viPointsBalance: number };

export type ViPointsLogQueryVariables = Exact<{ [key: string]: never; }>;


export type ViPointsLogQuery = { __typename?: 'Query', viPointsLog: { __typename?: 'ViPointsLogDto', customerId: number, pointsEarned: number, pointsSpent: number, items?: Array<{ __typename?: 'ViPointsLogItemDto', id: number, orderId?: number | null, points: number, transactionDate?: any | null, reason: ViPointsLogReason, notes?: string | null }> | null } };

export type PublicWishlistQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  wishlistSlug: Scalars['String']['input'];
  brandCode: Scalars['String']['input'];
  order?: InputMaybe<Array<PublicWishlistProductSort> | PublicWishlistProductSort>;
}>;


export type PublicWishlistQuery = { __typename?: 'Query', publicWishlistOwnerName?: string | null, publicWishlistProducts?: { __typename?: 'PublicWishlistProductsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'WishlistProductDto', id: number, name?: string | null, url?: string | null, thumbnailUrl?: string | null, productType?: string | null, blurb?: string | null, vanishingIncExclusive: boolean, displayPrice?: number | null, salePrice?: number | null, timeAdded: any, currencySymbol?: string | null, creators?: Array<{ __typename?: 'CreatorDto', id: number, name?: string | null, urlStub?: string | null }> | null }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasPreviousPage: boolean, hasNextPage: boolean } } | null };

export type WishlistItemsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  brandCode: Scalars['String']['input'];
  order?: InputMaybe<Array<WishlistProductSort> | WishlistProductSort>;
  shippingCountry?: InputMaybe<Scalars['String']['input']>;
}>;


export type WishlistItemsQuery = { __typename?: 'Query', wishlistProducts?: { __typename?: 'WishlistProductsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'WishlistProductDto', id: number, name?: string | null, url?: string | null, thumbnailUrl?: string | null, productType?: string | null, blurb?: string | null, vanishingIncExclusive: boolean, displayPrice?: number | null, salePrice?: number | null, timeAdded: any, currencySymbol?: string | null, hasDownloads: boolean, isPreorder?: boolean | null, preorderRelease?: any | null, creators?: Array<{ __typename?: 'CreatorDto', id: number, name?: string | null, urlStub?: string | null }> | null, ebookBundleOption?: { __typename?: 'EbookBundleOptionDto', physicalOptionId: number, downloadOptionId: number } | null, options: Array<{ __typename?: 'ProductOptionDto', id?: number | null, description?: string | null, position: number, price: number, salePrice?: number | null, priceIncVat?: number | null, salePriceIncVat?: number | null, taxType?: number | null, inStock: boolean, needsShipping: boolean, currency?: { __typename?: 'CurrencyDto', symbol?: string | null, code?: string | null } | null, productType?: { __typename?: 'ProductTypeDto', name?: string | null } | null }> }> | null, pageInfo: { __typename?: 'CollectionSegmentInfo', hasPreviousPage: boolean, hasNextPage: boolean } } | null, wishlist: { __typename?: 'WishlistDto', publicUrl: string, showName: boolean } };

export type WondersQueryVariables = Exact<{
  brandCode: Scalars['String']['input'];
}>;


export type WondersQuery = { __typename?: 'Query', productsByCategorySlug?: { __typename?: 'ProductsByCategorySlugCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'EcommProductDto', id: number, name?: string | null, url?: string | null, hasDownloads: boolean, displayPrice?: number | null, vanishingIncExclusive: boolean, thumbnails?: { __typename?: 'ProductThumbnailsDto', default?: string | null, square?: string | null, video?: string | null } | null, options: Array<{ __typename?: 'ProductOptionDto', id?: number | null, description?: string | null, price: number, salePrice?: number | null, inStock: boolean, productType?: { __typename?: 'ProductTypeDto', id: number, name?: string | null } | null, currency?: { __typename?: 'CurrencyDto', symbol?: string | null } | null }> }> | null } | null };



export const AddCustomerToSegmentDocument = `
    mutation AddCustomerToSegment($segmentId: Int!, $workspace: CustomerIOWorkspace) {
  addCustomerToSegment(segmentId: $segmentId, workspace: $workspace)
}
    `;

export const useAddCustomerToSegmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddCustomerToSegmentMutation, TError, AddCustomerToSegmentMutationVariables, TContext>) => {

    return useMutation<AddCustomerToSegmentMutation, TError, AddCustomerToSegmentMutationVariables, TContext>(
      {
    mutationKey: ['AddCustomerToSegment'],
    mutationFn: (variables?: AddCustomerToSegmentMutationVariables) => fetchData<AddCustomerToSegmentMutation, AddCustomerToSegmentMutationVariables>(AddCustomerToSegmentDocument, variables)(),
    ...options
  }
    )};


useAddCustomerToSegmentMutation.fetcher = (variables: AddCustomerToSegmentMutationVariables, options?: RequestInit['headers']) => fetchData<AddCustomerToSegmentMutation, AddCustomerToSegmentMutationVariables>(AddCustomerToSegmentDocument, variables, options);

export const AddEbookBundleToShoppingCartDocument = `
    mutation AddEbookBundleToShoppingCart($shoppingCartToken: String!, $productId: Int!, $physicalOptionId: Int!, $downloadOptionId: Int!, $quantity: Int) {
  addEbookBundleToShoppingCart(
    shoppingCartToken: $shoppingCartToken
    productId: $productId
    physicalOptionId: $physicalOptionId
    downloadOptionId: $downloadOptionId
    quantity: $quantity
  )
}
    `;

export const useAddEbookBundleToShoppingCartMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddEbookBundleToShoppingCartMutation, TError, AddEbookBundleToShoppingCartMutationVariables, TContext>) => {

    return useMutation<AddEbookBundleToShoppingCartMutation, TError, AddEbookBundleToShoppingCartMutationVariables, TContext>(
      {
    mutationKey: ['AddEbookBundleToShoppingCart'],
    mutationFn: (variables?: AddEbookBundleToShoppingCartMutationVariables) => fetchData<AddEbookBundleToShoppingCartMutation, AddEbookBundleToShoppingCartMutationVariables>(AddEbookBundleToShoppingCartDocument, variables)(),
    ...options
  }
    )};


useAddEbookBundleToShoppingCartMutation.fetcher = (variables: AddEbookBundleToShoppingCartMutationVariables, options?: RequestInit['headers']) => fetchData<AddEbookBundleToShoppingCartMutation, AddEbookBundleToShoppingCartMutationVariables>(AddEbookBundleToShoppingCartDocument, variables, options);

export const AddItemToShoppingCartDocument = `
    mutation AddItemToShoppingCart($shoppingCartToken: String!, $productId: Int!, $productOptionId: Int, $description: String, $quantity: Int, $unitPrice: Decimal) {
  addItemToShoppingCart(
    shoppingCartToken: $shoppingCartToken
    productId: $productId
    productOptionId: $productOptionId
    description: $description
    quantity: $quantity
    unitPrice: $unitPrice
  )
}
    `;

export const useAddItemToShoppingCartMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddItemToShoppingCartMutation, TError, AddItemToShoppingCartMutationVariables, TContext>) => {

    return useMutation<AddItemToShoppingCartMutation, TError, AddItemToShoppingCartMutationVariables, TContext>(
      {
    mutationKey: ['AddItemToShoppingCart'],
    mutationFn: (variables?: AddItemToShoppingCartMutationVariables) => fetchData<AddItemToShoppingCartMutation, AddItemToShoppingCartMutationVariables>(AddItemToShoppingCartDocument, variables)(),
    ...options
  }
    )};


useAddItemToShoppingCartMutation.fetcher = (variables: AddItemToShoppingCartMutationVariables, options?: RequestInit['headers']) => fetchData<AddItemToShoppingCartMutation, AddItemToShoppingCartMutationVariables>(AddItemToShoppingCartDocument, variables, options);

export const AddItemToWishlistDocument = `
    mutation AddItemToWishlist($productId: Int!) {
  addItemToWishList(productId: $productId, brandId: 1)
}
    `;

export const useAddItemToWishlistMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddItemToWishlistMutation, TError, AddItemToWishlistMutationVariables, TContext>) => {

    return useMutation<AddItemToWishlistMutation, TError, AddItemToWishlistMutationVariables, TContext>(
      {
    mutationKey: ['AddItemToWishlist'],
    mutationFn: (variables?: AddItemToWishlistMutationVariables) => fetchData<AddItemToWishlistMutation, AddItemToWishlistMutationVariables>(AddItemToWishlistDocument, variables)(),
    ...options
  }
    )};


useAddItemToWishlistMutation.fetcher = (variables: AddItemToWishlistMutationVariables, options?: RequestInit['headers']) => fetchData<AddItemToWishlistMutation, AddItemToWishlistMutationVariables>(AddItemToWishlistDocument, variables, options);

export const AddRestockAlertDocument = `
    mutation AddRestockAlert($productId: Int!, $optionId: Int, $brandId: Int) {
  addRestockAlert(productId: $productId, optionId: $optionId, brandId: $brandId)
}
    `;

export const useAddRestockAlertMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddRestockAlertMutation, TError, AddRestockAlertMutationVariables, TContext>) => {
    
    return useMutation<AddRestockAlertMutation, TError, AddRestockAlertMutationVariables, TContext>(
      {
    mutationKey: ['AddRestockAlert'],
    mutationFn: (variables?: AddRestockAlertMutationVariables) => fetchData<AddRestockAlertMutation, AddRestockAlertMutationVariables>(AddRestockAlertDocument, variables)(),
    ...options
  }
    )};


useAddRestockAlertMutation.fetcher = (variables: AddRestockAlertMutationVariables, options?: RequestInit['headers']) => fetchData<AddRestockAlertMutation, AddRestockAlertMutationVariables>(AddRestockAlertDocument, variables, options);

export const AssignCartToCustomerDocument = `
    mutation AssignCartToCustomer($shoppingCartToken: String!, $customerId: Int!) {
  assignCartToCustomer(
    shoppingCartToken: $shoppingCartToken
    customerId: $customerId
  )
}
    `;

export const useAssignCartToCustomerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AssignCartToCustomerMutation, TError, AssignCartToCustomerMutationVariables, TContext>) => {
    
    return useMutation<AssignCartToCustomerMutation, TError, AssignCartToCustomerMutationVariables, TContext>(
      {
    mutationKey: ['AssignCartToCustomer'],
    mutationFn: (variables?: AssignCartToCustomerMutationVariables) => fetchData<AssignCartToCustomerMutation, AssignCartToCustomerMutationVariables>(AssignCartToCustomerDocument, variables)(),
    ...options
  }
    )};


useAssignCartToCustomerMutation.fetcher = (variables: AssignCartToCustomerMutationVariables, options?: RequestInit['headers']) => fetchData<AssignCartToCustomerMutation, AssignCartToCustomerMutationVariables>(AssignCartToCustomerDocument, variables, options);

export const CancelSubscriptionDocument = `
    mutation CancelSubscription($subscriptionId: Int!, $reason: String!, $howTheyMightStay: String!) {
  cancelSubscription(
    subscriptionId: $subscriptionId
    reason: $reason
    howTheyMightStay: $howTheyMightStay
  )
}
    `;

export const useCancelSubscriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CancelSubscriptionMutation, TError, CancelSubscriptionMutationVariables, TContext>) => {
    
    return useMutation<CancelSubscriptionMutation, TError, CancelSubscriptionMutationVariables, TContext>(
      {
    mutationKey: ['CancelSubscription'],
    mutationFn: (variables?: CancelSubscriptionMutationVariables) => fetchData<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, variables)(),
    ...options
  }
    )};


useCancelSubscriptionMutation.fetcher = (variables: CancelSubscriptionMutationVariables, options?: RequestInit['headers']) => fetchData<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, variables, options);

export const CaptureShoppingCartPayPalOrderAndCompleteCartDocument = `
    mutation CaptureShoppingCartPayPalOrderAndCompleteCart($shoppingCartToken: String!, $paypalOrderId: String!, $addToNewsletter: Boolean = false, $prepayImportDuties: Boolean = false) {
  captureShoppingCartPayPalOrderAndCompleteCart(
    shoppingCartToken: $shoppingCartToken
    paypalOrderId: $paypalOrderId
    addToNewsletter: $addToNewsletter
    prepayImportDuties: $prepayImportDuties
  )
}
    `;

export const useCaptureShoppingCartPayPalOrderAndCompleteCartMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CaptureShoppingCartPayPalOrderAndCompleteCartMutation, TError, CaptureShoppingCartPayPalOrderAndCompleteCartMutationVariables, TContext>) => {
    
    return useMutation<CaptureShoppingCartPayPalOrderAndCompleteCartMutation, TError, CaptureShoppingCartPayPalOrderAndCompleteCartMutationVariables, TContext>(
      {
    mutationKey: ['CaptureShoppingCartPayPalOrderAndCompleteCart'],
    mutationFn: (variables?: CaptureShoppingCartPayPalOrderAndCompleteCartMutationVariables) => fetchData<CaptureShoppingCartPayPalOrderAndCompleteCartMutation, CaptureShoppingCartPayPalOrderAndCompleteCartMutationVariables>(CaptureShoppingCartPayPalOrderAndCompleteCartDocument, variables)(),
    ...options
  }
    )};


useCaptureShoppingCartPayPalOrderAndCompleteCartMutation.fetcher = (variables: CaptureShoppingCartPayPalOrderAndCompleteCartMutationVariables, options?: RequestInit['headers']) => fetchData<CaptureShoppingCartPayPalOrderAndCompleteCartMutation, CaptureShoppingCartPayPalOrderAndCompleteCartMutationVariables>(CaptureShoppingCartPayPalOrderAndCompleteCartDocument, variables, options);

export const CompleteManualPaymentDocument = `
    mutation CompleteManualPayment($paymentIntentId: String!, $amount: Decimal!, $currency: String!) {
  completeManualPayment(
    paymentIntentId: $paymentIntentId
    amount: $amount
    currency: $currency
  )
}
    `;

export const useCompleteManualPaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CompleteManualPaymentMutation, TError, CompleteManualPaymentMutationVariables, TContext>) => {
    
    return useMutation<CompleteManualPaymentMutation, TError, CompleteManualPaymentMutationVariables, TContext>(
      {
    mutationKey: ['CompleteManualPayment'],
    mutationFn: (variables?: CompleteManualPaymentMutationVariables) => fetchData<CompleteManualPaymentMutation, CompleteManualPaymentMutationVariables>(CompleteManualPaymentDocument, variables)(),
    ...options
  }
    )};


useCompleteManualPaymentMutation.fetcher = (variables: CompleteManualPaymentMutationVariables, options?: RequestInit['headers']) => fetchData<CompleteManualPaymentMutation, CompleteManualPaymentMutationVariables>(CompleteManualPaymentDocument, variables, options);

export const CompleteShoppingCartAsAdminWithoutOnlinePaymentDocument = `
    mutation CompleteShoppingCartAsAdminWithoutOnlinePayment($shoppingCartToken: String!, $mode: AdminShoppingCartCompletionMode!, $addToNewsletter: Boolean = false, $prepayImportDuties: Boolean = false) {
  completeShoppingCartAsAdminWithoutOnlinePayment(
    shoppingCartToken: $shoppingCartToken
    mode: $mode
    addToNewsletter: $addToNewsletter
    prepayImportDuties: $prepayImportDuties
  )
}
    `;

export const useCompleteShoppingCartAsAdminWithoutOnlinePaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CompleteShoppingCartAsAdminWithoutOnlinePaymentMutation, TError, CompleteShoppingCartAsAdminWithoutOnlinePaymentMutationVariables, TContext>) => {
    
    return useMutation<CompleteShoppingCartAsAdminWithoutOnlinePaymentMutation, TError, CompleteShoppingCartAsAdminWithoutOnlinePaymentMutationVariables, TContext>(
      {
    mutationKey: ['CompleteShoppingCartAsAdminWithoutOnlinePayment'],
    mutationFn: (variables?: CompleteShoppingCartAsAdminWithoutOnlinePaymentMutationVariables) => fetchData<CompleteShoppingCartAsAdminWithoutOnlinePaymentMutation, CompleteShoppingCartAsAdminWithoutOnlinePaymentMutationVariables>(CompleteShoppingCartAsAdminWithoutOnlinePaymentDocument, variables)(),
    ...options
  }
    )};


useCompleteShoppingCartAsAdminWithoutOnlinePaymentMutation.fetcher = (variables: CompleteShoppingCartAsAdminWithoutOnlinePaymentMutationVariables, options?: RequestInit['headers']) => fetchData<CompleteShoppingCartAsAdminWithoutOnlinePaymentMutation, CompleteShoppingCartAsAdminWithoutOnlinePaymentMutationVariables>(CompleteShoppingCartAsAdminWithoutOnlinePaymentDocument, variables, options);

export const CompleteShoppingCartWithStripePaymentDocument = `
    mutation CompleteShoppingCartWithStripePayment($shoppingCartToken: String!, $paymentIntentId: String!, $addToNewsletter: Boolean = false, $prepayImportDuties: Boolean = false) {
  completeShoppingCartWithStripePayment(
    shoppingCartToken: $shoppingCartToken
    paymentIntentId: $paymentIntentId
    addToNewsletter: $addToNewsletter
    prepayImportDuties: $prepayImportDuties
  )
}
    `;

export const useCompleteShoppingCartWithStripePaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CompleteShoppingCartWithStripePaymentMutation, TError, CompleteShoppingCartWithStripePaymentMutationVariables, TContext>) => {
    
    return useMutation<CompleteShoppingCartWithStripePaymentMutation, TError, CompleteShoppingCartWithStripePaymentMutationVariables, TContext>(
      {
    mutationKey: ['CompleteShoppingCartWithStripePayment'],
    mutationFn: (variables?: CompleteShoppingCartWithStripePaymentMutationVariables) => fetchData<CompleteShoppingCartWithStripePaymentMutation, CompleteShoppingCartWithStripePaymentMutationVariables>(CompleteShoppingCartWithStripePaymentDocument, variables)(),
    ...options
  }
    )};


useCompleteShoppingCartWithStripePaymentMutation.fetcher = (variables: CompleteShoppingCartWithStripePaymentMutationVariables, options?: RequestInit['headers']) => fetchData<CompleteShoppingCartWithStripePaymentMutation, CompleteShoppingCartWithStripePaymentMutationVariables>(CompleteShoppingCartWithStripePaymentDocument, variables, options);

export const CompleteShoppingCartWithoutPaymentDocument = `
    mutation CompleteShoppingCartWithoutPayment($shoppingCartToken: String!, $addToNewsletter: Boolean = false, $prepayImportDuties: Boolean = false) {
  completeShoppingCartWithoutPayment(
    shoppingCartToken: $shoppingCartToken
    addToNewsletter: $addToNewsletter
    prepayImportDuties: $prepayImportDuties
  )
}
    `;

export const useCompleteShoppingCartWithoutPaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CompleteShoppingCartWithoutPaymentMutation, TError, CompleteShoppingCartWithoutPaymentMutationVariables, TContext>) => {
    
    return useMutation<CompleteShoppingCartWithoutPaymentMutation, TError, CompleteShoppingCartWithoutPaymentMutationVariables, TContext>(
      {
    mutationKey: ['CompleteShoppingCartWithoutPayment'],
    mutationFn: (variables?: CompleteShoppingCartWithoutPaymentMutationVariables) => fetchData<CompleteShoppingCartWithoutPaymentMutation, CompleteShoppingCartWithoutPaymentMutationVariables>(CompleteShoppingCartWithoutPaymentDocument, variables)(),
    ...options
  }
    )};


useCompleteShoppingCartWithoutPaymentMutation.fetcher = (variables: CompleteShoppingCartWithoutPaymentMutationVariables, options?: RequestInit['headers']) => fetchData<CompleteShoppingCartWithoutPaymentMutation, CompleteShoppingCartWithoutPaymentMutationVariables>(CompleteShoppingCartWithoutPaymentDocument, variables, options);

export const ConfirmReturnImageUploadDocument = `
    mutation ConfirmReturnImageUpload($orderId: Int!, $orderItemId: Int!, $fileName: String!) {
  confirmReturnImageUpload(
    orderId: $orderId
    orderItemId: $orderItemId
    fileName: $fileName
  )
}
    `;

export const useConfirmReturnImageUploadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ConfirmReturnImageUploadMutation, TError, ConfirmReturnImageUploadMutationVariables, TContext>) => {
    
    return useMutation<ConfirmReturnImageUploadMutation, TError, ConfirmReturnImageUploadMutationVariables, TContext>(
      {
    mutationKey: ['ConfirmReturnImageUpload'],
    mutationFn: (variables?: ConfirmReturnImageUploadMutationVariables) => fetchData<ConfirmReturnImageUploadMutation, ConfirmReturnImageUploadMutationVariables>(ConfirmReturnImageUploadDocument, variables)(),
    ...options
  }
    )};


useConfirmReturnImageUploadMutation.fetcher = (variables: ConfirmReturnImageUploadMutationVariables, options?: RequestInit['headers']) => fetchData<ConfirmReturnImageUploadMutation, ConfirmReturnImageUploadMutationVariables>(ConfirmReturnImageUploadDocument, variables, options);

export const ConvertPointsToStoreCreditDocument = `
    mutation ConvertPointsToStoreCredit($brandId: Int!, $currencyId: Int!) {
  convertPointsToStoreCredit(brandId: $brandId, currencyId: $currencyId) {
    pointsConverted
    storeCreditAmount
    currencyId
  }
}
    `;

export const useConvertPointsToStoreCreditMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ConvertPointsToStoreCreditMutation, TError, ConvertPointsToStoreCreditMutationVariables, TContext>) => {
    
    return useMutation<ConvertPointsToStoreCreditMutation, TError, ConvertPointsToStoreCreditMutationVariables, TContext>(
      {
    mutationKey: ['ConvertPointsToStoreCredit'],
    mutationFn: (variables?: ConvertPointsToStoreCreditMutationVariables) => fetchData<ConvertPointsToStoreCreditMutation, ConvertPointsToStoreCreditMutationVariables>(ConvertPointsToStoreCreditDocument, variables)(),
    ...options
  }
    )};


useConvertPointsToStoreCreditMutation.fetcher = (variables: ConvertPointsToStoreCreditMutationVariables, options?: RequestInit['headers']) => fetchData<ConvertPointsToStoreCreditMutation, ConvertPointsToStoreCreditMutationVariables>(ConvertPointsToStoreCreditDocument, variables, options);

export const ConvertVoucherToStoreCreditDocument = `
    mutation ConvertVoucherToStoreCredit($brandId: Int!, $voucherCode: String!) {
  convertVoucherToStoreCredit(brandId: $brandId, voucherCode: $voucherCode) {
    amount
    currencyId
  }
}
    `;

export const useConvertVoucherToStoreCreditMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ConvertVoucherToStoreCreditMutation, TError, ConvertVoucherToStoreCreditMutationVariables, TContext>) => {
    
    return useMutation<ConvertVoucherToStoreCreditMutation, TError, ConvertVoucherToStoreCreditMutationVariables, TContext>(
      {
    mutationKey: ['ConvertVoucherToStoreCredit'],
    mutationFn: (variables?: ConvertVoucherToStoreCreditMutationVariables) => fetchData<ConvertVoucherToStoreCreditMutation, ConvertVoucherToStoreCreditMutationVariables>(ConvertVoucherToStoreCreditDocument, variables)(),
    ...options
  }
    )};


useConvertVoucherToStoreCreditMutation.fetcher = (variables: ConvertVoucherToStoreCreditMutationVariables, options?: RequestInit['headers']) => fetchData<ConvertVoucherToStoreCreditMutation, ConvertVoucherToStoreCreditMutationVariables>(ConvertVoucherToStoreCreditDocument, variables, options);

export const CreateAnonymousShoppingCartDocument = `
    mutation CreateAnonymousShoppingCart($countryIsoCode: String!, $currencyId: Int, $isConventionCart: Boolean) {
  createAnonymousShoppingCart(
    countryIsoCode: $countryIsoCode
    currencyId: $currencyId
    isConventionCart: $isConventionCart
  )
}
    `;

export const useCreateAnonymousShoppingCartMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateAnonymousShoppingCartMutation, TError, CreateAnonymousShoppingCartMutationVariables, TContext>) => {
    
    return useMutation<CreateAnonymousShoppingCartMutation, TError, CreateAnonymousShoppingCartMutationVariables, TContext>(
      {
    mutationKey: ['CreateAnonymousShoppingCart'],
    mutationFn: (variables?: CreateAnonymousShoppingCartMutationVariables) => fetchData<CreateAnonymousShoppingCartMutation, CreateAnonymousShoppingCartMutationVariables>(CreateAnonymousShoppingCartDocument, variables)(),
    ...options
  }
    )};


useCreateAnonymousShoppingCartMutation.fetcher = (variables: CreateAnonymousShoppingCartMutationVariables, options?: RequestInit['headers']) => fetchData<CreateAnonymousShoppingCartMutation, CreateAnonymousShoppingCartMutationVariables>(CreateAnonymousShoppingCartDocument, variables, options);

export const CreateBlogCommentDocument = `
    mutation CreateBlogComment($customerId: Int!, $blogPostId: Int!, $comment: String!, $responseTo: Int) {
  createBlogComment(
    customerId: $customerId
    blogPostId: $blogPostId
    comment: $comment
    responseTo: $responseTo
  )
}
    `;

export const useCreateBlogCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateBlogCommentMutation, TError, CreateBlogCommentMutationVariables, TContext>) => {
    
    return useMutation<CreateBlogCommentMutation, TError, CreateBlogCommentMutationVariables, TContext>(
      {
    mutationKey: ['CreateBlogComment'],
    mutationFn: (variables?: CreateBlogCommentMutationVariables) => fetchData<CreateBlogCommentMutation, CreateBlogCommentMutationVariables>(CreateBlogCommentDocument, variables)(),
    ...options
  }
    )};


useCreateBlogCommentMutation.fetcher = (variables: CreateBlogCommentMutationVariables, options?: RequestInit['headers']) => fetchData<CreateBlogCommentMutation, CreateBlogCommentMutationVariables>(CreateBlogCommentDocument, variables, options);

export const CreateCustomerDocument = `
    mutation CreateCustomer($firstName: String!, $lastName: String!, $email: String!, $password: String, $howSignedUp: Int = 1, $addToNewsletter: Boolean = false, $skipEmailValidation: Boolean = false) {
  createCustomer(
    firstName: $firstName
    lastName: $lastName
    email: $email
    password: $password
    howSignedUp: $howSignedUp
    addToNewsletter: $addToNewsletter
    skipEmailValidation: $skipEmailValidation
  ) {
    success
    customerId
    emailValidation {
      isValid
      errorType
      errorMessage
      suggestion
      correctedEmail
    }
    message
  }
}
    `;

export const useCreateCustomerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCustomerMutation, TError, CreateCustomerMutationVariables, TContext>) => {
    
    return useMutation<CreateCustomerMutation, TError, CreateCustomerMutationVariables, TContext>(
      {
    mutationKey: ['CreateCustomer'],
    mutationFn: (variables?: CreateCustomerMutationVariables) => fetchData<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, variables)(),
    ...options
  }
    )};


useCreateCustomerMutation.fetcher = (variables: CreateCustomerMutationVariables, options?: RequestInit['headers']) => fetchData<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, variables, options);

export const CreateCustomerAddressDocument = `
    mutation CreateCustomerAddress($customerId: Int!, $input: CreateCustomerAddressInput!, $shoppingCartToken: String) {
  createCustomerAddress(
    customerId: $customerId
    input: $input
    shoppingCartToken: $shoppingCartToken
  ) {
    addressId
    isValidated
    validationErrorMessage
  }
}
    `;

export const useCreateCustomerAddressMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCustomerAddressMutation, TError, CreateCustomerAddressMutationVariables, TContext>) => {
    
    return useMutation<CreateCustomerAddressMutation, TError, CreateCustomerAddressMutationVariables, TContext>(
      {
    mutationKey: ['CreateCustomerAddress'],
    mutationFn: (variables?: CreateCustomerAddressMutationVariables) => fetchData<CreateCustomerAddressMutation, CreateCustomerAddressMutationVariables>(CreateCustomerAddressDocument, variables)(),
    ...options
  }
    )};


useCreateCustomerAddressMutation.fetcher = (variables: CreateCustomerAddressMutationVariables, options?: RequestInit['headers']) => fetchData<CreateCustomerAddressMutation, CreateCustomerAddressMutationVariables>(CreateCustomerAddressDocument, variables, options);

export const CreateCustomerBrandLinkDocument = `
    mutation CreateCustomerBrandLink($brandId: Int) {
  createCustomerBrandLink(brandId: $brandId)
}
    `;

export const useCreateCustomerBrandLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCustomerBrandLinkMutation, TError, CreateCustomerBrandLinkMutationVariables, TContext>) => {
    
    return useMutation<CreateCustomerBrandLinkMutation, TError, CreateCustomerBrandLinkMutationVariables, TContext>(
      {
    mutationKey: ['CreateCustomerBrandLink'],
    mutationFn: (variables?: CreateCustomerBrandLinkMutationVariables) => fetchData<CreateCustomerBrandLinkMutation, CreateCustomerBrandLinkMutationVariables>(CreateCustomerBrandLinkDocument, variables)(),
    ...options
  }
    )};


useCreateCustomerBrandLinkMutation.fetcher = (variables?: CreateCustomerBrandLinkMutationVariables, options?: RequestInit['headers']) => fetchData<CreateCustomerBrandLinkMutation, CreateCustomerBrandLinkMutationVariables>(CreateCustomerBrandLinkDocument, variables, options);

export const CreateCustomerReviewDocument = `
    mutation CreateCustomerReview($productId: Int!, $rating: Int!, $review: String) {
  createCustomerReview(productId: $productId, rating: $rating, review: $review)
}
    `;

export const useCreateCustomerReviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCustomerReviewMutation, TError, CreateCustomerReviewMutationVariables, TContext>) => {
    
    return useMutation<CreateCustomerReviewMutation, TError, CreateCustomerReviewMutationVariables, TContext>(
      {
    mutationKey: ['CreateCustomerReview'],
    mutationFn: (variables?: CreateCustomerReviewMutationVariables) => fetchData<CreateCustomerReviewMutation, CreateCustomerReviewMutationVariables>(CreateCustomerReviewDocument, variables)(),
    ...options
  }
    )};


useCreateCustomerReviewMutation.fetcher = (variables: CreateCustomerReviewMutationVariables, options?: RequestInit['headers']) => fetchData<CreateCustomerReviewMutation, CreateCustomerReviewMutationVariables>(CreateCustomerReviewDocument, variables, options);

export const CreateCustomerShoppingCartDocument = `
    mutation CreateCustomerShoppingCart($customerId: Int!, $countryIsoCode: String!, $currencyId: Int, $forceNew: Boolean, $isConventionCart: Boolean) {
  createCustomerShoppingCart(
    customerId: $customerId
    countryIsoCode: $countryIsoCode
    currencyId: $currencyId
    forceNew: $forceNew
    isConventionCart: $isConventionCart
  )
}
    `;

export const useCreateCustomerShoppingCartMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCustomerShoppingCartMutation, TError, CreateCustomerShoppingCartMutationVariables, TContext>) => {
    
    return useMutation<CreateCustomerShoppingCartMutation, TError, CreateCustomerShoppingCartMutationVariables, TContext>(
      {
    mutationKey: ['CreateCustomerShoppingCart'],
    mutationFn: (variables?: CreateCustomerShoppingCartMutationVariables) => fetchData<CreateCustomerShoppingCartMutation, CreateCustomerShoppingCartMutationVariables>(CreateCustomerShoppingCartDocument, variables)(),
    ...options
  }
    )};


useCreateCustomerShoppingCartMutation.fetcher = (variables: CreateCustomerShoppingCartMutationVariables, options?: RequestInit['headers']) => fetchData<CreateCustomerShoppingCartMutation, CreateCustomerShoppingCartMutationVariables>(CreateCustomerShoppingCartDocument, variables, options);

export const CreateInstructionLinkDocument = `
    mutation CreateInstructionLink($instructionLink: String!, $productName: String!, $instructionPassword: String) {
  createInstructionLink(
    instructionLink: $instructionLink
    productName: $productName
    instructionPassword: $instructionPassword
  )
}
    `;

export const useCreateInstructionLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateInstructionLinkMutation, TError, CreateInstructionLinkMutationVariables, TContext>) => {
    
    return useMutation<CreateInstructionLinkMutation, TError, CreateInstructionLinkMutationVariables, TContext>(
      {
    mutationKey: ['CreateInstructionLink'],
    mutationFn: (variables?: CreateInstructionLinkMutationVariables) => fetchData<CreateInstructionLinkMutation, CreateInstructionLinkMutationVariables>(CreateInstructionLinkDocument, variables)(),
    ...options
  }
    )};


useCreateInstructionLinkMutation.fetcher = (variables: CreateInstructionLinkMutationVariables, options?: RequestInit['headers']) => fetchData<CreateInstructionLinkMutation, CreateInstructionLinkMutationVariables>(CreateInstructionLinkDocument, variables, options);

export const CreateManualPaymentIntentDocument = `
    mutation CreateManualPaymentIntent($amount: Decimal!, $currency: String!, $emailAddress: String!, $cardholderName: String!, $notes: String) {
  createManualPaymentIntent(
    amount: $amount
    currency: $currency
    emailAddress: $emailAddress
    cardholderName: $cardholderName
    notes: $notes
  ) {
    paymentIntentId
    clientSecret
    stripePublicKey
  }
}
    `;

export const useCreateManualPaymentIntentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateManualPaymentIntentMutation, TError, CreateManualPaymentIntentMutationVariables, TContext>) => {
    
    return useMutation<CreateManualPaymentIntentMutation, TError, CreateManualPaymentIntentMutationVariables, TContext>(
      {
    mutationKey: ['CreateManualPaymentIntent'],
    mutationFn: (variables?: CreateManualPaymentIntentMutationVariables) => fetchData<CreateManualPaymentIntentMutation, CreateManualPaymentIntentMutationVariables>(CreateManualPaymentIntentDocument, variables)(),
    ...options
  }
    )};


useCreateManualPaymentIntentMutation.fetcher = (variables: CreateManualPaymentIntentMutationVariables, options?: RequestInit['headers']) => fetchData<CreateManualPaymentIntentMutation, CreateManualPaymentIntentMutationVariables>(CreateManualPaymentIntentDocument, variables, options);

export const CreatePaymentMethodSetupTokenDocument = `
    mutation CreatePaymentMethodSetupToken($brandId: Int!) {
  createPaymentMethodSetupToken(brandId: $brandId)
}
    `;

export const useCreatePaymentMethodSetupTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePaymentMethodSetupTokenMutation, TError, CreatePaymentMethodSetupTokenMutationVariables, TContext>) => {
    
    return useMutation<CreatePaymentMethodSetupTokenMutation, TError, CreatePaymentMethodSetupTokenMutationVariables, TContext>(
      {
    mutationKey: ['CreatePaymentMethodSetupToken'],
    mutationFn: (variables?: CreatePaymentMethodSetupTokenMutationVariables) => fetchData<CreatePaymentMethodSetupTokenMutation, CreatePaymentMethodSetupTokenMutationVariables>(CreatePaymentMethodSetupTokenDocument, variables)(),
    ...options
  }
    )};


useCreatePaymentMethodSetupTokenMutation.fetcher = (variables: CreatePaymentMethodSetupTokenMutationVariables, options?: RequestInit['headers']) => fetchData<CreatePaymentMethodSetupTokenMutation, CreatePaymentMethodSetupTokenMutationVariables>(CreatePaymentMethodSetupTokenDocument, variables, options);

export const CreateProductQuestionDocument = `
    mutation CreateProductQuestion($productId: Int!, $question: String!, $responseTo: Int) {
  createProductQuestion(
    productId: $productId
    question: $question
    responseTo: $responseTo
  ) {
    id
    customerId
    customerName
    question
    responseTo
    answers {
      id
      customerId
      customerName
      answer
      isCreator
      responseTo
    }
  }
}
    `;

export const useCreateProductQuestionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateProductQuestionMutation, TError, CreateProductQuestionMutationVariables, TContext>) => {
    
    return useMutation<CreateProductQuestionMutation, TError, CreateProductQuestionMutationVariables, TContext>(
      {
    mutationKey: ['CreateProductQuestion'],
    mutationFn: (variables?: CreateProductQuestionMutationVariables) => fetchData<CreateProductQuestionMutation, CreateProductQuestionMutationVariables>(CreateProductQuestionDocument, variables)(),
    ...options
  }
    )};


useCreateProductQuestionMutation.fetcher = (variables: CreateProductQuestionMutationVariables, options?: RequestInit['headers']) => fetchData<CreateProductQuestionMutation, CreateProductQuestionMutationVariables>(CreateProductQuestionDocument, variables, options);

export const CreateReturnDocument = `
    mutation CreateReturn($orderId: Int!, $items: [ReturnRequestItemDtoInput!]!) {
  createReturn(orderId: $orderId, items: $items)
}
    `;

export const useCreateReturnMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateReturnMutation, TError, CreateReturnMutationVariables, TContext>) => {
    
    return useMutation<CreateReturnMutation, TError, CreateReturnMutationVariables, TContext>(
      {
    mutationKey: ['CreateReturn'],
    mutationFn: (variables?: CreateReturnMutationVariables) => fetchData<CreateReturnMutation, CreateReturnMutationVariables>(CreateReturnDocument, variables)(),
    ...options
  }
    )};


useCreateReturnMutation.fetcher = (variables: CreateReturnMutationVariables, options?: RequestInit['headers']) => fetchData<CreateReturnMutation, CreateReturnMutationVariables>(CreateReturnDocument, variables, options);

export const CreateShoppingCartPayPalOrderDocument = `
    mutation CreateShoppingCartPayPalOrder($shoppingCartToken: String!, $prepayImportDuties: Boolean = false, $lockShippingAddress: Boolean = false) {
  createShoppingCartPayPalOrder(
    shoppingCartToken: $shoppingCartToken
    prepayImportDuties: $prepayImportDuties
    lockShippingAddress: $lockShippingAddress
  ) {
    paypalOrderId
  }
}
    `;

export const useCreateShoppingCartPayPalOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateShoppingCartPayPalOrderMutation, TError, CreateShoppingCartPayPalOrderMutationVariables, TContext>) => {
    
    return useMutation<CreateShoppingCartPayPalOrderMutation, TError, CreateShoppingCartPayPalOrderMutationVariables, TContext>(
      {
    mutationKey: ['CreateShoppingCartPayPalOrder'],
    mutationFn: (variables?: CreateShoppingCartPayPalOrderMutationVariables) => fetchData<CreateShoppingCartPayPalOrderMutation, CreateShoppingCartPayPalOrderMutationVariables>(CreateShoppingCartPayPalOrderDocument, variables)(),
    ...options
  }
    )};


useCreateShoppingCartPayPalOrderMutation.fetcher = (variables: CreateShoppingCartPayPalOrderMutationVariables, options?: RequestInit['headers']) => fetchData<CreateShoppingCartPayPalOrderMutation, CreateShoppingCartPayPalOrderMutationVariables>(CreateShoppingCartPayPalOrderDocument, variables, options);

export const CreateShoppingCartPaymentIntentDocument = `
    mutation CreateShoppingCartPaymentIntent($shoppingCartToken: String!, $paymentMethodType: String, $paymentMethodId: String, $prepayImportDuties: Boolean = false) {
  createShoppingCartPaymentIntent(
    shoppingCartToken: $shoppingCartToken
    paymentMethodType: $paymentMethodType
    paymentMethodId: $paymentMethodId
    prepayImportDuties: $prepayImportDuties
  ) {
    paymentIntentId
    clientSecret
    stripePublicKey
  }
}
    `;

export const useCreateShoppingCartPaymentIntentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateShoppingCartPaymentIntentMutation, TError, CreateShoppingCartPaymentIntentMutationVariables, TContext>) => {
    
    return useMutation<CreateShoppingCartPaymentIntentMutation, TError, CreateShoppingCartPaymentIntentMutationVariables, TContext>(
      {
    mutationKey: ['CreateShoppingCartPaymentIntent'],
    mutationFn: (variables?: CreateShoppingCartPaymentIntentMutationVariables) => fetchData<CreateShoppingCartPaymentIntentMutation, CreateShoppingCartPaymentIntentMutationVariables>(CreateShoppingCartPaymentIntentDocument, variables)(),
    ...options
  }
    )};


useCreateShoppingCartPaymentIntentMutation.fetcher = (variables: CreateShoppingCartPaymentIntentMutationVariables, options?: RequestInit['headers']) => fetchData<CreateShoppingCartPaymentIntentMutation, CreateShoppingCartPaymentIntentMutationVariables>(CreateShoppingCartPaymentIntentDocument, variables, options);

export const DeactivateAppDeviceDocument = `
    mutation DeactivateAppDevice($deviceId: Int!) {
  deactivateAppDevice(deviceId: $deviceId) {
    success
    message
  }
}
    `;

export const useDeactivateAppDeviceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeactivateAppDeviceMutation, TError, DeactivateAppDeviceMutationVariables, TContext>) => {
    
    return useMutation<DeactivateAppDeviceMutation, TError, DeactivateAppDeviceMutationVariables, TContext>(
      {
    mutationKey: ['DeactivateAppDevice'],
    mutationFn: (variables?: DeactivateAppDeviceMutationVariables) => fetchData<DeactivateAppDeviceMutation, DeactivateAppDeviceMutationVariables>(DeactivateAppDeviceDocument, variables)(),
    ...options
  }
    )};


useDeactivateAppDeviceMutation.fetcher = (variables: DeactivateAppDeviceMutationVariables, options?: RequestInit['headers']) => fetchData<DeactivateAppDeviceMutation, DeactivateAppDeviceMutationVariables>(DeactivateAppDeviceDocument, variables, options);

export const DeleteCustomerAddressDocument = `
    mutation DeleteCustomerAddress($customerAddressId: Int!) {
  deleteCustomerAddress(customerAddressId: $customerAddressId) {
    success
  }
}
    `;

export const useDeleteCustomerAddressMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCustomerAddressMutation, TError, DeleteCustomerAddressMutationVariables, TContext>) => {
    
    return useMutation<DeleteCustomerAddressMutation, TError, DeleteCustomerAddressMutationVariables, TContext>(
      {
    mutationKey: ['DeleteCustomerAddress'],
    mutationFn: (variables?: DeleteCustomerAddressMutationVariables) => fetchData<DeleteCustomerAddressMutation, DeleteCustomerAddressMutationVariables>(DeleteCustomerAddressDocument, variables)(),
    ...options
  }
    )};


useDeleteCustomerAddressMutation.fetcher = (variables: DeleteCustomerAddressMutationVariables, options?: RequestInit['headers']) => fetchData<DeleteCustomerAddressMutation, DeleteCustomerAddressMutationVariables>(DeleteCustomerAddressDocument, variables, options);

export const DeleteCustomerPaymentMethodDocument = `
    mutation DeleteCustomerPaymentMethod($brandId: Int!, $paymentMethodId: String!) {
  deleteCustomerPaymentMethod(
    brandId: $brandId
    paymentMethodId: $paymentMethodId
  )
}
    `;

export const useDeleteCustomerPaymentMethodMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCustomerPaymentMethodMutation, TError, DeleteCustomerPaymentMethodMutationVariables, TContext>) => {
    
    return useMutation<DeleteCustomerPaymentMethodMutation, TError, DeleteCustomerPaymentMethodMutationVariables, TContext>(
      {
    mutationKey: ['DeleteCustomerPaymentMethod'],
    mutationFn: (variables?: DeleteCustomerPaymentMethodMutationVariables) => fetchData<DeleteCustomerPaymentMethodMutation, DeleteCustomerPaymentMethodMutationVariables>(DeleteCustomerPaymentMethodDocument, variables)(),
    ...options
  }
    )};


useDeleteCustomerPaymentMethodMutation.fetcher = (variables: DeleteCustomerPaymentMethodMutationVariables, options?: RequestInit['headers']) => fetchData<DeleteCustomerPaymentMethodMutation, DeleteCustomerPaymentMethodMutationVariables>(DeleteCustomerPaymentMethodDocument, variables, options);

export const DeleteCustomerReviewDocument = `
    mutation DeleteCustomerReview($reviewId: Int!) {
  deleteCustomerReview(reviewId: $reviewId)
}
    `;

export const useDeleteCustomerReviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCustomerReviewMutation, TError, DeleteCustomerReviewMutationVariables, TContext>) => {
    
    return useMutation<DeleteCustomerReviewMutation, TError, DeleteCustomerReviewMutationVariables, TContext>(
      {
    mutationKey: ['DeleteCustomerReview'],
    mutationFn: (variables?: DeleteCustomerReviewMutationVariables) => fetchData<DeleteCustomerReviewMutation, DeleteCustomerReviewMutationVariables>(DeleteCustomerReviewDocument, variables)(),
    ...options
  }
    )};


useDeleteCustomerReviewMutation.fetcher = (variables: DeleteCustomerReviewMutationVariables, options?: RequestInit['headers']) => fetchData<DeleteCustomerReviewMutation, DeleteCustomerReviewMutationVariables>(DeleteCustomerReviewDocument, variables, options);

export const DeleteInstructionLinkDocument = `
    mutation DeleteInstructionLink($instructionLinkId: Int!) {
  deleteInstructionLink(instructionLinkId: $instructionLinkId)
}
    `;

export const useDeleteInstructionLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteInstructionLinkMutation, TError, DeleteInstructionLinkMutationVariables, TContext>) => {
    
    return useMutation<DeleteInstructionLinkMutation, TError, DeleteInstructionLinkMutationVariables, TContext>(
      {
    mutationKey: ['DeleteInstructionLink'],
    mutationFn: (variables?: DeleteInstructionLinkMutationVariables) => fetchData<DeleteInstructionLinkMutation, DeleteInstructionLinkMutationVariables>(DeleteInstructionLinkDocument, variables)(),
    ...options
  }
    )};


useDeleteInstructionLinkMutation.fetcher = (variables: DeleteInstructionLinkMutationVariables, options?: RequestInit['headers']) => fetchData<DeleteInstructionLinkMutation, DeleteInstructionLinkMutationVariables>(DeleteInstructionLinkDocument, variables, options);

export const GrantFreeDownloadDocument = `
    mutation GrantFreeDownload($customerId: Int!, $brandId: Int!, $productSlug: String!) {
  grantFreeDownload(
    customerId: $customerId
    brandId: $brandId
    productSlug: $productSlug
  ) {
    success
    message
    productId
    orderId
    alreadyHadAccess
    productName
  }
}
    `;

export const useGrantFreeDownloadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GrantFreeDownloadMutation, TError, GrantFreeDownloadMutationVariables, TContext>) => {
    
    return useMutation<GrantFreeDownloadMutation, TError, GrantFreeDownloadMutationVariables, TContext>(
      {
    mutationKey: ['GrantFreeDownload'],
    mutationFn: (variables?: GrantFreeDownloadMutationVariables) => fetchData<GrantFreeDownloadMutation, GrantFreeDownloadMutationVariables>(GrantFreeDownloadDocument, variables)(),
    ...options
  }
    )};


useGrantFreeDownloadMutation.fetcher = (variables: GrantFreeDownloadMutationVariables, options?: RequestInit['headers']) => fetchData<GrantFreeDownloadMutation, GrantFreeDownloadMutationVariables>(GrantFreeDownloadDocument, variables, options);

export const MergeAnonymousShoppingCartDocument = `
    mutation MergeAnonymousShoppingCart($anonymousCartToken: String!, $customerId: Int!, $countryIsoCode: String!) {
  mergeAnonymousShoppingCart(
    anonymousCartToken: $anonymousCartToken
    customerId: $customerId
    countryIsoCode: $countryIsoCode
  ) {
    success
    status
    mergedItemCount
    skippedItemCount
    skippedReasonCodes
  }
}
    `;

export const useMergeAnonymousShoppingCartMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MergeAnonymousShoppingCartMutation, TError, MergeAnonymousShoppingCartMutationVariables, TContext>) => {
    
    return useMutation<MergeAnonymousShoppingCartMutation, TError, MergeAnonymousShoppingCartMutationVariables, TContext>(
      {
    mutationKey: ['MergeAnonymousShoppingCart'],
    mutationFn: (variables?: MergeAnonymousShoppingCartMutationVariables) => fetchData<MergeAnonymousShoppingCartMutation, MergeAnonymousShoppingCartMutationVariables>(MergeAnonymousShoppingCartDocument, variables)(),
    ...options
  }
    )};


useMergeAnonymousShoppingCartMutation.fetcher = (variables: MergeAnonymousShoppingCartMutationVariables, options?: RequestInit['headers']) => fetchData<MergeAnonymousShoppingCartMutation, MergeAnonymousShoppingCartMutationVariables>(MergeAnonymousShoppingCartDocument, variables, options);

export const PauseSubscriptionDocument = `
    mutation PauseSubscription($subscriptionId: Int!) {
  pauseSubscription(subscriptionId: $subscriptionId)
}
    `;

export const usePauseSubscriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PauseSubscriptionMutation, TError, PauseSubscriptionMutationVariables, TContext>) => {
    
    return useMutation<PauseSubscriptionMutation, TError, PauseSubscriptionMutationVariables, TContext>(
      {
    mutationKey: ['PauseSubscription'],
    mutationFn: (variables?: PauseSubscriptionMutationVariables) => fetchData<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>(PauseSubscriptionDocument, variables)(),
    ...options
  }
    )};


usePauseSubscriptionMutation.fetcher = (variables: PauseSubscriptionMutationVariables, options?: RequestInit['headers']) => fetchData<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>(PauseSubscriptionDocument, variables, options);

export const PresignedUrlForReturnImageDocument = `
    mutation PresignedUrlForReturnImage($orderId: Int!, $orderItemId: Int!, $fileName: String!, $contentType: String!) {
  presignedUrlForReturnImage(
    orderId: $orderId
    orderItemId: $orderItemId
    fileName: $fileName
    contentType: $contentType
  )
}
    `;

export const usePresignedUrlForReturnImageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PresignedUrlForReturnImageMutation, TError, PresignedUrlForReturnImageMutationVariables, TContext>) => {
    
    return useMutation<PresignedUrlForReturnImageMutation, TError, PresignedUrlForReturnImageMutationVariables, TContext>(
      {
    mutationKey: ['PresignedUrlForReturnImage'],
    mutationFn: (variables?: PresignedUrlForReturnImageMutationVariables) => fetchData<PresignedUrlForReturnImageMutation, PresignedUrlForReturnImageMutationVariables>(PresignedUrlForReturnImageDocument, variables)(),
    ...options
  }
    )};


usePresignedUrlForReturnImageMutation.fetcher = (variables: PresignedUrlForReturnImageMutationVariables, options?: RequestInit['headers']) => fetchData<PresignedUrlForReturnImageMutation, PresignedUrlForReturnImageMutationVariables>(PresignedUrlForReturnImageDocument, variables, options);

export const ReactivateSubscriptionDocument = `
    mutation ReactivateSubscription($subscriptionId: Int!) {
  reactivateSubscription(subscriptionId: $subscriptionId)
}
    `;

export const useReactivateSubscriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReactivateSubscriptionMutation, TError, ReactivateSubscriptionMutationVariables, TContext>) => {
    
    return useMutation<ReactivateSubscriptionMutation, TError, ReactivateSubscriptionMutationVariables, TContext>(
      {
    mutationKey: ['ReactivateSubscription'],
    mutationFn: (variables?: ReactivateSubscriptionMutationVariables) => fetchData<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>(ReactivateSubscriptionDocument, variables)(),
    ...options
  }
    )};


useReactivateSubscriptionMutation.fetcher = (variables: ReactivateSubscriptionMutationVariables, options?: RequestInit['headers']) => fetchData<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>(ReactivateSubscriptionDocument, variables, options);

export const RecordProductLiveChatMessageDocument = `
    mutation RecordProductLiveChatMessage($productId: Int!, $message: String!) {
  recordProductLiveChatMessage(productId: $productId, message: $message) {
    id
    message
    timePosted
    customerName
    gravatarUrl
  }
}
    `;

export const useRecordProductLiveChatMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RecordProductLiveChatMessageMutation, TError, RecordProductLiveChatMessageMutationVariables, TContext>) => {
    
    return useMutation<RecordProductLiveChatMessageMutation, TError, RecordProductLiveChatMessageMutationVariables, TContext>(
      {
    mutationKey: ['RecordProductLiveChatMessage'],
    mutationFn: (variables?: RecordProductLiveChatMessageMutationVariables) => fetchData<RecordProductLiveChatMessageMutation, RecordProductLiveChatMessageMutationVariables>(RecordProductLiveChatMessageDocument, variables)(),
    ...options
  }
    )};


useRecordProductLiveChatMessageMutation.fetcher = (variables: RecordProductLiveChatMessageMutationVariables, options?: RequestInit['headers']) => fetchData<RecordProductLiveChatMessageMutation, RecordProductLiveChatMessageMutationVariables>(RecordProductLiveChatMessageDocument, variables, options);

export const RecoverPaidCheckoutDocument = `
    mutation RecoverPaidCheckout($paymentIntentId: String!) {
  recoverPaidCheckout(paymentIntentId: $paymentIntentId) {
    paymentIntentId
    status
    message
    paymentSucceeded
    canRetry
    orderId
    shoppingCartId
  }
}
    `;

export const useRecoverPaidCheckoutMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RecoverPaidCheckoutMutation, TError, RecoverPaidCheckoutMutationVariables, TContext>) => {
    
    return useMutation<RecoverPaidCheckoutMutation, TError, RecoverPaidCheckoutMutationVariables, TContext>(
      {
    mutationKey: ['RecoverPaidCheckout'],
    mutationFn: (variables?: RecoverPaidCheckoutMutationVariables) => fetchData<RecoverPaidCheckoutMutation, RecoverPaidCheckoutMutationVariables>(RecoverPaidCheckoutDocument, variables)(),
    ...options
  }
    )};


useRecoverPaidCheckoutMutation.fetcher = (variables: RecoverPaidCheckoutMutationVariables, options?: RequestInit['headers']) => fetchData<RecoverPaidCheckoutMutation, RecoverPaidCheckoutMutationVariables>(RecoverPaidCheckoutDocument, variables, options);

export const RedeemDownloadCardDocument = `
    mutation RedeemDownloadCard($customerId: Int!, $brandId: Int!, $code: String!, $expectedProductId: Int) {
  redeemDownloadCard(
    customerId: $customerId
    brandId: $brandId
    code: $code
    expectedProductId: $expectedProductId
  ) {
    status
    message
    productId
    orderId
  }
}
    `;

export const useRedeemDownloadCardMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RedeemDownloadCardMutation, TError, RedeemDownloadCardMutationVariables, TContext>) => {
    
    return useMutation<RedeemDownloadCardMutation, TError, RedeemDownloadCardMutationVariables, TContext>(
      {
    mutationKey: ['RedeemDownloadCard'],
    mutationFn: (variables?: RedeemDownloadCardMutationVariables) => fetchData<RedeemDownloadCardMutation, RedeemDownloadCardMutationVariables>(RedeemDownloadCardDocument, variables)(),
    ...options
  }
    )};


useRedeemDownloadCardMutation.fetcher = (variables: RedeemDownloadCardMutationVariables, options?: RequestInit['headers']) => fetchData<RedeemDownloadCardMutation, RedeemDownloadCardMutationVariables>(RedeemDownloadCardDocument, variables, options);

export const RefreshShoppingCartPricesDocument = `
    mutation RefreshShoppingCartPrices($shoppingCartToken: String!) {
  refreshShoppingCartPrices(shoppingCartToken: $shoppingCartToken)
}
    `;

export const useRefreshShoppingCartPricesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RefreshShoppingCartPricesMutation, TError, RefreshShoppingCartPricesMutationVariables, TContext>) => {
    
    return useMutation<RefreshShoppingCartPricesMutation, TError, RefreshShoppingCartPricesMutationVariables, TContext>(
      {
    mutationKey: ['RefreshShoppingCartPrices'],
    mutationFn: (variables?: RefreshShoppingCartPricesMutationVariables) => fetchData<RefreshShoppingCartPricesMutation, RefreshShoppingCartPricesMutationVariables>(RefreshShoppingCartPricesDocument, variables)(),
    ...options
  }
    )};


useRefreshShoppingCartPricesMutation.fetcher = (variables: RefreshShoppingCartPricesMutationVariables, options?: RequestInit['headers']) => fetchData<RefreshShoppingCartPricesMutation, RefreshShoppingCartPricesMutationVariables>(RefreshShoppingCartPricesDocument, variables, options);

export const RegisterMagicStoreSignupDocument = `
    mutation RegisterMagicStoreSignup($email: String!, $firstName: String, $lastName: String, $store: String, $skipEmailValidation: Boolean = false) {
  registerMagicStoreSignup(
    email: $email
    firstName: $firstName
    lastName: $lastName
    store: $store
    skipEmailValidation: $skipEmailValidation
  ) {
    success
    message
    emailValidation {
      isValid
      errorType
      errorMessage
      suggestion
      correctedEmail
    }
  }
}
    `;

export const useRegisterMagicStoreSignupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RegisterMagicStoreSignupMutation, TError, RegisterMagicStoreSignupMutationVariables, TContext>) => {
    
    return useMutation<RegisterMagicStoreSignupMutation, TError, RegisterMagicStoreSignupMutationVariables, TContext>(
      {
    mutationKey: ['RegisterMagicStoreSignup'],
    mutationFn: (variables?: RegisterMagicStoreSignupMutationVariables) => fetchData<RegisterMagicStoreSignupMutation, RegisterMagicStoreSignupMutationVariables>(RegisterMagicStoreSignupDocument, variables)(),
    ...options
  }
    )};


useRegisterMagicStoreSignupMutation.fetcher = (variables: RegisterMagicStoreSignupMutationVariables, options?: RequestInit['headers']) => fetchData<RegisterMagicStoreSignupMutation, RegisterMagicStoreSignupMutationVariables>(RegisterMagicStoreSignupDocument, variables, options);

export const RemoveCartItemDocument = `
    mutation RemoveCartItem($shoppingCartToken: String!, $cartItemId: Int!) {
  removeItemFromCart(
    shoppingCartToken: $shoppingCartToken
    cartItemId: $cartItemId
  ) {
    success
  }
}
    `;

export const useRemoveCartItemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveCartItemMutation, TError, RemoveCartItemMutationVariables, TContext>) => {
    
    return useMutation<RemoveCartItemMutation, TError, RemoveCartItemMutationVariables, TContext>(
      {
    mutationKey: ['RemoveCartItem'],
    mutationFn: (variables?: RemoveCartItemMutationVariables) => fetchData<RemoveCartItemMutation, RemoveCartItemMutationVariables>(RemoveCartItemDocument, variables)(),
    ...options
  }
    )};


useRemoveCartItemMutation.fetcher = (variables: RemoveCartItemMutationVariables, options?: RequestInit['headers']) => fetchData<RemoveCartItemMutation, RemoveCartItemMutationVariables>(RemoveCartItemDocument, variables, options);

export const RemoveCustomerFromSegmentDocument = `
    mutation RemoveCustomerFromSegment($segmentId: Int!, $workspace: CustomerIOWorkspace) {
  removeCustomerFromSegment(segmentId: $segmentId, workspace: $workspace)
}
    `;

export const useRemoveCustomerFromSegmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveCustomerFromSegmentMutation, TError, RemoveCustomerFromSegmentMutationVariables, TContext>) => {
    
    return useMutation<RemoveCustomerFromSegmentMutation, TError, RemoveCustomerFromSegmentMutationVariables, TContext>(
      {
    mutationKey: ['RemoveCustomerFromSegment'],
    mutationFn: (variables?: RemoveCustomerFromSegmentMutationVariables) => fetchData<RemoveCustomerFromSegmentMutation, RemoveCustomerFromSegmentMutationVariables>(RemoveCustomerFromSegmentDocument, variables)(),
    ...options
  }
    )};


useRemoveCustomerFromSegmentMutation.fetcher = (variables: RemoveCustomerFromSegmentMutationVariables, options?: RequestInit['headers']) => fetchData<RemoveCustomerFromSegmentMutation, RemoveCustomerFromSegmentMutationVariables>(RemoveCustomerFromSegmentDocument, variables, options);

export const RemoveItemFromWishlistDocument = `
    mutation RemoveItemFromWishlist($productId: Int!) {
  removeItemFromWishList(productId: $productId)
}
    `;

export const useRemoveItemFromWishlistMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveItemFromWishlistMutation, TError, RemoveItemFromWishlistMutationVariables, TContext>) => {
    
    return useMutation<RemoveItemFromWishlistMutation, TError, RemoveItemFromWishlistMutationVariables, TContext>(
      {
    mutationKey: ['RemoveItemFromWishlist'],
    mutationFn: (variables?: RemoveItemFromWishlistMutationVariables) => fetchData<RemoveItemFromWishlistMutation, RemoveItemFromWishlistMutationVariables>(RemoveItemFromWishlistDocument, variables)(),
    ...options
  }
    )};


useRemoveItemFromWishlistMutation.fetcher = (variables: RemoveItemFromWishlistMutationVariables, options?: RequestInit['headers']) => fetchData<RemoveItemFromWishlistMutation, RemoveItemFromWishlistMutationVariables>(RemoveItemFromWishlistDocument, variables, options);

export const RequestPasswordResetDocument = `
    mutation RequestPasswordReset($email: String!) {
  requestPasswordReset(email: $email)
}
    `;

export const useRequestPasswordResetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RequestPasswordResetMutation, TError, RequestPasswordResetMutationVariables, TContext>) => {
    
    return useMutation<RequestPasswordResetMutation, TError, RequestPasswordResetMutationVariables, TContext>(
      {
    mutationKey: ['RequestPasswordReset'],
    mutationFn: (variables?: RequestPasswordResetMutationVariables) => fetchData<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, variables)(),
    ...options
  }
    )};


useRequestPasswordResetMutation.fetcher = (variables: RequestPasswordResetMutationVariables, options?: RequestInit['headers']) => fetchData<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, variables, options);

export const ResetPasswordDocument = `
    mutation ResetPassword($hash: String!, $customerId: Int!, $newPassword: String!, $confirmNewPassword: String!) {
  resetPassword(
    hash: $hash
    customerId: $customerId
    newPassword: $newPassword
    confirmNewPassword: $confirmNewPassword
  )
}
    `;

export const useResetPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>) => {
    
    return useMutation<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>(
      {
    mutationKey: ['ResetPassword'],
    mutationFn: (variables?: ResetPasswordMutationVariables) => fetchData<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, variables)(),
    ...options
  }
    )};


useResetPasswordMutation.fetcher = (variables: ResetPasswordMutationVariables, options?: RequestInit['headers']) => fetchData<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, variables, options);

export const RetryPaymentDocument = `
    mutation RetryPayment($subscriptionId: Int!) {
  retryPaymentWithResult(subscriptionId: $subscriptionId) {
    status
  }
}
    `;

export const useRetryPaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RetryPaymentMutation, TError, RetryPaymentMutationVariables, TContext>) => {
    
    return useMutation<RetryPaymentMutation, TError, RetryPaymentMutationVariables, TContext>(
      {
    mutationKey: ['RetryPayment'],
    mutationFn: (variables?: RetryPaymentMutationVariables) => fetchData<RetryPaymentMutation, RetryPaymentMutationVariables>(RetryPaymentDocument, variables)(),
    ...options
  }
    )};


useRetryPaymentMutation.fetcher = (variables: RetryPaymentMutationVariables, options?: RequestInit['headers']) => fetchData<RetryPaymentMutation, RetryPaymentMutationVariables>(RetryPaymentDocument, variables, options);

export const SendWishlistEmailDocument = `
    mutation SendWishlistEmail($recipientEmail: String!, $brandId: Int) {
  sendWishlistEmail(recipientEmail: $recipientEmail, brandId: $brandId)
}
    `;

export const useSendWishlistEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendWishlistEmailMutation, TError, SendWishlistEmailMutationVariables, TContext>) => {
    
    return useMutation<SendWishlistEmailMutation, TError, SendWishlistEmailMutationVariables, TContext>(
      {
    mutationKey: ['SendWishlistEmail'],
    mutationFn: (variables?: SendWishlistEmailMutationVariables) => fetchData<SendWishlistEmailMutation, SendWishlistEmailMutationVariables>(SendWishlistEmailDocument, variables)(),
    ...options
  }
    )};


useSendWishlistEmailMutation.fetcher = (variables: SendWishlistEmailMutationVariables, options?: RequestInit['headers']) => fetchData<SendWishlistEmailMutation, SendWishlistEmailMutationVariables>(SendWishlistEmailDocument, variables, options);

export const SetDefaultCustomerPaymentMethodDocument = `
    mutation SetDefaultCustomerPaymentMethod($brandId: Int!, $paymentMethodId: String!) {
  setDefaultCustomerPaymentMethod(
    brandId: $brandId
    paymentMethodId: $paymentMethodId
  )
}
    `;

export const useSetDefaultCustomerPaymentMethodMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetDefaultCustomerPaymentMethodMutation, TError, SetDefaultCustomerPaymentMethodMutationVariables, TContext>) => {
    
    return useMutation<SetDefaultCustomerPaymentMethodMutation, TError, SetDefaultCustomerPaymentMethodMutationVariables, TContext>(
      {
    mutationKey: ['SetDefaultCustomerPaymentMethod'],
    mutationFn: (variables?: SetDefaultCustomerPaymentMethodMutationVariables) => fetchData<SetDefaultCustomerPaymentMethodMutation, SetDefaultCustomerPaymentMethodMutationVariables>(SetDefaultCustomerPaymentMethodDocument, variables)(),
    ...options
  }
    )};


useSetDefaultCustomerPaymentMethodMutation.fetcher = (variables: SetDefaultCustomerPaymentMethodMutationVariables, options?: RequestInit['headers']) => fetchData<SetDefaultCustomerPaymentMethodMutation, SetDefaultCustomerPaymentMethodMutationVariables>(SetDefaultCustomerPaymentMethodDocument, variables, options);

export const SetShoppingCartShippingFromAddressDocument = `
    mutation SetShoppingCartShippingFromAddress($shoppingCartToken: String!, $address: ShippingAddressInput!, $shippingOptionId: String!, $shippingOptionDescription: String!, $shippingMethodId: Int!, $estDelivery: String!, $price: Decimal!, $shippingRateHash: String!, $currencySymbol: String!) {
  setShoppingCartShippingFromAddress(
    shoppingCartToken: $shoppingCartToken
    address: $address
    shippingOptionId: $shippingOptionId
    shippingOptionDescription: $shippingOptionDescription
    shippingMethodId: $shippingMethodId
    estDelivery: $estDelivery
    price: $price
    shippingRateHash: $shippingRateHash
    currencySymbol: $currencySymbol
  )
}
    `;

export const useSetShoppingCartShippingFromAddressMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetShoppingCartShippingFromAddressMutation, TError, SetShoppingCartShippingFromAddressMutationVariables, TContext>) => {
    
    return useMutation<SetShoppingCartShippingFromAddressMutation, TError, SetShoppingCartShippingFromAddressMutationVariables, TContext>(
      {
    mutationKey: ['SetShoppingCartShippingFromAddress'],
    mutationFn: (variables?: SetShoppingCartShippingFromAddressMutationVariables) => fetchData<SetShoppingCartShippingFromAddressMutation, SetShoppingCartShippingFromAddressMutationVariables>(SetShoppingCartShippingFromAddressDocument, variables)(),
    ...options
  }
    )};


useSetShoppingCartShippingFromAddressMutation.fetcher = (variables: SetShoppingCartShippingFromAddressMutationVariables, options?: RequestInit['headers']) => fetchData<SetShoppingCartShippingFromAddressMutation, SetShoppingCartShippingFromAddressMutationVariables>(SetShoppingCartShippingFromAddressDocument, variables, options);

export const SubmitConsultingFormDocument = `
    mutation SubmitConsultingForm($name: String!, $companyName: String!, $email: String!, $details: String!) {
  submitConsultingForm(
    name: $name
    companyName: $companyName
    email: $email
    details: $details
  )
}
    `;

export const useSubmitConsultingFormMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitConsultingFormMutation, TError, SubmitConsultingFormMutationVariables, TContext>) => {
    
    return useMutation<SubmitConsultingFormMutation, TError, SubmitConsultingFormMutationVariables, TContext>(
      {
    mutationKey: ['SubmitConsultingForm'],
    mutationFn: (variables?: SubmitConsultingFormMutationVariables) => fetchData<SubmitConsultingFormMutation, SubmitConsultingFormMutationVariables>(SubmitConsultingFormDocument, variables)(),
    ...options
  }
    )};


useSubmitConsultingFormMutation.fetcher = (variables: SubmitConsultingFormMutationVariables, options?: RequestInit['headers']) => fetchData<SubmitConsultingFormMutation, SubmitConsultingFormMutationVariables>(SubmitConsultingFormDocument, variables, options);

export const SubmitContactFormDocument = `
    mutation SubmitContactForm($name: String!, $email: String!, $reason: String!, $question: String!, $orderNumber: String) {
  submitContactForm(
    name: $name
    email: $email
    reason: $reason
    question: $question
    orderNumber: $orderNumber
  )
}
    `;

export const useSubmitContactFormMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitContactFormMutation, TError, SubmitContactFormMutationVariables, TContext>) => {
    
    return useMutation<SubmitContactFormMutation, TError, SubmitContactFormMutationVariables, TContext>(
      {
    mutationKey: ['SubmitContactForm'],
    mutationFn: (variables?: SubmitContactFormMutationVariables) => fetchData<SubmitContactFormMutation, SubmitContactFormMutationVariables>(SubmitContactFormDocument, variables)(),
    ...options
  }
    )};


useSubmitContactFormMutation.fetcher = (variables: SubmitContactFormMutationVariables, options?: RequestInit['headers']) => fetchData<SubmitContactFormMutation, SubmitContactFormMutationVariables>(SubmitContactFormDocument, variables, options);

export const SubmitJobApplicationDocument = `
    mutation SubmitJobApplication($turnstileToken: String!, $name: String!, $email: String!, $location: String!, $jobTitle: String!, $jobSlug: String!, $additionalNotes: String, $cvBase64: String, $cvFileName: String) {
  submitJobApplication(
    turnstileToken: $turnstileToken
    name: $name
    email: $email
    location: $location
    jobTitle: $jobTitle
    jobSlug: $jobSlug
    additionalNotes: $additionalNotes
    cvBase64: $cvBase64
    cvFileName: $cvFileName
  )
}
    `;

export const useSubmitJobApplicationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitJobApplicationMutation, TError, SubmitJobApplicationMutationVariables, TContext>) => {
    
    return useMutation<SubmitJobApplicationMutation, TError, SubmitJobApplicationMutationVariables, TContext>(
      {
    mutationKey: ['SubmitJobApplication'],
    mutationFn: (variables?: SubmitJobApplicationMutationVariables) => fetchData<SubmitJobApplicationMutation, SubmitJobApplicationMutationVariables>(SubmitJobApplicationDocument, variables)(),
    ...options
  }
    )};


useSubmitJobApplicationMutation.fetcher = (variables: SubmitJobApplicationMutationVariables, options?: RequestInit['headers']) => fetchData<SubmitJobApplicationMutation, SubmitJobApplicationMutationVariables>(SubmitJobApplicationDocument, variables, options);

export const SubmitReviewerApplicationDocument = `
    mutation SubmitReviewerApplication($aboutYou: String!, $email: String!, $name: String!) {
  submitReviewerApplication(
    input: {aboutYou: $aboutYou, email: $email, name: $name}
  )
}
    `;

export const useSubmitReviewerApplicationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitReviewerApplicationMutation, TError, SubmitReviewerApplicationMutationVariables, TContext>) => {
    
    return useMutation<SubmitReviewerApplicationMutation, TError, SubmitReviewerApplicationMutationVariables, TContext>(
      {
    mutationKey: ['SubmitReviewerApplication'],
    mutationFn: (variables?: SubmitReviewerApplicationMutationVariables) => fetchData<SubmitReviewerApplicationMutation, SubmitReviewerApplicationMutationVariables>(SubmitReviewerApplicationDocument, variables)(),
    ...options
  }
    )};


useSubmitReviewerApplicationMutation.fetcher = (variables: SubmitReviewerApplicationMutationVariables, options?: RequestInit['headers']) => fetchData<SubmitReviewerApplicationMutation, SubmitReviewerApplicationMutationVariables>(SubmitReviewerApplicationDocument, variables, options);

export const SubmitReviewerProductRequestDocument = `
    mutation SubmitReviewerProductRequest($input: ReviewerProductRequestInput!) {
  submitReviewerProductRequest(input: $input)
}
    `;

export const useSubmitReviewerProductRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitReviewerProductRequestMutation, TError, SubmitReviewerProductRequestMutationVariables, TContext>) => {
    
    return useMutation<SubmitReviewerProductRequestMutation, TError, SubmitReviewerProductRequestMutationVariables, TContext>(
      {
    mutationKey: ['SubmitReviewerProductRequest'],
    mutationFn: (variables?: SubmitReviewerProductRequestMutationVariables) => fetchData<SubmitReviewerProductRequestMutation, SubmitReviewerProductRequestMutationVariables>(SubmitReviewerProductRequestDocument, variables)(),
    ...options
  }
    )};


useSubmitReviewerProductRequestMutation.fetcher = (variables: SubmitReviewerProductRequestMutationVariables, options?: RequestInit['headers']) => fetchData<SubmitReviewerProductRequestMutation, SubmitReviewerProductRequestMutationVariables>(SubmitReviewerProductRequestDocument, variables, options);

export const SubmitSupportSurveyDocument = `
    mutation SubmitSupportSurvey($externalId: String!, $rating: Int, $customerServiceRating: Int!, $responseAttribution: String!, $comments: String!, $generalFeedback: String, $followUpRequested: Boolean!) {
  submitSupportSurvey(
    externalId: $externalId
    rating: $rating
    customerServiceRating: $customerServiceRating
    responseAttribution: $responseAttribution
    comments: $comments
    generalFeedback: $generalFeedback
    followUpRequested: $followUpRequested
  ) {
    success
    vimeoId
  }
}
    `;

export const useSubmitSupportSurveyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitSupportSurveyMutation, TError, SubmitSupportSurveyMutationVariables, TContext>) => {
    
    return useMutation<SubmitSupportSurveyMutation, TError, SubmitSupportSurveyMutationVariables, TContext>(
      {
    mutationKey: ['SubmitSupportSurvey'],
    mutationFn: (variables?: SubmitSupportSurveyMutationVariables) => fetchData<SubmitSupportSurveyMutation, SubmitSupportSurveyMutationVariables>(SubmitSupportSurveyDocument, variables)(),
    ...options
  }
    )};


useSubmitSupportSurveyMutation.fetcher = (variables: SubmitSupportSurveyMutationVariables, options?: RequestInit['headers']) => fetchData<SubmitSupportSurveyMutation, SubmitSupportSurveyMutationVariables>(SubmitSupportSurveyDocument, variables, options);

export const SubmitTrickDocument = `
    mutation SubmitTrick($name: String!, $email: String!, $trickName: String!, $description: String!, $websiteUrl: String, $videoUrl: String) {
  submitTrick(
    name: $name
    email: $email
    trickName: $trickName
    description: $description
    websiteUrl: $websiteUrl
    videoUrl: $videoUrl
  )
}
    `;

export const useSubmitTrickMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitTrickMutation, TError, SubmitTrickMutationVariables, TContext>) => {
    
    return useMutation<SubmitTrickMutation, TError, SubmitTrickMutationVariables, TContext>(
      {
    mutationKey: ['SubmitTrick'],
    mutationFn: (variables?: SubmitTrickMutationVariables) => fetchData<SubmitTrickMutation, SubmitTrickMutationVariables>(SubmitTrickDocument, variables)(),
    ...options
  }
    )};


useSubmitTrickMutation.fetcher = (variables: SubmitTrickMutationVariables, options?: RequestInit['headers']) => fetchData<SubmitTrickMutation, SubmitTrickMutationVariables>(SubmitTrickDocument, variables, options);

export const UnPauseSubscriptionDocument = `
    mutation UnPauseSubscription($subscriptionId: Int!) {
  unpauseSubscription(subscriptionId: $subscriptionId)
}
    `;

export const useUnPauseSubscriptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnPauseSubscriptionMutation, TError, UnPauseSubscriptionMutationVariables, TContext>) => {
    
    return useMutation<UnPauseSubscriptionMutation, TError, UnPauseSubscriptionMutationVariables, TContext>(
      {
    mutationKey: ['UnPauseSubscription'],
    mutationFn: (variables?: UnPauseSubscriptionMutationVariables) => fetchData<UnPauseSubscriptionMutation, UnPauseSubscriptionMutationVariables>(UnPauseSubscriptionDocument, variables)(),
    ...options
  }
    )};


useUnPauseSubscriptionMutation.fetcher = (variables: UnPauseSubscriptionMutationVariables, options?: RequestInit['headers']) => fetchData<UnPauseSubscriptionMutation, UnPauseSubscriptionMutationVariables>(UnPauseSubscriptionDocument, variables, options);

export const UnsubscribeFromAllNewslettersDocument = `
    mutation UnsubscribeFromAllNewsletters($workspace: CustomerIOWorkspace) {
  unsubscribeFromAllNewsletters(workspace: $workspace)
}
    `;

export const useUnsubscribeFromAllNewslettersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnsubscribeFromAllNewslettersMutation, TError, UnsubscribeFromAllNewslettersMutationVariables, TContext>) => {
    
    return useMutation<UnsubscribeFromAllNewslettersMutation, TError, UnsubscribeFromAllNewslettersMutationVariables, TContext>(
      {
    mutationKey: ['UnsubscribeFromAllNewsletters'],
    mutationFn: (variables?: UnsubscribeFromAllNewslettersMutationVariables) => fetchData<UnsubscribeFromAllNewslettersMutation, UnsubscribeFromAllNewslettersMutationVariables>(UnsubscribeFromAllNewslettersDocument, variables)(),
    ...options
  }
    )};


useUnsubscribeFromAllNewslettersMutation.fetcher = (variables?: UnsubscribeFromAllNewslettersMutationVariables, options?: RequestInit['headers']) => fetchData<UnsubscribeFromAllNewslettersMutation, UnsubscribeFromAllNewslettersMutationVariables>(UnsubscribeFromAllNewslettersDocument, variables, options);

export const UpdateCustomerBirthdayDocument = `
    mutation UpdateCustomerBirthday($birthday: DateTime!) {
  updateCustomerBirthday(birthday: $birthday)
}
    `;

export const useUpdateCustomerBirthdayMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCustomerBirthdayMutation, TError, UpdateCustomerBirthdayMutationVariables, TContext>) => {
    
    return useMutation<UpdateCustomerBirthdayMutation, TError, UpdateCustomerBirthdayMutationVariables, TContext>(
      {
    mutationKey: ['UpdateCustomerBirthday'],
    mutationFn: (variables?: UpdateCustomerBirthdayMutationVariables) => fetchData<UpdateCustomerBirthdayMutation, UpdateCustomerBirthdayMutationVariables>(UpdateCustomerBirthdayDocument, variables)(),
    ...options
  }
    )};


useUpdateCustomerBirthdayMutation.fetcher = (variables: UpdateCustomerBirthdayMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateCustomerBirthdayMutation, UpdateCustomerBirthdayMutationVariables>(UpdateCustomerBirthdayDocument, variables, options);

export const UpdateCustomerEmailDocument = `
    mutation UpdateCustomerEmail($input: UpdateCustomerEmailInput!) {
  updateCustomerEmail(input: $input) {
    success
    errorMessage
    suggestion
    correctedEmail
    validationWarnings
  }
}
    `;

export const useUpdateCustomerEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCustomerEmailMutation, TError, UpdateCustomerEmailMutationVariables, TContext>) => {
    
    return useMutation<UpdateCustomerEmailMutation, TError, UpdateCustomerEmailMutationVariables, TContext>(
      {
    mutationKey: ['UpdateCustomerEmail'],
    mutationFn: (variables?: UpdateCustomerEmailMutationVariables) => fetchData<UpdateCustomerEmailMutation, UpdateCustomerEmailMutationVariables>(UpdateCustomerEmailDocument, variables)(),
    ...options
  }
    )};


useUpdateCustomerEmailMutation.fetcher = (variables: UpdateCustomerEmailMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateCustomerEmailMutation, UpdateCustomerEmailMutationVariables>(UpdateCustomerEmailDocument, variables, options);

export const UpdateCustomerEoriDocument = `
    mutation UpdateCustomerEori($input: UpdateCustomerEoriInput!) {
  updateCustomerEori(input: $input)
}
    `;

export const useUpdateCustomerEoriMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCustomerEoriMutation, TError, UpdateCustomerEoriMutationVariables, TContext>) => {
    
    return useMutation<UpdateCustomerEoriMutation, TError, UpdateCustomerEoriMutationVariables, TContext>(
      {
    mutationKey: ['UpdateCustomerEori'],
    mutationFn: (variables?: UpdateCustomerEoriMutationVariables) => fetchData<UpdateCustomerEoriMutation, UpdateCustomerEoriMutationVariables>(UpdateCustomerEoriDocument, variables)(),
    ...options
  }
    )};


useUpdateCustomerEoriMutation.fetcher = (variables: UpdateCustomerEoriMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateCustomerEoriMutation, UpdateCustomerEoriMutationVariables>(UpdateCustomerEoriDocument, variables, options);

export const UpdateCustomerReviewDocument = `
    mutation UpdateCustomerReview($reviewId: Int!, $rating: Int!, $review: String, $status: Int) {
  updateCustomerReview(
    reviewId: $reviewId
    rating: $rating
    review: $review
    status: $status
  )
}
    `;

export const useUpdateCustomerReviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCustomerReviewMutation, TError, UpdateCustomerReviewMutationVariables, TContext>) => {
    
    return useMutation<UpdateCustomerReviewMutation, TError, UpdateCustomerReviewMutationVariables, TContext>(
      {
    mutationKey: ['UpdateCustomerReview'],
    mutationFn: (variables?: UpdateCustomerReviewMutationVariables) => fetchData<UpdateCustomerReviewMutation, UpdateCustomerReviewMutationVariables>(UpdateCustomerReviewDocument, variables)(),
    ...options
  }
    )};


useUpdateCustomerReviewMutation.fetcher = (variables: UpdateCustomerReviewMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateCustomerReviewMutation, UpdateCustomerReviewMutationVariables>(UpdateCustomerReviewDocument, variables, options);

export const UpdateCustomerVatDocument = `
    mutation UpdateCustomerVat($input: UpdateCustomerVatInput!) {
  updateCustomerVat(input: $input)
}
    `;

export const useUpdateCustomerVatMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCustomerVatMutation, TError, UpdateCustomerVatMutationVariables, TContext>) => {
    
    return useMutation<UpdateCustomerVatMutation, TError, UpdateCustomerVatMutationVariables, TContext>(
      {
    mutationKey: ['UpdateCustomerVat'],
    mutationFn: (variables?: UpdateCustomerVatMutationVariables) => fetchData<UpdateCustomerVatMutation, UpdateCustomerVatMutationVariables>(UpdateCustomerVatDocument, variables)(),
    ...options
  }
    )};


useUpdateCustomerVatMutation.fetcher = (variables: UpdateCustomerVatMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateCustomerVatMutation, UpdateCustomerVatMutationVariables>(UpdateCustomerVatDocument, variables, options);

export const UpdateDefaultCustomerAddressDocument = `
    mutation UpdateDefaultCustomerAddress($customerAddressId: Int!) {
  setDefaultCustomerAddress(customerAddressId: $customerAddressId)
}
    `;

export const useUpdateDefaultCustomerAddressMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateDefaultCustomerAddressMutation, TError, UpdateDefaultCustomerAddressMutationVariables, TContext>) => {
    
    return useMutation<UpdateDefaultCustomerAddressMutation, TError, UpdateDefaultCustomerAddressMutationVariables, TContext>(
      {
    mutationKey: ['UpdateDefaultCustomerAddress'],
    mutationFn: (variables?: UpdateDefaultCustomerAddressMutationVariables) => fetchData<UpdateDefaultCustomerAddressMutation, UpdateDefaultCustomerAddressMutationVariables>(UpdateDefaultCustomerAddressDocument, variables)(),
    ...options
  }
    )};


useUpdateDefaultCustomerAddressMutation.fetcher = (variables: UpdateDefaultCustomerAddressMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateDefaultCustomerAddressMutation, UpdateDefaultCustomerAddressMutationVariables>(UpdateDefaultCustomerAddressDocument, variables, options);

export const UpdateDownloadFileArchiveStatusDocument = `
    mutation UpdateDownloadFileArchiveStatus($productId: Int!, $isArchived: Boolean!) {
  updateDownloadFileArchiveStatus(productId: $productId, isArchived: $isArchived)
}
    `;

export const useUpdateDownloadFileArchiveStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateDownloadFileArchiveStatusMutation, TError, UpdateDownloadFileArchiveStatusMutationVariables, TContext>) => {
    
    return useMutation<UpdateDownloadFileArchiveStatusMutation, TError, UpdateDownloadFileArchiveStatusMutationVariables, TContext>(
      {
    mutationKey: ['UpdateDownloadFileArchiveStatus'],
    mutationFn: (variables?: UpdateDownloadFileArchiveStatusMutationVariables) => fetchData<UpdateDownloadFileArchiveStatusMutation, UpdateDownloadFileArchiveStatusMutationVariables>(UpdateDownloadFileArchiveStatusDocument, variables)(),
    ...options
  }
    )};


useUpdateDownloadFileArchiveStatusMutation.fetcher = (variables: UpdateDownloadFileArchiveStatusMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateDownloadFileArchiveStatusMutation, UpdateDownloadFileArchiveStatusMutationVariables>(UpdateDownloadFileArchiveStatusDocument, variables, options);

export const UpdateDownloadFileLastAccessPointDocument = `
    mutation UpdateDownloadFileLastAccessPoint($downloadFileId: Int!, $lastAccessPoint: Int!) {
  updateDownloadFileLastAccessPoint(
    downloadFileId: $downloadFileId
    lastAccessPoint: $lastAccessPoint
  )
}
    `;

export const useUpdateDownloadFileLastAccessPointMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateDownloadFileLastAccessPointMutation, TError, UpdateDownloadFileLastAccessPointMutationVariables, TContext>) => {
    
    return useMutation<UpdateDownloadFileLastAccessPointMutation, TError, UpdateDownloadFileLastAccessPointMutationVariables, TContext>(
      {
    mutationKey: ['UpdateDownloadFileLastAccessPoint'],
    mutationFn: (variables?: UpdateDownloadFileLastAccessPointMutationVariables) => fetchData<UpdateDownloadFileLastAccessPointMutation, UpdateDownloadFileLastAccessPointMutationVariables>(UpdateDownloadFileLastAccessPointDocument, variables)(),
    ...options
  }
    )};


useUpdateDownloadFileLastAccessPointMutation.fetcher = (variables: UpdateDownloadFileLastAccessPointMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateDownloadFileLastAccessPointMutation, UpdateDownloadFileLastAccessPointMutationVariables>(UpdateDownloadFileLastAccessPointDocument, variables, options);

export const UpdateGuestCheckoutCustomerProfileDocument = `
    mutation UpdateGuestCheckoutCustomerProfile($shoppingCartToken: String!, $customerId: Int!, $firstName: String!, $lastName: String!) {
  updateGuestCheckoutCustomerProfile(
    shoppingCartToken: $shoppingCartToken
    customerId: $customerId
    firstName: $firstName
    lastName: $lastName
  ) {
    success
    errorMessage
  }
}
    `;

export const useUpdateGuestCheckoutCustomerProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateGuestCheckoutCustomerProfileMutation, TError, UpdateGuestCheckoutCustomerProfileMutationVariables, TContext>) => {
    
    return useMutation<UpdateGuestCheckoutCustomerProfileMutation, TError, UpdateGuestCheckoutCustomerProfileMutationVariables, TContext>(
      {
    mutationKey: ['UpdateGuestCheckoutCustomerProfile'],
    mutationFn: (variables?: UpdateGuestCheckoutCustomerProfileMutationVariables) => fetchData<UpdateGuestCheckoutCustomerProfileMutation, UpdateGuestCheckoutCustomerProfileMutationVariables>(UpdateGuestCheckoutCustomerProfileDocument, variables)(),
    ...options
  }
    )};


useUpdateGuestCheckoutCustomerProfileMutation.fetcher = (variables: UpdateGuestCheckoutCustomerProfileMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateGuestCheckoutCustomerProfileMutation, UpdateGuestCheckoutCustomerProfileMutationVariables>(UpdateGuestCheckoutCustomerProfileDocument, variables, options);

export const UpdateGuestCheckoutEmailDocument = `
    mutation UpdateGuestCheckoutEmail($shoppingCartToken: String!, $customerId: Int!, $email: String!) {
  updateGuestCheckoutEmail(
    shoppingCartToken: $shoppingCartToken
    customerId: $customerId
    email: $email
  ) {
    success
    errorMessage
    suggestion
    correctedEmail
    validationWarnings
  }
}
    `;

export const useUpdateGuestCheckoutEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateGuestCheckoutEmailMutation, TError, UpdateGuestCheckoutEmailMutationVariables, TContext>) => {
    
    return useMutation<UpdateGuestCheckoutEmailMutation, TError, UpdateGuestCheckoutEmailMutationVariables, TContext>(
      {
    mutationKey: ['UpdateGuestCheckoutEmail'],
    mutationFn: (variables?: UpdateGuestCheckoutEmailMutationVariables) => fetchData<UpdateGuestCheckoutEmailMutation, UpdateGuestCheckoutEmailMutationVariables>(UpdateGuestCheckoutEmailDocument, variables)(),
    ...options
  }
    )};


useUpdateGuestCheckoutEmailMutation.fetcher = (variables: UpdateGuestCheckoutEmailMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateGuestCheckoutEmailMutation, UpdateGuestCheckoutEmailMutationVariables>(UpdateGuestCheckoutEmailDocument, variables, options);

export const UpdateInstructionLinkDocument = `
    mutation UpdateInstructionLink($instructionLinkId: Int!, $instructionLink: String!, $productName: String!, $instructionPassword: String) {
  updateInstructionLink(
    instructionLinkId: $instructionLinkId
    instructionLink: $instructionLink
    productName: $productName
    instructionPassword: $instructionPassword
  )
}
    `;

export const useUpdateInstructionLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateInstructionLinkMutation, TError, UpdateInstructionLinkMutationVariables, TContext>) => {
    
    return useMutation<UpdateInstructionLinkMutation, TError, UpdateInstructionLinkMutationVariables, TContext>(
      {
    mutationKey: ['UpdateInstructionLink'],
    mutationFn: (variables?: UpdateInstructionLinkMutationVariables) => fetchData<UpdateInstructionLinkMutation, UpdateInstructionLinkMutationVariables>(UpdateInstructionLinkDocument, variables)(),
    ...options
  }
    )};


useUpdateInstructionLinkMutation.fetcher = (variables: UpdateInstructionLinkMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateInstructionLinkMutation, UpdateInstructionLinkMutationVariables>(UpdateInstructionLinkDocument, variables, options);

export const UpdateInvoiceExtraInfoDocument = `
    mutation UpdateInvoiceExtraInfo($brandId: Int!, $extraInfo: String) {
  updateInvoiceExtraInfo(brandId: $brandId, extraInfo: $extraInfo)
}
    `;

export const useUpdateInvoiceExtraInfoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateInvoiceExtraInfoMutation, TError, UpdateInvoiceExtraInfoMutationVariables, TContext>) => {
    
    return useMutation<UpdateInvoiceExtraInfoMutation, TError, UpdateInvoiceExtraInfoMutationVariables, TContext>(
      {
    mutationKey: ['UpdateInvoiceExtraInfo'],
    mutationFn: (variables?: UpdateInvoiceExtraInfoMutationVariables) => fetchData<UpdateInvoiceExtraInfoMutation, UpdateInvoiceExtraInfoMutationVariables>(UpdateInvoiceExtraInfoDocument, variables)(),
    ...options
  }
    )};


useUpdateInvoiceExtraInfoMutation.fetcher = (variables: UpdateInvoiceExtraInfoMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateInvoiceExtraInfoMutation, UpdateInvoiceExtraInfoMutationVariables>(UpdateInvoiceExtraInfoDocument, variables, options);

export const UpdateOrderShippingAddressDocument = `
    mutation UpdateOrderShippingAddress($orderId: Int!, $input: UpdateOrderShippingAddressInput!) {
  updateOrderShippingAddress(orderId: $orderId, input: $input) {
    success
    errorMessage
    newAddressId
  }
}
    `;

export const useUpdateOrderShippingAddressMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOrderShippingAddressMutation, TError, UpdateOrderShippingAddressMutationVariables, TContext>) => {
    
    return useMutation<UpdateOrderShippingAddressMutation, TError, UpdateOrderShippingAddressMutationVariables, TContext>(
      {
    mutationKey: ['UpdateOrderShippingAddress'],
    mutationFn: (variables?: UpdateOrderShippingAddressMutationVariables) => fetchData<UpdateOrderShippingAddressMutation, UpdateOrderShippingAddressMutationVariables>(UpdateOrderShippingAddressDocument, variables)(),
    ...options
  }
    )};


useUpdateOrderShippingAddressMutation.fetcher = (variables: UpdateOrderShippingAddressMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateOrderShippingAddressMutation, UpdateOrderShippingAddressMutationVariables>(UpdateOrderShippingAddressDocument, variables, options);

export const UpdatePasswordDocument = `
    mutation UpdatePassword($newPassword: String!, $confirmNewPassword: String!, $oldPassword: String!) {
  updatePassword(
    newPassword: $newPassword
    confirmNewPassword: $confirmNewPassword
    oldPassword: $oldPassword
  )
}
    `;

export const useUpdatePasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePasswordMutation, TError, UpdatePasswordMutationVariables, TContext>) => {
    
    return useMutation<UpdatePasswordMutation, TError, UpdatePasswordMutationVariables, TContext>(
      {
    mutationKey: ['UpdatePassword'],
    mutationFn: (variables?: UpdatePasswordMutationVariables) => fetchData<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, variables)(),
    ...options
  }
    )};


useUpdatePasswordMutation.fetcher = (variables: UpdatePasswordMutationVariables, options?: RequestInit['headers']) => fetchData<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, variables, options);

export const UpdatePrivateWishlistSettingDocument = `
    mutation UpdatePrivateWishlistSetting($isPrivate: Boolean!) {
  updatePrivateWishlistSetting(isPrivate: $isPrivate)
}
    `;

export const useUpdatePrivateWishlistSettingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePrivateWishlistSettingMutation, TError, UpdatePrivateWishlistSettingMutationVariables, TContext>) => {
    
    return useMutation<UpdatePrivateWishlistSettingMutation, TError, UpdatePrivateWishlistSettingMutationVariables, TContext>(
      {
    mutationKey: ['UpdatePrivateWishlistSetting'],
    mutationFn: (variables?: UpdatePrivateWishlistSettingMutationVariables) => fetchData<UpdatePrivateWishlistSettingMutation, UpdatePrivateWishlistSettingMutationVariables>(UpdatePrivateWishlistSettingDocument, variables)(),
    ...options
  }
    )};


useUpdatePrivateWishlistSettingMutation.fetcher = (variables: UpdatePrivateWishlistSettingMutationVariables, options?: RequestInit['headers']) => fetchData<UpdatePrivateWishlistSettingMutation, UpdatePrivateWishlistSettingMutationVariables>(UpdatePrivateWishlistSettingDocument, variables, options);

export const UpdateShoppingCartItemPriceDocument = `
    mutation UpdateShoppingCartItemPrice($shoppingCartToken: String!, $shoppingCartItemId: Int!, $newPrice: Decimal!) {
  updateShoppingCartItemPrice(
    shoppingCartToken: $shoppingCartToken
    shoppingCartItemId: $shoppingCartItemId
    newPrice: $newPrice
  )
}
    `;

export const useUpdateShoppingCartItemPriceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateShoppingCartItemPriceMutation, TError, UpdateShoppingCartItemPriceMutationVariables, TContext>) => {
    
    return useMutation<UpdateShoppingCartItemPriceMutation, TError, UpdateShoppingCartItemPriceMutationVariables, TContext>(
      {
    mutationKey: ['UpdateShoppingCartItemPrice'],
    mutationFn: (variables?: UpdateShoppingCartItemPriceMutationVariables) => fetchData<UpdateShoppingCartItemPriceMutation, UpdateShoppingCartItemPriceMutationVariables>(UpdateShoppingCartItemPriceDocument, variables)(),
    ...options
  }
    )};


useUpdateShoppingCartItemPriceMutation.fetcher = (variables: UpdateShoppingCartItemPriceMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateShoppingCartItemPriceMutation, UpdateShoppingCartItemPriceMutationVariables>(UpdateShoppingCartItemPriceDocument, variables, options);

export const UpdateShoppingCartItemQtyDocument = `
    mutation UpdateShoppingCartItemQty($shoppingCartToken: String!, $shoppingCartItemId: Int!, $newQty: Int!) {
  updateShoppingCartItemQty(
    shoppingCartToken: $shoppingCartToken
    shoppingCartItemId: $shoppingCartItemId
    newQty: $newQty
  )
}
    `;

export const useUpdateShoppingCartItemQtyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateShoppingCartItemQtyMutation, TError, UpdateShoppingCartItemQtyMutationVariables, TContext>) => {
    
    return useMutation<UpdateShoppingCartItemQtyMutation, TError, UpdateShoppingCartItemQtyMutationVariables, TContext>(
      {
    mutationKey: ['UpdateShoppingCartItemQty'],
    mutationFn: (variables?: UpdateShoppingCartItemQtyMutationVariables) => fetchData<UpdateShoppingCartItemQtyMutation, UpdateShoppingCartItemQtyMutationVariables>(UpdateShoppingCartItemQtyDocument, variables)(),
    ...options
  }
    )};


useUpdateShoppingCartItemQtyMutation.fetcher = (variables: UpdateShoppingCartItemQtyMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateShoppingCartItemQtyMutation, UpdateShoppingCartItemQtyMutationVariables>(UpdateShoppingCartItemQtyDocument, variables, options);

export const UpdateShoppingCartLocationDocument = `
    mutation UpdateShoppingCartLocation($shoppingCartToken: String!, $countryIsoCode: String!) {
  updateShoppingCartLocation(
    shoppingCartToken: $shoppingCartToken
    countryIsoCode: $countryIsoCode
  )
}
    `;

export const useUpdateShoppingCartLocationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateShoppingCartLocationMutation, TError, UpdateShoppingCartLocationMutationVariables, TContext>) => {
    
    return useMutation<UpdateShoppingCartLocationMutation, TError, UpdateShoppingCartLocationMutationVariables, TContext>(
      {
    mutationKey: ['UpdateShoppingCartLocation'],
    mutationFn: (variables?: UpdateShoppingCartLocationMutationVariables) => fetchData<UpdateShoppingCartLocationMutation, UpdateShoppingCartLocationMutationVariables>(UpdateShoppingCartLocationDocument, variables)(),
    ...options
  }
    )};


useUpdateShoppingCartLocationMutation.fetcher = (variables: UpdateShoppingCartLocationMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateShoppingCartLocationMutation, UpdateShoppingCartLocationMutationVariables>(UpdateShoppingCartLocationDocument, variables, options);

export const UpdateShoppingCartPromoCodeDocument = `
    mutation UpdateShoppingCartPromoCode($shoppingCartToken: String!, $promoCode: String!) {
  updateShoppingCartPromoCode(
    shoppingCartToken: $shoppingCartToken
    promoCode: $promoCode
  ) {
    success
    status
    message
    voucherCode
  }
}
    `;

export const useUpdateShoppingCartPromoCodeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateShoppingCartPromoCodeMutation, TError, UpdateShoppingCartPromoCodeMutationVariables, TContext>) => {
    
    return useMutation<UpdateShoppingCartPromoCodeMutation, TError, UpdateShoppingCartPromoCodeMutationVariables, TContext>(
      {
    mutationKey: ['UpdateShoppingCartPromoCode'],
    mutationFn: (variables?: UpdateShoppingCartPromoCodeMutationVariables) => fetchData<UpdateShoppingCartPromoCodeMutation, UpdateShoppingCartPromoCodeMutationVariables>(UpdateShoppingCartPromoCodeDocument, variables)(),
    ...options
  }
    )};


useUpdateShoppingCartPromoCodeMutation.fetcher = (variables: UpdateShoppingCartPromoCodeMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateShoppingCartPromoCodeMutation, UpdateShoppingCartPromoCodeMutationVariables>(UpdateShoppingCartPromoCodeDocument, variables, options);

export const UpdateShoppingCartShippingAddressDocument = `
    mutation UpdateShoppingCartShippingAddress($shoppingCartToken: String!, $shippingAddressId: Int!) {
  updateShoppingCartShippingAddress(
    shoppingCartToken: $shoppingCartToken
    shippingAddressId: $shippingAddressId
  )
}
    `;

export const useUpdateShoppingCartShippingAddressMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateShoppingCartShippingAddressMutation, TError, UpdateShoppingCartShippingAddressMutationVariables, TContext>) => {
    
    return useMutation<UpdateShoppingCartShippingAddressMutation, TError, UpdateShoppingCartShippingAddressMutationVariables, TContext>(
      {
    mutationKey: ['UpdateShoppingCartShippingAddress'],
    mutationFn: (variables?: UpdateShoppingCartShippingAddressMutationVariables) => fetchData<UpdateShoppingCartShippingAddressMutation, UpdateShoppingCartShippingAddressMutationVariables>(UpdateShoppingCartShippingAddressDocument, variables)(),
    ...options
  }
    )};


useUpdateShoppingCartShippingAddressMutation.fetcher = (variables: UpdateShoppingCartShippingAddressMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateShoppingCartShippingAddressMutation, UpdateShoppingCartShippingAddressMutationVariables>(UpdateShoppingCartShippingAddressDocument, variables, options);

export const UpdateShoppingCartShippingOptionDocument = `
    mutation UpdateShoppingCartShippingOption($brandCode: String!, $shoppingCartToken: String!, $id: String!, $description: String!, $shippingMethodId: Int!, $estDelivery: String!, $price: Decimal!, $shippingRateHash: String!, $currencySymbol: String!, $destinationCountryOverride: String, $destinationZipOverride: String) {
  updateShoppingCartShippingOption(
    brandCode: $brandCode
    shoppingCartToken: $shoppingCartToken
    id: $id
    description: $description
    shippingMethodId: $shippingMethodId
    estDelivery: $estDelivery
    price: $price
    shippingRateHash: $shippingRateHash
    currencySymbol: $currencySymbol
    destinationCountryOverride: $destinationCountryOverride
    destinationZipOverride: $destinationZipOverride
  )
}
    `;

export const useUpdateShoppingCartShippingOptionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateShoppingCartShippingOptionMutation, TError, UpdateShoppingCartShippingOptionMutationVariables, TContext>) => {
    
    return useMutation<UpdateShoppingCartShippingOptionMutation, TError, UpdateShoppingCartShippingOptionMutationVariables, TContext>(
      {
    mutationKey: ['UpdateShoppingCartShippingOption'],
    mutationFn: (variables?: UpdateShoppingCartShippingOptionMutationVariables) => fetchData<UpdateShoppingCartShippingOptionMutation, UpdateShoppingCartShippingOptionMutationVariables>(UpdateShoppingCartShippingOptionDocument, variables)(),
    ...options
  }
    )};


useUpdateShoppingCartShippingOptionMutation.fetcher = (variables: UpdateShoppingCartShippingOptionMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateShoppingCartShippingOptionMutation, UpdateShoppingCartShippingOptionMutationVariables>(UpdateShoppingCartShippingOptionDocument, variables, options);

export const UpdateShoppingCartUseStoreCreditDocument = `
    mutation UpdateShoppingCartUseStoreCredit($shoppingCartToken: String!, $useStoreCredit: Boolean!) {
  updateShoppingCartUseStoreCredit(
    shoppingCartToken: $shoppingCartToken
    useStoreCredit: $useStoreCredit
  ) {
    token
    useStoreCredit
    storeCreditAvailable
    storeCreditToApply
    subTotal
    shippingCost
    taxCharged
    taxIncluded
    taxDescription
    giftVoucherDeduction
    currency {
      id
      symbol
    }
  }
}
    `;

export const useUpdateShoppingCartUseStoreCreditMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateShoppingCartUseStoreCreditMutation, TError, UpdateShoppingCartUseStoreCreditMutationVariables, TContext>) => {
    
    return useMutation<UpdateShoppingCartUseStoreCreditMutation, TError, UpdateShoppingCartUseStoreCreditMutationVariables, TContext>(
      {
    mutationKey: ['UpdateShoppingCartUseStoreCredit'],
    mutationFn: (variables?: UpdateShoppingCartUseStoreCreditMutationVariables) => fetchData<UpdateShoppingCartUseStoreCreditMutation, UpdateShoppingCartUseStoreCreditMutationVariables>(UpdateShoppingCartUseStoreCreditDocument, variables)(),
    ...options
  }
    )};


useUpdateShoppingCartUseStoreCreditMutation.fetcher = (variables: UpdateShoppingCartUseStoreCreditMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateShoppingCartUseStoreCreditMutation, UpdateShoppingCartUseStoreCreditMutationVariables>(UpdateShoppingCartUseStoreCreditDocument, variables, options);

export const ValidateCustomerAddressDocument = `
    mutation ValidateCustomerAddress($input: ValidateAddressInput!) {
  validateCustomerAddress(input: $input) {
    isValid
    easyPostAddressId
    errorMessage
  }
}
    `;

export const useValidateCustomerAddressMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ValidateCustomerAddressMutation, TError, ValidateCustomerAddressMutationVariables, TContext>) => {
    
    return useMutation<ValidateCustomerAddressMutation, TError, ValidateCustomerAddressMutationVariables, TContext>(
      {
    mutationKey: ['ValidateCustomerAddress'],
    mutationFn: (variables?: ValidateCustomerAddressMutationVariables) => fetchData<ValidateCustomerAddressMutation, ValidateCustomerAddressMutationVariables>(ValidateCustomerAddressDocument, variables)(),
    ...options
  }
    )};


useValidateCustomerAddressMutation.fetcher = (variables: ValidateCustomerAddressMutationVariables, options?: RequestInit['headers']) => fetchData<ValidateCustomerAddressMutation, ValidateCustomerAddressMutationVariables>(ValidateCustomerAddressDocument, variables, options);

export const ValidateExplanationUniqueCodeDocument = `
    mutation ValidateExplanationUniqueCode($slug: String!, $code: String!) {
  validateExplanationUniqueCode(slug: $slug, code: $code) {
    status
    message
    productId
    isApp
    requiresLogin
    alreadyRedeemed
  }
}
    `;

export const useValidateExplanationUniqueCodeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ValidateExplanationUniqueCodeMutation, TError, ValidateExplanationUniqueCodeMutationVariables, TContext>) => {
    
    return useMutation<ValidateExplanationUniqueCodeMutation, TError, ValidateExplanationUniqueCodeMutationVariables, TContext>(
      {
    mutationKey: ['ValidateExplanationUniqueCode'],
    mutationFn: (variables?: ValidateExplanationUniqueCodeMutationVariables) => fetchData<ValidateExplanationUniqueCodeMutation, ValidateExplanationUniqueCodeMutationVariables>(ValidateExplanationUniqueCodeDocument, variables)(),
    ...options
  }
    )};


useValidateExplanationUniqueCodeMutation.fetcher = (variables: ValidateExplanationUniqueCodeMutationVariables, options?: RequestInit['headers']) => fetchData<ValidateExplanationUniqueCodeMutation, ValidateExplanationUniqueCodeMutationVariables>(ValidateExplanationUniqueCodeDocument, variables, options);

export const AddConventionRegistrationBundleToShoppingCartDocument = `
    mutation AddConventionRegistrationBundleToShoppingCart($shoppingCartToken: String!, $conventionProductId: Int!, $registrationOptionId: Int, $registrants: [ConventionRegistrantInputDtoInput!]!, $paymentPlan: ConventionPaymentPlanInputDtoInput, $bypassSoldOut: Boolean! = false) {
  addConventionRegistrationBundleToShoppingCart(
    shoppingCartToken: $shoppingCartToken
    conventionProductId: $conventionProductId
    registrationOptionId: $registrationOptionId
    registrants: $registrants
    paymentPlan: $paymentPlan
    bypassSoldOut: $bypassSoldOut
  )
}
    `;

export const useAddConventionRegistrationBundleToShoppingCartMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddConventionRegistrationBundleToShoppingCartMutation, TError, AddConventionRegistrationBundleToShoppingCartMutationVariables, TContext>) => {
    
    return useMutation<AddConventionRegistrationBundleToShoppingCartMutation, TError, AddConventionRegistrationBundleToShoppingCartMutationVariables, TContext>(
      {
    mutationKey: ['AddConventionRegistrationBundleToShoppingCart'],
    mutationFn: (variables?: AddConventionRegistrationBundleToShoppingCartMutationVariables) => fetchData<AddConventionRegistrationBundleToShoppingCartMutation, AddConventionRegistrationBundleToShoppingCartMutationVariables>(AddConventionRegistrationBundleToShoppingCartDocument, variables)(),
    ...options
  }
    )};


useAddConventionRegistrationBundleToShoppingCartMutation.fetcher = (variables: AddConventionRegistrationBundleToShoppingCartMutationVariables, options?: RequestInit['headers']) => fetchData<AddConventionRegistrationBundleToShoppingCartMutation, AddConventionRegistrationBundleToShoppingCartMutationVariables>(AddConventionRegistrationBundleToShoppingCartDocument, variables, options);

export const AddConventionUpgradeToShoppingCartDocument = `
    mutation AddConventionUpgradeToShoppingCart($shoppingCartToken: String!, $registrationOrderItemId: Int!) {
  addConventionUpgradeToShoppingCart(
    shoppingCartToken: $shoppingCartToken
    registrationOrderItemId: $registrationOrderItemId
  )
}
    `;

export const useAddConventionUpgradeToShoppingCartMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddConventionUpgradeToShoppingCartMutation, TError, AddConventionUpgradeToShoppingCartMutationVariables, TContext>) => {
    
    return useMutation<AddConventionUpgradeToShoppingCartMutation, TError, AddConventionUpgradeToShoppingCartMutationVariables, TContext>(
      {
    mutationKey: ['AddConventionUpgradeToShoppingCart'],
    mutationFn: (variables?: AddConventionUpgradeToShoppingCartMutationVariables) => fetchData<AddConventionUpgradeToShoppingCartMutation, AddConventionUpgradeToShoppingCartMutationVariables>(AddConventionUpgradeToShoppingCartDocument, variables)(),
    ...options
  }
    )};


useAddConventionUpgradeToShoppingCartMutation.fetcher = (variables: AddConventionUpgradeToShoppingCartMutationVariables, options?: RequestInit['headers']) => fetchData<AddConventionUpgradeToShoppingCartMutation, AddConventionUpgradeToShoppingCartMutationVariables>(AddConventionUpgradeToShoppingCartDocument, variables, options);

export const AddConventionWaitingListDocument = `
    mutation AddConventionWaitingList($conventionProductId: Int!, $registrationOptionId: Int) {
  addConventionWaitingList(
    conventionProductId: $conventionProductId
    registrationOptionId: $registrationOptionId
  )
}
    `;

export const useAddConventionWaitingListMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddConventionWaitingListMutation, TError, AddConventionWaitingListMutationVariables, TContext>) => {
    
    return useMutation<AddConventionWaitingListMutation, TError, AddConventionWaitingListMutationVariables, TContext>(
      {
    mutationKey: ['AddConventionWaitingList'],
    mutationFn: (variables?: AddConventionWaitingListMutationVariables) => fetchData<AddConventionWaitingListMutation, AddConventionWaitingListMutationVariables>(AddConventionWaitingListDocument, variables)(),
    ...options
  }
    )};


useAddConventionWaitingListMutation.fetcher = (variables: AddConventionWaitingListMutationVariables, options?: RequestInit['headers']) => fetchData<AddConventionWaitingListMutation, AddConventionWaitingListMutationVariables>(AddConventionWaitingListDocument, variables, options);

export const LinkCreatorAccountDocument = `
    mutation LinkCreatorAccount($creatorId: Int!, $hash: String) {
  linkCreatorAccount(creatorId: $creatorId, hash: $hash)
}
    `;

export const useLinkCreatorAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LinkCreatorAccountMutation, TError, LinkCreatorAccountMutationVariables, TContext>) => {
    
    return useMutation<LinkCreatorAccountMutation, TError, LinkCreatorAccountMutationVariables, TContext>(
      {
    mutationKey: ['LinkCreatorAccount'],
    mutationFn: (variables?: LinkCreatorAccountMutationVariables) => fetchData<LinkCreatorAccountMutation, LinkCreatorAccountMutationVariables>(LinkCreatorAccountDocument, variables)(),
    ...options
  }
    )};


useLinkCreatorAccountMutation.fetcher = (variables: LinkCreatorAccountMutationVariables, options?: RequestInit['headers']) => fetchData<LinkCreatorAccountMutation, LinkCreatorAccountMutationVariables>(LinkCreatorAccountDocument, variables, options);

export const SubmitCreatorProfileUpdateDocument = `
    mutation SubmitCreatorProfileUpdate($bio: String!, $photoBase64: String!, $photoFileName: String!, $questionAnswers: [CreatorProfileQuestionAnswerInput!]!) {
  submitCreatorProfileUpdate(
    input: {bio: $bio, photoBase64: $photoBase64, photoFileName: $photoFileName, questionAnswers: $questionAnswers}
  )
}
    `;

export const useSubmitCreatorProfileUpdateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitCreatorProfileUpdateMutation, TError, SubmitCreatorProfileUpdateMutationVariables, TContext>) => {
    
    return useMutation<SubmitCreatorProfileUpdateMutation, TError, SubmitCreatorProfileUpdateMutationVariables, TContext>(
      {
    mutationKey: ['SubmitCreatorProfileUpdate'],
    mutationFn: (variables?: SubmitCreatorProfileUpdateMutationVariables) => fetchData<SubmitCreatorProfileUpdateMutation, SubmitCreatorProfileUpdateMutationVariables>(SubmitCreatorProfileUpdateDocument, variables)(),
    ...options
  }
    )};


useSubmitCreatorProfileUpdateMutation.fetcher = (variables: SubmitCreatorProfileUpdateMutationVariables, options?: RequestInit['headers']) => fetchData<SubmitCreatorProfileUpdateMutation, SubmitCreatorProfileUpdateMutationVariables>(SubmitCreatorProfileUpdateDocument, variables, options);

export const UpdateCreatorPayPalAddressDocument = `
    mutation UpdateCreatorPayPalAddress($input: UpdateCreatorPayPalAddressInput!) {
  updateCreatorPayPalAddress(input: $input)
}
    `;

export const useUpdateCreatorPayPalAddressMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCreatorPayPalAddressMutation, TError, UpdateCreatorPayPalAddressMutationVariables, TContext>) => {
    
    return useMutation<UpdateCreatorPayPalAddressMutation, TError, UpdateCreatorPayPalAddressMutationVariables, TContext>(
      {
    mutationKey: ['UpdateCreatorPayPalAddress'],
    mutationFn: (variables?: UpdateCreatorPayPalAddressMutationVariables) => fetchData<UpdateCreatorPayPalAddressMutation, UpdateCreatorPayPalAddressMutationVariables>(UpdateCreatorPayPalAddressDocument, variables)(),
    ...options
  }
    )};


useUpdateCreatorPayPalAddressMutation.fetcher = (variables: UpdateCreatorPayPalAddressMutationVariables, options?: RequestInit['headers']) => fetchData<UpdateCreatorPayPalAddressMutation, UpdateCreatorPayPalAddressMutationVariables>(UpdateCreatorPayPalAddressDocument, variables, options);

export const SupportSurveyByExternalIdDocument = `
    query SupportSurveyByExternalId($externalId: String!) {
  supportSurveyByExternalId(externalId: $externalId) {
    id
    externalId
  }
}
    `;

export const useSupportSurveyByExternalIdQuery = <
      TData = SupportSurveyByExternalIdQuery,
      TError = unknown
    >(
      variables: SupportSurveyByExternalIdQueryVariables,
      options?: Omit<UseQueryOptions<SupportSurveyByExternalIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SupportSurveyByExternalIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SupportSurveyByExternalIdQuery, TError, TData>(
      {
    queryKey: ['SupportSurveyByExternalId', variables],
    queryFn: fetchData<SupportSurveyByExternalIdQuery, SupportSurveyByExternalIdQueryVariables>(SupportSurveyByExternalIdDocument, variables),
    ...options
  }
    )};

useSupportSurveyByExternalIdQuery.getKey = (variables: SupportSurveyByExternalIdQueryVariables) => ['SupportSurveyByExternalId', variables];

export const useSuspenseSupportSurveyByExternalIdQuery = <
      TData = SupportSurveyByExternalIdQuery,
      TError = unknown
    >(
      variables: SupportSurveyByExternalIdQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<SupportSurveyByExternalIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<SupportSurveyByExternalIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<SupportSurveyByExternalIdQuery, TError, TData>(
      {
    queryKey: ['SupportSurveyByExternalId', variables],
    queryFn: fetchData<SupportSurveyByExternalIdQuery, SupportSurveyByExternalIdQueryVariables>(SupportSurveyByExternalIdDocument, variables),
    ...options
  }
    )};

useSuspenseSupportSurveyByExternalIdQuery.getKey = (variables: SupportSurveyByExternalIdQueryVariables) => ['SupportSurveyByExternalId', variables];

export const useInfiniteSupportSurveyByExternalIdQuery = <
      TData = InfiniteData<SupportSurveyByExternalIdQuery>,
      TError = unknown
    >(
      variables: SupportSurveyByExternalIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SupportSurveyByExternalIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SupportSurveyByExternalIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<SupportSurveyByExternalIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['SupportSurveyByExternalId.infinite', variables],
      queryFn: (metaData) => fetchData<SupportSurveyByExternalIdQuery, SupportSurveyByExternalIdQueryVariables>(SupportSurveyByExternalIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteSupportSurveyByExternalIdQuery.getKey = (variables: SupportSurveyByExternalIdQueryVariables) => ['SupportSurveyByExternalId.infinite', variables];

export const useSuspenseInfiniteSupportSurveyByExternalIdQuery = <
      TData = InfiniteData<SupportSurveyByExternalIdQuery>,
      TError = unknown
    >(
      variables: SupportSurveyByExternalIdQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<SupportSurveyByExternalIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<SupportSurveyByExternalIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<SupportSurveyByExternalIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['SupportSurveyByExternalId.infinite', variables],
      queryFn: (metaData) => fetchData<SupportSurveyByExternalIdQuery, SupportSurveyByExternalIdQueryVariables>(SupportSurveyByExternalIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteSupportSurveyByExternalIdQuery.getKey = (variables: SupportSurveyByExternalIdQueryVariables) => ['SupportSurveyByExternalId.infinite', variables];


useSupportSurveyByExternalIdQuery.fetcher = (variables: SupportSurveyByExternalIdQueryVariables, options?: RequestInit['headers']) => fetchData<SupportSurveyByExternalIdQuery, SupportSurveyByExternalIdQueryVariables>(SupportSurveyByExternalIdDocument, variables, options);

export const ValidateResetLinkDocument = `
    query ValidateResetLink($hash: String!, $customerId: Int!) {
  validateResetLink(hash: $hash, customerId: $customerId)
}
    `;

export const useValidateResetLinkQuery = <
      TData = ValidateResetLinkQuery,
      TError = unknown
    >(
      variables: ValidateResetLinkQueryVariables,
      options?: Omit<UseQueryOptions<ValidateResetLinkQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ValidateResetLinkQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ValidateResetLinkQuery, TError, TData>(
      {
    queryKey: ['ValidateResetLink', variables],
    queryFn: fetchData<ValidateResetLinkQuery, ValidateResetLinkQueryVariables>(ValidateResetLinkDocument, variables),
    ...options
  }
    )};

useValidateResetLinkQuery.getKey = (variables: ValidateResetLinkQueryVariables) => ['ValidateResetLink', variables];

export const useSuspenseValidateResetLinkQuery = <
      TData = ValidateResetLinkQuery,
      TError = unknown
    >(
      variables: ValidateResetLinkQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ValidateResetLinkQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ValidateResetLinkQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ValidateResetLinkQuery, TError, TData>(
      {
    queryKey: ['ValidateResetLink', variables],
    queryFn: fetchData<ValidateResetLinkQuery, ValidateResetLinkQueryVariables>(ValidateResetLinkDocument, variables),
    ...options
  }
    )};

useSuspenseValidateResetLinkQuery.getKey = (variables: ValidateResetLinkQueryVariables) => ['ValidateResetLink', variables];

export const useInfiniteValidateResetLinkQuery = <
      TData = InfiniteData<ValidateResetLinkQuery>,
      TError = unknown
    >(
      variables: ValidateResetLinkQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ValidateResetLinkQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ValidateResetLinkQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ValidateResetLinkQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ValidateResetLink.infinite', variables],
      queryFn: (metaData) => fetchData<ValidateResetLinkQuery, ValidateResetLinkQueryVariables>(ValidateResetLinkDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteValidateResetLinkQuery.getKey = (variables: ValidateResetLinkQueryVariables) => ['ValidateResetLink.infinite', variables];

export const useSuspenseInfiniteValidateResetLinkQuery = <
      TData = InfiniteData<ValidateResetLinkQuery>,
      TError = unknown
    >(
      variables: ValidateResetLinkQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ValidateResetLinkQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ValidateResetLinkQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ValidateResetLinkQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ValidateResetLink.infinite', variables],
      queryFn: (metaData) => fetchData<ValidateResetLinkQuery, ValidateResetLinkQueryVariables>(ValidateResetLinkDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteValidateResetLinkQuery.getKey = (variables: ValidateResetLinkQueryVariables) => ['ValidateResetLink.infinite', variables];


useValidateResetLinkQuery.fetcher = (variables: ValidateResetLinkQueryVariables, options?: RequestInit['headers']) => fetchData<ValidateResetLinkQuery, ValidateResetLinkQueryVariables>(ValidateResetLinkDocument, variables, options);

export const HomepageCarouselDocument = `
    query HomepageCarousel($brandCode: String!, $limit: Int!) {
  homepageCarouselBanners(limit: $limit, brandCode: $brandCode) {
    id
    name
    altText
    imageSrc
    url
  }
}
    `;

export const useHomepageCarouselQuery = <
      TData = HomepageCarouselQuery,
      TError = unknown
    >(
      variables: HomepageCarouselQueryVariables,
      options?: Omit<UseQueryOptions<HomepageCarouselQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<HomepageCarouselQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<HomepageCarouselQuery, TError, TData>(
      {
    queryKey: ['HomepageCarousel', variables],
    queryFn: fetchData<HomepageCarouselQuery, HomepageCarouselQueryVariables>(HomepageCarouselDocument, variables),
    ...options
  }
    )};

useHomepageCarouselQuery.getKey = (variables: HomepageCarouselQueryVariables) => ['HomepageCarousel', variables];

export const useSuspenseHomepageCarouselQuery = <
      TData = HomepageCarouselQuery,
      TError = unknown
    >(
      variables: HomepageCarouselQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<HomepageCarouselQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<HomepageCarouselQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<HomepageCarouselQuery, TError, TData>(
      {
    queryKey: ['HomepageCarousel', variables],
    queryFn: fetchData<HomepageCarouselQuery, HomepageCarouselQueryVariables>(HomepageCarouselDocument, variables),
    ...options
  }
    )};

useSuspenseHomepageCarouselQuery.getKey = (variables: HomepageCarouselQueryVariables) => ['HomepageCarousel', variables];

export const useInfiniteHomepageCarouselQuery = <
      TData = InfiniteData<HomepageCarouselQuery>,
      TError = unknown
    >(
      variables: HomepageCarouselQueryVariables,
      options: Omit<UseInfiniteQueryOptions<HomepageCarouselQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<HomepageCarouselQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<HomepageCarouselQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['HomepageCarousel.infinite', variables],
      queryFn: (metaData) => fetchData<HomepageCarouselQuery, HomepageCarouselQueryVariables>(HomepageCarouselDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteHomepageCarouselQuery.getKey = (variables: HomepageCarouselQueryVariables) => ['HomepageCarousel.infinite', variables];

export const useSuspenseInfiniteHomepageCarouselQuery = <
      TData = InfiniteData<HomepageCarouselQuery>,
      TError = unknown
    >(
      variables: HomepageCarouselQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<HomepageCarouselQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<HomepageCarouselQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<HomepageCarouselQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['HomepageCarousel.infinite', variables],
      queryFn: (metaData) => fetchData<HomepageCarouselQuery, HomepageCarouselQueryVariables>(HomepageCarouselDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteHomepageCarouselQuery.getKey = (variables: HomepageCarouselQueryVariables) => ['HomepageCarousel.infinite', variables];


useHomepageCarouselQuery.fetcher = (variables: HomepageCarouselQueryVariables, options?: RequestInit['headers']) => fetchData<HomepageCarouselQuery, HomepageCarouselQueryVariables>(HomepageCarouselDocument, variables, options);

export const SidebarAdsDocument = `
    query SidebarAds($brandCode: String!) {
  sidebarAds(brandCode: $brandCode, skip: 0, take: 4) {
    items {
      imageSrc
      name
      url
    }
  }
}
    `;

export const useSidebarAdsQuery = <
      TData = SidebarAdsQuery,
      TError = unknown
    >(
      variables: SidebarAdsQueryVariables,
      options?: Omit<UseQueryOptions<SidebarAdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SidebarAdsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SidebarAdsQuery, TError, TData>(
      {
    queryKey: ['SidebarAds', variables],
    queryFn: fetchData<SidebarAdsQuery, SidebarAdsQueryVariables>(SidebarAdsDocument, variables),
    ...options
  }
    )};

useSidebarAdsQuery.getKey = (variables: SidebarAdsQueryVariables) => ['SidebarAds', variables];

export const useSuspenseSidebarAdsQuery = <
      TData = SidebarAdsQuery,
      TError = unknown
    >(
      variables: SidebarAdsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<SidebarAdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<SidebarAdsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<SidebarAdsQuery, TError, TData>(
      {
    queryKey: ['SidebarAds', variables],
    queryFn: fetchData<SidebarAdsQuery, SidebarAdsQueryVariables>(SidebarAdsDocument, variables),
    ...options
  }
    )};

useSuspenseSidebarAdsQuery.getKey = (variables: SidebarAdsQueryVariables) => ['SidebarAds', variables];

export const useInfiniteSidebarAdsQuery = <
      TData = InfiniteData<SidebarAdsQuery>,
      TError = unknown
    >(
      variables: SidebarAdsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SidebarAdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SidebarAdsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<SidebarAdsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['SidebarAds.infinite', variables],
      queryFn: (metaData) => fetchData<SidebarAdsQuery, SidebarAdsQueryVariables>(SidebarAdsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteSidebarAdsQuery.getKey = (variables: SidebarAdsQueryVariables) => ['SidebarAds.infinite', variables];

export const useSuspenseInfiniteSidebarAdsQuery = <
      TData = InfiniteData<SidebarAdsQuery>,
      TError = unknown
    >(
      variables: SidebarAdsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<SidebarAdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<SidebarAdsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<SidebarAdsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['SidebarAds.infinite', variables],
      queryFn: (metaData) => fetchData<SidebarAdsQuery, SidebarAdsQueryVariables>(SidebarAdsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteSidebarAdsQuery.getKey = (variables: SidebarAdsQueryVariables) => ['SidebarAds.infinite', variables];


useSidebarAdsQuery.fetcher = (variables: SidebarAdsQueryVariables, options?: RequestInit['headers']) => fetchData<SidebarAdsQuery, SidebarAdsQueryVariables>(SidebarAdsDocument, variables, options);

export const CustomerAppsDocument = `
    query CustomerApps($skip: Int, $take: Int) {
  appProductsForCustomer(skip: $skip, take: $take) {
    items {
      activeDeviceCount
      productId
      productName
      allowedDeviceCount
      installUrls {
        key
        value
      }
      thumbnailUrl
      licenseCode
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

export const useCustomerAppsQuery = <
      TData = CustomerAppsQuery,
      TError = unknown
    >(
      variables?: CustomerAppsQueryVariables,
      options?: Omit<UseQueryOptions<CustomerAppsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerAppsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerAppsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerApps'] : ['CustomerApps', variables],
    queryFn: fetchData<CustomerAppsQuery, CustomerAppsQueryVariables>(CustomerAppsDocument, variables),
    ...options
  }
    )};

useCustomerAppsQuery.getKey = (variables?: CustomerAppsQueryVariables) => variables === undefined ? ['CustomerApps'] : ['CustomerApps', variables];

export const useSuspenseCustomerAppsQuery = <
      TData = CustomerAppsQuery,
      TError = unknown
    >(
      variables?: CustomerAppsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerAppsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerAppsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerAppsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerApps'] : ['CustomerApps', variables],
    queryFn: fetchData<CustomerAppsQuery, CustomerAppsQueryVariables>(CustomerAppsDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerAppsQuery.getKey = (variables?: CustomerAppsQueryVariables) => variables === undefined ? ['CustomerApps'] : ['CustomerApps', variables];

export const useInfiniteCustomerAppsQuery = <
      TData = InfiniteData<CustomerAppsQuery>,
      TError = unknown
    >(
      variables: CustomerAppsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerAppsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerAppsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerAppsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerApps.infinite'] : ['CustomerApps.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerAppsQuery, CustomerAppsQueryVariables>(CustomerAppsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerAppsQuery.getKey = (variables?: CustomerAppsQueryVariables) => variables === undefined ? ['CustomerApps.infinite'] : ['CustomerApps.infinite', variables];

export const useSuspenseInfiniteCustomerAppsQuery = <
      TData = InfiniteData<CustomerAppsQuery>,
      TError = unknown
    >(
      variables: CustomerAppsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerAppsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerAppsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerAppsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerApps.infinite'] : ['CustomerApps.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerAppsQuery, CustomerAppsQueryVariables>(CustomerAppsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerAppsQuery.getKey = (variables?: CustomerAppsQueryVariables) => variables === undefined ? ['CustomerApps.infinite'] : ['CustomerApps.infinite', variables];


useCustomerAppsQuery.fetcher = (variables?: CustomerAppsQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerAppsQuery, CustomerAppsQueryVariables>(CustomerAppsDocument, variables, options);

export const ProductAppDevicesDocument = `
    query ProductAppDevices($productId: Int!) {
  appDevicesForProduct(productId: $productId) {
    productId
    productName
    activeDeviceCount
    allowedDeviceCount
    thumbnailUrl
    devices {
      id
      productId
      productName
      lastInstallDate
      deactivatedDate
      deviceName
    }
    installUrls {
      key
      value
    }
  }
}
    `;

export const useProductAppDevicesQuery = <
      TData = ProductAppDevicesQuery,
      TError = unknown
    >(
      variables: ProductAppDevicesQueryVariables,
      options?: Omit<UseQueryOptions<ProductAppDevicesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProductAppDevicesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProductAppDevicesQuery, TError, TData>(
      {
    queryKey: ['ProductAppDevices', variables],
    queryFn: fetchData<ProductAppDevicesQuery, ProductAppDevicesQueryVariables>(ProductAppDevicesDocument, variables),
    ...options
  }
    )};

useProductAppDevicesQuery.getKey = (variables: ProductAppDevicesQueryVariables) => ['ProductAppDevices', variables];

export const useSuspenseProductAppDevicesQuery = <
      TData = ProductAppDevicesQuery,
      TError = unknown
    >(
      variables: ProductAppDevicesQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ProductAppDevicesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ProductAppDevicesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ProductAppDevicesQuery, TError, TData>(
      {
    queryKey: ['ProductAppDevices', variables],
    queryFn: fetchData<ProductAppDevicesQuery, ProductAppDevicesQueryVariables>(ProductAppDevicesDocument, variables),
    ...options
  }
    )};

useSuspenseProductAppDevicesQuery.getKey = (variables: ProductAppDevicesQueryVariables) => ['ProductAppDevices', variables];

export const useInfiniteProductAppDevicesQuery = <
      TData = InfiniteData<ProductAppDevicesQuery>,
      TError = unknown
    >(
      variables: ProductAppDevicesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProductAppDevicesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProductAppDevicesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ProductAppDevicesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductAppDevices.infinite', variables],
      queryFn: (metaData) => fetchData<ProductAppDevicesQuery, ProductAppDevicesQueryVariables>(ProductAppDevicesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteProductAppDevicesQuery.getKey = (variables: ProductAppDevicesQueryVariables) => ['ProductAppDevices.infinite', variables];

export const useSuspenseInfiniteProductAppDevicesQuery = <
      TData = InfiniteData<ProductAppDevicesQuery>,
      TError = unknown
    >(
      variables: ProductAppDevicesQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ProductAppDevicesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ProductAppDevicesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ProductAppDevicesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductAppDevices.infinite', variables],
      queryFn: (metaData) => fetchData<ProductAppDevicesQuery, ProductAppDevicesQueryVariables>(ProductAppDevicesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteProductAppDevicesQuery.getKey = (variables: ProductAppDevicesQueryVariables) => ['ProductAppDevices.infinite', variables];


useProductAppDevicesQuery.fetcher = (variables: ProductAppDevicesQueryVariables, options?: RequestInit['headers']) => fetchData<ProductAppDevicesQuery, ProductAppDevicesQueryVariables>(ProductAppDevicesDocument, variables, options);

export const BrandStoreDocument = `
    query BrandStore($brandCode: String!) {
  productsByCategorySlug(
    skip: 0
    take: 48
    brandCode: $brandCode
    includeChildCategories: true
    categorySlug: "brand-store"
    maxBlurbLength: 200
  ) {
    totalCount
    items {
      id
      name
      url
      hasDownloads
      thumbnails {
        default
        square
        video
      }
      displayPrice
      vanishingIncExclusive
      options {
        id
        description
        price
        salePrice
        inStock
        productType {
          id
          name
        }
        currency {
          symbol
        }
      }
    }
  }
}
    `;

export const useBrandStoreQuery = <
      TData = BrandStoreQuery,
      TError = unknown
    >(
      variables: BrandStoreQueryVariables,
      options?: Omit<UseQueryOptions<BrandStoreQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrandStoreQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrandStoreQuery, TError, TData>(
      {
    queryKey: ['BrandStore', variables],
    queryFn: fetchData<BrandStoreQuery, BrandStoreQueryVariables>(BrandStoreDocument, variables),
    ...options
  }
    )};

useBrandStoreQuery.getKey = (variables: BrandStoreQueryVariables) => ['BrandStore', variables];

export const useSuspenseBrandStoreQuery = <
      TData = BrandStoreQuery,
      TError = unknown
    >(
      variables: BrandStoreQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<BrandStoreQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<BrandStoreQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<BrandStoreQuery, TError, TData>(
      {
    queryKey: ['BrandStore', variables],
    queryFn: fetchData<BrandStoreQuery, BrandStoreQueryVariables>(BrandStoreDocument, variables),
    ...options
  }
    )};

useSuspenseBrandStoreQuery.getKey = (variables: BrandStoreQueryVariables) => ['BrandStore', variables];

export const useInfiniteBrandStoreQuery = <
      TData = InfiniteData<BrandStoreQuery>,
      TError = unknown
    >(
      variables: BrandStoreQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BrandStoreQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BrandStoreQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<BrandStoreQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['BrandStore.infinite', variables],
      queryFn: (metaData) => fetchData<BrandStoreQuery, BrandStoreQueryVariables>(BrandStoreDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteBrandStoreQuery.getKey = (variables: BrandStoreQueryVariables) => ['BrandStore.infinite', variables];

export const useSuspenseInfiniteBrandStoreQuery = <
      TData = InfiniteData<BrandStoreQuery>,
      TError = unknown
    >(
      variables: BrandStoreQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<BrandStoreQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<BrandStoreQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<BrandStoreQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['BrandStore.infinite', variables],
      queryFn: (metaData) => fetchData<BrandStoreQuery, BrandStoreQueryVariables>(BrandStoreDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteBrandStoreQuery.getKey = (variables: BrandStoreQueryVariables) => ['BrandStore.infinite', variables];


useBrandStoreQuery.fetcher = (variables: BrandStoreQueryVariables, options?: RequestInit['headers']) => fetchData<BrandStoreQuery, BrandStoreQueryVariables>(BrandStoreDocument, variables, options);

export const CategoriesDocument = `
    query Categories($order: [CategoryDtoSortInput!]) {
  categories(order: $order) {
    id
    name
    urlStub
    intro
    metaDescription
  }
}
    `;

export const useCategoriesQuery = <
      TData = CategoriesQuery,
      TError = unknown
    >(
      variables?: CategoriesQueryVariables,
      options?: Omit<UseQueryOptions<CategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CategoriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CategoriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Categories'] : ['Categories', variables],
    queryFn: fetchData<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, variables),
    ...options
  }
    )};

useCategoriesQuery.getKey = (variables?: CategoriesQueryVariables) => variables === undefined ? ['Categories'] : ['Categories', variables];

export const useSuspenseCategoriesQuery = <
      TData = CategoriesQuery,
      TError = unknown
    >(
      variables?: CategoriesQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CategoriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CategoriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Categories'] : ['Categories', variables],
    queryFn: fetchData<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, variables),
    ...options
  }
    )};

useSuspenseCategoriesQuery.getKey = (variables?: CategoriesQueryVariables) => variables === undefined ? ['Categories'] : ['Categories', variables];

export const useInfiniteCategoriesQuery = <
      TData = InfiniteData<CategoriesQuery>,
      TError = unknown
    >(
      variables: CategoriesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CategoriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CategoriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Categories.infinite'] : ['Categories.infinite', variables],
      queryFn: (metaData) => fetchData<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCategoriesQuery.getKey = (variables?: CategoriesQueryVariables) => variables === undefined ? ['Categories.infinite'] : ['Categories.infinite', variables];

export const useSuspenseInfiniteCategoriesQuery = <
      TData = InfiniteData<CategoriesQuery>,
      TError = unknown
    >(
      variables: CategoriesQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CategoriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CategoriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Categories.infinite'] : ['Categories.infinite', variables],
      queryFn: (metaData) => fetchData<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCategoriesQuery.getKey = (variables?: CategoriesQueryVariables) => variables === undefined ? ['Categories.infinite'] : ['Categories.infinite', variables];


useCategoriesQuery.fetcher = (variables?: CategoriesQueryVariables, options?: RequestInit['headers']) => fetchData<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, variables, options);

export const CategoryDocument = `
    query Category($slug: String!) {
  categoryBySlug(slug: $slug) {
    id
    intro
    name
  }
}
    `;

export const useCategoryQuery = <
      TData = CategoryQuery,
      TError = unknown
    >(
      variables: CategoryQueryVariables,
      options?: Omit<UseQueryOptions<CategoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CategoryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CategoryQuery, TError, TData>(
      {
    queryKey: ['Category', variables],
    queryFn: fetchData<CategoryQuery, CategoryQueryVariables>(CategoryDocument, variables),
    ...options
  }
    )};

useCategoryQuery.getKey = (variables: CategoryQueryVariables) => ['Category', variables];

export const useSuspenseCategoryQuery = <
      TData = CategoryQuery,
      TError = unknown
    >(
      variables: CategoryQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CategoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CategoryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CategoryQuery, TError, TData>(
      {
    queryKey: ['Category', variables],
    queryFn: fetchData<CategoryQuery, CategoryQueryVariables>(CategoryDocument, variables),
    ...options
  }
    )};

useSuspenseCategoryQuery.getKey = (variables: CategoryQueryVariables) => ['Category', variables];

export const useInfiniteCategoryQuery = <
      TData = InfiniteData<CategoryQuery>,
      TError = unknown
    >(
      variables: CategoryQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CategoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CategoryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CategoryQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Category.infinite', variables],
      queryFn: (metaData) => fetchData<CategoryQuery, CategoryQueryVariables>(CategoryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCategoryQuery.getKey = (variables: CategoryQueryVariables) => ['Category.infinite', variables];

export const useSuspenseInfiniteCategoryQuery = <
      TData = InfiniteData<CategoryQuery>,
      TError = unknown
    >(
      variables: CategoryQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CategoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CategoryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CategoryQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Category.infinite', variables],
      queryFn: (metaData) => fetchData<CategoryQuery, CategoryQueryVariables>(CategoryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCategoryQuery.getKey = (variables: CategoryQueryVariables) => ['Category.infinite', variables];


useCategoryQuery.fetcher = (variables: CategoryQueryVariables, options?: RequestInit['headers']) => fetchData<CategoryQuery, CategoryQueryVariables>(CategoryDocument, variables, options);

export const CategoryProductsDocument = `
    query CategoryProducts($categorySlug: String!, $take: Int!, $skip: Int!, $brandCode: String!, $includeChildCategories: Boolean!, $maxBlurbLength: Int!, $order: [ProductByCategorySort!], $where: ProductByCategoryFilter, $productTypeGroup: String) {
  productsByCategorySlug(
    skip: $skip
    take: $take
    brandCode: $brandCode
    includeChildCategories: $includeChildCategories
    maxBlurbLength: $maxBlurbLength
    categorySlug: $categorySlug
    where: $where
    order: $order
    productTypeGroup: $productTypeGroup
  ) {
    totalCount
    items {
      id
      name
      url
      blurb
      hasDownloads
      thumbnails {
        default
        square
        video
      }
      displayPrice
      vanishingIncExclusive
      options {
        id
        description
        price
        salePrice
        priceIncVat
        salePriceIncVat
        taxType
        inStock
        productType {
          id
          name
        }
        currency {
          symbol
          code
        }
      }
      productType {
        name
        id
      }
      creators {
        id
        name
        urlStub
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

export const useCategoryProductsQuery = <
      TData = CategoryProductsQuery,
      TError = unknown
    >(
      variables: CategoryProductsQueryVariables,
      options?: Omit<UseQueryOptions<CategoryProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CategoryProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CategoryProductsQuery, TError, TData>(
      {
    queryKey: ['CategoryProducts', variables],
    queryFn: fetchData<CategoryProductsQuery, CategoryProductsQueryVariables>(CategoryProductsDocument, variables),
    ...options
  }
    )};

useCategoryProductsQuery.getKey = (variables: CategoryProductsQueryVariables) => ['CategoryProducts', variables];

export const useSuspenseCategoryProductsQuery = <
      TData = CategoryProductsQuery,
      TError = unknown
    >(
      variables: CategoryProductsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CategoryProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CategoryProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CategoryProductsQuery, TError, TData>(
      {
    queryKey: ['CategoryProducts', variables],
    queryFn: fetchData<CategoryProductsQuery, CategoryProductsQueryVariables>(CategoryProductsDocument, variables),
    ...options
  }
    )};

useSuspenseCategoryProductsQuery.getKey = (variables: CategoryProductsQueryVariables) => ['CategoryProducts', variables];

export const useInfiniteCategoryProductsQuery = <
      TData = InfiniteData<CategoryProductsQuery>,
      TError = unknown
    >(
      variables: CategoryProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CategoryProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CategoryProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CategoryProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CategoryProducts.infinite', variables],
      queryFn: (metaData) => fetchData<CategoryProductsQuery, CategoryProductsQueryVariables>(CategoryProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCategoryProductsQuery.getKey = (variables: CategoryProductsQueryVariables) => ['CategoryProducts.infinite', variables];

export const useSuspenseInfiniteCategoryProductsQuery = <
      TData = InfiniteData<CategoryProductsQuery>,
      TError = unknown
    >(
      variables: CategoryProductsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CategoryProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CategoryProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CategoryProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CategoryProducts.infinite', variables],
      queryFn: (metaData) => fetchData<CategoryProductsQuery, CategoryProductsQueryVariables>(CategoryProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCategoryProductsQuery.getKey = (variables: CategoryProductsQueryVariables) => ['CategoryProducts.infinite', variables];


useCategoryProductsQuery.fetcher = (variables: CategoryProductsQueryVariables, options?: RequestInit['headers']) => fetchData<CategoryProductsQuery, CategoryProductsQueryVariables>(CategoryProductsDocument, variables, options);

export const CheckEmailExistsDocument = `
    query CheckEmailExists($email: String!) {
  checkEmailExists(email: $email)
}
    `;

export const useCheckEmailExistsQuery = <
      TData = CheckEmailExistsQuery,
      TError = unknown
    >(
      variables: CheckEmailExistsQueryVariables,
      options?: Omit<UseQueryOptions<CheckEmailExistsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CheckEmailExistsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CheckEmailExistsQuery, TError, TData>(
      {
    queryKey: ['CheckEmailExists', variables],
    queryFn: fetchData<CheckEmailExistsQuery, CheckEmailExistsQueryVariables>(CheckEmailExistsDocument, variables),
    ...options
  }
    )};

useCheckEmailExistsQuery.getKey = (variables: CheckEmailExistsQueryVariables) => ['CheckEmailExists', variables];

export const useSuspenseCheckEmailExistsQuery = <
      TData = CheckEmailExistsQuery,
      TError = unknown
    >(
      variables: CheckEmailExistsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CheckEmailExistsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CheckEmailExistsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CheckEmailExistsQuery, TError, TData>(
      {
    queryKey: ['CheckEmailExists', variables],
    queryFn: fetchData<CheckEmailExistsQuery, CheckEmailExistsQueryVariables>(CheckEmailExistsDocument, variables),
    ...options
  }
    )};

useSuspenseCheckEmailExistsQuery.getKey = (variables: CheckEmailExistsQueryVariables) => ['CheckEmailExists', variables];

export const useInfiniteCheckEmailExistsQuery = <
      TData = InfiniteData<CheckEmailExistsQuery>,
      TError = unknown
    >(
      variables: CheckEmailExistsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CheckEmailExistsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CheckEmailExistsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CheckEmailExistsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CheckEmailExists.infinite', variables],
      queryFn: (metaData) => fetchData<CheckEmailExistsQuery, CheckEmailExistsQueryVariables>(CheckEmailExistsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCheckEmailExistsQuery.getKey = (variables: CheckEmailExistsQueryVariables) => ['CheckEmailExists.infinite', variables];

export const useSuspenseInfiniteCheckEmailExistsQuery = <
      TData = InfiniteData<CheckEmailExistsQuery>,
      TError = unknown
    >(
      variables: CheckEmailExistsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CheckEmailExistsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CheckEmailExistsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CheckEmailExistsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CheckEmailExists.infinite', variables],
      queryFn: (metaData) => fetchData<CheckEmailExistsQuery, CheckEmailExistsQueryVariables>(CheckEmailExistsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCheckEmailExistsQuery.getKey = (variables: CheckEmailExistsQueryVariables) => ['CheckEmailExists.infinite', variables];


useCheckEmailExistsQuery.fetcher = (variables: CheckEmailExistsQueryVariables, options?: RequestInit['headers']) => fetchData<CheckEmailExistsQuery, CheckEmailExistsQueryVariables>(CheckEmailExistsDocument, variables, options);

export const ArticleDocument = `
    query Article($urlStub: String!, $brandCode: String!) {
  articleBySlug(slug: $urlStub, brandCode: $brandCode) {
    id
    urlStub
    url
    title
    content
    blurb
    authorName
    datePosted
    category {
      name
      urlStub
    }
  }
}
    `;

export const useArticleQuery = <
      TData = ArticleQuery,
      TError = unknown
    >(
      variables: ArticleQueryVariables,
      options?: Omit<UseQueryOptions<ArticleQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ArticleQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ArticleQuery, TError, TData>(
      {
    queryKey: ['Article', variables],
    queryFn: fetchData<ArticleQuery, ArticleQueryVariables>(ArticleDocument, variables),
    ...options
  }
    )};

useArticleQuery.getKey = (variables: ArticleQueryVariables) => ['Article', variables];

export const useSuspenseArticleQuery = <
      TData = ArticleQuery,
      TError = unknown
    >(
      variables: ArticleQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ArticleQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ArticleQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ArticleQuery, TError, TData>(
      {
    queryKey: ['Article', variables],
    queryFn: fetchData<ArticleQuery, ArticleQueryVariables>(ArticleDocument, variables),
    ...options
  }
    )};

useSuspenseArticleQuery.getKey = (variables: ArticleQueryVariables) => ['Article', variables];

export const useInfiniteArticleQuery = <
      TData = InfiniteData<ArticleQuery>,
      TError = unknown
    >(
      variables: ArticleQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ArticleQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ArticleQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ArticleQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Article.infinite', variables],
      queryFn: (metaData) => fetchData<ArticleQuery, ArticleQueryVariables>(ArticleDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteArticleQuery.getKey = (variables: ArticleQueryVariables) => ['Article.infinite', variables];

export const useSuspenseInfiniteArticleQuery = <
      TData = InfiniteData<ArticleQuery>,
      TError = unknown
    >(
      variables: ArticleQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ArticleQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ArticleQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ArticleQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Article.infinite', variables],
      queryFn: (metaData) => fetchData<ArticleQuery, ArticleQueryVariables>(ArticleDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteArticleQuery.getKey = (variables: ArticleQueryVariables) => ['Article.infinite', variables];


useArticleQuery.fetcher = (variables: ArticleQueryVariables, options?: RequestInit['headers']) => fetchData<ArticleQuery, ArticleQueryVariables>(ArticleDocument, variables, options);

export const ArticleByPathDocument = `
    query ArticleByPath($slug: String!, $brandCode: String!) {
  articleBySlug(slug: $slug, brandCode: $brandCode) {
    id
    urlStub
    title
    content
    authorName
    datePosted
  }
}
    `;

export const useArticleByPathQuery = <
      TData = ArticleByPathQuery,
      TError = unknown
    >(
      variables: ArticleByPathQueryVariables,
      options?: Omit<UseQueryOptions<ArticleByPathQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ArticleByPathQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ArticleByPathQuery, TError, TData>(
      {
    queryKey: ['ArticleByPath', variables],
    queryFn: fetchData<ArticleByPathQuery, ArticleByPathQueryVariables>(ArticleByPathDocument, variables),
    ...options
  }
    )};

useArticleByPathQuery.getKey = (variables: ArticleByPathQueryVariables) => ['ArticleByPath', variables];

export const useSuspenseArticleByPathQuery = <
      TData = ArticleByPathQuery,
      TError = unknown
    >(
      variables: ArticleByPathQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ArticleByPathQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ArticleByPathQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ArticleByPathQuery, TError, TData>(
      {
    queryKey: ['ArticleByPath', variables],
    queryFn: fetchData<ArticleByPathQuery, ArticleByPathQueryVariables>(ArticleByPathDocument, variables),
    ...options
  }
    )};

useSuspenseArticleByPathQuery.getKey = (variables: ArticleByPathQueryVariables) => ['ArticleByPath', variables];

export const useInfiniteArticleByPathQuery = <
      TData = InfiniteData<ArticleByPathQuery>,
      TError = unknown
    >(
      variables: ArticleByPathQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ArticleByPathQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ArticleByPathQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ArticleByPathQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ArticleByPath.infinite', variables],
      queryFn: (metaData) => fetchData<ArticleByPathQuery, ArticleByPathQueryVariables>(ArticleByPathDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteArticleByPathQuery.getKey = (variables: ArticleByPathQueryVariables) => ['ArticleByPath.infinite', variables];

export const useSuspenseInfiniteArticleByPathQuery = <
      TData = InfiniteData<ArticleByPathQuery>,
      TError = unknown
    >(
      variables: ArticleByPathQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ArticleByPathQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ArticleByPathQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ArticleByPathQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ArticleByPath.infinite', variables],
      queryFn: (metaData) => fetchData<ArticleByPathQuery, ArticleByPathQueryVariables>(ArticleByPathDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteArticleByPathQuery.getKey = (variables: ArticleByPathQueryVariables) => ['ArticleByPath.infinite', variables];


useArticleByPathQuery.fetcher = (variables: ArticleByPathQueryVariables, options?: RequestInit['headers']) => fetchData<ArticleByPathQuery, ArticleByPathQueryVariables>(ArticleByPathDocument, variables, options);

export const ArticlesDocument = `
    query Articles($skip: Int, $take: Int, $brandCode: String!) {
  articles(
    skip: $skip
    take: $take
    brandCode: $brandCode
    where: {live: {eq: true}, category: {urlStub: {nin: ["jobs", "faqs", "card-magic-basics", "playing-cards", "easy-magic-tricks", "easy-magic-tricks-card-tricks", "easy-magic-tricks-mentalism", "sw-erdnase", "london-magic-convention"]}}}
    order: {datePosted: DESC}
  ) {
    items {
      id
      blurb
      thumbnailSrc
      title
      urlStub
      authorName
      datePosted
      category {
        id
        name
        urlStub
      }
      url
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

export const useArticlesQuery = <
      TData = ArticlesQuery,
      TError = unknown
    >(
      variables: ArticlesQueryVariables,
      options?: Omit<UseQueryOptions<ArticlesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ArticlesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ArticlesQuery, TError, TData>(
      {
    queryKey: ['Articles', variables],
    queryFn: fetchData<ArticlesQuery, ArticlesQueryVariables>(ArticlesDocument, variables),
    ...options
  }
    )};

useArticlesQuery.getKey = (variables: ArticlesQueryVariables) => ['Articles', variables];

export const useSuspenseArticlesQuery = <
      TData = ArticlesQuery,
      TError = unknown
    >(
      variables: ArticlesQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ArticlesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ArticlesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ArticlesQuery, TError, TData>(
      {
    queryKey: ['Articles', variables],
    queryFn: fetchData<ArticlesQuery, ArticlesQueryVariables>(ArticlesDocument, variables),
    ...options
  }
    )};

useSuspenseArticlesQuery.getKey = (variables: ArticlesQueryVariables) => ['Articles', variables];

export const useInfiniteArticlesQuery = <
      TData = InfiniteData<ArticlesQuery>,
      TError = unknown
    >(
      variables: ArticlesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ArticlesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ArticlesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ArticlesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Articles.infinite', variables],
      queryFn: (metaData) => fetchData<ArticlesQuery, ArticlesQueryVariables>(ArticlesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteArticlesQuery.getKey = (variables: ArticlesQueryVariables) => ['Articles.infinite', variables];

export const useSuspenseInfiniteArticlesQuery = <
      TData = InfiniteData<ArticlesQuery>,
      TError = unknown
    >(
      variables: ArticlesQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ArticlesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ArticlesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ArticlesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Articles.infinite', variables],
      queryFn: (metaData) => fetchData<ArticlesQuery, ArticlesQueryVariables>(ArticlesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteArticlesQuery.getKey = (variables: ArticlesQueryVariables) => ['Articles.infinite', variables];


useArticlesQuery.fetcher = (variables: ArticlesQueryVariables, options?: RequestInit['headers']) => fetchData<ArticlesQuery, ArticlesQueryVariables>(ArticlesDocument, variables, options);

export const BannerMessagesDocument = `
    query BannerMessages {
  bannerMessages(order: {id: ASC}) {
    endDate
    html
    id
    name
    position
    startDate
  }
}
    `;

export const useBannerMessagesQuery = <
      TData = BannerMessagesQuery,
      TError = unknown
    >(
      variables?: BannerMessagesQueryVariables,
      options?: Omit<UseQueryOptions<BannerMessagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BannerMessagesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BannerMessagesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['BannerMessages'] : ['BannerMessages', variables],
    queryFn: fetchData<BannerMessagesQuery, BannerMessagesQueryVariables>(BannerMessagesDocument, variables),
    ...options
  }
    )};

useBannerMessagesQuery.getKey = (variables?: BannerMessagesQueryVariables) => variables === undefined ? ['BannerMessages'] : ['BannerMessages', variables];

export const useSuspenseBannerMessagesQuery = <
      TData = BannerMessagesQuery,
      TError = unknown
    >(
      variables?: BannerMessagesQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<BannerMessagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<BannerMessagesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<BannerMessagesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['BannerMessages'] : ['BannerMessages', variables],
    queryFn: fetchData<BannerMessagesQuery, BannerMessagesQueryVariables>(BannerMessagesDocument, variables),
    ...options
  }
    )};

useSuspenseBannerMessagesQuery.getKey = (variables?: BannerMessagesQueryVariables) => variables === undefined ? ['BannerMessages'] : ['BannerMessages', variables];

export const useInfiniteBannerMessagesQuery = <
      TData = InfiniteData<BannerMessagesQuery>,
      TError = unknown
    >(
      variables: BannerMessagesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BannerMessagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BannerMessagesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<BannerMessagesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['BannerMessages.infinite'] : ['BannerMessages.infinite', variables],
      queryFn: (metaData) => fetchData<BannerMessagesQuery, BannerMessagesQueryVariables>(BannerMessagesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteBannerMessagesQuery.getKey = (variables?: BannerMessagesQueryVariables) => variables === undefined ? ['BannerMessages.infinite'] : ['BannerMessages.infinite', variables];

export const useSuspenseInfiniteBannerMessagesQuery = <
      TData = InfiniteData<BannerMessagesQuery>,
      TError = unknown
    >(
      variables: BannerMessagesQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<BannerMessagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<BannerMessagesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<BannerMessagesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['BannerMessages.infinite'] : ['BannerMessages.infinite', variables],
      queryFn: (metaData) => fetchData<BannerMessagesQuery, BannerMessagesQueryVariables>(BannerMessagesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteBannerMessagesQuery.getKey = (variables?: BannerMessagesQueryVariables) => variables === undefined ? ['BannerMessages.infinite'] : ['BannerMessages.infinite', variables];


useBannerMessagesQuery.fetcher = (variables?: BannerMessagesQueryVariables, options?: RequestInit['headers']) => fetchData<BannerMessagesQuery, BannerMessagesQueryVariables>(BannerMessagesDocument, variables, options);

export const BlogPagePostsDocument = `
    query BlogPagePosts($skip: Int, $take: Int, $brandCode: String!) {
  blogPosts(
    order: {datePosted: DESC}
    skip: $skip
    take: $take
    where: {live: {eq: true}}
    brandCode: $brandCode
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      blurb
      title
      urlStub
      url
      authorName
      thumbnailSrc
      datePosted
      category {
        name
      }
    }
  }
}
    `;

export const useBlogPagePostsQuery = <
      TData = BlogPagePostsQuery,
      TError = unknown
    >(
      variables: BlogPagePostsQueryVariables,
      options?: Omit<UseQueryOptions<BlogPagePostsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BlogPagePostsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BlogPagePostsQuery, TError, TData>(
      {
    queryKey: ['BlogPagePosts', variables],
    queryFn: fetchData<BlogPagePostsQuery, BlogPagePostsQueryVariables>(BlogPagePostsDocument, variables),
    ...options
  }
    )};

useBlogPagePostsQuery.getKey = (variables: BlogPagePostsQueryVariables) => ['BlogPagePosts', variables];

export const useSuspenseBlogPagePostsQuery = <
      TData = BlogPagePostsQuery,
      TError = unknown
    >(
      variables: BlogPagePostsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<BlogPagePostsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<BlogPagePostsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<BlogPagePostsQuery, TError, TData>(
      {
    queryKey: ['BlogPagePosts', variables],
    queryFn: fetchData<BlogPagePostsQuery, BlogPagePostsQueryVariables>(BlogPagePostsDocument, variables),
    ...options
  }
    )};

useSuspenseBlogPagePostsQuery.getKey = (variables: BlogPagePostsQueryVariables) => ['BlogPagePosts', variables];

export const useInfiniteBlogPagePostsQuery = <
      TData = InfiniteData<BlogPagePostsQuery>,
      TError = unknown
    >(
      variables: BlogPagePostsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BlogPagePostsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BlogPagePostsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<BlogPagePostsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['BlogPagePosts.infinite', variables],
      queryFn: (metaData) => fetchData<BlogPagePostsQuery, BlogPagePostsQueryVariables>(BlogPagePostsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteBlogPagePostsQuery.getKey = (variables: BlogPagePostsQueryVariables) => ['BlogPagePosts.infinite', variables];

export const useSuspenseInfiniteBlogPagePostsQuery = <
      TData = InfiniteData<BlogPagePostsQuery>,
      TError = unknown
    >(
      variables: BlogPagePostsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<BlogPagePostsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<BlogPagePostsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<BlogPagePostsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['BlogPagePosts.infinite', variables],
      queryFn: (metaData) => fetchData<BlogPagePostsQuery, BlogPagePostsQueryVariables>(BlogPagePostsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteBlogPagePostsQuery.getKey = (variables: BlogPagePostsQueryVariables) => ['BlogPagePosts.infinite', variables];


useBlogPagePostsQuery.fetcher = (variables: BlogPagePostsQueryVariables, options?: RequestInit['headers']) => fetchData<BlogPagePostsQuery, BlogPagePostsQueryVariables>(BlogPagePostsDocument, variables, options);

export const BlogPostDocument = `
    query BlogPost($urlStub: String!) {
  blogPostBySlug(slug: $urlStub) {
    id
    title
    content
    authorName
    datePosted
    blurb
    thumbnailSrc
    url
    faqType
    comments {
      id
      customerId
      comment
      time
      responseTo
      customerName
      gravatarUrl
    }
    relatedPosts {
      id
      title
      urlStub
      url
      blurb
      authorName
      datePosted
      thumbnailSrc
      category {
        name
      }
    }
  }
}
    `;

export const useBlogPostQuery = <
      TData = BlogPostQuery,
      TError = unknown
    >(
      variables: BlogPostQueryVariables,
      options?: Omit<UseQueryOptions<BlogPostQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BlogPostQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BlogPostQuery, TError, TData>(
      {
    queryKey: ['BlogPost', variables],
    queryFn: fetchData<BlogPostQuery, BlogPostQueryVariables>(BlogPostDocument, variables),
    ...options
  }
    )};

useBlogPostQuery.getKey = (variables: BlogPostQueryVariables) => ['BlogPost', variables];

export const useSuspenseBlogPostQuery = <
      TData = BlogPostQuery,
      TError = unknown
    >(
      variables: BlogPostQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<BlogPostQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<BlogPostQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<BlogPostQuery, TError, TData>(
      {
    queryKey: ['BlogPost', variables],
    queryFn: fetchData<BlogPostQuery, BlogPostQueryVariables>(BlogPostDocument, variables),
    ...options
  }
    )};

useSuspenseBlogPostQuery.getKey = (variables: BlogPostQueryVariables) => ['BlogPost', variables];

export const useInfiniteBlogPostQuery = <
      TData = InfiniteData<BlogPostQuery>,
      TError = unknown
    >(
      variables: BlogPostQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BlogPostQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BlogPostQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<BlogPostQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['BlogPost.infinite', variables],
      queryFn: (metaData) => fetchData<BlogPostQuery, BlogPostQueryVariables>(BlogPostDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteBlogPostQuery.getKey = (variables: BlogPostQueryVariables) => ['BlogPost.infinite', variables];

export const useSuspenseInfiniteBlogPostQuery = <
      TData = InfiniteData<BlogPostQuery>,
      TError = unknown
    >(
      variables: BlogPostQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<BlogPostQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<BlogPostQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<BlogPostQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['BlogPost.infinite', variables],
      queryFn: (metaData) => fetchData<BlogPostQuery, BlogPostQueryVariables>(BlogPostDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteBlogPostQuery.getKey = (variables: BlogPostQueryVariables) => ['BlogPost.infinite', variables];


useBlogPostQuery.fetcher = (variables: BlogPostQueryVariables, options?: RequestInit['headers']) => fetchData<BlogPostQuery, BlogPostQueryVariables>(BlogPostDocument, variables, options);

export const BookReviewDocument = `
    query BookReview($slug: String!) {
  bookReviewBySlug(slug: $slug) {
    authorName
    blurb
    content
    datePosted
    productSlug
    thumbnailSrc
    title
    type
    url
    urlStub
  }
}
    `;

export const useBookReviewQuery = <
      TData = BookReviewQuery,
      TError = unknown
    >(
      variables: BookReviewQueryVariables,
      options?: Omit<UseQueryOptions<BookReviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BookReviewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BookReviewQuery, TError, TData>(
      {
    queryKey: ['BookReview', variables],
    queryFn: fetchData<BookReviewQuery, BookReviewQueryVariables>(BookReviewDocument, variables),
    ...options
  }
    )};

useBookReviewQuery.getKey = (variables: BookReviewQueryVariables) => ['BookReview', variables];

export const useSuspenseBookReviewQuery = <
      TData = BookReviewQuery,
      TError = unknown
    >(
      variables: BookReviewQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<BookReviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<BookReviewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<BookReviewQuery, TError, TData>(
      {
    queryKey: ['BookReview', variables],
    queryFn: fetchData<BookReviewQuery, BookReviewQueryVariables>(BookReviewDocument, variables),
    ...options
  }
    )};

useSuspenseBookReviewQuery.getKey = (variables: BookReviewQueryVariables) => ['BookReview', variables];

export const useInfiniteBookReviewQuery = <
      TData = InfiniteData<BookReviewQuery>,
      TError = unknown
    >(
      variables: BookReviewQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BookReviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BookReviewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<BookReviewQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['BookReview.infinite', variables],
      queryFn: (metaData) => fetchData<BookReviewQuery, BookReviewQueryVariables>(BookReviewDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteBookReviewQuery.getKey = (variables: BookReviewQueryVariables) => ['BookReview.infinite', variables];

export const useSuspenseInfiniteBookReviewQuery = <
      TData = InfiniteData<BookReviewQuery>,
      TError = unknown
    >(
      variables: BookReviewQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<BookReviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<BookReviewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<BookReviewQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['BookReview.infinite', variables],
      queryFn: (metaData) => fetchData<BookReviewQuery, BookReviewQueryVariables>(BookReviewDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteBookReviewQuery.getKey = (variables: BookReviewQueryVariables) => ['BookReview.infinite', variables];


useBookReviewQuery.fetcher = (variables: BookReviewQueryVariables, options?: RequestInit['headers']) => fetchData<BookReviewQuery, BookReviewQueryVariables>(BookReviewDocument, variables, options);

export const BookReviewsDocument = `
    query BookReviews($brandId: Int!, $skip: Int!, $take: Int!, $where: BookReviewDtoFilterInput) {
  bookReviews(brandId: $brandId, skip: $skip, take: $take, where: $where) {
    items {
      authorName
      datePosted
      id
      live
      title
      url
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

export const useBookReviewsQuery = <
      TData = BookReviewsQuery,
      TError = unknown
    >(
      variables: BookReviewsQueryVariables,
      options?: Omit<UseQueryOptions<BookReviewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BookReviewsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BookReviewsQuery, TError, TData>(
      {
    queryKey: ['BookReviews', variables],
    queryFn: fetchData<BookReviewsQuery, BookReviewsQueryVariables>(BookReviewsDocument, variables),
    ...options
  }
    )};

useBookReviewsQuery.getKey = (variables: BookReviewsQueryVariables) => ['BookReviews', variables];

export const useSuspenseBookReviewsQuery = <
      TData = BookReviewsQuery,
      TError = unknown
    >(
      variables: BookReviewsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<BookReviewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<BookReviewsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<BookReviewsQuery, TError, TData>(
      {
    queryKey: ['BookReviews', variables],
    queryFn: fetchData<BookReviewsQuery, BookReviewsQueryVariables>(BookReviewsDocument, variables),
    ...options
  }
    )};

useSuspenseBookReviewsQuery.getKey = (variables: BookReviewsQueryVariables) => ['BookReviews', variables];

export const useInfiniteBookReviewsQuery = <
      TData = InfiniteData<BookReviewsQuery>,
      TError = unknown
    >(
      variables: BookReviewsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BookReviewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BookReviewsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<BookReviewsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['BookReviews.infinite', variables],
      queryFn: (metaData) => fetchData<BookReviewsQuery, BookReviewsQueryVariables>(BookReviewsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteBookReviewsQuery.getKey = (variables: BookReviewsQueryVariables) => ['BookReviews.infinite', variables];

export const useSuspenseInfiniteBookReviewsQuery = <
      TData = InfiniteData<BookReviewsQuery>,
      TError = unknown
    >(
      variables: BookReviewsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<BookReviewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<BookReviewsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<BookReviewsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['BookReviews.infinite', variables],
      queryFn: (metaData) => fetchData<BookReviewsQuery, BookReviewsQueryVariables>(BookReviewsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteBookReviewsQuery.getKey = (variables: BookReviewsQueryVariables) => ['BookReviews.infinite', variables];


useBookReviewsQuery.fetcher = (variables: BookReviewsQueryVariables, options?: RequestInit['headers']) => fetchData<BookReviewsQuery, BookReviewsQueryVariables>(BookReviewsDocument, variables, options);

export const CategoryBlogPostsDocument = `
    query CategoryBlogPosts($categorySlug: String!, $brandCode: String!, $skip: Int, $take: Int) {
  pagesByCategory(
    skip: $skip
    take: $take
    brandCode: $brandCode
    categorySlug: $categorySlug
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      blurb
      title
      urlStub
      url
      authorName
      thumbnailSrc
      datePosted
      category {
        name
        urlStub
      }
    }
  }
}
    `;

export const useCategoryBlogPostsQuery = <
      TData = CategoryBlogPostsQuery,
      TError = unknown
    >(
      variables: CategoryBlogPostsQueryVariables,
      options?: Omit<UseQueryOptions<CategoryBlogPostsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CategoryBlogPostsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CategoryBlogPostsQuery, TError, TData>(
      {
    queryKey: ['CategoryBlogPosts', variables],
    queryFn: fetchData<CategoryBlogPostsQuery, CategoryBlogPostsQueryVariables>(CategoryBlogPostsDocument, variables),
    ...options
  }
    )};

useCategoryBlogPostsQuery.getKey = (variables: CategoryBlogPostsQueryVariables) => ['CategoryBlogPosts', variables];

export const useSuspenseCategoryBlogPostsQuery = <
      TData = CategoryBlogPostsQuery,
      TError = unknown
    >(
      variables: CategoryBlogPostsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CategoryBlogPostsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CategoryBlogPostsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CategoryBlogPostsQuery, TError, TData>(
      {
    queryKey: ['CategoryBlogPosts', variables],
    queryFn: fetchData<CategoryBlogPostsQuery, CategoryBlogPostsQueryVariables>(CategoryBlogPostsDocument, variables),
    ...options
  }
    )};

useSuspenseCategoryBlogPostsQuery.getKey = (variables: CategoryBlogPostsQueryVariables) => ['CategoryBlogPosts', variables];

export const useInfiniteCategoryBlogPostsQuery = <
      TData = InfiniteData<CategoryBlogPostsQuery>,
      TError = unknown
    >(
      variables: CategoryBlogPostsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CategoryBlogPostsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CategoryBlogPostsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CategoryBlogPostsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CategoryBlogPosts.infinite', variables],
      queryFn: (metaData) => fetchData<CategoryBlogPostsQuery, CategoryBlogPostsQueryVariables>(CategoryBlogPostsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCategoryBlogPostsQuery.getKey = (variables: CategoryBlogPostsQueryVariables) => ['CategoryBlogPosts.infinite', variables];

export const useSuspenseInfiniteCategoryBlogPostsQuery = <
      TData = InfiniteData<CategoryBlogPostsQuery>,
      TError = unknown
    >(
      variables: CategoryBlogPostsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CategoryBlogPostsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CategoryBlogPostsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CategoryBlogPostsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CategoryBlogPosts.infinite', variables],
      queryFn: (metaData) => fetchData<CategoryBlogPostsQuery, CategoryBlogPostsQueryVariables>(CategoryBlogPostsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCategoryBlogPostsQuery.getKey = (variables: CategoryBlogPostsQueryVariables) => ['CategoryBlogPosts.infinite', variables];


useCategoryBlogPostsQuery.fetcher = (variables: CategoryBlogPostsQueryVariables, options?: RequestInit['headers']) => fetchData<CategoryBlogPostsQuery, CategoryBlogPostsQueryVariables>(CategoryBlogPostsDocument, variables, options);

export const FaqDocument = `
    query Faq($slug: String!) {
  faqBySlug(slug: $slug, where: {live: {eq: true}}) {
    title
    id
    category {
      name
    }
    content
    authorName
    faqType
  }
}
    `;

export const useFaqQuery = <
      TData = FaqQuery,
      TError = unknown
    >(
      variables: FaqQueryVariables,
      options?: Omit<UseQueryOptions<FaqQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FaqQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FaqQuery, TError, TData>(
      {
    queryKey: ['Faq', variables],
    queryFn: fetchData<FaqQuery, FaqQueryVariables>(FaqDocument, variables),
    ...options
  }
    )};

useFaqQuery.getKey = (variables: FaqQueryVariables) => ['Faq', variables];

export const useSuspenseFaqQuery = <
      TData = FaqQuery,
      TError = unknown
    >(
      variables: FaqQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<FaqQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<FaqQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<FaqQuery, TError, TData>(
      {
    queryKey: ['Faq', variables],
    queryFn: fetchData<FaqQuery, FaqQueryVariables>(FaqDocument, variables),
    ...options
  }
    )};

useSuspenseFaqQuery.getKey = (variables: FaqQueryVariables) => ['Faq', variables];

export const useInfiniteFaqQuery = <
      TData = InfiniteData<FaqQuery>,
      TError = unknown
    >(
      variables: FaqQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FaqQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FaqQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<FaqQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Faq.infinite', variables],
      queryFn: (metaData) => fetchData<FaqQuery, FaqQueryVariables>(FaqDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteFaqQuery.getKey = (variables: FaqQueryVariables) => ['Faq.infinite', variables];

export const useSuspenseInfiniteFaqQuery = <
      TData = InfiniteData<FaqQuery>,
      TError = unknown
    >(
      variables: FaqQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<FaqQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<FaqQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<FaqQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Faq.infinite', variables],
      queryFn: (metaData) => fetchData<FaqQuery, FaqQueryVariables>(FaqDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteFaqQuery.getKey = (variables: FaqQueryVariables) => ['Faq.infinite', variables];


useFaqQuery.fetcher = (variables: FaqQueryVariables, options?: RequestInit['headers']) => fetchData<FaqQuery, FaqQueryVariables>(FaqDocument, variables, options);

export const FaqsDocument = `
    query Faqs {
  faqs(
    where: {and: [{live: {eq: true}}, {or: [{faqType: {eq: "shipping"}}, {faqType: {eq: "ordering"}}, {faqType: {eq: "contacting-us"}}, {faqType: {eq: "change-order"}}, {faqType: {eq: "invoices"}}, {faqType: {eq: "refunds"}}, {faqType: {eq: "discounts"}}, {faqType: {eq: "downloads"}}, {faqType: {eq: "tax"}}, {faqType: {eq: "website"}}, {faqType: {eq: "events"}}]}]}
    brandId: 1
  ) {
    id
    title
    faqType
    urlStub
  }
}
    `;

export const useFaqsQuery = <
      TData = FaqsQuery,
      TError = unknown
    >(
      variables?: FaqsQueryVariables,
      options?: Omit<UseQueryOptions<FaqsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FaqsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FaqsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Faqs'] : ['Faqs', variables],
    queryFn: fetchData<FaqsQuery, FaqsQueryVariables>(FaqsDocument, variables),
    ...options
  }
    )};

useFaqsQuery.getKey = (variables?: FaqsQueryVariables) => variables === undefined ? ['Faqs'] : ['Faqs', variables];

export const useSuspenseFaqsQuery = <
      TData = FaqsQuery,
      TError = unknown
    >(
      variables?: FaqsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<FaqsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<FaqsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<FaqsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Faqs'] : ['Faqs', variables],
    queryFn: fetchData<FaqsQuery, FaqsQueryVariables>(FaqsDocument, variables),
    ...options
  }
    )};

useSuspenseFaqsQuery.getKey = (variables?: FaqsQueryVariables) => variables === undefined ? ['Faqs'] : ['Faqs', variables];

export const useInfiniteFaqsQuery = <
      TData = InfiniteData<FaqsQuery>,
      TError = unknown
    >(
      variables: FaqsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FaqsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FaqsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<FaqsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Faqs.infinite'] : ['Faqs.infinite', variables],
      queryFn: (metaData) => fetchData<FaqsQuery, FaqsQueryVariables>(FaqsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteFaqsQuery.getKey = (variables?: FaqsQueryVariables) => variables === undefined ? ['Faqs.infinite'] : ['Faqs.infinite', variables];

export const useSuspenseInfiniteFaqsQuery = <
      TData = InfiniteData<FaqsQuery>,
      TError = unknown
    >(
      variables: FaqsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<FaqsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<FaqsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<FaqsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Faqs.infinite'] : ['Faqs.infinite', variables],
      queryFn: (metaData) => fetchData<FaqsQuery, FaqsQueryVariables>(FaqsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteFaqsQuery.getKey = (variables?: FaqsQueryVariables) => variables === undefined ? ['Faqs.infinite'] : ['Faqs.infinite', variables];


useFaqsQuery.fetcher = (variables?: FaqsQueryVariables, options?: RequestInit['headers']) => fetchData<FaqsQuery, FaqsQueryVariables>(FaqsDocument, variables, options);

export const FeaturedBlogPostsDocument = `
    query FeaturedBlogPosts($brandCode: String!) {
  blogPosts(
    order: {datePosted: DESC}
    skip: 0
    take: 2
    brandCode: $brandCode
    where: {live: {eq: true}}
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      blurb
      title
      urlStub
      authorName
      datePosted
      category {
        name
      }
    }
  }
}
    `;

export const useFeaturedBlogPostsQuery = <
      TData = FeaturedBlogPostsQuery,
      TError = unknown
    >(
      variables: FeaturedBlogPostsQueryVariables,
      options?: Omit<UseQueryOptions<FeaturedBlogPostsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FeaturedBlogPostsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FeaturedBlogPostsQuery, TError, TData>(
      {
    queryKey: ['FeaturedBlogPosts', variables],
    queryFn: fetchData<FeaturedBlogPostsQuery, FeaturedBlogPostsQueryVariables>(FeaturedBlogPostsDocument, variables),
    ...options
  }
    )};

useFeaturedBlogPostsQuery.getKey = (variables: FeaturedBlogPostsQueryVariables) => ['FeaturedBlogPosts', variables];

export const useSuspenseFeaturedBlogPostsQuery = <
      TData = FeaturedBlogPostsQuery,
      TError = unknown
    >(
      variables: FeaturedBlogPostsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<FeaturedBlogPostsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<FeaturedBlogPostsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<FeaturedBlogPostsQuery, TError, TData>(
      {
    queryKey: ['FeaturedBlogPosts', variables],
    queryFn: fetchData<FeaturedBlogPostsQuery, FeaturedBlogPostsQueryVariables>(FeaturedBlogPostsDocument, variables),
    ...options
  }
    )};

useSuspenseFeaturedBlogPostsQuery.getKey = (variables: FeaturedBlogPostsQueryVariables) => ['FeaturedBlogPosts', variables];

export const useInfiniteFeaturedBlogPostsQuery = <
      TData = InfiniteData<FeaturedBlogPostsQuery>,
      TError = unknown
    >(
      variables: FeaturedBlogPostsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FeaturedBlogPostsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FeaturedBlogPostsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<FeaturedBlogPostsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FeaturedBlogPosts.infinite', variables],
      queryFn: (metaData) => fetchData<FeaturedBlogPostsQuery, FeaturedBlogPostsQueryVariables>(FeaturedBlogPostsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteFeaturedBlogPostsQuery.getKey = (variables: FeaturedBlogPostsQueryVariables) => ['FeaturedBlogPosts.infinite', variables];

export const useSuspenseInfiniteFeaturedBlogPostsQuery = <
      TData = InfiniteData<FeaturedBlogPostsQuery>,
      TError = unknown
    >(
      variables: FeaturedBlogPostsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<FeaturedBlogPostsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<FeaturedBlogPostsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<FeaturedBlogPostsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FeaturedBlogPosts.infinite', variables],
      queryFn: (metaData) => fetchData<FeaturedBlogPostsQuery, FeaturedBlogPostsQueryVariables>(FeaturedBlogPostsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteFeaturedBlogPostsQuery.getKey = (variables: FeaturedBlogPostsQueryVariables) => ['FeaturedBlogPosts.infinite', variables];


useFeaturedBlogPostsQuery.fetcher = (variables: FeaturedBlogPostsQueryVariables, options?: RequestInit['headers']) => fetchData<FeaturedBlogPostsQuery, FeaturedBlogPostsQueryVariables>(FeaturedBlogPostsDocument, variables, options);

export const InsiderPodcastPostsDocument = `
    query InsiderPodcastPosts($brandCode: String!, $categoryName: String!, $take: Int) {
  blogPosts(
    order: {datePosted: DESC}
    skip: 0
    take: $take
    where: {live: {eq: true}, category: {name: {eq: $categoryName}}}
    brandCode: $brandCode
  ) {
    items {
      id
      title
      urlStub
      url
      thumbnailSrc
      datePosted
    }
  }
}
    `;

export const useInsiderPodcastPostsQuery = <
      TData = InsiderPodcastPostsQuery,
      TError = unknown
    >(
      variables: InsiderPodcastPostsQueryVariables,
      options?: Omit<UseQueryOptions<InsiderPodcastPostsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<InsiderPodcastPostsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<InsiderPodcastPostsQuery, TError, TData>(
      {
    queryKey: ['InsiderPodcastPosts', variables],
    queryFn: fetchData<InsiderPodcastPostsQuery, InsiderPodcastPostsQueryVariables>(InsiderPodcastPostsDocument, variables),
    ...options
  }
    )};

useInsiderPodcastPostsQuery.getKey = (variables: InsiderPodcastPostsQueryVariables) => ['InsiderPodcastPosts', variables];

export const useSuspenseInsiderPodcastPostsQuery = <
      TData = InsiderPodcastPostsQuery,
      TError = unknown
    >(
      variables: InsiderPodcastPostsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<InsiderPodcastPostsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<InsiderPodcastPostsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<InsiderPodcastPostsQuery, TError, TData>(
      {
    queryKey: ['InsiderPodcastPosts', variables],
    queryFn: fetchData<InsiderPodcastPostsQuery, InsiderPodcastPostsQueryVariables>(InsiderPodcastPostsDocument, variables),
    ...options
  }
    )};

useSuspenseInsiderPodcastPostsQuery.getKey = (variables: InsiderPodcastPostsQueryVariables) => ['InsiderPodcastPosts', variables];

export const useInfiniteInsiderPodcastPostsQuery = <
      TData = InfiniteData<InsiderPodcastPostsQuery>,
      TError = unknown
    >(
      variables: InsiderPodcastPostsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<InsiderPodcastPostsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<InsiderPodcastPostsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<InsiderPodcastPostsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['InsiderPodcastPosts.infinite', variables],
      queryFn: (metaData) => fetchData<InsiderPodcastPostsQuery, InsiderPodcastPostsQueryVariables>(InsiderPodcastPostsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteInsiderPodcastPostsQuery.getKey = (variables: InsiderPodcastPostsQueryVariables) => ['InsiderPodcastPosts.infinite', variables];

export const useSuspenseInfiniteInsiderPodcastPostsQuery = <
      TData = InfiniteData<InsiderPodcastPostsQuery>,
      TError = unknown
    >(
      variables: InsiderPodcastPostsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<InsiderPodcastPostsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<InsiderPodcastPostsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<InsiderPodcastPostsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['InsiderPodcastPosts.infinite', variables],
      queryFn: (metaData) => fetchData<InsiderPodcastPostsQuery, InsiderPodcastPostsQueryVariables>(InsiderPodcastPostsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteInsiderPodcastPostsQuery.getKey = (variables: InsiderPodcastPostsQueryVariables) => ['InsiderPodcastPosts.infinite', variables];


useInsiderPodcastPostsQuery.fetcher = (variables: InsiderPodcastPostsQueryVariables, options?: RequestInit['headers']) => fetchData<InsiderPodcastPostsQuery, InsiderPodcastPostsQueryVariables>(InsiderPodcastPostsDocument, variables, options);

export const ConventionOrderItemDocument = `
    query ConventionOrderItem($orderItemId: Int!) {
  conventionOrderItem(orderItemId: $orderItemId) {
    id
    orderId
    productId
    conventionName
    registrantName
    url
    priceCharged
    thumbnailSrc
    optionDescription
    order {
      id
      orderDate
      currency {
        id
        code
        symbol
      }
    }
    conventionStartDate
    conventionEndDate
    conventionLocation
    paymentInfo {
      totalAmount
      totalPaid
      remainingAmount
      hasPaymentCard
      isCardExpired
      defaultCard {
        brand
        last4
        expMonth
        expYear
      }
    }
    paymentInstallments {
      description
      dueDate
      paidDate
      amount
      isPaid
      isExtraPayment
    }
    upgrade {
      isAvailable
      amount
      currencyId
      unavailableReason
    }
  }
}
    `;

export const useConventionOrderItemQuery = <
      TData = ConventionOrderItemQuery,
      TError = unknown
    >(
      variables: ConventionOrderItemQueryVariables,
      options?: Omit<UseQueryOptions<ConventionOrderItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ConventionOrderItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ConventionOrderItemQuery, TError, TData>(
      {
    queryKey: ['ConventionOrderItem', variables],
    queryFn: fetchData<ConventionOrderItemQuery, ConventionOrderItemQueryVariables>(ConventionOrderItemDocument, variables),
    ...options
  }
    )};

useConventionOrderItemQuery.getKey = (variables: ConventionOrderItemQueryVariables) => ['ConventionOrderItem', variables];

export const useSuspenseConventionOrderItemQuery = <
      TData = ConventionOrderItemQuery,
      TError = unknown
    >(
      variables: ConventionOrderItemQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ConventionOrderItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ConventionOrderItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ConventionOrderItemQuery, TError, TData>(
      {
    queryKey: ['ConventionOrderItem', variables],
    queryFn: fetchData<ConventionOrderItemQuery, ConventionOrderItemQueryVariables>(ConventionOrderItemDocument, variables),
    ...options
  }
    )};

useSuspenseConventionOrderItemQuery.getKey = (variables: ConventionOrderItemQueryVariables) => ['ConventionOrderItem', variables];

export const useInfiniteConventionOrderItemQuery = <
      TData = InfiniteData<ConventionOrderItemQuery>,
      TError = unknown
    >(
      variables: ConventionOrderItemQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ConventionOrderItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ConventionOrderItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ConventionOrderItemQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ConventionOrderItem.infinite', variables],
      queryFn: (metaData) => fetchData<ConventionOrderItemQuery, ConventionOrderItemQueryVariables>(ConventionOrderItemDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteConventionOrderItemQuery.getKey = (variables: ConventionOrderItemQueryVariables) => ['ConventionOrderItem.infinite', variables];

export const useSuspenseInfiniteConventionOrderItemQuery = <
      TData = InfiniteData<ConventionOrderItemQuery>,
      TError = unknown
    >(
      variables: ConventionOrderItemQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ConventionOrderItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ConventionOrderItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ConventionOrderItemQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ConventionOrderItem.infinite', variables],
      queryFn: (metaData) => fetchData<ConventionOrderItemQuery, ConventionOrderItemQueryVariables>(ConventionOrderItemDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteConventionOrderItemQuery.getKey = (variables: ConventionOrderItemQueryVariables) => ['ConventionOrderItem.infinite', variables];


useConventionOrderItemQuery.fetcher = (variables: ConventionOrderItemQueryVariables, options?: RequestInit['headers']) => fetchData<ConventionOrderItemQuery, ConventionOrderItemQueryVariables>(ConventionOrderItemDocument, variables, options);

export const ConventionRegistrationProductDocument = `
    query ConventionRegistrationProduct($slug: String!, $brandCode: String!, $password: String) {
  ecommProductBySlug(brandCode: $brandCode, slug: $slug, password: $password) {
    id
    name
    displayPrice
    currencySymbol
    options {
      id
      description
      price
      salePrice
      priceIncVat
      salePriceIncVat
      maxQuantity
      currency {
        symbol
        code
      }
    }
    meta {
      key
      value
    }
  }
}
    `;

export const useConventionRegistrationProductQuery = <
      TData = ConventionRegistrationProductQuery,
      TError = unknown
    >(
      variables: ConventionRegistrationProductQueryVariables,
      options?: Omit<UseQueryOptions<ConventionRegistrationProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ConventionRegistrationProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ConventionRegistrationProductQuery, TError, TData>(
      {
    queryKey: ['ConventionRegistrationProduct', variables],
    queryFn: fetchData<ConventionRegistrationProductQuery, ConventionRegistrationProductQueryVariables>(ConventionRegistrationProductDocument, variables),
    ...options
  }
    )};

useConventionRegistrationProductQuery.getKey = (variables: ConventionRegistrationProductQueryVariables) => ['ConventionRegistrationProduct', variables];

export const useSuspenseConventionRegistrationProductQuery = <
      TData = ConventionRegistrationProductQuery,
      TError = unknown
    >(
      variables: ConventionRegistrationProductQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ConventionRegistrationProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ConventionRegistrationProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ConventionRegistrationProductQuery, TError, TData>(
      {
    queryKey: ['ConventionRegistrationProduct', variables],
    queryFn: fetchData<ConventionRegistrationProductQuery, ConventionRegistrationProductQueryVariables>(ConventionRegistrationProductDocument, variables),
    ...options
  }
    )};

useSuspenseConventionRegistrationProductQuery.getKey = (variables: ConventionRegistrationProductQueryVariables) => ['ConventionRegistrationProduct', variables];

export const useInfiniteConventionRegistrationProductQuery = <
      TData = InfiniteData<ConventionRegistrationProductQuery>,
      TError = unknown
    >(
      variables: ConventionRegistrationProductQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ConventionRegistrationProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ConventionRegistrationProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ConventionRegistrationProductQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ConventionRegistrationProduct.infinite', variables],
      queryFn: (metaData) => fetchData<ConventionRegistrationProductQuery, ConventionRegistrationProductQueryVariables>(ConventionRegistrationProductDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteConventionRegistrationProductQuery.getKey = (variables: ConventionRegistrationProductQueryVariables) => ['ConventionRegistrationProduct.infinite', variables];

export const useSuspenseInfiniteConventionRegistrationProductQuery = <
      TData = InfiniteData<ConventionRegistrationProductQuery>,
      TError = unknown
    >(
      variables: ConventionRegistrationProductQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ConventionRegistrationProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ConventionRegistrationProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ConventionRegistrationProductQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ConventionRegistrationProduct.infinite', variables],
      queryFn: (metaData) => fetchData<ConventionRegistrationProductQuery, ConventionRegistrationProductQueryVariables>(ConventionRegistrationProductDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteConventionRegistrationProductQuery.getKey = (variables: ConventionRegistrationProductQueryVariables) => ['ConventionRegistrationProduct.infinite', variables];


useConventionRegistrationProductQuery.fetcher = (variables: ConventionRegistrationProductQueryVariables, options?: RequestInit['headers']) => fetchData<ConventionRegistrationProductQuery, ConventionRegistrationProductQueryVariables>(ConventionRegistrationProductDocument, variables, options);

export const ConventionRegistrationsDocument = `
    query ConventionRegistrations($skip: Int, $take: Int, $filter: ConventionTimeFilterEnum) {
  conventionRegistrations(skip: $skip, take: $take, filter: $filter) {
    totalCount
    items {
      id
      conventionName
      registrantName
      thumbnailSrc
      optionDescription
      conventionStartDate
      order {
        statusDescription
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

export const useConventionRegistrationsQuery = <
      TData = ConventionRegistrationsQuery,
      TError = unknown
    >(
      variables?: ConventionRegistrationsQueryVariables,
      options?: Omit<UseQueryOptions<ConventionRegistrationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ConventionRegistrationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ConventionRegistrationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ConventionRegistrations'] : ['ConventionRegistrations', variables],
    queryFn: fetchData<ConventionRegistrationsQuery, ConventionRegistrationsQueryVariables>(ConventionRegistrationsDocument, variables),
    ...options
  }
    )};

useConventionRegistrationsQuery.getKey = (variables?: ConventionRegistrationsQueryVariables) => variables === undefined ? ['ConventionRegistrations'] : ['ConventionRegistrations', variables];

export const useSuspenseConventionRegistrationsQuery = <
      TData = ConventionRegistrationsQuery,
      TError = unknown
    >(
      variables?: ConventionRegistrationsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ConventionRegistrationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ConventionRegistrationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ConventionRegistrationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ConventionRegistrations'] : ['ConventionRegistrations', variables],
    queryFn: fetchData<ConventionRegistrationsQuery, ConventionRegistrationsQueryVariables>(ConventionRegistrationsDocument, variables),
    ...options
  }
    )};

useSuspenseConventionRegistrationsQuery.getKey = (variables?: ConventionRegistrationsQueryVariables) => variables === undefined ? ['ConventionRegistrations'] : ['ConventionRegistrations', variables];

export const useInfiniteConventionRegistrationsQuery = <
      TData = InfiniteData<ConventionRegistrationsQuery>,
      TError = unknown
    >(
      variables: ConventionRegistrationsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ConventionRegistrationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ConventionRegistrationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ConventionRegistrationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ConventionRegistrations.infinite'] : ['ConventionRegistrations.infinite', variables],
      queryFn: (metaData) => fetchData<ConventionRegistrationsQuery, ConventionRegistrationsQueryVariables>(ConventionRegistrationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteConventionRegistrationsQuery.getKey = (variables?: ConventionRegistrationsQueryVariables) => variables === undefined ? ['ConventionRegistrations.infinite'] : ['ConventionRegistrations.infinite', variables];

export const useSuspenseInfiniteConventionRegistrationsQuery = <
      TData = InfiniteData<ConventionRegistrationsQuery>,
      TError = unknown
    >(
      variables: ConventionRegistrationsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ConventionRegistrationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ConventionRegistrationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ConventionRegistrationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ConventionRegistrations.infinite'] : ['ConventionRegistrations.infinite', variables],
      queryFn: (metaData) => fetchData<ConventionRegistrationsQuery, ConventionRegistrationsQueryVariables>(ConventionRegistrationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteConventionRegistrationsQuery.getKey = (variables?: ConventionRegistrationsQueryVariables) => variables === undefined ? ['ConventionRegistrations.infinite'] : ['ConventionRegistrations.infinite', variables];


useConventionRegistrationsQuery.fetcher = (variables?: ConventionRegistrationsQueryVariables, options?: RequestInit['headers']) => fetchData<ConventionRegistrationsQuery, ConventionRegistrationsQueryVariables>(ConventionRegistrationsDocument, variables, options);

export const CreatorByIdDocument = `
    query CreatorById($id: Int!) {
  creatorById(id: $id) {
    id
    name
    urlStub
    intro
    emailAddress
    paymentMethod
  }
}
    `;

export const useCreatorByIdQuery = <
      TData = CreatorByIdQuery,
      TError = unknown
    >(
      variables: CreatorByIdQueryVariables,
      options?: Omit<UseQueryOptions<CreatorByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CreatorByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CreatorByIdQuery, TError, TData>(
      {
    queryKey: ['CreatorById', variables],
    queryFn: fetchData<CreatorByIdQuery, CreatorByIdQueryVariables>(CreatorByIdDocument, variables),
    ...options
  }
    )};

useCreatorByIdQuery.getKey = (variables: CreatorByIdQueryVariables) => ['CreatorById', variables];

export const useSuspenseCreatorByIdQuery = <
      TData = CreatorByIdQuery,
      TError = unknown
    >(
      variables: CreatorByIdQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CreatorByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CreatorByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CreatorByIdQuery, TError, TData>(
      {
    queryKey: ['CreatorById', variables],
    queryFn: fetchData<CreatorByIdQuery, CreatorByIdQueryVariables>(CreatorByIdDocument, variables),
    ...options
  }
    )};

useSuspenseCreatorByIdQuery.getKey = (variables: CreatorByIdQueryVariables) => ['CreatorById', variables];

export const useInfiniteCreatorByIdQuery = <
      TData = InfiniteData<CreatorByIdQuery>,
      TError = unknown
    >(
      variables: CreatorByIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CreatorByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CreatorByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CreatorByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreatorById.infinite', variables],
      queryFn: (metaData) => fetchData<CreatorByIdQuery, CreatorByIdQueryVariables>(CreatorByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCreatorByIdQuery.getKey = (variables: CreatorByIdQueryVariables) => ['CreatorById.infinite', variables];

export const useSuspenseInfiniteCreatorByIdQuery = <
      TData = InfiniteData<CreatorByIdQuery>,
      TError = unknown
    >(
      variables: CreatorByIdQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CreatorByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CreatorByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CreatorByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreatorById.infinite', variables],
      queryFn: (metaData) => fetchData<CreatorByIdQuery, CreatorByIdQueryVariables>(CreatorByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCreatorByIdQuery.getKey = (variables: CreatorByIdQueryVariables) => ['CreatorById.infinite', variables];


useCreatorByIdQuery.fetcher = (variables: CreatorByIdQueryVariables, options?: RequestInit['headers']) => fetchData<CreatorByIdQuery, CreatorByIdQueryVariables>(CreatorByIdDocument, variables, options);

export const CreatorContractUrlDocument = `
    query CreatorContractUrl($productId: Int!, $creatorId: Int!) {
  creatorContractUrl(productId: $productId, creatorId: $creatorId)
}
    `;

export const useCreatorContractUrlQuery = <
      TData = CreatorContractUrlQuery,
      TError = unknown
    >(
      variables: CreatorContractUrlQueryVariables,
      options?: Omit<UseQueryOptions<CreatorContractUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CreatorContractUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CreatorContractUrlQuery, TError, TData>(
      {
    queryKey: ['CreatorContractUrl', variables],
    queryFn: fetchData<CreatorContractUrlQuery, CreatorContractUrlQueryVariables>(CreatorContractUrlDocument, variables),
    ...options
  }
    )};

useCreatorContractUrlQuery.getKey = (variables: CreatorContractUrlQueryVariables) => ['CreatorContractUrl', variables];

export const useSuspenseCreatorContractUrlQuery = <
      TData = CreatorContractUrlQuery,
      TError = unknown
    >(
      variables: CreatorContractUrlQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CreatorContractUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CreatorContractUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CreatorContractUrlQuery, TError, TData>(
      {
    queryKey: ['CreatorContractUrl', variables],
    queryFn: fetchData<CreatorContractUrlQuery, CreatorContractUrlQueryVariables>(CreatorContractUrlDocument, variables),
    ...options
  }
    )};

useSuspenseCreatorContractUrlQuery.getKey = (variables: CreatorContractUrlQueryVariables) => ['CreatorContractUrl', variables];

export const useInfiniteCreatorContractUrlQuery = <
      TData = InfiniteData<CreatorContractUrlQuery>,
      TError = unknown
    >(
      variables: CreatorContractUrlQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CreatorContractUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CreatorContractUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CreatorContractUrlQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreatorContractUrl.infinite', variables],
      queryFn: (metaData) => fetchData<CreatorContractUrlQuery, CreatorContractUrlQueryVariables>(CreatorContractUrlDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCreatorContractUrlQuery.getKey = (variables: CreatorContractUrlQueryVariables) => ['CreatorContractUrl.infinite', variables];

export const useSuspenseInfiniteCreatorContractUrlQuery = <
      TData = InfiniteData<CreatorContractUrlQuery>,
      TError = unknown
    >(
      variables: CreatorContractUrlQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CreatorContractUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CreatorContractUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CreatorContractUrlQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreatorContractUrl.infinite', variables],
      queryFn: (metaData) => fetchData<CreatorContractUrlQuery, CreatorContractUrlQueryVariables>(CreatorContractUrlDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCreatorContractUrlQuery.getKey = (variables: CreatorContractUrlQueryVariables) => ['CreatorContractUrl.infinite', variables];


useCreatorContractUrlQuery.fetcher = (variables: CreatorContractUrlQueryVariables, options?: RequestInit['headers']) => fetchData<CreatorContractUrlQuery, CreatorContractUrlQueryVariables>(CreatorContractUrlDocument, variables, options);

export const CreatorInfoDocument = `
    query CreatorInfo($creatorId: Int!) {
  creatorById(id: $creatorId) {
    id
    name
    urlStub
    intro
    emailAddress
    paymentMethod
  }
}
    `;

export const useCreatorInfoQuery = <
      TData = CreatorInfoQuery,
      TError = unknown
    >(
      variables: CreatorInfoQueryVariables,
      options?: Omit<UseQueryOptions<CreatorInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CreatorInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CreatorInfoQuery, TError, TData>(
      {
    queryKey: ['CreatorInfo', variables],
    queryFn: fetchData<CreatorInfoQuery, CreatorInfoQueryVariables>(CreatorInfoDocument, variables),
    ...options
  }
    )};

useCreatorInfoQuery.getKey = (variables: CreatorInfoQueryVariables) => ['CreatorInfo', variables];

export const useSuspenseCreatorInfoQuery = <
      TData = CreatorInfoQuery,
      TError = unknown
    >(
      variables: CreatorInfoQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CreatorInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CreatorInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CreatorInfoQuery, TError, TData>(
      {
    queryKey: ['CreatorInfo', variables],
    queryFn: fetchData<CreatorInfoQuery, CreatorInfoQueryVariables>(CreatorInfoDocument, variables),
    ...options
  }
    )};

useSuspenseCreatorInfoQuery.getKey = (variables: CreatorInfoQueryVariables) => ['CreatorInfo', variables];

export const useInfiniteCreatorInfoQuery = <
      TData = InfiniteData<CreatorInfoQuery>,
      TError = unknown
    >(
      variables: CreatorInfoQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CreatorInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CreatorInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CreatorInfoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreatorInfo.infinite', variables],
      queryFn: (metaData) => fetchData<CreatorInfoQuery, CreatorInfoQueryVariables>(CreatorInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCreatorInfoQuery.getKey = (variables: CreatorInfoQueryVariables) => ['CreatorInfo.infinite', variables];

export const useSuspenseInfiniteCreatorInfoQuery = <
      TData = InfiniteData<CreatorInfoQuery>,
      TError = unknown
    >(
      variables: CreatorInfoQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CreatorInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CreatorInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CreatorInfoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreatorInfo.infinite', variables],
      queryFn: (metaData) => fetchData<CreatorInfoQuery, CreatorInfoQueryVariables>(CreatorInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCreatorInfoQuery.getKey = (variables: CreatorInfoQueryVariables) => ['CreatorInfo.infinite', variables];


useCreatorInfoQuery.fetcher = (variables: CreatorInfoQueryVariables, options?: RequestInit['headers']) => fetchData<CreatorInfoQuery, CreatorInfoQueryVariables>(CreatorInfoDocument, variables, options);

export const CreatorOwedStatementDocument = `
    query CreatorOwedStatement($creatorId: Int!) {
  creatorOwedStatement(creatorId: $creatorId) {
    productId
    optionId
    productName
    productUrlStub
    thumbnailUrl
    optionDescription
    displayName
    isDownload
    isGrossPayment
    lastPaymentDate
    retailUnits
    wholesaleUnits
    retailRoyalties
    wholesaleRoyalties
    totalRoyalties
    priorMonthBalance
    newExpenses
    totalPayable
    notes
  }
}
    `;

export const useCreatorOwedStatementQuery = <
      TData = CreatorOwedStatementQuery,
      TError = unknown
    >(
      variables: CreatorOwedStatementQueryVariables,
      options?: Omit<UseQueryOptions<CreatorOwedStatementQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CreatorOwedStatementQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CreatorOwedStatementQuery, TError, TData>(
      {
    queryKey: ['CreatorOwedStatement', variables],
    queryFn: fetchData<CreatorOwedStatementQuery, CreatorOwedStatementQueryVariables>(CreatorOwedStatementDocument, variables),
    ...options
  }
    )};

useCreatorOwedStatementQuery.getKey = (variables: CreatorOwedStatementQueryVariables) => ['CreatorOwedStatement', variables];

export const useSuspenseCreatorOwedStatementQuery = <
      TData = CreatorOwedStatementQuery,
      TError = unknown
    >(
      variables: CreatorOwedStatementQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CreatorOwedStatementQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CreatorOwedStatementQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CreatorOwedStatementQuery, TError, TData>(
      {
    queryKey: ['CreatorOwedStatement', variables],
    queryFn: fetchData<CreatorOwedStatementQuery, CreatorOwedStatementQueryVariables>(CreatorOwedStatementDocument, variables),
    ...options
  }
    )};

useSuspenseCreatorOwedStatementQuery.getKey = (variables: CreatorOwedStatementQueryVariables) => ['CreatorOwedStatement', variables];

export const useInfiniteCreatorOwedStatementQuery = <
      TData = InfiniteData<CreatorOwedStatementQuery>,
      TError = unknown
    >(
      variables: CreatorOwedStatementQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CreatorOwedStatementQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CreatorOwedStatementQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CreatorOwedStatementQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreatorOwedStatement.infinite', variables],
      queryFn: (metaData) => fetchData<CreatorOwedStatementQuery, CreatorOwedStatementQueryVariables>(CreatorOwedStatementDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCreatorOwedStatementQuery.getKey = (variables: CreatorOwedStatementQueryVariables) => ['CreatorOwedStatement.infinite', variables];

export const useSuspenseInfiniteCreatorOwedStatementQuery = <
      TData = InfiniteData<CreatorOwedStatementQuery>,
      TError = unknown
    >(
      variables: CreatorOwedStatementQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CreatorOwedStatementQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CreatorOwedStatementQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CreatorOwedStatementQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreatorOwedStatement.infinite', variables],
      queryFn: (metaData) => fetchData<CreatorOwedStatementQuery, CreatorOwedStatementQueryVariables>(CreatorOwedStatementDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCreatorOwedStatementQuery.getKey = (variables: CreatorOwedStatementQueryVariables) => ['CreatorOwedStatement.infinite', variables];


useCreatorOwedStatementQuery.fetcher = (variables: CreatorOwedStatementQueryVariables, options?: RequestInit['headers']) => fetchData<CreatorOwedStatementQuery, CreatorOwedStatementQueryVariables>(CreatorOwedStatementDocument, variables, options);

export const CreatorPaymentByIdDocument = `
    query CreatorPaymentById($id: Int!) {
  creatorPaymentById(id: $id) {
    id
    creatorId
    datePaid
    amount
    method
    description
    dateProcessed
  }
}
    `;

export const useCreatorPaymentByIdQuery = <
      TData = CreatorPaymentByIdQuery,
      TError = unknown
    >(
      variables: CreatorPaymentByIdQueryVariables,
      options?: Omit<UseQueryOptions<CreatorPaymentByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CreatorPaymentByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CreatorPaymentByIdQuery, TError, TData>(
      {
    queryKey: ['CreatorPaymentById', variables],
    queryFn: fetchData<CreatorPaymentByIdQuery, CreatorPaymentByIdQueryVariables>(CreatorPaymentByIdDocument, variables),
    ...options
  }
    )};

useCreatorPaymentByIdQuery.getKey = (variables: CreatorPaymentByIdQueryVariables) => ['CreatorPaymentById', variables];

export const useSuspenseCreatorPaymentByIdQuery = <
      TData = CreatorPaymentByIdQuery,
      TError = unknown
    >(
      variables: CreatorPaymentByIdQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CreatorPaymentByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CreatorPaymentByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CreatorPaymentByIdQuery, TError, TData>(
      {
    queryKey: ['CreatorPaymentById', variables],
    queryFn: fetchData<CreatorPaymentByIdQuery, CreatorPaymentByIdQueryVariables>(CreatorPaymentByIdDocument, variables),
    ...options
  }
    )};

useSuspenseCreatorPaymentByIdQuery.getKey = (variables: CreatorPaymentByIdQueryVariables) => ['CreatorPaymentById', variables];

export const useInfiniteCreatorPaymentByIdQuery = <
      TData = InfiniteData<CreatorPaymentByIdQuery>,
      TError = unknown
    >(
      variables: CreatorPaymentByIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CreatorPaymentByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CreatorPaymentByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CreatorPaymentByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreatorPaymentById.infinite', variables],
      queryFn: (metaData) => fetchData<CreatorPaymentByIdQuery, CreatorPaymentByIdQueryVariables>(CreatorPaymentByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCreatorPaymentByIdQuery.getKey = (variables: CreatorPaymentByIdQueryVariables) => ['CreatorPaymentById.infinite', variables];

export const useSuspenseInfiniteCreatorPaymentByIdQuery = <
      TData = InfiniteData<CreatorPaymentByIdQuery>,
      TError = unknown
    >(
      variables: CreatorPaymentByIdQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CreatorPaymentByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CreatorPaymentByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CreatorPaymentByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreatorPaymentById.infinite', variables],
      queryFn: (metaData) => fetchData<CreatorPaymentByIdQuery, CreatorPaymentByIdQueryVariables>(CreatorPaymentByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCreatorPaymentByIdQuery.getKey = (variables: CreatorPaymentByIdQueryVariables) => ['CreatorPaymentById.infinite', variables];


useCreatorPaymentByIdQuery.fetcher = (variables: CreatorPaymentByIdQueryVariables, options?: RequestInit['headers']) => fetchData<CreatorPaymentByIdQuery, CreatorPaymentByIdQueryVariables>(CreatorPaymentByIdDocument, variables, options);

export const CreatorPaymentsDocument = `
    query CreatorPayments($creatorId: Int!) {
  paymentsForCreator(creatorId: $creatorId) {
    id
    creatorId
    datePaid
    amount
    method
    description
    dateProcessed
  }
}
    `;

export const useCreatorPaymentsQuery = <
      TData = CreatorPaymentsQuery,
      TError = unknown
    >(
      variables: CreatorPaymentsQueryVariables,
      options?: Omit<UseQueryOptions<CreatorPaymentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CreatorPaymentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CreatorPaymentsQuery, TError, TData>(
      {
    queryKey: ['CreatorPayments', variables],
    queryFn: fetchData<CreatorPaymentsQuery, CreatorPaymentsQueryVariables>(CreatorPaymentsDocument, variables),
    ...options
  }
    )};

useCreatorPaymentsQuery.getKey = (variables: CreatorPaymentsQueryVariables) => ['CreatorPayments', variables];

export const useSuspenseCreatorPaymentsQuery = <
      TData = CreatorPaymentsQuery,
      TError = unknown
    >(
      variables: CreatorPaymentsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CreatorPaymentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CreatorPaymentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CreatorPaymentsQuery, TError, TData>(
      {
    queryKey: ['CreatorPayments', variables],
    queryFn: fetchData<CreatorPaymentsQuery, CreatorPaymentsQueryVariables>(CreatorPaymentsDocument, variables),
    ...options
  }
    )};

useSuspenseCreatorPaymentsQuery.getKey = (variables: CreatorPaymentsQueryVariables) => ['CreatorPayments', variables];

export const useInfiniteCreatorPaymentsQuery = <
      TData = InfiniteData<CreatorPaymentsQuery>,
      TError = unknown
    >(
      variables: CreatorPaymentsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CreatorPaymentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CreatorPaymentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CreatorPaymentsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreatorPayments.infinite', variables],
      queryFn: (metaData) => fetchData<CreatorPaymentsQuery, CreatorPaymentsQueryVariables>(CreatorPaymentsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCreatorPaymentsQuery.getKey = (variables: CreatorPaymentsQueryVariables) => ['CreatorPayments.infinite', variables];

export const useSuspenseInfiniteCreatorPaymentsQuery = <
      TData = InfiniteData<CreatorPaymentsQuery>,
      TError = unknown
    >(
      variables: CreatorPaymentsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CreatorPaymentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CreatorPaymentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CreatorPaymentsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreatorPayments.infinite', variables],
      queryFn: (metaData) => fetchData<CreatorPaymentsQuery, CreatorPaymentsQueryVariables>(CreatorPaymentsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCreatorPaymentsQuery.getKey = (variables: CreatorPaymentsQueryVariables) => ['CreatorPayments.infinite', variables];


useCreatorPaymentsQuery.fetcher = (variables: CreatorPaymentsQueryVariables, options?: RequestInit['headers']) => fetchData<CreatorPaymentsQuery, CreatorPaymentsQueryVariables>(CreatorPaymentsDocument, variables, options);

export const CreatorProductByIdDocument = `
    query CreatorProductById($productId: Int!, $creatorId: Int!, $optionId: Int) {
  creatorProductById(
    productId: $productId
    creatorId: $creatorId
    optionId: $optionId
  ) {
    id
    name
    urlStub
    thumbnailUrl
    percentageToCreator
    payPerUnit
    meta {
      id
      key
      value
    }
  }
}
    `;

export const useCreatorProductByIdQuery = <
      TData = CreatorProductByIdQuery,
      TError = unknown
    >(
      variables: CreatorProductByIdQueryVariables,
      options?: Omit<UseQueryOptions<CreatorProductByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CreatorProductByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CreatorProductByIdQuery, TError, TData>(
      {
    queryKey: ['CreatorProductById', variables],
    queryFn: fetchData<CreatorProductByIdQuery, CreatorProductByIdQueryVariables>(CreatorProductByIdDocument, variables),
    ...options
  }
    )};

useCreatorProductByIdQuery.getKey = (variables: CreatorProductByIdQueryVariables) => ['CreatorProductById', variables];

export const useSuspenseCreatorProductByIdQuery = <
      TData = CreatorProductByIdQuery,
      TError = unknown
    >(
      variables: CreatorProductByIdQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CreatorProductByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CreatorProductByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CreatorProductByIdQuery, TError, TData>(
      {
    queryKey: ['CreatorProductById', variables],
    queryFn: fetchData<CreatorProductByIdQuery, CreatorProductByIdQueryVariables>(CreatorProductByIdDocument, variables),
    ...options
  }
    )};

useSuspenseCreatorProductByIdQuery.getKey = (variables: CreatorProductByIdQueryVariables) => ['CreatorProductById', variables];

export const useInfiniteCreatorProductByIdQuery = <
      TData = InfiniteData<CreatorProductByIdQuery>,
      TError = unknown
    >(
      variables: CreatorProductByIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CreatorProductByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CreatorProductByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CreatorProductByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreatorProductById.infinite', variables],
      queryFn: (metaData) => fetchData<CreatorProductByIdQuery, CreatorProductByIdQueryVariables>(CreatorProductByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCreatorProductByIdQuery.getKey = (variables: CreatorProductByIdQueryVariables) => ['CreatorProductById.infinite', variables];

export const useSuspenseInfiniteCreatorProductByIdQuery = <
      TData = InfiniteData<CreatorProductByIdQuery>,
      TError = unknown
    >(
      variables: CreatorProductByIdQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CreatorProductByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CreatorProductByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CreatorProductByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreatorProductById.infinite', variables],
      queryFn: (metaData) => fetchData<CreatorProductByIdQuery, CreatorProductByIdQueryVariables>(CreatorProductByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCreatorProductByIdQuery.getKey = (variables: CreatorProductByIdQueryVariables) => ['CreatorProductById.infinite', variables];


useCreatorProductByIdQuery.fetcher = (variables: CreatorProductByIdQueryVariables, options?: RequestInit['headers']) => fetchData<CreatorProductByIdQuery, CreatorProductByIdQueryVariables>(CreatorProductByIdDocument, variables, options);

export const CreatorProductsDocument = `
    query CreatorProducts($creatorId: Int!) {
  productsThatRequireCreatorPayment(creatorId: $creatorId) {
    productId
    optionId
    displayName
    productName
    optionDescription
    productUrlStub
    thumbnailUrl
  }
}
    `;

export const useCreatorProductsQuery = <
      TData = CreatorProductsQuery,
      TError = unknown
    >(
      variables: CreatorProductsQueryVariables,
      options?: Omit<UseQueryOptions<CreatorProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CreatorProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CreatorProductsQuery, TError, TData>(
      {
    queryKey: ['CreatorProducts', variables],
    queryFn: fetchData<CreatorProductsQuery, CreatorProductsQueryVariables>(CreatorProductsDocument, variables),
    ...options
  }
    )};

useCreatorProductsQuery.getKey = (variables: CreatorProductsQueryVariables) => ['CreatorProducts', variables];

export const useSuspenseCreatorProductsQuery = <
      TData = CreatorProductsQuery,
      TError = unknown
    >(
      variables: CreatorProductsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CreatorProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CreatorProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CreatorProductsQuery, TError, TData>(
      {
    queryKey: ['CreatorProducts', variables],
    queryFn: fetchData<CreatorProductsQuery, CreatorProductsQueryVariables>(CreatorProductsDocument, variables),
    ...options
  }
    )};

useSuspenseCreatorProductsQuery.getKey = (variables: CreatorProductsQueryVariables) => ['CreatorProducts', variables];

export const useInfiniteCreatorProductsQuery = <
      TData = InfiniteData<CreatorProductsQuery>,
      TError = unknown
    >(
      variables: CreatorProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CreatorProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CreatorProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CreatorProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreatorProducts.infinite', variables],
      queryFn: (metaData) => fetchData<CreatorProductsQuery, CreatorProductsQueryVariables>(CreatorProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCreatorProductsQuery.getKey = (variables: CreatorProductsQueryVariables) => ['CreatorProducts.infinite', variables];

export const useSuspenseInfiniteCreatorProductsQuery = <
      TData = InfiniteData<CreatorProductsQuery>,
      TError = unknown
    >(
      variables: CreatorProductsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CreatorProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CreatorProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CreatorProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreatorProducts.infinite', variables],
      queryFn: (metaData) => fetchData<CreatorProductsQuery, CreatorProductsQueryVariables>(CreatorProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCreatorProductsQuery.getKey = (variables: CreatorProductsQueryVariables) => ['CreatorProducts.infinite', variables];


useCreatorProductsQuery.fetcher = (variables: CreatorProductsQueryVariables, options?: RequestInit['headers']) => fetchData<CreatorProductsQuery, CreatorProductsQueryVariables>(CreatorProductsDocument, variables, options);

export const CreatorSystemMessageDocument = `
    query CreatorSystemMessage($id: Int!) {
  blogPostById(id: $id) {
    id
    content
  }
}
    `;

export const useCreatorSystemMessageQuery = <
      TData = CreatorSystemMessageQuery,
      TError = unknown
    >(
      variables: CreatorSystemMessageQueryVariables,
      options?: Omit<UseQueryOptions<CreatorSystemMessageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CreatorSystemMessageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CreatorSystemMessageQuery, TError, TData>(
      {
    queryKey: ['CreatorSystemMessage', variables],
    queryFn: fetchData<CreatorSystemMessageQuery, CreatorSystemMessageQueryVariables>(CreatorSystemMessageDocument, variables),
    ...options
  }
    )};

useCreatorSystemMessageQuery.getKey = (variables: CreatorSystemMessageQueryVariables) => ['CreatorSystemMessage', variables];

export const useSuspenseCreatorSystemMessageQuery = <
      TData = CreatorSystemMessageQuery,
      TError = unknown
    >(
      variables: CreatorSystemMessageQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CreatorSystemMessageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CreatorSystemMessageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CreatorSystemMessageQuery, TError, TData>(
      {
    queryKey: ['CreatorSystemMessage', variables],
    queryFn: fetchData<CreatorSystemMessageQuery, CreatorSystemMessageQueryVariables>(CreatorSystemMessageDocument, variables),
    ...options
  }
    )};

useSuspenseCreatorSystemMessageQuery.getKey = (variables: CreatorSystemMessageQueryVariables) => ['CreatorSystemMessage', variables];

export const useInfiniteCreatorSystemMessageQuery = <
      TData = InfiniteData<CreatorSystemMessageQuery>,
      TError = unknown
    >(
      variables: CreatorSystemMessageQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CreatorSystemMessageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CreatorSystemMessageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CreatorSystemMessageQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreatorSystemMessage.infinite', variables],
      queryFn: (metaData) => fetchData<CreatorSystemMessageQuery, CreatorSystemMessageQueryVariables>(CreatorSystemMessageDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCreatorSystemMessageQuery.getKey = (variables: CreatorSystemMessageQueryVariables) => ['CreatorSystemMessage.infinite', variables];

export const useSuspenseInfiniteCreatorSystemMessageQuery = <
      TData = InfiniteData<CreatorSystemMessageQuery>,
      TError = unknown
    >(
      variables: CreatorSystemMessageQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CreatorSystemMessageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CreatorSystemMessageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CreatorSystemMessageQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CreatorSystemMessage.infinite', variables],
      queryFn: (metaData) => fetchData<CreatorSystemMessageQuery, CreatorSystemMessageQueryVariables>(CreatorSystemMessageDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCreatorSystemMessageQuery.getKey = (variables: CreatorSystemMessageQueryVariables) => ['CreatorSystemMessage.infinite', variables];


useCreatorSystemMessageQuery.fetcher = (variables: CreatorSystemMessageQueryVariables, options?: RequestInit['headers']) => fetchData<CreatorSystemMessageQuery, CreatorSystemMessageQueryVariables>(CreatorSystemMessageDocument, variables, options);

export const FinanceLogForProductDocument = `
    query FinanceLogForProduct($productId: Int!, $optionId: Int, $creatorId: Int!) {
  financeLogForProduct(
    productId: $productId
    optionId: $optionId
    creatorId: $creatorId
  ) {
    productId
    productName
    optionId
    optionDescription
    percentageToCreator
    isGrossPayment
    profit
    amountPaid
    amountOwed
    footerText
    items {
      date
      quantity
      category
      description
      amount
      isInternal
    }
  }
}
    `;

export const useFinanceLogForProductQuery = <
      TData = FinanceLogForProductQuery,
      TError = unknown
    >(
      variables: FinanceLogForProductQueryVariables,
      options?: Omit<UseQueryOptions<FinanceLogForProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FinanceLogForProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FinanceLogForProductQuery, TError, TData>(
      {
    queryKey: ['FinanceLogForProduct', variables],
    queryFn: fetchData<FinanceLogForProductQuery, FinanceLogForProductQueryVariables>(FinanceLogForProductDocument, variables),
    ...options
  }
    )};

useFinanceLogForProductQuery.getKey = (variables: FinanceLogForProductQueryVariables) => ['FinanceLogForProduct', variables];

export const useSuspenseFinanceLogForProductQuery = <
      TData = FinanceLogForProductQuery,
      TError = unknown
    >(
      variables: FinanceLogForProductQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<FinanceLogForProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<FinanceLogForProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<FinanceLogForProductQuery, TError, TData>(
      {
    queryKey: ['FinanceLogForProduct', variables],
    queryFn: fetchData<FinanceLogForProductQuery, FinanceLogForProductQueryVariables>(FinanceLogForProductDocument, variables),
    ...options
  }
    )};

useSuspenseFinanceLogForProductQuery.getKey = (variables: FinanceLogForProductQueryVariables) => ['FinanceLogForProduct', variables];

export const useInfiniteFinanceLogForProductQuery = <
      TData = InfiniteData<FinanceLogForProductQuery>,
      TError = unknown
    >(
      variables: FinanceLogForProductQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FinanceLogForProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FinanceLogForProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<FinanceLogForProductQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FinanceLogForProduct.infinite', variables],
      queryFn: (metaData) => fetchData<FinanceLogForProductQuery, FinanceLogForProductQueryVariables>(FinanceLogForProductDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteFinanceLogForProductQuery.getKey = (variables: FinanceLogForProductQueryVariables) => ['FinanceLogForProduct.infinite', variables];

export const useSuspenseInfiniteFinanceLogForProductQuery = <
      TData = InfiniteData<FinanceLogForProductQuery>,
      TError = unknown
    >(
      variables: FinanceLogForProductQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<FinanceLogForProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<FinanceLogForProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<FinanceLogForProductQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FinanceLogForProduct.infinite', variables],
      queryFn: (metaData) => fetchData<FinanceLogForProductQuery, FinanceLogForProductQueryVariables>(FinanceLogForProductDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteFinanceLogForProductQuery.getKey = (variables: FinanceLogForProductQueryVariables) => ['FinanceLogForProduct.infinite', variables];


useFinanceLogForProductQuery.fetcher = (variables: FinanceLogForProductQueryVariables, options?: RequestInit['headers']) => fetchData<FinanceLogForProductQuery, FinanceLogForProductQueryVariables>(FinanceLogForProductDocument, variables, options);

export const MagicianDocument = `
    query Magician($magicianSlug: String!) {
  creatorBySlug(slug: $magicianSlug) {
    id
    name
    urlStub
    intro
  }
}
    `;

export const useMagicianQuery = <
      TData = MagicianQuery,
      TError = unknown
    >(
      variables: MagicianQueryVariables,
      options?: Omit<UseQueryOptions<MagicianQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MagicianQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MagicianQuery, TError, TData>(
      {
    queryKey: ['Magician', variables],
    queryFn: fetchData<MagicianQuery, MagicianQueryVariables>(MagicianDocument, variables),
    ...options
  }
    )};

useMagicianQuery.getKey = (variables: MagicianQueryVariables) => ['Magician', variables];

export const useSuspenseMagicianQuery = <
      TData = MagicianQuery,
      TError = unknown
    >(
      variables: MagicianQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MagicianQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MagicianQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MagicianQuery, TError, TData>(
      {
    queryKey: ['Magician', variables],
    queryFn: fetchData<MagicianQuery, MagicianQueryVariables>(MagicianDocument, variables),
    ...options
  }
    )};

useSuspenseMagicianQuery.getKey = (variables: MagicianQueryVariables) => ['Magician', variables];

export const useInfiniteMagicianQuery = <
      TData = InfiniteData<MagicianQuery>,
      TError = unknown
    >(
      variables: MagicianQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MagicianQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MagicianQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<MagicianQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Magician.infinite', variables],
      queryFn: (metaData) => fetchData<MagicianQuery, MagicianQueryVariables>(MagicianDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMagicianQuery.getKey = (variables: MagicianQueryVariables) => ['Magician.infinite', variables];

export const useSuspenseInfiniteMagicianQuery = <
      TData = InfiniteData<MagicianQuery>,
      TError = unknown
    >(
      variables: MagicianQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<MagicianQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<MagicianQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<MagicianQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Magician.infinite', variables],
      queryFn: (metaData) => fetchData<MagicianQuery, MagicianQueryVariables>(MagicianDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteMagicianQuery.getKey = (variables: MagicianQueryVariables) => ['Magician.infinite', variables];


useMagicianQuery.fetcher = (variables: MagicianQueryVariables, options?: RequestInit['headers']) => fetchData<MagicianQuery, MagicianQueryVariables>(MagicianDocument, variables, options);

export const MagicianProductsDocument = `
    query MagicianProducts($magicianSlug: String!, $take: Int!, $skip: Int!, $brandCode: String!, $maxBlurbLength: Int!, $order: [ProductByCategorySort!]) {
  productsByCreatorSlug(
    skip: $skip
    take: $take
    brandCode: $brandCode
    maxBlurbLength: $maxBlurbLength
    creatorSlug: $magicianSlug
    order: $order
  ) {
    totalCount
    items {
      id
      name
      url
      blurb
      hasDownloads
      thumbnails {
        default
        video
      }
      displayPrice
      vanishingIncExclusive
      options {
        id
        description
        price
        salePrice
        priceIncVat
        salePriceIncVat
        taxType
        inStock
        productType {
          id
          name
        }
        currency {
          symbol
        }
      }
      productType {
        name
        id
      }
      creators {
        id
        name
        urlStub
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

export const useMagicianProductsQuery = <
      TData = MagicianProductsQuery,
      TError = unknown
    >(
      variables: MagicianProductsQueryVariables,
      options?: Omit<UseQueryOptions<MagicianProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MagicianProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MagicianProductsQuery, TError, TData>(
      {
    queryKey: ['MagicianProducts', variables],
    queryFn: fetchData<MagicianProductsQuery, MagicianProductsQueryVariables>(MagicianProductsDocument, variables),
    ...options
  }
    )};

useMagicianProductsQuery.getKey = (variables: MagicianProductsQueryVariables) => ['MagicianProducts', variables];

export const useSuspenseMagicianProductsQuery = <
      TData = MagicianProductsQuery,
      TError = unknown
    >(
      variables: MagicianProductsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MagicianProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MagicianProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MagicianProductsQuery, TError, TData>(
      {
    queryKey: ['MagicianProducts', variables],
    queryFn: fetchData<MagicianProductsQuery, MagicianProductsQueryVariables>(MagicianProductsDocument, variables),
    ...options
  }
    )};

useSuspenseMagicianProductsQuery.getKey = (variables: MagicianProductsQueryVariables) => ['MagicianProducts', variables];

export const useInfiniteMagicianProductsQuery = <
      TData = InfiniteData<MagicianProductsQuery>,
      TError = unknown
    >(
      variables: MagicianProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MagicianProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MagicianProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<MagicianProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MagicianProducts.infinite', variables],
      queryFn: (metaData) => fetchData<MagicianProductsQuery, MagicianProductsQueryVariables>(MagicianProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMagicianProductsQuery.getKey = (variables: MagicianProductsQueryVariables) => ['MagicianProducts.infinite', variables];

export const useSuspenseInfiniteMagicianProductsQuery = <
      TData = InfiniteData<MagicianProductsQuery>,
      TError = unknown
    >(
      variables: MagicianProductsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<MagicianProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<MagicianProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<MagicianProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MagicianProducts.infinite', variables],
      queryFn: (metaData) => fetchData<MagicianProductsQuery, MagicianProductsQueryVariables>(MagicianProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteMagicianProductsQuery.getKey = (variables: MagicianProductsQueryVariables) => ['MagicianProducts.infinite', variables];


useMagicianProductsQuery.fetcher = (variables: MagicianProductsQueryVariables, options?: RequestInit['headers']) => fetchData<MagicianProductsQuery, MagicianProductsQueryVariables>(MagicianProductsDocument, variables, options);

export const PaymentLogsForCreatorPaymentDocument = `
    query PaymentLogsForCreatorPayment($creatorPaymentId: Int!) {
  paymentLogsForCreatorPayment(creatorPaymentId: $creatorPaymentId) {
    id
    creatorPaymentId
    productId
    total
    brandId
    productOptionId
    productName
    productThumbnailUrl
    productUrlStub
    productOptionDescription
    isDownload
    salesCount
    retailSalesCount
    wholesaleSalesCount
    productMeta {
      id
      key
      value
    }
  }
}
    `;

export const usePaymentLogsForCreatorPaymentQuery = <
      TData = PaymentLogsForCreatorPaymentQuery,
      TError = unknown
    >(
      variables: PaymentLogsForCreatorPaymentQueryVariables,
      options?: Omit<UseQueryOptions<PaymentLogsForCreatorPaymentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PaymentLogsForCreatorPaymentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PaymentLogsForCreatorPaymentQuery, TError, TData>(
      {
    queryKey: ['PaymentLogsForCreatorPayment', variables],
    queryFn: fetchData<PaymentLogsForCreatorPaymentQuery, PaymentLogsForCreatorPaymentQueryVariables>(PaymentLogsForCreatorPaymentDocument, variables),
    ...options
  }
    )};

usePaymentLogsForCreatorPaymentQuery.getKey = (variables: PaymentLogsForCreatorPaymentQueryVariables) => ['PaymentLogsForCreatorPayment', variables];

export const useSuspensePaymentLogsForCreatorPaymentQuery = <
      TData = PaymentLogsForCreatorPaymentQuery,
      TError = unknown
    >(
      variables: PaymentLogsForCreatorPaymentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<PaymentLogsForCreatorPaymentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<PaymentLogsForCreatorPaymentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<PaymentLogsForCreatorPaymentQuery, TError, TData>(
      {
    queryKey: ['PaymentLogsForCreatorPayment', variables],
    queryFn: fetchData<PaymentLogsForCreatorPaymentQuery, PaymentLogsForCreatorPaymentQueryVariables>(PaymentLogsForCreatorPaymentDocument, variables),
    ...options
  }
    )};

useSuspensePaymentLogsForCreatorPaymentQuery.getKey = (variables: PaymentLogsForCreatorPaymentQueryVariables) => ['PaymentLogsForCreatorPayment', variables];

export const useInfinitePaymentLogsForCreatorPaymentQuery = <
      TData = InfiniteData<PaymentLogsForCreatorPaymentQuery>,
      TError = unknown
    >(
      variables: PaymentLogsForCreatorPaymentQueryVariables,
      options: Omit<UseInfiniteQueryOptions<PaymentLogsForCreatorPaymentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<PaymentLogsForCreatorPaymentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<PaymentLogsForCreatorPaymentQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['PaymentLogsForCreatorPayment.infinite', variables],
      queryFn: (metaData) => fetchData<PaymentLogsForCreatorPaymentQuery, PaymentLogsForCreatorPaymentQueryVariables>(PaymentLogsForCreatorPaymentDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfinitePaymentLogsForCreatorPaymentQuery.getKey = (variables: PaymentLogsForCreatorPaymentQueryVariables) => ['PaymentLogsForCreatorPayment.infinite', variables];

export const useSuspenseInfinitePaymentLogsForCreatorPaymentQuery = <
      TData = InfiniteData<PaymentLogsForCreatorPaymentQuery>,
      TError = unknown
    >(
      variables: PaymentLogsForCreatorPaymentQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<PaymentLogsForCreatorPaymentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<PaymentLogsForCreatorPaymentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<PaymentLogsForCreatorPaymentQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['PaymentLogsForCreatorPayment.infinite', variables],
      queryFn: (metaData) => fetchData<PaymentLogsForCreatorPaymentQuery, PaymentLogsForCreatorPaymentQueryVariables>(PaymentLogsForCreatorPaymentDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfinitePaymentLogsForCreatorPaymentQuery.getKey = (variables: PaymentLogsForCreatorPaymentQueryVariables) => ['PaymentLogsForCreatorPayment.infinite', variables];


usePaymentLogsForCreatorPaymentQuery.fetcher = (variables: PaymentLogsForCreatorPaymentQueryVariables, options?: RequestInit['headers']) => fetchData<PaymentLogsForCreatorPaymentQuery, PaymentLogsForCreatorPaymentQueryVariables>(PaymentLogsForCreatorPaymentDocument, variables, options);

export const PaymentLogsForProductAndCreatorDocument = `
    query PaymentLogsForProductAndCreator($productId: Int!, $creatorId: Int!) {
  paymentLogsForProductAndCreator(productId: $productId, creatorId: $creatorId) {
    id
    creatorPaymentId
    productId
    total
    brandId
    productOptionId
    productName
    productThumbnailUrl
    productUrlStub
    productOptionDescription
    productMeta {
      id
      key
      value
    }
    paymentDatePaid
    paymentMethod
  }
}
    `;

export const usePaymentLogsForProductAndCreatorQuery = <
      TData = PaymentLogsForProductAndCreatorQuery,
      TError = unknown
    >(
      variables: PaymentLogsForProductAndCreatorQueryVariables,
      options?: Omit<UseQueryOptions<PaymentLogsForProductAndCreatorQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PaymentLogsForProductAndCreatorQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PaymentLogsForProductAndCreatorQuery, TError, TData>(
      {
    queryKey: ['PaymentLogsForProductAndCreator', variables],
    queryFn: fetchData<PaymentLogsForProductAndCreatorQuery, PaymentLogsForProductAndCreatorQueryVariables>(PaymentLogsForProductAndCreatorDocument, variables),
    ...options
  }
    )};

usePaymentLogsForProductAndCreatorQuery.getKey = (variables: PaymentLogsForProductAndCreatorQueryVariables) => ['PaymentLogsForProductAndCreator', variables];

export const useSuspensePaymentLogsForProductAndCreatorQuery = <
      TData = PaymentLogsForProductAndCreatorQuery,
      TError = unknown
    >(
      variables: PaymentLogsForProductAndCreatorQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<PaymentLogsForProductAndCreatorQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<PaymentLogsForProductAndCreatorQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<PaymentLogsForProductAndCreatorQuery, TError, TData>(
      {
    queryKey: ['PaymentLogsForProductAndCreator', variables],
    queryFn: fetchData<PaymentLogsForProductAndCreatorQuery, PaymentLogsForProductAndCreatorQueryVariables>(PaymentLogsForProductAndCreatorDocument, variables),
    ...options
  }
    )};

useSuspensePaymentLogsForProductAndCreatorQuery.getKey = (variables: PaymentLogsForProductAndCreatorQueryVariables) => ['PaymentLogsForProductAndCreator', variables];

export const useInfinitePaymentLogsForProductAndCreatorQuery = <
      TData = InfiniteData<PaymentLogsForProductAndCreatorQuery>,
      TError = unknown
    >(
      variables: PaymentLogsForProductAndCreatorQueryVariables,
      options: Omit<UseInfiniteQueryOptions<PaymentLogsForProductAndCreatorQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<PaymentLogsForProductAndCreatorQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<PaymentLogsForProductAndCreatorQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['PaymentLogsForProductAndCreator.infinite', variables],
      queryFn: (metaData) => fetchData<PaymentLogsForProductAndCreatorQuery, PaymentLogsForProductAndCreatorQueryVariables>(PaymentLogsForProductAndCreatorDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfinitePaymentLogsForProductAndCreatorQuery.getKey = (variables: PaymentLogsForProductAndCreatorQueryVariables) => ['PaymentLogsForProductAndCreator.infinite', variables];

export const useSuspenseInfinitePaymentLogsForProductAndCreatorQuery = <
      TData = InfiniteData<PaymentLogsForProductAndCreatorQuery>,
      TError = unknown
    >(
      variables: PaymentLogsForProductAndCreatorQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<PaymentLogsForProductAndCreatorQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<PaymentLogsForProductAndCreatorQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<PaymentLogsForProductAndCreatorQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['PaymentLogsForProductAndCreator.infinite', variables],
      queryFn: (metaData) => fetchData<PaymentLogsForProductAndCreatorQuery, PaymentLogsForProductAndCreatorQueryVariables>(PaymentLogsForProductAndCreatorDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfinitePaymentLogsForProductAndCreatorQuery.getKey = (variables: PaymentLogsForProductAndCreatorQueryVariables) => ['PaymentLogsForProductAndCreator.infinite', variables];


usePaymentLogsForProductAndCreatorQuery.fetcher = (variables: PaymentLogsForProductAndCreatorQueryVariables, options?: RequestInit['headers']) => fetchData<PaymentLogsForProductAndCreatorQuery, PaymentLogsForProductAndCreatorQueryVariables>(PaymentLogsForProductAndCreatorDocument, variables, options);

export const ProductsWithAmountsOwedDocument = `
    query ProductsWithAmountsOwed($creatorId: Int!) {
  productsWithAmountsOwed(creatorId: $creatorId) {
    productId
    productName
    productUrlStub
    thumbnailUrl
    optionId
    optionDescription
    isDownload
    isGrossPayment
    amount
    retailAmount
    wholesaleAmount
    salesCount
    retailSalesCount
    wholesaleSalesCount
    notes
  }
}
    `;

export const useProductsWithAmountsOwedQuery = <
      TData = ProductsWithAmountsOwedQuery,
      TError = unknown
    >(
      variables: ProductsWithAmountsOwedQueryVariables,
      options?: Omit<UseQueryOptions<ProductsWithAmountsOwedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProductsWithAmountsOwedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProductsWithAmountsOwedQuery, TError, TData>(
      {
    queryKey: ['ProductsWithAmountsOwed', variables],
    queryFn: fetchData<ProductsWithAmountsOwedQuery, ProductsWithAmountsOwedQueryVariables>(ProductsWithAmountsOwedDocument, variables),
    ...options
  }
    )};

useProductsWithAmountsOwedQuery.getKey = (variables: ProductsWithAmountsOwedQueryVariables) => ['ProductsWithAmountsOwed', variables];

export const useSuspenseProductsWithAmountsOwedQuery = <
      TData = ProductsWithAmountsOwedQuery,
      TError = unknown
    >(
      variables: ProductsWithAmountsOwedQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ProductsWithAmountsOwedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ProductsWithAmountsOwedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ProductsWithAmountsOwedQuery, TError, TData>(
      {
    queryKey: ['ProductsWithAmountsOwed', variables],
    queryFn: fetchData<ProductsWithAmountsOwedQuery, ProductsWithAmountsOwedQueryVariables>(ProductsWithAmountsOwedDocument, variables),
    ...options
  }
    )};

useSuspenseProductsWithAmountsOwedQuery.getKey = (variables: ProductsWithAmountsOwedQueryVariables) => ['ProductsWithAmountsOwed', variables];

export const useInfiniteProductsWithAmountsOwedQuery = <
      TData = InfiniteData<ProductsWithAmountsOwedQuery>,
      TError = unknown
    >(
      variables: ProductsWithAmountsOwedQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProductsWithAmountsOwedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProductsWithAmountsOwedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ProductsWithAmountsOwedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductsWithAmountsOwed.infinite', variables],
      queryFn: (metaData) => fetchData<ProductsWithAmountsOwedQuery, ProductsWithAmountsOwedQueryVariables>(ProductsWithAmountsOwedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteProductsWithAmountsOwedQuery.getKey = (variables: ProductsWithAmountsOwedQueryVariables) => ['ProductsWithAmountsOwed.infinite', variables];

export const useSuspenseInfiniteProductsWithAmountsOwedQuery = <
      TData = InfiniteData<ProductsWithAmountsOwedQuery>,
      TError = unknown
    >(
      variables: ProductsWithAmountsOwedQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ProductsWithAmountsOwedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ProductsWithAmountsOwedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ProductsWithAmountsOwedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductsWithAmountsOwed.infinite', variables],
      queryFn: (metaData) => fetchData<ProductsWithAmountsOwedQuery, ProductsWithAmountsOwedQueryVariables>(ProductsWithAmountsOwedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteProductsWithAmountsOwedQuery.getKey = (variables: ProductsWithAmountsOwedQueryVariables) => ['ProductsWithAmountsOwed.infinite', variables];


useProductsWithAmountsOwedQuery.fetcher = (variables: ProductsWithAmountsOwedQueryVariables, options?: RequestInit['headers']) => fetchData<ProductsWithAmountsOwedQuery, ProductsWithAmountsOwedQueryVariables>(ProductsWithAmountsOwedDocument, variables, options);

export const CustomerAddressesDocument = `
    query CustomerAddresses {
  customerAddresses(order: {id: DESC}) {
    addressLine1
    city
    id
    firstName
    lastName
    phoneNumber
    country {
      id
      isoCode
      name
    }
    state {
      id
      name
    }
    addressLine2
    zip
    isDefault
    dateLastUsed
  }
}
    `;

export const useCustomerAddressesQuery = <
      TData = CustomerAddressesQuery,
      TError = unknown
    >(
      variables?: CustomerAddressesQueryVariables,
      options?: Omit<UseQueryOptions<CustomerAddressesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerAddressesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerAddressesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerAddresses'] : ['CustomerAddresses', variables],
    queryFn: fetchData<CustomerAddressesQuery, CustomerAddressesQueryVariables>(CustomerAddressesDocument, variables),
    ...options
  }
    )};

useCustomerAddressesQuery.getKey = (variables?: CustomerAddressesQueryVariables) => variables === undefined ? ['CustomerAddresses'] : ['CustomerAddresses', variables];

export const useSuspenseCustomerAddressesQuery = <
      TData = CustomerAddressesQuery,
      TError = unknown
    >(
      variables?: CustomerAddressesQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerAddressesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerAddressesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerAddressesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerAddresses'] : ['CustomerAddresses', variables],
    queryFn: fetchData<CustomerAddressesQuery, CustomerAddressesQueryVariables>(CustomerAddressesDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerAddressesQuery.getKey = (variables?: CustomerAddressesQueryVariables) => variables === undefined ? ['CustomerAddresses'] : ['CustomerAddresses', variables];

export const useInfiniteCustomerAddressesQuery = <
      TData = InfiniteData<CustomerAddressesQuery>,
      TError = unknown
    >(
      variables: CustomerAddressesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerAddressesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerAddressesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerAddressesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerAddresses.infinite'] : ['CustomerAddresses.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerAddressesQuery, CustomerAddressesQueryVariables>(CustomerAddressesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerAddressesQuery.getKey = (variables?: CustomerAddressesQueryVariables) => variables === undefined ? ['CustomerAddresses.infinite'] : ['CustomerAddresses.infinite', variables];

export const useSuspenseInfiniteCustomerAddressesQuery = <
      TData = InfiniteData<CustomerAddressesQuery>,
      TError = unknown
    >(
      variables: CustomerAddressesQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerAddressesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerAddressesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerAddressesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerAddresses.infinite'] : ['CustomerAddresses.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerAddressesQuery, CustomerAddressesQueryVariables>(CustomerAddressesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerAddressesQuery.getKey = (variables?: CustomerAddressesQueryVariables) => variables === undefined ? ['CustomerAddresses.infinite'] : ['CustomerAddresses.infinite', variables];


useCustomerAddressesQuery.fetcher = (variables?: CustomerAddressesQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerAddressesQuery, CustomerAddressesQueryVariables>(CustomerAddressesDocument, variables, options);

export const CustomerBirthdayDocument = `
    query CustomerBirthday {
  customer {
    birthday
  }
}
    `;

export const useCustomerBirthdayQuery = <
      TData = CustomerBirthdayQuery,
      TError = unknown
    >(
      variables?: CustomerBirthdayQueryVariables,
      options?: Omit<UseQueryOptions<CustomerBirthdayQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerBirthdayQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerBirthdayQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerBirthday'] : ['CustomerBirthday', variables],
    queryFn: fetchData<CustomerBirthdayQuery, CustomerBirthdayQueryVariables>(CustomerBirthdayDocument, variables),
    ...options
  }
    )};

useCustomerBirthdayQuery.getKey = (variables?: CustomerBirthdayQueryVariables) => variables === undefined ? ['CustomerBirthday'] : ['CustomerBirthday', variables];

export const useSuspenseCustomerBirthdayQuery = <
      TData = CustomerBirthdayQuery,
      TError = unknown
    >(
      variables?: CustomerBirthdayQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerBirthdayQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerBirthdayQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerBirthdayQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerBirthday'] : ['CustomerBirthday', variables],
    queryFn: fetchData<CustomerBirthdayQuery, CustomerBirthdayQueryVariables>(CustomerBirthdayDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerBirthdayQuery.getKey = (variables?: CustomerBirthdayQueryVariables) => variables === undefined ? ['CustomerBirthday'] : ['CustomerBirthday', variables];

export const useInfiniteCustomerBirthdayQuery = <
      TData = InfiniteData<CustomerBirthdayQuery>,
      TError = unknown
    >(
      variables: CustomerBirthdayQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerBirthdayQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerBirthdayQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerBirthdayQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerBirthday.infinite'] : ['CustomerBirthday.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerBirthdayQuery, CustomerBirthdayQueryVariables>(CustomerBirthdayDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerBirthdayQuery.getKey = (variables?: CustomerBirthdayQueryVariables) => variables === undefined ? ['CustomerBirthday.infinite'] : ['CustomerBirthday.infinite', variables];

export const useSuspenseInfiniteCustomerBirthdayQuery = <
      TData = InfiniteData<CustomerBirthdayQuery>,
      TError = unknown
    >(
      variables: CustomerBirthdayQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerBirthdayQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerBirthdayQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerBirthdayQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerBirthday.infinite'] : ['CustomerBirthday.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerBirthdayQuery, CustomerBirthdayQueryVariables>(CustomerBirthdayDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerBirthdayQuery.getKey = (variables?: CustomerBirthdayQueryVariables) => variables === undefined ? ['CustomerBirthday.infinite'] : ['CustomerBirthday.infinite', variables];


useCustomerBirthdayQuery.fetcher = (variables?: CustomerBirthdayQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerBirthdayQuery, CustomerBirthdayQueryVariables>(CustomerBirthdayDocument, variables, options);

export const CustomerCreatorIdDocument = `
    query CustomerCreatorId {
  customer {
    creatorId
    firstName
    lastName
    emailAddress
    isReviewer
  }
}
    `;

export const useCustomerCreatorIdQuery = <
      TData = CustomerCreatorIdQuery,
      TError = unknown
    >(
      variables?: CustomerCreatorIdQueryVariables,
      options?: Omit<UseQueryOptions<CustomerCreatorIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerCreatorIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerCreatorIdQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerCreatorId'] : ['CustomerCreatorId', variables],
    queryFn: fetchData<CustomerCreatorIdQuery, CustomerCreatorIdQueryVariables>(CustomerCreatorIdDocument, variables),
    ...options
  }
    )};

useCustomerCreatorIdQuery.getKey = (variables?: CustomerCreatorIdQueryVariables) => variables === undefined ? ['CustomerCreatorId'] : ['CustomerCreatorId', variables];

export const useSuspenseCustomerCreatorIdQuery = <
      TData = CustomerCreatorIdQuery,
      TError = unknown
    >(
      variables?: CustomerCreatorIdQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerCreatorIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerCreatorIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerCreatorIdQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerCreatorId'] : ['CustomerCreatorId', variables],
    queryFn: fetchData<CustomerCreatorIdQuery, CustomerCreatorIdQueryVariables>(CustomerCreatorIdDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerCreatorIdQuery.getKey = (variables?: CustomerCreatorIdQueryVariables) => variables === undefined ? ['CustomerCreatorId'] : ['CustomerCreatorId', variables];

export const useInfiniteCustomerCreatorIdQuery = <
      TData = InfiniteData<CustomerCreatorIdQuery>,
      TError = unknown
    >(
      variables: CustomerCreatorIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerCreatorIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerCreatorIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerCreatorIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerCreatorId.infinite'] : ['CustomerCreatorId.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerCreatorIdQuery, CustomerCreatorIdQueryVariables>(CustomerCreatorIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerCreatorIdQuery.getKey = (variables?: CustomerCreatorIdQueryVariables) => variables === undefined ? ['CustomerCreatorId.infinite'] : ['CustomerCreatorId.infinite', variables];

export const useSuspenseInfiniteCustomerCreatorIdQuery = <
      TData = InfiniteData<CustomerCreatorIdQuery>,
      TError = unknown
    >(
      variables: CustomerCreatorIdQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerCreatorIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerCreatorIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerCreatorIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerCreatorId.infinite'] : ['CustomerCreatorId.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerCreatorIdQuery, CustomerCreatorIdQueryVariables>(CustomerCreatorIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerCreatorIdQuery.getKey = (variables?: CustomerCreatorIdQueryVariables) => variables === undefined ? ['CustomerCreatorId.infinite'] : ['CustomerCreatorId.infinite', variables];


useCustomerCreatorIdQuery.fetcher = (variables?: CustomerCreatorIdQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerCreatorIdQuery, CustomerCreatorIdQueryVariables>(CustomerCreatorIdDocument, variables, options);

export const CustomerDigitalLibraryDocument = `
    query CustomerDigitalLibrary($skip: Int!, $take: Int!, $order: [DigitalLibraryItemDtoSortInput!], $where: DigitalLibraryFilter, $searchTerm: String) {
  digitalLibrary(
    skip: $skip
    take: $take
    where: $where
    order: $order
    searchTerm: $searchTerm
  ) {
    items {
      id
      name
      thumbnailSrc
      dateAdded
      productId
      productType
      isMasterclass
      isArchived
      firstCreatorName
      creatorNames
      creators {
        id
        name
      }
      files {
        type
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

export const useCustomerDigitalLibraryQuery = <
      TData = CustomerDigitalLibraryQuery,
      TError = unknown
    >(
      variables: CustomerDigitalLibraryQueryVariables,
      options?: Omit<UseQueryOptions<CustomerDigitalLibraryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerDigitalLibraryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerDigitalLibraryQuery, TError, TData>(
      {
    queryKey: ['CustomerDigitalLibrary', variables],
    queryFn: fetchData<CustomerDigitalLibraryQuery, CustomerDigitalLibraryQueryVariables>(CustomerDigitalLibraryDocument, variables),
    ...options
  }
    )};

useCustomerDigitalLibraryQuery.getKey = (variables: CustomerDigitalLibraryQueryVariables) => ['CustomerDigitalLibrary', variables];

export const useSuspenseCustomerDigitalLibraryQuery = <
      TData = CustomerDigitalLibraryQuery,
      TError = unknown
    >(
      variables: CustomerDigitalLibraryQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerDigitalLibraryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerDigitalLibraryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerDigitalLibraryQuery, TError, TData>(
      {
    queryKey: ['CustomerDigitalLibrary', variables],
    queryFn: fetchData<CustomerDigitalLibraryQuery, CustomerDigitalLibraryQueryVariables>(CustomerDigitalLibraryDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerDigitalLibraryQuery.getKey = (variables: CustomerDigitalLibraryQueryVariables) => ['CustomerDigitalLibrary', variables];

export const useInfiniteCustomerDigitalLibraryQuery = <
      TData = InfiniteData<CustomerDigitalLibraryQuery>,
      TError = unknown
    >(
      variables: CustomerDigitalLibraryQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerDigitalLibraryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerDigitalLibraryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerDigitalLibraryQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomerDigitalLibrary.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerDigitalLibraryQuery, CustomerDigitalLibraryQueryVariables>(CustomerDigitalLibraryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerDigitalLibraryQuery.getKey = (variables: CustomerDigitalLibraryQueryVariables) => ['CustomerDigitalLibrary.infinite', variables];

export const useSuspenseInfiniteCustomerDigitalLibraryQuery = <
      TData = InfiniteData<CustomerDigitalLibraryQuery>,
      TError = unknown
    >(
      variables: CustomerDigitalLibraryQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerDigitalLibraryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerDigitalLibraryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerDigitalLibraryQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomerDigitalLibrary.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerDigitalLibraryQuery, CustomerDigitalLibraryQueryVariables>(CustomerDigitalLibraryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerDigitalLibraryQuery.getKey = (variables: CustomerDigitalLibraryQueryVariables) => ['CustomerDigitalLibrary.infinite', variables];


useCustomerDigitalLibraryQuery.fetcher = (variables: CustomerDigitalLibraryQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerDigitalLibraryQuery, CustomerDigitalLibraryQueryVariables>(CustomerDigitalLibraryDocument, variables, options);

export const CustomerEmailDocument = `
    query CustomerEmail {
  customer {
    emailAddress
  }
}
    `;

export const useCustomerEmailQuery = <
      TData = CustomerEmailQuery,
      TError = unknown
    >(
      variables?: CustomerEmailQueryVariables,
      options?: Omit<UseQueryOptions<CustomerEmailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerEmailQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerEmailQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerEmail'] : ['CustomerEmail', variables],
    queryFn: fetchData<CustomerEmailQuery, CustomerEmailQueryVariables>(CustomerEmailDocument, variables),
    ...options
  }
    )};

useCustomerEmailQuery.getKey = (variables?: CustomerEmailQueryVariables) => variables === undefined ? ['CustomerEmail'] : ['CustomerEmail', variables];

export const useSuspenseCustomerEmailQuery = <
      TData = CustomerEmailQuery,
      TError = unknown
    >(
      variables?: CustomerEmailQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerEmailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerEmailQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerEmailQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerEmail'] : ['CustomerEmail', variables],
    queryFn: fetchData<CustomerEmailQuery, CustomerEmailQueryVariables>(CustomerEmailDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerEmailQuery.getKey = (variables?: CustomerEmailQueryVariables) => variables === undefined ? ['CustomerEmail'] : ['CustomerEmail', variables];

export const useInfiniteCustomerEmailQuery = <
      TData = InfiniteData<CustomerEmailQuery>,
      TError = unknown
    >(
      variables: CustomerEmailQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerEmailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerEmailQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerEmailQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerEmail.infinite'] : ['CustomerEmail.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerEmailQuery, CustomerEmailQueryVariables>(CustomerEmailDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerEmailQuery.getKey = (variables?: CustomerEmailQueryVariables) => variables === undefined ? ['CustomerEmail.infinite'] : ['CustomerEmail.infinite', variables];

export const useSuspenseInfiniteCustomerEmailQuery = <
      TData = InfiniteData<CustomerEmailQuery>,
      TError = unknown
    >(
      variables: CustomerEmailQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerEmailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerEmailQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerEmailQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerEmail.infinite'] : ['CustomerEmail.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerEmailQuery, CustomerEmailQueryVariables>(CustomerEmailDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerEmailQuery.getKey = (variables?: CustomerEmailQueryVariables) => variables === undefined ? ['CustomerEmail.infinite'] : ['CustomerEmail.infinite', variables];


useCustomerEmailQuery.fetcher = (variables?: CustomerEmailQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerEmailQuery, CustomerEmailQueryVariables>(CustomerEmailDocument, variables, options);

export const CustomerEoriNumberDocument = `
    query CustomerEoriNumber {
  customer {
    eoriNumber
  }
}
    `;

export const useCustomerEoriNumberQuery = <
      TData = CustomerEoriNumberQuery,
      TError = unknown
    >(
      variables?: CustomerEoriNumberQueryVariables,
      options?: Omit<UseQueryOptions<CustomerEoriNumberQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerEoriNumberQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerEoriNumberQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerEoriNumber'] : ['CustomerEoriNumber', variables],
    queryFn: fetchData<CustomerEoriNumberQuery, CustomerEoriNumberQueryVariables>(CustomerEoriNumberDocument, variables),
    ...options
  }
    )};

useCustomerEoriNumberQuery.getKey = (variables?: CustomerEoriNumberQueryVariables) => variables === undefined ? ['CustomerEoriNumber'] : ['CustomerEoriNumber', variables];

export const useSuspenseCustomerEoriNumberQuery = <
      TData = CustomerEoriNumberQuery,
      TError = unknown
    >(
      variables?: CustomerEoriNumberQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerEoriNumberQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerEoriNumberQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerEoriNumberQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerEoriNumber'] : ['CustomerEoriNumber', variables],
    queryFn: fetchData<CustomerEoriNumberQuery, CustomerEoriNumberQueryVariables>(CustomerEoriNumberDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerEoriNumberQuery.getKey = (variables?: CustomerEoriNumberQueryVariables) => variables === undefined ? ['CustomerEoriNumber'] : ['CustomerEoriNumber', variables];

export const useInfiniteCustomerEoriNumberQuery = <
      TData = InfiniteData<CustomerEoriNumberQuery>,
      TError = unknown
    >(
      variables: CustomerEoriNumberQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerEoriNumberQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerEoriNumberQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerEoriNumberQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerEoriNumber.infinite'] : ['CustomerEoriNumber.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerEoriNumberQuery, CustomerEoriNumberQueryVariables>(CustomerEoriNumberDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerEoriNumberQuery.getKey = (variables?: CustomerEoriNumberQueryVariables) => variables === undefined ? ['CustomerEoriNumber.infinite'] : ['CustomerEoriNumber.infinite', variables];

export const useSuspenseInfiniteCustomerEoriNumberQuery = <
      TData = InfiniteData<CustomerEoriNumberQuery>,
      TError = unknown
    >(
      variables: CustomerEoriNumberQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerEoriNumberQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerEoriNumberQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerEoriNumberQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerEoriNumber.infinite'] : ['CustomerEoriNumber.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerEoriNumberQuery, CustomerEoriNumberQueryVariables>(CustomerEoriNumberDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerEoriNumberQuery.getKey = (variables?: CustomerEoriNumberQueryVariables) => variables === undefined ? ['CustomerEoriNumber.infinite'] : ['CustomerEoriNumber.infinite', variables];


useCustomerEoriNumberQuery.fetcher = (variables?: CustomerEoriNumberQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerEoriNumberQuery, CustomerEoriNumberQueryVariables>(CustomerEoriNumberDocument, variables, options);

export const CustomerOrdersDocument = `
    query CustomerOrders($skip: Int, $take: Int, $order: [OrderDtoSortInput!]) {
  orders(skip: $skip, take: $take, order: $order) {
    totalCount
    items {
      orderDate
      id
      itemCount
      statusDescription
      totalPrice
      currency {
        code
        id
        symbol
      }
      orderItems {
        productName
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;

export const useCustomerOrdersQuery = <
      TData = CustomerOrdersQuery,
      TError = unknown
    >(
      variables?: CustomerOrdersQueryVariables,
      options?: Omit<UseQueryOptions<CustomerOrdersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerOrdersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerOrdersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerOrders'] : ['CustomerOrders', variables],
    queryFn: fetchData<CustomerOrdersQuery, CustomerOrdersQueryVariables>(CustomerOrdersDocument, variables),
    ...options
  }
    )};

useCustomerOrdersQuery.getKey = (variables?: CustomerOrdersQueryVariables) => variables === undefined ? ['CustomerOrders'] : ['CustomerOrders', variables];

export const useSuspenseCustomerOrdersQuery = <
      TData = CustomerOrdersQuery,
      TError = unknown
    >(
      variables?: CustomerOrdersQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerOrdersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerOrdersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerOrdersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerOrders'] : ['CustomerOrders', variables],
    queryFn: fetchData<CustomerOrdersQuery, CustomerOrdersQueryVariables>(CustomerOrdersDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerOrdersQuery.getKey = (variables?: CustomerOrdersQueryVariables) => variables === undefined ? ['CustomerOrders'] : ['CustomerOrders', variables];

export const useInfiniteCustomerOrdersQuery = <
      TData = InfiniteData<CustomerOrdersQuery>,
      TError = unknown
    >(
      variables: CustomerOrdersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerOrdersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerOrdersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerOrdersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerOrders.infinite'] : ['CustomerOrders.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerOrdersQuery, CustomerOrdersQueryVariables>(CustomerOrdersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerOrdersQuery.getKey = (variables?: CustomerOrdersQueryVariables) => variables === undefined ? ['CustomerOrders.infinite'] : ['CustomerOrders.infinite', variables];

export const useSuspenseInfiniteCustomerOrdersQuery = <
      TData = InfiniteData<CustomerOrdersQuery>,
      TError = unknown
    >(
      variables: CustomerOrdersQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerOrdersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerOrdersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerOrdersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerOrders.infinite'] : ['CustomerOrders.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerOrdersQuery, CustomerOrdersQueryVariables>(CustomerOrdersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerOrdersQuery.getKey = (variables?: CustomerOrdersQueryVariables) => variables === undefined ? ['CustomerOrders.infinite'] : ['CustomerOrders.infinite', variables];


useCustomerOrdersQuery.fetcher = (variables?: CustomerOrdersQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerOrdersQuery, CustomerOrdersQueryVariables>(CustomerOrdersDocument, variables, options);

export const CustomerProductInstructionsDocument = `
    query CustomerProductInstructions($skip: Int!, $take: Int!, $order: [ProductInstructionDtoSortInput!], $search: String!) {
  customerProductInstructions(
    skip: $skip
    take: $take
    order: $order
    searchTerm: $search
  ) {
    totalCount
    items {
      id
      name
      productId
      isManuallyAdded
      thumbnailSrc
      instructionLink
      password
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

export const useCustomerProductInstructionsQuery = <
      TData = CustomerProductInstructionsQuery,
      TError = unknown
    >(
      variables: CustomerProductInstructionsQueryVariables,
      options?: Omit<UseQueryOptions<CustomerProductInstructionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerProductInstructionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerProductInstructionsQuery, TError, TData>(
      {
    queryKey: ['CustomerProductInstructions', variables],
    queryFn: fetchData<CustomerProductInstructionsQuery, CustomerProductInstructionsQueryVariables>(CustomerProductInstructionsDocument, variables),
    ...options
  }
    )};

useCustomerProductInstructionsQuery.getKey = (variables: CustomerProductInstructionsQueryVariables) => ['CustomerProductInstructions', variables];

export const useSuspenseCustomerProductInstructionsQuery = <
      TData = CustomerProductInstructionsQuery,
      TError = unknown
    >(
      variables: CustomerProductInstructionsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerProductInstructionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerProductInstructionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerProductInstructionsQuery, TError, TData>(
      {
    queryKey: ['CustomerProductInstructions', variables],
    queryFn: fetchData<CustomerProductInstructionsQuery, CustomerProductInstructionsQueryVariables>(CustomerProductInstructionsDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerProductInstructionsQuery.getKey = (variables: CustomerProductInstructionsQueryVariables) => ['CustomerProductInstructions', variables];

export const useInfiniteCustomerProductInstructionsQuery = <
      TData = InfiniteData<CustomerProductInstructionsQuery>,
      TError = unknown
    >(
      variables: CustomerProductInstructionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerProductInstructionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerProductInstructionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerProductInstructionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomerProductInstructions.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerProductInstructionsQuery, CustomerProductInstructionsQueryVariables>(CustomerProductInstructionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerProductInstructionsQuery.getKey = (variables: CustomerProductInstructionsQueryVariables) => ['CustomerProductInstructions.infinite', variables];

export const useSuspenseInfiniteCustomerProductInstructionsQuery = <
      TData = InfiniteData<CustomerProductInstructionsQuery>,
      TError = unknown
    >(
      variables: CustomerProductInstructionsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerProductInstructionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerProductInstructionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerProductInstructionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomerProductInstructions.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerProductInstructionsQuery, CustomerProductInstructionsQueryVariables>(CustomerProductInstructionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerProductInstructionsQuery.getKey = (variables: CustomerProductInstructionsQueryVariables) => ['CustomerProductInstructions.infinite', variables];


useCustomerProductInstructionsQuery.fetcher = (variables: CustomerProductInstructionsQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerProductInstructionsQuery, CustomerProductInstructionsQueryVariables>(CustomerProductInstructionsDocument, variables, options);

export const CustomerRequiresPasswordSetDocument = `
    query CustomerRequiresPasswordSet($customerId: Int!) {
  customerRequiresPasswordSet(customerId: $customerId)
}
    `;

export const useCustomerRequiresPasswordSetQuery = <
      TData = CustomerRequiresPasswordSetQuery,
      TError = unknown
    >(
      variables: CustomerRequiresPasswordSetQueryVariables,
      options?: Omit<UseQueryOptions<CustomerRequiresPasswordSetQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerRequiresPasswordSetQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerRequiresPasswordSetQuery, TError, TData>(
      {
    queryKey: ['CustomerRequiresPasswordSet', variables],
    queryFn: fetchData<CustomerRequiresPasswordSetQuery, CustomerRequiresPasswordSetQueryVariables>(CustomerRequiresPasswordSetDocument, variables),
    ...options
  }
    )};

useCustomerRequiresPasswordSetQuery.getKey = (variables: CustomerRequiresPasswordSetQueryVariables) => ['CustomerRequiresPasswordSet', variables];

export const useSuspenseCustomerRequiresPasswordSetQuery = <
      TData = CustomerRequiresPasswordSetQuery,
      TError = unknown
    >(
      variables: CustomerRequiresPasswordSetQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerRequiresPasswordSetQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerRequiresPasswordSetQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerRequiresPasswordSetQuery, TError, TData>(
      {
    queryKey: ['CustomerRequiresPasswordSet', variables],
    queryFn: fetchData<CustomerRequiresPasswordSetQuery, CustomerRequiresPasswordSetQueryVariables>(CustomerRequiresPasswordSetDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerRequiresPasswordSetQuery.getKey = (variables: CustomerRequiresPasswordSetQueryVariables) => ['CustomerRequiresPasswordSet', variables];

export const useInfiniteCustomerRequiresPasswordSetQuery = <
      TData = InfiniteData<CustomerRequiresPasswordSetQuery>,
      TError = unknown
    >(
      variables: CustomerRequiresPasswordSetQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerRequiresPasswordSetQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerRequiresPasswordSetQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerRequiresPasswordSetQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomerRequiresPasswordSet.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerRequiresPasswordSetQuery, CustomerRequiresPasswordSetQueryVariables>(CustomerRequiresPasswordSetDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerRequiresPasswordSetQuery.getKey = (variables: CustomerRequiresPasswordSetQueryVariables) => ['CustomerRequiresPasswordSet.infinite', variables];

export const useSuspenseInfiniteCustomerRequiresPasswordSetQuery = <
      TData = InfiniteData<CustomerRequiresPasswordSetQuery>,
      TError = unknown
    >(
      variables: CustomerRequiresPasswordSetQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerRequiresPasswordSetQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerRequiresPasswordSetQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerRequiresPasswordSetQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomerRequiresPasswordSet.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerRequiresPasswordSetQuery, CustomerRequiresPasswordSetQueryVariables>(CustomerRequiresPasswordSetDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerRequiresPasswordSetQuery.getKey = (variables: CustomerRequiresPasswordSetQueryVariables) => ['CustomerRequiresPasswordSet.infinite', variables];


useCustomerRequiresPasswordSetQuery.fetcher = (variables: CustomerRequiresPasswordSetQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerRequiresPasswordSetQuery, CustomerRequiresPasswordSetQueryVariables>(CustomerRequiresPasswordSetDocument, variables, options);

export const CustomerReviewDocument = `
    query CustomerReview($reviewId: Int!) {
  customerReview(reviewId: $reviewId) {
    id
    productId
    productName
    productURL
    rating
    review
    reviewDate
    reviewerName
    thumbnail
    status
  }
}
    `;

export const useCustomerReviewQuery = <
      TData = CustomerReviewQuery,
      TError = unknown
    >(
      variables: CustomerReviewQueryVariables,
      options?: Omit<UseQueryOptions<CustomerReviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerReviewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerReviewQuery, TError, TData>(
      {
    queryKey: ['CustomerReview', variables],
    queryFn: fetchData<CustomerReviewQuery, CustomerReviewQueryVariables>(CustomerReviewDocument, variables),
    ...options
  }
    )};

useCustomerReviewQuery.getKey = (variables: CustomerReviewQueryVariables) => ['CustomerReview', variables];

export const useSuspenseCustomerReviewQuery = <
      TData = CustomerReviewQuery,
      TError = unknown
    >(
      variables: CustomerReviewQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerReviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerReviewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerReviewQuery, TError, TData>(
      {
    queryKey: ['CustomerReview', variables],
    queryFn: fetchData<CustomerReviewQuery, CustomerReviewQueryVariables>(CustomerReviewDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerReviewQuery.getKey = (variables: CustomerReviewQueryVariables) => ['CustomerReview', variables];

export const useInfiniteCustomerReviewQuery = <
      TData = InfiniteData<CustomerReviewQuery>,
      TError = unknown
    >(
      variables: CustomerReviewQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerReviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerReviewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerReviewQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomerReview.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerReviewQuery, CustomerReviewQueryVariables>(CustomerReviewDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerReviewQuery.getKey = (variables: CustomerReviewQueryVariables) => ['CustomerReview.infinite', variables];

export const useSuspenseInfiniteCustomerReviewQuery = <
      TData = InfiniteData<CustomerReviewQuery>,
      TError = unknown
    >(
      variables: CustomerReviewQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerReviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerReviewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerReviewQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomerReview.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerReviewQuery, CustomerReviewQueryVariables>(CustomerReviewDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerReviewQuery.getKey = (variables: CustomerReviewQueryVariables) => ['CustomerReview.infinite', variables];


useCustomerReviewQuery.fetcher = (variables: CustomerReviewQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerReviewQuery, CustomerReviewQueryVariables>(CustomerReviewDocument, variables, options);

export const CustomerReviewsDocument = `
    query CustomerReviews($skip: Int, $take: Int, $order: [CustomerReviewSort!]) {
  customerReviews(skip: $skip, take: $take, order: $order) {
    items {
      id
      productId
      productName
      productURL
      rating
      review
      reviewDate
      reviewerName
      thumbnail
      status
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

export const useCustomerReviewsQuery = <
      TData = CustomerReviewsQuery,
      TError = unknown
    >(
      variables?: CustomerReviewsQueryVariables,
      options?: Omit<UseQueryOptions<CustomerReviewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerReviewsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerReviewsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerReviews'] : ['CustomerReviews', variables],
    queryFn: fetchData<CustomerReviewsQuery, CustomerReviewsQueryVariables>(CustomerReviewsDocument, variables),
    ...options
  }
    )};

useCustomerReviewsQuery.getKey = (variables?: CustomerReviewsQueryVariables) => variables === undefined ? ['CustomerReviews'] : ['CustomerReviews', variables];

export const useSuspenseCustomerReviewsQuery = <
      TData = CustomerReviewsQuery,
      TError = unknown
    >(
      variables?: CustomerReviewsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerReviewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerReviewsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerReviewsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerReviews'] : ['CustomerReviews', variables],
    queryFn: fetchData<CustomerReviewsQuery, CustomerReviewsQueryVariables>(CustomerReviewsDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerReviewsQuery.getKey = (variables?: CustomerReviewsQueryVariables) => variables === undefined ? ['CustomerReviews'] : ['CustomerReviews', variables];

export const useInfiniteCustomerReviewsQuery = <
      TData = InfiniteData<CustomerReviewsQuery>,
      TError = unknown
    >(
      variables: CustomerReviewsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerReviewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerReviewsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerReviewsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerReviews.infinite'] : ['CustomerReviews.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerReviewsQuery, CustomerReviewsQueryVariables>(CustomerReviewsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerReviewsQuery.getKey = (variables?: CustomerReviewsQueryVariables) => variables === undefined ? ['CustomerReviews.infinite'] : ['CustomerReviews.infinite', variables];

export const useSuspenseInfiniteCustomerReviewsQuery = <
      TData = InfiniteData<CustomerReviewsQuery>,
      TError = unknown
    >(
      variables: CustomerReviewsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerReviewsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerReviewsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerReviewsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerReviews.infinite'] : ['CustomerReviews.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerReviewsQuery, CustomerReviewsQueryVariables>(CustomerReviewsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerReviewsQuery.getKey = (variables?: CustomerReviewsQueryVariables) => variables === undefined ? ['CustomerReviews.infinite'] : ['CustomerReviews.infinite', variables];


useCustomerReviewsQuery.fetcher = (variables?: CustomerReviewsQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerReviewsQuery, CustomerReviewsQueryVariables>(CustomerReviewsDocument, variables, options);

export const CustomerSegmentsDocument = `
    query CustomerSegments($workspace: CustomerIOWorkspace) {
  customerSegments(workspace: $workspace) {
    segments {
      id
      name
      description
    }
  }
}
    `;

export const useCustomerSegmentsQuery = <
      TData = CustomerSegmentsQuery,
      TError = unknown
    >(
      variables?: CustomerSegmentsQueryVariables,
      options?: Omit<UseQueryOptions<CustomerSegmentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerSegmentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerSegmentsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerSegments'] : ['CustomerSegments', variables],
    queryFn: fetchData<CustomerSegmentsQuery, CustomerSegmentsQueryVariables>(CustomerSegmentsDocument, variables),
    ...options
  }
    )};

useCustomerSegmentsQuery.getKey = (variables?: CustomerSegmentsQueryVariables) => variables === undefined ? ['CustomerSegments'] : ['CustomerSegments', variables];

export const useSuspenseCustomerSegmentsQuery = <
      TData = CustomerSegmentsQuery,
      TError = unknown
    >(
      variables?: CustomerSegmentsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerSegmentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerSegmentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerSegmentsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerSegments'] : ['CustomerSegments', variables],
    queryFn: fetchData<CustomerSegmentsQuery, CustomerSegmentsQueryVariables>(CustomerSegmentsDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerSegmentsQuery.getKey = (variables?: CustomerSegmentsQueryVariables) => variables === undefined ? ['CustomerSegments'] : ['CustomerSegments', variables];

export const useInfiniteCustomerSegmentsQuery = <
      TData = InfiniteData<CustomerSegmentsQuery>,
      TError = unknown
    >(
      variables: CustomerSegmentsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerSegmentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerSegmentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerSegmentsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerSegments.infinite'] : ['CustomerSegments.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerSegmentsQuery, CustomerSegmentsQueryVariables>(CustomerSegmentsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerSegmentsQuery.getKey = (variables?: CustomerSegmentsQueryVariables) => variables === undefined ? ['CustomerSegments.infinite'] : ['CustomerSegments.infinite', variables];

export const useSuspenseInfiniteCustomerSegmentsQuery = <
      TData = InfiniteData<CustomerSegmentsQuery>,
      TError = unknown
    >(
      variables: CustomerSegmentsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerSegmentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerSegmentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerSegmentsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerSegments.infinite'] : ['CustomerSegments.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerSegmentsQuery, CustomerSegmentsQueryVariables>(CustomerSegmentsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerSegmentsQuery.getKey = (variables?: CustomerSegmentsQueryVariables) => variables === undefined ? ['CustomerSegments.infinite'] : ['CustomerSegments.infinite', variables];


useCustomerSegmentsQuery.fetcher = (variables?: CustomerSegmentsQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerSegmentsQuery, CustomerSegmentsQueryVariables>(CustomerSegmentsDocument, variables, options);

export const CustomerVatNumberDocument = `
    query CustomerVatNumber {
  customer {
    vatNumber
  }
}
    `;

export const useCustomerVatNumberQuery = <
      TData = CustomerVatNumberQuery,
      TError = unknown
    >(
      variables?: CustomerVatNumberQueryVariables,
      options?: Omit<UseQueryOptions<CustomerVatNumberQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerVatNumberQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerVatNumberQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerVatNumber'] : ['CustomerVatNumber', variables],
    queryFn: fetchData<CustomerVatNumberQuery, CustomerVatNumberQueryVariables>(CustomerVatNumberDocument, variables),
    ...options
  }
    )};

useCustomerVatNumberQuery.getKey = (variables?: CustomerVatNumberQueryVariables) => variables === undefined ? ['CustomerVatNumber'] : ['CustomerVatNumber', variables];

export const useSuspenseCustomerVatNumberQuery = <
      TData = CustomerVatNumberQuery,
      TError = unknown
    >(
      variables?: CustomerVatNumberQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerVatNumberQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerVatNumberQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerVatNumberQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerVatNumber'] : ['CustomerVatNumber', variables],
    queryFn: fetchData<CustomerVatNumberQuery, CustomerVatNumberQueryVariables>(CustomerVatNumberDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerVatNumberQuery.getKey = (variables?: CustomerVatNumberQueryVariables) => variables === undefined ? ['CustomerVatNumber'] : ['CustomerVatNumber', variables];

export const useInfiniteCustomerVatNumberQuery = <
      TData = InfiniteData<CustomerVatNumberQuery>,
      TError = unknown
    >(
      variables: CustomerVatNumberQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerVatNumberQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerVatNumberQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerVatNumberQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerVatNumber.infinite'] : ['CustomerVatNumber.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerVatNumberQuery, CustomerVatNumberQueryVariables>(CustomerVatNumberDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerVatNumberQuery.getKey = (variables?: CustomerVatNumberQueryVariables) => variables === undefined ? ['CustomerVatNumber.infinite'] : ['CustomerVatNumber.infinite', variables];

export const useSuspenseInfiniteCustomerVatNumberQuery = <
      TData = InfiniteData<CustomerVatNumberQuery>,
      TError = unknown
    >(
      variables: CustomerVatNumberQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerVatNumberQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerVatNumberQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerVatNumberQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerVatNumber.infinite'] : ['CustomerVatNumber.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerVatNumberQuery, CustomerVatNumberQueryVariables>(CustomerVatNumberDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerVatNumberQuery.getKey = (variables?: CustomerVatNumberQueryVariables) => variables === undefined ? ['CustomerVatNumber.infinite'] : ['CustomerVatNumber.infinite', variables];


useCustomerVatNumberQuery.fetcher = (variables?: CustomerVatNumberQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerVatNumberQuery, CustomerVatNumberQueryVariables>(CustomerVatNumberDocument, variables, options);

export const PurchasedProductExportRowsDocument = `
    query PurchasedProductExportRows($skip: Int, $take: Int) {
  purchasedProductExportRows(skip: $skip, take: $take) {
    items {
      orderId
      productName
      productPageUrl
      purchasedDate
      productType
      creators {
        name
      }
    }
    pageInfo {
      hasNextPage
    }
  }
}
    `;

export const usePurchasedProductExportRowsQuery = <
      TData = PurchasedProductExportRowsQuery,
      TError = unknown
    >(
      variables?: PurchasedProductExportRowsQueryVariables,
      options?: Omit<UseQueryOptions<PurchasedProductExportRowsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PurchasedProductExportRowsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PurchasedProductExportRowsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['PurchasedProductExportRows'] : ['PurchasedProductExportRows', variables],
    queryFn: fetchData<PurchasedProductExportRowsQuery, PurchasedProductExportRowsQueryVariables>(PurchasedProductExportRowsDocument, variables),
    ...options
  }
    )};

usePurchasedProductExportRowsQuery.getKey = (variables?: PurchasedProductExportRowsQueryVariables) => variables === undefined ? ['PurchasedProductExportRows'] : ['PurchasedProductExportRows', variables];

export const useSuspensePurchasedProductExportRowsQuery = <
      TData = PurchasedProductExportRowsQuery,
      TError = unknown
    >(
      variables?: PurchasedProductExportRowsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<PurchasedProductExportRowsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<PurchasedProductExportRowsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<PurchasedProductExportRowsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['PurchasedProductExportRows'] : ['PurchasedProductExportRows', variables],
    queryFn: fetchData<PurchasedProductExportRowsQuery, PurchasedProductExportRowsQueryVariables>(PurchasedProductExportRowsDocument, variables),
    ...options
  }
    )};

useSuspensePurchasedProductExportRowsQuery.getKey = (variables?: PurchasedProductExportRowsQueryVariables) => variables === undefined ? ['PurchasedProductExportRows'] : ['PurchasedProductExportRows', variables];

export const useInfinitePurchasedProductExportRowsQuery = <
      TData = InfiniteData<PurchasedProductExportRowsQuery>,
      TError = unknown
    >(
      variables: PurchasedProductExportRowsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<PurchasedProductExportRowsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<PurchasedProductExportRowsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<PurchasedProductExportRowsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['PurchasedProductExportRows.infinite'] : ['PurchasedProductExportRows.infinite', variables],
      queryFn: (metaData) => fetchData<PurchasedProductExportRowsQuery, PurchasedProductExportRowsQueryVariables>(PurchasedProductExportRowsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfinitePurchasedProductExportRowsQuery.getKey = (variables?: PurchasedProductExportRowsQueryVariables) => variables === undefined ? ['PurchasedProductExportRows.infinite'] : ['PurchasedProductExportRows.infinite', variables];

export const useSuspenseInfinitePurchasedProductExportRowsQuery = <
      TData = InfiniteData<PurchasedProductExportRowsQuery>,
      TError = unknown
    >(
      variables: PurchasedProductExportRowsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<PurchasedProductExportRowsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<PurchasedProductExportRowsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<PurchasedProductExportRowsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['PurchasedProductExportRows.infinite'] : ['PurchasedProductExportRows.infinite', variables],
      queryFn: (metaData) => fetchData<PurchasedProductExportRowsQuery, PurchasedProductExportRowsQueryVariables>(PurchasedProductExportRowsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfinitePurchasedProductExportRowsQuery.getKey = (variables?: PurchasedProductExportRowsQueryVariables) => variables === undefined ? ['PurchasedProductExportRows.infinite'] : ['PurchasedProductExportRows.infinite', variables];


usePurchasedProductExportRowsQuery.fetcher = (variables?: PurchasedProductExportRowsQueryVariables, options?: RequestInit['headers']) => fetchData<PurchasedProductExportRowsQuery, PurchasedProductExportRowsQueryVariables>(PurchasedProductExportRowsDocument, variables, options);

export const ReviewerProductsCustomerDocument = `
    query ReviewerProductsCustomer {
  customer {
    isReviewer
  }
}
    `;

export const useReviewerProductsCustomerQuery = <
      TData = ReviewerProductsCustomerQuery,
      TError = unknown
    >(
      variables?: ReviewerProductsCustomerQueryVariables,
      options?: Omit<UseQueryOptions<ReviewerProductsCustomerQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ReviewerProductsCustomerQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ReviewerProductsCustomerQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ReviewerProductsCustomer'] : ['ReviewerProductsCustomer', variables],
    queryFn: fetchData<ReviewerProductsCustomerQuery, ReviewerProductsCustomerQueryVariables>(ReviewerProductsCustomerDocument, variables),
    ...options
  }
    )};

useReviewerProductsCustomerQuery.getKey = (variables?: ReviewerProductsCustomerQueryVariables) => variables === undefined ? ['ReviewerProductsCustomer'] : ['ReviewerProductsCustomer', variables];

export const useSuspenseReviewerProductsCustomerQuery = <
      TData = ReviewerProductsCustomerQuery,
      TError = unknown
    >(
      variables?: ReviewerProductsCustomerQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ReviewerProductsCustomerQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ReviewerProductsCustomerQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ReviewerProductsCustomerQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ReviewerProductsCustomer'] : ['ReviewerProductsCustomer', variables],
    queryFn: fetchData<ReviewerProductsCustomerQuery, ReviewerProductsCustomerQueryVariables>(ReviewerProductsCustomerDocument, variables),
    ...options
  }
    )};

useSuspenseReviewerProductsCustomerQuery.getKey = (variables?: ReviewerProductsCustomerQueryVariables) => variables === undefined ? ['ReviewerProductsCustomer'] : ['ReviewerProductsCustomer', variables];

export const useInfiniteReviewerProductsCustomerQuery = <
      TData = InfiniteData<ReviewerProductsCustomerQuery>,
      TError = unknown
    >(
      variables: ReviewerProductsCustomerQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ReviewerProductsCustomerQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ReviewerProductsCustomerQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ReviewerProductsCustomerQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ReviewerProductsCustomer.infinite'] : ['ReviewerProductsCustomer.infinite', variables],
      queryFn: (metaData) => fetchData<ReviewerProductsCustomerQuery, ReviewerProductsCustomerQueryVariables>(ReviewerProductsCustomerDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteReviewerProductsCustomerQuery.getKey = (variables?: ReviewerProductsCustomerQueryVariables) => variables === undefined ? ['ReviewerProductsCustomer.infinite'] : ['ReviewerProductsCustomer.infinite', variables];

export const useSuspenseInfiniteReviewerProductsCustomerQuery = <
      TData = InfiniteData<ReviewerProductsCustomerQuery>,
      TError = unknown
    >(
      variables: ReviewerProductsCustomerQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ReviewerProductsCustomerQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ReviewerProductsCustomerQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ReviewerProductsCustomerQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ReviewerProductsCustomer.infinite'] : ['ReviewerProductsCustomer.infinite', variables],
      queryFn: (metaData) => fetchData<ReviewerProductsCustomerQuery, ReviewerProductsCustomerQueryVariables>(ReviewerProductsCustomerDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteReviewerProductsCustomerQuery.getKey = (variables?: ReviewerProductsCustomerQueryVariables) => variables === undefined ? ['ReviewerProductsCustomer.infinite'] : ['ReviewerProductsCustomer.infinite', variables];


useReviewerProductsCustomerQuery.fetcher = (variables?: ReviewerProductsCustomerQueryVariables, options?: RequestInit['headers']) => fetchData<ReviewerProductsCustomerQuery, ReviewerProductsCustomerQueryVariables>(ReviewerProductsCustomerDocument, variables, options);

export const StoreCreditBalanceDocument = `
    query StoreCreditBalance($brandId: Int!, $currencyId: Int!) {
  storeCreditBalance(brandId: $brandId, currencyId: $currencyId)
}
    `;

export const useStoreCreditBalanceQuery = <
      TData = StoreCreditBalanceQuery,
      TError = unknown
    >(
      variables: StoreCreditBalanceQueryVariables,
      options?: Omit<UseQueryOptions<StoreCreditBalanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<StoreCreditBalanceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<StoreCreditBalanceQuery, TError, TData>(
      {
    queryKey: ['StoreCreditBalance', variables],
    queryFn: fetchData<StoreCreditBalanceQuery, StoreCreditBalanceQueryVariables>(StoreCreditBalanceDocument, variables),
    ...options
  }
    )};

useStoreCreditBalanceQuery.getKey = (variables: StoreCreditBalanceQueryVariables) => ['StoreCreditBalance', variables];

export const useSuspenseStoreCreditBalanceQuery = <
      TData = StoreCreditBalanceQuery,
      TError = unknown
    >(
      variables: StoreCreditBalanceQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<StoreCreditBalanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<StoreCreditBalanceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<StoreCreditBalanceQuery, TError, TData>(
      {
    queryKey: ['StoreCreditBalance', variables],
    queryFn: fetchData<StoreCreditBalanceQuery, StoreCreditBalanceQueryVariables>(StoreCreditBalanceDocument, variables),
    ...options
  }
    )};

useSuspenseStoreCreditBalanceQuery.getKey = (variables: StoreCreditBalanceQueryVariables) => ['StoreCreditBalance', variables];

export const useInfiniteStoreCreditBalanceQuery = <
      TData = InfiniteData<StoreCreditBalanceQuery>,
      TError = unknown
    >(
      variables: StoreCreditBalanceQueryVariables,
      options: Omit<UseInfiniteQueryOptions<StoreCreditBalanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<StoreCreditBalanceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<StoreCreditBalanceQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['StoreCreditBalance.infinite', variables],
      queryFn: (metaData) => fetchData<StoreCreditBalanceQuery, StoreCreditBalanceQueryVariables>(StoreCreditBalanceDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteStoreCreditBalanceQuery.getKey = (variables: StoreCreditBalanceQueryVariables) => ['StoreCreditBalance.infinite', variables];

export const useSuspenseInfiniteStoreCreditBalanceQuery = <
      TData = InfiniteData<StoreCreditBalanceQuery>,
      TError = unknown
    >(
      variables: StoreCreditBalanceQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<StoreCreditBalanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<StoreCreditBalanceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<StoreCreditBalanceQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['StoreCreditBalance.infinite', variables],
      queryFn: (metaData) => fetchData<StoreCreditBalanceQuery, StoreCreditBalanceQueryVariables>(StoreCreditBalanceDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteStoreCreditBalanceQuery.getKey = (variables: StoreCreditBalanceQueryVariables) => ['StoreCreditBalance.infinite', variables];


useStoreCreditBalanceQuery.fetcher = (variables: StoreCreditBalanceQueryVariables, options?: RequestInit['headers']) => fetchData<StoreCreditBalanceQuery, StoreCreditBalanceQueryVariables>(StoreCreditBalanceDocument, variables, options);

export const CustomerDigitalLibraryArchiveDocument = `
    query CustomerDigitalLibraryArchive($skip: Int!, $take: Int!, $order: [DigitalLibraryItemDtoSortInput!], $where: DigitalLibraryFilter) {
  digitalLibrary(skip: $skip, take: $take, where: $where, order: $order) {
    items {
      id
      name
      thumbnailSrc
      productId
      isArchived
      firstCreatorName
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

export const useCustomerDigitalLibraryArchiveQuery = <
      TData = CustomerDigitalLibraryArchiveQuery,
      TError = unknown
    >(
      variables: CustomerDigitalLibraryArchiveQueryVariables,
      options?: Omit<UseQueryOptions<CustomerDigitalLibraryArchiveQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerDigitalLibraryArchiveQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerDigitalLibraryArchiveQuery, TError, TData>(
      {
    queryKey: ['CustomerDigitalLibraryArchive', variables],
    queryFn: fetchData<CustomerDigitalLibraryArchiveQuery, CustomerDigitalLibraryArchiveQueryVariables>(CustomerDigitalLibraryArchiveDocument, variables),
    ...options
  }
    )};

useCustomerDigitalLibraryArchiveQuery.getKey = (variables: CustomerDigitalLibraryArchiveQueryVariables) => ['CustomerDigitalLibraryArchive', variables];

export const useSuspenseCustomerDigitalLibraryArchiveQuery = <
      TData = CustomerDigitalLibraryArchiveQuery,
      TError = unknown
    >(
      variables: CustomerDigitalLibraryArchiveQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerDigitalLibraryArchiveQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerDigitalLibraryArchiveQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerDigitalLibraryArchiveQuery, TError, TData>(
      {
    queryKey: ['CustomerDigitalLibraryArchive', variables],
    queryFn: fetchData<CustomerDigitalLibraryArchiveQuery, CustomerDigitalLibraryArchiveQueryVariables>(CustomerDigitalLibraryArchiveDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerDigitalLibraryArchiveQuery.getKey = (variables: CustomerDigitalLibraryArchiveQueryVariables) => ['CustomerDigitalLibraryArchive', variables];

export const useInfiniteCustomerDigitalLibraryArchiveQuery = <
      TData = InfiniteData<CustomerDigitalLibraryArchiveQuery>,
      TError = unknown
    >(
      variables: CustomerDigitalLibraryArchiveQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerDigitalLibraryArchiveQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerDigitalLibraryArchiveQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerDigitalLibraryArchiveQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomerDigitalLibraryArchive.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerDigitalLibraryArchiveQuery, CustomerDigitalLibraryArchiveQueryVariables>(CustomerDigitalLibraryArchiveDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerDigitalLibraryArchiveQuery.getKey = (variables: CustomerDigitalLibraryArchiveQueryVariables) => ['CustomerDigitalLibraryArchive.infinite', variables];

export const useSuspenseInfiniteCustomerDigitalLibraryArchiveQuery = <
      TData = InfiniteData<CustomerDigitalLibraryArchiveQuery>,
      TError = unknown
    >(
      variables: CustomerDigitalLibraryArchiveQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerDigitalLibraryArchiveQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerDigitalLibraryArchiveQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerDigitalLibraryArchiveQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomerDigitalLibraryArchive.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerDigitalLibraryArchiveQuery, CustomerDigitalLibraryArchiveQueryVariables>(CustomerDigitalLibraryArchiveDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerDigitalLibraryArchiveQuery.getKey = (variables: CustomerDigitalLibraryArchiveQueryVariables) => ['CustomerDigitalLibraryArchive.infinite', variables];


useCustomerDigitalLibraryArchiveQuery.fetcher = (variables: CustomerDigitalLibraryArchiveQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerDigitalLibraryArchiveQuery, CustomerDigitalLibraryArchiveQueryVariables>(CustomerDigitalLibraryArchiveDocument, variables, options);

export const DigitalLibraryItemDocument = `
    query DigitalLibraryItem($productId: Int!) {
  digitalLibraryItem(productId: $productId) {
    id
    name
    downloadIntro
    thumbnailSrc
    productId
    creators {
      name
    }
    masterclassDownloadQa {
      showQaSection
      creatorDisplayName
      productSlug
      questions {
        id
        customerId
        customerName
        question
        upvotes
        answers {
          id
          customerId
          customerName
          answer
          isCreator
          responseTo
        }
      }
    }
    files {
      type
      vtt
      title
      lastAccessPoint
      duration
      id
      name
      lectureStartTime
      playbackSources {
        streamingLink
        originalStreamingLink
      }
      downloadLink
      chapters {
        title
      }
    }
  }
}
    `;

export const useDigitalLibraryItemQuery = <
      TData = DigitalLibraryItemQuery,
      TError = unknown
    >(
      variables: DigitalLibraryItemQueryVariables,
      options?: Omit<UseQueryOptions<DigitalLibraryItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DigitalLibraryItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DigitalLibraryItemQuery, TError, TData>(
      {
    queryKey: ['DigitalLibraryItem', variables],
    queryFn: fetchData<DigitalLibraryItemQuery, DigitalLibraryItemQueryVariables>(DigitalLibraryItemDocument, variables),
    ...options
  }
    )};

useDigitalLibraryItemQuery.getKey = (variables: DigitalLibraryItemQueryVariables) => ['DigitalLibraryItem', variables];

export const useSuspenseDigitalLibraryItemQuery = <
      TData = DigitalLibraryItemQuery,
      TError = unknown
    >(
      variables: DigitalLibraryItemQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<DigitalLibraryItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<DigitalLibraryItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<DigitalLibraryItemQuery, TError, TData>(
      {
    queryKey: ['DigitalLibraryItem', variables],
    queryFn: fetchData<DigitalLibraryItemQuery, DigitalLibraryItemQueryVariables>(DigitalLibraryItemDocument, variables),
    ...options
  }
    )};

useSuspenseDigitalLibraryItemQuery.getKey = (variables: DigitalLibraryItemQueryVariables) => ['DigitalLibraryItem', variables];

export const useInfiniteDigitalLibraryItemQuery = <
      TData = InfiniteData<DigitalLibraryItemQuery>,
      TError = unknown
    >(
      variables: DigitalLibraryItemQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DigitalLibraryItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DigitalLibraryItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<DigitalLibraryItemQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['DigitalLibraryItem.infinite', variables],
      queryFn: (metaData) => fetchData<DigitalLibraryItemQuery, DigitalLibraryItemQueryVariables>(DigitalLibraryItemDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteDigitalLibraryItemQuery.getKey = (variables: DigitalLibraryItemQueryVariables) => ['DigitalLibraryItem.infinite', variables];

export const useSuspenseInfiniteDigitalLibraryItemQuery = <
      TData = InfiniteData<DigitalLibraryItemQuery>,
      TError = unknown
    >(
      variables: DigitalLibraryItemQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<DigitalLibraryItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<DigitalLibraryItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<DigitalLibraryItemQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['DigitalLibraryItem.infinite', variables],
      queryFn: (metaData) => fetchData<DigitalLibraryItemQuery, DigitalLibraryItemQueryVariables>(DigitalLibraryItemDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteDigitalLibraryItemQuery.getKey = (variables: DigitalLibraryItemQueryVariables) => ['DigitalLibraryItem.infinite', variables];


useDigitalLibraryItemQuery.fetcher = (variables: DigitalLibraryItemQueryVariables, options?: RequestInit['headers']) => fetchData<DigitalLibraryItemQuery, DigitalLibraryItemQueryVariables>(DigitalLibraryItemDocument, variables, options);

export const DirectDownloadUrlForProductDocument = `
    query DirectDownloadUrlForProduct($productId: Int!) {
  digitalLibraryItem(productId: $productId) {
    directDownloadUrl
    files {
      id
      title
    }
  }
}
    `;

export const useDirectDownloadUrlForProductQuery = <
      TData = DirectDownloadUrlForProductQuery,
      TError = unknown
    >(
      variables: DirectDownloadUrlForProductQueryVariables,
      options?: Omit<UseQueryOptions<DirectDownloadUrlForProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DirectDownloadUrlForProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DirectDownloadUrlForProductQuery, TError, TData>(
      {
    queryKey: ['DirectDownloadUrlForProduct', variables],
    queryFn: fetchData<DirectDownloadUrlForProductQuery, DirectDownloadUrlForProductQueryVariables>(DirectDownloadUrlForProductDocument, variables),
    ...options
  }
    )};

useDirectDownloadUrlForProductQuery.getKey = (variables: DirectDownloadUrlForProductQueryVariables) => ['DirectDownloadUrlForProduct', variables];

export const useSuspenseDirectDownloadUrlForProductQuery = <
      TData = DirectDownloadUrlForProductQuery,
      TError = unknown
    >(
      variables: DirectDownloadUrlForProductQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<DirectDownloadUrlForProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<DirectDownloadUrlForProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<DirectDownloadUrlForProductQuery, TError, TData>(
      {
    queryKey: ['DirectDownloadUrlForProduct', variables],
    queryFn: fetchData<DirectDownloadUrlForProductQuery, DirectDownloadUrlForProductQueryVariables>(DirectDownloadUrlForProductDocument, variables),
    ...options
  }
    )};

useSuspenseDirectDownloadUrlForProductQuery.getKey = (variables: DirectDownloadUrlForProductQueryVariables) => ['DirectDownloadUrlForProduct', variables];

export const useInfiniteDirectDownloadUrlForProductQuery = <
      TData = InfiniteData<DirectDownloadUrlForProductQuery>,
      TError = unknown
    >(
      variables: DirectDownloadUrlForProductQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DirectDownloadUrlForProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DirectDownloadUrlForProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<DirectDownloadUrlForProductQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['DirectDownloadUrlForProduct.infinite', variables],
      queryFn: (metaData) => fetchData<DirectDownloadUrlForProductQuery, DirectDownloadUrlForProductQueryVariables>(DirectDownloadUrlForProductDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteDirectDownloadUrlForProductQuery.getKey = (variables: DirectDownloadUrlForProductQueryVariables) => ['DirectDownloadUrlForProduct.infinite', variables];

export const useSuspenseInfiniteDirectDownloadUrlForProductQuery = <
      TData = InfiniteData<DirectDownloadUrlForProductQuery>,
      TError = unknown
    >(
      variables: DirectDownloadUrlForProductQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<DirectDownloadUrlForProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<DirectDownloadUrlForProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<DirectDownloadUrlForProductQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['DirectDownloadUrlForProduct.infinite', variables],
      queryFn: (metaData) => fetchData<DirectDownloadUrlForProductQuery, DirectDownloadUrlForProductQueryVariables>(DirectDownloadUrlForProductDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteDirectDownloadUrlForProductQuery.getKey = (variables: DirectDownloadUrlForProductQueryVariables) => ['DirectDownloadUrlForProduct.infinite', variables];


useDirectDownloadUrlForProductQuery.fetcher = (variables: DirectDownloadUrlForProductQueryVariables, options?: RequestInit['headers']) => fetchData<DirectDownloadUrlForProductQuery, DirectDownloadUrlForProductQueryVariables>(DirectDownloadUrlForProductDocument, variables, options);

export const EbookImageUrlDocument = `
    query EbookImageURL($imagePath: String!) {
  ebookImageURL(imagePath: $imagePath)
}
    `;

export const useEbookImageUrlQuery = <
      TData = EbookImageUrlQuery,
      TError = unknown
    >(
      variables: EbookImageUrlQueryVariables,
      options?: Omit<UseQueryOptions<EbookImageUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<EbookImageUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<EbookImageUrlQuery, TError, TData>(
      {
    queryKey: ['EbookImageURL', variables],
    queryFn: fetchData<EbookImageUrlQuery, EbookImageUrlQueryVariables>(EbookImageUrlDocument, variables),
    ...options
  }
    )};

useEbookImageUrlQuery.getKey = (variables: EbookImageUrlQueryVariables) => ['EbookImageURL', variables];

export const useSuspenseEbookImageUrlQuery = <
      TData = EbookImageUrlQuery,
      TError = unknown
    >(
      variables: EbookImageUrlQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<EbookImageUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<EbookImageUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<EbookImageUrlQuery, TError, TData>(
      {
    queryKey: ['EbookImageURL', variables],
    queryFn: fetchData<EbookImageUrlQuery, EbookImageUrlQueryVariables>(EbookImageUrlDocument, variables),
    ...options
  }
    )};

useSuspenseEbookImageUrlQuery.getKey = (variables: EbookImageUrlQueryVariables) => ['EbookImageURL', variables];

export const useInfiniteEbookImageUrlQuery = <
      TData = InfiniteData<EbookImageUrlQuery>,
      TError = unknown
    >(
      variables: EbookImageUrlQueryVariables,
      options: Omit<UseInfiniteQueryOptions<EbookImageUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<EbookImageUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<EbookImageUrlQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['EbookImageURL.infinite', variables],
      queryFn: (metaData) => fetchData<EbookImageUrlQuery, EbookImageUrlQueryVariables>(EbookImageUrlDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteEbookImageUrlQuery.getKey = (variables: EbookImageUrlQueryVariables) => ['EbookImageURL.infinite', variables];

export const useSuspenseInfiniteEbookImageUrlQuery = <
      TData = InfiniteData<EbookImageUrlQuery>,
      TError = unknown
    >(
      variables: EbookImageUrlQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<EbookImageUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<EbookImageUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<EbookImageUrlQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['EbookImageURL.infinite', variables],
      queryFn: (metaData) => fetchData<EbookImageUrlQuery, EbookImageUrlQueryVariables>(EbookImageUrlDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteEbookImageUrlQuery.getKey = (variables: EbookImageUrlQueryVariables) => ['EbookImageURL.infinite', variables];


useEbookImageUrlQuery.fetcher = (variables: EbookImageUrlQueryVariables, options?: RequestInit['headers']) => fetchData<EbookImageUrlQuery, EbookImageUrlQueryVariables>(EbookImageUrlDocument, variables, options);

export const MasterclassDocument = `
    query Masterclass($slug: String!) {
  masterclassBySlug(slug: $slug) {
    creators {
      name
    }
    id
    name
  }
}
    `;

export const useMasterclassQuery = <
      TData = MasterclassQuery,
      TError = unknown
    >(
      variables: MasterclassQueryVariables,
      options?: Omit<UseQueryOptions<MasterclassQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MasterclassQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MasterclassQuery, TError, TData>(
      {
    queryKey: ['Masterclass', variables],
    queryFn: fetchData<MasterclassQuery, MasterclassQueryVariables>(MasterclassDocument, variables),
    ...options
  }
    )};

useMasterclassQuery.getKey = (variables: MasterclassQueryVariables) => ['Masterclass', variables];

export const useSuspenseMasterclassQuery = <
      TData = MasterclassQuery,
      TError = unknown
    >(
      variables: MasterclassQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MasterclassQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MasterclassQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MasterclassQuery, TError, TData>(
      {
    queryKey: ['Masterclass', variables],
    queryFn: fetchData<MasterclassQuery, MasterclassQueryVariables>(MasterclassDocument, variables),
    ...options
  }
    )};

useSuspenseMasterclassQuery.getKey = (variables: MasterclassQueryVariables) => ['Masterclass', variables];

export const useInfiniteMasterclassQuery = <
      TData = InfiniteData<MasterclassQuery>,
      TError = unknown
    >(
      variables: MasterclassQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MasterclassQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MasterclassQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<MasterclassQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Masterclass.infinite', variables],
      queryFn: (metaData) => fetchData<MasterclassQuery, MasterclassQueryVariables>(MasterclassDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMasterclassQuery.getKey = (variables: MasterclassQueryVariables) => ['Masterclass.infinite', variables];

export const useSuspenseInfiniteMasterclassQuery = <
      TData = InfiniteData<MasterclassQuery>,
      TError = unknown
    >(
      variables: MasterclassQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<MasterclassQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<MasterclassQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<MasterclassQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Masterclass.infinite', variables],
      queryFn: (metaData) => fetchData<MasterclassQuery, MasterclassQueryVariables>(MasterclassDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteMasterclassQuery.getKey = (variables: MasterclassQueryVariables) => ['Masterclass.infinite', variables];


useMasterclassQuery.fetcher = (variables: MasterclassQueryVariables, options?: RequestInit['headers']) => fetchData<MasterclassQuery, MasterclassQueryVariables>(MasterclassDocument, variables, options);

export const MasterclassItemDocument = `
    query MasterclassItem($urlStub: String!) {
  masterclassItem(urlStub: $urlStub) {
    id
    name
    productId
    downloadIntro
    masterclassDownloadQa {
      showQaSection
      creatorDisplayName
      productSlug
      questions {
        id
        customerId
        customerName
        question
        upvotes
        answers {
          id
          customerId
          customerName
          answer
          isCreator
          responseTo
        }
      }
    }
    files {
      id
      type
      title
      playbackSources {
        streamingLink
        originalStreamingLink
      }
      downloadLink
      lastAccessPoint
      duration
      vtt
    }
  }
}
    `;

export const useMasterclassItemQuery = <
      TData = MasterclassItemQuery,
      TError = unknown
    >(
      variables: MasterclassItemQueryVariables,
      options?: Omit<UseQueryOptions<MasterclassItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MasterclassItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MasterclassItemQuery, TError, TData>(
      {
    queryKey: ['MasterclassItem', variables],
    queryFn: fetchData<MasterclassItemQuery, MasterclassItemQueryVariables>(MasterclassItemDocument, variables),
    ...options
  }
    )};

useMasterclassItemQuery.getKey = (variables: MasterclassItemQueryVariables) => ['MasterclassItem', variables];

export const useSuspenseMasterclassItemQuery = <
      TData = MasterclassItemQuery,
      TError = unknown
    >(
      variables: MasterclassItemQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MasterclassItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MasterclassItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MasterclassItemQuery, TError, TData>(
      {
    queryKey: ['MasterclassItem', variables],
    queryFn: fetchData<MasterclassItemQuery, MasterclassItemQueryVariables>(MasterclassItemDocument, variables),
    ...options
  }
    )};

useSuspenseMasterclassItemQuery.getKey = (variables: MasterclassItemQueryVariables) => ['MasterclassItem', variables];

export const useInfiniteMasterclassItemQuery = <
      TData = InfiniteData<MasterclassItemQuery>,
      TError = unknown
    >(
      variables: MasterclassItemQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MasterclassItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MasterclassItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<MasterclassItemQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MasterclassItem.infinite', variables],
      queryFn: (metaData) => fetchData<MasterclassItemQuery, MasterclassItemQueryVariables>(MasterclassItemDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMasterclassItemQuery.getKey = (variables: MasterclassItemQueryVariables) => ['MasterclassItem.infinite', variables];

export const useSuspenseInfiniteMasterclassItemQuery = <
      TData = InfiniteData<MasterclassItemQuery>,
      TError = unknown
    >(
      variables: MasterclassItemQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<MasterclassItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<MasterclassItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<MasterclassItemQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MasterclassItem.infinite', variables],
      queryFn: (metaData) => fetchData<MasterclassItemQuery, MasterclassItemQueryVariables>(MasterclassItemDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteMasterclassItemQuery.getKey = (variables: MasterclassItemQueryVariables) => ['MasterclassItem.infinite', variables];


useMasterclassItemQuery.fetcher = (variables: MasterclassItemQueryVariables, options?: RequestInit['headers']) => fetchData<MasterclassItemQuery, MasterclassItemQueryVariables>(MasterclassItemDocument, variables, options);

export const MasterclassLibraryDocument = `
    query MasterclassLibrary($skip: Int!, $take: Int!, $order: [MasterclassDtoSortInput!]) {
  masterclassStreamingLibrary(skip: $skip, take: $take, order: $order) {
    totalCount
    items {
      id
      name
      thumbnailSrc
      urlStub
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

export const useMasterclassLibraryQuery = <
      TData = MasterclassLibraryQuery,
      TError = unknown
    >(
      variables: MasterclassLibraryQueryVariables,
      options?: Omit<UseQueryOptions<MasterclassLibraryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MasterclassLibraryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MasterclassLibraryQuery, TError, TData>(
      {
    queryKey: ['MasterclassLibrary', variables],
    queryFn: fetchData<MasterclassLibraryQuery, MasterclassLibraryQueryVariables>(MasterclassLibraryDocument, variables),
    ...options
  }
    )};

useMasterclassLibraryQuery.getKey = (variables: MasterclassLibraryQueryVariables) => ['MasterclassLibrary', variables];

export const useSuspenseMasterclassLibraryQuery = <
      TData = MasterclassLibraryQuery,
      TError = unknown
    >(
      variables: MasterclassLibraryQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MasterclassLibraryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MasterclassLibraryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MasterclassLibraryQuery, TError, TData>(
      {
    queryKey: ['MasterclassLibrary', variables],
    queryFn: fetchData<MasterclassLibraryQuery, MasterclassLibraryQueryVariables>(MasterclassLibraryDocument, variables),
    ...options
  }
    )};

useSuspenseMasterclassLibraryQuery.getKey = (variables: MasterclassLibraryQueryVariables) => ['MasterclassLibrary', variables];

export const useInfiniteMasterclassLibraryQuery = <
      TData = InfiniteData<MasterclassLibraryQuery>,
      TError = unknown
    >(
      variables: MasterclassLibraryQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MasterclassLibraryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MasterclassLibraryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<MasterclassLibraryQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MasterclassLibrary.infinite', variables],
      queryFn: (metaData) => fetchData<MasterclassLibraryQuery, MasterclassLibraryQueryVariables>(MasterclassLibraryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMasterclassLibraryQuery.getKey = (variables: MasterclassLibraryQueryVariables) => ['MasterclassLibrary.infinite', variables];

export const useSuspenseInfiniteMasterclassLibraryQuery = <
      TData = InfiniteData<MasterclassLibraryQuery>,
      TError = unknown
    >(
      variables: MasterclassLibraryQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<MasterclassLibraryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<MasterclassLibraryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<MasterclassLibraryQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MasterclassLibrary.infinite', variables],
      queryFn: (metaData) => fetchData<MasterclassLibraryQuery, MasterclassLibraryQueryVariables>(MasterclassLibraryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteMasterclassLibraryQuery.getKey = (variables: MasterclassLibraryQueryVariables) => ['MasterclassLibrary.infinite', variables];


useMasterclassLibraryQuery.fetcher = (variables: MasterclassLibraryQueryVariables, options?: RequestInit['headers']) => fetchData<MasterclassLibraryQuery, MasterclassLibraryQueryVariables>(MasterclassLibraryDocument, variables, options);

export const StudioItemDocument = `
    query StudioItem($urlStub: String!) {
  studioItem(urlStub: $urlStub) {
    id
    name
    productId
    downloadIntro
    files {
      id
      type
      title
      playbackSources {
        streamingLink
        originalStreamingLink
      }
      downloadLink
      lastAccessPoint
      duration
      vtt
    }
  }
}
    `;

export const useStudioItemQuery = <
      TData = StudioItemQuery,
      TError = unknown
    >(
      variables: StudioItemQueryVariables,
      options?: Omit<UseQueryOptions<StudioItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<StudioItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<StudioItemQuery, TError, TData>(
      {
    queryKey: ['StudioItem', variables],
    queryFn: fetchData<StudioItemQuery, StudioItemQueryVariables>(StudioItemDocument, variables),
    ...options
  }
    )};

useStudioItemQuery.getKey = (variables: StudioItemQueryVariables) => ['StudioItem', variables];

export const useSuspenseStudioItemQuery = <
      TData = StudioItemQuery,
      TError = unknown
    >(
      variables: StudioItemQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<StudioItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<StudioItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<StudioItemQuery, TError, TData>(
      {
    queryKey: ['StudioItem', variables],
    queryFn: fetchData<StudioItemQuery, StudioItemQueryVariables>(StudioItemDocument, variables),
    ...options
  }
    )};

useSuspenseStudioItemQuery.getKey = (variables: StudioItemQueryVariables) => ['StudioItem', variables];

export const useInfiniteStudioItemQuery = <
      TData = InfiniteData<StudioItemQuery>,
      TError = unknown
    >(
      variables: StudioItemQueryVariables,
      options: Omit<UseInfiniteQueryOptions<StudioItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<StudioItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<StudioItemQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['StudioItem.infinite', variables],
      queryFn: (metaData) => fetchData<StudioItemQuery, StudioItemQueryVariables>(StudioItemDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteStudioItemQuery.getKey = (variables: StudioItemQueryVariables) => ['StudioItem.infinite', variables];

export const useSuspenseInfiniteStudioItemQuery = <
      TData = InfiniteData<StudioItemQuery>,
      TError = unknown
    >(
      variables: StudioItemQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<StudioItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<StudioItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<StudioItemQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['StudioItem.infinite', variables],
      queryFn: (metaData) => fetchData<StudioItemQuery, StudioItemQueryVariables>(StudioItemDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteStudioItemQuery.getKey = (variables: StudioItemQueryVariables) => ['StudioItem.infinite', variables];


useStudioItemQuery.fetcher = (variables: StudioItemQueryVariables, options?: RequestInit['headers']) => fetchData<StudioItemQuery, StudioItemQueryVariables>(StudioItemDocument, variables, options);

export const StudioVideosDocument = `
    query StudioVideos($skip: Int!, $take: Int!, $order: [ProductListItemDtoSortInput!]) {
  studioVideos(skip: $skip, take: $take, order: $order) {
    totalCount
    items {
      dateAdded
      id
      name
      rating
      thumbnailSrc
      urlStub
      creatorDisplayName
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

export const useStudioVideosQuery = <
      TData = StudioVideosQuery,
      TError = unknown
    >(
      variables: StudioVideosQueryVariables,
      options?: Omit<UseQueryOptions<StudioVideosQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<StudioVideosQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<StudioVideosQuery, TError, TData>(
      {
    queryKey: ['StudioVideos', variables],
    queryFn: fetchData<StudioVideosQuery, StudioVideosQueryVariables>(StudioVideosDocument, variables),
    ...options
  }
    )};

useStudioVideosQuery.getKey = (variables: StudioVideosQueryVariables) => ['StudioVideos', variables];

export const useSuspenseStudioVideosQuery = <
      TData = StudioVideosQuery,
      TError = unknown
    >(
      variables: StudioVideosQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<StudioVideosQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<StudioVideosQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<StudioVideosQuery, TError, TData>(
      {
    queryKey: ['StudioVideos', variables],
    queryFn: fetchData<StudioVideosQuery, StudioVideosQueryVariables>(StudioVideosDocument, variables),
    ...options
  }
    )};

useSuspenseStudioVideosQuery.getKey = (variables: StudioVideosQueryVariables) => ['StudioVideos', variables];

export const useInfiniteStudioVideosQuery = <
      TData = InfiniteData<StudioVideosQuery>,
      TError = unknown
    >(
      variables: StudioVideosQueryVariables,
      options: Omit<UseInfiniteQueryOptions<StudioVideosQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<StudioVideosQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<StudioVideosQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['StudioVideos.infinite', variables],
      queryFn: (metaData) => fetchData<StudioVideosQuery, StudioVideosQueryVariables>(StudioVideosDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteStudioVideosQuery.getKey = (variables: StudioVideosQueryVariables) => ['StudioVideos.infinite', variables];

export const useSuspenseInfiniteStudioVideosQuery = <
      TData = InfiniteData<StudioVideosQuery>,
      TError = unknown
    >(
      variables: StudioVideosQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<StudioVideosQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<StudioVideosQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<StudioVideosQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['StudioVideos.infinite', variables],
      queryFn: (metaData) => fetchData<StudioVideosQuery, StudioVideosQueryVariables>(StudioVideosDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteStudioVideosQuery.getKey = (variables: StudioVideosQueryVariables) => ['StudioVideos.infinite', variables];


useStudioVideosQuery.fetcher = (variables: StudioVideosQueryVariables, options?: RequestInit['headers']) => fetchData<StudioVideosQuery, StudioVideosQueryVariables>(StudioVideosDocument, variables, options);

export const UpcomingStudioVideosDocument = `
    query UpcomingStudioVideos {
  upComingStudioVideos {
    name
    urlStub
    thumbnailSrc
    creatorDisplayName
  }
}
    `;

export const useUpcomingStudioVideosQuery = <
      TData = UpcomingStudioVideosQuery,
      TError = unknown
    >(
      variables?: UpcomingStudioVideosQueryVariables,
      options?: Omit<UseQueryOptions<UpcomingStudioVideosQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UpcomingStudioVideosQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UpcomingStudioVideosQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['UpcomingStudioVideos'] : ['UpcomingStudioVideos', variables],
    queryFn: fetchData<UpcomingStudioVideosQuery, UpcomingStudioVideosQueryVariables>(UpcomingStudioVideosDocument, variables),
    ...options
  }
    )};

useUpcomingStudioVideosQuery.getKey = (variables?: UpcomingStudioVideosQueryVariables) => variables === undefined ? ['UpcomingStudioVideos'] : ['UpcomingStudioVideos', variables];

export const useSuspenseUpcomingStudioVideosQuery = <
      TData = UpcomingStudioVideosQuery,
      TError = unknown
    >(
      variables?: UpcomingStudioVideosQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<UpcomingStudioVideosQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<UpcomingStudioVideosQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<UpcomingStudioVideosQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['UpcomingStudioVideos'] : ['UpcomingStudioVideos', variables],
    queryFn: fetchData<UpcomingStudioVideosQuery, UpcomingStudioVideosQueryVariables>(UpcomingStudioVideosDocument, variables),
    ...options
  }
    )};

useSuspenseUpcomingStudioVideosQuery.getKey = (variables?: UpcomingStudioVideosQueryVariables) => variables === undefined ? ['UpcomingStudioVideos'] : ['UpcomingStudioVideos', variables];

export const useInfiniteUpcomingStudioVideosQuery = <
      TData = InfiniteData<UpcomingStudioVideosQuery>,
      TError = unknown
    >(
      variables: UpcomingStudioVideosQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UpcomingStudioVideosQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UpcomingStudioVideosQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UpcomingStudioVideosQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['UpcomingStudioVideos.infinite'] : ['UpcomingStudioVideos.infinite', variables],
      queryFn: (metaData) => fetchData<UpcomingStudioVideosQuery, UpcomingStudioVideosQueryVariables>(UpcomingStudioVideosDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUpcomingStudioVideosQuery.getKey = (variables?: UpcomingStudioVideosQueryVariables) => variables === undefined ? ['UpcomingStudioVideos.infinite'] : ['UpcomingStudioVideos.infinite', variables];

export const useSuspenseInfiniteUpcomingStudioVideosQuery = <
      TData = InfiniteData<UpcomingStudioVideosQuery>,
      TError = unknown
    >(
      variables: UpcomingStudioVideosQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<UpcomingStudioVideosQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<UpcomingStudioVideosQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<UpcomingStudioVideosQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['UpcomingStudioVideos.infinite'] : ['UpcomingStudioVideos.infinite', variables],
      queryFn: (metaData) => fetchData<UpcomingStudioVideosQuery, UpcomingStudioVideosQueryVariables>(UpcomingStudioVideosDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteUpcomingStudioVideosQuery.getKey = (variables?: UpcomingStudioVideosQueryVariables) => variables === undefined ? ['UpcomingStudioVideos.infinite'] : ['UpcomingStudioVideos.infinite', variables];


useUpcomingStudioVideosQuery.fetcher = (variables?: UpcomingStudioVideosQueryVariables, options?: RequestInit['headers']) => fetchData<UpcomingStudioVideosQuery, UpcomingStudioVideosQueryVariables>(UpcomingStudioVideosDocument, variables, options);

export const ExplanationPageDocument = `
    query ExplanationPage($slug: String!, $password: String) {
  explanationPage(slug: $slug, password: $password) {
    productId
    name
    urlSlug
    downloadUrl
    meta {
      id
      key
      value
    }
    downloadFiles {
      id
      title
      fileType
      filePath
      position
      bunnyId
      vtt
    }
  }
}
    `;

export const useExplanationPageQuery = <
      TData = ExplanationPageQuery,
      TError = unknown
    >(
      variables: ExplanationPageQueryVariables,
      options?: Omit<UseQueryOptions<ExplanationPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ExplanationPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ExplanationPageQuery, TError, TData>(
      {
    queryKey: ['ExplanationPage', variables],
    queryFn: fetchData<ExplanationPageQuery, ExplanationPageQueryVariables>(ExplanationPageDocument, variables),
    ...options
  }
    )};

useExplanationPageQuery.getKey = (variables: ExplanationPageQueryVariables) => ['ExplanationPage', variables];

export const useSuspenseExplanationPageQuery = <
      TData = ExplanationPageQuery,
      TError = unknown
    >(
      variables: ExplanationPageQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ExplanationPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ExplanationPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ExplanationPageQuery, TError, TData>(
      {
    queryKey: ['ExplanationPage', variables],
    queryFn: fetchData<ExplanationPageQuery, ExplanationPageQueryVariables>(ExplanationPageDocument, variables),
    ...options
  }
    )};

useSuspenseExplanationPageQuery.getKey = (variables: ExplanationPageQueryVariables) => ['ExplanationPage', variables];

export const useInfiniteExplanationPageQuery = <
      TData = InfiniteData<ExplanationPageQuery>,
      TError = unknown
    >(
      variables: ExplanationPageQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ExplanationPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ExplanationPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ExplanationPageQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ExplanationPage.infinite', variables],
      queryFn: (metaData) => fetchData<ExplanationPageQuery, ExplanationPageQueryVariables>(ExplanationPageDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteExplanationPageQuery.getKey = (variables: ExplanationPageQueryVariables) => ['ExplanationPage.infinite', variables];

export const useSuspenseInfiniteExplanationPageQuery = <
      TData = InfiniteData<ExplanationPageQuery>,
      TError = unknown
    >(
      variables: ExplanationPageQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ExplanationPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ExplanationPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ExplanationPageQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ExplanationPage.infinite', variables],
      queryFn: (metaData) => fetchData<ExplanationPageQuery, ExplanationPageQueryVariables>(ExplanationPageDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteExplanationPageQuery.getKey = (variables: ExplanationPageQueryVariables) => ['ExplanationPage.infinite', variables];


useExplanationPageQuery.fetcher = (variables: ExplanationPageQueryVariables, options?: RequestInit['headers']) => fetchData<ExplanationPageQuery, ExplanationPageQueryVariables>(ExplanationPageDocument, variables, options);

export const ExplanationSlugByPasswordDocument = `
    query ExplanationSlugByPassword($password: String!) {
  explanationSlugByPassword(password: $password)
}
    `;

export const useExplanationSlugByPasswordQuery = <
      TData = ExplanationSlugByPasswordQuery,
      TError = unknown
    >(
      variables: ExplanationSlugByPasswordQueryVariables,
      options?: Omit<UseQueryOptions<ExplanationSlugByPasswordQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ExplanationSlugByPasswordQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ExplanationSlugByPasswordQuery, TError, TData>(
      {
    queryKey: ['ExplanationSlugByPassword', variables],
    queryFn: fetchData<ExplanationSlugByPasswordQuery, ExplanationSlugByPasswordQueryVariables>(ExplanationSlugByPasswordDocument, variables),
    ...options
  }
    )};

useExplanationSlugByPasswordQuery.getKey = (variables: ExplanationSlugByPasswordQueryVariables) => ['ExplanationSlugByPassword', variables];

export const useSuspenseExplanationSlugByPasswordQuery = <
      TData = ExplanationSlugByPasswordQuery,
      TError = unknown
    >(
      variables: ExplanationSlugByPasswordQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ExplanationSlugByPasswordQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ExplanationSlugByPasswordQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ExplanationSlugByPasswordQuery, TError, TData>(
      {
    queryKey: ['ExplanationSlugByPassword', variables],
    queryFn: fetchData<ExplanationSlugByPasswordQuery, ExplanationSlugByPasswordQueryVariables>(ExplanationSlugByPasswordDocument, variables),
    ...options
  }
    )};

useSuspenseExplanationSlugByPasswordQuery.getKey = (variables: ExplanationSlugByPasswordQueryVariables) => ['ExplanationSlugByPassword', variables];

export const useInfiniteExplanationSlugByPasswordQuery = <
      TData = InfiniteData<ExplanationSlugByPasswordQuery>,
      TError = unknown
    >(
      variables: ExplanationSlugByPasswordQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ExplanationSlugByPasswordQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ExplanationSlugByPasswordQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ExplanationSlugByPasswordQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ExplanationSlugByPassword.infinite', variables],
      queryFn: (metaData) => fetchData<ExplanationSlugByPasswordQuery, ExplanationSlugByPasswordQueryVariables>(ExplanationSlugByPasswordDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteExplanationSlugByPasswordQuery.getKey = (variables: ExplanationSlugByPasswordQueryVariables) => ['ExplanationSlugByPassword.infinite', variables];

export const useSuspenseInfiniteExplanationSlugByPasswordQuery = <
      TData = InfiniteData<ExplanationSlugByPasswordQuery>,
      TError = unknown
    >(
      variables: ExplanationSlugByPasswordQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ExplanationSlugByPasswordQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ExplanationSlugByPasswordQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ExplanationSlugByPasswordQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ExplanationSlugByPassword.infinite', variables],
      queryFn: (metaData) => fetchData<ExplanationSlugByPasswordQuery, ExplanationSlugByPasswordQueryVariables>(ExplanationSlugByPasswordDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteExplanationSlugByPasswordQuery.getKey = (variables: ExplanationSlugByPasswordQueryVariables) => ['ExplanationSlugByPassword.infinite', variables];


useExplanationSlugByPasswordQuery.fetcher = (variables: ExplanationSlugByPasswordQueryVariables, options?: RequestInit['headers']) => fetchData<ExplanationSlugByPasswordQuery, ExplanationSlugByPasswordQueryVariables>(ExplanationSlugByPasswordDocument, variables, options);

export const GetExplanationDocument = `
    query GetExplanation($explanationSlug: String!) {
  explanationBySlug(slug: $explanationSlug) {
    id
    name
    thumbnailSrc
    hasPassword
    requiresUniqueCode
    requiresLogin
    promptText
    iosInstallLink
    androidInstallLink
  }
}
    `;

export const useGetExplanationQuery = <
      TData = GetExplanationQuery,
      TError = unknown
    >(
      variables: GetExplanationQueryVariables,
      options?: Omit<UseQueryOptions<GetExplanationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetExplanationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetExplanationQuery, TError, TData>(
      {
    queryKey: ['GetExplanation', variables],
    queryFn: fetchData<GetExplanationQuery, GetExplanationQueryVariables>(GetExplanationDocument, variables),
    ...options
  }
    )};

useGetExplanationQuery.getKey = (variables: GetExplanationQueryVariables) => ['GetExplanation', variables];

export const useSuspenseGetExplanationQuery = <
      TData = GetExplanationQuery,
      TError = unknown
    >(
      variables: GetExplanationQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<GetExplanationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<GetExplanationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<GetExplanationQuery, TError, TData>(
      {
    queryKey: ['GetExplanation', variables],
    queryFn: fetchData<GetExplanationQuery, GetExplanationQueryVariables>(GetExplanationDocument, variables),
    ...options
  }
    )};

useSuspenseGetExplanationQuery.getKey = (variables: GetExplanationQueryVariables) => ['GetExplanation', variables];

export const useInfiniteGetExplanationQuery = <
      TData = InfiniteData<GetExplanationQuery>,
      TError = unknown
    >(
      variables: GetExplanationQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetExplanationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetExplanationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetExplanationQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetExplanation.infinite', variables],
      queryFn: (metaData) => fetchData<GetExplanationQuery, GetExplanationQueryVariables>(GetExplanationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetExplanationQuery.getKey = (variables: GetExplanationQueryVariables) => ['GetExplanation.infinite', variables];

export const useSuspenseInfiniteGetExplanationQuery = <
      TData = InfiniteData<GetExplanationQuery>,
      TError = unknown
    >(
      variables: GetExplanationQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<GetExplanationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<GetExplanationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<GetExplanationQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetExplanation.infinite', variables],
      queryFn: (metaData) => fetchData<GetExplanationQuery, GetExplanationQueryVariables>(GetExplanationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteGetExplanationQuery.getKey = (variables: GetExplanationQueryVariables) => ['GetExplanation.infinite', variables];


useGetExplanationQuery.fetcher = (variables: GetExplanationQueryVariables, options?: RequestInit['headers']) => fetchData<GetExplanationQuery, GetExplanationQueryVariables>(GetExplanationDocument, variables, options);

export const GalleriesDocument = `
    query Galleries {
  galleries {
    id
    title
    intro
    photographer
    urlstub
    year
    leadPhotoUrl
  }
}
    `;

export const useGalleriesQuery = <
      TData = GalleriesQuery,
      TError = unknown
    >(
      variables?: GalleriesQueryVariables,
      options?: Omit<UseQueryOptions<GalleriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GalleriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GalleriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Galleries'] : ['Galleries', variables],
    queryFn: fetchData<GalleriesQuery, GalleriesQueryVariables>(GalleriesDocument, variables),
    ...options
  }
    )};

useGalleriesQuery.getKey = (variables?: GalleriesQueryVariables) => variables === undefined ? ['Galleries'] : ['Galleries', variables];

export const useSuspenseGalleriesQuery = <
      TData = GalleriesQuery,
      TError = unknown
    >(
      variables?: GalleriesQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<GalleriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<GalleriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<GalleriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Galleries'] : ['Galleries', variables],
    queryFn: fetchData<GalleriesQuery, GalleriesQueryVariables>(GalleriesDocument, variables),
    ...options
  }
    )};

useSuspenseGalleriesQuery.getKey = (variables?: GalleriesQueryVariables) => variables === undefined ? ['Galleries'] : ['Galleries', variables];

export const useInfiniteGalleriesQuery = <
      TData = InfiniteData<GalleriesQuery>,
      TError = unknown
    >(
      variables: GalleriesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GalleriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GalleriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GalleriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Galleries.infinite'] : ['Galleries.infinite', variables],
      queryFn: (metaData) => fetchData<GalleriesQuery, GalleriesQueryVariables>(GalleriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGalleriesQuery.getKey = (variables?: GalleriesQueryVariables) => variables === undefined ? ['Galleries.infinite'] : ['Galleries.infinite', variables];

export const useSuspenseInfiniteGalleriesQuery = <
      TData = InfiniteData<GalleriesQuery>,
      TError = unknown
    >(
      variables: GalleriesQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<GalleriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<GalleriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<GalleriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Galleries.infinite'] : ['Galleries.infinite', variables],
      queryFn: (metaData) => fetchData<GalleriesQuery, GalleriesQueryVariables>(GalleriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteGalleriesQuery.getKey = (variables?: GalleriesQueryVariables) => variables === undefined ? ['Galleries.infinite'] : ['Galleries.infinite', variables];


useGalleriesQuery.fetcher = (variables?: GalleriesQueryVariables, options?: RequestInit['headers']) => fetchData<GalleriesQuery, GalleriesQueryVariables>(GalleriesDocument, variables, options);

export const GalleryByUrlStubDocument = `
    query GalleryByUrlStub($urlStub: String!) {
  galleryByUrlStub(urlStub: $urlStub) {
    id
    title
    intro
    photographer
    urlstub
    year
    leadPhotoUrl
  }
}
    `;

export const useGalleryByUrlStubQuery = <
      TData = GalleryByUrlStubQuery,
      TError = unknown
    >(
      variables: GalleryByUrlStubQueryVariables,
      options?: Omit<UseQueryOptions<GalleryByUrlStubQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GalleryByUrlStubQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GalleryByUrlStubQuery, TError, TData>(
      {
    queryKey: ['GalleryByUrlStub', variables],
    queryFn: fetchData<GalleryByUrlStubQuery, GalleryByUrlStubQueryVariables>(GalleryByUrlStubDocument, variables),
    ...options
  }
    )};

useGalleryByUrlStubQuery.getKey = (variables: GalleryByUrlStubQueryVariables) => ['GalleryByUrlStub', variables];

export const useSuspenseGalleryByUrlStubQuery = <
      TData = GalleryByUrlStubQuery,
      TError = unknown
    >(
      variables: GalleryByUrlStubQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<GalleryByUrlStubQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<GalleryByUrlStubQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<GalleryByUrlStubQuery, TError, TData>(
      {
    queryKey: ['GalleryByUrlStub', variables],
    queryFn: fetchData<GalleryByUrlStubQuery, GalleryByUrlStubQueryVariables>(GalleryByUrlStubDocument, variables),
    ...options
  }
    )};

useSuspenseGalleryByUrlStubQuery.getKey = (variables: GalleryByUrlStubQueryVariables) => ['GalleryByUrlStub', variables];

export const useInfiniteGalleryByUrlStubQuery = <
      TData = InfiniteData<GalleryByUrlStubQuery>,
      TError = unknown
    >(
      variables: GalleryByUrlStubQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GalleryByUrlStubQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GalleryByUrlStubQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GalleryByUrlStubQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GalleryByUrlStub.infinite', variables],
      queryFn: (metaData) => fetchData<GalleryByUrlStubQuery, GalleryByUrlStubQueryVariables>(GalleryByUrlStubDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGalleryByUrlStubQuery.getKey = (variables: GalleryByUrlStubQueryVariables) => ['GalleryByUrlStub.infinite', variables];

export const useSuspenseInfiniteGalleryByUrlStubQuery = <
      TData = InfiniteData<GalleryByUrlStubQuery>,
      TError = unknown
    >(
      variables: GalleryByUrlStubQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<GalleryByUrlStubQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<GalleryByUrlStubQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<GalleryByUrlStubQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GalleryByUrlStub.infinite', variables],
      queryFn: (metaData) => fetchData<GalleryByUrlStubQuery, GalleryByUrlStubQueryVariables>(GalleryByUrlStubDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteGalleryByUrlStubQuery.getKey = (variables: GalleryByUrlStubQueryVariables) => ['GalleryByUrlStub.infinite', variables];


useGalleryByUrlStubQuery.fetcher = (variables: GalleryByUrlStubQueryVariables, options?: RequestInit['headers']) => fetchData<GalleryByUrlStubQuery, GalleryByUrlStubQueryVariables>(GalleryByUrlStubDocument, variables, options);

export const GalleryPhotosDocument = `
    query GalleryPhotos($galleryId: Int!, $page: Int!) {
  galleryPhotos(galleryId: $galleryId, page: $page) {
    id
    galleryId
    filePath
    title
    description
    imageUrl
  }
  galleryPhotosCount(galleryId: $galleryId)
}
    `;

export const useGalleryPhotosQuery = <
      TData = GalleryPhotosQuery,
      TError = unknown
    >(
      variables: GalleryPhotosQueryVariables,
      options?: Omit<UseQueryOptions<GalleryPhotosQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GalleryPhotosQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GalleryPhotosQuery, TError, TData>(
      {
    queryKey: ['GalleryPhotos', variables],
    queryFn: fetchData<GalleryPhotosQuery, GalleryPhotosQueryVariables>(GalleryPhotosDocument, variables),
    ...options
  }
    )};

useGalleryPhotosQuery.getKey = (variables: GalleryPhotosQueryVariables) => ['GalleryPhotos', variables];

export const useSuspenseGalleryPhotosQuery = <
      TData = GalleryPhotosQuery,
      TError = unknown
    >(
      variables: GalleryPhotosQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<GalleryPhotosQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<GalleryPhotosQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<GalleryPhotosQuery, TError, TData>(
      {
    queryKey: ['GalleryPhotos', variables],
    queryFn: fetchData<GalleryPhotosQuery, GalleryPhotosQueryVariables>(GalleryPhotosDocument, variables),
    ...options
  }
    )};

useSuspenseGalleryPhotosQuery.getKey = (variables: GalleryPhotosQueryVariables) => ['GalleryPhotos', variables];

export const useInfiniteGalleryPhotosQuery = <
      TData = InfiniteData<GalleryPhotosQuery>,
      TError = unknown
    >(
      variables: GalleryPhotosQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GalleryPhotosQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GalleryPhotosQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GalleryPhotosQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GalleryPhotos.infinite', variables],
      queryFn: (metaData) => fetchData<GalleryPhotosQuery, GalleryPhotosQueryVariables>(GalleryPhotosDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGalleryPhotosQuery.getKey = (variables: GalleryPhotosQueryVariables) => ['GalleryPhotos.infinite', variables];

export const useSuspenseInfiniteGalleryPhotosQuery = <
      TData = InfiniteData<GalleryPhotosQuery>,
      TError = unknown
    >(
      variables: GalleryPhotosQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<GalleryPhotosQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<GalleryPhotosQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<GalleryPhotosQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GalleryPhotos.infinite', variables],
      queryFn: (metaData) => fetchData<GalleryPhotosQuery, GalleryPhotosQueryVariables>(GalleryPhotosDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteGalleryPhotosQuery.getKey = (variables: GalleryPhotosQueryVariables) => ['GalleryPhotos.infinite', variables];


useGalleryPhotosQuery.fetcher = (variables: GalleryPhotosQueryVariables, options?: RequestInit['headers']) => fetchData<GalleryPhotosQuery, GalleryPhotosQueryVariables>(GalleryPhotosDocument, variables, options);

export const RecentGalleriesDocument = `
    query RecentGalleries($take: Int = 3) {
  recentGalleries(take: $take) {
    id
    title
    intro
    photographer
    urlstub
    year
    leadPhotoUrl
  }
}
    `;

export const useRecentGalleriesQuery = <
      TData = RecentGalleriesQuery,
      TError = unknown
    >(
      variables?: RecentGalleriesQueryVariables,
      options?: Omit<UseQueryOptions<RecentGalleriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<RecentGalleriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<RecentGalleriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['RecentGalleries'] : ['RecentGalleries', variables],
    queryFn: fetchData<RecentGalleriesQuery, RecentGalleriesQueryVariables>(RecentGalleriesDocument, variables),
    ...options
  }
    )};

useRecentGalleriesQuery.getKey = (variables?: RecentGalleriesQueryVariables) => variables === undefined ? ['RecentGalleries'] : ['RecentGalleries', variables];

export const useSuspenseRecentGalleriesQuery = <
      TData = RecentGalleriesQuery,
      TError = unknown
    >(
      variables?: RecentGalleriesQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<RecentGalleriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<RecentGalleriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<RecentGalleriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['RecentGalleries'] : ['RecentGalleries', variables],
    queryFn: fetchData<RecentGalleriesQuery, RecentGalleriesQueryVariables>(RecentGalleriesDocument, variables),
    ...options
  }
    )};

useSuspenseRecentGalleriesQuery.getKey = (variables?: RecentGalleriesQueryVariables) => variables === undefined ? ['RecentGalleries'] : ['RecentGalleries', variables];

export const useInfiniteRecentGalleriesQuery = <
      TData = InfiniteData<RecentGalleriesQuery>,
      TError = unknown
    >(
      variables: RecentGalleriesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<RecentGalleriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<RecentGalleriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<RecentGalleriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['RecentGalleries.infinite'] : ['RecentGalleries.infinite', variables],
      queryFn: (metaData) => fetchData<RecentGalleriesQuery, RecentGalleriesQueryVariables>(RecentGalleriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteRecentGalleriesQuery.getKey = (variables?: RecentGalleriesQueryVariables) => variables === undefined ? ['RecentGalleries.infinite'] : ['RecentGalleries.infinite', variables];

export const useSuspenseInfiniteRecentGalleriesQuery = <
      TData = InfiniteData<RecentGalleriesQuery>,
      TError = unknown
    >(
      variables: RecentGalleriesQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<RecentGalleriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<RecentGalleriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<RecentGalleriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['RecentGalleries.infinite'] : ['RecentGalleries.infinite', variables],
      queryFn: (metaData) => fetchData<RecentGalleriesQuery, RecentGalleriesQueryVariables>(RecentGalleriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteRecentGalleriesQuery.getKey = (variables?: RecentGalleriesQueryVariables) => variables === undefined ? ['RecentGalleries.infinite'] : ['RecentGalleries.infinite', variables];


useRecentGalleriesQuery.fetcher = (variables?: RecentGalleriesQueryVariables, options?: RequestInit['headers']) => fetchData<RecentGalleriesQuery, RecentGalleriesQueryVariables>(RecentGalleriesDocument, variables, options);

export const JobsDocument = `
    query Jobs {
  blogPosts(
    skip: null
    take: 10
    brandCode: "VANISHING_INC_US"
    where: {category: {urlStub: {contains: "jobs"}}}
  ) {
    totalCount
    items {
      thumbnailSrc
      urlStub
      id
      title
      category {
        id
        name
        urlStub
      }
    }
  }
}
    `;

export const useJobsQuery = <
      TData = JobsQuery,
      TError = unknown
    >(
      variables?: JobsQueryVariables,
      options?: Omit<UseQueryOptions<JobsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<JobsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<JobsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Jobs'] : ['Jobs', variables],
    queryFn: fetchData<JobsQuery, JobsQueryVariables>(JobsDocument, variables),
    ...options
  }
    )};

useJobsQuery.getKey = (variables?: JobsQueryVariables) => variables === undefined ? ['Jobs'] : ['Jobs', variables];

export const useSuspenseJobsQuery = <
      TData = JobsQuery,
      TError = unknown
    >(
      variables?: JobsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<JobsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<JobsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<JobsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Jobs'] : ['Jobs', variables],
    queryFn: fetchData<JobsQuery, JobsQueryVariables>(JobsDocument, variables),
    ...options
  }
    )};

useSuspenseJobsQuery.getKey = (variables?: JobsQueryVariables) => variables === undefined ? ['Jobs'] : ['Jobs', variables];

export const useInfiniteJobsQuery = <
      TData = InfiniteData<JobsQuery>,
      TError = unknown
    >(
      variables: JobsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<JobsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<JobsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<JobsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Jobs.infinite'] : ['Jobs.infinite', variables],
      queryFn: (metaData) => fetchData<JobsQuery, JobsQueryVariables>(JobsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteJobsQuery.getKey = (variables?: JobsQueryVariables) => variables === undefined ? ['Jobs.infinite'] : ['Jobs.infinite', variables];

export const useSuspenseInfiniteJobsQuery = <
      TData = InfiniteData<JobsQuery>,
      TError = unknown
    >(
      variables: JobsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<JobsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<JobsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<JobsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Jobs.infinite'] : ['Jobs.infinite', variables],
      queryFn: (metaData) => fetchData<JobsQuery, JobsQueryVariables>(JobsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteJobsQuery.getKey = (variables?: JobsQueryVariables) => variables === undefined ? ['Jobs.infinite'] : ['Jobs.infinite', variables];


useJobsQuery.fetcher = (variables?: JobsQueryVariables, options?: RequestInit['headers']) => fetchData<JobsQuery, JobsQueryVariables>(JobsDocument, variables, options);

export const JobsByBrandDocument = `
    query JobsByBrand($brandCode: String!) {
  pagesByCategory(categorySlug: "jobs", skip: 0, take: 50, brandCode: $brandCode) {
    items {
      id
      thumbnailSrc
      urlStub
      title
      live
    }
  }
}
    `;

export const useJobsByBrandQuery = <
      TData = JobsByBrandQuery,
      TError = unknown
    >(
      variables: JobsByBrandQueryVariables,
      options?: Omit<UseQueryOptions<JobsByBrandQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<JobsByBrandQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<JobsByBrandQuery, TError, TData>(
      {
    queryKey: ['JobsByBrand', variables],
    queryFn: fetchData<JobsByBrandQuery, JobsByBrandQueryVariables>(JobsByBrandDocument, variables),
    ...options
  }
    )};

useJobsByBrandQuery.getKey = (variables: JobsByBrandQueryVariables) => ['JobsByBrand', variables];

export const useSuspenseJobsByBrandQuery = <
      TData = JobsByBrandQuery,
      TError = unknown
    >(
      variables: JobsByBrandQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<JobsByBrandQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<JobsByBrandQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<JobsByBrandQuery, TError, TData>(
      {
    queryKey: ['JobsByBrand', variables],
    queryFn: fetchData<JobsByBrandQuery, JobsByBrandQueryVariables>(JobsByBrandDocument, variables),
    ...options
  }
    )};

useSuspenseJobsByBrandQuery.getKey = (variables: JobsByBrandQueryVariables) => ['JobsByBrand', variables];

export const useInfiniteJobsByBrandQuery = <
      TData = InfiniteData<JobsByBrandQuery>,
      TError = unknown
    >(
      variables: JobsByBrandQueryVariables,
      options: Omit<UseInfiniteQueryOptions<JobsByBrandQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<JobsByBrandQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<JobsByBrandQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['JobsByBrand.infinite', variables],
      queryFn: (metaData) => fetchData<JobsByBrandQuery, JobsByBrandQueryVariables>(JobsByBrandDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteJobsByBrandQuery.getKey = (variables: JobsByBrandQueryVariables) => ['JobsByBrand.infinite', variables];

export const useSuspenseInfiniteJobsByBrandQuery = <
      TData = InfiniteData<JobsByBrandQuery>,
      TError = unknown
    >(
      variables: JobsByBrandQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<JobsByBrandQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<JobsByBrandQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<JobsByBrandQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['JobsByBrand.infinite', variables],
      queryFn: (metaData) => fetchData<JobsByBrandQuery, JobsByBrandQueryVariables>(JobsByBrandDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteJobsByBrandQuery.getKey = (variables: JobsByBrandQueryVariables) => ['JobsByBrand.infinite', variables];


useJobsByBrandQuery.fetcher = (variables: JobsByBrandQueryVariables, options?: RequestInit['headers']) => fetchData<JobsByBrandQuery, JobsByBrandQueryVariables>(JobsByBrandDocument, variables, options);

export const CountriesDocument = `
    query Countries($order: [CountryDtoSortInput!]) {
  countries(order: $order) {
    id
    name
    isoCode
    brandCode
    currencyCode
  }
}
    `;

export const useCountriesQuery = <
      TData = CountriesQuery,
      TError = unknown
    >(
      variables?: CountriesQueryVariables,
      options?: Omit<UseQueryOptions<CountriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CountriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CountriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Countries'] : ['Countries', variables],
    queryFn: fetchData<CountriesQuery, CountriesQueryVariables>(CountriesDocument, variables),
    ...options
  }
    )};

useCountriesQuery.getKey = (variables?: CountriesQueryVariables) => variables === undefined ? ['Countries'] : ['Countries', variables];

export const useSuspenseCountriesQuery = <
      TData = CountriesQuery,
      TError = unknown
    >(
      variables?: CountriesQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CountriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CountriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CountriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Countries'] : ['Countries', variables],
    queryFn: fetchData<CountriesQuery, CountriesQueryVariables>(CountriesDocument, variables),
    ...options
  }
    )};

useSuspenseCountriesQuery.getKey = (variables?: CountriesQueryVariables) => variables === undefined ? ['Countries'] : ['Countries', variables];

export const useInfiniteCountriesQuery = <
      TData = InfiniteData<CountriesQuery>,
      TError = unknown
    >(
      variables: CountriesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CountriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CountriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CountriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Countries.infinite'] : ['Countries.infinite', variables],
      queryFn: (metaData) => fetchData<CountriesQuery, CountriesQueryVariables>(CountriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCountriesQuery.getKey = (variables?: CountriesQueryVariables) => variables === undefined ? ['Countries.infinite'] : ['Countries.infinite', variables];

export const useSuspenseInfiniteCountriesQuery = <
      TData = InfiniteData<CountriesQuery>,
      TError = unknown
    >(
      variables: CountriesQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CountriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CountriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CountriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Countries.infinite'] : ['Countries.infinite', variables],
      queryFn: (metaData) => fetchData<CountriesQuery, CountriesQueryVariables>(CountriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCountriesQuery.getKey = (variables?: CountriesQueryVariables) => variables === undefined ? ['Countries.infinite'] : ['Countries.infinite', variables];


useCountriesQuery.fetcher = (variables?: CountriesQueryVariables, options?: RequestInit['headers']) => fetchData<CountriesQuery, CountriesQueryVariables>(CountriesDocument, variables, options);

export const CountryShippingStatusDocument = `
    query CountryShippingStatus($isoCode: String!) {
  countryByIsoCode(isoCode: $isoCode) {
    id
    isoCode
    freeShipping
  }
}
    `;

export const useCountryShippingStatusQuery = <
      TData = CountryShippingStatusQuery,
      TError = unknown
    >(
      variables: CountryShippingStatusQueryVariables,
      options?: Omit<UseQueryOptions<CountryShippingStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CountryShippingStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CountryShippingStatusQuery, TError, TData>(
      {
    queryKey: ['CountryShippingStatus', variables],
    queryFn: fetchData<CountryShippingStatusQuery, CountryShippingStatusQueryVariables>(CountryShippingStatusDocument, variables),
    ...options
  }
    )};

useCountryShippingStatusQuery.getKey = (variables: CountryShippingStatusQueryVariables) => ['CountryShippingStatus', variables];

export const useSuspenseCountryShippingStatusQuery = <
      TData = CountryShippingStatusQuery,
      TError = unknown
    >(
      variables: CountryShippingStatusQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CountryShippingStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CountryShippingStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CountryShippingStatusQuery, TError, TData>(
      {
    queryKey: ['CountryShippingStatus', variables],
    queryFn: fetchData<CountryShippingStatusQuery, CountryShippingStatusQueryVariables>(CountryShippingStatusDocument, variables),
    ...options
  }
    )};

useSuspenseCountryShippingStatusQuery.getKey = (variables: CountryShippingStatusQueryVariables) => ['CountryShippingStatus', variables];

export const useInfiniteCountryShippingStatusQuery = <
      TData = InfiniteData<CountryShippingStatusQuery>,
      TError = unknown
    >(
      variables: CountryShippingStatusQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CountryShippingStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CountryShippingStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CountryShippingStatusQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CountryShippingStatus.infinite', variables],
      queryFn: (metaData) => fetchData<CountryShippingStatusQuery, CountryShippingStatusQueryVariables>(CountryShippingStatusDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCountryShippingStatusQuery.getKey = (variables: CountryShippingStatusQueryVariables) => ['CountryShippingStatus.infinite', variables];

export const useSuspenseInfiniteCountryShippingStatusQuery = <
      TData = InfiniteData<CountryShippingStatusQuery>,
      TError = unknown
    >(
      variables: CountryShippingStatusQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CountryShippingStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CountryShippingStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CountryShippingStatusQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CountryShippingStatus.infinite', variables],
      queryFn: (metaData) => fetchData<CountryShippingStatusQuery, CountryShippingStatusQueryVariables>(CountryShippingStatusDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCountryShippingStatusQuery.getKey = (variables: CountryShippingStatusQueryVariables) => ['CountryShippingStatus.infinite', variables];


useCountryShippingStatusQuery.fetcher = (variables: CountryShippingStatusQueryVariables, options?: RequestInit['headers']) => fetchData<CountryShippingStatusQuery, CountryShippingStatusQueryVariables>(CountryShippingStatusDocument, variables, options);

export const CurrenciesDocument = `
    query Currencies {
  currencies {
    code
    id
    symbol
  }
}
    `;

export const useCurrenciesQuery = <
      TData = CurrenciesQuery,
      TError = unknown
    >(
      variables?: CurrenciesQueryVariables,
      options?: Omit<UseQueryOptions<CurrenciesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CurrenciesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CurrenciesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Currencies'] : ['Currencies', variables],
    queryFn: fetchData<CurrenciesQuery, CurrenciesQueryVariables>(CurrenciesDocument, variables),
    ...options
  }
    )};

useCurrenciesQuery.getKey = (variables?: CurrenciesQueryVariables) => variables === undefined ? ['Currencies'] : ['Currencies', variables];

export const useSuspenseCurrenciesQuery = <
      TData = CurrenciesQuery,
      TError = unknown
    >(
      variables?: CurrenciesQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CurrenciesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CurrenciesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CurrenciesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Currencies'] : ['Currencies', variables],
    queryFn: fetchData<CurrenciesQuery, CurrenciesQueryVariables>(CurrenciesDocument, variables),
    ...options
  }
    )};

useSuspenseCurrenciesQuery.getKey = (variables?: CurrenciesQueryVariables) => variables === undefined ? ['Currencies'] : ['Currencies', variables];

export const useInfiniteCurrenciesQuery = <
      TData = InfiniteData<CurrenciesQuery>,
      TError = unknown
    >(
      variables: CurrenciesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CurrenciesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CurrenciesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CurrenciesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Currencies.infinite'] : ['Currencies.infinite', variables],
      queryFn: (metaData) => fetchData<CurrenciesQuery, CurrenciesQueryVariables>(CurrenciesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCurrenciesQuery.getKey = (variables?: CurrenciesQueryVariables) => variables === undefined ? ['Currencies.infinite'] : ['Currencies.infinite', variables];

export const useSuspenseInfiniteCurrenciesQuery = <
      TData = InfiniteData<CurrenciesQuery>,
      TError = unknown
    >(
      variables: CurrenciesQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CurrenciesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CurrenciesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CurrenciesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Currencies.infinite'] : ['Currencies.infinite', variables],
      queryFn: (metaData) => fetchData<CurrenciesQuery, CurrenciesQueryVariables>(CurrenciesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCurrenciesQuery.getKey = (variables?: CurrenciesQueryVariables) => variables === undefined ? ['Currencies.infinite'] : ['Currencies.infinite', variables];


useCurrenciesQuery.fetcher = (variables?: CurrenciesQueryVariables, options?: RequestInit['headers']) => fetchData<CurrenciesQuery, CurrenciesQueryVariables>(CurrenciesDocument, variables, options);

export const EcommBrandByCountryDocument = `
    query EcommBrandByCountry($country: String!) {
  ecommBrandByCountry(country: $country) {
    id
    name
    currency {
      id
      code
      symbol
    }
  }
}
    `;

export const useEcommBrandByCountryQuery = <
      TData = EcommBrandByCountryQuery,
      TError = unknown
    >(
      variables: EcommBrandByCountryQueryVariables,
      options?: Omit<UseQueryOptions<EcommBrandByCountryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<EcommBrandByCountryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<EcommBrandByCountryQuery, TError, TData>(
      {
    queryKey: ['EcommBrandByCountry', variables],
    queryFn: fetchData<EcommBrandByCountryQuery, EcommBrandByCountryQueryVariables>(EcommBrandByCountryDocument, variables),
    ...options
  }
    )};

useEcommBrandByCountryQuery.getKey = (variables: EcommBrandByCountryQueryVariables) => ['EcommBrandByCountry', variables];

export const useSuspenseEcommBrandByCountryQuery = <
      TData = EcommBrandByCountryQuery,
      TError = unknown
    >(
      variables: EcommBrandByCountryQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<EcommBrandByCountryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<EcommBrandByCountryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<EcommBrandByCountryQuery, TError, TData>(
      {
    queryKey: ['EcommBrandByCountry', variables],
    queryFn: fetchData<EcommBrandByCountryQuery, EcommBrandByCountryQueryVariables>(EcommBrandByCountryDocument, variables),
    ...options
  }
    )};

useSuspenseEcommBrandByCountryQuery.getKey = (variables: EcommBrandByCountryQueryVariables) => ['EcommBrandByCountry', variables];

export const useInfiniteEcommBrandByCountryQuery = <
      TData = InfiniteData<EcommBrandByCountryQuery>,
      TError = unknown
    >(
      variables: EcommBrandByCountryQueryVariables,
      options: Omit<UseInfiniteQueryOptions<EcommBrandByCountryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<EcommBrandByCountryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<EcommBrandByCountryQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['EcommBrandByCountry.infinite', variables],
      queryFn: (metaData) => fetchData<EcommBrandByCountryQuery, EcommBrandByCountryQueryVariables>(EcommBrandByCountryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteEcommBrandByCountryQuery.getKey = (variables: EcommBrandByCountryQueryVariables) => ['EcommBrandByCountry.infinite', variables];

export const useSuspenseInfiniteEcommBrandByCountryQuery = <
      TData = InfiniteData<EcommBrandByCountryQuery>,
      TError = unknown
    >(
      variables: EcommBrandByCountryQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<EcommBrandByCountryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<EcommBrandByCountryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<EcommBrandByCountryQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['EcommBrandByCountry.infinite', variables],
      queryFn: (metaData) => fetchData<EcommBrandByCountryQuery, EcommBrandByCountryQueryVariables>(EcommBrandByCountryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteEcommBrandByCountryQuery.getKey = (variables: EcommBrandByCountryQueryVariables) => ['EcommBrandByCountry.infinite', variables];


useEcommBrandByCountryQuery.fetcher = (variables: EcommBrandByCountryQueryVariables, options?: RequestInit['headers']) => fetchData<EcommBrandByCountryQuery, EcommBrandByCountryQueryVariables>(EcommBrandByCountryDocument, variables, options);

export const StatesDocument = `
    query States($countryId: Int!) {
  states(countryId: $countryId) {
    abbreviation
    country {
      id
      name
    }
    id
    name
  }
}
    `;

export const useStatesQuery = <
      TData = StatesQuery,
      TError = unknown
    >(
      variables: StatesQueryVariables,
      options?: Omit<UseQueryOptions<StatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<StatesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<StatesQuery, TError, TData>(
      {
    queryKey: ['States', variables],
    queryFn: fetchData<StatesQuery, StatesQueryVariables>(StatesDocument, variables),
    ...options
  }
    )};

useStatesQuery.getKey = (variables: StatesQueryVariables) => ['States', variables];

export const useSuspenseStatesQuery = <
      TData = StatesQuery,
      TError = unknown
    >(
      variables: StatesQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<StatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<StatesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<StatesQuery, TError, TData>(
      {
    queryKey: ['States', variables],
    queryFn: fetchData<StatesQuery, StatesQueryVariables>(StatesDocument, variables),
    ...options
  }
    )};

useSuspenseStatesQuery.getKey = (variables: StatesQueryVariables) => ['States', variables];

export const useInfiniteStatesQuery = <
      TData = InfiniteData<StatesQuery>,
      TError = unknown
    >(
      variables: StatesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<StatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<StatesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<StatesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['States.infinite', variables],
      queryFn: (metaData) => fetchData<StatesQuery, StatesQueryVariables>(StatesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteStatesQuery.getKey = (variables: StatesQueryVariables) => ['States.infinite', variables];

export const useSuspenseInfiniteStatesQuery = <
      TData = InfiniteData<StatesQuery>,
      TError = unknown
    >(
      variables: StatesQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<StatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<StatesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<StatesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['States.infinite', variables],
      queryFn: (metaData) => fetchData<StatesQuery, StatesQueryVariables>(StatesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteStatesQuery.getKey = (variables: StatesQueryVariables) => ['States.infinite', variables];


useStatesQuery.fetcher = (variables: StatesQueryVariables, options?: RequestInit['headers']) => fetchData<StatesQuery, StatesQueryVariables>(StatesDocument, variables, options);

export const NewsletterMarketingDefaultPreCheckedDocument = `
    query NewsletterMarketingDefaultPreChecked($countryIsoCode: String) {
  newsletterMarketingDefaultPreChecked(countryIsoCode: $countryIsoCode)
}
    `;

export const useNewsletterMarketingDefaultPreCheckedQuery = <
      TData = NewsletterMarketingDefaultPreCheckedQuery,
      TError = unknown
    >(
      variables?: NewsletterMarketingDefaultPreCheckedQueryVariables,
      options?: Omit<UseQueryOptions<NewsletterMarketingDefaultPreCheckedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<NewsletterMarketingDefaultPreCheckedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<NewsletterMarketingDefaultPreCheckedQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['NewsletterMarketingDefaultPreChecked'] : ['NewsletterMarketingDefaultPreChecked', variables],
    queryFn: fetchData<NewsletterMarketingDefaultPreCheckedQuery, NewsletterMarketingDefaultPreCheckedQueryVariables>(NewsletterMarketingDefaultPreCheckedDocument, variables),
    ...options
  }
    )};

useNewsletterMarketingDefaultPreCheckedQuery.getKey = (variables?: NewsletterMarketingDefaultPreCheckedQueryVariables) => variables === undefined ? ['NewsletterMarketingDefaultPreChecked'] : ['NewsletterMarketingDefaultPreChecked', variables];

export const useSuspenseNewsletterMarketingDefaultPreCheckedQuery = <
      TData = NewsletterMarketingDefaultPreCheckedQuery,
      TError = unknown
    >(
      variables?: NewsletterMarketingDefaultPreCheckedQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<NewsletterMarketingDefaultPreCheckedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<NewsletterMarketingDefaultPreCheckedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<NewsletterMarketingDefaultPreCheckedQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['NewsletterMarketingDefaultPreChecked'] : ['NewsletterMarketingDefaultPreChecked', variables],
    queryFn: fetchData<NewsletterMarketingDefaultPreCheckedQuery, NewsletterMarketingDefaultPreCheckedQueryVariables>(NewsletterMarketingDefaultPreCheckedDocument, variables),
    ...options
  }
    )};

useSuspenseNewsletterMarketingDefaultPreCheckedQuery.getKey = (variables?: NewsletterMarketingDefaultPreCheckedQueryVariables) => variables === undefined ? ['NewsletterMarketingDefaultPreChecked'] : ['NewsletterMarketingDefaultPreChecked', variables];

export const useInfiniteNewsletterMarketingDefaultPreCheckedQuery = <
      TData = InfiniteData<NewsletterMarketingDefaultPreCheckedQuery>,
      TError = unknown
    >(
      variables: NewsletterMarketingDefaultPreCheckedQueryVariables,
      options: Omit<UseInfiniteQueryOptions<NewsletterMarketingDefaultPreCheckedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<NewsletterMarketingDefaultPreCheckedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<NewsletterMarketingDefaultPreCheckedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['NewsletterMarketingDefaultPreChecked.infinite'] : ['NewsletterMarketingDefaultPreChecked.infinite', variables],
      queryFn: (metaData) => fetchData<NewsletterMarketingDefaultPreCheckedQuery, NewsletterMarketingDefaultPreCheckedQueryVariables>(NewsletterMarketingDefaultPreCheckedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteNewsletterMarketingDefaultPreCheckedQuery.getKey = (variables?: NewsletterMarketingDefaultPreCheckedQueryVariables) => variables === undefined ? ['NewsletterMarketingDefaultPreChecked.infinite'] : ['NewsletterMarketingDefaultPreChecked.infinite', variables];

export const useSuspenseInfiniteNewsletterMarketingDefaultPreCheckedQuery = <
      TData = InfiniteData<NewsletterMarketingDefaultPreCheckedQuery>,
      TError = unknown
    >(
      variables: NewsletterMarketingDefaultPreCheckedQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<NewsletterMarketingDefaultPreCheckedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<NewsletterMarketingDefaultPreCheckedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<NewsletterMarketingDefaultPreCheckedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['NewsletterMarketingDefaultPreChecked.infinite'] : ['NewsletterMarketingDefaultPreChecked.infinite', variables],
      queryFn: (metaData) => fetchData<NewsletterMarketingDefaultPreCheckedQuery, NewsletterMarketingDefaultPreCheckedQueryVariables>(NewsletterMarketingDefaultPreCheckedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteNewsletterMarketingDefaultPreCheckedQuery.getKey = (variables?: NewsletterMarketingDefaultPreCheckedQueryVariables) => variables === undefined ? ['NewsletterMarketingDefaultPreChecked.infinite'] : ['NewsletterMarketingDefaultPreChecked.infinite', variables];


useNewsletterMarketingDefaultPreCheckedQuery.fetcher = (variables?: NewsletterMarketingDefaultPreCheckedQueryVariables, options?: RequestInit['headers']) => fetchData<NewsletterMarketingDefaultPreCheckedQuery, NewsletterMarketingDefaultPreCheckedQueryVariables>(NewsletterMarketingDefaultPreCheckedDocument, variables, options);

export const NewsletterSubscribeDocument = `
    query NewsletterSubscribe($customerId: Int!, $countryIsoCode: String) {
  newsletterSubscribe(customerId: $customerId, countryIsoCode: $countryIsoCode) {
    showMainCheckoutUpsell
    defaultMainNewsletterPreChecked
  }
}
    `;

export const useNewsletterSubscribeQuery = <
      TData = NewsletterSubscribeQuery,
      TError = unknown
    >(
      variables: NewsletterSubscribeQueryVariables,
      options?: Omit<UseQueryOptions<NewsletterSubscribeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<NewsletterSubscribeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<NewsletterSubscribeQuery, TError, TData>(
      {
    queryKey: ['NewsletterSubscribe', variables],
    queryFn: fetchData<NewsletterSubscribeQuery, NewsletterSubscribeQueryVariables>(NewsletterSubscribeDocument, variables),
    ...options
  }
    )};

useNewsletterSubscribeQuery.getKey = (variables: NewsletterSubscribeQueryVariables) => ['NewsletterSubscribe', variables];

export const useSuspenseNewsletterSubscribeQuery = <
      TData = NewsletterSubscribeQuery,
      TError = unknown
    >(
      variables: NewsletterSubscribeQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<NewsletterSubscribeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<NewsletterSubscribeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<NewsletterSubscribeQuery, TError, TData>(
      {
    queryKey: ['NewsletterSubscribe', variables],
    queryFn: fetchData<NewsletterSubscribeQuery, NewsletterSubscribeQueryVariables>(NewsletterSubscribeDocument, variables),
    ...options
  }
    )};

useSuspenseNewsletterSubscribeQuery.getKey = (variables: NewsletterSubscribeQueryVariables) => ['NewsletterSubscribe', variables];

export const useInfiniteNewsletterSubscribeQuery = <
      TData = InfiniteData<NewsletterSubscribeQuery>,
      TError = unknown
    >(
      variables: NewsletterSubscribeQueryVariables,
      options: Omit<UseInfiniteQueryOptions<NewsletterSubscribeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<NewsletterSubscribeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<NewsletterSubscribeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['NewsletterSubscribe.infinite', variables],
      queryFn: (metaData) => fetchData<NewsletterSubscribeQuery, NewsletterSubscribeQueryVariables>(NewsletterSubscribeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteNewsletterSubscribeQuery.getKey = (variables: NewsletterSubscribeQueryVariables) => ['NewsletterSubscribe.infinite', variables];

export const useSuspenseInfiniteNewsletterSubscribeQuery = <
      TData = InfiniteData<NewsletterSubscribeQuery>,
      TError = unknown
    >(
      variables: NewsletterSubscribeQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<NewsletterSubscribeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<NewsletterSubscribeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<NewsletterSubscribeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['NewsletterSubscribe.infinite', variables],
      queryFn: (metaData) => fetchData<NewsletterSubscribeQuery, NewsletterSubscribeQueryVariables>(NewsletterSubscribeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteNewsletterSubscribeQuery.getKey = (variables: NewsletterSubscribeQueryVariables) => ['NewsletterSubscribe.infinite', variables];


useNewsletterSubscribeQuery.fetcher = (variables: NewsletterSubscribeQueryVariables, options?: RequestInit['headers']) => fetchData<NewsletterSubscribeQuery, NewsletterSubscribeQueryVariables>(NewsletterSubscribeDocument, variables, options);

export const CheckoutPaymentRecoveryStatusDocument = `
    query CheckoutPaymentRecoveryStatus($paymentIntentId: String!) {
  checkoutPaymentRecoveryStatus(paymentIntentId: $paymentIntentId) {
    paymentIntentId
    status
    message
    paymentSucceeded
    canRetry
    orderId
    shoppingCartId
  }
}
    `;

export const useCheckoutPaymentRecoveryStatusQuery = <
      TData = CheckoutPaymentRecoveryStatusQuery,
      TError = unknown
    >(
      variables: CheckoutPaymentRecoveryStatusQueryVariables,
      options?: Omit<UseQueryOptions<CheckoutPaymentRecoveryStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CheckoutPaymentRecoveryStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CheckoutPaymentRecoveryStatusQuery, TError, TData>(
      {
    queryKey: ['CheckoutPaymentRecoveryStatus', variables],
    queryFn: fetchData<CheckoutPaymentRecoveryStatusQuery, CheckoutPaymentRecoveryStatusQueryVariables>(CheckoutPaymentRecoveryStatusDocument, variables),
    ...options
  }
    )};

useCheckoutPaymentRecoveryStatusQuery.getKey = (variables: CheckoutPaymentRecoveryStatusQueryVariables) => ['CheckoutPaymentRecoveryStatus', variables];

export const useSuspenseCheckoutPaymentRecoveryStatusQuery = <
      TData = CheckoutPaymentRecoveryStatusQuery,
      TError = unknown
    >(
      variables: CheckoutPaymentRecoveryStatusQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CheckoutPaymentRecoveryStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CheckoutPaymentRecoveryStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CheckoutPaymentRecoveryStatusQuery, TError, TData>(
      {
    queryKey: ['CheckoutPaymentRecoveryStatus', variables],
    queryFn: fetchData<CheckoutPaymentRecoveryStatusQuery, CheckoutPaymentRecoveryStatusQueryVariables>(CheckoutPaymentRecoveryStatusDocument, variables),
    ...options
  }
    )};

useSuspenseCheckoutPaymentRecoveryStatusQuery.getKey = (variables: CheckoutPaymentRecoveryStatusQueryVariables) => ['CheckoutPaymentRecoveryStatus', variables];

export const useInfiniteCheckoutPaymentRecoveryStatusQuery = <
      TData = InfiniteData<CheckoutPaymentRecoveryStatusQuery>,
      TError = unknown
    >(
      variables: CheckoutPaymentRecoveryStatusQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CheckoutPaymentRecoveryStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CheckoutPaymentRecoveryStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CheckoutPaymentRecoveryStatusQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CheckoutPaymentRecoveryStatus.infinite', variables],
      queryFn: (metaData) => fetchData<CheckoutPaymentRecoveryStatusQuery, CheckoutPaymentRecoveryStatusQueryVariables>(CheckoutPaymentRecoveryStatusDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCheckoutPaymentRecoveryStatusQuery.getKey = (variables: CheckoutPaymentRecoveryStatusQueryVariables) => ['CheckoutPaymentRecoveryStatus.infinite', variables];

export const useSuspenseInfiniteCheckoutPaymentRecoveryStatusQuery = <
      TData = InfiniteData<CheckoutPaymentRecoveryStatusQuery>,
      TError = unknown
    >(
      variables: CheckoutPaymentRecoveryStatusQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CheckoutPaymentRecoveryStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CheckoutPaymentRecoveryStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CheckoutPaymentRecoveryStatusQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CheckoutPaymentRecoveryStatus.infinite', variables],
      queryFn: (metaData) => fetchData<CheckoutPaymentRecoveryStatusQuery, CheckoutPaymentRecoveryStatusQueryVariables>(CheckoutPaymentRecoveryStatusDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCheckoutPaymentRecoveryStatusQuery.getKey = (variables: CheckoutPaymentRecoveryStatusQueryVariables) => ['CheckoutPaymentRecoveryStatus.infinite', variables];


useCheckoutPaymentRecoveryStatusQuery.fetcher = (variables: CheckoutPaymentRecoveryStatusQueryVariables, options?: RequestInit['headers']) => fetchData<CheckoutPaymentRecoveryStatusQuery, CheckoutPaymentRecoveryStatusQueryVariables>(CheckoutPaymentRecoveryStatusDocument, variables, options);

export const CustomerReturnsDocument = `
    query CustomerReturns($skip: Int!, $take: Int!) {
  returnsForCustomer(skip: $skip, take: $take) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      dateReceived
      dateRequested
      status
      returnTracking
      shippingRefundAmount
      order {
        id
      }
      items {
        id
        orderItemId
        reasonId
        notes
        action
        product {
          name
        }
      }
    }
  }
}
    `;

export const useCustomerReturnsQuery = <
      TData = CustomerReturnsQuery,
      TError = unknown
    >(
      variables: CustomerReturnsQueryVariables,
      options?: Omit<UseQueryOptions<CustomerReturnsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerReturnsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerReturnsQuery, TError, TData>(
      {
    queryKey: ['CustomerReturns', variables],
    queryFn: fetchData<CustomerReturnsQuery, CustomerReturnsQueryVariables>(CustomerReturnsDocument, variables),
    ...options
  }
    )};

useCustomerReturnsQuery.getKey = (variables: CustomerReturnsQueryVariables) => ['CustomerReturns', variables];

export const useSuspenseCustomerReturnsQuery = <
      TData = CustomerReturnsQuery,
      TError = unknown
    >(
      variables: CustomerReturnsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerReturnsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerReturnsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerReturnsQuery, TError, TData>(
      {
    queryKey: ['CustomerReturns', variables],
    queryFn: fetchData<CustomerReturnsQuery, CustomerReturnsQueryVariables>(CustomerReturnsDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerReturnsQuery.getKey = (variables: CustomerReturnsQueryVariables) => ['CustomerReturns', variables];

export const useInfiniteCustomerReturnsQuery = <
      TData = InfiniteData<CustomerReturnsQuery>,
      TError = unknown
    >(
      variables: CustomerReturnsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerReturnsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerReturnsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerReturnsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomerReturns.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerReturnsQuery, CustomerReturnsQueryVariables>(CustomerReturnsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerReturnsQuery.getKey = (variables: CustomerReturnsQueryVariables) => ['CustomerReturns.infinite', variables];

export const useSuspenseInfiniteCustomerReturnsQuery = <
      TData = InfiniteData<CustomerReturnsQuery>,
      TError = unknown
    >(
      variables: CustomerReturnsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerReturnsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerReturnsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerReturnsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomerReturns.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerReturnsQuery, CustomerReturnsQueryVariables>(CustomerReturnsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerReturnsQuery.getKey = (variables: CustomerReturnsQueryVariables) => ['CustomerReturns.infinite', variables];


useCustomerReturnsQuery.fetcher = (variables: CustomerReturnsQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerReturnsQuery, CustomerReturnsQueryVariables>(CustomerReturnsDocument, variables, options);

export const InTransitPackagesDocument = `
    query InTransitPackages {
  inTransitPackagesForCustomer {
    orderId
    orderDate
    trackingNumber
    trackingUrl
  }
}
    `;

export const useInTransitPackagesQuery = <
      TData = InTransitPackagesQuery,
      TError = unknown
    >(
      variables?: InTransitPackagesQueryVariables,
      options?: Omit<UseQueryOptions<InTransitPackagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<InTransitPackagesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<InTransitPackagesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['InTransitPackages'] : ['InTransitPackages', variables],
    queryFn: fetchData<InTransitPackagesQuery, InTransitPackagesQueryVariables>(InTransitPackagesDocument, variables),
    ...options
  }
    )};

useInTransitPackagesQuery.getKey = (variables?: InTransitPackagesQueryVariables) => variables === undefined ? ['InTransitPackages'] : ['InTransitPackages', variables];

export const useSuspenseInTransitPackagesQuery = <
      TData = InTransitPackagesQuery,
      TError = unknown
    >(
      variables?: InTransitPackagesQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<InTransitPackagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<InTransitPackagesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<InTransitPackagesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['InTransitPackages'] : ['InTransitPackages', variables],
    queryFn: fetchData<InTransitPackagesQuery, InTransitPackagesQueryVariables>(InTransitPackagesDocument, variables),
    ...options
  }
    )};

useSuspenseInTransitPackagesQuery.getKey = (variables?: InTransitPackagesQueryVariables) => variables === undefined ? ['InTransitPackages'] : ['InTransitPackages', variables];

export const useInfiniteInTransitPackagesQuery = <
      TData = InfiniteData<InTransitPackagesQuery>,
      TError = unknown
    >(
      variables: InTransitPackagesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<InTransitPackagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<InTransitPackagesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<InTransitPackagesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['InTransitPackages.infinite'] : ['InTransitPackages.infinite', variables],
      queryFn: (metaData) => fetchData<InTransitPackagesQuery, InTransitPackagesQueryVariables>(InTransitPackagesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteInTransitPackagesQuery.getKey = (variables?: InTransitPackagesQueryVariables) => variables === undefined ? ['InTransitPackages.infinite'] : ['InTransitPackages.infinite', variables];

export const useSuspenseInfiniteInTransitPackagesQuery = <
      TData = InfiniteData<InTransitPackagesQuery>,
      TError = unknown
    >(
      variables: InTransitPackagesQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<InTransitPackagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<InTransitPackagesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<InTransitPackagesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['InTransitPackages.infinite'] : ['InTransitPackages.infinite', variables],
      queryFn: (metaData) => fetchData<InTransitPackagesQuery, InTransitPackagesQueryVariables>(InTransitPackagesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteInTransitPackagesQuery.getKey = (variables?: InTransitPackagesQueryVariables) => variables === undefined ? ['InTransitPackages.infinite'] : ['InTransitPackages.infinite', variables];


useInTransitPackagesQuery.fetcher = (variables?: InTransitPackagesQueryVariables, options?: RequestInit['headers']) => fetchData<InTransitPackagesQuery, InTransitPackagesQueryVariables>(InTransitPackagesDocument, variables, options);

export const OrderDocument = `
    query Order($orderId: Int!) {
  order(orderId: $orderId) {
    id
    orderDate
    statusDescription
    totalPrice
    currency {
      id
      symbol
      code
    }
    packages {
      id
      carrier {
        name
        contactPhone
        logoUrl
      }
      deliveredDate
      dispatchedDate
      errorDescription
      id
      service
      shippingMethod
      status
      trackingNumber
      orderItems {
        id
        productName
      }
    }
    timeline {
      id
      time
      note
      noteType
    }
    orderItems {
      id
      productId
      instructionLink
      priceCharged
      quantity
      returnId
      tax
      productName
      productType
      optionDescription
      hasInstructions
      hasDownloads
      dispatchedDate
      thumbnailSrc
      url
      needsShipping
    }
    shippingAddress {
      addressLine1
      addressLine2
      city
      id
      firstName
      lastName
      zip
      country {
        id
        isoCode
        name
      }
      state {
        id
        name
      }
    }
    totalTax
    shippingPrice
    shippingMethod
    itemCount
    canChangeShippingAddress
  }
}
    `;

export const useOrderQuery = <
      TData = OrderQuery,
      TError = unknown
    >(
      variables: OrderQueryVariables,
      options?: Omit<UseQueryOptions<OrderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrderQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrderQuery, TError, TData>(
      {
    queryKey: ['Order', variables],
    queryFn: fetchData<OrderQuery, OrderQueryVariables>(OrderDocument, variables),
    ...options
  }
    )};

useOrderQuery.getKey = (variables: OrderQueryVariables) => ['Order', variables];

export const useSuspenseOrderQuery = <
      TData = OrderQuery,
      TError = unknown
    >(
      variables: OrderQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<OrderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<OrderQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<OrderQuery, TError, TData>(
      {
    queryKey: ['Order', variables],
    queryFn: fetchData<OrderQuery, OrderQueryVariables>(OrderDocument, variables),
    ...options
  }
    )};

useSuspenseOrderQuery.getKey = (variables: OrderQueryVariables) => ['Order', variables];

export const useInfiniteOrderQuery = <
      TData = InfiniteData<OrderQuery>,
      TError = unknown
    >(
      variables: OrderQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrderQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<OrderQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Order.infinite', variables],
      queryFn: (metaData) => fetchData<OrderQuery, OrderQueryVariables>(OrderDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteOrderQuery.getKey = (variables: OrderQueryVariables) => ['Order.infinite', variables];

export const useSuspenseInfiniteOrderQuery = <
      TData = InfiniteData<OrderQuery>,
      TError = unknown
    >(
      variables: OrderQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<OrderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<OrderQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<OrderQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Order.infinite', variables],
      queryFn: (metaData) => fetchData<OrderQuery, OrderQueryVariables>(OrderDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteOrderQuery.getKey = (variables: OrderQueryVariables) => ['Order.infinite', variables];


useOrderQuery.fetcher = (variables: OrderQueryVariables, options?: RequestInit['headers']) => fetchData<OrderQuery, OrderQueryVariables>(OrderDocument, variables, options);

export const OrderByPaymentIntentIdDocument = `
    query OrderByPaymentIntentId($paymentIntentId: String!) {
  orderByPaymentIntentId(paymentIntentId: $paymentIntentId) {
    id
    orderDate
    statusDescription
    totalPrice
    currency {
      id
      symbol
      code
    }
  }
}
    `;

export const useOrderByPaymentIntentIdQuery = <
      TData = OrderByPaymentIntentIdQuery,
      TError = unknown
    >(
      variables: OrderByPaymentIntentIdQueryVariables,
      options?: Omit<UseQueryOptions<OrderByPaymentIntentIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrderByPaymentIntentIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrderByPaymentIntentIdQuery, TError, TData>(
      {
    queryKey: ['OrderByPaymentIntentId', variables],
    queryFn: fetchData<OrderByPaymentIntentIdQuery, OrderByPaymentIntentIdQueryVariables>(OrderByPaymentIntentIdDocument, variables),
    ...options
  }
    )};

useOrderByPaymentIntentIdQuery.getKey = (variables: OrderByPaymentIntentIdQueryVariables) => ['OrderByPaymentIntentId', variables];

export const useSuspenseOrderByPaymentIntentIdQuery = <
      TData = OrderByPaymentIntentIdQuery,
      TError = unknown
    >(
      variables: OrderByPaymentIntentIdQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<OrderByPaymentIntentIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<OrderByPaymentIntentIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<OrderByPaymentIntentIdQuery, TError, TData>(
      {
    queryKey: ['OrderByPaymentIntentId', variables],
    queryFn: fetchData<OrderByPaymentIntentIdQuery, OrderByPaymentIntentIdQueryVariables>(OrderByPaymentIntentIdDocument, variables),
    ...options
  }
    )};

useSuspenseOrderByPaymentIntentIdQuery.getKey = (variables: OrderByPaymentIntentIdQueryVariables) => ['OrderByPaymentIntentId', variables];

export const useInfiniteOrderByPaymentIntentIdQuery = <
      TData = InfiniteData<OrderByPaymentIntentIdQuery>,
      TError = unknown
    >(
      variables: OrderByPaymentIntentIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrderByPaymentIntentIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrderByPaymentIntentIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<OrderByPaymentIntentIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['OrderByPaymentIntentId.infinite', variables],
      queryFn: (metaData) => fetchData<OrderByPaymentIntentIdQuery, OrderByPaymentIntentIdQueryVariables>(OrderByPaymentIntentIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteOrderByPaymentIntentIdQuery.getKey = (variables: OrderByPaymentIntentIdQueryVariables) => ['OrderByPaymentIntentId.infinite', variables];

export const useSuspenseInfiniteOrderByPaymentIntentIdQuery = <
      TData = InfiniteData<OrderByPaymentIntentIdQuery>,
      TError = unknown
    >(
      variables: OrderByPaymentIntentIdQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<OrderByPaymentIntentIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<OrderByPaymentIntentIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<OrderByPaymentIntentIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['OrderByPaymentIntentId.infinite', variables],
      queryFn: (metaData) => fetchData<OrderByPaymentIntentIdQuery, OrderByPaymentIntentIdQueryVariables>(OrderByPaymentIntentIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteOrderByPaymentIntentIdQuery.getKey = (variables: OrderByPaymentIntentIdQueryVariables) => ['OrderByPaymentIntentId.infinite', variables];


useOrderByPaymentIntentIdQuery.fetcher = (variables: OrderByPaymentIntentIdQueryVariables, options?: RequestInit['headers']) => fetchData<OrderByPaymentIntentIdQuery, OrderByPaymentIntentIdQueryVariables>(OrderByPaymentIntentIdDocument, variables, options);

export const OrderItemDocument = `
    query OrderItem($orderItemId: Int!) {
  orderItem(orderItemId: $orderItemId) {
    id
    productId
    instructionLink
    orderId
    priceCharged
    quantity
    tax
    productName
    productType
    hasInstructions
    hasDownloads
    dispatchedDate
    thumbnailSrc
    url
    needsShipping
    returnId
    description
    optionId
    optionDescription
    order {
      id
      orderDate
      currency {
        id
        symbol
        code
      }
    }
    productMeta {
      key
      value
    }
  }
}
    `;

export const useOrderItemQuery = <
      TData = OrderItemQuery,
      TError = unknown
    >(
      variables: OrderItemQueryVariables,
      options?: Omit<UseQueryOptions<OrderItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrderItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrderItemQuery, TError, TData>(
      {
    queryKey: ['OrderItem', variables],
    queryFn: fetchData<OrderItemQuery, OrderItemQueryVariables>(OrderItemDocument, variables),
    ...options
  }
    )};

useOrderItemQuery.getKey = (variables: OrderItemQueryVariables) => ['OrderItem', variables];

export const useSuspenseOrderItemQuery = <
      TData = OrderItemQuery,
      TError = unknown
    >(
      variables: OrderItemQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<OrderItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<OrderItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<OrderItemQuery, TError, TData>(
      {
    queryKey: ['OrderItem', variables],
    queryFn: fetchData<OrderItemQuery, OrderItemQueryVariables>(OrderItemDocument, variables),
    ...options
  }
    )};

useSuspenseOrderItemQuery.getKey = (variables: OrderItemQueryVariables) => ['OrderItem', variables];

export const useInfiniteOrderItemQuery = <
      TData = InfiniteData<OrderItemQuery>,
      TError = unknown
    >(
      variables: OrderItemQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrderItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrderItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<OrderItemQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['OrderItem.infinite', variables],
      queryFn: (metaData) => fetchData<OrderItemQuery, OrderItemQueryVariables>(OrderItemDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteOrderItemQuery.getKey = (variables: OrderItemQueryVariables) => ['OrderItem.infinite', variables];

export const useSuspenseInfiniteOrderItemQuery = <
      TData = InfiniteData<OrderItemQuery>,
      TError = unknown
    >(
      variables: OrderItemQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<OrderItemQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<OrderItemQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<OrderItemQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['OrderItem.infinite', variables],
      queryFn: (metaData) => fetchData<OrderItemQuery, OrderItemQueryVariables>(OrderItemDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteOrderItemQuery.getKey = (variables: OrderItemQueryVariables) => ['OrderItem.infinite', variables];


useOrderItemQuery.fetcher = (variables: OrderItemQueryVariables, options?: RequestInit['headers']) => fetchData<OrderItemQuery, OrderItemQueryVariables>(OrderItemDocument, variables, options);

export const OrderItemsToReturnDocument = `
    query OrderItemsToReturn($orderId: Int!) {
  itemsToReturnForOrder(orderId: $orderId) {
    explanation
    items {
      id
      productId
      productName
      returnEligibilityMessage
      availableReturnActions {
        action
        description
      }
      availableReturnReasons {
        id
        description
      }
    }
  }
}
    `;

export const useOrderItemsToReturnQuery = <
      TData = OrderItemsToReturnQuery,
      TError = unknown
    >(
      variables: OrderItemsToReturnQueryVariables,
      options?: Omit<UseQueryOptions<OrderItemsToReturnQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrderItemsToReturnQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrderItemsToReturnQuery, TError, TData>(
      {
    queryKey: ['OrderItemsToReturn', variables],
    queryFn: fetchData<OrderItemsToReturnQuery, OrderItemsToReturnQueryVariables>(OrderItemsToReturnDocument, variables),
    ...options
  }
    )};

useOrderItemsToReturnQuery.getKey = (variables: OrderItemsToReturnQueryVariables) => ['OrderItemsToReturn', variables];

export const useSuspenseOrderItemsToReturnQuery = <
      TData = OrderItemsToReturnQuery,
      TError = unknown
    >(
      variables: OrderItemsToReturnQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<OrderItemsToReturnQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<OrderItemsToReturnQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<OrderItemsToReturnQuery, TError, TData>(
      {
    queryKey: ['OrderItemsToReturn', variables],
    queryFn: fetchData<OrderItemsToReturnQuery, OrderItemsToReturnQueryVariables>(OrderItemsToReturnDocument, variables),
    ...options
  }
    )};

useSuspenseOrderItemsToReturnQuery.getKey = (variables: OrderItemsToReturnQueryVariables) => ['OrderItemsToReturn', variables];

export const useInfiniteOrderItemsToReturnQuery = <
      TData = InfiniteData<OrderItemsToReturnQuery>,
      TError = unknown
    >(
      variables: OrderItemsToReturnQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrderItemsToReturnQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrderItemsToReturnQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<OrderItemsToReturnQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['OrderItemsToReturn.infinite', variables],
      queryFn: (metaData) => fetchData<OrderItemsToReturnQuery, OrderItemsToReturnQueryVariables>(OrderItemsToReturnDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteOrderItemsToReturnQuery.getKey = (variables: OrderItemsToReturnQueryVariables) => ['OrderItemsToReturn.infinite', variables];

export const useSuspenseInfiniteOrderItemsToReturnQuery = <
      TData = InfiniteData<OrderItemsToReturnQuery>,
      TError = unknown
    >(
      variables: OrderItemsToReturnQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<OrderItemsToReturnQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<OrderItemsToReturnQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<OrderItemsToReturnQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['OrderItemsToReturn.infinite', variables],
      queryFn: (metaData) => fetchData<OrderItemsToReturnQuery, OrderItemsToReturnQueryVariables>(OrderItemsToReturnDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteOrderItemsToReturnQuery.getKey = (variables: OrderItemsToReturnQueryVariables) => ['OrderItemsToReturn.infinite', variables];


useOrderItemsToReturnQuery.fetcher = (variables: OrderItemsToReturnQueryVariables, options?: RequestInit['headers']) => fetchData<OrderItemsToReturnQuery, OrderItemsToReturnQueryVariables>(OrderItemsToReturnDocument, variables, options);

export const ReturnDocument = `
    query Return($returnId: Int!) {
  return(returnId: $returnId) {
    id
    dateReceived
    dateRequested
    status
    returnTracking
    shippingRefundAmount
    returnNotes
    returnDetails
    order {
      id
    }
    items {
      id
      orderItemId
      reasonId
      reason
      notes
      action
      requestedAction
      files
      product {
        name
        thumbnails {
          default
        }
      }
    }
  }
}
    `;

export const useReturnQuery = <
      TData = ReturnQuery,
      TError = unknown
    >(
      variables: ReturnQueryVariables,
      options?: Omit<UseQueryOptions<ReturnQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ReturnQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ReturnQuery, TError, TData>(
      {
    queryKey: ['Return', variables],
    queryFn: fetchData<ReturnQuery, ReturnQueryVariables>(ReturnDocument, variables),
    ...options
  }
    )};

useReturnQuery.getKey = (variables: ReturnQueryVariables) => ['Return', variables];

export const useSuspenseReturnQuery = <
      TData = ReturnQuery,
      TError = unknown
    >(
      variables: ReturnQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ReturnQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ReturnQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ReturnQuery, TError, TData>(
      {
    queryKey: ['Return', variables],
    queryFn: fetchData<ReturnQuery, ReturnQueryVariables>(ReturnDocument, variables),
    ...options
  }
    )};

useSuspenseReturnQuery.getKey = (variables: ReturnQueryVariables) => ['Return', variables];

export const useInfiniteReturnQuery = <
      TData = InfiniteData<ReturnQuery>,
      TError = unknown
    >(
      variables: ReturnQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ReturnQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ReturnQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ReturnQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Return.infinite', variables],
      queryFn: (metaData) => fetchData<ReturnQuery, ReturnQueryVariables>(ReturnDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteReturnQuery.getKey = (variables: ReturnQueryVariables) => ['Return.infinite', variables];

export const useSuspenseInfiniteReturnQuery = <
      TData = InfiniteData<ReturnQuery>,
      TError = unknown
    >(
      variables: ReturnQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ReturnQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ReturnQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ReturnQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Return.infinite', variables],
      queryFn: (metaData) => fetchData<ReturnQuery, ReturnQueryVariables>(ReturnDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteReturnQuery.getKey = (variables: ReturnQueryVariables) => ['Return.infinite', variables];


useReturnQuery.fetcher = (variables: ReturnQueryVariables, options?: RequestInit['headers']) => fetchData<ReturnQuery, ReturnQueryVariables>(ReturnDocument, variables, options);

export const CountriesWithoutFreeShippingDocument = `
    query CountriesWithoutFreeShipping($brandCode: String!) {
  countriesWithoutFreeShipping(brandCode: $brandCode) {
    name
  }
}
    `;

export const useCountriesWithoutFreeShippingQuery = <
      TData = CountriesWithoutFreeShippingQuery,
      TError = unknown
    >(
      variables: CountriesWithoutFreeShippingQueryVariables,
      options?: Omit<UseQueryOptions<CountriesWithoutFreeShippingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CountriesWithoutFreeShippingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CountriesWithoutFreeShippingQuery, TError, TData>(
      {
    queryKey: ['CountriesWithoutFreeShipping', variables],
    queryFn: fetchData<CountriesWithoutFreeShippingQuery, CountriesWithoutFreeShippingQueryVariables>(CountriesWithoutFreeShippingDocument, variables),
    ...options
  }
    )};

useCountriesWithoutFreeShippingQuery.getKey = (variables: CountriesWithoutFreeShippingQueryVariables) => ['CountriesWithoutFreeShipping', variables];

export const useSuspenseCountriesWithoutFreeShippingQuery = <
      TData = CountriesWithoutFreeShippingQuery,
      TError = unknown
    >(
      variables: CountriesWithoutFreeShippingQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CountriesWithoutFreeShippingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CountriesWithoutFreeShippingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CountriesWithoutFreeShippingQuery, TError, TData>(
      {
    queryKey: ['CountriesWithoutFreeShipping', variables],
    queryFn: fetchData<CountriesWithoutFreeShippingQuery, CountriesWithoutFreeShippingQueryVariables>(CountriesWithoutFreeShippingDocument, variables),
    ...options
  }
    )};

useSuspenseCountriesWithoutFreeShippingQuery.getKey = (variables: CountriesWithoutFreeShippingQueryVariables) => ['CountriesWithoutFreeShipping', variables];

export const useInfiniteCountriesWithoutFreeShippingQuery = <
      TData = InfiniteData<CountriesWithoutFreeShippingQuery>,
      TError = unknown
    >(
      variables: CountriesWithoutFreeShippingQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CountriesWithoutFreeShippingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CountriesWithoutFreeShippingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CountriesWithoutFreeShippingQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CountriesWithoutFreeShipping.infinite', variables],
      queryFn: (metaData) => fetchData<CountriesWithoutFreeShippingQuery, CountriesWithoutFreeShippingQueryVariables>(CountriesWithoutFreeShippingDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCountriesWithoutFreeShippingQuery.getKey = (variables: CountriesWithoutFreeShippingQueryVariables) => ['CountriesWithoutFreeShipping.infinite', variables];

export const useSuspenseInfiniteCountriesWithoutFreeShippingQuery = <
      TData = InfiniteData<CountriesWithoutFreeShippingQuery>,
      TError = unknown
    >(
      variables: CountriesWithoutFreeShippingQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CountriesWithoutFreeShippingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CountriesWithoutFreeShippingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CountriesWithoutFreeShippingQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CountriesWithoutFreeShipping.infinite', variables],
      queryFn: (metaData) => fetchData<CountriesWithoutFreeShippingQuery, CountriesWithoutFreeShippingQueryVariables>(CountriesWithoutFreeShippingDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCountriesWithoutFreeShippingQuery.getKey = (variables: CountriesWithoutFreeShippingQueryVariables) => ['CountriesWithoutFreeShipping.infinite', variables];


useCountriesWithoutFreeShippingQuery.fetcher = (variables: CountriesWithoutFreeShippingQueryVariables, options?: RequestInit['headers']) => fetchData<CountriesWithoutFreeShippingQuery, CountriesWithoutFreeShippingQueryVariables>(CountriesWithoutFreeShippingDocument, variables, options);

export const DecksDocument = `
    query Decks($take: Int!, $skip: Int!, $brandCode: String!, $order: [ProductByCategorySort!], $where: ProductByCategoryFilter, $inStockOnly: Boolean!) {
  productsByCategorySlug(
    skip: $skip
    take: $take
    brandCode: $brandCode
    includeChildCategories: false
    maxBlurbLength: 150
    categorySlug: "playing-cards"
    where: $where
    order: $order
    inStockOnly: $inStockOnly
  ) {
    totalCount
    items {
      id
      name
      url
      blurb
      thumbnails {
        square
      }
      displayPrice
      options {
        id
        description
        price
        salePrice
        priceIncVat
        salePriceIncVat
        taxType
        inStock
        currency {
          symbol
          code
        }
        productType {
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

export const useDecksQuery = <
      TData = DecksQuery,
      TError = unknown
    >(
      variables: DecksQueryVariables,
      options?: Omit<UseQueryOptions<DecksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DecksQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DecksQuery, TError, TData>(
      {
    queryKey: ['Decks', variables],
    queryFn: fetchData<DecksQuery, DecksQueryVariables>(DecksDocument, variables),
    ...options
  }
    )};

useDecksQuery.getKey = (variables: DecksQueryVariables) => ['Decks', variables];

export const useSuspenseDecksQuery = <
      TData = DecksQuery,
      TError = unknown
    >(
      variables: DecksQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<DecksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<DecksQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<DecksQuery, TError, TData>(
      {
    queryKey: ['Decks', variables],
    queryFn: fetchData<DecksQuery, DecksQueryVariables>(DecksDocument, variables),
    ...options
  }
    )};

useSuspenseDecksQuery.getKey = (variables: DecksQueryVariables) => ['Decks', variables];

export const useInfiniteDecksQuery = <
      TData = InfiniteData<DecksQuery>,
      TError = unknown
    >(
      variables: DecksQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DecksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DecksQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<DecksQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Decks.infinite', variables],
      queryFn: (metaData) => fetchData<DecksQuery, DecksQueryVariables>(DecksDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteDecksQuery.getKey = (variables: DecksQueryVariables) => ['Decks.infinite', variables];

export const useSuspenseInfiniteDecksQuery = <
      TData = InfiniteData<DecksQuery>,
      TError = unknown
    >(
      variables: DecksQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<DecksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<DecksQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<DecksQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Decks.infinite', variables],
      queryFn: (metaData) => fetchData<DecksQuery, DecksQueryVariables>(DecksDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteDecksQuery.getKey = (variables: DecksQueryVariables) => ['Decks.infinite', variables];


useDecksQuery.fetcher = (variables: DecksQueryVariables, options?: RequestInit['headers']) => fetchData<DecksQuery, DecksQueryVariables>(DecksDocument, variables, options);

export const PlayingCardManufacturersDocument = `
    query PlayingCardManufacturers {
  playingCardManufacturers {
    id
    name
    urlStub
  }
}
    `;

export const usePlayingCardManufacturersQuery = <
      TData = PlayingCardManufacturersQuery,
      TError = unknown
    >(
      variables?: PlayingCardManufacturersQueryVariables,
      options?: Omit<UseQueryOptions<PlayingCardManufacturersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PlayingCardManufacturersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PlayingCardManufacturersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['PlayingCardManufacturers'] : ['PlayingCardManufacturers', variables],
    queryFn: fetchData<PlayingCardManufacturersQuery, PlayingCardManufacturersQueryVariables>(PlayingCardManufacturersDocument, variables),
    ...options
  }
    )};

usePlayingCardManufacturersQuery.getKey = (variables?: PlayingCardManufacturersQueryVariables) => variables === undefined ? ['PlayingCardManufacturers'] : ['PlayingCardManufacturers', variables];

export const useSuspensePlayingCardManufacturersQuery = <
      TData = PlayingCardManufacturersQuery,
      TError = unknown
    >(
      variables?: PlayingCardManufacturersQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<PlayingCardManufacturersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<PlayingCardManufacturersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<PlayingCardManufacturersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['PlayingCardManufacturers'] : ['PlayingCardManufacturers', variables],
    queryFn: fetchData<PlayingCardManufacturersQuery, PlayingCardManufacturersQueryVariables>(PlayingCardManufacturersDocument, variables),
    ...options
  }
    )};

useSuspensePlayingCardManufacturersQuery.getKey = (variables?: PlayingCardManufacturersQueryVariables) => variables === undefined ? ['PlayingCardManufacturers'] : ['PlayingCardManufacturers', variables];

export const useInfinitePlayingCardManufacturersQuery = <
      TData = InfiniteData<PlayingCardManufacturersQuery>,
      TError = unknown
    >(
      variables: PlayingCardManufacturersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<PlayingCardManufacturersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<PlayingCardManufacturersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<PlayingCardManufacturersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['PlayingCardManufacturers.infinite'] : ['PlayingCardManufacturers.infinite', variables],
      queryFn: (metaData) => fetchData<PlayingCardManufacturersQuery, PlayingCardManufacturersQueryVariables>(PlayingCardManufacturersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfinitePlayingCardManufacturersQuery.getKey = (variables?: PlayingCardManufacturersQueryVariables) => variables === undefined ? ['PlayingCardManufacturers.infinite'] : ['PlayingCardManufacturers.infinite', variables];

export const useSuspenseInfinitePlayingCardManufacturersQuery = <
      TData = InfiniteData<PlayingCardManufacturersQuery>,
      TError = unknown
    >(
      variables: PlayingCardManufacturersQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<PlayingCardManufacturersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<PlayingCardManufacturersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<PlayingCardManufacturersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['PlayingCardManufacturers.infinite'] : ['PlayingCardManufacturers.infinite', variables],
      queryFn: (metaData) => fetchData<PlayingCardManufacturersQuery, PlayingCardManufacturersQueryVariables>(PlayingCardManufacturersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfinitePlayingCardManufacturersQuery.getKey = (variables?: PlayingCardManufacturersQueryVariables) => variables === undefined ? ['PlayingCardManufacturers.infinite'] : ['PlayingCardManufacturers.infinite', variables];


usePlayingCardManufacturersQuery.fetcher = (variables?: PlayingCardManufacturersQueryVariables, options?: RequestInit['headers']) => fetchData<PlayingCardManufacturersQuery, PlayingCardManufacturersQueryVariables>(PlayingCardManufacturersDocument, variables, options);

export const AllExclusiveProductsDocument = `
    query AllExclusiveProducts($take: Int!, $skip: Int!, $brandCode: String!, $maxBlurbLength: Int!, $order: [ProductsSort!]) {
  ecommProducts(
    take: $take
    skip: $skip
    brandCode: $brandCode
    maxBlurbLength: $maxBlurbLength
    where: {vanishingIncExclusive: {eq: true}}
    order: $order
  ) {
    totalCount
    items {
      id
      name
      url
      blurb
      thumbnails {
        default
        square
        video
      }
      displayPrice
      vanishingIncExclusive
      options {
        id
        description
        price
        salePrice
        priceIncVat
        salePriceIncVat
        taxType
        inStock
        productType {
          id
          name
        }
        currency {
          symbol
        }
      }
      productType {
        name
        id
      }
      creators {
        id
        name
        urlStub
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;

export const useAllExclusiveProductsQuery = <
      TData = AllExclusiveProductsQuery,
      TError = unknown
    >(
      variables: AllExclusiveProductsQueryVariables,
      options?: Omit<UseQueryOptions<AllExclusiveProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AllExclusiveProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AllExclusiveProductsQuery, TError, TData>(
      {
    queryKey: ['AllExclusiveProducts', variables],
    queryFn: fetchData<AllExclusiveProductsQuery, AllExclusiveProductsQueryVariables>(AllExclusiveProductsDocument, variables),
    ...options
  }
    )};

useAllExclusiveProductsQuery.getKey = (variables: AllExclusiveProductsQueryVariables) => ['AllExclusiveProducts', variables];

export const useSuspenseAllExclusiveProductsQuery = <
      TData = AllExclusiveProductsQuery,
      TError = unknown
    >(
      variables: AllExclusiveProductsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<AllExclusiveProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<AllExclusiveProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<AllExclusiveProductsQuery, TError, TData>(
      {
    queryKey: ['AllExclusiveProducts', variables],
    queryFn: fetchData<AllExclusiveProductsQuery, AllExclusiveProductsQueryVariables>(AllExclusiveProductsDocument, variables),
    ...options
  }
    )};

useSuspenseAllExclusiveProductsQuery.getKey = (variables: AllExclusiveProductsQueryVariables) => ['AllExclusiveProducts', variables];

export const useInfiniteAllExclusiveProductsQuery = <
      TData = InfiniteData<AllExclusiveProductsQuery>,
      TError = unknown
    >(
      variables: AllExclusiveProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AllExclusiveProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AllExclusiveProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<AllExclusiveProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AllExclusiveProducts.infinite', variables],
      queryFn: (metaData) => fetchData<AllExclusiveProductsQuery, AllExclusiveProductsQueryVariables>(AllExclusiveProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteAllExclusiveProductsQuery.getKey = (variables: AllExclusiveProductsQueryVariables) => ['AllExclusiveProducts.infinite', variables];

export const useSuspenseInfiniteAllExclusiveProductsQuery = <
      TData = InfiniteData<AllExclusiveProductsQuery>,
      TError = unknown
    >(
      variables: AllExclusiveProductsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<AllExclusiveProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<AllExclusiveProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<AllExclusiveProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AllExclusiveProducts.infinite', variables],
      queryFn: (metaData) => fetchData<AllExclusiveProductsQuery, AllExclusiveProductsQueryVariables>(AllExclusiveProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteAllExclusiveProductsQuery.getKey = (variables: AllExclusiveProductsQueryVariables) => ['AllExclusiveProducts.infinite', variables];


useAllExclusiveProductsQuery.fetcher = (variables: AllExclusiveProductsQueryVariables, options?: RequestInit['headers']) => fetchData<AllExclusiveProductsQuery, AllExclusiveProductsQueryVariables>(AllExclusiveProductsDocument, variables, options);

export const BeginnerProductsWithExplanationsDocument = `
    query BeginnerProductsWithExplanations($categorySlug: String!, $take: Int!, $skip: Int!, $brandCode: String!, $includeChildCategories: Boolean!, $maxBlurbLength: Int!, $order: [ProductByCategorySort!]) {
  productsByCategorySlug(
    skip: $skip
    take: $take
    brandCode: $brandCode
    includeChildCategories: $includeChildCategories
    maxBlurbLength: $maxBlurbLength
    categorySlug: $categorySlug
    order: $order
  ) {
    totalCount
    items {
      id
      name
      url
      meta {
        key
        value
      }
      thumbnails {
        default
        video
      }
    }
    pageInfo {
      hasNextPage
    }
  }
}
    `;

export const useBeginnerProductsWithExplanationsQuery = <
      TData = BeginnerProductsWithExplanationsQuery,
      TError = unknown
    >(
      variables: BeginnerProductsWithExplanationsQueryVariables,
      options?: Omit<UseQueryOptions<BeginnerProductsWithExplanationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BeginnerProductsWithExplanationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BeginnerProductsWithExplanationsQuery, TError, TData>(
      {
    queryKey: ['BeginnerProductsWithExplanations', variables],
    queryFn: fetchData<BeginnerProductsWithExplanationsQuery, BeginnerProductsWithExplanationsQueryVariables>(BeginnerProductsWithExplanationsDocument, variables),
    ...options
  }
    )};

useBeginnerProductsWithExplanationsQuery.getKey = (variables: BeginnerProductsWithExplanationsQueryVariables) => ['BeginnerProductsWithExplanations', variables];

export const useSuspenseBeginnerProductsWithExplanationsQuery = <
      TData = BeginnerProductsWithExplanationsQuery,
      TError = unknown
    >(
      variables: BeginnerProductsWithExplanationsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<BeginnerProductsWithExplanationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<BeginnerProductsWithExplanationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<BeginnerProductsWithExplanationsQuery, TError, TData>(
      {
    queryKey: ['BeginnerProductsWithExplanations', variables],
    queryFn: fetchData<BeginnerProductsWithExplanationsQuery, BeginnerProductsWithExplanationsQueryVariables>(BeginnerProductsWithExplanationsDocument, variables),
    ...options
  }
    )};

useSuspenseBeginnerProductsWithExplanationsQuery.getKey = (variables: BeginnerProductsWithExplanationsQueryVariables) => ['BeginnerProductsWithExplanations', variables];

export const useInfiniteBeginnerProductsWithExplanationsQuery = <
      TData = InfiniteData<BeginnerProductsWithExplanationsQuery>,
      TError = unknown
    >(
      variables: BeginnerProductsWithExplanationsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BeginnerProductsWithExplanationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BeginnerProductsWithExplanationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<BeginnerProductsWithExplanationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['BeginnerProductsWithExplanations.infinite', variables],
      queryFn: (metaData) => fetchData<BeginnerProductsWithExplanationsQuery, BeginnerProductsWithExplanationsQueryVariables>(BeginnerProductsWithExplanationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteBeginnerProductsWithExplanationsQuery.getKey = (variables: BeginnerProductsWithExplanationsQueryVariables) => ['BeginnerProductsWithExplanations.infinite', variables];

export const useSuspenseInfiniteBeginnerProductsWithExplanationsQuery = <
      TData = InfiniteData<BeginnerProductsWithExplanationsQuery>,
      TError = unknown
    >(
      variables: BeginnerProductsWithExplanationsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<BeginnerProductsWithExplanationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<BeginnerProductsWithExplanationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<BeginnerProductsWithExplanationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['BeginnerProductsWithExplanations.infinite', variables],
      queryFn: (metaData) => fetchData<BeginnerProductsWithExplanationsQuery, BeginnerProductsWithExplanationsQueryVariables>(BeginnerProductsWithExplanationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteBeginnerProductsWithExplanationsQuery.getKey = (variables: BeginnerProductsWithExplanationsQueryVariables) => ['BeginnerProductsWithExplanations.infinite', variables];


useBeginnerProductsWithExplanationsQuery.fetcher = (variables: BeginnerProductsWithExplanationsQueryVariables, options?: RequestInit['headers']) => fetchData<BeginnerProductsWithExplanationsQuery, BeginnerProductsWithExplanationsQueryVariables>(BeginnerProductsWithExplanationsDocument, variables, options);

export const CategoryProductCountsDocument = `
    query CategoryProductCounts($categoryIds: [Int!]!) {
  productCountsByCategories(categoryIds: $categoryIds) {
    key
    value
  }
}
    `;

export const useCategoryProductCountsQuery = <
      TData = CategoryProductCountsQuery,
      TError = unknown
    >(
      variables: CategoryProductCountsQueryVariables,
      options?: Omit<UseQueryOptions<CategoryProductCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CategoryProductCountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CategoryProductCountsQuery, TError, TData>(
      {
    queryKey: ['CategoryProductCounts', variables],
    queryFn: fetchData<CategoryProductCountsQuery, CategoryProductCountsQueryVariables>(CategoryProductCountsDocument, variables),
    ...options
  }
    )};

useCategoryProductCountsQuery.getKey = (variables: CategoryProductCountsQueryVariables) => ['CategoryProductCounts', variables];

export const useSuspenseCategoryProductCountsQuery = <
      TData = CategoryProductCountsQuery,
      TError = unknown
    >(
      variables: CategoryProductCountsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CategoryProductCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CategoryProductCountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CategoryProductCountsQuery, TError, TData>(
      {
    queryKey: ['CategoryProductCounts', variables],
    queryFn: fetchData<CategoryProductCountsQuery, CategoryProductCountsQueryVariables>(CategoryProductCountsDocument, variables),
    ...options
  }
    )};

useSuspenseCategoryProductCountsQuery.getKey = (variables: CategoryProductCountsQueryVariables) => ['CategoryProductCounts', variables];

export const useInfiniteCategoryProductCountsQuery = <
      TData = InfiniteData<CategoryProductCountsQuery>,
      TError = unknown
    >(
      variables: CategoryProductCountsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CategoryProductCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CategoryProductCountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CategoryProductCountsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CategoryProductCounts.infinite', variables],
      queryFn: (metaData) => fetchData<CategoryProductCountsQuery, CategoryProductCountsQueryVariables>(CategoryProductCountsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCategoryProductCountsQuery.getKey = (variables: CategoryProductCountsQueryVariables) => ['CategoryProductCounts.infinite', variables];

export const useSuspenseInfiniteCategoryProductCountsQuery = <
      TData = InfiniteData<CategoryProductCountsQuery>,
      TError = unknown
    >(
      variables: CategoryProductCountsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CategoryProductCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CategoryProductCountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CategoryProductCountsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CategoryProductCounts.infinite', variables],
      queryFn: (metaData) => fetchData<CategoryProductCountsQuery, CategoryProductCountsQueryVariables>(CategoryProductCountsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCategoryProductCountsQuery.getKey = (variables: CategoryProductCountsQueryVariables) => ['CategoryProductCounts.infinite', variables];


useCategoryProductCountsQuery.fetcher = (variables: CategoryProductCountsQueryVariables, options?: RequestInit['headers']) => fetchData<CategoryProductCountsQuery, CategoryProductCountsQueryVariables>(CategoryProductCountsDocument, variables, options);

export const DiscoveryProductDocument = `
    query DiscoveryProduct($id: String!, $brandCode: String!) {
  productForDiscoverie(id: $id, brandCode: $brandCode) {
    productUrl
    price
    hasPurchased
    imageUrl
  }
}
    `;

export const useDiscoveryProductQuery = <
      TData = DiscoveryProductQuery,
      TError = unknown
    >(
      variables: DiscoveryProductQueryVariables,
      options?: Omit<UseQueryOptions<DiscoveryProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DiscoveryProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DiscoveryProductQuery, TError, TData>(
      {
    queryKey: ['DiscoveryProduct', variables],
    queryFn: fetchData<DiscoveryProductQuery, DiscoveryProductQueryVariables>(DiscoveryProductDocument, variables),
    ...options
  }
    )};

useDiscoveryProductQuery.getKey = (variables: DiscoveryProductQueryVariables) => ['DiscoveryProduct', variables];

export const useSuspenseDiscoveryProductQuery = <
      TData = DiscoveryProductQuery,
      TError = unknown
    >(
      variables: DiscoveryProductQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<DiscoveryProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<DiscoveryProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<DiscoveryProductQuery, TError, TData>(
      {
    queryKey: ['DiscoveryProduct', variables],
    queryFn: fetchData<DiscoveryProductQuery, DiscoveryProductQueryVariables>(DiscoveryProductDocument, variables),
    ...options
  }
    )};

useSuspenseDiscoveryProductQuery.getKey = (variables: DiscoveryProductQueryVariables) => ['DiscoveryProduct', variables];

export const useInfiniteDiscoveryProductQuery = <
      TData = InfiniteData<DiscoveryProductQuery>,
      TError = unknown
    >(
      variables: DiscoveryProductQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DiscoveryProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DiscoveryProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<DiscoveryProductQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['DiscoveryProduct.infinite', variables],
      queryFn: (metaData) => fetchData<DiscoveryProductQuery, DiscoveryProductQueryVariables>(DiscoveryProductDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteDiscoveryProductQuery.getKey = (variables: DiscoveryProductQueryVariables) => ['DiscoveryProduct.infinite', variables];

export const useSuspenseInfiniteDiscoveryProductQuery = <
      TData = InfiniteData<DiscoveryProductQuery>,
      TError = unknown
    >(
      variables: DiscoveryProductQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<DiscoveryProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<DiscoveryProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<DiscoveryProductQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['DiscoveryProduct.infinite', variables],
      queryFn: (metaData) => fetchData<DiscoveryProductQuery, DiscoveryProductQueryVariables>(DiscoveryProductDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteDiscoveryProductQuery.getKey = (variables: DiscoveryProductQueryVariables) => ['DiscoveryProduct.infinite', variables];


useDiscoveryProductQuery.fetcher = (variables: DiscoveryProductQueryVariables, options?: RequestInit['headers']) => fetchData<DiscoveryProductQuery, DiscoveryProductQueryVariables>(DiscoveryProductDocument, variables, options);

export const ExclusiveDownloadsDocument = `
    query ExclusiveDownloads($take: Int!, $skip: Int!, $brandCode: String!) {
  productsByCategorySlug(
    skip: $skip
    take: $take
    brandCode: $brandCode
    includeChildCategories: true
    categorySlug: "downloads"
    where: {vanishingIncExclusive: {eq: true}}
    order: {dateAdded: DESC}
    maxBlurbLength: 100
    productTypeGroup: "downloads"
  ) {
    totalCount
    items {
      id
      name
      url
      blurb
      vanishingIncExclusive
      thumbnails {
        default
        square
        video
      }
      displayPrice
      options {
        id
        description
        price
        salePrice
        inStock
        productType {
          id
          name
        }
        currency {
          symbol
        }
      }
      productType {
        name
        id
      }
      creators {
        id
        name
        urlStub
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

export const useExclusiveDownloadsQuery = <
      TData = ExclusiveDownloadsQuery,
      TError = unknown
    >(
      variables: ExclusiveDownloadsQueryVariables,
      options?: Omit<UseQueryOptions<ExclusiveDownloadsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ExclusiveDownloadsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ExclusiveDownloadsQuery, TError, TData>(
      {
    queryKey: ['ExclusiveDownloads', variables],
    queryFn: fetchData<ExclusiveDownloadsQuery, ExclusiveDownloadsQueryVariables>(ExclusiveDownloadsDocument, variables),
    ...options
  }
    )};

useExclusiveDownloadsQuery.getKey = (variables: ExclusiveDownloadsQueryVariables) => ['ExclusiveDownloads', variables];

export const useSuspenseExclusiveDownloadsQuery = <
      TData = ExclusiveDownloadsQuery,
      TError = unknown
    >(
      variables: ExclusiveDownloadsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ExclusiveDownloadsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ExclusiveDownloadsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ExclusiveDownloadsQuery, TError, TData>(
      {
    queryKey: ['ExclusiveDownloads', variables],
    queryFn: fetchData<ExclusiveDownloadsQuery, ExclusiveDownloadsQueryVariables>(ExclusiveDownloadsDocument, variables),
    ...options
  }
    )};

useSuspenseExclusiveDownloadsQuery.getKey = (variables: ExclusiveDownloadsQueryVariables) => ['ExclusiveDownloads', variables];

export const useInfiniteExclusiveDownloadsQuery = <
      TData = InfiniteData<ExclusiveDownloadsQuery>,
      TError = unknown
    >(
      variables: ExclusiveDownloadsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ExclusiveDownloadsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ExclusiveDownloadsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ExclusiveDownloadsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ExclusiveDownloads.infinite', variables],
      queryFn: (metaData) => fetchData<ExclusiveDownloadsQuery, ExclusiveDownloadsQueryVariables>(ExclusiveDownloadsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteExclusiveDownloadsQuery.getKey = (variables: ExclusiveDownloadsQueryVariables) => ['ExclusiveDownloads.infinite', variables];

export const useSuspenseInfiniteExclusiveDownloadsQuery = <
      TData = InfiniteData<ExclusiveDownloadsQuery>,
      TError = unknown
    >(
      variables: ExclusiveDownloadsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ExclusiveDownloadsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ExclusiveDownloadsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ExclusiveDownloadsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ExclusiveDownloads.infinite', variables],
      queryFn: (metaData) => fetchData<ExclusiveDownloadsQuery, ExclusiveDownloadsQueryVariables>(ExclusiveDownloadsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteExclusiveDownloadsQuery.getKey = (variables: ExclusiveDownloadsQueryVariables) => ['ExclusiveDownloads.infinite', variables];


useExclusiveDownloadsQuery.fetcher = (variables: ExclusiveDownloadsQueryVariables, options?: RequestInit['headers']) => fetchData<ExclusiveDownloadsQuery, ExclusiveDownloadsQueryVariables>(ExclusiveDownloadsDocument, variables, options);

export const FeaturedProductsDocument = `
    query FeaturedProducts($brandCode: String!) {
  ecommProducts(
    skip: 0
    take: 8
    brandCode: $brandCode
    order: {dateAdded: DESC}
    where: {featured: {eq: true}}
    maxBlurbLength: 200
  ) {
    items {
      id
      name
      url
      blurb
      thumbnails {
        default
      }
    }
  }
}
    `;

export const useFeaturedProductsQuery = <
      TData = FeaturedProductsQuery,
      TError = unknown
    >(
      variables: FeaturedProductsQueryVariables,
      options?: Omit<UseQueryOptions<FeaturedProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FeaturedProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FeaturedProductsQuery, TError, TData>(
      {
    queryKey: ['FeaturedProducts', variables],
    queryFn: fetchData<FeaturedProductsQuery, FeaturedProductsQueryVariables>(FeaturedProductsDocument, variables),
    ...options
  }
    )};

useFeaturedProductsQuery.getKey = (variables: FeaturedProductsQueryVariables) => ['FeaturedProducts', variables];

export const useSuspenseFeaturedProductsQuery = <
      TData = FeaturedProductsQuery,
      TError = unknown
    >(
      variables: FeaturedProductsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<FeaturedProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<FeaturedProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<FeaturedProductsQuery, TError, TData>(
      {
    queryKey: ['FeaturedProducts', variables],
    queryFn: fetchData<FeaturedProductsQuery, FeaturedProductsQueryVariables>(FeaturedProductsDocument, variables),
    ...options
  }
    )};

useSuspenseFeaturedProductsQuery.getKey = (variables: FeaturedProductsQueryVariables) => ['FeaturedProducts', variables];

export const useInfiniteFeaturedProductsQuery = <
      TData = InfiniteData<FeaturedProductsQuery>,
      TError = unknown
    >(
      variables: FeaturedProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FeaturedProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FeaturedProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<FeaturedProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FeaturedProducts.infinite', variables],
      queryFn: (metaData) => fetchData<FeaturedProductsQuery, FeaturedProductsQueryVariables>(FeaturedProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteFeaturedProductsQuery.getKey = (variables: FeaturedProductsQueryVariables) => ['FeaturedProducts.infinite', variables];

export const useSuspenseInfiniteFeaturedProductsQuery = <
      TData = InfiniteData<FeaturedProductsQuery>,
      TError = unknown
    >(
      variables: FeaturedProductsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<FeaturedProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<FeaturedProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<FeaturedProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['FeaturedProducts.infinite', variables],
      queryFn: (metaData) => fetchData<FeaturedProductsQuery, FeaturedProductsQueryVariables>(FeaturedProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteFeaturedProductsQuery.getKey = (variables: FeaturedProductsQueryVariables) => ['FeaturedProducts.infinite', variables];


useFeaturedProductsQuery.fetcher = (variables: FeaturedProductsQueryVariables, options?: RequestInit['headers']) => fetchData<FeaturedProductsQuery, FeaturedProductsQueryVariables>(FeaturedProductsDocument, variables, options);

export const GetProductLiveChatMessagesDocument = `
    query GetProductLiveChatMessages($productId: Int!, $take: Int) {
  productLiveChatMessages(productId: $productId, take: $take) {
    id
    productId
    customerId
    message
    timePosted
    customerName
    gravatarUrl
    isAdminStaff
  }
}
    `;

export const useGetProductLiveChatMessagesQuery = <
      TData = GetProductLiveChatMessagesQuery,
      TError = unknown
    >(
      variables: GetProductLiveChatMessagesQueryVariables,
      options?: Omit<UseQueryOptions<GetProductLiveChatMessagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProductLiveChatMessagesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProductLiveChatMessagesQuery, TError, TData>(
      {
    queryKey: ['GetProductLiveChatMessages', variables],
    queryFn: fetchData<GetProductLiveChatMessagesQuery, GetProductLiveChatMessagesQueryVariables>(GetProductLiveChatMessagesDocument, variables),
    ...options
  }
    )};

useGetProductLiveChatMessagesQuery.getKey = (variables: GetProductLiveChatMessagesQueryVariables) => ['GetProductLiveChatMessages', variables];

export const useSuspenseGetProductLiveChatMessagesQuery = <
      TData = GetProductLiveChatMessagesQuery,
      TError = unknown
    >(
      variables: GetProductLiveChatMessagesQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<GetProductLiveChatMessagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<GetProductLiveChatMessagesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<GetProductLiveChatMessagesQuery, TError, TData>(
      {
    queryKey: ['GetProductLiveChatMessages', variables],
    queryFn: fetchData<GetProductLiveChatMessagesQuery, GetProductLiveChatMessagesQueryVariables>(GetProductLiveChatMessagesDocument, variables),
    ...options
  }
    )};

useSuspenseGetProductLiveChatMessagesQuery.getKey = (variables: GetProductLiveChatMessagesQueryVariables) => ['GetProductLiveChatMessages', variables];

export const useInfiniteGetProductLiveChatMessagesQuery = <
      TData = InfiniteData<GetProductLiveChatMessagesQuery>,
      TError = unknown
    >(
      variables: GetProductLiveChatMessagesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetProductLiveChatMessagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetProductLiveChatMessagesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetProductLiveChatMessagesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetProductLiveChatMessages.infinite', variables],
      queryFn: (metaData) => fetchData<GetProductLiveChatMessagesQuery, GetProductLiveChatMessagesQueryVariables>(GetProductLiveChatMessagesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetProductLiveChatMessagesQuery.getKey = (variables: GetProductLiveChatMessagesQueryVariables) => ['GetProductLiveChatMessages.infinite', variables];

export const useSuspenseInfiniteGetProductLiveChatMessagesQuery = <
      TData = InfiniteData<GetProductLiveChatMessagesQuery>,
      TError = unknown
    >(
      variables: GetProductLiveChatMessagesQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<GetProductLiveChatMessagesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<GetProductLiveChatMessagesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<GetProductLiveChatMessagesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetProductLiveChatMessages.infinite', variables],
      queryFn: (metaData) => fetchData<GetProductLiveChatMessagesQuery, GetProductLiveChatMessagesQueryVariables>(GetProductLiveChatMessagesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteGetProductLiveChatMessagesQuery.getKey = (variables: GetProductLiveChatMessagesQueryVariables) => ['GetProductLiveChatMessages.infinite', variables];


useGetProductLiveChatMessagesQuery.fetcher = (variables: GetProductLiveChatMessagesQueryVariables, options?: RequestInit['headers']) => fetchData<GetProductLiveChatMessagesQuery, GetProductLiveChatMessagesQueryVariables>(GetProductLiveChatMessagesDocument, variables, options);

export const GetProductOptionsBySlugDocument = `
    query GetProductOptionsBySlug($slug: String!, $brandCode: String!) {
  ecommProductBySlug(brandCode: $brandCode, slug: $slug) {
    id
    name
    options {
      price
      salePrice
      inStock
      viPoints
      currency {
        symbol
      }
      description
      id
      productType {
        name
      }
    }
  }
}
    `;

export const useGetProductOptionsBySlugQuery = <
      TData = GetProductOptionsBySlugQuery,
      TError = unknown
    >(
      variables: GetProductOptionsBySlugQueryVariables,
      options?: Omit<UseQueryOptions<GetProductOptionsBySlugQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetProductOptionsBySlugQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetProductOptionsBySlugQuery, TError, TData>(
      {
    queryKey: ['GetProductOptionsBySlug', variables],
    queryFn: fetchData<GetProductOptionsBySlugQuery, GetProductOptionsBySlugQueryVariables>(GetProductOptionsBySlugDocument, variables),
    ...options
  }
    )};

useGetProductOptionsBySlugQuery.getKey = (variables: GetProductOptionsBySlugQueryVariables) => ['GetProductOptionsBySlug', variables];

export const useSuspenseGetProductOptionsBySlugQuery = <
      TData = GetProductOptionsBySlugQuery,
      TError = unknown
    >(
      variables: GetProductOptionsBySlugQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<GetProductOptionsBySlugQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<GetProductOptionsBySlugQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<GetProductOptionsBySlugQuery, TError, TData>(
      {
    queryKey: ['GetProductOptionsBySlug', variables],
    queryFn: fetchData<GetProductOptionsBySlugQuery, GetProductOptionsBySlugQueryVariables>(GetProductOptionsBySlugDocument, variables),
    ...options
  }
    )};

useSuspenseGetProductOptionsBySlugQuery.getKey = (variables: GetProductOptionsBySlugQueryVariables) => ['GetProductOptionsBySlug', variables];

export const useInfiniteGetProductOptionsBySlugQuery = <
      TData = InfiniteData<GetProductOptionsBySlugQuery>,
      TError = unknown
    >(
      variables: GetProductOptionsBySlugQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetProductOptionsBySlugQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetProductOptionsBySlugQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetProductOptionsBySlugQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetProductOptionsBySlug.infinite', variables],
      queryFn: (metaData) => fetchData<GetProductOptionsBySlugQuery, GetProductOptionsBySlugQueryVariables>(GetProductOptionsBySlugDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetProductOptionsBySlugQuery.getKey = (variables: GetProductOptionsBySlugQueryVariables) => ['GetProductOptionsBySlug.infinite', variables];

export const useSuspenseInfiniteGetProductOptionsBySlugQuery = <
      TData = InfiniteData<GetProductOptionsBySlugQuery>,
      TError = unknown
    >(
      variables: GetProductOptionsBySlugQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<GetProductOptionsBySlugQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<GetProductOptionsBySlugQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<GetProductOptionsBySlugQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetProductOptionsBySlug.infinite', variables],
      queryFn: (metaData) => fetchData<GetProductOptionsBySlugQuery, GetProductOptionsBySlugQueryVariables>(GetProductOptionsBySlugDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteGetProductOptionsBySlugQuery.getKey = (variables: GetProductOptionsBySlugQueryVariables) => ['GetProductOptionsBySlug.infinite', variables];


useGetProductOptionsBySlugQuery.fetcher = (variables: GetProductOptionsBySlugQueryVariables, options?: RequestInit['headers']) => fetchData<GetProductOptionsBySlugQuery, GetProductOptionsBySlugQueryVariables>(GetProductOptionsBySlugDocument, variables, options);

export const HasPurchasedProductDocument = `
    query HasPurchasedProduct($productId: Int!, $productOptionId: Int) {
  hasPurchasedProduct(productId: $productId, productOptionId: $productOptionId)
}
    `;

export const useHasPurchasedProductQuery = <
      TData = HasPurchasedProductQuery,
      TError = unknown
    >(
      variables: HasPurchasedProductQueryVariables,
      options?: Omit<UseQueryOptions<HasPurchasedProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<HasPurchasedProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<HasPurchasedProductQuery, TError, TData>(
      {
    queryKey: ['HasPurchasedProduct', variables],
    queryFn: fetchData<HasPurchasedProductQuery, HasPurchasedProductQueryVariables>(HasPurchasedProductDocument, variables),
    ...options
  }
    )};

useHasPurchasedProductQuery.getKey = (variables: HasPurchasedProductQueryVariables) => ['HasPurchasedProduct', variables];

export const useSuspenseHasPurchasedProductQuery = <
      TData = HasPurchasedProductQuery,
      TError = unknown
    >(
      variables: HasPurchasedProductQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<HasPurchasedProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<HasPurchasedProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<HasPurchasedProductQuery, TError, TData>(
      {
    queryKey: ['HasPurchasedProduct', variables],
    queryFn: fetchData<HasPurchasedProductQuery, HasPurchasedProductQueryVariables>(HasPurchasedProductDocument, variables),
    ...options
  }
    )};

useSuspenseHasPurchasedProductQuery.getKey = (variables: HasPurchasedProductQueryVariables) => ['HasPurchasedProduct', variables];

export const useInfiniteHasPurchasedProductQuery = <
      TData = InfiniteData<HasPurchasedProductQuery>,
      TError = unknown
    >(
      variables: HasPurchasedProductQueryVariables,
      options: Omit<UseInfiniteQueryOptions<HasPurchasedProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<HasPurchasedProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<HasPurchasedProductQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['HasPurchasedProduct.infinite', variables],
      queryFn: (metaData) => fetchData<HasPurchasedProductQuery, HasPurchasedProductQueryVariables>(HasPurchasedProductDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteHasPurchasedProductQuery.getKey = (variables: HasPurchasedProductQueryVariables) => ['HasPurchasedProduct.infinite', variables];

export const useSuspenseInfiniteHasPurchasedProductQuery = <
      TData = InfiniteData<HasPurchasedProductQuery>,
      TError = unknown
    >(
      variables: HasPurchasedProductQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<HasPurchasedProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<HasPurchasedProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<HasPurchasedProductQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['HasPurchasedProduct.infinite', variables],
      queryFn: (metaData) => fetchData<HasPurchasedProductQuery, HasPurchasedProductQueryVariables>(HasPurchasedProductDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteHasPurchasedProductQuery.getKey = (variables: HasPurchasedProductQueryVariables) => ['HasPurchasedProduct.infinite', variables];


useHasPurchasedProductQuery.fetcher = (variables: HasPurchasedProductQueryVariables, options?: RequestInit['headers']) => fetchData<HasPurchasedProductQuery, HasPurchasedProductQueryVariables>(HasPurchasedProductDocument, variables, options);

export const HomepageProductListDocument = `
    query HomepageProductList($productListId: Int!, $brandCode: String!) {
  productsByProductListId(
    productListId: $productListId
    brandCode: $brandCode
    take: 3
    skip: 0
    order: {positionInList: ASC}
    includeProductTrailers: true
  ) {
    items {
      id
      name
      url
      thumbnails {
        video
      }
      productTrailers {
        bunnyId
      }
    }
  }
}
    `;

export const useHomepageProductListQuery = <
      TData = HomepageProductListQuery,
      TError = unknown
    >(
      variables: HomepageProductListQueryVariables,
      options?: Omit<UseQueryOptions<HomepageProductListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<HomepageProductListQuery, TError, TData>['queryKey'] }
    ) => {

    return useQuery<HomepageProductListQuery, TError, TData>(
      {
    queryKey: ['HomepageProductList', variables],
    queryFn: fetchData<HomepageProductListQuery, HomepageProductListQueryVariables>(HomepageProductListDocument, variables),
    ...options
  }
    )};

useHomepageProductListQuery.getKey = (variables: HomepageProductListQueryVariables) => ['HomepageProductList', variables];

export const useSuspenseHomepageProductListQuery = <
      TData = HomepageProductListQuery,
      TError = unknown
    >(
      variables: HomepageProductListQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<HomepageProductListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<HomepageProductListQuery, TError, TData>['queryKey'] }
    ) => {

    return useSuspenseQuery<HomepageProductListQuery, TError, TData>(
      {
    queryKey: ['HomepageProductList', variables],
    queryFn: fetchData<HomepageProductListQuery, HomepageProductListQueryVariables>(HomepageProductListDocument, variables),
    ...options
  }
    )};

useSuspenseHomepageProductListQuery.getKey = (variables: HomepageProductListQueryVariables) => ['HomepageProductList', variables];

export const useInfiniteHomepageProductListQuery = <
      TData = InfiniteData<HomepageProductListQuery>,
      TError = unknown
    >(
      variables: HomepageProductListQueryVariables,
      options: Omit<UseInfiniteQueryOptions<HomepageProductListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<HomepageProductListQuery, TError, TData>['queryKey'] }
    ) => {

    return useInfiniteQuery<HomepageProductListQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['HomepageProductList.infinite', variables],
      queryFn: (metaData) => fetchData<HomepageProductListQuery, HomepageProductListQueryVariables>(HomepageProductListDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteHomepageProductListQuery.getKey = (variables: HomepageProductListQueryVariables) => ['HomepageProductList.infinite', variables];

export const useSuspenseInfiniteHomepageProductListQuery = <
      TData = InfiniteData<HomepageProductListQuery>,
      TError = unknown
    >(
      variables: HomepageProductListQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<HomepageProductListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<HomepageProductListQuery, TError, TData>['queryKey'] }
    ) => {

    return useSuspenseInfiniteQuery<HomepageProductListQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['HomepageProductList.infinite', variables],
      queryFn: (metaData) => fetchData<HomepageProductListQuery, HomepageProductListQueryVariables>(HomepageProductListDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteHomepageProductListQuery.getKey = (variables: HomepageProductListQueryVariables) => ['HomepageProductList.infinite', variables];


useHomepageProductListQuery.fetcher = (variables: HomepageProductListQueryVariables, options?: RequestInit['headers']) => fetchData<HomepageProductListQuery, HomepageProductListQueryVariables>(HomepageProductListDocument, variables, options);

export const LatestExclusiveProductsDocument = `
    query LatestExclusiveProducts {
  ecommProducts(
    take: 8
    skip: 0
    brandCode: "VANISHING_INC_US"
    where: {vanishingIncExclusive: {eq: true}, featured: {eq: true}}
    order: {dateAdded: DESC}
  ) {
    totalCount
    items {
      id
      name
      url
      thumbnails {
        default
      }
      creators {
        name
      }
    }
  }
}
    `;

export const useLatestExclusiveProductsQuery = <
      TData = LatestExclusiveProductsQuery,
      TError = unknown
    >(
      variables?: LatestExclusiveProductsQueryVariables,
      options?: Omit<UseQueryOptions<LatestExclusiveProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LatestExclusiveProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LatestExclusiveProductsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LatestExclusiveProducts'] : ['LatestExclusiveProducts', variables],
    queryFn: fetchData<LatestExclusiveProductsQuery, LatestExclusiveProductsQueryVariables>(LatestExclusiveProductsDocument, variables),
    ...options
  }
    )};

useLatestExclusiveProductsQuery.getKey = (variables?: LatestExclusiveProductsQueryVariables) => variables === undefined ? ['LatestExclusiveProducts'] : ['LatestExclusiveProducts', variables];

export const useSuspenseLatestExclusiveProductsQuery = <
      TData = LatestExclusiveProductsQuery,
      TError = unknown
    >(
      variables?: LatestExclusiveProductsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<LatestExclusiveProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<LatestExclusiveProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<LatestExclusiveProductsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['LatestExclusiveProducts'] : ['LatestExclusiveProducts', variables],
    queryFn: fetchData<LatestExclusiveProductsQuery, LatestExclusiveProductsQueryVariables>(LatestExclusiveProductsDocument, variables),
    ...options
  }
    )};

useSuspenseLatestExclusiveProductsQuery.getKey = (variables?: LatestExclusiveProductsQueryVariables) => variables === undefined ? ['LatestExclusiveProducts'] : ['LatestExclusiveProducts', variables];

export const useInfiniteLatestExclusiveProductsQuery = <
      TData = InfiniteData<LatestExclusiveProductsQuery>,
      TError = unknown
    >(
      variables: LatestExclusiveProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<LatestExclusiveProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<LatestExclusiveProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<LatestExclusiveProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['LatestExclusiveProducts.infinite'] : ['LatestExclusiveProducts.infinite', variables],
      queryFn: (metaData) => fetchData<LatestExclusiveProductsQuery, LatestExclusiveProductsQueryVariables>(LatestExclusiveProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteLatestExclusiveProductsQuery.getKey = (variables?: LatestExclusiveProductsQueryVariables) => variables === undefined ? ['LatestExclusiveProducts.infinite'] : ['LatestExclusiveProducts.infinite', variables];

export const useSuspenseInfiniteLatestExclusiveProductsQuery = <
      TData = InfiniteData<LatestExclusiveProductsQuery>,
      TError = unknown
    >(
      variables: LatestExclusiveProductsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<LatestExclusiveProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<LatestExclusiveProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<LatestExclusiveProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['LatestExclusiveProducts.infinite'] : ['LatestExclusiveProducts.infinite', variables],
      queryFn: (metaData) => fetchData<LatestExclusiveProductsQuery, LatestExclusiveProductsQueryVariables>(LatestExclusiveProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteLatestExclusiveProductsQuery.getKey = (variables?: LatestExclusiveProductsQueryVariables) => variables === undefined ? ['LatestExclusiveProducts.infinite'] : ['LatestExclusiveProducts.infinite', variables];


useLatestExclusiveProductsQuery.fetcher = (variables?: LatestExclusiveProductsQueryVariables, options?: RequestInit['headers']) => fetchData<LatestExclusiveProductsQuery, LatestExclusiveProductsQueryVariables>(LatestExclusiveProductsDocument, variables, options);

export const LatestFeaturedProductsDocument = `
    query LatestFeaturedProducts($take: Int!, $skip: Int!, $brandCode: String!, $where: EcommProductDtoFilterInput) {
  ecommProducts(
    take: $take
    skip: $skip
    brandCode: $brandCode
    maxBlurbLength: 200
    order: {dateAdded: DESC}
    where: $where
  ) {
    items {
      id
      name
      dateAdded
      url
      blurb
      hasDownloads
      thumbnails {
        default
        square
        video
      }
      displayPrice
      vanishingIncExclusive
      options {
        id
        description
        price
        salePrice
        priceIncVat
        salePriceIncVat
        taxType
        inStock
        productType {
          id
          name
        }
        currency {
          symbol
        }
      }
      productType {
        name
        id
      }
      creators {
        id
        name
        urlStub
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;

export const useLatestFeaturedProductsQuery = <
      TData = LatestFeaturedProductsQuery,
      TError = unknown
    >(
      variables: LatestFeaturedProductsQueryVariables,
      options?: Omit<UseQueryOptions<LatestFeaturedProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LatestFeaturedProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LatestFeaturedProductsQuery, TError, TData>(
      {
    queryKey: ['LatestFeaturedProducts', variables],
    queryFn: fetchData<LatestFeaturedProductsQuery, LatestFeaturedProductsQueryVariables>(LatestFeaturedProductsDocument, variables),
    ...options
  }
    )};

useLatestFeaturedProductsQuery.getKey = (variables: LatestFeaturedProductsQueryVariables) => ['LatestFeaturedProducts', variables];

export const useSuspenseLatestFeaturedProductsQuery = <
      TData = LatestFeaturedProductsQuery,
      TError = unknown
    >(
      variables: LatestFeaturedProductsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<LatestFeaturedProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<LatestFeaturedProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<LatestFeaturedProductsQuery, TError, TData>(
      {
    queryKey: ['LatestFeaturedProducts', variables],
    queryFn: fetchData<LatestFeaturedProductsQuery, LatestFeaturedProductsQueryVariables>(LatestFeaturedProductsDocument, variables),
    ...options
  }
    )};

useSuspenseLatestFeaturedProductsQuery.getKey = (variables: LatestFeaturedProductsQueryVariables) => ['LatestFeaturedProducts', variables];

export const useInfiniteLatestFeaturedProductsQuery = <
      TData = InfiniteData<LatestFeaturedProductsQuery>,
      TError = unknown
    >(
      variables: LatestFeaturedProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<LatestFeaturedProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<LatestFeaturedProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<LatestFeaturedProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['LatestFeaturedProducts.infinite', variables],
      queryFn: (metaData) => fetchData<LatestFeaturedProductsQuery, LatestFeaturedProductsQueryVariables>(LatestFeaturedProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteLatestFeaturedProductsQuery.getKey = (variables: LatestFeaturedProductsQueryVariables) => ['LatestFeaturedProducts.infinite', variables];

export const useSuspenseInfiniteLatestFeaturedProductsQuery = <
      TData = InfiniteData<LatestFeaturedProductsQuery>,
      TError = unknown
    >(
      variables: LatestFeaturedProductsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<LatestFeaturedProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<LatestFeaturedProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<LatestFeaturedProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['LatestFeaturedProducts.infinite', variables],
      queryFn: (metaData) => fetchData<LatestFeaturedProductsQuery, LatestFeaturedProductsQueryVariables>(LatestFeaturedProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteLatestFeaturedProductsQuery.getKey = (variables: LatestFeaturedProductsQueryVariables) => ['LatestFeaturedProducts.infinite', variables];


useLatestFeaturedProductsQuery.fetcher = (variables: LatestFeaturedProductsQueryVariables, options?: RequestInit['headers']) => fetchData<LatestFeaturedProductsQuery, LatestFeaturedProductsQueryVariables>(LatestFeaturedProductsDocument, variables, options);

export const LatestProductsDocument = `
    query LatestProducts($take: Int!, $skip: Int!, $brandCode: String!, $maxBlurbLength: Int!, $where: EcommProductDtoFilterInput, $order: [ProductsSort!], $productTypeGroup: String) {
  ecommProducts(
    take: $take
    skip: $skip
    brandCode: $brandCode
    maxBlurbLength: $maxBlurbLength
    where: $where
    order: $order
    productTypeGroup: $productTypeGroup
  ) {
    totalCount
    items {
      id
      name
      url
      blurb
      hasDownloads
      thumbnails {
        default
        square
        video
      }
      displayPrice
      vanishingIncExclusive
      options {
        id
        description
        price
        salePrice
        priceIncVat
        salePriceIncVat
        taxType
        inStock
        productType {
          id
          name
        }
        currency {
          symbol
        }
      }
      productType {
        name
        id
      }
      creators {
        id
        name
        urlStub
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
    }
  }
}
    `;

export const useLatestProductsQuery = <
      TData = LatestProductsQuery,
      TError = unknown
    >(
      variables: LatestProductsQueryVariables,
      options?: Omit<UseQueryOptions<LatestProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LatestProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LatestProductsQuery, TError, TData>(
      {
    queryKey: ['LatestProducts', variables],
    queryFn: fetchData<LatestProductsQuery, LatestProductsQueryVariables>(LatestProductsDocument, variables),
    ...options
  }
    )};

useLatestProductsQuery.getKey = (variables: LatestProductsQueryVariables) => ['LatestProducts', variables];

export const useSuspenseLatestProductsQuery = <
      TData = LatestProductsQuery,
      TError = unknown
    >(
      variables: LatestProductsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<LatestProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<LatestProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<LatestProductsQuery, TError, TData>(
      {
    queryKey: ['LatestProducts', variables],
    queryFn: fetchData<LatestProductsQuery, LatestProductsQueryVariables>(LatestProductsDocument, variables),
    ...options
  }
    )};

useSuspenseLatestProductsQuery.getKey = (variables: LatestProductsQueryVariables) => ['LatestProducts', variables];

export const useInfiniteLatestProductsQuery = <
      TData = InfiniteData<LatestProductsQuery>,
      TError = unknown
    >(
      variables: LatestProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<LatestProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<LatestProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<LatestProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['LatestProducts.infinite', variables],
      queryFn: (metaData) => fetchData<LatestProductsQuery, LatestProductsQueryVariables>(LatestProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteLatestProductsQuery.getKey = (variables: LatestProductsQueryVariables) => ['LatestProducts.infinite', variables];

export const useSuspenseInfiniteLatestProductsQuery = <
      TData = InfiniteData<LatestProductsQuery>,
      TError = unknown
    >(
      variables: LatestProductsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<LatestProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<LatestProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<LatestProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['LatestProducts.infinite', variables],
      queryFn: (metaData) => fetchData<LatestProductsQuery, LatestProductsQueryVariables>(LatestProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteLatestProductsQuery.getKey = (variables: LatestProductsQueryVariables) => ['LatestProducts.infinite', variables];


useLatestProductsQuery.fetcher = (variables: LatestProductsQueryVariables, options?: RequestInit['headers']) => fetchData<LatestProductsQuery, LatestProductsQueryVariables>(LatestProductsDocument, variables, options);

export const ListPageDocument = `
    query ListPage($listSlug: String!, $take: Int!, $skip: Int!, $brandCode: String!) {
  productList(urlStub: $listSlug) {
    introduction
    templateKey
    title
  }
  productsByProductListSlug(
    skip: $skip
    take: $take
    brandCode: $brandCode
    productListSlug: $listSlug
  ) {
    totalCount
    items {
      blurb
      displayPrice
      id
      name
      url
      hasDownloads
      vanishingIncExclusive
      creators {
        id
        name
        urlStub
      }
      options {
        description
        id
        inStock
        price
        salePrice
        priceIncVat
        salePriceIncVat
        taxType
        productType {
          id
          name
        }
        currency {
          symbol
          code
        }
      }
      productType {
        id
        name
      }
      thumbnails {
        default
        square
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

export const useListPageQuery = <
      TData = ListPageQuery,
      TError = unknown
    >(
      variables: ListPageQueryVariables,
      options?: Omit<UseQueryOptions<ListPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListPageQuery, TError, TData>(
      {
    queryKey: ['ListPage', variables],
    queryFn: fetchData<ListPageQuery, ListPageQueryVariables>(ListPageDocument, variables),
    ...options
  }
    )};

useListPageQuery.getKey = (variables: ListPageQueryVariables) => ['ListPage', variables];

export const useSuspenseListPageQuery = <
      TData = ListPageQuery,
      TError = unknown
    >(
      variables: ListPageQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ListPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ListPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ListPageQuery, TError, TData>(
      {
    queryKey: ['ListPage', variables],
    queryFn: fetchData<ListPageQuery, ListPageQueryVariables>(ListPageDocument, variables),
    ...options
  }
    )};

useSuspenseListPageQuery.getKey = (variables: ListPageQueryVariables) => ['ListPage', variables];

export const useInfiniteListPageQuery = <
      TData = InfiniteData<ListPageQuery>,
      TError = unknown
    >(
      variables: ListPageQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListPageQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListPage.infinite', variables],
      queryFn: (metaData) => fetchData<ListPageQuery, ListPageQueryVariables>(ListPageDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListPageQuery.getKey = (variables: ListPageQueryVariables) => ['ListPage.infinite', variables];

export const useSuspenseInfiniteListPageQuery = <
      TData = InfiniteData<ListPageQuery>,
      TError = unknown
    >(
      variables: ListPageQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ListPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ListPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ListPageQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListPage.infinite', variables],
      queryFn: (metaData) => fetchData<ListPageQuery, ListPageQueryVariables>(ListPageDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteListPageQuery.getKey = (variables: ListPageQueryVariables) => ['ListPage.infinite', variables];


useListPageQuery.fetcher = (variables: ListPageQueryVariables, options?: RequestInit['headers']) => fetchData<ListPageQuery, ListPageQueryVariables>(ListPageDocument, variables, options);

export const MinimalProductDocument = `
    query MinimalProduct($slug: String!, $brandCode: String!) {
  ecommProductBySlug(brandCode: $brandCode, slug: $slug) {
    id
    name
    url
    blurb
    thumbnails {
      default
      square
      video
    }
  }
}
    `;

export const useMinimalProductQuery = <
      TData = MinimalProductQuery,
      TError = unknown
    >(
      variables: MinimalProductQueryVariables,
      options?: Omit<UseQueryOptions<MinimalProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MinimalProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MinimalProductQuery, TError, TData>(
      {
    queryKey: ['MinimalProduct', variables],
    queryFn: fetchData<MinimalProductQuery, MinimalProductQueryVariables>(MinimalProductDocument, variables),
    ...options
  }
    )};

useMinimalProductQuery.getKey = (variables: MinimalProductQueryVariables) => ['MinimalProduct', variables];

export const useSuspenseMinimalProductQuery = <
      TData = MinimalProductQuery,
      TError = unknown
    >(
      variables: MinimalProductQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MinimalProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MinimalProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MinimalProductQuery, TError, TData>(
      {
    queryKey: ['MinimalProduct', variables],
    queryFn: fetchData<MinimalProductQuery, MinimalProductQueryVariables>(MinimalProductDocument, variables),
    ...options
  }
    )};

useSuspenseMinimalProductQuery.getKey = (variables: MinimalProductQueryVariables) => ['MinimalProduct', variables];

export const useInfiniteMinimalProductQuery = <
      TData = InfiniteData<MinimalProductQuery>,
      TError = unknown
    >(
      variables: MinimalProductQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MinimalProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MinimalProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<MinimalProductQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MinimalProduct.infinite', variables],
      queryFn: (metaData) => fetchData<MinimalProductQuery, MinimalProductQueryVariables>(MinimalProductDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMinimalProductQuery.getKey = (variables: MinimalProductQueryVariables) => ['MinimalProduct.infinite', variables];

export const useSuspenseInfiniteMinimalProductQuery = <
      TData = InfiniteData<MinimalProductQuery>,
      TError = unknown
    >(
      variables: MinimalProductQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<MinimalProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<MinimalProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<MinimalProductQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MinimalProduct.infinite', variables],
      queryFn: (metaData) => fetchData<MinimalProductQuery, MinimalProductQueryVariables>(MinimalProductDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteMinimalProductQuery.getKey = (variables: MinimalProductQueryVariables) => ['MinimalProduct.infinite', variables];


useMinimalProductQuery.fetcher = (variables: MinimalProductQueryVariables, options?: RequestInit['headers']) => fetchData<MinimalProductQuery, MinimalProductQueryVariables>(MinimalProductDocument, variables, options);

export const ProductDocument = `
    query Product($slug: String!, $brandCode: String!, $password: String) {
  ecommProductBySlug(brandCode: $brandCode, slug: $slug, password: $password) {
    id
    name
    url
    displayPrice
    currencySymbol
    description
    murphysProductId
    vanishingIncExclusive
    dateAdded
    options {
      price
      salePrice
      priceIncVat
      salePriceIncVat
      taxType
      inStock
      viPoints
      maxQuantity
      currency {
        symbol
        code
      }
      description
      murphysProductId
      id
      productType {
        name
      }
      needsShipping
    }
    productImages {
      id
      src
    }
    thumbnails {
      default
      video
    }
    productTrailers {
      bunnyId
    }
    creators {
      urlStub
      name
    }
    productType {
      id
      name
    }
    hasDownloads
    isPreorder
    isParent
    childProductContents {
      id
      name
      urlStub
      url
      description
      thumbnailUrl
    }
    childProductCommercials {
      id
      displayPrice
      isPreorder
      options {
        price
        salePrice
        priceIncVat
        salePriceIncVat
        taxType
        inStock
        viPoints
        maxQuantity
        currency {
          symbol
          code
        }
        description
        id
        productType {
          name
        }
        needsShipping
      }
    }
    ebookBundleOption {
      physicalOptionId
      downloadOptionId
      price
      currency {
        symbol
        code
      }
    }
    reviews {
      id
      rating
      review
      reviewerName
      gravatarUrl
      isMasterclassSubscriber
    }
    categories {
      id
      urlStub
      name
    }
    meta {
      id
      key
      value
    }
  }
}
    `;

export const useProductQuery = <
      TData = ProductQuery,
      TError = unknown
    >(
      variables: ProductQueryVariables,
      options?: Omit<UseQueryOptions<ProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProductQuery, TError, TData>(
      {
    queryKey: ['Product', variables],
    queryFn: fetchData<ProductQuery, ProductQueryVariables>(ProductDocument, variables),
    ...options
  }
    )};

useProductQuery.getKey = (variables: ProductQueryVariables) => ['Product', variables];

export const useSuspenseProductQuery = <
      TData = ProductQuery,
      TError = unknown
    >(
      variables: ProductQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ProductQuery, TError, TData>(
      {
    queryKey: ['Product', variables],
    queryFn: fetchData<ProductQuery, ProductQueryVariables>(ProductDocument, variables),
    ...options
  }
    )};

useSuspenseProductQuery.getKey = (variables: ProductQueryVariables) => ['Product', variables];

export const useInfiniteProductQuery = <
      TData = InfiniteData<ProductQuery>,
      TError = unknown
    >(
      variables: ProductQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ProductQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Product.infinite', variables],
      queryFn: (metaData) => fetchData<ProductQuery, ProductQueryVariables>(ProductDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteProductQuery.getKey = (variables: ProductQueryVariables) => ['Product.infinite', variables];

export const useSuspenseInfiniteProductQuery = <
      TData = InfiniteData<ProductQuery>,
      TError = unknown
    >(
      variables: ProductQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ProductQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Product.infinite', variables],
      queryFn: (metaData) => fetchData<ProductQuery, ProductQueryVariables>(ProductDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteProductQuery.getKey = (variables: ProductQueryVariables) => ['Product.infinite', variables];


useProductQuery.fetcher = (variables: ProductQueryVariables, options?: RequestInit['headers']) => fetchData<ProductQuery, ProductQueryVariables>(ProductDocument, variables, options);

export const ProductAccessDocument = `
    query ProductAccess($slug: String!) {
  ecommProductAccessBySlug(slug: $slug) {
    productId
    requiresPassword
  }
}
    `;

export const useProductAccessQuery = <
      TData = ProductAccessQuery,
      TError = unknown
    >(
      variables: ProductAccessQueryVariables,
      options?: Omit<UseQueryOptions<ProductAccessQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProductAccessQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProductAccessQuery, TError, TData>(
      {
    queryKey: ['ProductAccess', variables],
    queryFn: fetchData<ProductAccessQuery, ProductAccessQueryVariables>(ProductAccessDocument, variables),
    ...options
  }
    )};

useProductAccessQuery.getKey = (variables: ProductAccessQueryVariables) => ['ProductAccess', variables];

export const useSuspenseProductAccessQuery = <
      TData = ProductAccessQuery,
      TError = unknown
    >(
      variables: ProductAccessQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ProductAccessQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ProductAccessQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ProductAccessQuery, TError, TData>(
      {
    queryKey: ['ProductAccess', variables],
    queryFn: fetchData<ProductAccessQuery, ProductAccessQueryVariables>(ProductAccessDocument, variables),
    ...options
  }
    )};

useSuspenseProductAccessQuery.getKey = (variables: ProductAccessQueryVariables) => ['ProductAccess', variables];

export const useInfiniteProductAccessQuery = <
      TData = InfiniteData<ProductAccessQuery>,
      TError = unknown
    >(
      variables: ProductAccessQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProductAccessQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProductAccessQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ProductAccessQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductAccess.infinite', variables],
      queryFn: (metaData) => fetchData<ProductAccessQuery, ProductAccessQueryVariables>(ProductAccessDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteProductAccessQuery.getKey = (variables: ProductAccessQueryVariables) => ['ProductAccess.infinite', variables];

export const useSuspenseInfiniteProductAccessQuery = <
      TData = InfiniteData<ProductAccessQuery>,
      TError = unknown
    >(
      variables: ProductAccessQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ProductAccessQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ProductAccessQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ProductAccessQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductAccess.infinite', variables],
      queryFn: (metaData) => fetchData<ProductAccessQuery, ProductAccessQueryVariables>(ProductAccessDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteProductAccessQuery.getKey = (variables: ProductAccessQueryVariables) => ['ProductAccess.infinite', variables];


useProductAccessQuery.fetcher = (variables: ProductAccessQueryVariables, options?: RequestInit['headers']) => fetchData<ProductAccessQuery, ProductAccessQueryVariables>(ProductAccessDocument, variables, options);

export const ProductByIdDocument = `
    query ProductById($id: Int!, $brandCode: String!, $shippingCountry: String) {
  ecommProductById(
    id: $id
    brandCode: $brandCode
    shippingCountry: $shippingCountry
  ) {
    id
    name
    url
    displayPrice
    currencySymbol
    inStock
    hasDownloads
    isPreorder
    preorderRelease
    ebookBundleOption {
      physicalOptionId
      downloadOptionId
    }
    options {
      id
      description
      position
      price
      salePrice
      priceIncVat
      salePriceIncVat
      taxType
      inStock
      needsShipping
      currency {
        symbol
        code
      }
      productType {
        name
      }
    }
    creators {
      name
    }
  }
}
    `;

export const useProductByIdQuery = <
      TData = ProductByIdQuery,
      TError = unknown
    >(
      variables: ProductByIdQueryVariables,
      options?: Omit<UseQueryOptions<ProductByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProductByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProductByIdQuery, TError, TData>(
      {
    queryKey: ['ProductById', variables],
    queryFn: fetchData<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, variables),
    ...options
  }
    )};

useProductByIdQuery.getKey = (variables: ProductByIdQueryVariables) => ['ProductById', variables];

export const useSuspenseProductByIdQuery = <
      TData = ProductByIdQuery,
      TError = unknown
    >(
      variables: ProductByIdQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ProductByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ProductByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ProductByIdQuery, TError, TData>(
      {
    queryKey: ['ProductById', variables],
    queryFn: fetchData<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, variables),
    ...options
  }
    )};

useSuspenseProductByIdQuery.getKey = (variables: ProductByIdQueryVariables) => ['ProductById', variables];

export const useInfiniteProductByIdQuery = <
      TData = InfiniteData<ProductByIdQuery>,
      TError = unknown
    >(
      variables: ProductByIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProductByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProductByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ProductByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductById.infinite', variables],
      queryFn: (metaData) => fetchData<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteProductByIdQuery.getKey = (variables: ProductByIdQueryVariables) => ['ProductById.infinite', variables];

export const useSuspenseInfiniteProductByIdQuery = <
      TData = InfiniteData<ProductByIdQuery>,
      TError = unknown
    >(
      variables: ProductByIdQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ProductByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ProductByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ProductByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductById.infinite', variables],
      queryFn: (metaData) => fetchData<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteProductByIdQuery.getKey = (variables: ProductByIdQueryVariables) => ['ProductById.infinite', variables];


useProductByIdQuery.fetcher = (variables: ProductByIdQueryVariables, options?: RequestInit['headers']) => fetchData<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, variables, options);

export const ProductCommercialDocument = `
    query ProductCommercial($slug: String!, $brandCode: String!, $password: String, $shippingCountry: String) {
  ecommProductCommercialBySlug(
    slug: $slug
    brandCode: $brandCode
    password: $password
    shippingCountry: $shippingCountry
  ) {
    id
    displayPrice
    murphysProductId
    ebookBundleOption {
      physicalOptionId
      downloadOptionId
      price
      currency {
        symbol
        code
      }
    }
    options {
      price
      salePrice
      priceIncVat
      salePriceIncVat
      taxType
      inStock
      viPoints
      maxQuantity
      currency {
        symbol
        code
      }
      description
      murphysProductId
      id
      productType {
        name
      }
      needsShipping
    }
    isParent
    childProductCommercials {
      id
      displayPrice
      isPreorder
      options {
        price
        salePrice
        priceIncVat
        salePriceIncVat
        taxType
        inStock
        viPoints
        maxQuantity
        currency {
          symbol
          code
        }
        description
        id
        productType {
          name
        }
        needsShipping
      }
    }
  }
}
    `;

export const useProductCommercialQuery = <
      TData = ProductCommercialQuery,
      TError = unknown
    >(
      variables: ProductCommercialQueryVariables,
      options?: Omit<UseQueryOptions<ProductCommercialQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProductCommercialQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProductCommercialQuery, TError, TData>(
      {
    queryKey: ['ProductCommercial', variables],
    queryFn: fetchData<ProductCommercialQuery, ProductCommercialQueryVariables>(ProductCommercialDocument, variables),
    ...options
  }
    )};

useProductCommercialQuery.getKey = (variables: ProductCommercialQueryVariables) => ['ProductCommercial', variables];

export const useSuspenseProductCommercialQuery = <
      TData = ProductCommercialQuery,
      TError = unknown
    >(
      variables: ProductCommercialQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ProductCommercialQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ProductCommercialQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ProductCommercialQuery, TError, TData>(
      {
    queryKey: ['ProductCommercial', variables],
    queryFn: fetchData<ProductCommercialQuery, ProductCommercialQueryVariables>(ProductCommercialDocument, variables),
    ...options
  }
    )};

useSuspenseProductCommercialQuery.getKey = (variables: ProductCommercialQueryVariables) => ['ProductCommercial', variables];

export const useInfiniteProductCommercialQuery = <
      TData = InfiniteData<ProductCommercialQuery>,
      TError = unknown
    >(
      variables: ProductCommercialQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProductCommercialQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProductCommercialQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ProductCommercialQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductCommercial.infinite', variables],
      queryFn: (metaData) => fetchData<ProductCommercialQuery, ProductCommercialQueryVariables>(ProductCommercialDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteProductCommercialQuery.getKey = (variables: ProductCommercialQueryVariables) => ['ProductCommercial.infinite', variables];

export const useSuspenseInfiniteProductCommercialQuery = <
      TData = InfiniteData<ProductCommercialQuery>,
      TError = unknown
    >(
      variables: ProductCommercialQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ProductCommercialQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ProductCommercialQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ProductCommercialQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductCommercial.infinite', variables],
      queryFn: (metaData) => fetchData<ProductCommercialQuery, ProductCommercialQueryVariables>(ProductCommercialDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteProductCommercialQuery.getKey = (variables: ProductCommercialQueryVariables) => ['ProductCommercial.infinite', variables];


useProductCommercialQuery.fetcher = (variables: ProductCommercialQueryVariables, options?: RequestInit['headers']) => fetchData<ProductCommercialQuery, ProductCommercialQueryVariables>(ProductCommercialDocument, variables, options);

export const ProductContentDocument = `
    query ProductContent($slug: String!) {
  ecommProductContentBySlug(slug: $slug) {
    id
    name
    url
    description
    murphysProductId
    vanishingIncExclusive
    dateAdded
    manufacturerId
    hasDownloads
    isPreorder
    preorderRelease
    discontinued
    rating
    productImages {
      id
      src
    }
    thumbnails {
      default
      video
    }
    productTrailers {
      bunnyId
    }
    creators {
      urlStub
      name
    }
    productType {
      id
      name
    }
    reviews {
      id
      rating
      review
      reviewerName
      gravatarUrl
      isMasterclassSubscriber
      reviewDate
    }
    categories {
      id
      urlStub
      name
    }
    meta {
      id
      key
      value
    }
    isParent
    childProductContents {
      id
      name
      urlStub
      url
      description
      thumbnailUrl
    }
  }
}
    `;

export const useProductContentQuery = <
      TData = ProductContentQuery,
      TError = unknown
    >(
      variables: ProductContentQueryVariables,
      options?: Omit<UseQueryOptions<ProductContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProductContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProductContentQuery, TError, TData>(
      {
    queryKey: ['ProductContent', variables],
    queryFn: fetchData<ProductContentQuery, ProductContentQueryVariables>(ProductContentDocument, variables),
    ...options
  }
    )};

useProductContentQuery.getKey = (variables: ProductContentQueryVariables) => ['ProductContent', variables];

export const useSuspenseProductContentQuery = <
      TData = ProductContentQuery,
      TError = unknown
    >(
      variables: ProductContentQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ProductContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ProductContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ProductContentQuery, TError, TData>(
      {
    queryKey: ['ProductContent', variables],
    queryFn: fetchData<ProductContentQuery, ProductContentQueryVariables>(ProductContentDocument, variables),
    ...options
  }
    )};

useSuspenseProductContentQuery.getKey = (variables: ProductContentQueryVariables) => ['ProductContent', variables];

export const useInfiniteProductContentQuery = <
      TData = InfiniteData<ProductContentQuery>,
      TError = unknown
    >(
      variables: ProductContentQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProductContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProductContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ProductContentQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductContent.infinite', variables],
      queryFn: (metaData) => fetchData<ProductContentQuery, ProductContentQueryVariables>(ProductContentDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteProductContentQuery.getKey = (variables: ProductContentQueryVariables) => ['ProductContent.infinite', variables];

export const useSuspenseInfiniteProductContentQuery = <
      TData = InfiniteData<ProductContentQuery>,
      TError = unknown
    >(
      variables: ProductContentQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ProductContentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ProductContentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ProductContentQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductContent.infinite', variables],
      queryFn: (metaData) => fetchData<ProductContentQuery, ProductContentQueryVariables>(ProductContentDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteProductContentQuery.getKey = (variables: ProductContentQueryVariables) => ['ProductContent.infinite', variables];


useProductContentQuery.fetcher = (variables: ProductContentQueryVariables, options?: RequestInit['headers']) => fetchData<ProductContentQuery, ProductContentQueryVariables>(ProductContentDocument, variables, options);

export const ProductListDocument = `
    query ProductList($urlStub: String!) {
  productList(urlStub: $urlStub) {
    id
    introduction
    live
    title
    urlStub
  }
}
    `;

export const useProductListQuery = <
      TData = ProductListQuery,
      TError = unknown
    >(
      variables: ProductListQueryVariables,
      options?: Omit<UseQueryOptions<ProductListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProductListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProductListQuery, TError, TData>(
      {
    queryKey: ['ProductList', variables],
    queryFn: fetchData<ProductListQuery, ProductListQueryVariables>(ProductListDocument, variables),
    ...options
  }
    )};

useProductListQuery.getKey = (variables: ProductListQueryVariables) => ['ProductList', variables];

export const useSuspenseProductListQuery = <
      TData = ProductListQuery,
      TError = unknown
    >(
      variables: ProductListQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ProductListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ProductListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ProductListQuery, TError, TData>(
      {
    queryKey: ['ProductList', variables],
    queryFn: fetchData<ProductListQuery, ProductListQueryVariables>(ProductListDocument, variables),
    ...options
  }
    )};

useSuspenseProductListQuery.getKey = (variables: ProductListQueryVariables) => ['ProductList', variables];

export const useInfiniteProductListQuery = <
      TData = InfiniteData<ProductListQuery>,
      TError = unknown
    >(
      variables: ProductListQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProductListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProductListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ProductListQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductList.infinite', variables],
      queryFn: (metaData) => fetchData<ProductListQuery, ProductListQueryVariables>(ProductListDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteProductListQuery.getKey = (variables: ProductListQueryVariables) => ['ProductList.infinite', variables];

export const useSuspenseInfiniteProductListQuery = <
      TData = InfiniteData<ProductListQuery>,
      TError = unknown
    >(
      variables: ProductListQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ProductListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ProductListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ProductListQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductList.infinite', variables],
      queryFn: (metaData) => fetchData<ProductListQuery, ProductListQueryVariables>(ProductListDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteProductListQuery.getKey = (variables: ProductListQueryVariables) => ['ProductList.infinite', variables];


useProductListQuery.fetcher = (variables: ProductListQueryVariables, options?: RequestInit['headers']) => fetchData<ProductListQuery, ProductListQueryVariables>(ProductListDocument, variables, options);

export const ProductListProductsDocument = `
    query ProductListProducts($productListSlug: String!, $take: Int!, $skip: Int!, $brandCode: String!, $order: [ProductsByProductListSort!]) {
  productsByProductListSlug(
    skip: $skip
    take: $take
    brandCode: $brandCode
    productListSlug: $productListSlug
    order: $order
  ) {
    totalCount
    items {
      blurb
      dateAdded
      description
      displayPrice
      id
      name
      url
      hasDownloads
      vanishingIncExclusive
      creators {
        id
        name
        urlStub
      }
      options {
        description
        id
        inStock
        price
        salePrice
        priceIncVat
        salePriceIncVat
        taxType
        needsShipping
        productType {
          id
          name
        }
        currency {
          symbol
          code
        }
      }
      productImages {
        id
        src
      }
      productType {
        id
        name
      }
      meta {
        id
        key
        value
      }
      thumbnails {
        default
        square
        video
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    `;

export const useProductListProductsQuery = <
      TData = ProductListProductsQuery,
      TError = unknown
    >(
      variables: ProductListProductsQueryVariables,
      options?: Omit<UseQueryOptions<ProductListProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProductListProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProductListProductsQuery, TError, TData>(
      {
    queryKey: ['ProductListProducts', variables],
    queryFn: fetchData<ProductListProductsQuery, ProductListProductsQueryVariables>(ProductListProductsDocument, variables),
    ...options
  }
    )};

useProductListProductsQuery.getKey = (variables: ProductListProductsQueryVariables) => ['ProductListProducts', variables];

export const useSuspenseProductListProductsQuery = <
      TData = ProductListProductsQuery,
      TError = unknown
    >(
      variables: ProductListProductsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ProductListProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ProductListProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ProductListProductsQuery, TError, TData>(
      {
    queryKey: ['ProductListProducts', variables],
    queryFn: fetchData<ProductListProductsQuery, ProductListProductsQueryVariables>(ProductListProductsDocument, variables),
    ...options
  }
    )};

useSuspenseProductListProductsQuery.getKey = (variables: ProductListProductsQueryVariables) => ['ProductListProducts', variables];

export const useInfiniteProductListProductsQuery = <
      TData = InfiniteData<ProductListProductsQuery>,
      TError = unknown
    >(
      variables: ProductListProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProductListProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProductListProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ProductListProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductListProducts.infinite', variables],
      queryFn: (metaData) => fetchData<ProductListProductsQuery, ProductListProductsQueryVariables>(ProductListProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteProductListProductsQuery.getKey = (variables: ProductListProductsQueryVariables) => ['ProductListProducts.infinite', variables];

export const useSuspenseInfiniteProductListProductsQuery = <
      TData = InfiniteData<ProductListProductsQuery>,
      TError = unknown
    >(
      variables: ProductListProductsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ProductListProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ProductListProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ProductListProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductListProducts.infinite', variables],
      queryFn: (metaData) => fetchData<ProductListProductsQuery, ProductListProductsQueryVariables>(ProductListProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteProductListProductsQuery.getKey = (variables: ProductListProductsQueryVariables) => ['ProductListProducts.infinite', variables];


useProductListProductsQuery.fetcher = (variables: ProductListProductsQueryVariables, options?: RequestInit['headers']) => fetchData<ProductListProductsQuery, ProductListProductsQueryVariables>(ProductListProductsDocument, variables, options);

export const ProductQuestionDocument = `
    query ProductQuestion($productQuestionId: Int!) {
  productQuestion(productQuestionId: $productQuestionId) {
    id
    customerId
    customerName
    question
    productId
    productName
  }
}
    `;

export const useProductQuestionQuery = <
      TData = ProductQuestionQuery,
      TError = unknown
    >(
      variables: ProductQuestionQueryVariables,
      options?: Omit<UseQueryOptions<ProductQuestionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProductQuestionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProductQuestionQuery, TError, TData>(
      {
    queryKey: ['ProductQuestion', variables],
    queryFn: fetchData<ProductQuestionQuery, ProductQuestionQueryVariables>(ProductQuestionDocument, variables),
    ...options
  }
    )};

useProductQuestionQuery.getKey = (variables: ProductQuestionQueryVariables) => ['ProductQuestion', variables];

export const useSuspenseProductQuestionQuery = <
      TData = ProductQuestionQuery,
      TError = unknown
    >(
      variables: ProductQuestionQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ProductQuestionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ProductQuestionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ProductQuestionQuery, TError, TData>(
      {
    queryKey: ['ProductQuestion', variables],
    queryFn: fetchData<ProductQuestionQuery, ProductQuestionQueryVariables>(ProductQuestionDocument, variables),
    ...options
  }
    )};

useSuspenseProductQuestionQuery.getKey = (variables: ProductQuestionQueryVariables) => ['ProductQuestion', variables];

export const useInfiniteProductQuestionQuery = <
      TData = InfiniteData<ProductQuestionQuery>,
      TError = unknown
    >(
      variables: ProductQuestionQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProductQuestionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProductQuestionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ProductQuestionQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductQuestion.infinite', variables],
      queryFn: (metaData) => fetchData<ProductQuestionQuery, ProductQuestionQueryVariables>(ProductQuestionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteProductQuestionQuery.getKey = (variables: ProductQuestionQueryVariables) => ['ProductQuestion.infinite', variables];

export const useSuspenseInfiniteProductQuestionQuery = <
      TData = InfiniteData<ProductQuestionQuery>,
      TError = unknown
    >(
      variables: ProductQuestionQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ProductQuestionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ProductQuestionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ProductQuestionQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductQuestion.infinite', variables],
      queryFn: (metaData) => fetchData<ProductQuestionQuery, ProductQuestionQueryVariables>(ProductQuestionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteProductQuestionQuery.getKey = (variables: ProductQuestionQueryVariables) => ['ProductQuestion.infinite', variables];


useProductQuestionQuery.fetcher = (variables: ProductQuestionQueryVariables, options?: RequestInit['headers']) => fetchData<ProductQuestionQuery, ProductQuestionQueryVariables>(ProductQuestionDocument, variables, options);

export const ProductQuestionsDocument = `
    query ProductQuestions($productId: Int!, $take: Int!, $skip: Int = 0) {
  productQuestions(productId: $productId, skip: $skip, take: $take) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    items {
      id
      customerId
      customerName
      question
      answers {
        id
        customerId
        customerName
        answer
        isCreator
      }
    }
  }
}
    `;

export const useProductQuestionsQuery = <
      TData = ProductQuestionsQuery,
      TError = unknown
    >(
      variables: ProductQuestionsQueryVariables,
      options?: Omit<UseQueryOptions<ProductQuestionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProductQuestionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProductQuestionsQuery, TError, TData>(
      {
    queryKey: ['ProductQuestions', variables],
    queryFn: fetchData<ProductQuestionsQuery, ProductQuestionsQueryVariables>(ProductQuestionsDocument, variables),
    ...options
  }
    )};

useProductQuestionsQuery.getKey = (variables: ProductQuestionsQueryVariables) => ['ProductQuestions', variables];

export const useSuspenseProductQuestionsQuery = <
      TData = ProductQuestionsQuery,
      TError = unknown
    >(
      variables: ProductQuestionsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ProductQuestionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ProductQuestionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ProductQuestionsQuery, TError, TData>(
      {
    queryKey: ['ProductQuestions', variables],
    queryFn: fetchData<ProductQuestionsQuery, ProductQuestionsQueryVariables>(ProductQuestionsDocument, variables),
    ...options
  }
    )};

useSuspenseProductQuestionsQuery.getKey = (variables: ProductQuestionsQueryVariables) => ['ProductQuestions', variables];

export const useInfiniteProductQuestionsQuery = <
      TData = InfiniteData<ProductQuestionsQuery>,
      TError = unknown
    >(
      variables: ProductQuestionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProductQuestionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProductQuestionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ProductQuestionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductQuestions.infinite', variables],
      queryFn: (metaData) => fetchData<ProductQuestionsQuery, ProductQuestionsQueryVariables>(ProductQuestionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteProductQuestionsQuery.getKey = (variables: ProductQuestionsQueryVariables) => ['ProductQuestions.infinite', variables];

export const useSuspenseInfiniteProductQuestionsQuery = <
      TData = InfiniteData<ProductQuestionsQuery>,
      TError = unknown
    >(
      variables: ProductQuestionsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ProductQuestionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ProductQuestionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ProductQuestionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ProductQuestions.infinite', variables],
      queryFn: (metaData) => fetchData<ProductQuestionsQuery, ProductQuestionsQueryVariables>(ProductQuestionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteProductQuestionsQuery.getKey = (variables: ProductQuestionsQueryVariables) => ['ProductQuestions.infinite', variables];


useProductQuestionsQuery.fetcher = (variables: ProductQuestionsQueryVariables, options?: RequestInit['headers']) => fetchData<ProductQuestionsQuery, ProductQuestionsQueryVariables>(ProductQuestionsDocument, variables, options);

export const ReviewerProductsDocument = `
    query ReviewerProducts($brandCode: String!) {
  ecommProducts(
    take: 20
    skip: 0
    brandCode: $brandCode
    maxBlurbLength: 160
    where: {vanishingIncExclusive: {eq: true}}
    order: {dateAdded: DESC}
  ) {
    items {
      id
      name
      url
      blurb
      meta {
        key
      }
      thumbnails {
        default
      }
      productType {
        name
      }
      creators {
        name
      }
    }
  }
}
    `;

export const useReviewerProductsQuery = <
      TData = ReviewerProductsQuery,
      TError = unknown
    >(
      variables: ReviewerProductsQueryVariables,
      options?: Omit<UseQueryOptions<ReviewerProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ReviewerProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ReviewerProductsQuery, TError, TData>(
      {
    queryKey: ['ReviewerProducts', variables],
    queryFn: fetchData<ReviewerProductsQuery, ReviewerProductsQueryVariables>(ReviewerProductsDocument, variables),
    ...options
  }
    )};

useReviewerProductsQuery.getKey = (variables: ReviewerProductsQueryVariables) => ['ReviewerProducts', variables];

export const useSuspenseReviewerProductsQuery = <
      TData = ReviewerProductsQuery,
      TError = unknown
    >(
      variables: ReviewerProductsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ReviewerProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ReviewerProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ReviewerProductsQuery, TError, TData>(
      {
    queryKey: ['ReviewerProducts', variables],
    queryFn: fetchData<ReviewerProductsQuery, ReviewerProductsQueryVariables>(ReviewerProductsDocument, variables),
    ...options
  }
    )};

useSuspenseReviewerProductsQuery.getKey = (variables: ReviewerProductsQueryVariables) => ['ReviewerProducts', variables];

export const useInfiniteReviewerProductsQuery = <
      TData = InfiniteData<ReviewerProductsQuery>,
      TError = unknown
    >(
      variables: ReviewerProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ReviewerProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ReviewerProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ReviewerProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ReviewerProducts.infinite', variables],
      queryFn: (metaData) => fetchData<ReviewerProductsQuery, ReviewerProductsQueryVariables>(ReviewerProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteReviewerProductsQuery.getKey = (variables: ReviewerProductsQueryVariables) => ['ReviewerProducts.infinite', variables];

export const useSuspenseInfiniteReviewerProductsQuery = <
      TData = InfiniteData<ReviewerProductsQuery>,
      TError = unknown
    >(
      variables: ReviewerProductsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ReviewerProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ReviewerProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ReviewerProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ReviewerProducts.infinite', variables],
      queryFn: (metaData) => fetchData<ReviewerProductsQuery, ReviewerProductsQueryVariables>(ReviewerProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteReviewerProductsQuery.getKey = (variables: ReviewerProductsQueryVariables) => ['ReviewerProducts.infinite', variables];


useReviewerProductsQuery.fetcher = (variables: ReviewerProductsQueryVariables, options?: RequestInit['headers']) => fetchData<ReviewerProductsQuery, ReviewerProductsQueryVariables>(ReviewerProductsDocument, variables, options);

export const TopSellersDocument = `
    query TopSellers($brandCode: String!) {
  topSellers(brandCode: $brandCode) {
    id
    url
    imageUrl
    name
    onSale
  }
}
    `;

export const useTopSellersQuery = <
      TData = TopSellersQuery,
      TError = unknown
    >(
      variables: TopSellersQueryVariables,
      options?: Omit<UseQueryOptions<TopSellersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<TopSellersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<TopSellersQuery, TError, TData>(
      {
    queryKey: ['TopSellers', variables],
    queryFn: fetchData<TopSellersQuery, TopSellersQueryVariables>(TopSellersDocument, variables),
    ...options
  }
    )};

useTopSellersQuery.getKey = (variables: TopSellersQueryVariables) => ['TopSellers', variables];

export const useSuspenseTopSellersQuery = <
      TData = TopSellersQuery,
      TError = unknown
    >(
      variables: TopSellersQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<TopSellersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<TopSellersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<TopSellersQuery, TError, TData>(
      {
    queryKey: ['TopSellers', variables],
    queryFn: fetchData<TopSellersQuery, TopSellersQueryVariables>(TopSellersDocument, variables),
    ...options
  }
    )};

useSuspenseTopSellersQuery.getKey = (variables: TopSellersQueryVariables) => ['TopSellers', variables];

export const useInfiniteTopSellersQuery = <
      TData = InfiniteData<TopSellersQuery>,
      TError = unknown
    >(
      variables: TopSellersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<TopSellersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<TopSellersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<TopSellersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['TopSellers.infinite', variables],
      queryFn: (metaData) => fetchData<TopSellersQuery, TopSellersQueryVariables>(TopSellersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteTopSellersQuery.getKey = (variables: TopSellersQueryVariables) => ['TopSellers.infinite', variables];

export const useSuspenseInfiniteTopSellersQuery = <
      TData = InfiniteData<TopSellersQuery>,
      TError = unknown
    >(
      variables: TopSellersQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<TopSellersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<TopSellersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<TopSellersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['TopSellers.infinite', variables],
      queryFn: (metaData) => fetchData<TopSellersQuery, TopSellersQueryVariables>(TopSellersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteTopSellersQuery.getKey = (variables: TopSellersQueryVariables) => ['TopSellers.infinite', variables];


useTopSellersQuery.fetcher = (variables: TopSellersQueryVariables, options?: RequestInit['headers']) => fetchData<TopSellersQuery, TopSellersQueryVariables>(TopSellersDocument, variables, options);

export const ActiveShoppingCartDocument = `
    query ActiveShoppingCart($customerId: Int, $anonymousCartToken: String, $includeConventionCart: Boolean) {
  activeShoppingCart(
    customerId: $customerId
    anonymousCartToken: $anonymousCartToken
    includeConventionCart: $includeConventionCart
  ) {
    token
    voucherCode
    giftVoucherCode
    giftVoucherDownloadsOnly
    giftVoucherDeduction
    promoCodeMessage
    subTotal
    subTotalIncVat
    viPoints
    items {
      id
      price
      priceIncVat
      listPrice
      listPriceIncVat
      isDiscounted
      discountTag
      taxType
      description
      discountDescription
      metadata
      productId
      quantity
      productName
      masterclassAirsInNote
      thumbnailSrc
      url
      optionDescription
      isPreorder
      needsShipping
      isDownload
      lowStock
      hazardous
      associatedOrderItemId
    }
    brand {
      name
      id
      code
    }
    currency {
      id
      symbol
      code
    }
    country {
      name
      isoCode
      id
      freeShipping
    }
    shippingAddress {
      id
      firstName
      lastName
      city
      addressLine1
      addressLine2
      phoneNumber
      state {
        name
        abbreviation
        id
      }
      country {
        name
        id
        isoCode
      }
      zip
    }
    shippingMethod
    shippingCost
    taxCharged
    taxIncluded
    taxDescription
    useStoreCredit
    storeCreditAvailable
    storeCreditToApply
  }
}
    `;

export const useActiveShoppingCartQuery = <
      TData = ActiveShoppingCartQuery,
      TError = unknown
    >(
      variables?: ActiveShoppingCartQueryVariables,
      options?: Omit<UseQueryOptions<ActiveShoppingCartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ActiveShoppingCartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ActiveShoppingCartQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ActiveShoppingCart'] : ['ActiveShoppingCart', variables],
    queryFn: fetchData<ActiveShoppingCartQuery, ActiveShoppingCartQueryVariables>(ActiveShoppingCartDocument, variables),
    ...options
  }
    )};

useActiveShoppingCartQuery.getKey = (variables?: ActiveShoppingCartQueryVariables) => variables === undefined ? ['ActiveShoppingCart'] : ['ActiveShoppingCart', variables];

export const useSuspenseActiveShoppingCartQuery = <
      TData = ActiveShoppingCartQuery,
      TError = unknown
    >(
      variables?: ActiveShoppingCartQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ActiveShoppingCartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ActiveShoppingCartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ActiveShoppingCartQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ActiveShoppingCart'] : ['ActiveShoppingCart', variables],
    queryFn: fetchData<ActiveShoppingCartQuery, ActiveShoppingCartQueryVariables>(ActiveShoppingCartDocument, variables),
    ...options
  }
    )};

useSuspenseActiveShoppingCartQuery.getKey = (variables?: ActiveShoppingCartQueryVariables) => variables === undefined ? ['ActiveShoppingCart'] : ['ActiveShoppingCart', variables];

export const useInfiniteActiveShoppingCartQuery = <
      TData = InfiniteData<ActiveShoppingCartQuery>,
      TError = unknown
    >(
      variables: ActiveShoppingCartQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ActiveShoppingCartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ActiveShoppingCartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ActiveShoppingCartQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ActiveShoppingCart.infinite'] : ['ActiveShoppingCart.infinite', variables],
      queryFn: (metaData) => fetchData<ActiveShoppingCartQuery, ActiveShoppingCartQueryVariables>(ActiveShoppingCartDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteActiveShoppingCartQuery.getKey = (variables?: ActiveShoppingCartQueryVariables) => variables === undefined ? ['ActiveShoppingCart.infinite'] : ['ActiveShoppingCart.infinite', variables];

export const useSuspenseInfiniteActiveShoppingCartQuery = <
      TData = InfiniteData<ActiveShoppingCartQuery>,
      TError = unknown
    >(
      variables: ActiveShoppingCartQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ActiveShoppingCartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ActiveShoppingCartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ActiveShoppingCartQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ActiveShoppingCart.infinite'] : ['ActiveShoppingCart.infinite', variables],
      queryFn: (metaData) => fetchData<ActiveShoppingCartQuery, ActiveShoppingCartQueryVariables>(ActiveShoppingCartDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteActiveShoppingCartQuery.getKey = (variables?: ActiveShoppingCartQueryVariables) => variables === undefined ? ['ActiveShoppingCart.infinite'] : ['ActiveShoppingCart.infinite', variables];


useActiveShoppingCartQuery.fetcher = (variables?: ActiveShoppingCartQueryVariables, options?: RequestInit['headers']) => fetchData<ActiveShoppingCartQuery, ActiveShoppingCartQueryVariables>(ActiveShoppingCartDocument, variables, options);

export const ActiveShoppingCartHeaderDocument = `
    query ActiveShoppingCartHeader($customerId: Int, $anonymousCartToken: String, $includeConventionCart: Boolean) {
  activeShoppingCartHeader(
    customerId: $customerId
    anonymousCartToken: $anonymousCartToken
    includeConventionCart: $includeConventionCart
  ) {
    totalQuantity
  }
}
    `;

export const useActiveShoppingCartHeaderQuery = <
      TData = ActiveShoppingCartHeaderQuery,
      TError = unknown
    >(
      variables?: ActiveShoppingCartHeaderQueryVariables,
      options?: Omit<UseQueryOptions<ActiveShoppingCartHeaderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ActiveShoppingCartHeaderQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ActiveShoppingCartHeaderQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ActiveShoppingCartHeader'] : ['ActiveShoppingCartHeader', variables],
    queryFn: fetchData<ActiveShoppingCartHeaderQuery, ActiveShoppingCartHeaderQueryVariables>(ActiveShoppingCartHeaderDocument, variables),
    ...options
  }
    )};

useActiveShoppingCartHeaderQuery.getKey = (variables?: ActiveShoppingCartHeaderQueryVariables) => variables === undefined ? ['ActiveShoppingCartHeader'] : ['ActiveShoppingCartHeader', variables];

export const useSuspenseActiveShoppingCartHeaderQuery = <
      TData = ActiveShoppingCartHeaderQuery,
      TError = unknown
    >(
      variables?: ActiveShoppingCartHeaderQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ActiveShoppingCartHeaderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ActiveShoppingCartHeaderQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ActiveShoppingCartHeaderQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ActiveShoppingCartHeader'] : ['ActiveShoppingCartHeader', variables],
    queryFn: fetchData<ActiveShoppingCartHeaderQuery, ActiveShoppingCartHeaderQueryVariables>(ActiveShoppingCartHeaderDocument, variables),
    ...options
  }
    )};

useSuspenseActiveShoppingCartHeaderQuery.getKey = (variables?: ActiveShoppingCartHeaderQueryVariables) => variables === undefined ? ['ActiveShoppingCartHeader'] : ['ActiveShoppingCartHeader', variables];

export const useInfiniteActiveShoppingCartHeaderQuery = <
      TData = InfiniteData<ActiveShoppingCartHeaderQuery>,
      TError = unknown
    >(
      variables: ActiveShoppingCartHeaderQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ActiveShoppingCartHeaderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ActiveShoppingCartHeaderQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ActiveShoppingCartHeaderQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ActiveShoppingCartHeader.infinite'] : ['ActiveShoppingCartHeader.infinite', variables],
      queryFn: (metaData) => fetchData<ActiveShoppingCartHeaderQuery, ActiveShoppingCartHeaderQueryVariables>(ActiveShoppingCartHeaderDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteActiveShoppingCartHeaderQuery.getKey = (variables?: ActiveShoppingCartHeaderQueryVariables) => variables === undefined ? ['ActiveShoppingCartHeader.infinite'] : ['ActiveShoppingCartHeader.infinite', variables];

export const useSuspenseInfiniteActiveShoppingCartHeaderQuery = <
      TData = InfiniteData<ActiveShoppingCartHeaderQuery>,
      TError = unknown
    >(
      variables: ActiveShoppingCartHeaderQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ActiveShoppingCartHeaderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ActiveShoppingCartHeaderQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ActiveShoppingCartHeaderQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ActiveShoppingCartHeader.infinite'] : ['ActiveShoppingCartHeader.infinite', variables],
      queryFn: (metaData) => fetchData<ActiveShoppingCartHeaderQuery, ActiveShoppingCartHeaderQueryVariables>(ActiveShoppingCartHeaderDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteActiveShoppingCartHeaderQuery.getKey = (variables?: ActiveShoppingCartHeaderQueryVariables) => variables === undefined ? ['ActiveShoppingCartHeader.infinite'] : ['ActiveShoppingCartHeader.infinite', variables];


useActiveShoppingCartHeaderQuery.fetcher = (variables?: ActiveShoppingCartHeaderQueryVariables, options?: RequestInit['headers']) => fetchData<ActiveShoppingCartHeaderQuery, ActiveShoppingCartHeaderQueryVariables>(ActiveShoppingCartHeaderDocument, variables, options);

export const AvailablePaymentMethodsForShoppingCartDocument = `
    query AvailablePaymentMethodsForShoppingCart($shoppingCartToken: String!) {
  availablePaymentMethodsForShoppingCart(shoppingCartToken: $shoppingCartToken) {
    showPayPal
    showKlarna
    showCreditCard
    showApplePay
    showAdminFreeOrder
    showAdminManualPayment
    payPalAccount
    paymentPlan {
      dueDates
      totalAmount
      installmentAmount
      numberOfInstallments
      enabled
      conventionProductId
    }
  }
}
    `;

export const useAvailablePaymentMethodsForShoppingCartQuery = <
      TData = AvailablePaymentMethodsForShoppingCartQuery,
      TError = unknown
    >(
      variables: AvailablePaymentMethodsForShoppingCartQueryVariables,
      options?: Omit<UseQueryOptions<AvailablePaymentMethodsForShoppingCartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AvailablePaymentMethodsForShoppingCartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AvailablePaymentMethodsForShoppingCartQuery, TError, TData>(
      {
    queryKey: ['AvailablePaymentMethodsForShoppingCart', variables],
    queryFn: fetchData<AvailablePaymentMethodsForShoppingCartQuery, AvailablePaymentMethodsForShoppingCartQueryVariables>(AvailablePaymentMethodsForShoppingCartDocument, variables),
    ...options
  }
    )};

useAvailablePaymentMethodsForShoppingCartQuery.getKey = (variables: AvailablePaymentMethodsForShoppingCartQueryVariables) => ['AvailablePaymentMethodsForShoppingCart', variables];

export const useSuspenseAvailablePaymentMethodsForShoppingCartQuery = <
      TData = AvailablePaymentMethodsForShoppingCartQuery,
      TError = unknown
    >(
      variables: AvailablePaymentMethodsForShoppingCartQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<AvailablePaymentMethodsForShoppingCartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<AvailablePaymentMethodsForShoppingCartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<AvailablePaymentMethodsForShoppingCartQuery, TError, TData>(
      {
    queryKey: ['AvailablePaymentMethodsForShoppingCart', variables],
    queryFn: fetchData<AvailablePaymentMethodsForShoppingCartQuery, AvailablePaymentMethodsForShoppingCartQueryVariables>(AvailablePaymentMethodsForShoppingCartDocument, variables),
    ...options
  }
    )};

useSuspenseAvailablePaymentMethodsForShoppingCartQuery.getKey = (variables: AvailablePaymentMethodsForShoppingCartQueryVariables) => ['AvailablePaymentMethodsForShoppingCart', variables];

export const useInfiniteAvailablePaymentMethodsForShoppingCartQuery = <
      TData = InfiniteData<AvailablePaymentMethodsForShoppingCartQuery>,
      TError = unknown
    >(
      variables: AvailablePaymentMethodsForShoppingCartQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AvailablePaymentMethodsForShoppingCartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AvailablePaymentMethodsForShoppingCartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<AvailablePaymentMethodsForShoppingCartQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AvailablePaymentMethodsForShoppingCart.infinite', variables],
      queryFn: (metaData) => fetchData<AvailablePaymentMethodsForShoppingCartQuery, AvailablePaymentMethodsForShoppingCartQueryVariables>(AvailablePaymentMethodsForShoppingCartDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteAvailablePaymentMethodsForShoppingCartQuery.getKey = (variables: AvailablePaymentMethodsForShoppingCartQueryVariables) => ['AvailablePaymentMethodsForShoppingCart.infinite', variables];

export const useSuspenseInfiniteAvailablePaymentMethodsForShoppingCartQuery = <
      TData = InfiniteData<AvailablePaymentMethodsForShoppingCartQuery>,
      TError = unknown
    >(
      variables: AvailablePaymentMethodsForShoppingCartQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<AvailablePaymentMethodsForShoppingCartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<AvailablePaymentMethodsForShoppingCartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<AvailablePaymentMethodsForShoppingCartQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AvailablePaymentMethodsForShoppingCart.infinite', variables],
      queryFn: (metaData) => fetchData<AvailablePaymentMethodsForShoppingCartQuery, AvailablePaymentMethodsForShoppingCartQueryVariables>(AvailablePaymentMethodsForShoppingCartDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteAvailablePaymentMethodsForShoppingCartQuery.getKey = (variables: AvailablePaymentMethodsForShoppingCartQueryVariables) => ['AvailablePaymentMethodsForShoppingCart.infinite', variables];


useAvailablePaymentMethodsForShoppingCartQuery.fetcher = (variables: AvailablePaymentMethodsForShoppingCartQueryVariables, options?: RequestInit['headers']) => fetchData<AvailablePaymentMethodsForShoppingCartQuery, AvailablePaymentMethodsForShoppingCartQueryVariables>(AvailablePaymentMethodsForShoppingCartDocument, variables, options);

export const CustomerPaymentMethodsDocument = `
    query CustomerPaymentMethods($brandCode: String!) {
  paymentMethodsForCustomer(brandCode: $brandCode) {
    paymentCompany
    expiryMonth
    expiryYear
    id
    isDefault
    last4
  }
}
    `;

export const useCustomerPaymentMethodsQuery = <
      TData = CustomerPaymentMethodsQuery,
      TError = unknown
    >(
      variables: CustomerPaymentMethodsQueryVariables,
      options?: Omit<UseQueryOptions<CustomerPaymentMethodsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerPaymentMethodsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerPaymentMethodsQuery, TError, TData>(
      {
    queryKey: ['CustomerPaymentMethods', variables],
    queryFn: fetchData<CustomerPaymentMethodsQuery, CustomerPaymentMethodsQueryVariables>(CustomerPaymentMethodsDocument, variables),
    ...options
  }
    )};

useCustomerPaymentMethodsQuery.getKey = (variables: CustomerPaymentMethodsQueryVariables) => ['CustomerPaymentMethods', variables];

export const useSuspenseCustomerPaymentMethodsQuery = <
      TData = CustomerPaymentMethodsQuery,
      TError = unknown
    >(
      variables: CustomerPaymentMethodsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerPaymentMethodsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerPaymentMethodsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerPaymentMethodsQuery, TError, TData>(
      {
    queryKey: ['CustomerPaymentMethods', variables],
    queryFn: fetchData<CustomerPaymentMethodsQuery, CustomerPaymentMethodsQueryVariables>(CustomerPaymentMethodsDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerPaymentMethodsQuery.getKey = (variables: CustomerPaymentMethodsQueryVariables) => ['CustomerPaymentMethods', variables];

export const useInfiniteCustomerPaymentMethodsQuery = <
      TData = InfiniteData<CustomerPaymentMethodsQuery>,
      TError = unknown
    >(
      variables: CustomerPaymentMethodsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerPaymentMethodsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerPaymentMethodsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerPaymentMethodsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomerPaymentMethods.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerPaymentMethodsQuery, CustomerPaymentMethodsQueryVariables>(CustomerPaymentMethodsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerPaymentMethodsQuery.getKey = (variables: CustomerPaymentMethodsQueryVariables) => ['CustomerPaymentMethods.infinite', variables];

export const useSuspenseInfiniteCustomerPaymentMethodsQuery = <
      TData = InfiniteData<CustomerPaymentMethodsQuery>,
      TError = unknown
    >(
      variables: CustomerPaymentMethodsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerPaymentMethodsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerPaymentMethodsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerPaymentMethodsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomerPaymentMethods.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerPaymentMethodsQuery, CustomerPaymentMethodsQueryVariables>(CustomerPaymentMethodsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerPaymentMethodsQuery.getKey = (variables: CustomerPaymentMethodsQueryVariables) => ['CustomerPaymentMethods.infinite', variables];


useCustomerPaymentMethodsQuery.fetcher = (variables: CustomerPaymentMethodsQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerPaymentMethodsQuery, CustomerPaymentMethodsQueryVariables>(CustomerPaymentMethodsDocument, variables, options);

export const ImportDutiesQuoteForShoppingCartDocument = `
    query ImportDutiesQuoteForShoppingCart($shoppingCartToken: String!) {
  importDutiesQuoteForShoppingCart(shoppingCartToken: $shoppingCartToken) {
    type
    isPrepayAvailable
    isRequired
    duties
    taxes
    fees
    total
    requiredDuties
    requiredTaxes
    requiredFees
    requiredTotal
    optionalPrepayTotal
    description
    formula
    shipToCountryName
    shipFromCountryIsoCode
  }
}
    `;

export const useImportDutiesQuoteForShoppingCartQuery = <
      TData = ImportDutiesQuoteForShoppingCartQuery,
      TError = unknown
    >(
      variables: ImportDutiesQuoteForShoppingCartQueryVariables,
      options?: Omit<UseQueryOptions<ImportDutiesQuoteForShoppingCartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ImportDutiesQuoteForShoppingCartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ImportDutiesQuoteForShoppingCartQuery, TError, TData>(
      {
    queryKey: ['ImportDutiesQuoteForShoppingCart', variables],
    queryFn: fetchData<ImportDutiesQuoteForShoppingCartQuery, ImportDutiesQuoteForShoppingCartQueryVariables>(ImportDutiesQuoteForShoppingCartDocument, variables),
    ...options
  }
    )};

useImportDutiesQuoteForShoppingCartQuery.getKey = (variables: ImportDutiesQuoteForShoppingCartQueryVariables) => ['ImportDutiesQuoteForShoppingCart', variables];

export const useSuspenseImportDutiesQuoteForShoppingCartQuery = <
      TData = ImportDutiesQuoteForShoppingCartQuery,
      TError = unknown
    >(
      variables: ImportDutiesQuoteForShoppingCartQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ImportDutiesQuoteForShoppingCartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ImportDutiesQuoteForShoppingCartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ImportDutiesQuoteForShoppingCartQuery, TError, TData>(
      {
    queryKey: ['ImportDutiesQuoteForShoppingCart', variables],
    queryFn: fetchData<ImportDutiesQuoteForShoppingCartQuery, ImportDutiesQuoteForShoppingCartQueryVariables>(ImportDutiesQuoteForShoppingCartDocument, variables),
    ...options
  }
    )};

useSuspenseImportDutiesQuoteForShoppingCartQuery.getKey = (variables: ImportDutiesQuoteForShoppingCartQueryVariables) => ['ImportDutiesQuoteForShoppingCart', variables];

export const useInfiniteImportDutiesQuoteForShoppingCartQuery = <
      TData = InfiniteData<ImportDutiesQuoteForShoppingCartQuery>,
      TError = unknown
    >(
      variables: ImportDutiesQuoteForShoppingCartQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ImportDutiesQuoteForShoppingCartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ImportDutiesQuoteForShoppingCartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ImportDutiesQuoteForShoppingCartQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ImportDutiesQuoteForShoppingCart.infinite', variables],
      queryFn: (metaData) => fetchData<ImportDutiesQuoteForShoppingCartQuery, ImportDutiesQuoteForShoppingCartQueryVariables>(ImportDutiesQuoteForShoppingCartDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteImportDutiesQuoteForShoppingCartQuery.getKey = (variables: ImportDutiesQuoteForShoppingCartQueryVariables) => ['ImportDutiesQuoteForShoppingCart.infinite', variables];

export const useSuspenseInfiniteImportDutiesQuoteForShoppingCartQuery = <
      TData = InfiniteData<ImportDutiesQuoteForShoppingCartQuery>,
      TError = unknown
    >(
      variables: ImportDutiesQuoteForShoppingCartQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ImportDutiesQuoteForShoppingCartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ImportDutiesQuoteForShoppingCartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ImportDutiesQuoteForShoppingCartQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ImportDutiesQuoteForShoppingCart.infinite', variables],
      queryFn: (metaData) => fetchData<ImportDutiesQuoteForShoppingCartQuery, ImportDutiesQuoteForShoppingCartQueryVariables>(ImportDutiesQuoteForShoppingCartDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteImportDutiesQuoteForShoppingCartQuery.getKey = (variables: ImportDutiesQuoteForShoppingCartQueryVariables) => ['ImportDutiesQuoteForShoppingCart.infinite', variables];


useImportDutiesQuoteForShoppingCartQuery.fetcher = (variables: ImportDutiesQuoteForShoppingCartQueryVariables, options?: RequestInit['headers']) => fetchData<ImportDutiesQuoteForShoppingCartQuery, ImportDutiesQuoteForShoppingCartQueryVariables>(ImportDutiesQuoteForShoppingCartDocument, variables, options);

export const PurchasedProductIdsDocument = `
    query PurchasedProductIds {
  purchasedProductIds
}
    `;

export const usePurchasedProductIdsQuery = <
      TData = PurchasedProductIdsQuery,
      TError = unknown
    >(
      variables?: PurchasedProductIdsQueryVariables,
      options?: Omit<UseQueryOptions<PurchasedProductIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PurchasedProductIdsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PurchasedProductIdsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['PurchasedProductIds'] : ['PurchasedProductIds', variables],
    queryFn: fetchData<PurchasedProductIdsQuery, PurchasedProductIdsQueryVariables>(PurchasedProductIdsDocument, variables),
    ...options
  }
    )};

usePurchasedProductIdsQuery.getKey = (variables?: PurchasedProductIdsQueryVariables) => variables === undefined ? ['PurchasedProductIds'] : ['PurchasedProductIds', variables];

export const useSuspensePurchasedProductIdsQuery = <
      TData = PurchasedProductIdsQuery,
      TError = unknown
    >(
      variables?: PurchasedProductIdsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<PurchasedProductIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<PurchasedProductIdsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<PurchasedProductIdsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['PurchasedProductIds'] : ['PurchasedProductIds', variables],
    queryFn: fetchData<PurchasedProductIdsQuery, PurchasedProductIdsQueryVariables>(PurchasedProductIdsDocument, variables),
    ...options
  }
    )};

useSuspensePurchasedProductIdsQuery.getKey = (variables?: PurchasedProductIdsQueryVariables) => variables === undefined ? ['PurchasedProductIds'] : ['PurchasedProductIds', variables];

export const useInfinitePurchasedProductIdsQuery = <
      TData = InfiniteData<PurchasedProductIdsQuery>,
      TError = unknown
    >(
      variables: PurchasedProductIdsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<PurchasedProductIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<PurchasedProductIdsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<PurchasedProductIdsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['PurchasedProductIds.infinite'] : ['PurchasedProductIds.infinite', variables],
      queryFn: (metaData) => fetchData<PurchasedProductIdsQuery, PurchasedProductIdsQueryVariables>(PurchasedProductIdsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfinitePurchasedProductIdsQuery.getKey = (variables?: PurchasedProductIdsQueryVariables) => variables === undefined ? ['PurchasedProductIds.infinite'] : ['PurchasedProductIds.infinite', variables];

export const useSuspenseInfinitePurchasedProductIdsQuery = <
      TData = InfiniteData<PurchasedProductIdsQuery>,
      TError = unknown
    >(
      variables: PurchasedProductIdsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<PurchasedProductIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<PurchasedProductIdsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<PurchasedProductIdsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['PurchasedProductIds.infinite'] : ['PurchasedProductIds.infinite', variables],
      queryFn: (metaData) => fetchData<PurchasedProductIdsQuery, PurchasedProductIdsQueryVariables>(PurchasedProductIdsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfinitePurchasedProductIdsQuery.getKey = (variables?: PurchasedProductIdsQueryVariables) => variables === undefined ? ['PurchasedProductIds.infinite'] : ['PurchasedProductIds.infinite', variables];


usePurchasedProductIdsQuery.fetcher = (variables?: PurchasedProductIdsQueryVariables, options?: RequestInit['headers']) => fetchData<PurchasedProductIdsQuery, PurchasedProductIdsQueryVariables>(PurchasedProductIdsDocument, variables, options);

export const ShoppingCartPaymentMethodsDocument = `
    query ShoppingCartPaymentMethods($shoppingCartToken: String!) {
  paymentMethodsForShoppingCart(shoppingCartToken: $shoppingCartToken) {
    paymentCompany
    expiryMonth
    expiryYear
    id
    isDefault
    last4
  }
}
    `;

export const useShoppingCartPaymentMethodsQuery = <
      TData = ShoppingCartPaymentMethodsQuery,
      TError = unknown
    >(
      variables: ShoppingCartPaymentMethodsQueryVariables,
      options?: Omit<UseQueryOptions<ShoppingCartPaymentMethodsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ShoppingCartPaymentMethodsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ShoppingCartPaymentMethodsQuery, TError, TData>(
      {
    queryKey: ['ShoppingCartPaymentMethods', variables],
    queryFn: fetchData<ShoppingCartPaymentMethodsQuery, ShoppingCartPaymentMethodsQueryVariables>(ShoppingCartPaymentMethodsDocument, variables),
    ...options
  }
    )};

useShoppingCartPaymentMethodsQuery.getKey = (variables: ShoppingCartPaymentMethodsQueryVariables) => ['ShoppingCartPaymentMethods', variables];

export const useSuspenseShoppingCartPaymentMethodsQuery = <
      TData = ShoppingCartPaymentMethodsQuery,
      TError = unknown
    >(
      variables: ShoppingCartPaymentMethodsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ShoppingCartPaymentMethodsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ShoppingCartPaymentMethodsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ShoppingCartPaymentMethodsQuery, TError, TData>(
      {
    queryKey: ['ShoppingCartPaymentMethods', variables],
    queryFn: fetchData<ShoppingCartPaymentMethodsQuery, ShoppingCartPaymentMethodsQueryVariables>(ShoppingCartPaymentMethodsDocument, variables),
    ...options
  }
    )};

useSuspenseShoppingCartPaymentMethodsQuery.getKey = (variables: ShoppingCartPaymentMethodsQueryVariables) => ['ShoppingCartPaymentMethods', variables];

export const useInfiniteShoppingCartPaymentMethodsQuery = <
      TData = InfiniteData<ShoppingCartPaymentMethodsQuery>,
      TError = unknown
    >(
      variables: ShoppingCartPaymentMethodsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ShoppingCartPaymentMethodsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ShoppingCartPaymentMethodsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ShoppingCartPaymentMethodsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ShoppingCartPaymentMethods.infinite', variables],
      queryFn: (metaData) => fetchData<ShoppingCartPaymentMethodsQuery, ShoppingCartPaymentMethodsQueryVariables>(ShoppingCartPaymentMethodsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteShoppingCartPaymentMethodsQuery.getKey = (variables: ShoppingCartPaymentMethodsQueryVariables) => ['ShoppingCartPaymentMethods.infinite', variables];

export const useSuspenseInfiniteShoppingCartPaymentMethodsQuery = <
      TData = InfiniteData<ShoppingCartPaymentMethodsQuery>,
      TError = unknown
    >(
      variables: ShoppingCartPaymentMethodsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ShoppingCartPaymentMethodsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ShoppingCartPaymentMethodsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ShoppingCartPaymentMethodsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ShoppingCartPaymentMethods.infinite', variables],
      queryFn: (metaData) => fetchData<ShoppingCartPaymentMethodsQuery, ShoppingCartPaymentMethodsQueryVariables>(ShoppingCartPaymentMethodsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteShoppingCartPaymentMethodsQuery.getKey = (variables: ShoppingCartPaymentMethodsQueryVariables) => ['ShoppingCartPaymentMethods.infinite', variables];


useShoppingCartPaymentMethodsQuery.fetcher = (variables: ShoppingCartPaymentMethodsQueryVariables, options?: RequestInit['headers']) => fetchData<ShoppingCartPaymentMethodsQuery, ShoppingCartPaymentMethodsQueryVariables>(ShoppingCartPaymentMethodsDocument, variables, options);

export const ShoppingCartShippingOptionsDocument = `
    query ShoppingCartShippingOptions($shoppingCartToken: String!) {
  shippingOptionsForShoppingCart(shoppingCartToken: $shoppingCartToken) {
    id
    estDelivery
    description
    price
    currencySymbol
    shippingMethodId
    hash
    isFallback
    notice
  }
}
    `;

export const useShoppingCartShippingOptionsQuery = <
      TData = ShoppingCartShippingOptionsQuery,
      TError = unknown
    >(
      variables: ShoppingCartShippingOptionsQueryVariables,
      options?: Omit<UseQueryOptions<ShoppingCartShippingOptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ShoppingCartShippingOptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ShoppingCartShippingOptionsQuery, TError, TData>(
      {
    queryKey: ['ShoppingCartShippingOptions', variables],
    queryFn: fetchData<ShoppingCartShippingOptionsQuery, ShoppingCartShippingOptionsQueryVariables>(ShoppingCartShippingOptionsDocument, variables),
    ...options
  }
    )};

useShoppingCartShippingOptionsQuery.getKey = (variables: ShoppingCartShippingOptionsQueryVariables) => ['ShoppingCartShippingOptions', variables];

export const useSuspenseShoppingCartShippingOptionsQuery = <
      TData = ShoppingCartShippingOptionsQuery,
      TError = unknown
    >(
      variables: ShoppingCartShippingOptionsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ShoppingCartShippingOptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ShoppingCartShippingOptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ShoppingCartShippingOptionsQuery, TError, TData>(
      {
    queryKey: ['ShoppingCartShippingOptions', variables],
    queryFn: fetchData<ShoppingCartShippingOptionsQuery, ShoppingCartShippingOptionsQueryVariables>(ShoppingCartShippingOptionsDocument, variables),
    ...options
  }
    )};

useSuspenseShoppingCartShippingOptionsQuery.getKey = (variables: ShoppingCartShippingOptionsQueryVariables) => ['ShoppingCartShippingOptions', variables];

export const useInfiniteShoppingCartShippingOptionsQuery = <
      TData = InfiniteData<ShoppingCartShippingOptionsQuery>,
      TError = unknown
    >(
      variables: ShoppingCartShippingOptionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ShoppingCartShippingOptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ShoppingCartShippingOptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ShoppingCartShippingOptionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ShoppingCartShippingOptions.infinite', variables],
      queryFn: (metaData) => fetchData<ShoppingCartShippingOptionsQuery, ShoppingCartShippingOptionsQueryVariables>(ShoppingCartShippingOptionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteShoppingCartShippingOptionsQuery.getKey = (variables: ShoppingCartShippingOptionsQueryVariables) => ['ShoppingCartShippingOptions.infinite', variables];

export const useSuspenseInfiniteShoppingCartShippingOptionsQuery = <
      TData = InfiniteData<ShoppingCartShippingOptionsQuery>,
      TError = unknown
    >(
      variables: ShoppingCartShippingOptionsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ShoppingCartShippingOptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ShoppingCartShippingOptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ShoppingCartShippingOptionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ShoppingCartShippingOptions.infinite', variables],
      queryFn: (metaData) => fetchData<ShoppingCartShippingOptionsQuery, ShoppingCartShippingOptionsQueryVariables>(ShoppingCartShippingOptionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteShoppingCartShippingOptionsQuery.getKey = (variables: ShoppingCartShippingOptionsQueryVariables) => ['ShoppingCartShippingOptions.infinite', variables];


useShoppingCartShippingOptionsQuery.fetcher = (variables: ShoppingCartShippingOptionsQueryVariables, options?: RequestInit['headers']) => fetchData<ShoppingCartShippingOptionsQuery, ShoppingCartShippingOptionsQueryVariables>(ShoppingCartShippingOptionsDocument, variables, options);

export const ShoppingCartShippingOptionsForAddressDocument = `
    query ShoppingCartShippingOptionsForAddress($shoppingCartToken: String!, $address: ShippingAddressInput!) {
  shippingOptionsForShoppingCartAddress(
    shoppingCartToken: $shoppingCartToken
    address: $address
  ) {
    id
    estDelivery
    description
    price
    currencySymbol
    shippingMethodId
    hash
    isFallback
    notice
  }
}
    `;

export const useShoppingCartShippingOptionsForAddressQuery = <
      TData = ShoppingCartShippingOptionsForAddressQuery,
      TError = unknown
    >(
      variables: ShoppingCartShippingOptionsForAddressQueryVariables,
      options?: Omit<UseQueryOptions<ShoppingCartShippingOptionsForAddressQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ShoppingCartShippingOptionsForAddressQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ShoppingCartShippingOptionsForAddressQuery, TError, TData>(
      {
    queryKey: ['ShoppingCartShippingOptionsForAddress', variables],
    queryFn: fetchData<ShoppingCartShippingOptionsForAddressQuery, ShoppingCartShippingOptionsForAddressQueryVariables>(ShoppingCartShippingOptionsForAddressDocument, variables),
    ...options
  }
    )};

useShoppingCartShippingOptionsForAddressQuery.getKey = (variables: ShoppingCartShippingOptionsForAddressQueryVariables) => ['ShoppingCartShippingOptionsForAddress', variables];

export const useSuspenseShoppingCartShippingOptionsForAddressQuery = <
      TData = ShoppingCartShippingOptionsForAddressQuery,
      TError = unknown
    >(
      variables: ShoppingCartShippingOptionsForAddressQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ShoppingCartShippingOptionsForAddressQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ShoppingCartShippingOptionsForAddressQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ShoppingCartShippingOptionsForAddressQuery, TError, TData>(
      {
    queryKey: ['ShoppingCartShippingOptionsForAddress', variables],
    queryFn: fetchData<ShoppingCartShippingOptionsForAddressQuery, ShoppingCartShippingOptionsForAddressQueryVariables>(ShoppingCartShippingOptionsForAddressDocument, variables),
    ...options
  }
    )};

useSuspenseShoppingCartShippingOptionsForAddressQuery.getKey = (variables: ShoppingCartShippingOptionsForAddressQueryVariables) => ['ShoppingCartShippingOptionsForAddress', variables];

export const useInfiniteShoppingCartShippingOptionsForAddressQuery = <
      TData = InfiniteData<ShoppingCartShippingOptionsForAddressQuery>,
      TError = unknown
    >(
      variables: ShoppingCartShippingOptionsForAddressQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ShoppingCartShippingOptionsForAddressQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ShoppingCartShippingOptionsForAddressQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ShoppingCartShippingOptionsForAddressQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ShoppingCartShippingOptionsForAddress.infinite', variables],
      queryFn: (metaData) => fetchData<ShoppingCartShippingOptionsForAddressQuery, ShoppingCartShippingOptionsForAddressQueryVariables>(ShoppingCartShippingOptionsForAddressDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteShoppingCartShippingOptionsForAddressQuery.getKey = (variables: ShoppingCartShippingOptionsForAddressQueryVariables) => ['ShoppingCartShippingOptionsForAddress.infinite', variables];

export const useSuspenseInfiniteShoppingCartShippingOptionsForAddressQuery = <
      TData = InfiniteData<ShoppingCartShippingOptionsForAddressQuery>,
      TError = unknown
    >(
      variables: ShoppingCartShippingOptionsForAddressQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ShoppingCartShippingOptionsForAddressQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ShoppingCartShippingOptionsForAddressQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ShoppingCartShippingOptionsForAddressQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ShoppingCartShippingOptionsForAddress.infinite', variables],
      queryFn: (metaData) => fetchData<ShoppingCartShippingOptionsForAddressQuery, ShoppingCartShippingOptionsForAddressQueryVariables>(ShoppingCartShippingOptionsForAddressDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteShoppingCartShippingOptionsForAddressQuery.getKey = (variables: ShoppingCartShippingOptionsForAddressQueryVariables) => ['ShoppingCartShippingOptionsForAddress.infinite', variables];


useShoppingCartShippingOptionsForAddressQuery.fetcher = (variables: ShoppingCartShippingOptionsForAddressQueryVariables, options?: RequestInit['headers']) => fetchData<ShoppingCartShippingOptionsForAddressQuery, ShoppingCartShippingOptionsForAddressQueryVariables>(ShoppingCartShippingOptionsForAddressDocument, variables, options);

export const ValidateCartStockDocument = `
    query ValidateCartStock($shoppingCartToken: String!) {
  validateCartStock(shoppingCartToken: $shoppingCartToken) {
    isValid
    unavailableItems {
      productId
      productName
      optionId
      optionName
      requestedQuantity
      availableQuantity
      cartItemId
    }
    reducedQuantityItems {
      productId
      productName
      optionId
      optionName
      requestedQuantity
      availableQuantity
      cartItemId
    }
  }
}
    `;

export const useValidateCartStockQuery = <
      TData = ValidateCartStockQuery,
      TError = unknown
    >(
      variables: ValidateCartStockQueryVariables,
      options?: Omit<UseQueryOptions<ValidateCartStockQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ValidateCartStockQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ValidateCartStockQuery, TError, TData>(
      {
    queryKey: ['ValidateCartStock', variables],
    queryFn: fetchData<ValidateCartStockQuery, ValidateCartStockQueryVariables>(ValidateCartStockDocument, variables),
    ...options
  }
    )};

useValidateCartStockQuery.getKey = (variables: ValidateCartStockQueryVariables) => ['ValidateCartStock', variables];

export const useSuspenseValidateCartStockQuery = <
      TData = ValidateCartStockQuery,
      TError = unknown
    >(
      variables: ValidateCartStockQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ValidateCartStockQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ValidateCartStockQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ValidateCartStockQuery, TError, TData>(
      {
    queryKey: ['ValidateCartStock', variables],
    queryFn: fetchData<ValidateCartStockQuery, ValidateCartStockQueryVariables>(ValidateCartStockDocument, variables),
    ...options
  }
    )};

useSuspenseValidateCartStockQuery.getKey = (variables: ValidateCartStockQueryVariables) => ['ValidateCartStock', variables];

export const useInfiniteValidateCartStockQuery = <
      TData = InfiniteData<ValidateCartStockQuery>,
      TError = unknown
    >(
      variables: ValidateCartStockQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ValidateCartStockQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ValidateCartStockQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ValidateCartStockQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ValidateCartStock.infinite', variables],
      queryFn: (metaData) => fetchData<ValidateCartStockQuery, ValidateCartStockQueryVariables>(ValidateCartStockDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteValidateCartStockQuery.getKey = (variables: ValidateCartStockQueryVariables) => ['ValidateCartStock.infinite', variables];

export const useSuspenseInfiniteValidateCartStockQuery = <
      TData = InfiniteData<ValidateCartStockQuery>,
      TError = unknown
    >(
      variables: ValidateCartStockQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ValidateCartStockQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ValidateCartStockQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ValidateCartStockQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ValidateCartStock.infinite', variables],
      queryFn: (metaData) => fetchData<ValidateCartStockQuery, ValidateCartStockQueryVariables>(ValidateCartStockDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteValidateCartStockQuery.getKey = (variables: ValidateCartStockQueryVariables) => ['ValidateCartStock.infinite', variables];


useValidateCartStockQuery.fetcher = (variables: ValidateCartStockQueryVariables, options?: RequestInit['headers']) => fetchData<ValidateCartStockQuery, ValidateCartStockQueryVariables>(ValidateCartStockDocument, variables, options);

export const MasterClassStudioDocument = `
    query MasterClassStudio($take: Int!, $skip: Int!) {
  streams(activeOnly: true, take: $take, skip: $skip, order: {name: ASC}) {
    totalCount
    items {
      id
      name
      thumbnailSrc
      urlStub
      rating
      creators {
        name
        urlStub
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

export const useMasterClassStudioQuery = <
      TData = MasterClassStudioQuery,
      TError = unknown
    >(
      variables: MasterClassStudioQueryVariables,
      options?: Omit<UseQueryOptions<MasterClassStudioQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MasterClassStudioQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MasterClassStudioQuery, TError, TData>(
      {
    queryKey: ['MasterClassStudio', variables],
    queryFn: fetchData<MasterClassStudioQuery, MasterClassStudioQueryVariables>(MasterClassStudioDocument, variables),
    ...options
  }
    )};

useMasterClassStudioQuery.getKey = (variables: MasterClassStudioQueryVariables) => ['MasterClassStudio', variables];

export const useSuspenseMasterClassStudioQuery = <
      TData = MasterClassStudioQuery,
      TError = unknown
    >(
      variables: MasterClassStudioQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MasterClassStudioQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MasterClassStudioQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MasterClassStudioQuery, TError, TData>(
      {
    queryKey: ['MasterClassStudio', variables],
    queryFn: fetchData<MasterClassStudioQuery, MasterClassStudioQueryVariables>(MasterClassStudioDocument, variables),
    ...options
  }
    )};

useSuspenseMasterClassStudioQuery.getKey = (variables: MasterClassStudioQueryVariables) => ['MasterClassStudio', variables];

export const useInfiniteMasterClassStudioQuery = <
      TData = InfiniteData<MasterClassStudioQuery>,
      TError = unknown
    >(
      variables: MasterClassStudioQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MasterClassStudioQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MasterClassStudioQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<MasterClassStudioQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MasterClassStudio.infinite', variables],
      queryFn: (metaData) => fetchData<MasterClassStudioQuery, MasterClassStudioQueryVariables>(MasterClassStudioDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMasterClassStudioQuery.getKey = (variables: MasterClassStudioQueryVariables) => ['MasterClassStudio.infinite', variables];

export const useSuspenseInfiniteMasterClassStudioQuery = <
      TData = InfiniteData<MasterClassStudioQuery>,
      TError = unknown
    >(
      variables: MasterClassStudioQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<MasterClassStudioQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<MasterClassStudioQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<MasterClassStudioQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['MasterClassStudio.infinite', variables],
      queryFn: (metaData) => fetchData<MasterClassStudioQuery, MasterClassStudioQueryVariables>(MasterClassStudioDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteMasterClassStudioQuery.getKey = (variables: MasterClassStudioQueryVariables) => ['MasterClassStudio.infinite', variables];


useMasterClassStudioQuery.fetcher = (variables: MasterClassStudioQueryVariables, options?: RequestInit['headers']) => fetchData<MasterClassStudioQuery, MasterClassStudioQueryVariables>(MasterClassStudioDocument, variables, options);

export const CurrentMasterclassDocument = `
    query CurrentMasterclass {
  currentMasterclass {
    id
    name
    url
    monthName
    videoSrc
    lectureDates
    hasReleasedFiles
    thumbnails {
      default
      video
    }
  }
}
    `;

export const useCurrentMasterclassQuery = <
      TData = CurrentMasterclassQuery,
      TError = unknown
    >(
      variables?: CurrentMasterclassQueryVariables,
      options?: Omit<UseQueryOptions<CurrentMasterclassQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CurrentMasterclassQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CurrentMasterclassQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CurrentMasterclass'] : ['CurrentMasterclass', variables],
    queryFn: fetchData<CurrentMasterclassQuery, CurrentMasterclassQueryVariables>(CurrentMasterclassDocument, variables),
    ...options
  }
    )};

useCurrentMasterclassQuery.getKey = (variables?: CurrentMasterclassQueryVariables) => variables === undefined ? ['CurrentMasterclass'] : ['CurrentMasterclass', variables];

export const useSuspenseCurrentMasterclassQuery = <
      TData = CurrentMasterclassQuery,
      TError = unknown
    >(
      variables?: CurrentMasterclassQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CurrentMasterclassQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CurrentMasterclassQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CurrentMasterclassQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CurrentMasterclass'] : ['CurrentMasterclass', variables],
    queryFn: fetchData<CurrentMasterclassQuery, CurrentMasterclassQueryVariables>(CurrentMasterclassDocument, variables),
    ...options
  }
    )};

useSuspenseCurrentMasterclassQuery.getKey = (variables?: CurrentMasterclassQueryVariables) => variables === undefined ? ['CurrentMasterclass'] : ['CurrentMasterclass', variables];

export const useInfiniteCurrentMasterclassQuery = <
      TData = InfiniteData<CurrentMasterclassQuery>,
      TError = unknown
    >(
      variables: CurrentMasterclassQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CurrentMasterclassQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CurrentMasterclassQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CurrentMasterclassQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CurrentMasterclass.infinite'] : ['CurrentMasterclass.infinite', variables],
      queryFn: (metaData) => fetchData<CurrentMasterclassQuery, CurrentMasterclassQueryVariables>(CurrentMasterclassDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCurrentMasterclassQuery.getKey = (variables?: CurrentMasterclassQueryVariables) => variables === undefined ? ['CurrentMasterclass.infinite'] : ['CurrentMasterclass.infinite', variables];

export const useSuspenseInfiniteCurrentMasterclassQuery = <
      TData = InfiniteData<CurrentMasterclassQuery>,
      TError = unknown
    >(
      variables: CurrentMasterclassQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CurrentMasterclassQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CurrentMasterclassQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CurrentMasterclassQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CurrentMasterclass.infinite'] : ['CurrentMasterclass.infinite', variables],
      queryFn: (metaData) => fetchData<CurrentMasterclassQuery, CurrentMasterclassQueryVariables>(CurrentMasterclassDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCurrentMasterclassQuery.getKey = (variables?: CurrentMasterclassQueryVariables) => variables === undefined ? ['CurrentMasterclass.infinite'] : ['CurrentMasterclass.infinite', variables];


useCurrentMasterclassQuery.fetcher = (variables?: CurrentMasterclassQueryVariables, options?: RequestInit['headers']) => fetchData<CurrentMasterclassQuery, CurrentMasterclassQueryVariables>(CurrentMasterclassDocument, variables, options);

export const CustomerSubscriptionsDocument = `
    query CustomerSubscriptions($take: Int = 100, $skip: Int = 0) {
  allSubscriptionsForCustomer(take: $take, skip: $skip) {
    items {
      id
      subscriptionId
      subscriptionTier
      isActive
      isInGoodStanding
      isPaused
      nextBillingDate
      isTrial
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

export const useCustomerSubscriptionsQuery = <
      TData = CustomerSubscriptionsQuery,
      TError = unknown
    >(
      variables?: CustomerSubscriptionsQueryVariables,
      options?: Omit<UseQueryOptions<CustomerSubscriptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerSubscriptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerSubscriptionsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerSubscriptions'] : ['CustomerSubscriptions', variables],
    queryFn: fetchData<CustomerSubscriptionsQuery, CustomerSubscriptionsQueryVariables>(CustomerSubscriptionsDocument, variables),
    ...options
  }
    )};

useCustomerSubscriptionsQuery.getKey = (variables?: CustomerSubscriptionsQueryVariables) => variables === undefined ? ['CustomerSubscriptions'] : ['CustomerSubscriptions', variables];

export const useSuspenseCustomerSubscriptionsQuery = <
      TData = CustomerSubscriptionsQuery,
      TError = unknown
    >(
      variables?: CustomerSubscriptionsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerSubscriptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerSubscriptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerSubscriptionsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerSubscriptions'] : ['CustomerSubscriptions', variables],
    queryFn: fetchData<CustomerSubscriptionsQuery, CustomerSubscriptionsQueryVariables>(CustomerSubscriptionsDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerSubscriptionsQuery.getKey = (variables?: CustomerSubscriptionsQueryVariables) => variables === undefined ? ['CustomerSubscriptions'] : ['CustomerSubscriptions', variables];

export const useInfiniteCustomerSubscriptionsQuery = <
      TData = InfiniteData<CustomerSubscriptionsQuery>,
      TError = unknown
    >(
      variables: CustomerSubscriptionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerSubscriptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerSubscriptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerSubscriptionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerSubscriptions.infinite'] : ['CustomerSubscriptions.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerSubscriptionsQuery, CustomerSubscriptionsQueryVariables>(CustomerSubscriptionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerSubscriptionsQuery.getKey = (variables?: CustomerSubscriptionsQueryVariables) => variables === undefined ? ['CustomerSubscriptions.infinite'] : ['CustomerSubscriptions.infinite', variables];

export const useSuspenseInfiniteCustomerSubscriptionsQuery = <
      TData = InfiniteData<CustomerSubscriptionsQuery>,
      TError = unknown
    >(
      variables: CustomerSubscriptionsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerSubscriptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerSubscriptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerSubscriptionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerSubscriptions.infinite'] : ['CustomerSubscriptions.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerSubscriptionsQuery, CustomerSubscriptionsQueryVariables>(CustomerSubscriptionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerSubscriptionsQuery.getKey = (variables?: CustomerSubscriptionsQueryVariables) => variables === undefined ? ['CustomerSubscriptions.infinite'] : ['CustomerSubscriptions.infinite', variables];


useCustomerSubscriptionsQuery.fetcher = (variables?: CustomerSubscriptionsQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerSubscriptionsQuery, CustomerSubscriptionsQueryVariables>(CustomerSubscriptionsDocument, variables, options);

export const IsEligibleForTrialDocument = `
    query IsEligibleForTrial($customerId: Int!) {
  isEligibleForTrial(customerId: $customerId)
}
    `;

export const useIsEligibleForTrialQuery = <
      TData = IsEligibleForTrialQuery,
      TError = unknown
    >(
      variables: IsEligibleForTrialQueryVariables,
      options?: Omit<UseQueryOptions<IsEligibleForTrialQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<IsEligibleForTrialQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<IsEligibleForTrialQuery, TError, TData>(
      {
    queryKey: ['IsEligibleForTrial', variables],
    queryFn: fetchData<IsEligibleForTrialQuery, IsEligibleForTrialQueryVariables>(IsEligibleForTrialDocument, variables),
    ...options
  }
    )};

useIsEligibleForTrialQuery.getKey = (variables: IsEligibleForTrialQueryVariables) => ['IsEligibleForTrial', variables];

export const useSuspenseIsEligibleForTrialQuery = <
      TData = IsEligibleForTrialQuery,
      TError = unknown
    >(
      variables: IsEligibleForTrialQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<IsEligibleForTrialQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<IsEligibleForTrialQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<IsEligibleForTrialQuery, TError, TData>(
      {
    queryKey: ['IsEligibleForTrial', variables],
    queryFn: fetchData<IsEligibleForTrialQuery, IsEligibleForTrialQueryVariables>(IsEligibleForTrialDocument, variables),
    ...options
  }
    )};

useSuspenseIsEligibleForTrialQuery.getKey = (variables: IsEligibleForTrialQueryVariables) => ['IsEligibleForTrial', variables];

export const useInfiniteIsEligibleForTrialQuery = <
      TData = InfiniteData<IsEligibleForTrialQuery>,
      TError = unknown
    >(
      variables: IsEligibleForTrialQueryVariables,
      options: Omit<UseInfiniteQueryOptions<IsEligibleForTrialQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<IsEligibleForTrialQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<IsEligibleForTrialQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['IsEligibleForTrial.infinite', variables],
      queryFn: (metaData) => fetchData<IsEligibleForTrialQuery, IsEligibleForTrialQueryVariables>(IsEligibleForTrialDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteIsEligibleForTrialQuery.getKey = (variables: IsEligibleForTrialQueryVariables) => ['IsEligibleForTrial.infinite', variables];

export const useSuspenseInfiniteIsEligibleForTrialQuery = <
      TData = InfiniteData<IsEligibleForTrialQuery>,
      TError = unknown
    >(
      variables: IsEligibleForTrialQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<IsEligibleForTrialQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<IsEligibleForTrialQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<IsEligibleForTrialQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['IsEligibleForTrial.infinite', variables],
      queryFn: (metaData) => fetchData<IsEligibleForTrialQuery, IsEligibleForTrialQueryVariables>(IsEligibleForTrialDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteIsEligibleForTrialQuery.getKey = (variables: IsEligibleForTrialQueryVariables) => ['IsEligibleForTrial.infinite', variables];


useIsEligibleForTrialQuery.fetcher = (variables: IsEligibleForTrialQueryVariables, options?: RequestInit['headers']) => fetchData<IsEligibleForTrialQuery, IsEligibleForTrialQueryVariables>(IsEligibleForTrialDocument, variables, options);

export const MasterclassLiveBannerDocument = `
    query MasterclassLiveBanner {
  masterclassLiveBanner {
    showBanner
    lectureName
    streamUrl
    thumbnails {
      default
    }
  }
}
    `;

export const useMasterclassLiveBannerQuery = <
      TData = MasterclassLiveBannerQuery,
      TError = unknown
    >(
      variables?: MasterclassLiveBannerQueryVariables,
      options?: Omit<UseQueryOptions<MasterclassLiveBannerQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MasterclassLiveBannerQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MasterclassLiveBannerQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MasterclassLiveBanner'] : ['MasterclassLiveBanner', variables],
    queryFn: fetchData<MasterclassLiveBannerQuery, MasterclassLiveBannerQueryVariables>(MasterclassLiveBannerDocument, variables),
    ...options
  }
    )};

useMasterclassLiveBannerQuery.getKey = (variables?: MasterclassLiveBannerQueryVariables) => variables === undefined ? ['MasterclassLiveBanner'] : ['MasterclassLiveBanner', variables];

export const useSuspenseMasterclassLiveBannerQuery = <
      TData = MasterclassLiveBannerQuery,
      TError = unknown
    >(
      variables?: MasterclassLiveBannerQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MasterclassLiveBannerQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MasterclassLiveBannerQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MasterclassLiveBannerQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MasterclassLiveBanner'] : ['MasterclassLiveBanner', variables],
    queryFn: fetchData<MasterclassLiveBannerQuery, MasterclassLiveBannerQueryVariables>(MasterclassLiveBannerDocument, variables),
    ...options
  }
    )};

useSuspenseMasterclassLiveBannerQuery.getKey = (variables?: MasterclassLiveBannerQueryVariables) => variables === undefined ? ['MasterclassLiveBanner'] : ['MasterclassLiveBanner', variables];

export const useInfiniteMasterclassLiveBannerQuery = <
      TData = InfiniteData<MasterclassLiveBannerQuery>,
      TError = unknown
    >(
      variables: MasterclassLiveBannerQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MasterclassLiveBannerQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MasterclassLiveBannerQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<MasterclassLiveBannerQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['MasterclassLiveBanner.infinite'] : ['MasterclassLiveBanner.infinite', variables],
      queryFn: (metaData) => fetchData<MasterclassLiveBannerQuery, MasterclassLiveBannerQueryVariables>(MasterclassLiveBannerDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMasterclassLiveBannerQuery.getKey = (variables?: MasterclassLiveBannerQueryVariables) => variables === undefined ? ['MasterclassLiveBanner.infinite'] : ['MasterclassLiveBanner.infinite', variables];

export const useSuspenseInfiniteMasterclassLiveBannerQuery = <
      TData = InfiniteData<MasterclassLiveBannerQuery>,
      TError = unknown
    >(
      variables: MasterclassLiveBannerQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<MasterclassLiveBannerQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<MasterclassLiveBannerQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<MasterclassLiveBannerQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['MasterclassLiveBanner.infinite'] : ['MasterclassLiveBanner.infinite', variables],
      queryFn: (metaData) => fetchData<MasterclassLiveBannerQuery, MasterclassLiveBannerQueryVariables>(MasterclassLiveBannerDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteMasterclassLiveBannerQuery.getKey = (variables?: MasterclassLiveBannerQueryVariables) => variables === undefined ? ['MasterclassLiveBanner.infinite'] : ['MasterclassLiveBanner.infinite', variables];


useMasterclassLiveBannerQuery.fetcher = (variables?: MasterclassLiveBannerQueryVariables, options?: RequestInit['headers']) => fetchData<MasterclassLiveBannerQuery, MasterclassLiveBannerQueryVariables>(MasterclassLiveBannerDocument, variables, options);

export const MasterclassLiveStatusDocument = `
    query MasterclassLiveStatus {
  masterclassLiveStatus {
    url
  }
}
    `;

export const useMasterclassLiveStatusQuery = <
      TData = MasterclassLiveStatusQuery,
      TError = unknown
    >(
      variables?: MasterclassLiveStatusQueryVariables,
      options?: Omit<UseQueryOptions<MasterclassLiveStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MasterclassLiveStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MasterclassLiveStatusQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MasterclassLiveStatus'] : ['MasterclassLiveStatus', variables],
    queryFn: fetchData<MasterclassLiveStatusQuery, MasterclassLiveStatusQueryVariables>(MasterclassLiveStatusDocument, variables),
    ...options
  }
    )};

useMasterclassLiveStatusQuery.getKey = (variables?: MasterclassLiveStatusQueryVariables) => variables === undefined ? ['MasterclassLiveStatus'] : ['MasterclassLiveStatus', variables];

export const useSuspenseMasterclassLiveStatusQuery = <
      TData = MasterclassLiveStatusQuery,
      TError = unknown
    >(
      variables?: MasterclassLiveStatusQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MasterclassLiveStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MasterclassLiveStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MasterclassLiveStatusQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MasterclassLiveStatus'] : ['MasterclassLiveStatus', variables],
    queryFn: fetchData<MasterclassLiveStatusQuery, MasterclassLiveStatusQueryVariables>(MasterclassLiveStatusDocument, variables),
    ...options
  }
    )};

useSuspenseMasterclassLiveStatusQuery.getKey = (variables?: MasterclassLiveStatusQueryVariables) => variables === undefined ? ['MasterclassLiveStatus'] : ['MasterclassLiveStatus', variables];

export const useInfiniteMasterclassLiveStatusQuery = <
      TData = InfiniteData<MasterclassLiveStatusQuery>,
      TError = unknown
    >(
      variables: MasterclassLiveStatusQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MasterclassLiveStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MasterclassLiveStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<MasterclassLiveStatusQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['MasterclassLiveStatus.infinite'] : ['MasterclassLiveStatus.infinite', variables],
      queryFn: (metaData) => fetchData<MasterclassLiveStatusQuery, MasterclassLiveStatusQueryVariables>(MasterclassLiveStatusDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMasterclassLiveStatusQuery.getKey = (variables?: MasterclassLiveStatusQueryVariables) => variables === undefined ? ['MasterclassLiveStatus.infinite'] : ['MasterclassLiveStatus.infinite', variables];

export const useSuspenseInfiniteMasterclassLiveStatusQuery = <
      TData = InfiniteData<MasterclassLiveStatusQuery>,
      TError = unknown
    >(
      variables: MasterclassLiveStatusQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<MasterclassLiveStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<MasterclassLiveStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<MasterclassLiveStatusQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['MasterclassLiveStatus.infinite'] : ['MasterclassLiveStatus.infinite', variables],
      queryFn: (metaData) => fetchData<MasterclassLiveStatusQuery, MasterclassLiveStatusQueryVariables>(MasterclassLiveStatusDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteMasterclassLiveStatusQuery.getKey = (variables?: MasterclassLiveStatusQueryVariables) => variables === undefined ? ['MasterclassLiveStatus.infinite'] : ['MasterclassLiveStatus.infinite', variables];


useMasterclassLiveStatusQuery.fetcher = (variables?: MasterclassLiveStatusQueryVariables, options?: RequestInit['headers']) => fetchData<MasterclassLiveStatusQuery, MasterclassLiveStatusQueryVariables>(MasterclassLiveStatusDocument, variables, options);

export const MasterclassStatusDocument = `
    query MasterclassStatus {
  masterclassStatusForCustomer {
    id
    canStreamMasterclassCatalog
    isDelinquent
    isPaused
    isCanceled
    isFreeSubscription
    isPauseScheduled
    nextBillingDate
    proratedAmount
    resumeChargeAmount
    resumeChargeCurrency
    resumeChargeLast4
    trial {
      isTrial
      trialEndDate
      trialStartDate
    }
  }
}
    `;

export const useMasterclassStatusQuery = <
      TData = MasterclassStatusQuery,
      TError = unknown
    >(
      variables?: MasterclassStatusQueryVariables,
      options?: Omit<UseQueryOptions<MasterclassStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MasterclassStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MasterclassStatusQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MasterclassStatus'] : ['MasterclassStatus', variables],
    queryFn: fetchData<MasterclassStatusQuery, MasterclassStatusQueryVariables>(MasterclassStatusDocument, variables),
    ...options
  }
    )};

useMasterclassStatusQuery.getKey = (variables?: MasterclassStatusQueryVariables) => variables === undefined ? ['MasterclassStatus'] : ['MasterclassStatus', variables];

export const useSuspenseMasterclassStatusQuery = <
      TData = MasterclassStatusQuery,
      TError = unknown
    >(
      variables?: MasterclassStatusQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<MasterclassStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<MasterclassStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<MasterclassStatusQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['MasterclassStatus'] : ['MasterclassStatus', variables],
    queryFn: fetchData<MasterclassStatusQuery, MasterclassStatusQueryVariables>(MasterclassStatusDocument, variables),
    ...options
  }
    )};

useSuspenseMasterclassStatusQuery.getKey = (variables?: MasterclassStatusQueryVariables) => variables === undefined ? ['MasterclassStatus'] : ['MasterclassStatus', variables];

export const useInfiniteMasterclassStatusQuery = <
      TData = InfiniteData<MasterclassStatusQuery>,
      TError = unknown
    >(
      variables: MasterclassStatusQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MasterclassStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MasterclassStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<MasterclassStatusQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['MasterclassStatus.infinite'] : ['MasterclassStatus.infinite', variables],
      queryFn: (metaData) => fetchData<MasterclassStatusQuery, MasterclassStatusQueryVariables>(MasterclassStatusDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteMasterclassStatusQuery.getKey = (variables?: MasterclassStatusQueryVariables) => variables === undefined ? ['MasterclassStatus.infinite'] : ['MasterclassStatus.infinite', variables];

export const useSuspenseInfiniteMasterclassStatusQuery = <
      TData = InfiniteData<MasterclassStatusQuery>,
      TError = unknown
    >(
      variables: MasterclassStatusQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<MasterclassStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<MasterclassStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<MasterclassStatusQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['MasterclassStatus.infinite'] : ['MasterclassStatus.infinite', variables],
      queryFn: (metaData) => fetchData<MasterclassStatusQuery, MasterclassStatusQueryVariables>(MasterclassStatusDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteMasterclassStatusQuery.getKey = (variables?: MasterclassStatusQueryVariables) => variables === undefined ? ['MasterclassStatus.infinite'] : ['MasterclassStatus.infinite', variables];


useMasterclassStatusQuery.fetcher = (variables?: MasterclassStatusQueryVariables, options?: RequestInit['headers']) => fetchData<MasterclassStatusQuery, MasterclassStatusQueryVariables>(MasterclassStatusDocument, variables, options);

export const NextMonthMasterclassDocument = `
    query NextMonthMasterclass($month: Int!, $year: Int!) {
  masterclassByMonthAndYear(month: $month, year: $year) {
    id
    name
    thumbnails {
      video
    }
    url
    meta {
      key
      value
    }
    lectureDates
    downloadFiles {
      id
      title
      type
      lectureStartTime
    }
  }
}
    `;

export const useNextMonthMasterclassQuery = <
      TData = NextMonthMasterclassQuery,
      TError = unknown
    >(
      variables: NextMonthMasterclassQueryVariables,
      options?: Omit<UseQueryOptions<NextMonthMasterclassQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<NextMonthMasterclassQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<NextMonthMasterclassQuery, TError, TData>(
      {
    queryKey: ['NextMonthMasterclass', variables],
    queryFn: fetchData<NextMonthMasterclassQuery, NextMonthMasterclassQueryVariables>(NextMonthMasterclassDocument, variables),
    ...options
  }
    )};

useNextMonthMasterclassQuery.getKey = (variables: NextMonthMasterclassQueryVariables) => ['NextMonthMasterclass', variables];

export const useSuspenseNextMonthMasterclassQuery = <
      TData = NextMonthMasterclassQuery,
      TError = unknown
    >(
      variables: NextMonthMasterclassQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<NextMonthMasterclassQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<NextMonthMasterclassQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<NextMonthMasterclassQuery, TError, TData>(
      {
    queryKey: ['NextMonthMasterclass', variables],
    queryFn: fetchData<NextMonthMasterclassQuery, NextMonthMasterclassQueryVariables>(NextMonthMasterclassDocument, variables),
    ...options
  }
    )};

useSuspenseNextMonthMasterclassQuery.getKey = (variables: NextMonthMasterclassQueryVariables) => ['NextMonthMasterclass', variables];

export const useInfiniteNextMonthMasterclassQuery = <
      TData = InfiniteData<NextMonthMasterclassQuery>,
      TError = unknown
    >(
      variables: NextMonthMasterclassQueryVariables,
      options: Omit<UseInfiniteQueryOptions<NextMonthMasterclassQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<NextMonthMasterclassQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<NextMonthMasterclassQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['NextMonthMasterclass.infinite', variables],
      queryFn: (metaData) => fetchData<NextMonthMasterclassQuery, NextMonthMasterclassQueryVariables>(NextMonthMasterclassDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteNextMonthMasterclassQuery.getKey = (variables: NextMonthMasterclassQueryVariables) => ['NextMonthMasterclass.infinite', variables];

export const useSuspenseInfiniteNextMonthMasterclassQuery = <
      TData = InfiniteData<NextMonthMasterclassQuery>,
      TError = unknown
    >(
      variables: NextMonthMasterclassQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<NextMonthMasterclassQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<NextMonthMasterclassQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<NextMonthMasterclassQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['NextMonthMasterclass.infinite', variables],
      queryFn: (metaData) => fetchData<NextMonthMasterclassQuery, NextMonthMasterclassQueryVariables>(NextMonthMasterclassDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteNextMonthMasterclassQuery.getKey = (variables: NextMonthMasterclassQueryVariables) => ['NextMonthMasterclass.infinite', variables];


useNextMonthMasterclassQuery.fetcher = (variables: NextMonthMasterclassQueryVariables, options?: RequestInit['headers']) => fetchData<NextMonthMasterclassQuery, NextMonthMasterclassQueryVariables>(NextMonthMasterclassDocument, variables, options);

export const SubscriptionDocument = `
    query Subscription($subscriptionId: Int!) {
  subscriptionById(subscriptionId: $subscriptionId) {
    id
    subscriptionId
    subscriptionTier
    isActive
    isInGoodStanding
    isPaused
    nextBillingDate
    endDate
    isTrial
  }
}
    `;

export const useSubscriptionQuery = <
      TData = SubscriptionQuery,
      TError = unknown
    >(
      variables: SubscriptionQueryVariables,
      options?: Omit<UseQueryOptions<SubscriptionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SubscriptionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SubscriptionQuery, TError, TData>(
      {
    queryKey: ['Subscription', variables],
    queryFn: fetchData<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, variables),
    ...options
  }
    )};

useSubscriptionQuery.getKey = (variables: SubscriptionQueryVariables) => ['Subscription', variables];

export const useSuspenseSubscriptionQuery = <
      TData = SubscriptionQuery,
      TError = unknown
    >(
      variables: SubscriptionQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<SubscriptionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<SubscriptionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<SubscriptionQuery, TError, TData>(
      {
    queryKey: ['Subscription', variables],
    queryFn: fetchData<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, variables),
    ...options
  }
    )};

useSuspenseSubscriptionQuery.getKey = (variables: SubscriptionQueryVariables) => ['Subscription', variables];

export const useInfiniteSubscriptionQuery = <
      TData = InfiniteData<SubscriptionQuery>,
      TError = unknown
    >(
      variables: SubscriptionQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SubscriptionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SubscriptionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<SubscriptionQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Subscription.infinite', variables],
      queryFn: (metaData) => fetchData<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteSubscriptionQuery.getKey = (variables: SubscriptionQueryVariables) => ['Subscription.infinite', variables];

export const useSuspenseInfiniteSubscriptionQuery = <
      TData = InfiniteData<SubscriptionQuery>,
      TError = unknown
    >(
      variables: SubscriptionQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<SubscriptionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<SubscriptionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<SubscriptionQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Subscription.infinite', variables],
      queryFn: (metaData) => fetchData<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteSubscriptionQuery.getKey = (variables: SubscriptionQueryVariables) => ['Subscription.infinite', variables];


useSubscriptionQuery.fetcher = (variables: SubscriptionQueryVariables, options?: RequestInit['headers']) => fetchData<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, variables, options);

export const SubscriptionEligibilityDocument = `
    query SubscriptionEligibility {
  subscriptionEligibility {
    isSubscriber
    hasHadSubscriptionBefore
    isEligibleForTrial
    hasPausedSubscription
    hasDelinquentSubscription
  }
}
    `;

export const useSubscriptionEligibilityQuery = <
      TData = SubscriptionEligibilityQuery,
      TError = unknown
    >(
      variables?: SubscriptionEligibilityQueryVariables,
      options?: Omit<UseQueryOptions<SubscriptionEligibilityQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SubscriptionEligibilityQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SubscriptionEligibilityQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['SubscriptionEligibility'] : ['SubscriptionEligibility', variables],
    queryFn: fetchData<SubscriptionEligibilityQuery, SubscriptionEligibilityQueryVariables>(SubscriptionEligibilityDocument, variables),
    ...options
  }
    )};

useSubscriptionEligibilityQuery.getKey = (variables?: SubscriptionEligibilityQueryVariables) => variables === undefined ? ['SubscriptionEligibility'] : ['SubscriptionEligibility', variables];

export const useSuspenseSubscriptionEligibilityQuery = <
      TData = SubscriptionEligibilityQuery,
      TError = unknown
    >(
      variables?: SubscriptionEligibilityQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<SubscriptionEligibilityQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<SubscriptionEligibilityQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<SubscriptionEligibilityQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['SubscriptionEligibility'] : ['SubscriptionEligibility', variables],
    queryFn: fetchData<SubscriptionEligibilityQuery, SubscriptionEligibilityQueryVariables>(SubscriptionEligibilityDocument, variables),
    ...options
  }
    )};

useSuspenseSubscriptionEligibilityQuery.getKey = (variables?: SubscriptionEligibilityQueryVariables) => variables === undefined ? ['SubscriptionEligibility'] : ['SubscriptionEligibility', variables];

export const useInfiniteSubscriptionEligibilityQuery = <
      TData = InfiniteData<SubscriptionEligibilityQuery>,
      TError = unknown
    >(
      variables: SubscriptionEligibilityQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SubscriptionEligibilityQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SubscriptionEligibilityQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<SubscriptionEligibilityQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['SubscriptionEligibility.infinite'] : ['SubscriptionEligibility.infinite', variables],
      queryFn: (metaData) => fetchData<SubscriptionEligibilityQuery, SubscriptionEligibilityQueryVariables>(SubscriptionEligibilityDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteSubscriptionEligibilityQuery.getKey = (variables?: SubscriptionEligibilityQueryVariables) => variables === undefined ? ['SubscriptionEligibility.infinite'] : ['SubscriptionEligibility.infinite', variables];

export const useSuspenseInfiniteSubscriptionEligibilityQuery = <
      TData = InfiniteData<SubscriptionEligibilityQuery>,
      TError = unknown
    >(
      variables: SubscriptionEligibilityQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<SubscriptionEligibilityQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<SubscriptionEligibilityQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<SubscriptionEligibilityQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['SubscriptionEligibility.infinite'] : ['SubscriptionEligibility.infinite', variables],
      queryFn: (metaData) => fetchData<SubscriptionEligibilityQuery, SubscriptionEligibilityQueryVariables>(SubscriptionEligibilityDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteSubscriptionEligibilityQuery.getKey = (variables?: SubscriptionEligibilityQueryVariables) => variables === undefined ? ['SubscriptionEligibility.infinite'] : ['SubscriptionEligibility.infinite', variables];


useSubscriptionEligibilityQuery.fetcher = (variables?: SubscriptionEligibilityQueryVariables, options?: RequestInit['headers']) => fetchData<SubscriptionEligibilityQuery, SubscriptionEligibilityQueryVariables>(SubscriptionEligibilityDocument, variables, options);

export const InvoicePdfDocument = `
    query InvoicePdf($orderId: Int!) {
  invoicePdf(orderId: $orderId)
}
    `;

export const useInvoicePdfQuery = <
      TData = InvoicePdfQuery,
      TError = unknown
    >(
      variables: InvoicePdfQueryVariables,
      options?: Omit<UseQueryOptions<InvoicePdfQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<InvoicePdfQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<InvoicePdfQuery, TError, TData>(
      {
    queryKey: ['InvoicePdf', variables],
    queryFn: fetchData<InvoicePdfQuery, InvoicePdfQueryVariables>(InvoicePdfDocument, variables),
    ...options
  }
    )};

useInvoicePdfQuery.getKey = (variables: InvoicePdfQueryVariables) => ['InvoicePdf', variables];

export const useSuspenseInvoicePdfQuery = <
      TData = InvoicePdfQuery,
      TError = unknown
    >(
      variables: InvoicePdfQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<InvoicePdfQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<InvoicePdfQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<InvoicePdfQuery, TError, TData>(
      {
    queryKey: ['InvoicePdf', variables],
    queryFn: fetchData<InvoicePdfQuery, InvoicePdfQueryVariables>(InvoicePdfDocument, variables),
    ...options
  }
    )};

useSuspenseInvoicePdfQuery.getKey = (variables: InvoicePdfQueryVariables) => ['InvoicePdf', variables];

export const useInfiniteInvoicePdfQuery = <
      TData = InfiniteData<InvoicePdfQuery>,
      TError = unknown
    >(
      variables: InvoicePdfQueryVariables,
      options: Omit<UseInfiniteQueryOptions<InvoicePdfQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<InvoicePdfQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<InvoicePdfQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['InvoicePdf.infinite', variables],
      queryFn: (metaData) => fetchData<InvoicePdfQuery, InvoicePdfQueryVariables>(InvoicePdfDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteInvoicePdfQuery.getKey = (variables: InvoicePdfQueryVariables) => ['InvoicePdf.infinite', variables];

export const useSuspenseInfiniteInvoicePdfQuery = <
      TData = InfiniteData<InvoicePdfQuery>,
      TError = unknown
    >(
      variables: InvoicePdfQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<InvoicePdfQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<InvoicePdfQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<InvoicePdfQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['InvoicePdf.infinite', variables],
      queryFn: (metaData) => fetchData<InvoicePdfQuery, InvoicePdfQueryVariables>(InvoicePdfDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteInvoicePdfQuery.getKey = (variables: InvoicePdfQueryVariables) => ['InvoicePdf.infinite', variables];


useInvoicePdfQuery.fetcher = (variables: InvoicePdfQueryVariables, options?: RequestInit['headers']) => fetchData<InvoicePdfQuery, InvoicePdfQueryVariables>(InvoicePdfDocument, variables, options);

export const PackageTrackingDocument = `
    query PackageTracking($trackingNumber: String!) {
  trackingInfo(trackingCode: $trackingNumber) {
    carrier {
      name
      contactPhone
      logoUrl
    }
    cost
    trackingUrl
    externalTrackingUrl
    deliveredDate
    dispatchedDate
    errorDescription
    estDeliveryDate
    id
    service
    shippingMethod
    signedBy
    status
    statusCode
    statusDetail
    statusLabel
    trackingNumber
    trackingState
    weight
    trackingHistory {
      city
      country {
        isoCode
        name
      }
      details
      id
      state
      status
      timeUpdated
      zip
    }
  }
}
    `;

export const usePackageTrackingQuery = <
      TData = PackageTrackingQuery,
      TError = unknown
    >(
      variables: PackageTrackingQueryVariables,
      options?: Omit<UseQueryOptions<PackageTrackingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PackageTrackingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PackageTrackingQuery, TError, TData>(
      {
    queryKey: ['PackageTracking', variables],
    queryFn: fetchData<PackageTrackingQuery, PackageTrackingQueryVariables>(PackageTrackingDocument, variables),
    ...options
  }
    )};

usePackageTrackingQuery.getKey = (variables: PackageTrackingQueryVariables) => ['PackageTracking', variables];

export const useSuspensePackageTrackingQuery = <
      TData = PackageTrackingQuery,
      TError = unknown
    >(
      variables: PackageTrackingQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<PackageTrackingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<PackageTrackingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<PackageTrackingQuery, TError, TData>(
      {
    queryKey: ['PackageTracking', variables],
    queryFn: fetchData<PackageTrackingQuery, PackageTrackingQueryVariables>(PackageTrackingDocument, variables),
    ...options
  }
    )};

useSuspensePackageTrackingQuery.getKey = (variables: PackageTrackingQueryVariables) => ['PackageTracking', variables];

export const useInfinitePackageTrackingQuery = <
      TData = InfiniteData<PackageTrackingQuery>,
      TError = unknown
    >(
      variables: PackageTrackingQueryVariables,
      options: Omit<UseInfiniteQueryOptions<PackageTrackingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<PackageTrackingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<PackageTrackingQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['PackageTracking.infinite', variables],
      queryFn: (metaData) => fetchData<PackageTrackingQuery, PackageTrackingQueryVariables>(PackageTrackingDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfinitePackageTrackingQuery.getKey = (variables: PackageTrackingQueryVariables) => ['PackageTracking.infinite', variables];

export const useSuspenseInfinitePackageTrackingQuery = <
      TData = InfiniteData<PackageTrackingQuery>,
      TError = unknown
    >(
      variables: PackageTrackingQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<PackageTrackingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<PackageTrackingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<PackageTrackingQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['PackageTracking.infinite', variables],
      queryFn: (metaData) => fetchData<PackageTrackingQuery, PackageTrackingQueryVariables>(PackageTrackingDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfinitePackageTrackingQuery.getKey = (variables: PackageTrackingQueryVariables) => ['PackageTracking.infinite', variables];


usePackageTrackingQuery.fetcher = (variables: PackageTrackingQueryVariables, options?: RequestInit['headers']) => fetchData<PackageTrackingQuery, PackageTrackingQueryVariables>(PackageTrackingDocument, variables, options);

export const GiftCertificateOptionsDocument = `
    query GiftCertificateOptions($currencyId: Int!) {
  giftCertificateOptions(currencyId: $currencyId) {
    id
    name
    price
    currencySymbol
  }
}
    `;

export const useGiftCertificateOptionsQuery = <
      TData = GiftCertificateOptionsQuery,
      TError = unknown
    >(
      variables: GiftCertificateOptionsQueryVariables,
      options?: Omit<UseQueryOptions<GiftCertificateOptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GiftCertificateOptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GiftCertificateOptionsQuery, TError, TData>(
      {
    queryKey: ['GiftCertificateOptions', variables],
    queryFn: fetchData<GiftCertificateOptionsQuery, GiftCertificateOptionsQueryVariables>(GiftCertificateOptionsDocument, variables),
    ...options
  }
    )};

useGiftCertificateOptionsQuery.getKey = (variables: GiftCertificateOptionsQueryVariables) => ['GiftCertificateOptions', variables];

export const useSuspenseGiftCertificateOptionsQuery = <
      TData = GiftCertificateOptionsQuery,
      TError = unknown
    >(
      variables: GiftCertificateOptionsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<GiftCertificateOptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<GiftCertificateOptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<GiftCertificateOptionsQuery, TError, TData>(
      {
    queryKey: ['GiftCertificateOptions', variables],
    queryFn: fetchData<GiftCertificateOptionsQuery, GiftCertificateOptionsQueryVariables>(GiftCertificateOptionsDocument, variables),
    ...options
  }
    )};

useSuspenseGiftCertificateOptionsQuery.getKey = (variables: GiftCertificateOptionsQueryVariables) => ['GiftCertificateOptions', variables];

export const useInfiniteGiftCertificateOptionsQuery = <
      TData = InfiniteData<GiftCertificateOptionsQuery>,
      TError = unknown
    >(
      variables: GiftCertificateOptionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GiftCertificateOptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GiftCertificateOptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GiftCertificateOptionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GiftCertificateOptions.infinite', variables],
      queryFn: (metaData) => fetchData<GiftCertificateOptionsQuery, GiftCertificateOptionsQueryVariables>(GiftCertificateOptionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGiftCertificateOptionsQuery.getKey = (variables: GiftCertificateOptionsQueryVariables) => ['GiftCertificateOptions.infinite', variables];

export const useSuspenseInfiniteGiftCertificateOptionsQuery = <
      TData = InfiniteData<GiftCertificateOptionsQuery>,
      TError = unknown
    >(
      variables: GiftCertificateOptionsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<GiftCertificateOptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<GiftCertificateOptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<GiftCertificateOptionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GiftCertificateOptions.infinite', variables],
      queryFn: (metaData) => fetchData<GiftCertificateOptionsQuery, GiftCertificateOptionsQueryVariables>(GiftCertificateOptionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteGiftCertificateOptionsQuery.getKey = (variables: GiftCertificateOptionsQueryVariables) => ['GiftCertificateOptions.infinite', variables];


useGiftCertificateOptionsQuery.fetcher = (variables: GiftCertificateOptionsQueryVariables, options?: RequestInit['headers']) => fetchData<GiftCertificateOptionsQuery, GiftCertificateOptionsQueryVariables>(GiftCertificateOptionsDocument, variables, options);

export const InvoiceExtraInfoDocument = `
    query InvoiceExtraInfo($brandId: Int!) {
  invoiceExtraInfo(brandId: $brandId)
}
    `;

export const useInvoiceExtraInfoQuery = <
      TData = InvoiceExtraInfoQuery,
      TError = unknown
    >(
      variables: InvoiceExtraInfoQueryVariables,
      options?: Omit<UseQueryOptions<InvoiceExtraInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<InvoiceExtraInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<InvoiceExtraInfoQuery, TError, TData>(
      {
    queryKey: ['InvoiceExtraInfo', variables],
    queryFn: fetchData<InvoiceExtraInfoQuery, InvoiceExtraInfoQueryVariables>(InvoiceExtraInfoDocument, variables),
    ...options
  }
    )};

useInvoiceExtraInfoQuery.getKey = (variables: InvoiceExtraInfoQueryVariables) => ['InvoiceExtraInfo', variables];

export const useSuspenseInvoiceExtraInfoQuery = <
      TData = InvoiceExtraInfoQuery,
      TError = unknown
    >(
      variables: InvoiceExtraInfoQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<InvoiceExtraInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<InvoiceExtraInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<InvoiceExtraInfoQuery, TError, TData>(
      {
    queryKey: ['InvoiceExtraInfo', variables],
    queryFn: fetchData<InvoiceExtraInfoQuery, InvoiceExtraInfoQueryVariables>(InvoiceExtraInfoDocument, variables),
    ...options
  }
    )};

useSuspenseInvoiceExtraInfoQuery.getKey = (variables: InvoiceExtraInfoQueryVariables) => ['InvoiceExtraInfo', variables];

export const useInfiniteInvoiceExtraInfoQuery = <
      TData = InfiniteData<InvoiceExtraInfoQuery>,
      TError = unknown
    >(
      variables: InvoiceExtraInfoQueryVariables,
      options: Omit<UseInfiniteQueryOptions<InvoiceExtraInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<InvoiceExtraInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<InvoiceExtraInfoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['InvoiceExtraInfo.infinite', variables],
      queryFn: (metaData) => fetchData<InvoiceExtraInfoQuery, InvoiceExtraInfoQueryVariables>(InvoiceExtraInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteInvoiceExtraInfoQuery.getKey = (variables: InvoiceExtraInfoQueryVariables) => ['InvoiceExtraInfo.infinite', variables];

export const useSuspenseInfiniteInvoiceExtraInfoQuery = <
      TData = InfiniteData<InvoiceExtraInfoQuery>,
      TError = unknown
    >(
      variables: InvoiceExtraInfoQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<InvoiceExtraInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<InvoiceExtraInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<InvoiceExtraInfoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['InvoiceExtraInfo.infinite', variables],
      queryFn: (metaData) => fetchData<InvoiceExtraInfoQuery, InvoiceExtraInfoQueryVariables>(InvoiceExtraInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteInvoiceExtraInfoQuery.getKey = (variables: InvoiceExtraInfoQueryVariables) => ['InvoiceExtraInfo.infinite', variables];


useInvoiceExtraInfoQuery.fetcher = (variables: InvoiceExtraInfoQueryVariables, options?: RequestInit['headers']) => fetchData<InvoiceExtraInfoQuery, InvoiceExtraInfoQueryVariables>(InvoiceExtraInfoDocument, variables, options);

export const CustomerPurchasedProductsDocument = `
    query CustomerPurchasedProducts($customerID: Int!, $take: Int!, $skip: Int!, $order: [PurchasedProductsSort!]) {
  purchasedProducts(
    customerId: $customerID
    take: $take
    skip: $skip
    order: $order
  ) {
    totalCount
    items {
      hasDownloads
      hasInstructions
      id
      productName
      purchasedDate
      thumbnailPath
      url
      creators {
        id
        name
        urlStub
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

export const useCustomerPurchasedProductsQuery = <
      TData = CustomerPurchasedProductsQuery,
      TError = unknown
    >(
      variables: CustomerPurchasedProductsQueryVariables,
      options?: Omit<UseQueryOptions<CustomerPurchasedProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerPurchasedProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerPurchasedProductsQuery, TError, TData>(
      {
    queryKey: ['CustomerPurchasedProducts', variables],
    queryFn: fetchData<CustomerPurchasedProductsQuery, CustomerPurchasedProductsQueryVariables>(CustomerPurchasedProductsDocument, variables),
    ...options
  }
    )};

useCustomerPurchasedProductsQuery.getKey = (variables: CustomerPurchasedProductsQueryVariables) => ['CustomerPurchasedProducts', variables];

export const useSuspenseCustomerPurchasedProductsQuery = <
      TData = CustomerPurchasedProductsQuery,
      TError = unknown
    >(
      variables: CustomerPurchasedProductsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerPurchasedProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerPurchasedProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerPurchasedProductsQuery, TError, TData>(
      {
    queryKey: ['CustomerPurchasedProducts', variables],
    queryFn: fetchData<CustomerPurchasedProductsQuery, CustomerPurchasedProductsQueryVariables>(CustomerPurchasedProductsDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerPurchasedProductsQuery.getKey = (variables: CustomerPurchasedProductsQueryVariables) => ['CustomerPurchasedProducts', variables];

export const useInfiniteCustomerPurchasedProductsQuery = <
      TData = InfiniteData<CustomerPurchasedProductsQuery>,
      TError = unknown
    >(
      variables: CustomerPurchasedProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerPurchasedProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerPurchasedProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerPurchasedProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomerPurchasedProducts.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerPurchasedProductsQuery, CustomerPurchasedProductsQueryVariables>(CustomerPurchasedProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerPurchasedProductsQuery.getKey = (variables: CustomerPurchasedProductsQueryVariables) => ['CustomerPurchasedProducts.infinite', variables];

export const useSuspenseInfiniteCustomerPurchasedProductsQuery = <
      TData = InfiniteData<CustomerPurchasedProductsQuery>,
      TError = unknown
    >(
      variables: CustomerPurchasedProductsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerPurchasedProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerPurchasedProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerPurchasedProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomerPurchasedProducts.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerPurchasedProductsQuery, CustomerPurchasedProductsQueryVariables>(CustomerPurchasedProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerPurchasedProductsQuery.getKey = (variables: CustomerPurchasedProductsQueryVariables) => ['CustomerPurchasedProducts.infinite', variables];


useCustomerPurchasedProductsQuery.fetcher = (variables: CustomerPurchasedProductsQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerPurchasedProductsQuery, CustomerPurchasedProductsQueryVariables>(CustomerPurchasedProductsDocument, variables, options);

export const CustomerPurchasedProductsAppDocument = `
    query CustomerPurchasedProductsApp($customerID: Int!, $take: Int!, $skip: Int!, $order: [PurchasedProductsAppSort!]) {
  purchasedProductsApp(
    customerId: $customerID
    take: $take
    skip: $skip
    order: $order
  ) {
    totalCount
    items {
      allowDownload
      bannerImageUrl
      category
      hasDownloads
      hasInstructions
      id
      isMasterClass
      productName
      purchasedDate
      thumbnailPath
      url
      creators {
        id
        name
        urlStub
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

export const useCustomerPurchasedProductsAppQuery = <
      TData = CustomerPurchasedProductsAppQuery,
      TError = unknown
    >(
      variables: CustomerPurchasedProductsAppQueryVariables,
      options?: Omit<UseQueryOptions<CustomerPurchasedProductsAppQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerPurchasedProductsAppQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerPurchasedProductsAppQuery, TError, TData>(
      {
    queryKey: ['CustomerPurchasedProductsApp', variables],
    queryFn: fetchData<CustomerPurchasedProductsAppQuery, CustomerPurchasedProductsAppQueryVariables>(CustomerPurchasedProductsAppDocument, variables),
    ...options
  }
    )};

useCustomerPurchasedProductsAppQuery.getKey = (variables: CustomerPurchasedProductsAppQueryVariables) => ['CustomerPurchasedProductsApp', variables];

export const useSuspenseCustomerPurchasedProductsAppQuery = <
      TData = CustomerPurchasedProductsAppQuery,
      TError = unknown
    >(
      variables: CustomerPurchasedProductsAppQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerPurchasedProductsAppQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerPurchasedProductsAppQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerPurchasedProductsAppQuery, TError, TData>(
      {
    queryKey: ['CustomerPurchasedProductsApp', variables],
    queryFn: fetchData<CustomerPurchasedProductsAppQuery, CustomerPurchasedProductsAppQueryVariables>(CustomerPurchasedProductsAppDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerPurchasedProductsAppQuery.getKey = (variables: CustomerPurchasedProductsAppQueryVariables) => ['CustomerPurchasedProductsApp', variables];

export const useInfiniteCustomerPurchasedProductsAppQuery = <
      TData = InfiniteData<CustomerPurchasedProductsAppQuery>,
      TError = unknown
    >(
      variables: CustomerPurchasedProductsAppQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerPurchasedProductsAppQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerPurchasedProductsAppQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerPurchasedProductsAppQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomerPurchasedProductsApp.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerPurchasedProductsAppQuery, CustomerPurchasedProductsAppQueryVariables>(CustomerPurchasedProductsAppDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerPurchasedProductsAppQuery.getKey = (variables: CustomerPurchasedProductsAppQueryVariables) => ['CustomerPurchasedProductsApp.infinite', variables];

export const useSuspenseInfiniteCustomerPurchasedProductsAppQuery = <
      TData = InfiniteData<CustomerPurchasedProductsAppQuery>,
      TError = unknown
    >(
      variables: CustomerPurchasedProductsAppQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerPurchasedProductsAppQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerPurchasedProductsAppQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerPurchasedProductsAppQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CustomerPurchasedProductsApp.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerPurchasedProductsAppQuery, CustomerPurchasedProductsAppQueryVariables>(CustomerPurchasedProductsAppDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerPurchasedProductsAppQuery.getKey = (variables: CustomerPurchasedProductsAppQueryVariables) => ['CustomerPurchasedProductsApp.infinite', variables];


useCustomerPurchasedProductsAppQuery.fetcher = (variables: CustomerPurchasedProductsAppQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerPurchasedProductsAppQuery, CustomerPurchasedProductsAppQueryVariables>(CustomerPurchasedProductsAppDocument, variables, options);

export const CustomerPurchasedProductsListDocument = `
    query CustomerPurchasedProductsList {
  purchasedProductsList {
    hasDownloads
    hasInstructions
    id
    productName
    purchasedDate
    thumbnailPath
    url
    creators {
      id
      name
      urlStub
    }
  }
}
    `;

export const useCustomerPurchasedProductsListQuery = <
      TData = CustomerPurchasedProductsListQuery,
      TError = unknown
    >(
      variables?: CustomerPurchasedProductsListQueryVariables,
      options?: Omit<UseQueryOptions<CustomerPurchasedProductsListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CustomerPurchasedProductsListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CustomerPurchasedProductsListQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerPurchasedProductsList'] : ['CustomerPurchasedProductsList', variables],
    queryFn: fetchData<CustomerPurchasedProductsListQuery, CustomerPurchasedProductsListQueryVariables>(CustomerPurchasedProductsListDocument, variables),
    ...options
  }
    )};

useCustomerPurchasedProductsListQuery.getKey = (variables?: CustomerPurchasedProductsListQueryVariables) => variables === undefined ? ['CustomerPurchasedProductsList'] : ['CustomerPurchasedProductsList', variables];

export const useSuspenseCustomerPurchasedProductsListQuery = <
      TData = CustomerPurchasedProductsListQuery,
      TError = unknown
    >(
      variables?: CustomerPurchasedProductsListQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CustomerPurchasedProductsListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CustomerPurchasedProductsListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<CustomerPurchasedProductsListQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['CustomerPurchasedProductsList'] : ['CustomerPurchasedProductsList', variables],
    queryFn: fetchData<CustomerPurchasedProductsListQuery, CustomerPurchasedProductsListQueryVariables>(CustomerPurchasedProductsListDocument, variables),
    ...options
  }
    )};

useSuspenseCustomerPurchasedProductsListQuery.getKey = (variables?: CustomerPurchasedProductsListQueryVariables) => variables === undefined ? ['CustomerPurchasedProductsList'] : ['CustomerPurchasedProductsList', variables];

export const useInfiniteCustomerPurchasedProductsListQuery = <
      TData = InfiniteData<CustomerPurchasedProductsListQuery>,
      TError = unknown
    >(
      variables: CustomerPurchasedProductsListQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CustomerPurchasedProductsListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CustomerPurchasedProductsListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CustomerPurchasedProductsListQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerPurchasedProductsList.infinite'] : ['CustomerPurchasedProductsList.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerPurchasedProductsListQuery, CustomerPurchasedProductsListQueryVariables>(CustomerPurchasedProductsListDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCustomerPurchasedProductsListQuery.getKey = (variables?: CustomerPurchasedProductsListQueryVariables) => variables === undefined ? ['CustomerPurchasedProductsList.infinite'] : ['CustomerPurchasedProductsList.infinite', variables];

export const useSuspenseInfiniteCustomerPurchasedProductsListQuery = <
      TData = InfiniteData<CustomerPurchasedProductsListQuery>,
      TError = unknown
    >(
      variables: CustomerPurchasedProductsListQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CustomerPurchasedProductsListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CustomerPurchasedProductsListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CustomerPurchasedProductsListQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['CustomerPurchasedProductsList.infinite'] : ['CustomerPurchasedProductsList.infinite', variables],
      queryFn: (metaData) => fetchData<CustomerPurchasedProductsListQuery, CustomerPurchasedProductsListQueryVariables>(CustomerPurchasedProductsListDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCustomerPurchasedProductsListQuery.getKey = (variables?: CustomerPurchasedProductsListQueryVariables) => variables === undefined ? ['CustomerPurchasedProductsList.infinite'] : ['CustomerPurchasedProductsList.infinite', variables];


useCustomerPurchasedProductsListQuery.fetcher = (variables?: CustomerPurchasedProductsListQueryVariables, options?: RequestInit['headers']) => fetchData<CustomerPurchasedProductsListQuery, CustomerPurchasedProductsListQueryVariables>(CustomerPurchasedProductsListDocument, variables, options);

export const ViPointsBalanceDocument = `
    query ViPointsBalance {
  viPointsBalance
}
    `;

export const useViPointsBalanceQuery = <
      TData = ViPointsBalanceQuery,
      TError = unknown
    >(
      variables?: ViPointsBalanceQueryVariables,
      options?: Omit<UseQueryOptions<ViPointsBalanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ViPointsBalanceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ViPointsBalanceQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ViPointsBalance'] : ['ViPointsBalance', variables],
    queryFn: fetchData<ViPointsBalanceQuery, ViPointsBalanceQueryVariables>(ViPointsBalanceDocument, variables),
    ...options
  }
    )};

useViPointsBalanceQuery.getKey = (variables?: ViPointsBalanceQueryVariables) => variables === undefined ? ['ViPointsBalance'] : ['ViPointsBalance', variables];

export const useSuspenseViPointsBalanceQuery = <
      TData = ViPointsBalanceQuery,
      TError = unknown
    >(
      variables?: ViPointsBalanceQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ViPointsBalanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ViPointsBalanceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ViPointsBalanceQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ViPointsBalance'] : ['ViPointsBalance', variables],
    queryFn: fetchData<ViPointsBalanceQuery, ViPointsBalanceQueryVariables>(ViPointsBalanceDocument, variables),
    ...options
  }
    )};

useSuspenseViPointsBalanceQuery.getKey = (variables?: ViPointsBalanceQueryVariables) => variables === undefined ? ['ViPointsBalance'] : ['ViPointsBalance', variables];

export const useInfiniteViPointsBalanceQuery = <
      TData = InfiniteData<ViPointsBalanceQuery>,
      TError = unknown
    >(
      variables: ViPointsBalanceQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ViPointsBalanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ViPointsBalanceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ViPointsBalanceQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ViPointsBalance.infinite'] : ['ViPointsBalance.infinite', variables],
      queryFn: (metaData) => fetchData<ViPointsBalanceQuery, ViPointsBalanceQueryVariables>(ViPointsBalanceDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteViPointsBalanceQuery.getKey = (variables?: ViPointsBalanceQueryVariables) => variables === undefined ? ['ViPointsBalance.infinite'] : ['ViPointsBalance.infinite', variables];

export const useSuspenseInfiniteViPointsBalanceQuery = <
      TData = InfiniteData<ViPointsBalanceQuery>,
      TError = unknown
    >(
      variables: ViPointsBalanceQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ViPointsBalanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ViPointsBalanceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ViPointsBalanceQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ViPointsBalance.infinite'] : ['ViPointsBalance.infinite', variables],
      queryFn: (metaData) => fetchData<ViPointsBalanceQuery, ViPointsBalanceQueryVariables>(ViPointsBalanceDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteViPointsBalanceQuery.getKey = (variables?: ViPointsBalanceQueryVariables) => variables === undefined ? ['ViPointsBalance.infinite'] : ['ViPointsBalance.infinite', variables];


useViPointsBalanceQuery.fetcher = (variables?: ViPointsBalanceQueryVariables, options?: RequestInit['headers']) => fetchData<ViPointsBalanceQuery, ViPointsBalanceQueryVariables>(ViPointsBalanceDocument, variables, options);

export const ViPointsLogDocument = `
    query ViPointsLog {
  viPointsLog {
    customerId
    pointsEarned
    pointsSpent
    items {
      id
      orderId
      points
      transactionDate
      reason
      notes
    }
  }
}
    `;

export const useViPointsLogQuery = <
      TData = ViPointsLogQuery,
      TError = unknown
    >(
      variables?: ViPointsLogQueryVariables,
      options?: Omit<UseQueryOptions<ViPointsLogQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ViPointsLogQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ViPointsLogQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ViPointsLog'] : ['ViPointsLog', variables],
    queryFn: fetchData<ViPointsLogQuery, ViPointsLogQueryVariables>(ViPointsLogDocument, variables),
    ...options
  }
    )};

useViPointsLogQuery.getKey = (variables?: ViPointsLogQueryVariables) => variables === undefined ? ['ViPointsLog'] : ['ViPointsLog', variables];

export const useSuspenseViPointsLogQuery = <
      TData = ViPointsLogQuery,
      TError = unknown
    >(
      variables?: ViPointsLogQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<ViPointsLogQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<ViPointsLogQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<ViPointsLogQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ViPointsLog'] : ['ViPointsLog', variables],
    queryFn: fetchData<ViPointsLogQuery, ViPointsLogQueryVariables>(ViPointsLogDocument, variables),
    ...options
  }
    )};

useSuspenseViPointsLogQuery.getKey = (variables?: ViPointsLogQueryVariables) => variables === undefined ? ['ViPointsLog'] : ['ViPointsLog', variables];

export const useInfiniteViPointsLogQuery = <
      TData = InfiniteData<ViPointsLogQuery>,
      TError = unknown
    >(
      variables: ViPointsLogQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ViPointsLogQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ViPointsLogQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ViPointsLogQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ViPointsLog.infinite'] : ['ViPointsLog.infinite', variables],
      queryFn: (metaData) => fetchData<ViPointsLogQuery, ViPointsLogQueryVariables>(ViPointsLogDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteViPointsLogQuery.getKey = (variables?: ViPointsLogQueryVariables) => variables === undefined ? ['ViPointsLog.infinite'] : ['ViPointsLog.infinite', variables];

export const useSuspenseInfiniteViPointsLogQuery = <
      TData = InfiniteData<ViPointsLogQuery>,
      TError = unknown
    >(
      variables: ViPointsLogQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<ViPointsLogQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<ViPointsLogQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<ViPointsLogQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ViPointsLog.infinite'] : ['ViPointsLog.infinite', variables],
      queryFn: (metaData) => fetchData<ViPointsLogQuery, ViPointsLogQueryVariables>(ViPointsLogDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteViPointsLogQuery.getKey = (variables?: ViPointsLogQueryVariables) => variables === undefined ? ['ViPointsLog.infinite'] : ['ViPointsLog.infinite', variables];


useViPointsLogQuery.fetcher = (variables?: ViPointsLogQueryVariables, options?: RequestInit['headers']) => fetchData<ViPointsLogQuery, ViPointsLogQueryVariables>(ViPointsLogDocument, variables, options);

export const PublicWishlistDocument = `
    query PublicWishlist($skip: Int!, $take: Int!, $wishlistSlug: String!, $brandCode: String!, $order: [PublicWishlistProductSort!]) {
  publicWishlistProducts(
    skip: $skip
    take: $take
    wishlistSlug: $wishlistSlug
    brandCode: $brandCode
    order: $order
  ) {
    items {
      id
      name
      url
      thumbnailUrl
      productType
      blurb
      vanishingIncExclusive
      displayPrice
      salePrice
      timeAdded
      creators {
        id
        name
        urlStub
      }
      currencySymbol
    }
    totalCount
    pageInfo {
      hasPreviousPage
      hasNextPage
    }
  }
  publicWishlistOwnerName(wishlistSlug: $wishlistSlug)
}
    `;

export const usePublicWishlistQuery = <
      TData = PublicWishlistQuery,
      TError = unknown
    >(
      variables: PublicWishlistQueryVariables,
      options?: Omit<UseQueryOptions<PublicWishlistQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PublicWishlistQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PublicWishlistQuery, TError, TData>(
      {
    queryKey: ['PublicWishlist', variables],
    queryFn: fetchData<PublicWishlistQuery, PublicWishlistQueryVariables>(PublicWishlistDocument, variables),
    ...options
  }
    )};

usePublicWishlistQuery.getKey = (variables: PublicWishlistQueryVariables) => ['PublicWishlist', variables];

export const useSuspensePublicWishlistQuery = <
      TData = PublicWishlistQuery,
      TError = unknown
    >(
      variables: PublicWishlistQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<PublicWishlistQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<PublicWishlistQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<PublicWishlistQuery, TError, TData>(
      {
    queryKey: ['PublicWishlist', variables],
    queryFn: fetchData<PublicWishlistQuery, PublicWishlistQueryVariables>(PublicWishlistDocument, variables),
    ...options
  }
    )};

useSuspensePublicWishlistQuery.getKey = (variables: PublicWishlistQueryVariables) => ['PublicWishlist', variables];

export const useInfinitePublicWishlistQuery = <
      TData = InfiniteData<PublicWishlistQuery>,
      TError = unknown
    >(
      variables: PublicWishlistQueryVariables,
      options: Omit<UseInfiniteQueryOptions<PublicWishlistQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<PublicWishlistQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<PublicWishlistQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['PublicWishlist.infinite', variables],
      queryFn: (metaData) => fetchData<PublicWishlistQuery, PublicWishlistQueryVariables>(PublicWishlistDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfinitePublicWishlistQuery.getKey = (variables: PublicWishlistQueryVariables) => ['PublicWishlist.infinite', variables];

export const useSuspenseInfinitePublicWishlistQuery = <
      TData = InfiniteData<PublicWishlistQuery>,
      TError = unknown
    >(
      variables: PublicWishlistQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<PublicWishlistQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<PublicWishlistQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<PublicWishlistQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['PublicWishlist.infinite', variables],
      queryFn: (metaData) => fetchData<PublicWishlistQuery, PublicWishlistQueryVariables>(PublicWishlistDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfinitePublicWishlistQuery.getKey = (variables: PublicWishlistQueryVariables) => ['PublicWishlist.infinite', variables];


usePublicWishlistQuery.fetcher = (variables: PublicWishlistQueryVariables, options?: RequestInit['headers']) => fetchData<PublicWishlistQuery, PublicWishlistQueryVariables>(PublicWishlistDocument, variables, options);

export const WishlistItemsDocument = `
    query WishlistItems($skip: Int, $take: Int, $brandCode: String!, $order: [WishlistProductSort!], $shippingCountry: String) {
  wishlistProducts(
    skip: $skip
    take: $take
    brandCode: $brandCode
    order: $order
    shippingCountry: $shippingCountry
  ) {
    items {
      id
      name
      url
      thumbnailUrl
      productType
      blurb
      vanishingIncExclusive
      creators {
        id
        name
        urlStub
      }
      displayPrice
      salePrice
      timeAdded
      currencySymbol
      hasDownloads
      isPreorder
      preorderRelease
      ebookBundleOption {
        physicalOptionId
        downloadOptionId
      }
      options {
        id
        description
        position
        price
        salePrice
        priceIncVat
        salePriceIncVat
        taxType
        inStock
        needsShipping
        currency {
          symbol
          code
        }
        productType {
          name
        }
      }
    }
    totalCount
    pageInfo {
      hasPreviousPage
      hasNextPage
    }
  }
  wishlist {
    publicUrl
    showName
  }
}
    `;

export const useWishlistItemsQuery = <
      TData = WishlistItemsQuery,
      TError = unknown
    >(
      variables: WishlistItemsQueryVariables,
      options?: Omit<UseQueryOptions<WishlistItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<WishlistItemsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<WishlistItemsQuery, TError, TData>(
      {
    queryKey: ['WishlistItems', variables],
    queryFn: fetchData<WishlistItemsQuery, WishlistItemsQueryVariables>(WishlistItemsDocument, variables),
    ...options
  }
    )};

useWishlistItemsQuery.getKey = (variables: WishlistItemsQueryVariables) => ['WishlistItems', variables];

export const useSuspenseWishlistItemsQuery = <
      TData = WishlistItemsQuery,
      TError = unknown
    >(
      variables: WishlistItemsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<WishlistItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<WishlistItemsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<WishlistItemsQuery, TError, TData>(
      {
    queryKey: ['WishlistItems', variables],
    queryFn: fetchData<WishlistItemsQuery, WishlistItemsQueryVariables>(WishlistItemsDocument, variables),
    ...options
  }
    )};

useSuspenseWishlistItemsQuery.getKey = (variables: WishlistItemsQueryVariables) => ['WishlistItems', variables];

export const useInfiniteWishlistItemsQuery = <
      TData = InfiniteData<WishlistItemsQuery>,
      TError = unknown
    >(
      variables: WishlistItemsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<WishlistItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<WishlistItemsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<WishlistItemsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WishlistItems.infinite', variables],
      queryFn: (metaData) => fetchData<WishlistItemsQuery, WishlistItemsQueryVariables>(WishlistItemsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteWishlistItemsQuery.getKey = (variables: WishlistItemsQueryVariables) => ['WishlistItems.infinite', variables];

export const useSuspenseInfiniteWishlistItemsQuery = <
      TData = InfiniteData<WishlistItemsQuery>,
      TError = unknown
    >(
      variables: WishlistItemsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<WishlistItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<WishlistItemsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<WishlistItemsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WishlistItems.infinite', variables],
      queryFn: (metaData) => fetchData<WishlistItemsQuery, WishlistItemsQueryVariables>(WishlistItemsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteWishlistItemsQuery.getKey = (variables: WishlistItemsQueryVariables) => ['WishlistItems.infinite', variables];


useWishlistItemsQuery.fetcher = (variables: WishlistItemsQueryVariables, options?: RequestInit['headers']) => fetchData<WishlistItemsQuery, WishlistItemsQueryVariables>(WishlistItemsDocument, variables, options);

export const WondersDocument = `
    query Wonders($brandCode: String!) {
  productsByCategorySlug(
    skip: 0
    take: 100
    brandCode: $brandCode
    includeChildCategories: true
    categorySlug: "wonders"
    maxBlurbLength: 200
  ) {
    totalCount
    items {
      id
      name
      url
      hasDownloads
      thumbnails {
        default
        square
        video
      }
      displayPrice
      vanishingIncExclusive
      options {
        id
        description
        price
        salePrice
        inStock
        productType {
          id
          name
        }
        currency {
          symbol
        }
      }
    }
  }
}
    `;

export const useWondersQuery = <
      TData = WondersQuery,
      TError = unknown
    >(
      variables: WondersQueryVariables,
      options?: Omit<UseQueryOptions<WondersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<WondersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<WondersQuery, TError, TData>(
      {
    queryKey: ['Wonders', variables],
    queryFn: fetchData<WondersQuery, WondersQueryVariables>(WondersDocument, variables),
    ...options
  }
    )};

useWondersQuery.getKey = (variables: WondersQueryVariables) => ['Wonders', variables];

export const useSuspenseWondersQuery = <
      TData = WondersQuery,
      TError = unknown
    >(
      variables: WondersQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<WondersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<WondersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<WondersQuery, TError, TData>(
      {
    queryKey: ['Wonders', variables],
    queryFn: fetchData<WondersQuery, WondersQueryVariables>(WondersDocument, variables),
    ...options
  }
    )};

useSuspenseWondersQuery.getKey = (variables: WondersQueryVariables) => ['Wonders', variables];

export const useInfiniteWondersQuery = <
      TData = InfiniteData<WondersQuery>,
      TError = unknown
    >(
      variables: WondersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<WondersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<WondersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<WondersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Wonders.infinite', variables],
      queryFn: (metaData) => fetchData<WondersQuery, WondersQueryVariables>(WondersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteWondersQuery.getKey = (variables: WondersQueryVariables) => ['Wonders.infinite', variables];

export const useSuspenseInfiniteWondersQuery = <
      TData = InfiniteData<WondersQuery>,
      TError = unknown
    >(
      variables: WondersQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<WondersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<WondersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<WondersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['Wonders.infinite', variables],
      queryFn: (metaData) => fetchData<WondersQuery, WondersQueryVariables>(WondersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteWondersQuery.getKey = (variables: WondersQueryVariables) => ['Wonders.infinite', variables];


useWondersQuery.fetcher = (variables: WondersQueryVariables, options?: RequestInit['headers']) => fetchData<WondersQuery, WondersQueryVariables>(WondersDocument, variables, options);
